import * as v from "react";
import B, { forwardRef as q, useMemo as wc, lazy as c0, Suspense as u0, useLayoutEffect as bc, useEffect as ke, useState as ye, useRef as qe, useCallback as ot, createContext as bt, Children as Yo, isValidElement as ur, cloneElement as tn, useContext as Xe, createElement as d0, useImperativeHandle as f0, useId as $n, Fragment as p0 } from "react";
import { jsx as m, Fragment as Ne, jsxs as ee } from "react/jsx-runtime";
import * as Rn from "react-dom";
import To, { createPortal as m0 } from "react-dom";
import { f as md, g as Ko, c as g0 } from "./arrow-up-to-square-hCsHVP-D.js";
function h0(e, t) {
  const n = v.createContext(t), r = (a) => {
    const { children: i, ...s } = a, l = v.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ m(n.Provider, { value: l, children: i });
  };
  r.displayName = e + "Provider";
  function o(a) {
    const i = v.useContext(n);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function Ye(e, t = []) {
  let n = [];
  function r(a, i) {
    const s = v.createContext(i), l = n.length;
    n = [...n, i];
    const c = (d) => {
      var b;
      const { scope: f, children: p, ...h } = d, g = ((b = f == null ? void 0 : f[e]) == null ? void 0 : b[l]) || s, w = v.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ m(g.Provider, { value: w, children: p });
    };
    c.displayName = a + "Provider";
    function u(d, f) {
      var g;
      const p = ((g = f == null ? void 0 : f[e]) == null ? void 0 : g[l]) || s, h = v.useContext(p);
      if (h) return h;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${a}\``);
    }
    return [c, u];
  }
  const o = () => {
    const a = n.map((i) => v.createContext(i));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || a;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return o.scopeName = e, [r, v0(o, ...t)];
}
function v0(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(a)[`__scope${c}`];
        return { ...s, ...d };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function gd(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Ei(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const a = gd(o, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const a = r[o];
          typeof a == "function" ? a() : gd(e[o], null);
        }
      };
  };
}
function xe(...e) {
  return v.useCallback(Ei(...e), e);
}
var Nn = v.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = v.Children.toArray(n), a = o.find(w0);
  if (a) {
    const i = a.props.children, s = o.map((l) => l === a ? v.Children.count(i) > 1 ? v.Children.only(null) : v.isValidElement(i) ? i.props.children : null : l);
    return /* @__PURE__ */ m(xl, { ...r, ref: t, children: v.isValidElement(i) ? v.cloneElement(i, void 0, s) : null });
  }
  return /* @__PURE__ */ m(xl, { ...r, ref: t, children: n });
});
Nn.displayName = "Slot";
var xl = v.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (v.isValidElement(n)) {
    const o = y0(n), a = b0(r, n.props);
    return n.type !== v.Fragment && (a.ref = t ? Ei(t, o) : o), v.cloneElement(n, a);
  }
  return v.Children.count(n) > 1 ? v.Children.only(null) : null;
});
xl.displayName = "SlotClone";
var _p = ({ children: e }) => /* @__PURE__ */ m(Ne, { children: e });
function w0(e) {
  return v.isValidElement(e) && e.type === _p;
}
function b0(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function y0(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function qr(e) {
  const t = e + "CollectionProvider", [n, r] = Ye(t), [o, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (p) => {
    const { scope: h, children: g } = p, w = B.useRef(null), b = B.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ m(o, { scope: h, itemMap: b, collectionRef: w, children: g });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = B.forwardRef(
    (p, h) => {
      const { scope: g, children: w } = p, b = a(s, g), y = xe(h, b.collectionRef);
      return /* @__PURE__ */ m(Nn, { ref: y, children: w });
    }
  );
  l.displayName = s;
  const c = e + "CollectionItemSlot", u = "data-radix-collection-item", d = B.forwardRef(
    (p, h) => {
      const { scope: g, children: w, ...b } = p, y = B.useRef(null), x = xe(h, y), C = a(c, g);
      return B.useEffect(() => (C.itemMap.set(y, { ref: y, ...b }), () => void C.itemMap.delete(y))), /* @__PURE__ */ m(Nn, { [u]: "", ref: x, children: w });
    }
  );
  d.displayName = c;
  function f(p) {
    const h = a(e + "CollectionConsumer", p);
    return B.useCallback(() => {
      const w = h.collectionRef.current;
      if (!w) return [];
      const b = Array.from(w.querySelectorAll(`[${u}]`));
      return Array.from(h.itemMap.values()).sort(
        (C, S) => b.indexOf(C.ref.current) - b.indexOf(S.ref.current)
      );
    }, [h.collectionRef, h.itemMap]);
  }
  return [
    { Provider: i, Slot: l, ItemSlot: d },
    f,
    r
  ];
}
function re(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Ze(e) {
  const t = v.useRef(e);
  return v.useEffect(() => {
    t.current = e;
  }), v.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function je({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = x0({ defaultProp: t, onChange: n }), a = e !== void 0, i = a ? e : r, s = Ze(n), l = v.useCallback(
    (c) => {
      if (a) {
        const d = typeof c == "function" ? c(e) : c;
        d !== e && s(d);
      } else
        o(c);
    },
    [a, e, o, s]
  );
  return [i, l];
}
function x0({
  defaultProp: e,
  onChange: t
}) {
  const n = v.useState(e), [r] = n, o = v.useRef(r), a = Ze(t);
  return v.useEffect(() => {
    o.current !== r && (a(r), o.current = r);
  }, [r, o, a]), n;
}
var S0 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ie = S0.reduce((e, t) => {
  const n = v.forwardRef((r, o) => {
    const { asChild: a, ...i } = r, s = a ? Nn : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(s, { ...i, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function yc(e, t) {
  e && Rn.flushSync(() => e.dispatchEvent(t));
}
var et = globalThis != null && globalThis.document ? v.useLayoutEffect : () => {
};
function C0(e, t) {
  return v.useReducer((n, r) => t[n][r] ?? n, e);
}
var at = (e) => {
  const { present: t, children: n } = e, r = E0(t), o = typeof n == "function" ? n({ present: r.isPresent }) : v.Children.only(n), a = xe(r.ref, k0(o));
  return typeof n == "function" || r.isPresent ? v.cloneElement(o, { ref: a }) : null;
};
at.displayName = "Presence";
function E0(e) {
  const [t, n] = v.useState(), r = v.useRef({}), o = v.useRef(e), a = v.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = C0(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return v.useEffect(() => {
    const c = Ma(r.current);
    a.current = s === "mounted" ? c : "none";
  }, [s]), et(() => {
    const c = r.current, u = o.current;
    if (u !== e) {
      const f = a.current, p = Ma(c);
      e ? l("MOUNT") : p === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), et(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (p) => {
        const g = Ma(r.current).includes(p.animationName);
        if (p.target === t && g && (l("ANIMATION_END"), !o.current)) {
          const w = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = w);
          });
        }
      }, f = (p) => {
        p.target === t && (a.current = Ma(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: v.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function Ma(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function k0(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var R0 = v.useId || (() => {
}), P0 = 0;
function Te(e) {
  const [t, n] = v.useState(R0());
  return et(() => {
    n((r) => r ?? String(P0++));
  }, [e]), t ? `radix-${t}` : "";
}
var xc = "Collapsible", [N0, Ip] = Ye(xc), [T0, Sc] = N0(xc), Mp = v.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: o,
      disabled: a,
      onOpenChange: i,
      ...s
    } = e, [l = !1, c] = je({
      prop: r,
      defaultProp: o,
      onChange: i
    });
    return /* @__PURE__ */ m(
      T0,
      {
        scope: n,
        disabled: a,
        contentId: Te(),
        open: l,
        onOpenToggle: v.useCallback(() => c((u) => !u), [c]),
        children: /* @__PURE__ */ m(
          ie.div,
          {
            "data-state": Rc(l),
            "data-disabled": a ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
Mp.displayName = xc;
var Op = "CollapsibleTrigger", Cc = v.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, o = Sc(Op, n);
    return /* @__PURE__ */ m(
      ie.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": Rc(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: t,
        onClick: re(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Cc.displayName = Op;
var Ec = "CollapsibleContent", kc = v.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = Sc(Ec, e.__scopeCollapsible);
    return /* @__PURE__ */ m(at, { present: n || o.open, children: ({ present: a }) => /* @__PURE__ */ m(_0, { ...r, ref: t, present: a }) });
  }
);
kc.displayName = Ec;
var _0 = v.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...a } = e, i = Sc(Ec, n), [s, l] = v.useState(r), c = v.useRef(null), u = xe(t, c), d = v.useRef(0), f = d.current, p = v.useRef(0), h = p.current, g = i.open || s, w = v.useRef(g), b = v.useRef(void 0);
  return v.useEffect(() => {
    const y = requestAnimationFrame(() => w.current = !1);
    return () => cancelAnimationFrame(y);
  }, []), et(() => {
    const y = c.current;
    if (y) {
      b.current = b.current || {
        transitionDuration: y.style.transitionDuration,
        animationName: y.style.animationName
      }, y.style.transitionDuration = "0s", y.style.animationName = "none";
      const x = y.getBoundingClientRect();
      d.current = x.height, p.current = x.width, w.current || (y.style.transitionDuration = b.current.transitionDuration, y.style.animationName = b.current.animationName), l(r);
    }
  }, [i.open, r]), /* @__PURE__ */ m(
    ie.div,
    {
      "data-state": Rc(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !g,
      ...a,
      ref: u,
      style: {
        "--radix-collapsible-content-height": f ? `${f}px` : void 0,
        "--radix-collapsible-content-width": h ? `${h}px` : void 0,
        ...e.style
      },
      children: g && o
    }
  );
});
function Rc(e) {
  return e ? "open" : "closed";
}
var Dp = Mp, I0 = Cc, M0 = kc, O0 = v.createContext(void 0);
function Ln(e) {
  const t = v.useContext(O0);
  return e || t || "ltr";
}
var vn = "Accordion", D0 = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Pc, A0, $0] = qr(vn), [ki, h3] = Ye(vn, [
  $0,
  Ip
]), Nc = Ip(), Ap = B.forwardRef(
  (e, t) => {
    const { type: n, ...r } = e, o = r, a = r;
    return /* @__PURE__ */ m(Pc.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ m(V0, { ...a, ref: t }) : /* @__PURE__ */ m(z0, { ...o, ref: t }) });
  }
);
Ap.displayName = vn;
var [$p, L0] = ki(vn), [Lp, F0] = ki(
  vn,
  { collapsible: !1 }
), z0 = B.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: o = () => {
      },
      collapsible: a = !1,
      ...i
    } = e, [s, l] = je({
      prop: n,
      defaultProp: r,
      onChange: o
    });
    return /* @__PURE__ */ m(
      $p,
      {
        scope: e.__scopeAccordion,
        value: s ? [s] : [],
        onItemOpen: l,
        onItemClose: B.useCallback(() => a && l(""), [a, l]),
        children: /* @__PURE__ */ m(Lp, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ m(Fp, { ...i, ref: t }) })
      }
    );
  }
), V0 = B.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...a
  } = e, [i = [], s] = je({
    prop: n,
    defaultProp: r,
    onChange: o
  }), l = B.useCallback(
    (u) => s((d = []) => [...d, u]),
    [s]
  ), c = B.useCallback(
    (u) => s((d = []) => d.filter((f) => f !== u)),
    [s]
  );
  return /* @__PURE__ */ m(
    $p,
    {
      scope: e.__scopeAccordion,
      value: i,
      onItemOpen: l,
      onItemClose: c,
      children: /* @__PURE__ */ m(Lp, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ m(Fp, { ...a, ref: t }) })
    }
  );
}), [B0, Ri] = ki(vn), Fp = B.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: r, dir: o, orientation: a = "vertical", ...i } = e, s = B.useRef(null), l = xe(s, t), c = A0(n), d = Ln(o) === "ltr", f = re(e.onKeyDown, (p) => {
      var M;
      if (!D0.includes(p.key)) return;
      const h = p.target, g = c().filter((F) => {
        var G;
        return !((G = F.ref.current) != null && G.disabled);
      }), w = g.findIndex((F) => F.ref.current === h), b = g.length;
      if (w === -1) return;
      p.preventDefault();
      let y = w;
      const x = 0, C = b - 1, S = () => {
        y = w + 1, y > C && (y = x);
      }, R = () => {
        y = w - 1, y < x && (y = C);
      };
      switch (p.key) {
        case "Home":
          y = x;
          break;
        case "End":
          y = C;
          break;
        case "ArrowRight":
          a === "horizontal" && (d ? S() : R());
          break;
        case "ArrowDown":
          a === "vertical" && S();
          break;
        case "ArrowLeft":
          a === "horizontal" && (d ? R() : S());
          break;
        case "ArrowUp":
          a === "vertical" && R();
          break;
      }
      const E = y % b;
      (M = g[E].ref.current) == null || M.focus();
    });
    return /* @__PURE__ */ m(
      B0,
      {
        scope: n,
        disabled: r,
        direction: o,
        orientation: a,
        children: /* @__PURE__ */ m(Pc.Slot, { scope: n, children: /* @__PURE__ */ m(
          ie.div,
          {
            ...i,
            "data-orientation": a,
            ref: l,
            onKeyDown: r ? void 0 : f
          }
        ) })
      }
    );
  }
), ii = "AccordionItem", [H0, Tc] = ki(ii), zp = B.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: r, ...o } = e, a = Ri(ii, n), i = L0(ii, n), s = Nc(n), l = Te(), c = r && i.value.includes(r) || !1, u = a.disabled || e.disabled;
    return /* @__PURE__ */ m(
      H0,
      {
        scope: n,
        open: c,
        disabled: u,
        triggerId: l,
        children: /* @__PURE__ */ m(
          Dp,
          {
            "data-orientation": a.orientation,
            "data-state": Gp(c),
            ...s,
            ...o,
            ref: t,
            disabled: u,
            open: c,
            onOpenChange: (d) => {
              d ? i.onItemOpen(r) : i.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
zp.displayName = ii;
var Vp = "AccordionHeader", Bp = B.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Ri(vn, n), a = Tc(Vp, n);
    return /* @__PURE__ */ m(
      ie.h3,
      {
        "data-orientation": o.orientation,
        "data-state": Gp(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
Bp.displayName = Vp;
var Sl = "AccordionTrigger", Hp = B.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Ri(vn, n), a = Tc(Sl, n), i = F0(Sl, n), s = Nc(n);
    return /* @__PURE__ */ m(Pc.ItemSlot, { scope: n, children: /* @__PURE__ */ m(
      I0,
      {
        "aria-disabled": a.open && !i.collapsible || void 0,
        "data-orientation": o.orientation,
        id: a.triggerId,
        ...s,
        ...r,
        ref: t
      }
    ) });
  }
);
Hp.displayName = Sl;
var Wp = "AccordionContent", jp = B.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Ri(vn, n), a = Tc(Wp, n), i = Nc(n);
    return /* @__PURE__ */ m(
      M0,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": o.orientation,
        ...i,
        ...r,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
jp.displayName = Wp;
function Gp(e) {
  return e ? "open" : "closed";
}
var Cl = Ap, W0 = zp, j0 = Bp, Up = Hp, _c = jp;
const G0 = (e, t, n) => {
  const r = e[t];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((o, a) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      a.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + t + (t.split("/").length !== n ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
function qp(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = qp(e[t])) && (r && (r += " "), r += n);
  else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function U0() {
  for (var e, t, n = 0, r = ""; n < arguments.length; ) (e = arguments[n++]) && (t = qp(e)) && (r && (r += " "), r += t);
  return r;
}
const Ic = "-", q0 = (e) => {
  const t = K0(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (o) => {
      const a = o.split(Ic);
      return a[0] === "" && a.length !== 1 && a.shift(), Yp(a, t) || Y0(o);
    },
    getConflictingClassGroupIds: (o, a) => {
      const i = n[o] || [];
      return a && r[o] ? [...i, ...r[o]] : i;
    }
  };
}, Yp = (e, t) => {
  var n;
  if (e.length === 0) return t.classGroupId;
  const r = e[0], o = t.nextPart.get(r), a = o ? Yp(e.slice(1), o) : void 0;
  if (a) return a;
  if (t.validators.length === 0) return;
  const i = e.join(Ic);
  return (n = t.validators.find(({
    validator: s
  }) => s(i))) == null ? void 0 : n.classGroupId;
}, hd = /^\[(.+)\]$/, Y0 = (e) => {
  if (hd.test(e)) {
    const t = hd.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n) return "arbitrary.." + n;
  }
}, K0 = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return J0(Object.entries(e.classGroups), n).forEach(([o, a]) => {
    El(a, r, o, t);
  }), r;
}, El = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : vd(t, o);
      a.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (X0(o)) {
        El(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([a, i]) => {
      El(i, vd(t, a), n, r);
    });
  });
}, vd = (e, t) => {
  let n = e;
  return t.split(Ic).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, X0 = (e) => e.isThemeGetter, J0 = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((a) => typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([i, s]) => [t + i, s])) : a);
  return [n, o];
}) : e, Q0 = (e) => {
  if (e < 1) return {
    get: () => {
    },
    set: () => {
    }
  };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (a, i) => {
    n.set(a, i), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let i = n.get(a);
      if (i !== void 0) return i;
      if ((i = r.get(a)) !== void 0) return o(a, i), i;
    },
    set(a, i) {
      n.has(a) ? n.set(a, i) : o(a, i);
    }
  };
}, Kp = "!", Z0 = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], a = t.length, i = (s) => {
    const l = [];
    let c = 0, u = 0, d;
    for (let w = 0; w < s.length; w++) {
      let b = s[w];
      if (c === 0) {
        if (b === o && (r || s.slice(w, w + a) === t)) {
          l.push(s.slice(u, w)), u = w + a;
          continue;
        }
        if (b === "/") {
          d = w;
          continue;
        }
      }
      b === "[" ? c++ : b === "]" && c--;
    }
    const f = l.length === 0 ? s : s.substring(u), p = f.startsWith(Kp), h = p ? f.substring(1) : f, g = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: p,
      baseClassName: h,
      maybePostfixModifierPosition: g
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: i
  }) : i;
}, eS = (e) => {
  if (e.length <= 1) return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, tS = (e) => ({
  cache: Q0(e.cacheSize),
  parseClassName: Z0(e),
  ...q0(e)
}), nS = /\s+/, rS = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, a = [], i = e.trim().split(nS);
  let s = "";
  for (let l = i.length - 1; l >= 0; l -= 1) {
    const c = i[l], {
      modifiers: u,
      hasImportantModifier: d,
      baseClassName: f,
      maybePostfixModifierPosition: p
    } = n(c);
    let h = !!p, g = r(h ? f.substring(0, p) : f);
    if (!g) {
      if (!h) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (g = r(f), !g) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      h = !1;
    }
    const w = eS(u).join(":"), b = d ? w + Kp : w, y = b + g;
    if (a.includes(y)) continue;
    a.push(y);
    const x = o(g, h);
    for (let C = 0; C < x.length; ++C) {
      const S = x[C];
      a.push(b + S);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function oS() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; ) (t = arguments[e++]) && (n = Xp(t)) && (r && (r += " "), r += n);
  return r;
}
const Xp = (e) => {
  if (typeof e == "string") return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++) e[r] && (t = Xp(e[r])) && (n && (n += " "), n += t);
  return n;
};
function aS(e, ...t) {
  let n, r, o, a = i;
  function i(l) {
    const c = t.reduce((u, d) => d(u), e());
    return n = tS(c), r = n.cache.get, o = n.cache.set, a = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c) return c;
    const u = rS(l, n);
    return o(l, u), u;
  }
  return function() {
    return a(oS.apply(null, arguments));
  };
}
const Fe = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Jp = /^\[(?:([a-z-]+):)?(.+)\]$/i, iS = /^\d+\/\d+$/, sS = /* @__PURE__ */ new Set(["px", "full", "screen"]), lS = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, cS = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, uS = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, dS = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, fS = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, cn = (e) => Nr(e) || sS.has(e) || iS.test(e), bn = (e) => Yr(e, "length", yS), Nr = (e) => !!e && !Number.isNaN(Number(e)), Ss = (e) => Yr(e, "number", Nr), so = (e) => !!e && Number.isInteger(Number(e)), pS = (e) => e.endsWith("%") && Nr(e.slice(0, -1)), be = (e) => Jp.test(e), yn = (e) => lS.test(e), mS = /* @__PURE__ */ new Set(["length", "size", "percentage"]), gS = (e) => Yr(e, mS, Qp), hS = (e) => Yr(e, "position", Qp), vS = /* @__PURE__ */ new Set(["image", "url"]), wS = (e) => Yr(e, vS, SS), bS = (e) => Yr(e, "", xS), lo = () => !0, Yr = (e, t, n) => {
  const r = Jp.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, yS = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  cS.test(e) && !uS.test(e)
), Qp = () => !1, xS = (e) => dS.test(e), SS = (e) => fS.test(e), CS = () => {
  const e = Fe("colors"), t = Fe("spacing"), n = Fe("blur"), r = Fe("brightness"), o = Fe("borderColor"), a = Fe("borderRadius"), i = Fe("borderSpacing"), s = Fe("borderWidth"), l = Fe("contrast"), c = Fe("grayscale"), u = Fe("hueRotate"), d = Fe("invert"), f = Fe("gap"), p = Fe("gradientColorStops"), h = Fe("gradientColorStopPositions"), g = Fe("inset"), w = Fe("margin"), b = Fe("opacity"), y = Fe("padding"), x = Fe("saturate"), C = Fe("scale"), S = Fe("sepia"), R = Fe("skew"), E = Fe("space"), M = Fe("translate"), F = () => ["auto", "contain", "none"], G = () => ["auto", "hidden", "clip", "visible", "scroll"], U = () => ["auto", be, t], H = () => [be, t], j = () => ["", cn, bn], z = () => ["auto", Nr, be], Z = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], Y = () => ["solid", "dashed", "dotted", "double", "none"], O = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], I = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], W = () => ["", "0", be], A = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], K = () => [Nr, be];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [lo],
      spacing: [cn, bn],
      blur: ["none", "", yn, be],
      brightness: K(),
      borderColor: [e],
      borderRadius: ["none", "", "full", yn, be],
      borderSpacing: H(),
      borderWidth: j(),
      contrast: K(),
      grayscale: W(),
      hueRotate: K(),
      invert: W(),
      gap: H(),
      gradientColorStops: [e],
      gradientColorStopPositions: [pS, bn],
      inset: U(),
      margin: U(),
      opacity: K(),
      padding: H(),
      saturate: K(),
      scale: K(),
      sepia: W(),
      skew: K(),
      space: H(),
      translate: H()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", be]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [yn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": A()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": A()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...Z(), be]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: G()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": G()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": G()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: F()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": F()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": F()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", so, be]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: U()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", be]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: W()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: W()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", so, be]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [lo]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", so, be]
        }, be]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": z()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": z()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [lo]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [so, be]
        }, be]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": z()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": z()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", be]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", be]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...I()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...I(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...I(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [w]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [w]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [w]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [w]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [w]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [w]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [w]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [w]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [w]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [E]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [E]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", be, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [be, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [be, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [yn]
        }, yn]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [be, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [be, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [be, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [be, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", yn, bn]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ss]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [lo]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", be]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Nr, Ss]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", cn, be]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", be]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", be]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Y(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", cn, bn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", cn, be]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: H()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", be]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", be]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...Z(), hS]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", gS]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, wS]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [h]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Y(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Y()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...Y()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [cn, be]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [cn, bn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: j()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [cn, bn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", yn, bS]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [lo]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...O(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": O()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", yn, be]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", be]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: K()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", be]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: K()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", be]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [so, be]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [M]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [M]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [R]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [R]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", be]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", be]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": H()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": H()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": H()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": H()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": H()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": H()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": H()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": H()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": H()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": H()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": H()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": H()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": H()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": H()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": H()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": H()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": H()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": H()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", be]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [cn, bn, Ss]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, ES = /* @__PURE__ */ aS(CS), kS = [
  // Responsiveness
  "screens",
  "supports",
  "data",
  // Reusable base configs
  "colors",
  "spacing",
  // Components
  "container",
  // Utilities
  "inset",
  "zIndex",
  "order",
  "gridColumn",
  "gridColumnStart",
  "gridColumnEnd",
  "gridRow",
  "gridRowStart",
  "gridRowEnd",
  "aspectRatio",
  "height",
  "maxHeight",
  "minHeight",
  "width",
  "maxWidth",
  "minWidth",
  "gap",
  "backgroundColor",
  "fill",
  "stroke",
  "padding",
  "margin",
  "flex",
  "flexShrink",
  "flexGrow",
  "flexBasis",
  "borderSpacing",
  "transformOrigin",
  "translate",
  "rotate",
  "skew",
  "scale",
  "animation",
  "keyframes",
  "cursor",
  "scrollMargin",
  "scrollPadding",
  "listStyleType",
  "columns",
  "gridAutoColumns",
  "gridAutoRows",
  "gridTemplateColumns",
  "gridTemplateRows",
  "space",
  "divideWidth",
  "divideColor",
  "divideOpacity",
  "borderRadius",
  "borderWidth",
  "borderColor",
  "borderOpacity",
  "backgroundOpacity",
  "backgroundImage",
  "gradientColorStops",
  "backgroundSize",
  "backgroundPosition",
  "strokeWidth",
  "objectPosition",
  "textIndent",
  "fontFamily",
  "fontSize",
  "fontWeight",
  "lineHeight",
  "letterSpacing",
  "textColor",
  "textOpacity",
  "textDecorationColor",
  "textDecorationThickness",
  "textUnderlineOffset",
  "placeholderColor",
  "placeholderOpacity",
  "caretColor",
  "accentColor",
  "opacity",
  "boxShadow",
  "boxShadowColor",
  "outlineWidth",
  "outlineOffset",
  "outlineColor",
  "ringWidth",
  "ringColor",
  "ringOpacity",
  "ringOffsetWidth",
  "ringOffsetColor",
  "blur",
  "brightness",
  "contrast",
  "dropShadow",
  "grayscale",
  "hueRotate",
  "invert",
  "saturate",
  "sepia",
  "backdropBlur",
  "backdropBrightness",
  "backdropContrast",
  "backdropGrayscale",
  "backdropHueRotate",
  "backdropInvert",
  "backdropOpacity",
  "backdropSaturate",
  "backdropSepia",
  "transitionProperty",
  "transitionTimingFunction",
  "transitionDelay",
  "transitionDuration",
  "willChange",
  "content"
], RS = {
  color: "colors",
  fontFamilies: "fontFamily",
  fontSizes: "fontSize",
  fontWeights: "fontWeight",
  lineHeights: "lineHeight",
  radius: "borderRadius",
  grid: "screens",
  size: "width",
  paragraphSpacing: void 0,
  // maybe replace with function
  textCase: void 0,
  textDecoration: void 0,
  dimension: void 0,
  typography: void 0,
  float: void 0,
  string: void 0
}, PS = (e) => RS[e] ?? kS.find((t) => t === e), NS = (e) => (t) => e.find(({
  path: n
}) => n === t), TS = (e, t) => e.reduce((n, r) => n !== null ? n : t(r), null), Zp = (e) => !!e, _S = (e) => (t) => Object.keys(t).map((n) => {
  const [r, o] = TS(e.transformers, (a) => a(n)) ?? [];
  return r && o ? [r, o, t[n]] : null;
}).filter(Zp).reduce((n, [r, o, a]) => ({
  ...n,
  [r]: {
    ...n[r],
    [o]: a
  }
}), {}), IS = (e) => {
  const t = e.split("-");
  return t.length < 3 ? null : [t.slice(0, -1).join("-"), t[t.length - 1]];
}, MS = [{
  path: "typography",
  transformers: [IS]
}], OS = NS(MS), DS = (e) => {
  const t = Object.entries(e).map(([o, a]) => {
    const i = PS(o);
    if (i) return [i, a];
    const s = OS(o);
    if (s) return ["components", _S(s)(a)];
  }).filter(Zp), {
    components: n,
    ...r
  } = Object.fromEntries(t);
  return [r, n];
}, AS = {
  fontFamily: {
    family2: "var(--fontFamilies-family2, Inter)",
    family1: "var(--fontFamilies-family1, Inter)"
  },
  lineHeight: {
    100: "var(--lineHeights-100, 100%)",
    110: "var(--lineHeights-110, 110%)",
    120: "var(--lineHeights-120, 120%)",
    130: "var(--lineHeights-130, 130%)",
    140: "var(--lineHeights-140, 140%)",
    150: "var(--lineHeights-150, 150%)"
  },
  fontWeight: {
    bold: "var(--fontWeights-bold, Bold)",
    boldCondensed: "var(--fontWeights-bold-condensed, Bold Condensed)",
    medium: "var(--fontWeights-medium, Medium)",
    regular: "var(--fontWeights-regular, Regular)",
    semi: "var(--fontWeights-semi, Semi Bold)"
  },
  fontSize: {
    1: "var(--fontSizes-font-size-1, 12px)",
    2: "var(--fontSizes-font-size-2, 14px)",
    3: "var(--fontSizes-font-size-3, 16px)",
    4: "var(--fontSizes-font-size-4, 18px)",
    5: "var(--fontSizes-font-size-5, 20px)",
    6: "var(--fontSizes-font-size-6, 24px)"
  },
  letterSpacing: {
    loose: "var(--letterSpacing-loose, 1%)",
    looser: "var(--letterSpacing-looser, 2%)",
    none: "var(--letterSpacing-none, 0%)",
    loosest: "var(--letterSpacing-loosest, 4%)",
    tight: "var(--letterSpacing-tight, -1%)",
    tightest: "var(--letterSpacing-tightest, -5%)"
  },
  unknown: {
    "paragraphSpacing-1": "var(--paragraphSpacing-1, 2px)",
    "paragraphSpacing-2": "var(--paragraphSpacing-2, 4px)",
    "paragraphSpacing-3": "var(--paragraphSpacing-3, 8px)",
    "paragraphSpacing-4": "var(--paragraphSpacing-4, 12px)",
    "paragraphSpacing-5": "var(--paragraphSpacing-5, 16px)",
    "paragraphSpacing-6": "var(--paragraphSpacing-6, 24px)",
    "paragraphSpacing-7": "var(--paragraphSpacing-7, 32px)",
    "paragraphSpacing-none": "var(--paragraphSpacing-none, 0)",
    "textCase-none": "var(--textCase-none, none)",
    "textCase-uppercase": "var(--textCase-uppercase, uppercase)",
    "textDecoration-none": "var(--textDecoration-none, none)",
    "textDecoration-line-through": "var(--textDecoration-line-through, line-through)",
    "textDecoration-underline": "var(--textDecoration-underline, underline)",
    "paragraphIndent-0": "var(--dimension-paragraph-indent-0, 0px)"
  },
  typography: {
    "body-xl-bold-font": "var(--typography-body-xl-bold-font, Bold 18px/100% Inter)",
    "body-xl-bold": "var(--typography-body-xl-bold-letter-spacing, 0%)",
    "body-xl-bold-paragraphSpacing": "var(--typography-body-xl-bold-paragraph-spacing, 0)",
    "body-xl-bold-paragraphIndent": "var(--typography-body-xl-bold-paragraph-indent, 0px)",
    "body-xl-bold-textCase": "var(--typography-body-xl-bold-text-case, none)",
    "body-xl-bold-textDecoration": "var(--typography-body-xl-bold-text-decoration, none)",
    "body-lg-medium-font": "var(--typography-body-lg-medium-font, Medium 16px/100% Inter)",
    "body-lg-medium": "var(--typography-body-lg-medium-letter-spacing, 0%)",
    "body-lg-medium-paragraphSpacing": "var(--typography-body-lg-medium-paragraph-spacing, 0)",
    "body-lg-medium-paragraphIndent": "var(--typography-body-lg-medium-paragraph-indent, 0px)",
    "body-lg-medium-textCase": "var(--typography-body-lg-medium-text-case, none)",
    "body-lg-medium-textDecoration": "var(--typography-body-lg-medium-text-decoration, none)",
    "body-lg-regular-font": "var(--typography-body-lg-regular-font, Regular 16px/140% Inter)",
    "body-lg-regular": "var(--typography-body-lg-regular-letter-spacing, 0%)",
    "body-lg-regular-paragraphSpacing": "var(--typography-body-lg-regular-paragraph-spacing, 0)",
    "body-lg-regular-paragraphIndent": "var(--typography-body-lg-regular-paragraph-indent, 0px)",
    "body-lg-regular-textCase": "var(--typography-body-lg-regular-text-case, none)",
    "body-lg-regular-textDecoration": "var(--typography-body-lg-regular-text-decoration, none)",
    "body-md-bold-font": "var(--typography-body-md-bold-font, Bold 14px/150% Inter)",
    "body-md-bold": "var(--typography-body-md-bold-letter-spacing, 0%)",
    "body-md-bold-paragraphSpacing": "var(--typography-body-md-bold-paragraph-spacing, 0)",
    "body-md-bold-paragraphIndent": "var(--typography-body-md-bold-paragraph-indent, 0px)",
    "body-md-bold-textCase": "var(--typography-body-md-bold-text-case, none)",
    "body-md-bold-textDecoration": "var(--typography-body-md-bold-text-decoration, none)",
    "body-md-medium-font": "var(--typography-body-md-medium-font, Medium 14px/150% Inter)",
    "body-md-medium": "var(--typography-body-md-medium-letter-spacing, 0%)",
    "body-md-medium-paragraphSpacing": "var(--typography-body-md-medium-paragraph-spacing, 0)",
    "body-md-medium-paragraphIndent": "var(--typography-body-md-medium-paragraph-indent, 0px)",
    "body-md-medium-textCase": "var(--typography-body-md-medium-text-case, none)",
    "body-md-medium-textDecoration": "var(--typography-body-md-medium-text-decoration, none)",
    "body-md-regular-font": "var(--typography-body-md-regular-font, Regular 14px/100% Inter)",
    "body-md-regular": "var(--typography-body-md-regular-letter-spacing, -1%)",
    "body-md-regular-paragraphSpacing": "var(--typography-body-md-regular-paragraph-spacing, 0)",
    "body-md-regular-paragraphIndent": "var(--typography-body-md-regular-paragraph-indent, 0px)",
    "body-md-regular-textCase": "var(--typography-body-md-regular-text-case, none)",
    "body-md-regular-textDecoration": "var(--typography-body-md-regular-text-decoration, none)",
    "body-md-regular-line-font": "var(--typography-body-md-regular-line-font, Regular 14px/100% Inter)",
    "body-md-regular-line": "var(--typography-body-md-regular-line-letter-spacing, -1%)",
    "body-md-regular-line-paragraphSpacing": "var(--typography-body-md-regular-line-paragraph-spacing, 0)",
    "body-md-regular-line-paragraphIndent": "var(--typography-body-md-regular-line-paragraph-indent, 0px)",
    "body-md-regular-line-textCase": "var(--typography-body-md-regular-line-text-case, none)",
    "body-md-regular-line-textDecoration": "var(--typography-body-md-regular-line-text-decoration, line-through)",
    "body-xs-medium-font": "var(--typography-body-xs-medium-font, Medium 12px/100% Inter)",
    "body-xs-medium": "var(--typography-body-xs-medium-letter-spacing, 0%)",
    "body-xs-medium-paragraphSpacing": "var(--typography-body-xs-medium-paragraph-spacing, 0)",
    "body-xs-medium-paragraphIndent": "var(--typography-body-xs-medium-paragraph-indent, 0px)",
    "body-xs-medium-textCase": "var(--typography-body-xs-medium-text-case, none)",
    "body-xs-medium-textDecoration": "var(--typography-body-xs-medium-text-decoration, none)",
    "label-lg-bold-font": "var(--typography-label-lg-bold-font, Bold 16px/100% Inter)",
    "label-lg-bold": "var(--typography-label-lg-bold-letter-spacing, 0%)",
    "label-lg-bold-paragraphSpacing": "var(--typography-label-lg-bold-paragraph-spacing, 0)",
    "label-lg-bold-paragraphIndent": "var(--typography-label-lg-bold-paragraph-indent, 0px)",
    "label-lg-bold-textCase": "var(--typography-label-lg-bold-text-case, none)",
    "label-lg-bold-textDecoration": "var(--typography-label-lg-bold-text-decoration, none)",
    "label-lg-regular-font": "var(--typography-label-lg-regular-font, Regular 16px/100% Inter)",
    "label-lg-regular": "var(--typography-label-lg-regular-letter-spacing, 0%)",
    "label-lg-regular-paragraphSpacing": "var(--typography-label-lg-regular-paragraph-spacing, 0)",
    "label-lg-regular-paragraphIndent": "var(--typography-label-lg-regular-paragraph-indent, 0px)",
    "label-lg-regular-textCase": "var(--typography-label-lg-regular-text-case, none)",
    "label-lg-regular-textDecoration": "var(--typography-label-lg-regular-text-decoration, none)",
    "label-md-bold-font": "var(--typography-label-md-bold-font, Bold 14px/100% Inter)",
    "label-md-bold": "var(--typography-label-md-bold-letter-spacing, 0%)",
    "label-md-bold-paragraphSpacing": "var(--typography-label-md-bold-paragraph-spacing, 0)",
    "label-md-bold-paragraphIndent": "var(--typography-label-md-bold-paragraph-indent, 0px)",
    "label-md-bold-textCase": "var(--typography-label-md-bold-text-case, none)",
    "label-md-bold-textDecoration": "var(--typography-label-md-bold-text-decoration, none)",
    "label-md-medium-font": "var(--typography-label-md-medium-font, Medium 14px/100% Inter)",
    "label-md-medium": "var(--typography-label-md-medium-letter-spacing, 0%)",
    "label-md-medium-paragraphSpacing": "var(--typography-label-md-medium-paragraph-spacing, 0)",
    "label-md-medium-paragraphIndent": "var(--typography-label-md-medium-paragraph-indent, 0px)",
    "label-md-medium-textCase": "var(--typography-label-md-medium-text-case, none)",
    "label-md-medium-textDecoration": "var(--typography-label-md-medium-text-decoration, none)",
    "label-md-regular-font": "var(--typography-label-md-regular-font, Regular 14px/100% Inter)",
    "label-md-regular": "var(--typography-label-md-regular-letter-spacing, 0%)",
    "label-md-regular-paragraphSpacing": "var(--typography-label-md-regular-paragraph-spacing, 0)",
    "label-md-regular-paragraphIndent": "var(--typography-label-md-regular-paragraph-indent, 0px)",
    "label-md-regular-textCase": "var(--typography-label-md-regular-text-case, none)",
    "label-md-regular-textDecoration": "var(--typography-label-md-regular-text-decoration, none)",
    "label-xs-semi-font": "var(--typography-label-xs-semi-font, Semi Bold 12px/100% Inter)",
    "label-xs-semi": "var(--typography-label-xs-semi-letter-spacing, 2%)",
    "label-xs-semi-paragraphSpacing": "var(--typography-label-xs-semi-paragraph-spacing, 0)",
    "label-xs-semi-paragraphIndent": "var(--typography-label-xs-semi-paragraph-indent, 0px)",
    "label-xs-semi-textCase": "var(--typography-label-xs-semi-text-case, none)",
    "label-xs-semi-textDecoration": "var(--typography-label-xs-semi-text-decoration, none)",
    "label-xs-medium-font": "var(--typography-label-xs-medium-font, Medium 12px/130% Inter)",
    "label-xs-medium": "var(--typography-label-xs-medium-letter-spacing, 0%)",
    "label-xs-medium-paragraphSpacing": "var(--typography-label-xs-medium-paragraph-spacing, 0)",
    "label-xs-medium-paragraphIndent": "var(--typography-label-xs-medium-paragraph-indent, 0px)",
    "label-xs-medium-textCase": "var(--typography-label-xs-medium-text-case, none)",
    "label-xs-medium-textDecoration": "var(--typography-label-xs-medium-text-decoration, none)",
    "interactive-lg-medium-font": "var(--typography-interactive-lg-medium-font, Medium 18px/100% Inter)",
    "interactive-lg-medium": "var(--typography-interactive-lg-medium-letter-spacing, 0%)",
    "interactive-lg-medium-paragraphSpacing": "var(--typography-interactive-lg-medium-paragraph-spacing, 0)",
    "interactive-lg-medium-paragraphIndent": "var(--typography-interactive-lg-medium-paragraph-indent, 0px)",
    "interactive-lg-medium-textCase": "var(--typography-interactive-lg-medium-text-case, none)",
    "interactive-lg-medium-textDecoration": "var(--typography-interactive-lg-medium-text-decoration, none)",
    "interactive-md-medium-font": "var(--typography-interactive-md-medium-font, Medium 16px/100% Inter)",
    "interactive-md-medium": "var(--typography-interactive-md-medium-letter-spacing, 0%)",
    "interactive-md-medium-paragraphSpacing": "var(--typography-interactive-md-medium-paragraph-spacing, 0)",
    "interactive-md-medium-paragraphIndent": "var(--typography-interactive-md-medium-paragraph-indent, 0px)",
    "interactive-md-medium-textCase": "var(--typography-interactive-md-medium-text-case, none)",
    "interactive-md-medium-textDecoration": "var(--typography-interactive-md-medium-text-decoration, none)",
    "interactive-sm-medium-font": "var(--typography-interactive-sm-medium-font, Medium 14px/100% Inter)",
    "interactive-sm-medium": "var(--typography-interactive-sm-medium-letter-spacing, 0%)",
    "interactive-sm-medium-paragraphSpacing": "var(--typography-interactive-sm-medium-paragraph-spacing, 0)",
    "interactive-sm-medium-paragraphIndent": "var(--typography-interactive-sm-medium-paragraph-indent, 0px)",
    "interactive-sm-medium-textCase": "var(--typography-interactive-sm-medium-text-case, none)",
    "interactive-sm-medium-textDecoration": "var(--typography-interactive-sm-medium-text-decoration, none)",
    "interactive-sm-regular-underline-font": "var(--typography-interactive-sm-regular-underline-font, Medium 14px/100% Inter)",
    "interactive-sm-regular-underline": "var(--typography-interactive-sm-regular-underline-letter-spacing, 0%)",
    "interactive-sm-regular-underline-paragraphSpacing": "var(--typography-interactive-sm-regular-underline-paragraph-spacing, 0)",
    "interactive-sm-regular-underline-paragraphIndent": "var(--typography-interactive-sm-regular-underline-paragraph-indent, 0px)",
    "interactive-sm-regular-underline-textCase": "var(--typography-interactive-sm-regular-underline-text-case, none)",
    "interactive-sm-regular-underline-textDecoration": "var(--typography-interactive-sm-regular-underline-text-decoration, underline)",
    "interactive-sm-regular-font": "var(--typography-interactive-sm-regular-font, Regular 14px/100% Inter)",
    "interactive-sm-regular": "var(--typography-interactive-sm-regular-letter-spacing, 0%)",
    "interactive-sm-regular-paragraphSpacing": "var(--typography-interactive-sm-regular-paragraph-spacing, 0)",
    "interactive-sm-regular-paragraphIndent": "var(--typography-interactive-sm-regular-paragraph-indent, 0px)",
    "interactive-sm-regular-textCase": "var(--typography-interactive-sm-regular-text-case, none)",
    "interactive-sm-regular-textDecoration": "var(--typography-interactive-sm-regular-text-decoration, none)",
    "interactive-xs-semi-font": "var(--typography-interactive-xs-semi-font, Semi Bold 12px/140% Inter)",
    "interactive-xs-semi": "var(--typography-interactive-xs-semi-letter-spacing, 0%)",
    "interactive-xs-semi-paragraphSpacing": "var(--typography-interactive-xs-semi-paragraph-spacing, 0)",
    "interactive-xs-semi-paragraphIndent": "var(--typography-interactive-xs-semi-paragraph-indent, 0px)",
    "interactive-xs-semi-textCase": "var(--typography-interactive-xs-semi-text-case, none)",
    "interactive-xs-semi-textDecoration": "var(--typography-interactive-xs-semi-text-decoration, none)",
    "link-underlined-md-medium-font": "var(--typography-link-underlined-md-medium-font, Medium 16px/140% Inter)",
    "link-underlined-md-medium": "var(--typography-link-underlined-md-medium-letter-spacing, 0%)",
    "link-underlined-md-medium-paragraphSpacing": "var(--typography-link-underlined-md-medium-paragraph-spacing, 0)",
    "link-underlined-md-medium-paragraphIndent": "var(--typography-link-underlined-md-medium-paragraph-indent, 0px)",
    "link-underlined-md-medium-textCase": "var(--typography-link-underlined-md-medium-text-case, none)",
    "link-underlined-md-medium-textDecoration": "var(--typography-link-underlined-md-medium-text-decoration, underline)",
    "link-underlined-md-regular-font": "var(--typography-link-underlined-md-regular-font, Regular 16px/140% Inter)",
    "link-underlined-md-regular": "var(--typography-link-underlined-md-regular-letter-spacing, 0%)",
    "link-underlined-md-regular-paragraphSpacing": "var(--typography-link-underlined-md-regular-paragraph-spacing, 0)",
    "link-underlined-md-regular-paragraphIndent": "var(--typography-link-underlined-md-regular-paragraph-indent, 0px)",
    "link-underlined-md-regular-textCase": "var(--typography-link-underlined-md-regular-text-case, none)",
    "link-underlined-md-regular-textDecoration": "var(--typography-link-underlined-md-regular-text-decoration, underline)",
    "link-underlined-sm-semi-font": "var(--typography-link-underlined-sm-semi-font, Semi Bold 14px/140% Inter)",
    "link-underlined-sm-semi": "var(--typography-link-underlined-sm-semi-letter-spacing, 0%)",
    "link-underlined-sm-semi-paragraphSpacing": "var(--typography-link-underlined-sm-semi-paragraph-spacing, 0)",
    "link-underlined-sm-semi-paragraphIndent": "var(--typography-link-underlined-sm-semi-paragraph-indent, 0px)",
    "link-underlined-sm-semi-textCase": "var(--typography-link-underlined-sm-semi-text-case, none)",
    "link-underlined-sm-semi-textDecoration": "var(--typography-link-underlined-sm-semi-text-decoration, underline)",
    "link-underlined-sm-regular-font": "var(--typography-link-underlined-sm-regular-font, Regular 14px/140% Inter)",
    "link-underlined-sm-regular": "var(--typography-link-underlined-sm-regular-letter-spacing, 0%)",
    "link-underlined-sm-regular-paragraphSpacing": "var(--typography-link-underlined-sm-regular-paragraph-spacing, 0)",
    "link-underlined-sm-regular-paragraphIndent": "var(--typography-link-underlined-sm-regular-paragraph-indent, 0px)",
    "link-underlined-sm-regular-textCase": "var(--typography-link-underlined-sm-regular-text-case, none)",
    "link-underlined-sm-regular-textDecoration": "var(--typography-link-underlined-sm-regular-text-decoration, underline)",
    "link-underlined-xs-semi-font": "var(--typography-link-underlined-xs-semi-font, Semi Bold 12px/140% Inter)",
    "link-underlined-xs-semi": "var(--typography-link-underlined-xs-semi-letter-spacing, 0%)",
    "link-underlined-xs-semi-paragraphSpacing": "var(--typography-link-underlined-xs-semi-paragraph-spacing, 0)",
    "link-underlined-xs-semi-paragraphIndent": "var(--typography-link-underlined-xs-semi-paragraph-indent, 0px)",
    "link-underlined-xs-semi-textCase": "var(--typography-link-underlined-xs-semi-text-case, none)",
    "link-underlined-xs-semi-textDecoration": "var(--typography-link-underlined-xs-semi-text-decoration, underline)",
    "link-plain-md-medium-font": "var(--typography-link-plain-md-medium-font, Medium 16px/140% Inter)",
    "link-plain-md-medium": "var(--typography-link-plain-md-medium-letter-spacing, 0%)",
    "link-plain-md-medium-paragraphSpacing": "var(--typography-link-plain-md-medium-paragraph-spacing, 0)",
    "link-plain-md-medium-paragraphIndent": "var(--typography-link-plain-md-medium-paragraph-indent, 0px)",
    "link-plain-md-medium-textCase": "var(--typography-link-plain-md-medium-text-case, none)",
    "link-plain-md-medium-textDecoration": "var(--typography-link-plain-md-medium-text-decoration, none)",
    "link-plain-md-regular-font": "var(--typography-link-plain-md-regular-font, Regular 16px/140% Inter)",
    "link-plain-md-regular": "var(--typography-link-plain-md-regular-letter-spacing, 0%)",
    "link-plain-md-regular-paragraphSpacing": "var(--typography-link-plain-md-regular-paragraph-spacing, 0)",
    "link-plain-md-regular-paragraphIndent": "var(--typography-link-plain-md-regular-paragraph-indent, 0px)",
    "link-plain-md-regular-textCase": "var(--typography-link-plain-md-regular-text-case, none)",
    "link-plain-md-regular-textDecoration": "var(--typography-link-plain-md-regular-text-decoration, none)",
    "link-plain-sm-semi-font": "var(--typography-link-plain-sm-semi-font, Semi Bold 14px/140% Inter)",
    "link-plain-sm-semi": "var(--typography-link-plain-sm-semi-letter-spacing, 0%)",
    "link-plain-sm-semi-paragraphSpacing": "var(--typography-link-plain-sm-semi-paragraph-spacing, 0)",
    "link-plain-sm-semi-paragraphIndent": "var(--typography-link-plain-sm-semi-paragraph-indent, 0px)",
    "link-plain-sm-semi-textCase": "var(--typography-link-plain-sm-semi-text-case, none)",
    "link-plain-sm-semi-textDecoration": "var(--typography-link-plain-sm-semi-text-decoration, none)",
    "link-plain-sm-regular-font": "var(--typography-link-plain-sm-regular-font, Regular 14px/140% Inter)",
    "link-plain-sm-regular": "var(--typography-link-plain-sm-regular-letter-spacing, 0%)",
    "link-plain-sm-regular-paragraphSpacing": "var(--typography-link-plain-sm-regular-paragraph-spacing, 0)",
    "link-plain-sm-regular-paragraphIndent": "var(--typography-link-plain-sm-regular-paragraph-indent, 0px)",
    "link-plain-sm-regular-textCase": "var(--typography-link-plain-sm-regular-text-case, none)",
    "link-plain-sm-regular-textDecoration": "var(--typography-link-plain-sm-regular-text-decoration, none)",
    "link-plain-xs-semi-font": "var(--typography-link-plain-xs-semi-font, Semi Bold 12px/140% Inter)",
    "link-plain-xs-semi": "var(--typography-link-plain-xs-semi-letter-spacing, 0%)",
    "link-plain-xs-semi-paragraphSpacing": "var(--typography-link-plain-xs-semi-paragraph-spacing, 0)",
    "link-plain-xs-semi-paragraphIndent": "var(--typography-link-plain-xs-semi-paragraph-indent, 0px)",
    "link-plain-xs-semi-textCase": "var(--typography-link-plain-xs-semi-text-case, none)",
    "link-plain-xs-semi-textDecoration": "var(--typography-link-plain-xs-semi-text-decoration, none)",
    "heading-xl-font": "var(--typography-heading-xl-font, Bold 24px/120% Inter)",
    "heading-xl": "var(--typography-heading-xl-letter-spacing, 0%)",
    "heading-xl-paragraphSpacing": "var(--typography-heading-xl-paragraph-spacing, 0)",
    "heading-xl-paragraphIndent": "var(--typography-heading-xl-paragraph-indent, 0px)",
    "heading-xl-textCase": "var(--typography-heading-xl-text-case, none)",
    "heading-xl-textDecoration": "var(--typography-heading-xl-text-decoration, none)",
    "heading-lg-font": "var(--typography-heading-lg-font, Bold 20px/100% Inter)",
    "heading-lg": "var(--typography-heading-lg-letter-spacing, 0%)",
    "heading-lg-paragraphSpacing": "var(--typography-heading-lg-paragraph-spacing, 0)",
    "heading-lg-paragraphIndent": "var(--typography-heading-lg-paragraph-indent, 0px)",
    "heading-lg-textCase": "var(--typography-heading-lg-text-case, none)",
    "heading-lg-textDecoration": "var(--typography-heading-lg-text-decoration, none)",
    "heading-md-font": "var(--typography-heading-md-font, Bold 16px/100% Inter)",
    "heading-md": "var(--typography-heading-md-letter-spacing, 0%)",
    "heading-md-paragraphSpacing": "var(--typography-heading-md-paragraph-spacing, 0)",
    "heading-md-paragraphIndent": "var(--typography-heading-md-paragraph-indent, 0px)",
    "heading-md-textCase": "var(--typography-heading-md-text-case, none)",
    "heading-md-textDecoration": "var(--typography-heading-md-text-decoration, none)",
    "heading-sm-font": "var(--typography-heading-sm-font, Bold 14px/100% Inter)",
    "heading-sm": "var(--typography-heading-sm-letter-spacing, 0%)",
    "heading-sm-paragraphSpacing": "var(--typography-heading-sm-paragraph-spacing, 0)",
    "heading-sm-paragraphIndent": "var(--typography-heading-sm-paragraph-indent, 0px)",
    "heading-sm-textCase": "var(--typography-heading-sm-text-case, none)",
    "heading-sm-textDecoration": "var(--typography-heading-sm-text-decoration, none)"
  }
}, $S = {
  screen: {
    "brand-grid-mobile": "var(--brand-grid-breakpoints-mobile, 0px)",
    "brand-grid-tablet": "var(--brand-grid-breakpoints-tablet, 0px)",
    "brand-grid-desktop": "var(--brand-grid-breakpoints-desktop, 0px)"
  },
  colors: {
    "brand-primary-10": "var(--brand-color-primary-10, rgba(23, 35, 102, 1.00))",
    "brand-primary-9": "var(--brand-color-primary-9, rgba(18, 34, 125, 1.00))",
    "brand-primary-8": "var(--brand-color-primary-8, rgba(12, 33, 148, 1.00))",
    "brand-primary-7": "var(--brand-color-primary-7, rgba(1, 30, 193, 1.00))",
    "brand-primary-6": "var(--brand-color-primary-6, rgba(63, 85, 209, 1.00))",
    "brand-primary-5": "var(--brand-color-primary-5, rgba(124, 139, 224, 1.00))",
    "brand-primary-4": "var(--brand-color-primary-4, rgba(186, 194, 240, 1.00))",
    "brand-primary-3": "var(--brand-color-primary-3, rgba(214, 218, 240, 1.00))",
    "brand-primary-2": "var(--brand-color-primary-2, rgba(236, 237, 247, 1.00))",
    "brand-primary-1": "var(--brand-color-primary-1, rgba(247, 248, 255, 1.00))",
    "brand-accent-5": "var(--brand-color-accent-5, rgba(221, 150, 32, 1.00))",
    "brand-accent-4": "var(--brand-color-accent-4, rgba(245, 166, 35, 1.00))",
    "brand-accent-3": "var(--brand-color-accent-3, rgba(254, 199, 47, 1.00))",
    "brand-accent-2": "var(--brand-color-accent-2, rgba(255, 227, 151, 1.00))",
    "brand-accent-1": "var(--brand-color-accent-1, rgba(255, 248, 229, 1.00))",
    "brand-neutral-black": "var(--brand-color-neutral-black, rgba(0, 0, 0, 1.00))",
    "brand-neutral-12": "var(--brand-color-neutral-12, rgba(32, 32, 32, 1.00))",
    "brand-neutral-11": "var(--brand-color-neutral-11, rgba(39, 39, 39, 1.00))",
    "brand-neutral-10": "var(--brand-color-neutral-10, rgba(46, 46, 46, 1.00))",
    "brand-neutral-9": "var(--brand-color-neutral-9, rgba(60, 60, 60, 1.00))",
    "brand-neutral-8": "var(--brand-color-neutral-8, rgba(74, 74, 74, 1.00))",
    "brand-neutral-7": "var(--brand-color-neutral-7, rgba(87, 87, 87, 1.00))",
    "brand-neutral-6": "var(--brand-color-neutral-6, rgba(149, 149, 149, 1.00))",
    "brand-neutral-5": "var(--brand-color-neutral-5, rgba(173, 173, 173, 1.00))",
    "brand-neutral-4": "var(--brand-color-neutral-4, rgba(206, 206, 206, 1.00))",
    "brand-neutral-3": "var(--brand-color-neutral-3, rgba(225, 225, 225, 1.00))",
    "brand-neutral-2": "var(--brand-color-neutral-2, rgba(239, 239, 239, 1.00))",
    "brand-neutral-1": "var(--brand-color-neutral-1, rgba(250, 250, 250, 1.00))",
    "brand-neutral-white": "var(--brand-color-neutral-white, rgba(255, 255, 255, 1.00))",
    "brand-depth-weak": "var(--brand-depth-color-weak, rgba(191, 191, 191, 1.00))",
    "brand-depth-weaker": "var(--brand-depth-color-weaker, rgba(204, 204, 204, 1.00))",
    "brand-depth-weakest": "var(--brand-depth-color-weakest, rgba(235, 235, 235, 1.00))",
    "brand-neutral-none": "var(--brand-color-neutral-none, rgba(255, 255, 255, 0.00))",
    "semantic-focus-outline": "var(--semantic-focus-color-outline)",
    "semantic-focus-innerline": "var(--semantic-focus-color-innerline)",
    "semantic-action-foreground-primary-strongest": "var(--semantic-action-color-foreground-primary-strongest)",
    "semantic-action-foreground-primary-stronger": "var(--semantic-action-color-foreground-primary-stronger)",
    "semantic-action-foreground-primary-default": "var(--semantic-action-color-foreground-primary-default)",
    "semantic-action-foreground-neutral-strong": "var(--semantic-action-color-foreground-neutral-strong)",
    "semantic-action-foreground-neutral-weak": "var(--semantic-action-color-foreground-neutral-weak)",
    "semantic-action-foreground-neutral-white": "var(--semantic-action-color-foreground-neutral-white)",
    "semantic-formElement-label-default": "var(--semantic-form-element-color-label-default)",
    "semantic-formElement-label-weak": "var(--semantic-form-element-color-label-weak)",
    "semantic-formElement-foreground-primary-stronger": "var(--semantic-form-element-color-foreground-primary-stronger)",
    "semantic-formElement-foreground-primary-strong": "var(--semantic-form-element-color-foreground-primary-strong)",
    "semantic-formElement-foreground-primary-default": "var(--semantic-form-element-color-foreground-primary-default)",
    "semantic-formElement-background-primary-stronger": "var(--semantic-form-element-color-background-primary-stronger)",
    "semantic-formElement-background-primary-strong": "var(--semantic-form-element-color-background-primary-strong)",
    "semantic-formElement-background-primary-default": "var(--semantic-form-element-color-background-primary-default)",
    "semantic-formElement-border-primary-strongest": "var(--semantic-form-element-color-border-primary-strongest)",
    "semantic-formElement-border-primary-stronger": "var(--semantic-form-element-color-border-primary-stronger)",
    "semantic-formElement-border-primary-default": "var(--semantic-form-element-color-border-primary-default)",
    "semantic-formElement-border-neutral-stronger": "var(--semantic-form-element-color-border-neutral-stronger)",
    "semantic-formElement-border-neutral-strong": "var(--semantic-form-element-color-border-neutral-strong)",
    "semantic-formElement-border-neutral-default": "var(--semantic-form-element-color-border-neutral-default)",
    "semantic-formElement-border-neutral-error": "var(--semantic-form-element-color-border-neutral-error)",
    "semantic-formElement-border-neutral-disabled": "var(--semantic-form-element-color-border-neutral-disabled)",
    "semantic-formElement-background-neutral-stronger": "var(--semantic-form-element-color-background-neutral-stronger)",
    "semantic-formElement-background-neutral-strong": "var(--semantic-form-element-color-background-neutral-strong)",
    "semantic-formElement-background-neutral-default": "var(--semantic-form-element-color-background-neutral-default)",
    "semantic-formElement-background-neutral-error": "var(--semantic-form-element-color-background-neutral-error)",
    "semantic-formElement-background-neutral-disabled": "var(--semantic-form-element-color-background-neutral-disabled)",
    "semantic-formElement-foreground-neutral-stronger": "var(--semantic-form-element-color-foreground-neutral-stronger, rgba(255, 255, 255, 1.00))",
    "semantic-formElement-foreground-neutral-strong": "var(--semantic-form-element-color-foreground-neutral-strong, rgba(255, 255, 255, 1.00))",
    "semantic-formElement-foreground-neutral-default": "var(--semantic-form-element-color-foreground-neutral-default)",
    "semantic-formElement-foreground-neutral-error": "var(--semantic-form-element-color-foreground-neutral-error, rgba(255, 255, 255, 1.00))",
    "semantic-formElement-foreground-neutral-disabled": "var(--semantic-form-element-color-foreground-neutral-disabled)",
    "semantic-formElement-foreground-neutral-inverted": "var(--semantic-form-element-color-foreground-neutral-inverted)",
    "semantic-formElement-label-error": "var(--semantic-form-element-color-label-error)",
    "semantic-formElement-label-disabled": "var(--semantic-form-element-color-label-disabled)",
    "components-badge-solid-red-background": "var(--components-badge-color-solid-red-background, rgba(229, 77, 46, 1.00))",
    "components-badge-solid-red-foreground": "var(--components-badge-color-solid-red-foreground, rgba(255, 255, 255, 1.00))",
    "semantic-static-foreground-neutral-default": "var(--semantic-static-color-foreground-neutral-default)",
    "semantic-static-foreground-neutral-weak": "var(--semantic-static-color-foreground-neutral-weak)",
    "semantic-static-foreground-neutral-weaker": "var(--semantic-static-color-foreground-neutral-weaker)",
    "semantic-static-foreground-neutral-inverted": "var(--semantic-static-color-foreground-neutral-inverted)",
    "semantic-static-foreground-primary-default": "var(--semantic-static-color-foreground-primary-default)",
    "semantic-static-foreground-primary-weak": "var(--semantic-static-color-foreground-primary-weak)",
    "semantic-static-foreground-primary-weaker": "var(--semantic-static-color-foreground-primary-weaker)",
    "semantic-static-background-neutral-stronger": "var(--semantic-static-color-background-neutral-stronger)",
    "semantic-static-background-neutral-strong": "var(--semantic-static-color-background-neutral-strong)",
    "semantic-static-background-neutral-default": "var(--semantic-static-color-background-neutral-default)",
    "semantic-static-border-neutral-stronger": "var(--semantic-static-color-border-neutral-stronger)",
    "semantic-static-border-neutral-strong": "var(--semantic-static-color-border-neutral-strong)",
    "semantic-static-border-neutral-default": "var(--semantic-static-color-border-neutral-default)",
    "semantic-static-border-neutral-inverted": "var(--semantic-static-color-border-neutral-inverted)",
    "semantic-static-border-primary-stronger": "var(--semantic-static-color-border-primary-stronger)",
    "semantic-static-border-primary-strong": "var(--semantic-static-color-border-primary-strong)",
    "semantic-static-border-primary-default": "var(--semantic-static-color-border-primary-default)",
    "semantic-static-background-neutral-inverted": "var(--semantic-static-color-background-neutral-inverted)",
    "semantic-static-background-primary-stronger": "var(--semantic-static-color-background-primary-stronger)",
    "semantic-static-background-primary-strong": "var(--semantic-static-color-background-primary-strong)",
    "semantic-static-background-primary-default": "var(--semantic-static-color-background-primary-default)",
    "semantic-static-focus-focusRing": "var(--semantic-static-color-focus-focus-ring)",
    "components-badge-solid-red-border": "var(--components-badge-color-solid-red-border)",
    "components-badge-solid-green-foreground": "var(--components-badge-color-solid-green-foreground, rgba(38, 124, 56, 1.00))",
    "components-badge-solid-green-background": "var(--components-badge-color-solid-green-background, rgba(235, 249, 235, 1.00))",
    "components-badge-solid-blue-foreground": "var(--components-badge-color-solid-blue-foreground, rgba(49, 79, 178, 1.00))",
    "components-badge-solid-green-border": "var(--components-badge-color-solid-green-border)",
    "components-badge-solid-blue-background": "var(--components-badge-color-solid-blue-background, rgba(240, 244, 255, 1.00))",
    "components-badge-solid-orange-foreground": "var(--components-badge-color-solid-orange-foreground, rgba(153, 79, 48, 1.00))",
    "components-badge-solid-blue-border": "var(--components-badge-color-solid-blue-border)",
    "components-badge-solid-orange-background": "var(--components-badge-color-solid-orange-background, rgba(255, 237, 213, 1.00))",
    "components-badge-solid-yellow-foreground": "var(--components-badge-color-solid-yellow-foreground, rgba(119, 95, 40, 1.00))",
    "components-badge-solid-yellow-background": "var(--components-badge-color-solid-yellow-background, rgba(255, 249, 198, 1.00))",
    "components-badge-solid-yellow-border": "var(--components-badge-color-solid-yellow-border)",
    "components-badge-solid-neutral-foreground": "var(--components-badge-color-solid-neutral-foreground, rgba(32, 32, 32, 1.00))",
    "components-badge-solid-orange-border": "var(--components-badge-color-solid-orange-border)",
    "components-badge-solid-neutral-background": "var(--components-badge-color-solid-neutral-background, rgba(239, 239, 239, 1.00))",
    "components-badge-solid-neutral-border": "var(--components-badge-color-solid-neutral-border)",
    "semantic-action-background-primary-strongest": "var(--semantic-action-color-background-primary-strongest)",
    "semantic-action-background-primary-stronger": "var(--semantic-action-color-background-primary-stronger)",
    "semantic-action-background-primary-strong": "var(--semantic-action-color-background-primary-strong)",
    "semantic-action-background-primary-default": "var(--semantic-action-color-background-primary-default)",
    "semantic-action-background-primary-weak": "var(--semantic-action-color-background-primary-weak)",
    "semantic-action-background-primary-weaker": "var(--semantic-action-color-background-primary-weaker)",
    "semantic-action-background-primary-weakest": "var(--semantic-action-color-background-primary-weakest)",
    "semantic-action-background-primary-2xweakest": "var(--semantic-action-color-background-primary-2xweakest)",
    "semantic-action-background-accent-stronger": "var(--semantic-action-color-background-accent-stronger)",
    "semantic-action-background-destructive-stronger": "var(--semantic-action-color-background-destructive-stronger)",
    "semantic-action-background-accent-strong": "var(--semantic-action-color-background-accent-strong)",
    "semantic-action-background-destructive-strong": "var(--semantic-action-color-background-destructive-strong)",
    "semantic-action-background-accent-default": "var(--semantic-action-color-background-accent-default)",
    "semantic-action-background-destructive-default": "var(--semantic-action-color-background-destructive-default)",
    "semantic-action-background-neutral-strongest": "var(--semantic-action-color-background-neutral-strongest)",
    "semantic-action-background-neutral-stronger": "var(--semantic-action-color-background-neutral-stronger)",
    "semantic-action-background-neutral-strong": "var(--semantic-action-color-background-neutral-strong)",
    "semantic-action-background-neutral-light": "var(--semantic-action-color-background-neutral-light, rgba(224, 224, 224, 1.00))",
    "semantic-action-background-neutral-default": "var(--semantic-action-color-background-neutral-default)",
    "semantic-action-background-neutral-weaker": "var(--semantic-action-color-background-neutral-weaker)",
    "semantic-action-background-neutral-weakest": "var(--semantic-action-color-background-neutral-weakest)",
    "semantic-action-background-neutral-white": "var(--semantic-action-color-background-neutral-white)",
    "semantic-action-background-neutral-none": "var(--semantic-action-color-background-neutral-none)",
    "semantic-action-background-error-weakest": "var(--semantic-action-color-background-error-weakest)",
    "semantic-action-background-warning-weakest": "var(--semantic-action-color-background-warning-weakest)",
    "semantic-action-background-success-weakest": "var(--semantic-action-color-background-success-weakest)",
    "semantic-action-background-info-weakest": "var(--semantic-action-color-background-info-weakest)",
    "semantic-action-border-primary-default": "var(--semantic-action-color-border-primary-default)",
    "semantic-action-border-primary-weak": "var(--semantic-action-color-border-primary-weak)",
    "semantic-action-border-primary-weaker": "var(--semantic-action-color-border-primary-weaker)",
    "semantic-action-border-neutral-weak": "var(--semantic-action-color-border-neutral-weak)",
    "semantic-action-border-neutral-weaker": "var(--semantic-action-color-border-neutral-weaker)",
    "semantic-action-border-error-weak": "var(--semantic-action-color-border-error-weak)",
    "semantic-action-border-warning-weak": "var(--semantic-action-color-border-warning-weak)",
    "semantic-action-border-success-weak": "var(--semantic-action-color-border-success-weak)",
    "semantic-action-border-info-weak": "var(--semantic-action-color-border-info-weak)",
    "components-badge-outline-red-foreground": "var(--components-badge-color-outline-red-foreground, rgba(195, 48, 19, 1.00))",
    "components-badge-outline-red-background": "var(--components-badge-color-outline-red-background, rgba(255, 255, 255, 1.00))",
    "components-badge-outline-red-border": "var(--components-badge-color-outline-red-border, rgba(234, 146, 128, 1.00))",
    "components-badge-outline-green-foreground": "var(--components-badge-color-outline-green-foreground, rgba(38, 124, 56, 1.00))",
    "components-badge-outline-green-background": "var(--components-badge-color-outline-green-background, rgba(255, 255, 255, 1.00))",
    "components-badge-outline-blue-foreground": "var(--components-badge-color-outline-blue-foreground, rgba(49, 79, 178, 1.00))",
    "components-badge-outline-green-border": "var(--components-badge-color-outline-green-border, rgba(101, 186, 117, 1.00))",
    "components-badge-outline-blue-background": "var(--components-badge-color-outline-blue-background, rgba(255, 255, 255, 1.00))",
    "components-badge-outline-orange-foreground": "var(--components-badge-color-outline-orange-foreground, rgba(153, 79, 48, 1.00))",
    "components-badge-outline-blue-border": "var(--components-badge-color-outline-blue-border, rgba(141, 164, 239, 1.00))",
    "components-badge-outline-orange-background": "var(--components-badge-color-outline-orange-background, rgba(255, 255, 255, 1.00))",
    "components-badge-outline-orange-border": "var(--components-badge-color-outline-orange-border, rgba(237, 138, 92, 1.00))",
    "components-badge-outline-yellow-foreground": "var(--components-badge-color-outline-yellow-foreground, rgba(119, 95, 40, 1.00))",
    "components-badge-outline-yellow-background": "var(--components-badge-color-outline-yellow-background, rgba(255, 255, 255, 1.00))",
    "components-badge-outline-yellow-border": "var(--components-badge-color-outline-yellow-border, rgba(201, 170, 69, 1.00))",
    "components-badge-outline-neutral-foreground": "var(--components-badge-color-outline-neutral-foreground, rgba(32, 32, 32, 1.00))",
    "components-badge-outline-neutral-background": "var(--components-badge-color-outline-neutral-background, rgba(255, 255, 255, 1.00))",
    "components-badge-outline-neutral-border": "var(--components-badge-color-outline-neutral-border, rgba(32, 32, 32, 1.00))",
    "components-badge-ghost-red-foreground": "var(--components-badge-color-ghost-red-foreground, rgba(195, 48, 19, 1.00))",
    "components-badge-ghost-red-background": "var(--components-badge-color-ghost-red-background)",
    "components-badge-ghost-green-foreground": "var(--components-badge-color-ghost-green-foreground, rgba(38, 124, 56, 1.00))",
    "components-badge-ghost-red-border": "var(--components-badge-color-ghost-red-border)",
    "components-badge-ghost-green-background": "var(--components-badge-color-ghost-green-background)",
    "components-badge-ghost-green-border": "var(--components-badge-color-ghost-green-border)",
    "components-badge-ghost-blue-foreground": "var(--components-badge-color-ghost-blue-foreground, rgba(49, 79, 178, 1.00))",
    "components-badge-ghost-blue-background": "var(--components-badge-color-ghost-blue-background)",
    "components-badge-ghost-blue-border": "var(--components-badge-color-ghost-blue-border)",
    "components-badge-ghost-orange-foreground": "var(--components-badge-color-ghost-orange-foreground, rgba(153, 79, 48, 1.00))",
    "components-badge-ghost-orange-background": "var(--components-badge-color-ghost-orange-background)",
    "components-badge-ghost-orange-border": "var(--components-badge-color-ghost-orange-border)",
    "components-badge-ghost-yellow-foreground": "var(--components-badge-color-ghost-yellow-foreground, rgba(119, 95, 40, 1.00))",
    "components-badge-ghost-yellow-background": "var(--components-badge-color-ghost-yellow-background)",
    "components-badge-ghost-yellow-border": "var(--components-badge-color-ghost-yellow-border)",
    "components-badge-ghost-neutral-foreground": "var(--components-badge-color-ghost-neutral-foreground, rgba(32, 32, 32, 1.00))",
    "components-badge-ghost-neutral-background": "var(--components-badge-color-ghost-neutral-background)",
    "components-badge-ghost-neutral-border": "var(--components-badge-color-ghost-neutral-border)",
    "semantic-action-gradient-start": "var(--semantic-action-color-gradient-start)",
    "semantic-action-gradient-end": "var(--semantic-action-color-gradient-end)",
    "components-separator-neutral-weaker": "var(--components-separator-color-neutral-weaker)",
    "components-separator-neutral-weak": "var(--components-separator-color-neutral-weak)",
    "components-separator-neutral-default": "var(--components-separator-color-neutral-default)",
    "components-separator-neutral-strong": "var(--components-separator-color-neutral-strong)",
    "components-separator-neutral-stronger": "var(--components-separator-color-neutral-stronger)",
    "components-separator-primary-weaker": "var(--components-separator-color-primary-weaker)",
    "components-separator-primary-weak": "var(--components-separator-color-primary-weak)",
    "components-separator-primary-default": "var(--components-separator-color-primary-default)",
    "components-separator-primary-strong": "var(--components-separator-color-primary-strong)",
    "components-separator-primary-stronger": "var(--components-separator-color-primary-stronger)",
    "semantic-action-foreground-error-stronger": "var(--semantic-action-color-foreground-error-stronger)",
    "semantic-action-foreground-error-default": "var(--semantic-action-color-foreground-error-default)",
    "semantic-action-foreground-error-weak": "var(--semantic-action-color-foreground-error-weak)",
    "semantic-action-foreground-warning-stronger": "var(--semantic-action-color-foreground-warning-stronger)",
    "semantic-action-foreground-warning-default": "var(--semantic-action-color-foreground-warning-default)",
    "semantic-action-foreground-warning-weak": "var(--semantic-action-color-foreground-warning-weak)",
    "semantic-action-foreground-success-stronger": "var(--semantic-action-color-foreground-success-stronger)",
    "semantic-action-foreground-info-weak": "var(--semantic-action-color-foreground-info-weak)",
    "semantic-action-foreground-info-default": "var(--semantic-action-color-foreground-info-default)",
    "semantic-action-foreground-info-stronger": "var(--semantic-action-color-foreground-info-stronger)",
    "semantic-action-foreground-success-default": "var(--semantic-action-color-foreground-success-default)",
    "semantic-action-foreground-success-weak": "var(--semantic-action-color-foreground-success-weak)"
  },
  unknown: {
    "brand-interactive-ixPrimary-strongest": "var(--brand-interactive-ix-primary-strongest, rgba(23, 35, 102, 1.00))",
    "brand-feedback-error-strongest": "var(--brand-feedback-error-strongest, rgba(74, 22, 11, 1.00))",
    "brand-static-staticBrand-strongest": "var(--brand-static-static-brand-strongest, rgba(23, 35, 102, 1.00))",
    "brand-static-staticBrand-stronger": "var(--brand-static-static-brand-stronger, rgba(12, 33, 148, 1.00))",
    "brand-static-staticBrand-strong": "var(--brand-static-static-brand-strong, rgba(7, 32, 171, 1.00))",
    "brand-static-staticBrand-default": "var(--brand-static-static-brand-default, rgba(1, 30, 193, 1.00))",
    "brand-static-staticBrand-weak": "var(--brand-static-static-brand-weak, rgba(186, 194, 240, 1.00))",
    "brand-static-staticBrand-weaker": "var(--brand-static-static-brand-weaker, rgba(214, 218, 240, 1.00))",
    "brand-static-staticBrand-weakest": "var(--brand-static-static-brand-weakest, rgba(236, 237, 247, 1.00))",
    "brand-static-staticBrand-2xweakest": "var(--brand-static-static-brand-2xweakest, rgba(247, 248, 255, 1.00))",
    "brand-static-staticNeutral-black": "var(--brand-static-static-neutral-black)",
    "brand-static-staticNeutral-strongest": "var(--brand-static-static-neutral-strongest)",
    "brand-static-staticNeutral-stronger": "var(--brand-static-static-neutral-stronger)",
    "brand-static-staticNeutral-strong": "var(--brand-static-static-neutral-strong)",
    "brand-static-staticNeutral-default": "var(--brand-static-static-neutral-default)",
    "brand-static-staticNeutral-weak": "var(--brand-static-static-neutral-weak)",
    "brand-static-staticNeutral-weaker": "var(--brand-static-static-neutral-weaker)",
    "brand-static-staticNeutral-weakest": "var(--brand-static-static-neutral-weakest)",
    "brand-static-staticNeutral-white": "var(--brand-static-static-neutral-white)",
    "brand-feedback-error-stronger": "var(--brand-feedback-error-stronger, rgba(98, 27, 13, 1.00))",
    "brand-feedback-error-strong": "var(--brand-feedback-error-strong, rgba(121, 32, 14, 1.00))",
    "brand-feedback-error-default": "var(--brand-feedback-error-default, rgba(188, 47, 19, 1.00))",
    "brand-feedback-error-weak": "var(--brand-feedback-error-weak, rgba(221, 68, 37, 1.00))",
    "brand-feedback-error-weaker": "var(--brand-feedback-error-weaker, rgba(252, 231, 227, 1.00))",
    "brand-feedback-error-weakest": "var(--brand-feedback-error-weakest, rgba(254, 243, 241, 1.00))",
    "brand-feedback-success-strongest": "var(--brand-feedback-success-strongest, rgba(25, 59, 45, 1.00))",
    "brand-feedback-success-stronger": "var(--brand-feedback-success-stronger, rgba(27, 77, 56, 1.00))",
    "brand-feedback-success-strong": "var(--brand-feedback-success-strong, rgba(29, 95, 67, 1.00))",
    "brand-feedback-success-default": "var(--brand-feedback-success-default, rgba(33, 131, 88, 1.00))",
    "brand-feedback-success-weak": "var(--brand-feedback-success-weak, rgba(48, 164, 108, 1.00))",
    "brand-feedback-success-weaker": "var(--brand-feedback-success-weaker, rgba(213, 240, 224, 1.00))",
    "brand-feedback-success-weakest": "var(--brand-feedback-success-weakest, rgba(240, 254, 244, 1.00))",
    "brand-feedback-warning-strongest": "var(--brand-feedback-warning-strongest, rgba(71, 59, 31, 1.00))",
    "brand-feedback-warning-stronger": "var(--brand-feedback-warning-stronger, rgba(93, 72, 24, 1.00))",
    "brand-feedback-warning-strong": "var(--brand-feedback-warning-strong, rgba(115, 84, 16, 1.00))",
    "brand-feedback-warning-default": "var(--brand-feedback-warning-default, rgba(158, 108, 0, 1.00))",
    "brand-feedback-warning-weak": "var(--brand-feedback-warning-weak, rgba(207, 168, 58, 1.00))",
    "brand-feedback-warning-weaker": "var(--brand-feedback-warning-weaker, rgba(255, 250, 184, 1.00))",
    "brand-feedback-warning-weakest": "var(--brand-feedback-warning-weakest, rgba(255, 253, 220, 1.00))",
    "brand-feedback-info-strongest": "var(--brand-feedback-info-strongest, rgba(17, 50, 100, 1.00))",
    "brand-feedback-info-stronger": "var(--brand-feedback-info-stronger, rgba(15, 83, 153, 1.00))",
    "brand-feedback-info-strong": "var(--brand-feedback-info-strong, rgba(14, 100, 180, 1.00))",
    "brand-feedback-info-default": "var(--brand-feedback-info-default, rgba(13, 116, 206, 1.00))",
    "brand-feedback-info-weak": "var(--brand-feedback-info-weak, rgba(0, 144, 255, 1.00))",
    "brand-feedback-info-weaker": "var(--brand-feedback-info-weaker, rgba(225, 241, 253, 1.00))",
    "brand-feedback-info-weakest": "var(--brand-feedback-info-weakest, rgba(241, 249, 255, 1.00))",
    "brand-static-staticStatus-strong-green": "var(--brand-static-static-status-strong-green, rgba(25, 59, 45, 1.00))",
    "brand-static-staticStatus-strong-blue": "var(--brand-static-static-status-strong-blue, rgba(23, 35, 102, 1.00))",
    "brand-static-staticStatus-strong-orange": "var(--brand-static-static-status-strong-orange, rgba(88, 45, 29, 1.00))",
    "brand-static-staticStatus-strong-yellow": "var(--brand-static-static-status-strong-yellow, rgba(71, 59, 31, 1.00))",
    "brand-static-staticStatus-weak-green": "var(--brand-static-static-status-weak-green, rgba(240, 254, 244, 1.00))",
    "brand-static-staticStatus-weak-blue": "var(--brand-static-static-status-weak-blue, rgba(225, 241, 253, 1.00))",
    "brand-static-staticStatus-weak-orange": "var(--brand-static-static-status-weak-orange, rgba(255, 237, 213, 1.00))",
    "brand-static-staticStatus-weak-yellow": "var(--brand-static-static-status-weak-yellow, rgba(255, 253, 220, 1.00))",
    "brand-interactive-ixPrimary-stronger": "var(--brand-interactive-ix-primary-stronger, rgba(12, 33, 148, 1.00))",
    "brand-interactive-ixPrimary-strong": "var(--brand-interactive-ix-primary-strong, rgba(7, 32, 171, 1.00))",
    "brand-interactive-ixPrimary-default": "var(--brand-interactive-ix-primary-default, rgba(1, 30, 193, 1.00))",
    "brand-interactive-ixPrimary-weak": "var(--brand-interactive-ix-primary-weak, rgba(186, 194, 240, 1.00))",
    "brand-interactive-ixPrimary-weaker": "var(--brand-interactive-ix-primary-weaker, rgba(214, 218, 240, 1.00))",
    "brand-interactive-ixPrimary-weakest": "var(--brand-interactive-ix-primary-weakest, rgba(236, 237, 247, 1.00))",
    "brand-interactive-ixPrimary-weakestx2": "var(--brand-interactive-ix-primary-weakestx2, rgba(247, 248, 255, 1.00))",
    "brand-interactive-ixNeutral-black": "var(--brand-interactive-ix-neutral-black, rgba(0, 0, 0, 1.00))",
    "brand-interactive-ixDestructive-strongest": "var(--brand-interactive-ix-destructive-strongest, rgba(167, 42, 17, 1.00))",
    "brand-interactive-ixDestructive-strong": "var(--brand-interactive-ix-destructive-strong, rgba(209, 52, 21, 1.00))",
    "brand-interactive-ixDestructive-default": "var(--brand-interactive-ix-destructive-default, rgba(229, 77, 46, 1.00))",
    "brand-interactive-ixNeutral-strongest": "var(--brand-interactive-ix-neutral-strongest, rgba(32, 32, 32, 1.00))",
    "brand-interactive-ixNeutral-stronger": "var(--brand-interactive-ix-neutral-stronger, rgba(46, 46, 46, 1.00))",
    "brand-interactive-ixNeutral-strong": "var(--brand-interactive-ix-neutral-strong, rgba(74, 74, 74, 1.00))",
    "brand-interactive-ixNeutral-default": "var(--brand-interactive-ix-neutral-default, rgba(87, 87, 87, 1.00))",
    "brand-interactive-ixNeutral-weak": "var(--brand-interactive-ix-neutral-weak, rgba(173, 173, 173, 1.00))",
    "brand-interactive-ixNeutral-weaker": "var(--brand-interactive-ix-neutral-weaker, rgba(239, 239, 239, 1.00))",
    "brand-interactive-ixNeutral-weakest": "var(--brand-interactive-ix-neutral-weakest, rgba(250, 250, 250, 1.00))",
    "brand-grid-test": "var(--brand-grid-test, 0px)",
    "brand-interactive-ixNeutral-white": "var(--brand-interactive-ix-neutral-white, rgba(255, 255, 255, 1.00))",
    "brand-size-0": "var(--brand-size-0, 0px)",
    "brand-size-2": "var(--brand-size-2, 2px)",
    "brand-size-4": "var(--brand-size-4, 4px)",
    "brand-size-8": "var(--brand-size-8, 8px)",
    "brand-size-12": "var(--brand-size-12, 12px)",
    "brand-size-16": "var(--brand-size-16, 16px)",
    "brand-size-18": "var(--brand-size-18, 18px)",
    "brand-size-20": "var(--brand-size-20, 20px)",
    "brand-size-24": "var(--brand-size-24, 24px)",
    "brand-size-32": "var(--brand-size-32, 32px)",
    "brand-size-40": "var(--brand-size-40, 40px)",
    "brand-size-48": "var(--brand-size-48, 48px)",
    "brand-size-64": "var(--brand-size-64, 64px)",
    "brand-depth-spread-none": "var(--brand-depth-spread-none, 0)",
    "brand-interactive-ixDisabled-strongest": "var(--brand-interactive-ix-disabled-strongest)",
    "brand-interactive-ixDisabled-stronger": "var(--brand-interactive-ix-disabled-stronger)",
    "brand-interactive-ixDisabled-strong": "var(--brand-interactive-ix-disabled-strong)",
    "brand-interactive-ixDisabled-default": "var(--brand-interactive-ix-disabled-default)",
    "brand-interactive-ixDisabled-weak": "var(--brand-interactive-ix-disabled-weak)",
    "brand-interactive-ixDisabled-weaker": "var(--brand-interactive-ix-disabled-weaker)",
    "brand-interactive-ixDisabled-white": "var(--brand-interactive-ix-disabled-white)",
    "brand-interactive-ixFocus-strong": "var(--brand-interactive-ix-focus-strong, rgba(23, 35, 102, 1.00))",
    "brand-interactive-ixFocus-weak": "var(--brand-interactive-ix-focus-weak, rgba(247, 248, 255, 1.00))",
    "brand-depth-position-none": "var(--brand-depth-position-none, 0)",
    "brand-depth-position-xs": "var(--brand-depth-position-xs, 2)",
    "brand-depth-position-sm": "var(--brand-depth-position-sm, 3)",
    "brand-depth-position-md": "var(--brand-depth-position-md, 6)",
    "brand-depth-gradientStart-weak": "var(--brand-depth-gradient-start-weak, rgba(255, 255, 255, 0.60))",
    "brand-depth-gradientEnd-weak": "var(--brand-depth-gradient-end-weak, rgba(255, 255, 255, 0.00))",
    "brand-interactive-ixAccent-stronger": "var(--brand-interactive-ix-accent-stronger, rgba(221, 150, 32, 1.00))",
    "brand-interactive-ixAccent-strong": "var(--brand-interactive-ix-accent-strong, rgba(245, 166, 35, 1.00))",
    "brand-interactive-ixAccent-default": "var(--brand-interactive-ix-accent-default, rgba(254, 199, 47, 1.00))",
    "brand-interactive-ixAccent-weak": "var(--brand-interactive-ix-accent-weak, rgba(255, 227, 151, 1.00))",
    "brand-interactive-ixAccent-weaker": "var(--brand-interactive-ix-accent-weaker, rgba(255, 248, 229, 1.00))",
    static: "var(--static)",
    "components-link-default": "var(--components-link-default)",
    "components-link-hover": "var(--components-link-hover)",
    "components-link-active": "var(--components-link-active)",
    foreground: "var(--foreground)",
    hover: "var(--hover, rgba(255, 255, 255, 1.00))",
    background: "var(--background)",
    "density-formElement-size-sm": "var(--density-form-element-size-sm)",
    "density-formElement-size-md": "var(--density-form-element-size-md)"
  },
  minWidth: {
    "brand-grid-grid": "var(--brand-grid-grid-min-width, 0px)",
    "density-formElement-xs": "var(--density-form-element-min-width-xs)",
    "density-status-sm": "var(--density-status-min-width-sm)",
    grid: "var(--grid-min-width, 0)"
  },
  borderWidth: {
    "brand-05": "var(--brand-border-width-05, 0.5px)",
    "brand-10": "var(--brand-border-width-10, 1px)",
    "brand-15": "var(--brand-border-width-15, 1.5px)",
    "brand-20": "var(--brand-border-width-20, 2px)",
    "brand-40": "var(--brand-border-width-40, 4px)",
    "density-focus-innerline": "var(--density-focus-border-width-innerline)",
    "density-focus-outline": "var(--density-focus-border-width-outline)",
    "density-formElement-default": "var(--density-form-element-border-width-default)",
    "density-action-default": "var(--density-action-border-width-default)",
    "density-action-thin": "var(--density-action-border-width-thin)",
    "density-status-default": "var(--density-status-border-width-default)",
    "density-static-default": "var(--density-static-border-width-default)",
    "density-feedback": "var(--density-feedback-border-width)"
  },
  borderRadius: {
    "brand-none": "var(--brand-border-radius-none, 0px)",
    "brand-xs": "var(--brand-border-radius-xs, 2px)",
    "brand-sm": "var(--brand-border-radius-sm, 4px)",
    "brand-md": "var(--brand-border-radius-md, 6px)",
    "brand-lg": "var(--brand-border-radius-lg, 8px)",
    "brand-xl": "var(--brand-border-radius-xl, 16px)",
    "brand-full": "var(--brand-border-radius-full, 9999px)",
    "density-action-none": "var(--density-action-border-radius-none)",
    "density-action-default": "var(--density-action-border-radius-default)",
    "density-action-sm": "var(--density-action-border-radius-sm)",
    "density-action-full": "var(--density-action-border-radius-full)",
    "density-formElement-xs": "var(--density-form-element-border-radius-xs)",
    "density-formElement-sm": "var(--density-form-element-border-radius-sm)",
    "density-status-xs": "var(--density-status-border-radius-xs)",
    "density-status-full": "var(--density-status-border-radius-full)",
    "density-static-none": "var(--density-static-border-radius-none)",
    "density-static-xs": "var(--density-static-border-radius-xs)",
    "density-static-sm": "var(--density-static-border-radius-sm)",
    "density-static-md": "var(--density-static-border-radius-md)",
    "density-static-lg": "var(--density-static-border-radius-lg)",
    "density-static-xl": "var(--density-static-border-radius-xl)",
    "density-static-full": "var(--density-static-border-radius-full)",
    "density-feedback-xs": "var(--density-feedback-border-radius-xs)"
  },
  spacing: {
    "brand-0": "var(--brand-spacing-0, 0px)",
    "brand-2": "var(--brand-spacing-2, 2px)",
    "brand-4": "var(--brand-spacing-4, 4px)",
    "brand-8": "var(--brand-spacing-8, 8px)",
    "brand-12": "var(--brand-spacing-12, 12px)",
    "brand-16": "var(--brand-spacing-16, 16px)",
    "brand-20": "var(--brand-spacing-20, 20px)",
    "brand-24": "var(--brand-spacing-24, 24px)",
    "brand-32": "var(--brand-spacing-32, 32px)",
    "brand-40": "var(--brand-spacing-40, 40px)",
    "brand-48": "var(--brand-spacing-48, 48px)",
    "brand-64": "var(--brand-spacing-64, 64px)",
    "density-formElement-gap-xs": "var(--density-form-element-spacing-gap-xs)",
    "density-formElement-gap-sm": "var(--density-form-element-spacing-gap-sm)",
    "density-formElement-gap-md": "var(--density-form-element-spacing-gap-md)",
    "density-formElement-gap-lg": "var(--density-form-element-spacing-gap-lg)",
    "density-formElement-padding-none": "var(--density-form-element-spacing-padding-none)",
    "density-formElement-padding-xs": "var(--density-form-element-spacing-padding-xs)",
    "density-formElement-padding-sm": "var(--density-form-element-spacing-padding-sm)",
    "density-formElement-padding-md": "var(--density-form-element-spacing-padding-md)",
    "density-formElement-padding-lg": "var(--density-form-element-spacing-padding-lg)",
    "density-formElement-padding-xl": "var(--density-form-element-spacing-padding-xl)",
    "density-action-height-2xs": "var(--density-action-spacing-height-2xs)",
    "density-action-height-xs": "var(--density-action-spacing-height-xs)",
    "density-action-height-sm": "var(--density-action-spacing-height-sm)",
    "density-action-height-md": "var(--density-action-spacing-height-md)",
    "density-action-height-lg": "var(--density-action-spacing-height-lg)",
    "density-action-height-xl": "var(--density-action-spacing-height-xl)",
    "density-action-width-2xs": "var(--density-action-spacing-width-2xs)",
    "density-action-width-xs": "var(--density-action-spacing-width-xs)",
    "density-action-width-sm": "var(--density-action-spacing-width-sm)",
    "density-action-width-md": "var(--density-action-spacing-width-md)",
    "density-action-width-lg": "var(--density-action-spacing-width-lg)",
    "density-action-icon-xs": "var(--density-action-spacing-icon-xs)",
    "density-action-width-xl": "var(--density-action-spacing-width-xl)",
    "density-action-icon-sm": "var(--density-action-spacing-icon-sm)",
    "density-action-icon-md": "var(--density-action-spacing-icon-md)",
    "density-action-icon-lg": "var(--density-action-spacing-icon-lg)",
    "density-action-padding-3xs": "var(--density-action-spacing-padding-3xs)",
    "density-action-icon-xl": "var(--density-action-spacing-icon-xl)",
    "density-action-padding-2xs": "var(--density-action-spacing-padding-2xs)",
    "density-action-padding-xs": "var(--density-action-spacing-padding-xs, 6px)",
    "density-action-padding-sm": "var(--density-action-spacing-padding-sm)",
    "density-action-padding-md": "var(--density-action-spacing-padding-md)",
    "density-action-padding-lg": "var(--density-action-spacing-padding-lg)",
    "density-action-padding-xl": "var(--density-action-spacing-padding-xl)",
    "density-action-padding-2xl": "var(--density-action-spacing-padding-2xl)",
    "density-action-padding-3xl": "var(--density-action-spacing-padding-3xl)",
    "density-action-gap-sm": "var(--density-action-spacing-gap-sm)",
    "density-action-gap-md": "var(--density-action-spacing-gap-md)",
    "density-action-gap-lg": "var(--density-action-spacing-gap-lg)",
    "density-action-gap-xl": "var(--density-action-spacing-gap-xl)",
    "density-status-gap-sm": "var(--density-status-spacing-gap-sm)",
    "density-status-icon-xs": "var(--density-status-spacing-icon-xs)",
    "density-status-padding-sm": "var(--density-status-spacing-padding-sm, 4px)",
    "density-status-padding-md": "var(--density-status-spacing-padding-md, 8px)",
    "density-static-padding-3xs": "var(--density-static-spacing-padding-3xs)",
    "density-static-padding-2xs": "var(--density-static-spacing-padding-2xs)",
    "density-static-padding-xs": "var(--density-static-spacing-padding-xs)",
    "density-static-padding-sm": "var(--density-static-spacing-padding-sm)",
    "density-static-padding-md": "var(--density-static-spacing-padding-md)",
    "density-static-padding-lg": "var(--density-static-spacing-padding-lg)",
    "density-static-padding-xl": "var(--density-static-spacing-padding-xl)",
    "density-static-width-xs": "var(--density-static-spacing-width-xs)",
    "density-static-width-sm": "var(--density-static-spacing-width-sm)",
    "density-static-gap-xs": "var(--density-static-spacing-gap-xs)",
    "density-static-icon-sm": "var(--density-static-spacing-icon-sm)",
    "density-static-icon-md": "var(--density-static-spacing-icon-md)",
    "density-static-icon-lg": "var(--density-static-spacing-icon-lg)",
    "density-static-icon-xl": "var(--density-static-spacing-icon-xl)",
    "density-static-gap-sm": "var(--density-static-spacing-gap-sm)",
    "density-static-gap-md": "var(--density-static-spacing-gap-md)",
    "density-feedback-padding-sm": "var(--density-feedback-spacing-padding-sm)",
    "density-feedback-padding-md": "var(--density-feedback-spacing-padding-md)"
  },
  blur: {
    "brand-depth-xs": "var(--brand-depth-blur-xs, 8)",
    "brand-depth-sm": "var(--brand-depth-blur-sm, 10)",
    "brand-depth-md": "var(--brand-depth-blur-md, 20)"
  },
  stroke: {
    "": "var(--stroke)"
  },
  height: {
    "density-formElement-xs": "var(--density-form-element-height-xs)",
    "density-formElement-sm": "var(--density-form-element-height-sm)",
    "density-formElement-md": "var(--density-form-element-height-md)",
    "density-formElement-lg": "var(--density-form-element-height-lg)",
    "density-formElement-xl": "var(--density-form-element-height-xl)"
  },
  gap: {
    "density-feedback-sm": "var(--density-feedback-gap-sm)",
    "density-feedback-md": "var(--density-feedback-gap-md)",
    "density-feedback-lg": "var(--density-feedback-gap-lg)",
    grid: "var(--grid-gap, 8)"
  },
  width: {
    "density-component-switch-sm": "var(--density-component-switch-width-sm, 28)",
    "density-component-switch-md": "var(--density-component-switch-width-md, 42)",
    "density-component-tag-sm": "var(--density-component-tag-width-sm, 160)"
  },
  minHeight: {
    "density-formElement-xs": "var(--density-form-element-min-height-xs)",
    "density-formElement-lg": "var(--density-form-element-min-height-lg)"
  },
  maxWidth: {
    grid: "var(--grid-max-width, 639)"
  },
  padding: {
    grid: "var(--grid-padding, 16px)"
  },
  columns: {
    grid: "var(--grid-columns, 4)"
  }
}, N = function(...e) {
  return ES(U0(e));
};
DS({
  ...AS,
  ...$S
});
function em(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = em(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function LS() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = em(e)) && (r && (r += " "), r += t);
  return r;
}
const wd = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, bd = LS, oe = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return bd(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: a } = t, i = Object.keys(o).map((c) => {
    const u = n == null ? void 0 : n[c], d = a == null ? void 0 : a[c];
    if (u === null) return null;
    const f = wd(u) || wd(d);
    return o[c][f];
  }), s = n && Object.entries(n).reduce((c, u) => {
    let [d, f] = u;
    return f === void 0 || (c[d] = f), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: f, ...p } = u;
    return Object.entries(p).every((h) => {
      let [g, w] = h;
      return Array.isArray(w) ? w.includes({
        ...a,
        ...s
      }[g]) : {
        ...a,
        ...s
      }[g] === w;
    }) ? [
      ...c,
      d,
      f
    ] : c;
  }, []);
  return bd(e, i, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, yd = oe("tw-flex tw-justify-center ", {
  variants: {
    size: {
      sm: "tw-size-density-action-icon-sm",
      md: "tw-size-density-action-icon-md",
      lg: "tw-size-density-action-icon-lg",
      xl: "tw-size-density-action-icon-xl"
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), de = q(
  ({ icon: e, size: t = "sm", className: n, ...r }, o) => {
    const a = e.replace(/[^a-zA-Z0-9-]/g, ""), i = wc(() => a === "" ? (console.error("Icon name is required and cannot be empty."), null) : c0(() => G0(/* @__PURE__ */ Object.assign({ "./generated/360-degrees.tsx": () => import("./360-degrees-DQDuJgl3.js"), "./generated/Vector.tsx": () => import("./Vector-Cfql0OsS.js"), "./generated/address-book.tsx": () => import("./address-book-BqiMqjC0.js"), "./generated/address-card.tsx": () => import("./address-card-DI4gn_2m.js"), "./generated/anchor.tsx": () => import("./anchor-CsQIPgfE.js"), "./generated/arrow-down-left-and-arrow-up-right-to-center.tsx": () => import("./arrow-down-left-and-arrow-up-right-to-center-Bu60Uumz.js"), "./generated/arrow-down-square-triangle.tsx": () => import("./arrow-down-square-triangle-CiHhflFe.js"), "./generated/arrow-down-to-square.tsx": () => import("./arrow-down-to-square-Czg6FGJZ.js"), "./generated/arrow-down-up.tsx": () => import("./arrow-down-up-Cvur1yZ0.js"), "./generated/arrow-down.tsx": () => import("./arrow-down-BUWzdoMb.js"), "./generated/arrow-left.tsx": () => import("./arrow-left-BwBIx5Qk.js"), "./generated/arrow-right.tsx": () => import("./arrow-right-CtnzKusR.js"), "./generated/arrow-turn-down-right.tsx": () => import("./arrow-turn-down-right-DjilInEi.js"), "./generated/arrow-up-right-and-arrow-down-left-from-center.tsx": () => import("./arrow-up-right-and-arrow-down-left-from-center-oC89cTJC.js"), "./generated/arrow-up-right-from-square.tsx": () => import("./arrow-up-right-from-square-Daa6xymj.js"), "./generated/arrow-up-square-triangle.tsx": () => import("./arrow-up-square-triangle-LRNXcwCn.js"), "./generated/arrow-up-to-square.tsx": () => import("./arrow-up-to-square-hCsHVP-D.js").then((s) => s.a), "./generated/arrow-up.tsx": () => import("./arrow-up-16VeNn3o.js"), "./generated/arrows-expand.tsx": () => import("./arrows-expand-DO-ScQPt.js"), "./generated/badge-dollar.tsx": () => import("./badge-dollar-1IRIhXS_.js"), "./generated/bag-shopping.tsx": () => import("./bag-shopping-BwzbSK06.js"), "./generated/barcode-read.tsx": () => import("./barcode-read-BjNka6Zb.js"), "./generated/barcode-scan.tsx": () => import("./barcode-scan-Qk_NMbjN.js"), "./generated/barcode.tsx": () => import("./barcode-lLWpKH2y.js"), "./generated/bars.tsx": () => import("./bars-CXrtRN-9.js"), "./generated/bolt.tsx": () => import("./bolt-DlMy0QgT.js"), "./generated/bookmark-solid.tsx": () => import("./bookmark-solid-D49OCILt.js"), "./generated/bookmark.tsx": () => import("./bookmark-BIS_da4c.js"), "./generated/building.tsx": () => import("./building-DFvrI-ID.js"), "./generated/buildings.tsx": () => import("./buildings-B2n83kya.js"), "./generated/bullseye.tsx": () => import("./bullseye-DYAU6dzO.js"), "./generated/calendar-day.tsx": () => import("./calendar-day-CHzpf2MP.js"), "./generated/calendar-week.tsx": () => import("./calendar-week-BXh4yEcU.js"), "./generated/camera-viewfinder.tsx": () => import("./camera-viewfinder-BlHJqc7K.js"), "./generated/camera.tsx": () => import("./camera-BGFCSi3a.js"), "./generated/car-side-bolt.tsx": () => import("./car-side-bolt-SwqbSbNq.js"), "./generated/car-side.tsx": () => import("./car-side-DDPvXdbY.js"), "./generated/car.tsx": () => import("./car-1rjM43EG.js"), "./generated/caret-down.tsx": () => import("./caret-down-Bkr1wmFx.js"), "./generated/caret-left.tsx": () => import("./caret-left-CtcJMZ61.js"), "./generated/caret-right.tsx": () => import("./caret-right-MZMSPA3i.js"), "./generated/caret-up.tsx": () => import("./caret-up-D-LtPZ-J.js"), "./generated/cars.tsx": () => import("./cars-CtYGWN5X.js"), "./generated/cart-circle-plus.tsx": () => import("./cart-circle-plus-CdgOiuxE.js"), "./generated/cart-circle-xmark.tsx": () => import("./cart-circle-xmark-DcNMZeL4.js"), "./generated/cart-plus.tsx": () => import("./cart-plus-Bm1S4m-H.js"), "./generated/cart-shopping-fast.tsx": () => import("./cart-shopping-fast-B54AxwLp.js"), "./generated/cart-shopping.tsx": () => import("./cart-shopping-BC9dw2lU.js"), "./generated/chart-line-up-solid.tsx": () => import("./chart-line-up-solid-BHvKqYC8.js"), "./generated/check.tsx": () => import("./check-BKCKfIB2.js"), "./generated/checkbox-checked.tsx": () => import("./checkbox-checked-CvCBjRtU.js"), "./generated/checkbox-unchecked.tsx": () => import("./checkbox-unchecked-zWQolLoQ.js"), "./generated/chevron-down.tsx": () => import("./chevron-down-HHsBbEqR.js"), "./generated/chevron-left.tsx": () => import("./chevron-left-B_oOLnBe.js"), "./generated/chevron-right.tsx": () => import("./chevron-right-X5dshPjU.js"), "./generated/chevron-up.tsx": () => import("./chevron-up-ZU-PPVTY.js"), "./generated/chevrons-down.tsx": () => import("./chevrons-down-Bf285ZZ_.js"), "./generated/chevrons-left.tsx": () => import("./chevrons-left-BvumrCvn.js"), "./generated/chevrons-right.tsx": () => import("./chevrons-right-Dzjs8UFw.js"), "./generated/chevrons-up.tsx": () => import("./chevrons-up-DU79Ro94.js"), "./generated/circle-check.tsx": () => import("./circle-check-Bqkx2IZ7.js"), "./generated/circle-chevron-down.tsx": () => import("./circle-chevron-down-DilGTpFA.js"), "./generated/circle-chevron-left.tsx": () => import("./circle-chevron-left-BK8CFQYX.js"), "./generated/circle-chevron-right.tsx": () => import("./circle-chevron-right-CbHFKMAx.js"), "./generated/circle-chevron-up.tsx": () => import("./circle-chevron-up-BUSPsJp4.js"), "./generated/circle-info.tsx": () => import("./circle-info-BgL2AlVW.js"), "./generated/circle-play.tsx": () => import("./circle-play-CR77MskU.js"), "./generated/circle-plus.tsx": () => import("./circle-plus-DuPyjhbB.js"), "./generated/circle-question.tsx": () => import("./circle-question-COReqaGC.js"), "./generated/circle-user.tsx": () => import("./circle-user-O_fkXIyC.js"), "./generated/circle-xmark.tsx": () => import("./circle-xmark-CSnD5TW2.js"), "./generated/clipboard.tsx": () => import("./clipboard-DHSkk3Q1.js"), "./generated/clock-rotate-left.tsx": () => import("./clock-rotate-left-DvgUo-Yn.js"), "./generated/clock.tsx": () => import("./clock-DuzbzK8P.js"), "./generated/cloud-arrow-down.tsx": () => import("./cloud-arrow-down-e5CuHLL1.js"), "./generated/cloud-arrow-up.tsx": () => import("./cloud-arrow-up-CZIuukze.js"), "./generated/code.tsx": () => import("./code-BIerEHX-.js"), "./generated/columns-3.tsx": () => import("./columns-3-CsEDIHar.js"), "./generated/comma.tsx": () => import("./comma-DXuF9xGP.js"), "./generated/compress.tsx": () => import("./compress-BVhIQJcf.js"), "./generated/computer.tsx": () => import("./computer-BImzIeO7.js"), "./generated/credit-card-blank-sharp-solid.tsx": () => import("./credit-card-blank-sharp-solid-DWeXhJTx.js"), "./generated/credit-card.tsx": () => import("./credit-card-CJOqKAKg.js"), "./generated/dash.tsx": () => import("./dash-BsJs7XXq.js"), "./generated/desktop.tsx": () => import("./desktop-pNCok0ps.js"), "./generated/diamond.tsx": () => import("./diamond-DCrP9KnA.js"), "./generated/document.tsx": () => import("./document-BlI3UGyB.js"), "./generated/down-to-bracket.tsx": () => import("./down-to-bracket-DSOhD3Ql.js"), "./generated/down.tsx": () => import("./down-DczkgCjT.js"), "./generated/ellipsis-vertical.tsx": () => import("./ellipsis-vertical-Cay1qmP0.js"), "./generated/ellipsis.tsx": () => import("./ellipsis-De4YoAnO.js"), "./generated/engine.tsx": () => import("./engine-BYpemUMQ.js"), "./generated/envelope-circle-check.tsx": () => import("./envelope-circle-check-DW6_ThcN.js"), "./generated/envelope-dot.tsx": () => import("./envelope-dot-CUIm12Qw.js"), "./generated/envelope-open-dollar.tsx": () => import("./envelope-open-dollar-C96VV0pg.js"), "./generated/envelope-open-text.tsx": () => import("./envelope-open-text-DYUbepF4.js"), "./generated/envelope-open.tsx": () => import("./envelope-open-CfPsIprG.js"), "./generated/envelope.tsx": () => import("./envelope-m2qaBFNX.js"), "./generated/expand.tsx": () => import("./expand-BpoGfT-b.js"), "./generated/eye-slash.tsx": () => import("./eye-slash-D0r5JERE.js"), "./generated/eye.tsx": () => import("./eye-CZTZXd-w.js"), "./generated/face-viewfinder.tsx": () => import("./face-viewfinder-CxNzg-bP.js"), "./generated/file-invoice-dollar.tsx": () => import("./file-invoice-dollar-DhIfkTsZ.js"), "./generated/file-invoice.tsx": () => import("./file-invoice-BCwu6FKd.js"), "./generated/file-spreadsheet.tsx": () => import("./file-spreadsheet-Bl1Yg0j6.js"), "./generated/filter.tsx": () => import("./filter-CqNd68Jn.js"), "./generated/flag.tsx": () => import("./flag-CIyxzKbP.js"), "./generated/flask.tsx": () => import("./flask-DI-bx3I_.js"), "./generated/folder-arrow-up.tsx": () => import("./folder-arrow-up-CGCA7kQn.js"), "./generated/folder-closed.tsx": () => import("./folder-closed-wACRv-wS.js"), "./generated/gauge-circle-minus.tsx": () => import("./gauge-circle-minus-CITstsky.js"), "./generated/gauge-circle-plus.tsx": () => import("./gauge-circle-plus-CRy73S9F.js"), "./generated/gauge-simple-max-sharp-solid.tsx": () => import("./gauge-simple-max-sharp-solid-CocIp-o_.js"), "./generated/gauge.tsx": () => import("./gauge-SiNPFIhP.js"), "./generated/gear.tsx": () => import("./gear-n3adaFVr.js"), "./generated/globe.tsx": () => import("./globe-ldAlXgpl.js"), "./generated/grid-2.tsx": () => import("./grid-2-DorTAxKy.js"), "./generated/grid-dividers.tsx": () => import("./grid-dividers-W3VHA_PJ.js"), "./generated/grid-horizontal.tsx": () => import("./grid-horizontal-DoNhvY4b.js"), "./generated/grid-round.tsx": () => import("./grid-round-tcuFMXpj.js"), "./generated/grid.tsx": () => import("./grid-DtAuSk75.js"), "./generated/grip-corner.tsx": () => import("./grip-corner-BocQ_tmj.js"), "./generated/grip-lines-vertical.tsx": () => import("./grip-lines-vertical-BXAncGr4.js"), "./generated/grip-lines.tsx": () => import("./grip-lines-iXxlB-ak.js"), "./generated/heart-filled.tsx": () => import("./heart-filled-B81jyZFJ.js"), "./generated/heart.tsx": () => import("./heart-B8bkd9pY.js"), "./generated/hourglass.tsx": () => import("./hourglass-B6WqOsRg.js"), "./generated/house-blank.tsx": () => import("./house-blank-B3UOq8vN.js"), "./generated/house.tsx": () => import("./house-CEGTcXl5.js"), "./generated/image-slash.tsx": () => import("./image-slash-CNPEM1CO.js"), "./generated/image-user.tsx": () => import("./image-user-DujdzoOd.js"), "./generated/image.tsx": () => import("./image-CE6kbjUs.js"), "./generated/input-generic-sharp-solid.tsx": () => import("./input-generic-sharp-solid-C5Pn2jem.js"), "./generated/input-numeric.tsx": () => import("./input-numeric-C4nhdRJv.js"), "./generated/laptop-mobile.tsx": () => import("./laptop-mobile-DgrD71BY.js"), "./generated/laptop.tsx": () => import("./laptop-B4EYHHZH.js"), "./generated/list-check.tsx": () => import("./list-check-C66-yUow.js"), "./generated/list-radio.tsx": () => import("./list-radio-zg31D7Bt.js"), "./generated/list.tsx": () => import("./list-pk2JmewT.js"), "./generated/location-arrow.tsx": () => import("./location-arrow-ZjSwsJ3a.js"), "./generated/location-check.tsx": () => import("./location-check-DhXEPKA0.js"), "./generated/location-dot.tsx": () => import("./location-dot-DyvLiWEF.js"), "./generated/location-pen.tsx": () => import("./location-pen-BTwOnRy3.js"), "./generated/location-pin-lock.tsx": () => import("./location-pin-lock-B2GkZNE2.js"), "./generated/location-pin.tsx": () => import("./location-pin-DCPHcrTF.js"), "./generated/location-plus.tsx": () => import("./location-plus-aYz6LV36.js"), "./generated/lock-open.tsx": () => import("./lock-open-RWd3n3Oy.js"), "./generated/lock.tsx": () => import("./lock-zxoylHpW.js"), "./generated/logo.tsx": () => import("./logo-DKJfhExD.js"), "./generated/magnifying-glass.tsx": () => import("./magnifying-glass-BTw8D48-.js"), "./generated/maximize.tsx": () => import("./maximize-BISy38Bs.js"), "./generated/memo.tsx": () => import("./memo-CPFolRLS.js"), "./generated/message-exclamation.tsx": () => import("./message-exclamation-drcD6x41.js"), "./generated/message.tsx": () => import("./message-pRy2Ubow.js"), "./generated/messages.tsx": () => import("./messages-CEImiBu6.js"), "./generated/microphone-solid.tsx": () => import("./microphone-solid-B_LmqFiu.js"), "./generated/minus.tsx": () => import("./minus-Dd_HCQaC.js"), "./generated/money-check-dollar-pen.tsx": () => import("./money-check-dollar-pen-Bz0RB2Py.js"), "./generated/money-check-pen.tsx": () => import("./money-check-pen-D6JIG5J-.js"), "./generated/notification.tsx": () => import("./notification-b4tIDmkP.js"), "./generated/octagon-exclamation.tsx": () => import("./octagon-exclamation-CrECZYeN.js"), "./generated/octagon-xmark.tsx": () => import("./octagon-xmark-B6AOdkvw.js"), "./generated/pen-to-square.tsx": () => import("./pen-to-square-BzoxOU2i.js"), "./generated/pen.tsx": () => import("./pen-wRtD0_1B.js"), "./generated/person-circle-minus.tsx": () => import("./person-circle-minus-C2_YSg4b.js"), "./generated/person-circle-plus.tsx": () => import("./person-circle-plus-6YnIE5rc.js"), "./generated/phone.tsx": () => import("./phone-PBPwjY96.js"), "./generated/play.tsx": () => import("./play-DHXLBdZ5.js"), "./generated/plus-large.tsx": () => import("./plus-large-z3SU_uSo.js"), "./generated/plus.tsx": () => import("./plus-DqZ0qvcs.js"), "./generated/print.tsx": () => import("./print-CVvv6vaE.js"), "./generated/question.tsx": () => import("./question-Dc8CS31O.js"), "./generated/receipt.tsx": () => import("./receipt-DM8QvQ5r.js"), "./generated/rectangle-barcode.tsx": () => import("./rectangle-barcode-D0JpdN_L.js"), "./generated/rectangle-history.tsx": () => import("./rectangle-history-qszNVpxd.js"), "./generated/rectangle-vertical-history.tsx": () => import("./rectangle-vertical-history-DrZ8bKGz.js"), "./generated/right-from-bracket.tsx": () => import("./right-from-bracket-DzDEvJ7x.js"), "./generated/right-to-bracket.tsx": () => import("./right-to-bracket-CgTkBsQD.js"), "./generated/rotate.tsx": () => import("./rotate-DgT8KfRJ.js"), "./generated/rv.tsx": () => import("./rv-Cfd8LvRI.js"), "./generated/seal.tsx": () => import("./seal-P1dvmbi1.js"), "./generated/sedan.tsx": () => import("./sedan-DxsDaHt8.js"), "./generated/share-from-square.tsx": () => import("./share-from-square-CvQX2MuS.js"), "./generated/shield.tsx": () => import("./shield-BPsoPrGM.js"), "./generated/sidebar-flip.tsx": () => import("./sidebar-flip-DdEQRLhS.js"), "./generated/sidebar.tsx": () => import("./sidebar-DYieEkTF.js"), "./generated/sort-down.tsx": () => import("./sort-down-Dsqw7zmH.js"), "./generated/sort-up.tsx": () => import("./sort-up-DELgN8CY.js"), "./generated/sort.tsx": () => import("./sort-CoOZXsFj.js"), "./generated/sparkles.tsx": () => import("./sparkles-DdvIyt1o.js"), "./generated/spinner-third.tsx": () => import("./spinner-third-NuLESZU6.js"), "./generated/square-arrow-down.tsx": () => import("./square-arrow-down-bWnWCmgz.js"), "./generated/square-arrow-left.tsx": () => import("./square-arrow-left-B2Mcv3RL.js"), "./generated/square-arrow-right.tsx": () => import("./square-arrow-right-CmqEdnQu.js"), "./generated/square-arrow-up.tsx": () => import("./square-arrow-up-DIEWJTAk.js"), "./generated/square-caret-down.tsx": () => import("./square-caret-down-CtJKGRQ9.js"), "./generated/square-caret-left.tsx": () => import("./square-caret-left-D6Yrgxtp.js"), "./generated/square-caret-right.tsx": () => import("./square-caret-right-Daf8SNE5.js"), "./generated/square-caret-up.tsx": () => import("./square-caret-up-oC8-nuso.js"), "./generated/square-check.tsx": () => import("./square-check-BvBF4XLu.js"), "./generated/square-chevron-down.tsx": () => import("./square-chevron-down-CwqWPv5i.js"), "./generated/square-chevron-left.tsx": () => import("./square-chevron-left-L7zSWvv7.js"), "./generated/square-chevron-right.tsx": () => import("./square-chevron-right-BNnLOqr0.js"), "./generated/square-chevron-up.tsx": () => import("./square-chevron-up-D7T8jGlL.js"), "./generated/square-code.tsx": () => import("./square-code-DOruInED.js"), "./generated/square-exclamation.tsx": () => import("./square-exclamation-DPxPblj8.js"), "./generated/square-full.tsx": () => import("./square-full-C8s_WEby.js"), "./generated/square-heart.tsx": () => import("./square-heart-Bfv_meBW.js"), "./generated/square-info.tsx": () => import("./square-info-DSu96-8D.js"), "./generated/square-minus.tsx": () => import("./square-minus-C9uA7E9i.js"), "./generated/square-pen.tsx": () => import("./square-pen-JZcM2Am0.js"), "./generated/square-phone.tsx": () => import("./square-phone-Df7E7Wzg.js"), "./generated/square-plus.tsx": () => import("./square-plus-D932PpVc.js"), "./generated/square-question.tsx": () => import("./square-question-DkJRuCW5.js"), "./generated/square-share-nodes.tsx": () => import("./square-share-nodes-LSrsP10Y.js"), "./generated/square-sharp.tsx": () => import("./square-sharp-CV-xIqJ9.js"), "./generated/square-sliders-vertical.tsx": () => import("./square-sliders-vertical-eyrIDCFn.js"), "./generated/square-sliders.tsx": () => import("./square-sliders-eLN7IyWz.js"), "./generated/square-small.tsx": () => import("./square-small-C8s_WEby.js"), "./generated/square-star.tsx": () => import("./square-star-DGRweN57.js"), "./generated/square-up-right.tsx": () => import("./square-up-right-ed_efR8T.js"), "./generated/square-up.tsx": () => import("./square-up-CeEEdC7L.js"), "./generated/square-user.tsx": () => import("./square-user-BWN63L-b.js"), "./generated/square-xmark.tsx": () => import("./square-xmark-ByaycjzS.js"), "./generated/square.tsx": () => import("./square-CTIcuUS9.js"), "./generated/star-half-stroke.tsx": () => import("./star-half-stroke-dRfEHoY4.js"), "./generated/star.tsx": () => import("./star-etSoYG3l.js"), "./generated/steering-wheel.tsx": () => import("./steering-wheel-D8T9-xuF.js"), "./generated/stop.tsx": () => import("./stop-D1mUrnKC.js"), "./generated/table-cells-large.tsx": () => import("./table-cells-large-B06TT_eE.js"), "./generated/table-cells.tsx": () => import("./table-cells-QCQLI1Fw.js"), "./generated/table-layout.tsx": () => import("./table-layout-BMWrNO0s.js"), "./generated/table.tsx": () => import("./table-C_6jmFCz.js"), "./generated/tag.tsx": () => import("./tag-C_GpaEP3.js"), "./generated/tags.tsx": () => import("./tags-DDTLYXKJ.js"), "./generated/tractor.tsx": () => import("./tractor-shwZPfKt.js"), "./generated/trash-can.tsx": () => import("./trash-can-CTSBUrhb.js"), "./generated/trash.tsx": () => import("./trash-C4GlQNIk.js"), "./generated/triangle-exclamation.tsx": () => import("./triangle-exclamation-_D_ks3zY.js"), "./generated/truck-container.tsx": () => import("./truck-container-DZ8JKkZ4.js"), "./generated/truck-plane.tsx": () => import("./truck-plane-CnYD2AXu.js"), "./generated/truck.tsx": () => import("./truck-uLpdfsBY.js"), "./generated/up.tsx": () => import("./up-DE3haldX.js"), "./generated/user-plus.tsx": () => import("./user-plus-OoDduPlD.js"), "./generated/user.tsx": () => import("./user-HUAFMTii.js"), "./generated/users.tsx": () => import("./users-xnYwS7VG.js"), "./generated/wrench-simple.tsx": () => import("./wrench-simple-Rvw-9ute.js"), "./generated/xmark-large.tsx": () => import("./xmark-large-B5iT7xg5.js"), "./generated/xmark-lines.tsx": () => import("./xmark-lines-ClBJ2Ark.js"), "./generated/xmark.tsx": () => import("./xmark-BysvWIV4.js") }), `./generated/${a}.tsx`, 3)), [a]);
    return /* @__PURE__ */ m(
      "span",
      {
        className: N(yd({ size: t }), n),
        "aria-hidden": "true",
        ref: o,
        ...r,
        style: {
          ...r.style,
          backgroundColor: "tw-bg-transparent"
        },
        children: i && /* @__PURE__ */ m(
          u0,
          {
            fallback: /* @__PURE__ */ m("span", { className: N(yd({ size: t }), n), children: " " }),
            children: /* @__PURE__ */ m(i, {})
          }
        )
      }
    );
  }
);
de.displayName = "Icon";
const FS = oe(
  // AccordionChevron class added to missing tokens for icon animation
  "AccordionChevron custom-button-focus-ring--inset tw-flex tw-flex-1 tw-text-left tw-items-center tw-justify-between tw-w-full tw-p-density-action-padding-sm tw-py-density-action-padding-md tw-pr-density-action-padding-lg",
  {
    variants: {
      state: {
        default: "",
        disabled: "tw-cursor-not-allowed tw-text-semantic-action-foreground-neutral-weak hover:tw-text-semantic-action-foreground-neutral-weak "
      },
      open: {
        true: "tw-bg-semantic-action-background-primary-2xweakest"
        // background color when open
      }
    },
    defaultVariants: {
      state: "default",
      open: !1
    }
  }
), zS = "tw-flex", VS = "tw-border-semantic-action-border-neutral-lighter tw-border-b-density-action-thin last-of-type:tw-border-none tw-text-semantic-action-foreground-neutral-darkest tw-label-md-regular", BS = q(
  ({ value: e, defaultValue: t, onValueChange: n, type: r = "multiple", ...o }, a) => r === "single" ? /* @__PURE__ */ m(
    Cl,
    {
      ref: a,
      type: r,
      value: e,
      defaultValue: t,
      onValueChange: n,
      ...o
    }
  ) : /* @__PURE__ */ m(
    Cl,
    {
      ref: a,
      type: r,
      value: e,
      defaultValue: t,
      onValueChange: n,
      ...o
    }
  )
);
BS.displayName = Cl.displayName;
const HS = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    W0,
    {
      ref: n,
      className: N(VS, e),
      ...t
    }
  )
);
HS.displayName = "AccordionItem";
const WS = q(
  ({ className: e, children: t, ...n }, r) => {
    const o = n.asChild ? t : /* @__PURE__ */ ee(
      Ne,
      { children: [
        t,
        /* @__PURE__ */ m(
          de,
          {
            className: "custom-accordion-icon",
            icon: "chevron-down",
            size: "sm"
          }
        )
      ] }
    );
    return /* @__PURE__ */ m(
      j0,
      { className: zS, children: /* @__PURE__ */ m(
        Up,
        {
          ref: r,
          className: N(
            FS({
              state: n != null && n.disabled ? "disabled" : "default"
            }),
            e
          ),
          ...n,
          children: o
        }
      ) }
    );
  }
);
WS.displayName = Up.displayName;
const tm = q(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ m(
    _c,
    {
      ref: r,
      className: N(
        "tw-overflow-hidden tw-transition-all tw-duration-500 tw-ease-out",
        "data-[state=closed]:tw-animate-accordion-up data-[state=open]:tw-animate-accordion-down",
        e
      ),
      ...n,
      children: /* @__PURE__ */ m("div", { className: "tw-p-2", children: t })
    }
  )
);
tm.displayName = _c.displayName;
tm.displayName = _c.displayName;
const jS = oe("tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-density-action-default -visible:tw-outline-none disabled:tw-cursor-not-allowed disabled:tw-bg-semantic-action-background-neutral-weaker disabled:tw-text-semantic-action-foreground-neutral-weak custom-button-focus-ring tw-transition-all tw-duration-100 tw-ease-in-out", {
  variants: {
    variant: {
      solid: "",
      outline: "",
      ghost: ""
    },
    intent: {
      primary: "",
      neutral: "",
      destructive: "tw-text-semantic-action-foreground-neutral-white tw-bg-semantic-action-background-destructive-default hover:tw-bg-semantic-action-background-destructive-strong active:tw-bg-semantic-action-background-destructive-stronger ",
      // background-color on active
      accent: "tw-text-semantic-action-foreground-neutral-strongest tw-bg-semantic-action-background-accent-default hover:tw-bg-semantic-action-background-accent-strong active:tw-bg-semantic-action-background-accent-stronger ",
      // background-color on active
      success: "tw-text-semantic-action-foreground-neutral-strongest tw-bg-semantic-action-background-success-default hover:tw-bg-semantic-action-background-success-strong active:tw-bg-semantic-action-background-success-stronger "
      // background-color on active
    },
    spread: {
      true: "tw-justify-between",
      false: ""
    },
    size: {
      sm: "tw-h-density-action-height-sm tw-px-density-action-padding-sm tw-gap-density-action-gap-sm tw-font-semibold tw-text-xs",
      // font
      md: "tw-h-density-action-height-md tw-px-density-action-padding-md tw-gap-density-action-gap-md tw-font-[500] tw-text-sm",
      // font
      lg: "tw-h-density-action-height-lg tw-px-density-action-padding-lg tw-gap-density-action-gap-lg tw-font-[500] tw-text-base",
      // font
      xl: "tw-h-density-action-height-xl tw-px-density-action-padding-xl tw-gap-density-action-gap-xl tw-font-[500] tw-text-lg"
      // font
    },
    inverse: {
      true: "tw-bg-transparent !tw-text-white hover:!tw-bg-white/10",
      false: ""
    },
    state: {
      loading: "tw-pointer-events-none tw-opacity-50 tw-transition-opacity",
      success: "tw-pointer-events-none tw-bg-semantic-action-border-success-weak ",
      default: ""
    }
  },
  compoundVariants: [{
    intent: "primary",
    variant: "solid",
    inverse: !0,
    class: "!tw-bg-transparent !tw-text-white"
  }, {
    intent: "primary",
    variant: "solid",
    inverse: !1,
    class: "tw-text-semantic-action-foreground-neutral-white tw-bg-semantic-action-background-primary-default hover:tw-bg-semantic-action-background-primary-strong active:tw-bg-semantic-action-background-primary-strongest "
    // background-color on active
  }, {
    intent: "primary",
    variant: "outline",
    class: "tw-text-semantic-action-foreground-primary-default tw-bg-semantic-action-background-neutral-white tw-border-semantic-action-border-primary-default tw-border-[16pxpx] hover:tw-bg-semantic-action-background-primary-weakest active:tw-bg-semantic-action-background-primary-weak active:tw-border-semantic-action-border-primary-default "
    // border-color on hover
  }, {
    intent: "primary",
    variant: "ghost",
    class: "tw-text-semantic-action-foreground-primary-default hover:tw-bg-semantic-action-background-primary-weakest active:tw-bg-semantic-action-background-primary-weaker disabled:tw-bg-transparent "
  }, {
    intent: "neutral",
    variant: "solid",
    class: "tw-text-semantic-action-foreground-neutral-strongest tw-bg-semantic-action-background-neutral-weaker hover:tw-bg-semantic-action-background-neutral-light active:tw-bg-semantic-action-background-neutral-default "
    //border color on active
  }, {
    intent: "neutral",
    variant: "outline",
    class: "tw-text-semantic-action-foreground-neutral-strongest tw-bg-semantic-action-background-neutral-white tw-border-semantic-action-border-neutral-weak tw-border-[1px] hover:tw-bg-semantic-action-background-neutral-weakest active:tw-bg-semantic-action-background-neutral-weaker "
    //border color on active
  }, {
    intent: "neutral",
    variant: "ghost",
    class: "tw-text-semantic-action-foreground-neutral-strongest hover:tw-bg-semantic-action-background-neutral-weaker active:tw-bg-semantic-action-background-neutral-light disabled:tw-bg-transparent "
  }, {
    intent: "accent",
    variant: "solid",
    class: "tw-text-semantic-action-foreground-neutral-strongest tw-bg-semantic-action-background-accent-default hover:tw-bg-semantic-action-background-accent-strong active:tw-bg-semantic-action-background-accent-strong "
  }],
  defaultVariants: {
    variant: "solid",
    size: "md",
    intent: "neutral"
  }
}), GS = oe("tw-animate-spin tw-rounded-full", {
  variants: {
    color: {
      default: "tw-border-brand-primary-7 tw-border-t-brand-primary-3",
      inverse: "tw-border-brand-primary-3 tw-border-t-brand-primary-7",
      dark: "tw-border-brand-neutral-12 tw-border-t-brand-primary-3"
    },
    size: {
      sm: "tw-h-4 tw-w-4 tw-border-2",
      md: "tw-h-8 tw-w-8 tw-border-4",
      lg: "tw-h-12 tw-w-12 tw-border-4"
    }
  },
  defaultVariants: {
    color: "default",
    size: "md"
  }
}), nm = ({ color: e = "default", size: t = "md" }) => /* @__PURE__ */ m("div", { className: GS({ color: e, size: t }) }), pt = q(
  ({
    className: e,
    variant: t = "solid",
    size: n = "sm",
    intent: r = "neutral",
    iconLeft: o = "",
    iconRight: a = "",
    inverse: i = !1,
    spread: s = !1,
    state: l = "default",
    ...c
  }, u) => /* @__PURE__ */ ee(
    "button",
    {
      className: N(
        jS({
          variant: t,
          inverse: i,
          size: n,
          intent: r,
          className: e,
          state: l,
          spread: s
        })
      ),
      ref: u,
      ...c,
      children: [
        l === "loading" && /* @__PURE__ */ ee(
          Ne,
          { children: [
            /* @__PURE__ */ m(
              nm,
              {
                color: r === "primary" ? "default" : "dark",
                size: "sm"
              }
            ),
            c.children
          ] }
        ),
        l === "success" && /* @__PURE__ */ m(Ne, { children: c.children }),
        l === "default" && /* @__PURE__ */ ee(
          Ne,
          { children: [
            o && /* @__PURE__ */ m(de, { icon: o, size: "sm" }),
            c.children,
            a && /* @__PURE__ */ m(de, { icon: a, size: "sm" })
          ] }
        )
      ]
    }
  )
);
pt.displayName = "Button";
function US(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ze(e);
  v.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var qS = "DismissableLayer", kl = "dismissableLayer.update", YS = "dismissableLayer.pointerDownOutside", KS = "dismissableLayer.focusOutside", xd, rm = v.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), dr = v.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, c = v.useContext(rm), [u, d] = v.useState(null), f = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = v.useState({}), h = xe(t, (E) => d(E)), g = Array.from(c.layers), [w] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), b = g.indexOf(w), y = u ? g.indexOf(u) : -1, x = c.layersWithOutsidePointerEventsDisabled.size > 0, C = y >= b, S = JS((E) => {
      const M = E.target, F = [...c.branches].some((G) => G.contains(M));
      !C || F || (o == null || o(E), i == null || i(E), E.defaultPrevented || s == null || s());
    }, f), R = QS((E) => {
      const M = E.target;
      [...c.branches].some((G) => G.contains(M)) || (a == null || a(E), i == null || i(E), E.defaultPrevented || s == null || s());
    }, f);
    return US((E) => {
      y === c.layers.size - 1 && (r == null || r(E), !E.defaultPrevented && s && (E.preventDefault(), s()));
    }, f), v.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (xd = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), Sd(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = xd);
        };
    }, [u, f, n, c]), v.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), Sd());
    }, [u, c]), v.useEffect(() => {
      const E = () => p({});
      return document.addEventListener(kl, E), () => document.removeEventListener(kl, E);
    }, []), /* @__PURE__ */ m(
      ie.div,
      {
        ...l,
        ref: h,
        style: {
          pointerEvents: x ? C ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: re(e.onFocusCapture, R.onFocusCapture),
        onBlurCapture: re(e.onBlurCapture, R.onBlurCapture),
        onPointerDownCapture: re(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
dr.displayName = qS;
var XS = "DismissableLayerBranch", om = v.forwardRef((e, t) => {
  const n = v.useContext(rm), r = v.useRef(null), o = xe(t, r);
  return v.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ m(ie.div, { ...e, ref: o });
});
om.displayName = XS;
function JS(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ze(e), r = v.useRef(!1), o = v.useRef(() => {
  });
  return v.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          am(
            YS,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function QS(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ze(e), r = v.useRef(!1);
  return v.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && am(KS, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Sd() {
  const e = new CustomEvent(kl);
  document.dispatchEvent(e);
}
function am(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? yc(o, a) : o.dispatchEvent(a);
}
var ZS = dr, eC = om, Cs = 0;
function Pi() {
  v.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Cd()), document.body.insertAdjacentElement("beforeend", e[1] ?? Cd()), Cs++, () => {
      Cs === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Cs--;
    };
  }, []);
}
function Cd() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Es = "focusScope.autoFocusOnMount", ks = "focusScope.autoFocusOnUnmount", Ed = { bubbles: !1, cancelable: !0 }, tC = "FocusScope", Xo = v.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...i
  } = e, [s, l] = v.useState(null), c = Ze(o), u = Ze(a), d = v.useRef(null), f = xe(t, (g) => l(g)), p = v.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  v.useEffect(() => {
    if (r) {
      let g = function(x) {
        if (p.paused || !s) return;
        const C = x.target;
        s.contains(C) ? d.current = C : Sn(d.current, { select: !0 });
      }, w = function(x) {
        if (p.paused || !s) return;
        const C = x.relatedTarget;
        C !== null && (s.contains(C) || Sn(d.current, { select: !0 }));
      }, b = function(x) {
        if (document.activeElement === document.body)
          for (const S of x)
            S.removedNodes.length > 0 && Sn(s);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", w);
      const y = new MutationObserver(b);
      return s && y.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", w), y.disconnect();
      };
    }
  }, [r, s, p.paused]), v.useEffect(() => {
    if (s) {
      Rd.add(p);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const b = new CustomEvent(Es, Ed);
        s.addEventListener(Es, c), s.dispatchEvent(b), b.defaultPrevented || (nC(sC(im(s)), { select: !0 }), document.activeElement === g && Sn(s));
      }
      return () => {
        s.removeEventListener(Es, c), setTimeout(() => {
          const b = new CustomEvent(ks, Ed);
          s.addEventListener(ks, u), s.dispatchEvent(b), b.defaultPrevented || Sn(g ?? document.body, { select: !0 }), s.removeEventListener(ks, u), Rd.remove(p);
        }, 0);
      };
    }
  }, [s, c, u, p]);
  const h = v.useCallback(
    (g) => {
      if (!n && !r || p.paused) return;
      const w = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
      if (w && b) {
        const y = g.currentTarget, [x, C] = rC(y);
        x && C ? !g.shiftKey && b === C ? (g.preventDefault(), n && Sn(x, { select: !0 })) : g.shiftKey && b === x && (g.preventDefault(), n && Sn(C, { select: !0 })) : b === y && g.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ m(ie.div, { tabIndex: -1, ...i, ref: f, onKeyDown: h });
});
Xo.displayName = tC;
function nC(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Sn(r, { select: t }), document.activeElement !== n) return;
}
function rC(e) {
  const t = im(e), n = kd(t, e), r = kd(t.reverse(), e);
  return [n, r];
}
function im(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function kd(e, t) {
  for (const n of e)
    if (!oC(n, { upTo: t })) return n;
}
function oC(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function aC(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Sn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && aC(e) && t && e.select();
  }
}
var Rd = iC();
function iC() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Pd(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Pd(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Pd(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function sC(e) {
  return e.filter((t) => t.tagName !== "A");
}
const lC = ["top", "right", "bottom", "left"], Tn = Math.min, St = Math.max, si = Math.round, Oa = Math.floor, en = (e) => ({
  x: e,
  y: e
}), cC = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, uC = {
  start: "end",
  end: "start"
};
function Rl(e, t, n) {
  return St(e, Tn(t, n));
}
function gn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function hn(e) {
  return e.split("-")[0];
}
function Kr(e) {
  return e.split("-")[1];
}
function Mc(e) {
  return e === "x" ? "y" : "x";
}
function Oc(e) {
  return e === "y" ? "height" : "width";
}
function _n(e) {
  return ["top", "bottom"].includes(hn(e)) ? "y" : "x";
}
function Dc(e) {
  return Mc(_n(e));
}
function dC(e, t, n) {
  n === void 0 && (n = !1);
  const r = Kr(e), o = Dc(e), a = Oc(o);
  let i = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = li(i)), [i, li(i)];
}
function fC(e) {
  const t = li(e);
  return [Pl(e), t, Pl(t)];
}
function Pl(e) {
  return e.replace(/start|end/g, (t) => uC[t]);
}
function pC(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? a : i;
    default:
      return [];
  }
}
function mC(e, t, n, r) {
  const o = Kr(e);
  let a = pC(hn(e), n === "start", r);
  return o && (a = a.map((i) => i + "-" + o), t && (a = a.concat(a.map(Pl)))), a;
}
function li(e) {
  return e.replace(/left|right|bottom|top/g, (t) => cC[t]);
}
function gC(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function sm(e) {
  return typeof e != "number" ? gC(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ci(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Nd(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = _n(t), i = Dc(t), s = Oc(i), l = hn(t), c = a === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[s] / 2 - o[s] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (Kr(t)) {
    case "start":
      p[i] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      p[i] += f * (n && c ? -1 : 1);
      break;
  }
  return p;
}
const hC = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = n, s = a.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = Nd(c, r, l), f = r, p = {}, h = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: w,
      fn: b
    } = s[g], {
      x: y,
      y: x,
      data: C,
      reset: S
    } = await b({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: p,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = y ?? u, d = x ?? d, p = {
      ...p,
      [w]: {
        ...p[w],
        ...C
      }
    }, S && h <= 50 && (h++, typeof S == "object" && (S.placement && (f = S.placement), S.rects && (c = S.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : S.rects), {
      x: u,
      y: d
    } = Nd(c, f, l)), g = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: p
  };
};
async function Oo(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = gn(t, e), h = sm(p), w = s[f ? d === "floating" ? "reference" : "floating" : d], b = ci(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(w))) == null || n ? w : w.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), y = d === "floating" ? {
    x: r,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, x = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), C = await (a.isElement == null ? void 0 : a.isElement(x)) ? await (a.getScale == null ? void 0 : a.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = ci(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: y,
    offsetParent: x,
    strategy: l
  }) : y);
  return {
    top: (b.top - S.top + h.top) / C.y,
    bottom: (S.bottom - b.bottom + h.bottom) / C.y,
    left: (b.left - S.left + h.left) / C.x,
    right: (S.right - b.right + h.right) / C.x
  };
}
const vC = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = gn(e, t) || {};
    if (c == null)
      return {};
    const d = sm(u), f = {
      x: n,
      y: r
    }, p = Dc(o), h = Oc(p), g = await i.getDimensions(c), w = p === "y", b = w ? "top" : "left", y = w ? "bottom" : "right", x = w ? "clientHeight" : "clientWidth", C = a.reference[h] + a.reference[p] - f[p] - a.floating[h], S = f[p] - a.reference[p], R = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let E = R ? R[x] : 0;
    (!E || !await (i.isElement == null ? void 0 : i.isElement(R))) && (E = s.floating[x] || a.floating[h]);
    const M = C / 2 - S / 2, F = E / 2 - g[h] / 2 - 1, G = Tn(d[b], F), U = Tn(d[y], F), H = G, j = E - g[h] - U, z = E / 2 - g[h] / 2 + M, Z = Rl(H, z, j), Y = !l.arrow && Kr(o) != null && z !== Z && a.reference[h] / 2 - (z < H ? G : U) - g[h] / 2 < 0, O = Y ? z < H ? z - H : z - j : 0;
    return {
      [p]: f[p] + O,
      data: {
        [p]: Z,
        centerOffset: z - Z - O,
        ...Y && {
          alignmentOffset: O
        }
      },
      reset: Y
    };
  }
}), wC = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: g = !0,
        ...w
      } = gn(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const b = hn(o), y = _n(s), x = hn(s) === s, C = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), S = f || (x || !g ? [li(s)] : fC(s)), R = h !== "none";
      !f && R && S.push(...mC(s, g, h, C));
      const E = [s, ...S], M = await Oo(t, w), F = [];
      let G = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (u && F.push(M[b]), d) {
        const z = dC(o, i, C);
        F.push(M[z[0]], M[z[1]]);
      }
      if (G = [...G, {
        placement: o,
        overflows: F
      }], !F.every((z) => z <= 0)) {
        var U, H;
        const z = (((U = a.flip) == null ? void 0 : U.index) || 0) + 1, Z = E[z];
        if (Z)
          return {
            data: {
              index: z,
              overflows: G
            },
            reset: {
              placement: Z
            }
          };
        let Y = (H = G.filter((O) => O.overflows[0] <= 0).sort((O, I) => O.overflows[1] - I.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!Y)
          switch (p) {
            case "bestFit": {
              var j;
              const O = (j = G.filter((I) => {
                if (R) {
                  const W = _n(I.placement);
                  return W === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  W === "y";
                }
                return !0;
              }).map((I) => [I.placement, I.overflows.filter((W) => W > 0).reduce((W, A) => W + A, 0)]).sort((I, W) => I[1] - W[1])[0]) == null ? void 0 : j[0];
              O && (Y = O);
              break;
            }
            case "initialPlacement":
              Y = s;
              break;
          }
        if (o !== Y)
          return {
            reset: {
              placement: Y
            }
          };
      }
      return {};
    }
  };
};
function Td(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function _d(e) {
  return lC.some((t) => e[t] >= 0);
}
const bC = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = gn(e, t);
      switch (r) {
        case "referenceHidden": {
          const a = await Oo(t, {
            ...o,
            elementContext: "reference"
          }), i = Td(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: _d(i)
            }
          };
        }
        case "escaped": {
          const a = await Oo(t, {
            ...o,
            altBoundary: !0
          }), i = Td(a, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: _d(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function yC(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), i = hn(n), s = Kr(n), l = _n(n) === "y", c = ["left", "top"].includes(i) ? -1 : 1, u = a && l ? -1 : 1, d = gn(t, e);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: h
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof h == "number" && (p = s === "end" ? h * -1 : h), l ? {
    x: p * u,
    y: f * c
  } : {
    x: f * c,
    y: p * u
  };
}
const xC = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: a,
        placement: i,
        middlewareData: s
      } = t, l = await yC(t, e);
      return i === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, SC = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (w) => {
            let {
              x: b,
              y
            } = w;
            return {
              x: b,
              y
            };
          }
        },
        ...l
      } = gn(e, t), c = {
        x: n,
        y: r
      }, u = await Oo(t, l), d = _n(hn(o)), f = Mc(d);
      let p = c[f], h = c[d];
      if (a) {
        const w = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", y = p + u[w], x = p - u[b];
        p = Rl(y, p, x);
      }
      if (i) {
        const w = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", y = h + u[w], x = h - u[b];
        h = Rl(y, h, x);
      }
      const g = s.fn({
        ...t,
        [f]: p,
        [d]: h
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r,
          enabled: {
            [f]: a,
            [d]: i
          }
        }
      };
    }
  };
}, CC = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: a,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = gn(e, t), u = {
        x: n,
        y: r
      }, d = _n(o), f = Mc(d);
      let p = u[f], h = u[d];
      const g = gn(s, t), w = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const x = f === "y" ? "height" : "width", C = a.reference[f] - a.floating[x] + w.mainAxis, S = a.reference[f] + a.reference[x] - w.mainAxis;
        p < C ? p = C : p > S && (p = S);
      }
      if (c) {
        var b, y;
        const x = f === "y" ? "width" : "height", C = ["top", "left"].includes(hn(o)), S = a.reference[d] - a.floating[x] + (C && ((b = i.offset) == null ? void 0 : b[d]) || 0) + (C ? 0 : w.crossAxis), R = a.reference[d] + a.reference[x] + (C ? 0 : ((y = i.offset) == null ? void 0 : y[d]) || 0) - (C ? w.crossAxis : 0);
        h < S ? h = S : h > R && (h = R);
      }
      return {
        [f]: p,
        [d]: h
      };
    }
  };
}, EC = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: a,
        platform: i,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...c
      } = gn(e, t), u = await Oo(t, c), d = hn(o), f = Kr(o), p = _n(o) === "y", {
        width: h,
        height: g
      } = a.floating;
      let w, b;
      d === "top" || d === "bottom" ? (w = d, b = f === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (b = d, w = f === "end" ? "top" : "bottom");
      const y = g - u.top - u.bottom, x = h - u.left - u.right, C = Tn(g - u[w], y), S = Tn(h - u[b], x), R = !t.middlewareData.shift;
      let E = C, M = S;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (M = x), (r = t.middlewareData.shift) != null && r.enabled.y && (E = y), R && !f) {
        const G = St(u.left, 0), U = St(u.right, 0), H = St(u.top, 0), j = St(u.bottom, 0);
        p ? M = h - 2 * (G !== 0 || U !== 0 ? G + U : St(u.left, u.right)) : E = g - 2 * (H !== 0 || j !== 0 ? H + j : St(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: M,
        availableHeight: E
      });
      const F = await i.getDimensions(s.floating);
      return h !== F.width || g !== F.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ni() {
  return typeof window < "u";
}
function Xr(e) {
  return lm(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ct(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function on(e) {
  var t;
  return (t = (lm(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function lm(e) {
  return Ni() ? e instanceof Node || e instanceof Ct(e).Node : !1;
}
function Lt(e) {
  return Ni() ? e instanceof Element || e instanceof Ct(e).Element : !1;
}
function nn(e) {
  return Ni() ? e instanceof HTMLElement || e instanceof Ct(e).HTMLElement : !1;
}
function Id(e) {
  return !Ni() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ct(e).ShadowRoot;
}
function Jo(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Ft(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function kC(e) {
  return ["table", "td", "th"].includes(Xr(e));
}
function Ti(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Ac(e) {
  const t = $c(), n = Lt(e) ? Ft(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function RC(e) {
  let t = In(e);
  for (; nn(t) && !Dr(t); ) {
    if (Ac(t))
      return t;
    if (Ti(t))
      return null;
    t = In(t);
  }
  return null;
}
function $c() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Dr(e) {
  return ["html", "body", "#document"].includes(Xr(e));
}
function Ft(e) {
  return Ct(e).getComputedStyle(e);
}
function _i(e) {
  return Lt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function In(e) {
  if (Xr(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Id(e) && e.host || // Fallback.
    on(e)
  );
  return Id(t) ? t.host : t;
}
function cm(e) {
  const t = In(e);
  return Dr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : nn(t) && Jo(t) ? t : cm(t);
}
function Do(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = cm(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), i = Ct(o);
  if (a) {
    const s = Nl(i);
    return t.concat(i, i.visualViewport || [], Jo(o) ? o : [], s && n ? Do(s) : []);
  }
  return t.concat(o, Do(o, [], n));
}
function Nl(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function um(e) {
  const t = Ft(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = nn(e), a = o ? e.offsetWidth : n, i = o ? e.offsetHeight : r, s = si(n) !== a || si(r) !== i;
  return s && (n = a, r = i), {
    width: n,
    height: r,
    $: s
  };
}
function Lc(e) {
  return Lt(e) ? e : e.contextElement;
}
function Tr(e) {
  const t = Lc(e);
  if (!nn(t))
    return en(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = um(t);
  let i = (a ? si(n.width) : n.width) / r, s = (a ? si(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const PC = /* @__PURE__ */ en(0);
function dm(e) {
  const t = Ct(e);
  return !$c() || !t.visualViewport ? PC : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function NC(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Ct(e) ? !1 : t;
}
function er(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = Lc(e);
  let i = en(1);
  t && (r ? Lt(r) && (i = Tr(r)) : i = Tr(e));
  const s = NC(a, n, r) ? dm(a) : en(0);
  let l = (o.left + s.x) / i.x, c = (o.top + s.y) / i.y, u = o.width / i.x, d = o.height / i.y;
  if (a) {
    const f = Ct(a), p = r && Lt(r) ? Ct(r) : r;
    let h = f, g = Nl(h);
    for (; g && r && p !== h; ) {
      const w = Tr(g), b = g.getBoundingClientRect(), y = Ft(g), x = b.left + (g.clientLeft + parseFloat(y.paddingLeft)) * w.x, C = b.top + (g.clientTop + parseFloat(y.paddingTop)) * w.y;
      l *= w.x, c *= w.y, u *= w.x, d *= w.y, l += x, c += C, h = Ct(g), g = Nl(h);
    }
  }
  return ci({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function Fc(e, t) {
  const n = _i(e).scrollLeft;
  return t ? t.left + n : er(on(e)).left + n;
}
function fm(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Fc(e, r)
  )), a = r.top + t.scrollTop;
  return {
    x: o,
    y: a
  };
}
function TC(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const a = o === "fixed", i = on(r), s = t ? Ti(t.floating) : !1;
  if (r === i || s && a)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = en(1);
  const u = en(0), d = nn(r);
  if ((d || !d && !a) && ((Xr(r) !== "body" || Jo(i)) && (l = _i(r)), nn(r))) {
    const p = er(r);
    c = Tr(r), u.x = p.x + r.clientLeft, u.y = p.y + r.clientTop;
  }
  const f = i && !d && !a ? fm(i, l, !0) : en(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x + f.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y + f.y
  };
}
function _C(e) {
  return Array.from(e.getClientRects());
}
function IC(e) {
  const t = on(e), n = _i(e), r = e.ownerDocument.body, o = St(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = St(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -n.scrollLeft + Fc(e);
  const s = -n.scrollTop;
  return Ft(r).direction === "rtl" && (i += St(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: s
  };
}
function MC(e, t) {
  const n = Ct(e), r = on(e), o = n.visualViewport;
  let a = r.clientWidth, i = r.clientHeight, s = 0, l = 0;
  if (o) {
    a = o.width, i = o.height;
    const c = $c();
    (!c || c && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
function OC(e, t) {
  const n = er(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, a = nn(e) ? Tr(e) : en(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, l = o * a.x, c = r * a.y;
  return {
    width: i,
    height: s,
    x: l,
    y: c
  };
}
function Md(e, t, n) {
  let r;
  if (t === "viewport")
    r = MC(e, n);
  else if (t === "document")
    r = IC(on(e));
  else if (Lt(t))
    r = OC(t, n);
  else {
    const o = dm(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return ci(r);
}
function pm(e, t) {
  const n = In(e);
  return n === t || !Lt(n) || Dr(n) ? !1 : Ft(n).position === "fixed" || pm(n, t);
}
function DC(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Do(e, [], !1).filter((s) => Lt(s) && Xr(s) !== "body"), o = null;
  const a = Ft(e).position === "fixed";
  let i = a ? In(e) : e;
  for (; Lt(i) && !Dr(i); ) {
    const s = Ft(i), l = Ac(i);
    !l && s.position === "fixed" && (o = null), (a ? !l && !o : !l && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Jo(i) && !l && pm(e, i)) ? r = r.filter((u) => u !== i) : o = s, i = In(i);
  }
  return t.set(e, r), r;
}
function AC(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const i = [...n === "clippingAncestors" ? Ti(t) ? [] : DC(t, this._c) : [].concat(n), r], s = i[0], l = i.reduce((c, u) => {
    const d = Md(t, u, o);
    return c.top = St(d.top, c.top), c.right = Tn(d.right, c.right), c.bottom = Tn(d.bottom, c.bottom), c.left = St(d.left, c.left), c;
  }, Md(t, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function $C(e) {
  const {
    width: t,
    height: n
  } = um(e);
  return {
    width: t,
    height: n
  };
}
function LC(e, t, n) {
  const r = nn(t), o = on(t), a = n === "fixed", i = er(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = en(0);
  if (r || !r && !a)
    if ((Xr(t) !== "body" || Jo(o)) && (s = _i(t)), r) {
      const f = er(t, !0, a, t);
      l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
    } else o && (l.x = Fc(o));
  const c = o && !r && !a ? fm(o, s) : en(0), u = i.left + s.scrollLeft - l.x - c.x, d = i.top + s.scrollTop - l.y - c.y;
  return {
    x: u,
    y: d,
    width: i.width,
    height: i.height
  };
}
function Rs(e) {
  return Ft(e).position === "static";
}
function Od(e, t) {
  if (!nn(e) || Ft(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return on(e) === n && (n = n.ownerDocument.body), n;
}
function mm(e, t) {
  const n = Ct(e);
  if (Ti(e))
    return n;
  if (!nn(e)) {
    let o = In(e);
    for (; o && !Dr(o); ) {
      if (Lt(o) && !Rs(o))
        return o;
      o = In(o);
    }
    return n;
  }
  let r = Od(e, t);
  for (; r && kC(r) && Rs(r); )
    r = Od(r, t);
  return r && Dr(r) && Rs(r) && !Ac(r) ? n : r || RC(e) || n;
}
const FC = async function(e) {
  const t = this.getOffsetParent || mm, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: LC(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function zC(e) {
  return Ft(e).direction === "rtl";
}
const VC = {
  convertOffsetParentRelativeRectToViewportRelativeRect: TC,
  getDocumentElement: on,
  getClippingRect: AC,
  getOffsetParent: mm,
  getElementRects: FC,
  getClientRects: _C,
  getDimensions: $C,
  getScale: Tr,
  isElement: Lt,
  isRTL: zC
};
function gm(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function BC(e, t) {
  let n = null, r;
  const o = on(e);
  function a() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const c = e.getBoundingClientRect(), {
      left: u,
      top: d,
      width: f,
      height: p
    } = c;
    if (s || t(), !f || !p)
      return;
    const h = Oa(d), g = Oa(o.clientWidth - (u + f)), w = Oa(o.clientHeight - (d + p)), b = Oa(u), x = {
      rootMargin: -h + "px " + -g + "px " + -w + "px " + -b + "px",
      threshold: St(0, Tn(1, l)) || 1
    };
    let C = !0;
    function S(R) {
      const E = R[0].intersectionRatio;
      if (E !== l) {
        if (!C)
          return i();
        E ? i(!1, E) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !gm(c, e.getBoundingClientRect()) && i(), C = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, x);
    }
    n.observe(e);
  }
  return i(!0), a;
}
function HC(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = Lc(e), u = o || a ? [...c ? Do(c) : [], ...Do(t)] : [];
  u.forEach((b) => {
    o && b.addEventListener("scroll", n, {
      passive: !0
    }), a && b.addEventListener("resize", n);
  });
  const d = c && s ? BC(c, n) : null;
  let f = -1, p = null;
  i && (p = new ResizeObserver((b) => {
    let [y] = b;
    y && y.target === c && p && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var x;
      (x = p) == null || x.observe(t);
    })), n();
  }), c && !l && p.observe(c), p.observe(t));
  let h, g = l ? er(e) : null;
  l && w();
  function w() {
    const b = er(e);
    g && !gm(g, b) && n(), g = b, h = requestAnimationFrame(w);
  }
  return n(), () => {
    var b;
    u.forEach((y) => {
      o && y.removeEventListener("scroll", n), a && y.removeEventListener("resize", n);
    }), d == null || d(), (b = p) == null || b.disconnect(), p = null, l && cancelAnimationFrame(h);
  };
}
const WC = xC, jC = SC, GC = wC, UC = EC, qC = bC, Dd = vC, YC = CC, KC = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: VC,
    ...n
  }, a = {
    ...o.platform,
    _c: r
  };
  return hC(e, t, {
    ...o,
    platform: a
  });
};
var Ja = typeof document < "u" ? bc : ke;
function ui(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!ui(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = o[r];
      if (!(a === "_owner" && e.$$typeof) && !ui(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function hm(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ad(e, t) {
  const n = hm(e);
  return Math.round(t * n) / n;
}
function Ps(e) {
  const t = v.useRef(e);
  return Ja(() => {
    t.current = e;
  }), t;
}
function XC(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = v.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, p] = v.useState(r);
  ui(f, r) || p(r);
  const [h, g] = v.useState(null), [w, b] = v.useState(null), y = v.useCallback((I) => {
    I !== R.current && (R.current = I, g(I));
  }, []), x = v.useCallback((I) => {
    I !== E.current && (E.current = I, b(I));
  }, []), C = a || h, S = i || w, R = v.useRef(null), E = v.useRef(null), M = v.useRef(u), F = l != null, G = Ps(l), U = Ps(o), H = Ps(c), j = v.useCallback(() => {
    if (!R.current || !E.current)
      return;
    const I = {
      placement: t,
      strategy: n,
      middleware: f
    };
    U.current && (I.platform = U.current), KC(R.current, E.current, I).then((W) => {
      const A = {
        ...W,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: H.current !== !1
      };
      z.current && !ui(M.current, A) && (M.current = A, Rn.flushSync(() => {
        d(A);
      }));
    });
  }, [f, t, n, U, H]);
  Ja(() => {
    c === !1 && M.current.isPositioned && (M.current.isPositioned = !1, d((I) => ({
      ...I,
      isPositioned: !1
    })));
  }, [c]);
  const z = v.useRef(!1);
  Ja(() => (z.current = !0, () => {
    z.current = !1;
  }), []), Ja(() => {
    if (C && (R.current = C), S && (E.current = S), C && S) {
      if (G.current)
        return G.current(C, S, j);
      j();
    }
  }, [C, S, j, G, F]);
  const Z = v.useMemo(() => ({
    reference: R,
    floating: E,
    setReference: y,
    setFloating: x
  }), [y, x]), Y = v.useMemo(() => ({
    reference: C,
    floating: S
  }), [C, S]), O = v.useMemo(() => {
    const I = {
      position: n,
      left: 0,
      top: 0
    };
    if (!Y.floating)
      return I;
    const W = Ad(Y.floating, u.x), A = Ad(Y.floating, u.y);
    return s ? {
      ...I,
      transform: "translate(" + W + "px, " + A + "px)",
      ...hm(Y.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: W,
      top: A
    };
  }, [n, s, Y.floating, u.x, u.y]);
  return v.useMemo(() => ({
    ...u,
    update: j,
    refs: Z,
    elements: Y,
    floatingStyles: O
  }), [u, j, Z, Y, O]);
}
const JC = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Dd({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Dd({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, QC = (e, t) => ({
  ...WC(e),
  options: [e, t]
}), ZC = (e, t) => ({
  ...jC(e),
  options: [e, t]
}), eE = (e, t) => ({
  ...YC(e),
  options: [e, t]
}), tE = (e, t) => ({
  ...GC(e),
  options: [e, t]
}), nE = (e, t) => ({
  ...UC(e),
  options: [e, t]
}), rE = (e, t) => ({
  ...qC(e),
  options: [e, t]
}), oE = (e, t) => ({
  ...JC(e),
  options: [e, t]
});
var aE = "Arrow", vm = v.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ m(
    ie.svg,
    {
      ...a,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ m("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
vm.displayName = aE;
var iE = vm;
function Ii(e) {
  const [t, n] = v.useState(void 0);
  return et(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          i = c.inlineSize, s = c.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({ width: i, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var zc = "Popper", [wm, Fn] = Ye(zc), [sE, bm] = wm(zc), ym = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = v.useState(null);
  return /* @__PURE__ */ m(sE, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
ym.displayName = zc;
var xm = "PopperAnchor", Sm = v.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, a = bm(xm, n), i = v.useRef(null), s = xe(t, i);
    return v.useEffect(() => {
      a.onAnchorChange((r == null ? void 0 : r.current) || i.current);
    }), r ? null : /* @__PURE__ */ m(ie.div, { ...o, ref: s });
  }
);
Sm.displayName = xm;
var Vc = "PopperContent", [lE, cE] = wm(Vc), Cm = v.forwardRef(
  (e, t) => {
    var T, L, J, Q, ne, D;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: h,
      ...g
    } = e, w = bm(Vc, n), [b, y] = v.useState(null), x = xe(t, (le) => y(le)), [C, S] = v.useState(null), R = Ii(C), E = (R == null ? void 0 : R.width) ?? 0, M = (R == null ? void 0 : R.height) ?? 0, F = r + (a !== "center" ? "-" + a : ""), G = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, U = Array.isArray(c) ? c : [c], H = U.length > 0, j = {
      padding: G,
      boundary: U.filter(dE),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: H
    }, { refs: z, floatingStyles: Z, placement: Y, isPositioned: O, middlewareData: I } = XC({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: F,
      whileElementsMounted: (...le) => HC(...le, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: w.anchor
      },
      middleware: [
        QC({ mainAxis: o + M, alignmentAxis: i }),
        l && ZC({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? eE() : void 0,
          ...j
        }),
        l && tE({ ...j }),
        nE({
          ...j,
          apply: ({ elements: le, rects: te, availableWidth: Se, availableHeight: Le }) => {
            const { width: ze, height: lt } = te.reference, _e = le.floating.style;
            _e.setProperty("--radix-popper-available-width", `${Se}px`), _e.setProperty("--radix-popper-available-height", `${Le}px`), _e.setProperty("--radix-popper-anchor-width", `${ze}px`), _e.setProperty("--radix-popper-anchor-height", `${lt}px`);
          }
        }),
        C && oE({ element: C, padding: s }),
        fE({ arrowWidth: E, arrowHeight: M }),
        f && rE({ strategy: "referenceHidden", ...j })
      ]
    }), [W, A] = Rm(Y), K = Ze(h);
    et(() => {
      O && (K == null || K());
    }, [O, K]);
    const k = (T = I.arrow) == null ? void 0 : T.x, $ = (L = I.arrow) == null ? void 0 : L.y, P = ((J = I.arrow) == null ? void 0 : J.centerOffset) !== 0, [_, V] = v.useState();
    return et(() => {
      b && V(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ m(
      "div",
      {
        ref: z.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...Z,
          transform: O ? Z.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: _,
          "--radix-popper-transform-origin": [
            (Q = I.transformOrigin) == null ? void 0 : Q.x,
            (ne = I.transformOrigin) == null ? void 0 : ne.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((D = I.hide) == null ? void 0 : D.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ m(
          lE,
          {
            scope: n,
            placedSide: W,
            onArrowChange: S,
            arrowX: k,
            arrowY: $,
            shouldHideArrow: P,
            children: /* @__PURE__ */ m(
              ie.div,
              {
                "data-side": W,
                "data-align": A,
                ...g,
                ref: x,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: O ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Cm.displayName = Vc;
var Em = "PopperArrow", uE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, km = v.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, a = cE(Em, r), i = uE[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ m(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ m(
          iE,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
km.displayName = Em;
function dE(e) {
  return e !== null;
}
var fE = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var w, b, y;
    const { placement: n, rects: r, middlewareData: o } = t, i = ((w = o.arrow) == null ? void 0 : w.centerOffset) !== 0, s = i ? 0 : e.arrowWidth, l = i ? 0 : e.arrowHeight, [c, u] = Rm(n), d = { start: "0%", center: "50%", end: "100%" }[u], f = (((b = o.arrow) == null ? void 0 : b.x) ?? 0) + s / 2, p = (((y = o.arrow) == null ? void 0 : y.y) ?? 0) + l / 2;
    let h = "", g = "";
    return c === "bottom" ? (h = i ? d : `${f}px`, g = `${-l}px`) : c === "top" ? (h = i ? d : `${f}px`, g = `${r.floating.height + l}px`) : c === "right" ? (h = `${-l}px`, g = i ? d : `${p}px`) : c === "left" && (h = `${r.floating.width + l}px`, g = i ? d : `${p}px`), { data: { x: h, y: g } };
  }
});
function Rm(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Qo = ym, Zo = Sm, Mi = Cm, Oi = km, pE = "Portal", Jr = v.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [o, a] = v.useState(!1);
  et(() => a(!0), []);
  const i = n || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? To.createPortal(/* @__PURE__ */ m(ie.div, { ...r, ref: t }), i) : null;
});
Jr.displayName = pE;
var mE = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, vr = /* @__PURE__ */ new WeakMap(), Da = /* @__PURE__ */ new WeakMap(), Aa = {}, Ns = 0, Pm = function(e) {
  return e && (e.host || Pm(e.parentNode));
}, gE = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Pm(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, hE = function(e, t, n, r) {
  var o = gE(t, Array.isArray(e) ? e : [e]);
  Aa[n] || (Aa[n] = /* @__PURE__ */ new WeakMap());
  var a = Aa[n], i = [], s = /* @__PURE__ */ new Set(), l = new Set(o), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  o.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (s.has(f))
        u(f);
      else
        try {
          var p = f.getAttribute(r), h = p !== null && p !== "false", g = (vr.get(f) || 0) + 1, w = (a.get(f) || 0) + 1;
          vr.set(f, g), a.set(f, w), i.push(f), g === 1 && h && Da.set(f, !0), w === 1 && f.setAttribute(n, "true"), h || f.setAttribute(r, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", f, b);
        }
    });
  };
  return u(t), s.clear(), Ns++, function() {
    i.forEach(function(d) {
      var f = vr.get(d) - 1, p = a.get(d) - 1;
      vr.set(d, f), a.set(d, p), f || (Da.has(d) || d.removeAttribute(r), Da.delete(d)), p || d.removeAttribute(n);
    }), Ns--, Ns || (vr = /* @__PURE__ */ new WeakMap(), vr = /* @__PURE__ */ new WeakMap(), Da = /* @__PURE__ */ new WeakMap(), Aa = {});
  };
}, Di = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = mE(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), hE(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Xt = function() {
  return Xt = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Xt.apply(this, arguments);
};
function Nm(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function vE(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, a; r < o; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Qa = "right-scroll-bar-position", Za = "width-before-scroll-bar", wE = "with-scroll-bars-hidden", bE = "--removed-body-scroll-bar-size";
function Ts(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function yE(e, t) {
  var n = ye(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var xE = typeof window < "u" ? v.useLayoutEffect : v.useEffect, $d = /* @__PURE__ */ new WeakMap();
function SE(e, t) {
  var n = yE(null, function(r) {
    return e.forEach(function(o) {
      return Ts(o, r);
    });
  });
  return xE(function() {
    var r = $d.get(n);
    if (r) {
      var o = new Set(r), a = new Set(e), i = n.current;
      o.forEach(function(s) {
        a.has(s) || Ts(s, null);
      }), a.forEach(function(s) {
        o.has(s) || Ts(s, i);
      });
    }
    $d.set(n, e);
  }, [e]), n;
}
function CE(e) {
  return e;
}
function EE(e, t) {
  t === void 0 && (t = CE);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, r);
      return n.push(i), function() {
        n = n.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var i = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), i = n;
      }
      var l = function() {
        var u = i;
        i = [], u.forEach(a);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          i.push(u), c();
        },
        filter: function(u) {
          return i = i.filter(u), n;
        }
      };
    }
  };
  return o;
}
function kE(e) {
  e === void 0 && (e = {});
  var t = EE(null);
  return t.options = Xt({ async: !0, ssr: !1 }, e), t;
}
var Tm = function(e) {
  var t = e.sideCar, n = Nm(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return v.createElement(r, Xt({}, n));
};
Tm.isSideCarExport = !0;
function RE(e, t) {
  return e.useMedium(t), Tm;
}
var _m = kE(), _s = function() {
}, Ai = v.forwardRef(function(e, t) {
  var n = v.useRef(null), r = v.useState({
    onScrollCapture: _s,
    onWheelCapture: _s,
    onTouchMoveCapture: _s
  }), o = r[0], a = r[1], i = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, p = e.noIsolation, h = e.inert, g = e.allowPinchZoom, w = e.as, b = w === void 0 ? "div" : w, y = e.gapMode, x = Nm(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), C = f, S = SE([n, t]), R = Xt(Xt({}, x), o);
  return v.createElement(
    v.Fragment,
    null,
    u && v.createElement(C, { sideCar: _m, removeScrollBar: c, shards: d, noIsolation: p, inert: h, setCallbacks: a, allowPinchZoom: !!g, lockRef: n, gapMode: y }),
    i ? v.cloneElement(v.Children.only(s), Xt(Xt({}, R), { ref: S })) : v.createElement(b, Xt({}, R, { className: l, ref: S }), s)
  );
});
Ai.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ai.classNames = {
  fullWidth: Za,
  zeroRight: Qa
};
var PE = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function NE() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = PE();
  return t && e.setAttribute("nonce", t), e;
}
function TE(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function _E(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var IE = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = NE()) && (TE(t, n), _E(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, ME = function() {
  var e = IE();
  return function(t, n) {
    v.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Im = function() {
  var e = ME(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, OE = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Is = function(e) {
  return parseInt(e || "", 10) || 0;
}, DE = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Is(n), Is(r), Is(o)];
}, AE = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return OE;
  var t = DE(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, $E = Im(), _r = "data-scroll-locked", LE = function(e, t, n, r) {
  var o = e.left, a = e.top, i = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(wE, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(_r, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Qa, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Za, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Qa, " .").concat(Qa, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Za, " .").concat(Za, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(_r, `] {
    `).concat(bE, ": ").concat(s, `px;
  }
`);
}, Ld = function() {
  var e = parseInt(document.body.getAttribute(_r) || "0", 10);
  return isFinite(e) ? e : 0;
}, FE = function() {
  v.useEffect(function() {
    return document.body.setAttribute(_r, (Ld() + 1).toString()), function() {
      var e = Ld() - 1;
      e <= 0 ? document.body.removeAttribute(_r) : document.body.setAttribute(_r, e.toString());
    };
  }, []);
}, zE = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  FE();
  var a = v.useMemo(function() {
    return AE(o);
  }, [o]);
  return v.createElement($E, { styles: LE(a, !t, o, n ? "" : "!important") });
}, Tl = !1;
if (typeof window < "u")
  try {
    var $a = Object.defineProperty({}, "passive", {
      get: function() {
        return Tl = !0, !0;
      }
    });
    window.addEventListener("test", $a, $a), window.removeEventListener("test", $a, $a);
  } catch {
    Tl = !1;
  }
var wr = Tl ? { passive: !1 } : !1, VE = function(e) {
  return e.tagName === "TEXTAREA";
}, Mm = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !VE(e) && n[t] === "visible")
  );
}, BE = function(e) {
  return Mm(e, "overflowY");
}, HE = function(e) {
  return Mm(e, "overflowX");
}, Fd = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Om(e, r);
    if (o) {
      var a = Dm(e, r), i = a[1], s = a[2];
      if (i > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, WE = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, jE = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Om = function(e, t) {
  return e === "v" ? BE(t) : HE(t);
}, Dm = function(e, t) {
  return e === "v" ? WE(t) : jE(t);
}, GE = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, UE = function(e, t, n, r, o) {
  var a = GE(e, window.getComputedStyle(t).direction), i = a * r, s = n.target, l = t.contains(s), c = !1, u = i > 0, d = 0, f = 0;
  do {
    var p = Dm(e, s), h = p[0], g = p[1], w = p[2], b = g - w - a * h;
    (h || b) && Om(e, s) && (d += b, f += h), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(f) < 1) && (c = !0), c;
}, La = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, zd = function(e) {
  return [e.deltaX, e.deltaY];
}, Vd = function(e) {
  return e && "current" in e ? e.current : e;
}, qE = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, YE = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, KE = 0, br = [];
function XE(e) {
  var t = v.useRef([]), n = v.useRef([0, 0]), r = v.useRef(), o = v.useState(KE++)[0], a = v.useState(Im)[0], i = v.useRef(e);
  v.useEffect(function() {
    i.current = e;
  }, [e]), v.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = vE([e.lockRef.current], (e.shards || []).map(Vd), !0).filter(Boolean);
      return g.forEach(function(w) {
        return w.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(w) {
          return w.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = v.useCallback(function(g, w) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !i.current.allowPinchZoom;
    var b = La(g), y = n.current, x = "deltaX" in g ? g.deltaX : y[0] - b[0], C = "deltaY" in g ? g.deltaY : y[1] - b[1], S, R = g.target, E = Math.abs(x) > Math.abs(C) ? "h" : "v";
    if ("touches" in g && E === "h" && R.type === "range")
      return !1;
    var M = Fd(E, R);
    if (!M)
      return !0;
    if (M ? S = E : (S = E === "v" ? "h" : "v", M = Fd(E, R)), !M)
      return !1;
    if (!r.current && "changedTouches" in g && (x || C) && (r.current = S), !S)
      return !0;
    var F = r.current || S;
    return UE(F, w, g, F === "h" ? x : C);
  }, []), l = v.useCallback(function(g) {
    var w = g;
    if (!(!br.length || br[br.length - 1] !== a)) {
      var b = "deltaY" in w ? zd(w) : La(w), y = t.current.filter(function(S) {
        return S.name === w.type && (S.target === w.target || w.target === S.shadowParent) && qE(S.delta, b);
      })[0];
      if (y && y.should) {
        w.cancelable && w.preventDefault();
        return;
      }
      if (!y) {
        var x = (i.current.shards || []).map(Vd).filter(Boolean).filter(function(S) {
          return S.contains(w.target);
        }), C = x.length > 0 ? s(w, x[0]) : !i.current.noIsolation;
        C && w.cancelable && w.preventDefault();
      }
    }
  }, []), c = v.useCallback(function(g, w, b, y) {
    var x = { name: g, delta: w, target: b, should: y, shadowParent: JE(b) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== x;
      });
    }, 1);
  }, []), u = v.useCallback(function(g) {
    n.current = La(g), r.current = void 0;
  }, []), d = v.useCallback(function(g) {
    c(g.type, zd(g), g.target, s(g, e.lockRef.current));
  }, []), f = v.useCallback(function(g) {
    c(g.type, La(g), g.target, s(g, e.lockRef.current));
  }, []);
  v.useEffect(function() {
    return br.push(a), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, wr), document.addEventListener("touchmove", l, wr), document.addEventListener("touchstart", u, wr), function() {
      br = br.filter(function(g) {
        return g !== a;
      }), document.removeEventListener("wheel", l, wr), document.removeEventListener("touchmove", l, wr), document.removeEventListener("touchstart", u, wr);
    };
  }, []);
  var p = e.removeScrollBar, h = e.inert;
  return v.createElement(
    v.Fragment,
    null,
    h ? v.createElement(a, { styles: YE(o) }) : null,
    p ? v.createElement(zE, { gapMode: e.gapMode }) : null
  );
}
function JE(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const QE = RE(_m, XE);
var ea = v.forwardRef(function(e, t) {
  return v.createElement(Ai, Xt({}, e, { ref: t, sideCar: QE }));
});
ea.classNames = Ai.classNames;
var Bc = "Popover", [Am, v3] = Ye(Bc, [
  Fn
]), ta = Fn(), [ZE, zn] = Am(Bc), $m = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: i = !1
  } = e, s = ta(t), l = v.useRef(null), [c, u] = v.useState(!1), [d = !1, f] = je({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ m(Qo, { ...s, children: /* @__PURE__ */ m(
    ZE,
    {
      scope: t,
      contentId: Te(),
      triggerRef: l,
      open: d,
      onOpenChange: f,
      onOpenToggle: v.useCallback(() => f((p) => !p), [f]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: v.useCallback(() => u(!0), []),
      onCustomAnchorRemove: v.useCallback(() => u(!1), []),
      modal: i,
      children: n
    }
  ) });
};
$m.displayName = Bc;
var Lm = "PopoverAnchor", Fm = v.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = zn(Lm, n), a = ta(n), { onCustomAnchorAdd: i, onCustomAnchorRemove: s } = o;
    return v.useEffect(() => (i(), () => s()), [i, s]), /* @__PURE__ */ m(Zo, { ...a, ...r, ref: t });
  }
);
Fm.displayName = Lm;
var zm = "PopoverTrigger", Vm = v.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = zn(zm, n), a = ta(n), i = xe(t, o.triggerRef), s = /* @__PURE__ */ m(
      ie.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": qm(o.open),
        ...r,
        ref: i,
        onClick: re(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? s : /* @__PURE__ */ m(Zo, { asChild: !0, ...a, children: s });
  }
);
Vm.displayName = zm;
var Hc = "PopoverPortal", [e1, t1] = Am(Hc, {
  forceMount: void 0
}), Bm = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, a = zn(Hc, t);
  return /* @__PURE__ */ m(e1, { scope: t, forceMount: n, children: /* @__PURE__ */ m(at, { present: n || a.open, children: /* @__PURE__ */ m(Jr, { asChild: !0, container: o, children: r }) }) });
};
Bm.displayName = Hc;
var Ar = "PopoverContent", Hm = v.forwardRef(
  (e, t) => {
    const n = t1(Ar, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, a = zn(Ar, e.__scopePopover);
    return /* @__PURE__ */ m(at, { present: r || a.open, children: a.modal ? /* @__PURE__ */ m(n1, { ...o, ref: t }) : /* @__PURE__ */ m(r1, { ...o, ref: t }) });
  }
);
Hm.displayName = Ar;
var n1 = v.forwardRef(
  (e, t) => {
    const n = zn(Ar, e.__scopePopover), r = v.useRef(null), o = xe(t, r), a = v.useRef(!1);
    return v.useEffect(() => {
      const i = r.current;
      if (i) return Di(i);
    }, []), /* @__PURE__ */ m(ea, { as: Nn, allowPinchZoom: !0, children: /* @__PURE__ */ m(
      Wm,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: re(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), a.current || (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: re(
          e.onPointerDownOutside,
          (i) => {
            const s = i.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0, c = s.button === 2 || l;
            a.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: re(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), r1 = v.forwardRef(
  (e, t) => {
    const n = zn(Ar, e.__scopePopover), r = v.useRef(!1), o = v.useRef(!1);
    return /* @__PURE__ */ m(
      Wm,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var l, c;
          (l = e.onInteractOutside) == null || l.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const i = a.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), Wm = v.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: s,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onInteractOutside: u,
      ...d
    } = e, f = zn(Ar, n), p = ta(n);
    return Pi(), /* @__PURE__ */ m(
      Xo,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ m(
          dr,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: u,
            onEscapeKeyDown: s,
            onPointerDownOutside: l,
            onFocusOutside: c,
            onDismiss: () => f.onOpenChange(!1),
            children: /* @__PURE__ */ m(
              Mi,
              {
                "data-state": qm(f.open),
                role: "dialog",
                id: f.contentId,
                ...p,
                ...d,
                ref: t,
                style: {
                  ...d.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), jm = "PopoverClose", Gm = v.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = zn(jm, n);
    return /* @__PURE__ */ m(
      ie.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: re(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Gm.displayName = jm;
var o1 = "PopoverArrow", Um = v.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = ta(n);
    return /* @__PURE__ */ m(Oi, { ...o, ...r, ref: t });
  }
);
Um.displayName = o1;
function qm(e) {
  return e ? "open" : "closed";
}
var a1 = $m, i1 = Fm, s1 = Vm, l1 = Bm, Ym = Hm;
const c1 = "tw-bg-brand-neutral-white tw-z-[100] tw-w-72 tw-rounded-md tw-border tw-p-4 tw-shadow-md tw-relative tw-flex data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=open]:slide-in-from-top-2 data-[state=closed]:slide-out-to-top-2 tw-duration-200", Km = a1, Xm = s1, w3 = i1, b3 = Gm, y3 = Um, Wc = q(
  ({ className: e, side: t, align: n, sticky: r, avoidCollisions: o, sideOffset: a = 4, ...i }, s) => /* @__PURE__ */ m(
    l1,
    { children: /* @__PURE__ */ m(
      Ym,
      {
        ref: s,
        align: n,
        side: t,
        avoidCollisions: o,
        sideOffset: a,
        sticky: r,
        className: N(c1, e),
        ...i
      }
    ) }
  )
);
Wc.displayName = Ym.displayName;
function u1(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Bd(e) {
  return u1(e) || Array.isArray(e);
}
function d1() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function jc(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  const o = JSON.stringify(Object.keys(e.breakpoints || {})), a = JSON.stringify(Object.keys(t.breakpoints || {}));
  return o !== a ? !1 : n.every((i) => {
    const s = e[i], l = t[i];
    return typeof s == "function" ? `${s}` == `${l}` : !Bd(s) || !Bd(l) ? s === l : jc(s, l);
  });
}
function Hd(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function f1(e, t) {
  if (e.length !== t.length) return !1;
  const n = Hd(e), r = Hd(t);
  return n.every((o, a) => {
    const i = r[a];
    return jc(o, i);
  });
}
function Gc(e) {
  return typeof e == "number";
}
function _l(e) {
  return typeof e == "string";
}
function $i(e) {
  return typeof e == "boolean";
}
function Wd(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function We(e) {
  return Math.abs(e);
}
function Uc(e) {
  return Math.sign(e);
}
function _o(e, t) {
  return We(e - t);
}
function p1(e, t) {
  if (e === 0 || t === 0 || We(e) <= We(t)) return 0;
  const n = _o(We(e), We(t));
  return We(n / e);
}
function m1(e) {
  return Math.round(e * 100) / 100;
}
function Ao(e) {
  return $o(e).map(Number);
}
function Dt(e) {
  return e[na(e)];
}
function na(e) {
  return Math.max(0, e.length - 1);
}
function qc(e, t) {
  return t === na(e);
}
function jd(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function $o(e) {
  return Object.keys(e);
}
function Jm(e, t) {
  return [e, t].reduce((n, r) => ($o(r).forEach((o) => {
    const a = n[o], i = r[o], s = Wd(a) && Wd(i);
    n[o] = s ? Jm(a, i) : i;
  }), n), {});
}
function Il(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function g1(e, t) {
  const n = {
    start: r,
    center: o,
    end: a
  };
  function r() {
    return 0;
  }
  function o(l) {
    return a(l) / 2;
  }
  function a(l) {
    return t - l;
  }
  function i(l, c) {
    return _l(e) ? n[e](l) : e(t, l, c);
  }
  return {
    measure: i
  };
}
function Lo() {
  let e = [];
  function t(o, a, i, s = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in o)
      o.addEventListener(a, i, s), l = () => o.removeEventListener(a, i, s);
    else {
      const c = o;
      c.addListener(i), l = () => c.removeListener(i);
    }
    return e.push(l), r;
  }
  function n() {
    e = e.filter((o) => o());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function h1(e, t, n, r) {
  const o = Lo(), a = 1e3 / 60;
  let i = null, s = 0, l = 0;
  function c() {
    o.add(e, "visibilitychange", () => {
      e.hidden && h();
    });
  }
  function u() {
    p(), o.clear();
  }
  function d(w) {
    if (!l) return;
    i || (i = w, n(), n());
    const b = w - i;
    for (i = w, s += b; s >= a; )
      n(), s -= a;
    const y = s / a;
    r(y), l && (l = t.requestAnimationFrame(d));
  }
  function f() {
    l || (l = t.requestAnimationFrame(d));
  }
  function p() {
    t.cancelAnimationFrame(l), i = null, s = 0, l = 0;
  }
  function h() {
    i = null, s = 0;
  }
  return {
    init: c,
    destroy: u,
    start: f,
    stop: p,
    update: n,
    render: r
  };
}
function v1(e, t) {
  const n = t === "rtl", r = e === "y", o = r ? "y" : "x", a = r ? "x" : "y", i = !r && n ? -1 : 1, s = u(), l = d();
  function c(h) {
    const {
      height: g,
      width: w
    } = h;
    return r ? g : w;
  }
  function u() {
    return r ? "top" : n ? "right" : "left";
  }
  function d() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function f(h) {
    return h * i;
  }
  return {
    scroll: o,
    cross: a,
    startEdge: s,
    endEdge: l,
    measureSize: c,
    direction: f
  };
}
function tr(e = 0, t = 0) {
  const n = We(e - t);
  function r(c) {
    return c < e;
  }
  function o(c) {
    return c > t;
  }
  function a(c) {
    return r(c) || o(c);
  }
  function i(c) {
    return a(c) ? r(c) ? e : t : c;
  }
  function s(c) {
    return n ? c - n * Math.ceil((c - t) / n) : c;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: i,
    reachedAny: a,
    reachedMax: o,
    reachedMin: r,
    removeOffset: s
  };
}
function Qm(e, t, n) {
  const {
    constrain: r
  } = tr(0, e), o = e + 1;
  let a = i(t);
  function i(f) {
    return n ? We((o + f) % o) : r(f);
  }
  function s() {
    return a;
  }
  function l(f) {
    return a = i(f), d;
  }
  function c(f) {
    return u().set(s() + f);
  }
  function u() {
    return Qm(e, s(), n);
  }
  const d = {
    get: s,
    set: l,
    add: c,
    clone: u
  };
  return d;
}
function w1(e, t, n, r, o, a, i, s, l, c, u, d, f, p, h, g, w, b, y) {
  const {
    cross: x,
    direction: C
  } = e, S = ["INPUT", "SELECT", "TEXTAREA"], R = {
    passive: !1
  }, E = Lo(), M = Lo(), F = tr(50, 225).constrain(p.measure(20)), G = {
    mouse: 300,
    touch: 400
  }, U = {
    mouse: 500,
    touch: 600
  }, H = h ? 43 : 25;
  let j = !1, z = 0, Z = 0, Y = !1, O = !1, I = !1, W = !1;
  function A(D) {
    if (!y) return;
    function le(Se) {
      ($i(y) || y(D, Se)) && V(Se);
    }
    const te = t;
    E.add(te, "dragstart", (Se) => Se.preventDefault(), R).add(te, "touchmove", () => {
    }, R).add(te, "touchend", () => {
    }).add(te, "touchstart", le).add(te, "mousedown", le).add(te, "touchcancel", L).add(te, "contextmenu", L).add(te, "click", J, !0);
  }
  function K() {
    E.clear(), M.clear();
  }
  function k() {
    const D = W ? n : t;
    M.add(D, "touchmove", T, R).add(D, "touchend", L).add(D, "mousemove", T, R).add(D, "mouseup", L);
  }
  function $(D) {
    const le = D.nodeName || "";
    return S.includes(le);
  }
  function P() {
    return (h ? U : G)[W ? "mouse" : "touch"];
  }
  function _(D, le) {
    const te = d.add(Uc(D) * -1), Se = u.byDistance(D, !h).distance;
    return h || We(D) < F ? Se : w && le ? Se * 0.5 : u.byIndex(te.get(), 0).distance;
  }
  function V(D) {
    const le = Il(D, r);
    W = le, I = h && le && !D.buttons && j, j = _o(o.get(), i.get()) >= 2, !(le && D.button !== 0) && ($(D.target) || (Y = !0, a.pointerDown(D), c.useFriction(0).useDuration(0), o.set(i), k(), z = a.readPoint(D), Z = a.readPoint(D, x), f.emit("pointerDown")));
  }
  function T(D) {
    if (!Il(D, r) && D.touches.length >= 2) return L(D);
    const te = a.readPoint(D), Se = a.readPoint(D, x), Le = _o(te, z), ze = _o(Se, Z);
    if (!O && !W && (!D.cancelable || (O = Le > ze, !O)))
      return L(D);
    const lt = a.pointerMove(D);
    Le > g && (I = !0), c.useFriction(0.3).useDuration(0.75), s.start(), o.add(C(lt)), D.preventDefault();
  }
  function L(D) {
    const te = u.byDistance(0, !1).index !== d.get(), Se = a.pointerUp(D) * P(), Le = _(C(Se), te), ze = p1(Se, Le), lt = H - 10 * ze, _e = b + ze / 50;
    O = !1, Y = !1, M.clear(), c.useDuration(lt).useFriction(_e), l.distance(Le, !h), W = !1, f.emit("pointerUp");
  }
  function J(D) {
    I && (D.stopPropagation(), D.preventDefault(), I = !1);
  }
  function Q() {
    return Y;
  }
  return {
    init: A,
    destroy: K,
    pointerDown: Q
  };
}
function b1(e, t) {
  let r, o;
  function a(d) {
    return d.timeStamp;
  }
  function i(d, f) {
    const h = `client${(f || e.scroll) === "x" ? "X" : "Y"}`;
    return (Il(d, t) ? d : d.touches[0])[h];
  }
  function s(d) {
    return r = d, o = d, i(d);
  }
  function l(d) {
    const f = i(d) - i(o), p = a(d) - a(r) > 170;
    return o = d, p && (r = d), f;
  }
  function c(d) {
    if (!r || !o) return 0;
    const f = i(o) - i(r), p = a(d) - a(r), h = a(d) - a(o) > 170, g = f / p;
    return p && !h && We(g) > 0.1 ? g : 0;
  }
  return {
    pointerDown: s,
    pointerMove: l,
    pointerUp: c,
    readPoint: i
  };
}
function y1() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: o,
      offsetWidth: a,
      offsetHeight: i
    } = n;
    return {
      top: r,
      right: o + a,
      bottom: r + i,
      left: o,
      width: a,
      height: i
    };
  }
  return {
    measure: e
  };
}
function x1(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function S1(e, t, n, r, o, a, i) {
  const s = [e].concat(r);
  let l, c, u = [], d = !1;
  function f(w) {
    return o.measureSize(i.measure(w));
  }
  function p(w) {
    if (!a) return;
    c = f(e), u = r.map(f);
    function b(y) {
      for (const x of y) {
        if (d) return;
        const C = x.target === e, S = r.indexOf(x.target), R = C ? c : u[S], E = f(C ? e : r[S]);
        if (We(E - R) >= 0.5) {
          w.reInit(), t.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((y) => {
      ($i(a) || a(w, y)) && b(y);
    }), n.requestAnimationFrame(() => {
      s.forEach((y) => l.observe(y));
    });
  }
  function h() {
    d = !0, l && l.disconnect();
  }
  return {
    init: p,
    destroy: h
  };
}
function C1(e, t, n, r, o, a) {
  let i = 0, s = 0, l = o, c = a, u = e.get(), d = 0;
  function f() {
    const R = r.get() - e.get(), E = !l;
    let M = 0;
    return E ? (i = 0, n.set(r), e.set(r), M = R) : (n.set(e), i += R / l, i *= c, u += i, e.add(i), M = u - d), s = Uc(M), d = u, S;
  }
  function p() {
    const R = r.get() - t.get();
    return We(R) < 1e-3;
  }
  function h() {
    return l;
  }
  function g() {
    return s;
  }
  function w() {
    return i;
  }
  function b() {
    return x(o);
  }
  function y() {
    return C(a);
  }
  function x(R) {
    return l = R, S;
  }
  function C(R) {
    return c = R, S;
  }
  const S = {
    direction: g,
    duration: h,
    velocity: w,
    seek: f,
    settled: p,
    useBaseFriction: y,
    useBaseDuration: b,
    useFriction: C,
    useDuration: x
  };
  return S;
}
function E1(e, t, n, r, o) {
  const a = o.measure(10), i = o.measure(50), s = tr(0.1, 0.99);
  let l = !1;
  function c() {
    return !(l || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function u(p) {
    if (!c()) return;
    const h = e.reachedMin(t.get()) ? "min" : "max", g = We(e[h] - t.get()), w = n.get() - t.get(), b = s.constrain(g / i);
    n.subtract(w * b), !p && We(w) < a && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function d(p) {
    l = !p;
  }
  return {
    shouldConstrain: c,
    constrain: u,
    toggleActive: d
  };
}
function k1(e, t, n, r, o) {
  const a = tr(-t + e, 0), i = d(), s = u(), l = f();
  function c(h, g) {
    return _o(h, g) <= 1;
  }
  function u() {
    const h = i[0], g = Dt(i), w = i.lastIndexOf(h), b = i.indexOf(g) + 1;
    return tr(w, b);
  }
  function d() {
    return n.map((h, g) => {
      const {
        min: w,
        max: b
      } = a, y = a.constrain(h), x = !g, C = qc(n, g);
      return x ? b : C || c(w, y) ? w : c(b, y) ? b : y;
    }).map((h) => parseFloat(h.toFixed(3)));
  }
  function f() {
    if (t <= e + o) return [a.max];
    if (r === "keepSnaps") return i;
    const {
      min: h,
      max: g
    } = s;
    return i.slice(h, g);
  }
  return {
    snapsContained: l,
    scrollContainLimit: s
  };
}
function R1(e, t, n) {
  const r = t[0], o = n ? r - e : Dt(t);
  return {
    limit: tr(o, r)
  };
}
function P1(e, t, n, r) {
  const a = t.min + 0.1, i = t.max + 0.1, {
    reachedMin: s,
    reachedMax: l
  } = tr(a, i);
  function c(f) {
    return f === 1 ? l(n.get()) : f === -1 ? s(n.get()) : !1;
  }
  function u(f) {
    if (!c(f)) return;
    const p = e * (f * -1);
    r.forEach((h) => h.add(p));
  }
  return {
    loop: u
  };
}
function N1(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(a) {
    const i = a - t;
    return n ? i / -n : 0;
  }
  return {
    get: r
  };
}
function T1(e, t, n, r, o) {
  const {
    startEdge: a,
    endEdge: i
  } = e, {
    groupSlides: s
  } = o, l = d().map(t.measure), c = f(), u = p();
  function d() {
    return s(r).map((g) => Dt(g)[i] - g[0][a]).map(We);
  }
  function f() {
    return r.map((g) => n[a] - g[a]).map((g) => -We(g));
  }
  function p() {
    return s(c).map((g) => g[0]).map((g, w) => g + l[w]);
  }
  return {
    snaps: c,
    snapsAligned: u
  };
}
function _1(e, t, n, r, o, a) {
  const {
    groupSlides: i
  } = o, {
    min: s,
    max: l
  } = r, c = u();
  function u() {
    const f = i(a), p = !e || t === "keepSnaps";
    return n.length === 1 ? [a] : p ? f : f.slice(s, l).map((h, g, w) => {
      const b = !g, y = qc(w, g);
      if (b) {
        const x = Dt(w[0]) + 1;
        return jd(x);
      }
      if (y) {
        const x = na(a) - Dt(w)[0] + 1;
        return jd(x, Dt(w)[0]);
      }
      return h;
    });
  }
  return {
    slideRegistry: c
  };
}
function I1(e, t, n, r, o) {
  const {
    reachedAny: a,
    removeOffset: i,
    constrain: s
  } = r;
  function l(h) {
    return h.concat().sort((g, w) => We(g) - We(w))[0];
  }
  function c(h) {
    const g = e ? i(h) : s(h), w = t.map((y, x) => ({
      diff: u(y - g, 0),
      index: x
    })).sort((y, x) => We(y.diff) - We(x.diff)), {
      index: b
    } = w[0];
    return {
      index: b,
      distance: g
    };
  }
  function u(h, g) {
    const w = [h, h + n, h - n];
    if (!e) return h;
    if (!g) return l(w);
    const b = w.filter((y) => Uc(y) === g);
    return b.length ? l(b) : Dt(w) - n;
  }
  function d(h, g) {
    const w = t[h] - o.get(), b = u(w, g);
    return {
      index: h,
      distance: b
    };
  }
  function f(h, g) {
    const w = o.get() + h, {
      index: b,
      distance: y
    } = c(w), x = !e && a(w);
    if (!g || x) return {
      index: b,
      distance: h
    };
    const C = t[b] - y, S = h + u(C, 0);
    return {
      index: b,
      distance: S
    };
  }
  return {
    byDistance: f,
    byIndex: d,
    shortcut: u
  };
}
function M1(e, t, n, r, o, a, i) {
  function s(d) {
    const f = d.distance, p = d.index !== t.get();
    a.add(f), f && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), p && (n.set(t.get()), t.set(d.index), i.emit("select"));
  }
  function l(d, f) {
    const p = o.byDistance(d, f);
    s(p);
  }
  function c(d, f) {
    const p = t.clone().set(d), h = o.byIndex(p.get(), f);
    s(h);
  }
  return {
    distance: l,
    index: c
  };
}
function O1(e, t, n, r, o, a, i, s) {
  const l = {
    passive: !0,
    capture: !0
  };
  let c = 0;
  function u(p) {
    if (!s) return;
    function h(g) {
      if ((/* @__PURE__ */ new Date()).getTime() - c > 10) return;
      i.emit("slideFocusStart"), e.scrollLeft = 0;
      const y = n.findIndex((x) => x.includes(g));
      Gc(y) && (o.useDuration(0), r.index(y, 0), i.emit("slideFocus"));
    }
    a.add(document, "keydown", d, !1), t.forEach((g, w) => {
      a.add(g, "focus", (b) => {
        ($i(s) || s(p, b)) && h(w);
      }, l);
    });
  }
  function d(p) {
    p.code === "Tab" && (c = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: u
  };
}
function Eo(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(l) {
    t = i(l);
  }
  function o(l) {
    t += i(l);
  }
  function a(l) {
    t -= i(l);
  }
  function i(l) {
    return Gc(l) ? l : l.get();
  }
  return {
    get: n,
    set: r,
    add: o,
    subtract: a
  };
}
function Zm(e, t) {
  const n = e.scroll === "x" ? i : s, r = t.style;
  let o = null, a = !1;
  function i(f) {
    return `translate3d(${f}px,0px,0px)`;
  }
  function s(f) {
    return `translate3d(0px,${f}px,0px)`;
  }
  function l(f) {
    if (a) return;
    const p = m1(e.direction(f));
    p !== o && (r.transform = n(p), o = p);
  }
  function c(f) {
    a = !f;
  }
  function u() {
    a || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: u,
    to: l,
    toggleActive: c
  };
}
function D1(e, t, n, r, o, a, i, s, l) {
  const u = Ao(o), d = Ao(o).reverse(), f = b().concat(y());
  function p(E, M) {
    return E.reduce((F, G) => F - o[G], M);
  }
  function h(E, M) {
    return E.reduce((F, G) => p(F, M) > 0 ? F.concat([G]) : F, []);
  }
  function g(E) {
    return a.map((M, F) => ({
      start: M - r[F] + 0.5 + E,
      end: M + t - 0.5 + E
    }));
  }
  function w(E, M, F) {
    const G = g(M);
    return E.map((U) => {
      const H = F ? 0 : -n, j = F ? n : 0, z = F ? "end" : "start", Z = G[U][z];
      return {
        index: U,
        loopPoint: Z,
        slideLocation: Eo(-1),
        translate: Zm(e, l[U]),
        target: () => s.get() > Z ? H : j
      };
    });
  }
  function b() {
    const E = i[0], M = h(d, E);
    return w(M, n, !1);
  }
  function y() {
    const E = t - i[0] - 1, M = h(u, E);
    return w(M, -n, !0);
  }
  function x() {
    return f.every(({
      index: E
    }) => {
      const M = u.filter((F) => F !== E);
      return p(M, t) <= 0.1;
    });
  }
  function C() {
    f.forEach((E) => {
      const {
        target: M,
        translate: F,
        slideLocation: G
      } = E, U = M();
      U !== G.get() && (F.to(U), G.set(U));
    });
  }
  function S() {
    f.forEach((E) => E.translate.clear());
  }
  return {
    canLoop: x,
    clear: S,
    loop: C,
    loopPoints: f
  };
}
function A1(e, t, n) {
  let r, o = !1;
  function a(l) {
    if (!n) return;
    function c(u) {
      for (const d of u)
        if (d.type === "childList") {
          l.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((u) => {
      o || ($i(n) || n(l, u)) && c(u);
    }), r.observe(e, {
      childList: !0
    });
  }
  function i() {
    r && r.disconnect(), o = !0;
  }
  return {
    init: a,
    destroy: i
  };
}
function $1(e, t, n, r) {
  const o = {};
  let a = null, i = null, s, l = !1;
  function c() {
    s = new IntersectionObserver((h) => {
      l || (h.forEach((g) => {
        const w = t.indexOf(g.target);
        o[w] = g;
      }), a = null, i = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((h) => s.observe(h));
  }
  function u() {
    s && s.disconnect(), l = !0;
  }
  function d(h) {
    return $o(o).reduce((g, w) => {
      const b = parseInt(w), {
        isIntersecting: y
      } = o[b];
      return (h && y || !h && !y) && g.push(b), g;
    }, []);
  }
  function f(h = !0) {
    if (h && a) return a;
    if (!h && i) return i;
    const g = d(h);
    return h && (a = g), h || (i = g), g;
  }
  return {
    init: c,
    destroy: u,
    get: f
  };
}
function L1(e, t, n, r, o, a) {
  const {
    measureSize: i,
    startEdge: s,
    endEdge: l
  } = e, c = n[0] && o, u = h(), d = g(), f = n.map(i), p = w();
  function h() {
    if (!c) return 0;
    const y = n[0];
    return We(t[s] - y[s]);
  }
  function g() {
    if (!c) return 0;
    const y = a.getComputedStyle(Dt(r));
    return parseFloat(y.getPropertyValue(`margin-${l}`));
  }
  function w() {
    return n.map((y, x, C) => {
      const S = !x, R = qc(C, x);
      return S ? f[x] + u : R ? f[x] + d : C[x + 1][s] - y[s];
    }).map(We);
  }
  return {
    slideSizes: f,
    slideSizesWithGaps: p,
    startGap: u,
    endGap: d
  };
}
function F1(e, t, n, r, o, a, i, s, l) {
  const {
    startEdge: c,
    endEdge: u,
    direction: d
  } = e, f = Gc(n);
  function p(b, y) {
    return Ao(b).filter((x) => x % y === 0).map((x) => b.slice(x, x + y));
  }
  function h(b) {
    return b.length ? Ao(b).reduce((y, x, C) => {
      const S = Dt(y) || 0, R = S === 0, E = x === na(b), M = o[c] - a[S][c], F = o[c] - a[x][u], G = !r && R ? d(i) : 0, U = !r && E ? d(s) : 0, H = We(F - U - (M + G));
      return C && H > t + l && y.push(x), E && y.push(b.length), y;
    }, []).map((y, x, C) => {
      const S = Math.max(C[x - 1] || 0);
      return b.slice(S, y);
    }) : [];
  }
  function g(b) {
    return f ? p(b, n) : h(b);
  }
  return {
    groupSlides: g
  };
}
function z1(e, t, n, r, o, a, i) {
  const {
    align: s,
    axis: l,
    direction: c,
    startIndex: u,
    loop: d,
    duration: f,
    dragFree: p,
    dragThreshold: h,
    inViewThreshold: g,
    slidesToScroll: w,
    skipSnaps: b,
    containScroll: y,
    watchResize: x,
    watchSlides: C,
    watchDrag: S,
    watchFocus: R
  } = a, E = 2, M = y1(), F = M.measure(t), G = n.map(M.measure), U = v1(l, c), H = U.measureSize(F), j = x1(H), z = g1(s, H), Z = !d && !!y, Y = d || !!y, {
    slideSizes: O,
    slideSizesWithGaps: I,
    startGap: W,
    endGap: A
  } = L1(U, F, G, n, Y, o), K = F1(U, H, w, d, F, G, W, A, E), {
    snaps: k,
    snapsAligned: $
  } = T1(U, z, F, G, K), P = -Dt(k) + Dt(I), {
    snapsContained: _,
    scrollContainLimit: V
  } = k1(H, P, $, y, E), T = Z ? _ : $, {
    limit: L
  } = R1(P, T, d), J = Qm(na(T), u, d), Q = J.clone(), ne = Ao(n), D = ({
    dragHandler: sn,
    scrollBody: io,
    scrollBounds: ln,
    options: {
      loop: jn
    }
  }) => {
    jn || ln.constrain(sn.pointerDown()), io.seek();
  }, le = ({
    scrollBody: sn,
    translate: io,
    location: ln,
    offsetLocation: jn,
    previousLocation: vs,
    scrollLooper: ws,
    slideLooper: bs,
    dragHandler: ys,
    animation: xs,
    eventHandler: me,
    scrollBounds: Pe,
    options: {
      loop: De
    }
  }, Ee) => {
    const Ve = sn.settled(), tt = !Pe.shouldConstrain(), Ke = De ? Ve : Ve && tt;
    Ke && !ys.pointerDown() && (xs.stop(), me.emit("settle")), Ke || me.emit("scroll");
    const Ut = ln.get() * Ee + vs.get() * (1 - Ee);
    jn.set(Ut), De && (ws.loop(sn.direction()), bs.loop()), io.to(jn.get());
  }, te = h1(r, o, () => D(ao), (sn) => le(ao, sn)), Se = 0.68, Le = T[J.get()], ze = Eo(Le), lt = Eo(Le), _e = Eo(Le), Je = Eo(Le), Gt = C1(ze, _e, lt, Je, f, Se), Tt = I1(d, T, P, L, Je), kt = M1(te, J, Q, Gt, Tt, Je, i), gr = N1(L), oo = Lo(), hs = $1(t, n, i, g), {
    slideRegistry: _a
  } = _1(Z, y, T, V, K, ne), hr = O1(e, n, _a, kt, Gt, oo, i, R), ao = {
    ownerDocument: r,
    ownerWindow: o,
    eventHandler: i,
    containerRect: F,
    slideRects: G,
    animation: te,
    axis: U,
    dragHandler: w1(U, e, r, o, Je, b1(U, o), ze, te, kt, Gt, Tt, J, i, j, p, h, b, Se, S),
    eventStore: oo,
    percentOfView: j,
    index: J,
    indexPrevious: Q,
    limit: L,
    location: ze,
    offsetLocation: _e,
    previousLocation: lt,
    options: a,
    resizeHandler: S1(t, i, o, n, U, x, M),
    scrollBody: Gt,
    scrollBounds: E1(L, _e, Je, Gt, j),
    scrollLooper: P1(P, L, _e, [ze, _e, lt, Je]),
    scrollProgress: gr,
    scrollSnapList: T.map(gr.get),
    scrollSnaps: T,
    scrollTarget: Tt,
    scrollTo: kt,
    slideLooper: D1(U, H, P, O, I, k, T, _e, n),
    slideFocus: hr,
    slidesHandler: A1(t, i, C),
    slidesInView: hs,
    slideIndexes: ne,
    slideRegistry: _a,
    slidesToScroll: K,
    target: Je,
    translate: Zm(U, t)
  };
  return ao;
}
function V1() {
  let e = {}, t;
  function n(c) {
    t = c;
  }
  function r(c) {
    return e[c] || [];
  }
  function o(c) {
    return r(c).forEach((u) => u(t, c)), l;
  }
  function a(c, u) {
    return e[c] = r(c).concat([u]), l;
  }
  function i(c, u) {
    return e[c] = r(c).filter((d) => d !== u), l;
  }
  function s() {
    e = {};
  }
  const l = {
    init: n,
    emit: o,
    off: i,
    on: a,
    clear: s
  };
  return l;
}
const B1 = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function H1(e) {
  function t(a, i) {
    return Jm(a, i || {});
  }
  function n(a) {
    const i = a.breakpoints || {}, s = $o(i).filter((l) => e.matchMedia(l).matches).map((l) => i[l]).reduce((l, c) => t(l, c), {});
    return t(a, s);
  }
  function r(a) {
    return a.map((i) => $o(i.breakpoints || {})).reduce((i, s) => i.concat(s), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function W1(e) {
  let t = [];
  function n(a, i) {
    return t = i.filter(({
      options: s
    }) => e.optionsAtMedia(s).active !== !1), t.forEach((s) => s.init(a, e)), i.reduce((s, l) => Object.assign(s, {
      [l.name]: l
    }), {});
  }
  function r() {
    t = t.filter((a) => a.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function di(e, t, n) {
  const r = e.ownerDocument, o = r.defaultView, a = H1(o), i = W1(a), s = Lo(), l = V1(), {
    mergeOptions: c,
    optionsAtMedia: u,
    optionsMediaQueries: d
  } = a, {
    on: f,
    off: p,
    emit: h
  } = l, g = U;
  let w = !1, b, y = c(B1, di.globalOptions), x = c(y), C = [], S, R, E;
  function M() {
    const {
      container: ne,
      slides: D
    } = x;
    R = (_l(ne) ? e.querySelector(ne) : ne) || e.children[0];
    const te = _l(D) ? R.querySelectorAll(D) : D;
    E = [].slice.call(te || R.children);
  }
  function F(ne) {
    const D = z1(e, R, E, r, o, ne, l);
    if (ne.loop && !D.slideLooper.canLoop()) {
      const le = Object.assign({}, ne, {
        loop: !1
      });
      return F(le);
    }
    return D;
  }
  function G(ne, D) {
    w || (y = c(y, ne), x = u(y), C = D || C, M(), b = F(x), d([y, ...C.map(({
      options: le
    }) => le)]).forEach((le) => s.add(le, "change", U)), x.active && (b.translate.to(b.location.get()), b.animation.init(), b.slidesInView.init(), b.slideFocus.init(Q), b.eventHandler.init(Q), b.resizeHandler.init(Q), b.slidesHandler.init(Q), b.options.loop && b.slideLooper.loop(), R.offsetParent && E.length && b.dragHandler.init(Q), S = i.init(Q, C)));
  }
  function U(ne, D) {
    const le = K();
    H(), G(c({
      startIndex: le
    }, ne), D), l.emit("reInit");
  }
  function H() {
    b.dragHandler.destroy(), b.eventStore.clear(), b.translate.clear(), b.slideLooper.clear(), b.resizeHandler.destroy(), b.slidesHandler.destroy(), b.slidesInView.destroy(), b.animation.destroy(), i.destroy(), s.clear();
  }
  function j() {
    w || (w = !0, s.clear(), H(), l.emit("destroy"), l.clear());
  }
  function z(ne, D, le) {
    !x.active || w || (b.scrollBody.useBaseFriction().useDuration(D === !0 ? 0 : x.duration), b.scrollTo.index(ne, le || 0));
  }
  function Z(ne) {
    const D = b.index.add(1).get();
    z(D, ne, -1);
  }
  function Y(ne) {
    const D = b.index.add(-1).get();
    z(D, ne, 1);
  }
  function O() {
    return b.index.add(1).get() !== K();
  }
  function I() {
    return b.index.add(-1).get() !== K();
  }
  function W() {
    return b.scrollSnapList;
  }
  function A() {
    return b.scrollProgress.get(b.location.get());
  }
  function K() {
    return b.index.get();
  }
  function k() {
    return b.indexPrevious.get();
  }
  function $() {
    return b.slidesInView.get();
  }
  function P() {
    return b.slidesInView.get(!1);
  }
  function _() {
    return S;
  }
  function V() {
    return b;
  }
  function T() {
    return e;
  }
  function L() {
    return R;
  }
  function J() {
    return E;
  }
  const Q = {
    canScrollNext: O,
    canScrollPrev: I,
    containerNode: L,
    internalEngine: V,
    destroy: j,
    off: p,
    on: f,
    emit: h,
    plugins: _,
    previousScrollSnap: k,
    reInit: g,
    rootNode: T,
    scrollNext: Z,
    scrollPrev: Y,
    scrollProgress: A,
    scrollSnapList: W,
    scrollTo: z,
    selectedScrollSnap: K,
    slideNodes: J,
    slidesInView: $,
    slidesNotInView: P
  };
  return G(t, n), setTimeout(() => l.emit("init"), 0), Q;
}
di.globalOptions = void 0;
function Fo(e = {}, t = []) {
  const n = qe(e), r = qe(t), [o, a] = ye(), [i, s] = ye(), l = ot(() => {
    o && o.reInit(n.current, r.current);
  }, [o]);
  return ke(() => {
    jc(n.current, e) || (n.current = e, l());
  }, [e, l]), ke(() => {
    f1(r.current, t) || (r.current = t, l());
  }, [t, l]), ke(() => {
    if (d1() && i) {
      di.globalOptions = Fo.globalOptions;
      const c = di(i, n.current, r.current);
      return a(c), () => c.destroy();
    } else
      a(void 0);
  }, [i, a]), [s, o];
}
Fo.globalOptions = void 0;
const j1 = oe("custom-button-focus-ring tw-grid tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-density-action-default tw-font-medium disabled:tw-cursor-not-allowed disabled:tw-border-none disabled:tw-bg-semantic-action-background-neutral-weaker disabled:tw-text-semantic-action-foreground-neutral-weak", {
  variants: {
    variant: {
      solid: "",
      outline: "tw-border-y-density-action-thin tw-border-x-density-action-thin ",
      ghost: ""
    },
    intent: {
      primary: "",
      neutral: "tw-text-semantic-action-foreground-neutral-darkest tw-bg-semantic-action-background-neutral-weakest active:tw-bg-semantic-action-background-neutral-light hover:tw-bg-semantic-action-background-neutral-weaker ",
      destructive: "tw-text-semantic-action-foreground-neutral-white tw-bg-semantic-action-background-destructive-default hover:tw-bg-semantic-action-background-destructive-dark active:tw-bg-semantic-action-background-destructive-darker "
    },
    size: {
      sm: "tw-size-density-action-height-sm ",
      md: "tw-size-density-action-height-md ",
      lg: "tw-size-density-action-height-lg ",
      xl: "tw-size-density-action-height-xl "
    },
    inverse: {
      true: "tw-bg-transparent !tw-text-white hover:!tw-bg-white/10",
      false: ""
    }
  },
  defaultVariants: {
    variant: "solid",
    size: "sm"
  },
  compoundVariants: [{
    intent: "neutral",
    variant: "solid",
    inverse: !0,
    class: "!tw-bg-transparent !tw-text-white"
  }, {
    intent: "neutral",
    variant: "outline",
    inverse: !1,
    class: "tw-text-semantic-action-foreground-neutral-strongest tw-bg-semantic-action-background-neutral-white tw-border-y-density-action-default tw-border-x-density-action-default tw-border-semantic-action-border-neutral-weak hover:tw-bg-semantic-action-background-neutral-light active:tw-bg-semantic-action-background-neutral-weak "
    //border color on active
  }, {
    intent: "neutral",
    variant: "ghost",
    class: "tw-bg-transparent tw-text-semantic-action-foreground-neutral-darkest "
  }, {
    intent: "primary",
    variant: "solid",
    class: "hover:tw-bg-semantic-action-background-primary-darker active:tw-bg-semantic-action-background-primary-darkest tw-text-semantic-action-foreground-neutral-white tw-bg-semantic-action-background-primary-default "
  }, {
    intent: "primary",
    variant: "ghost",
    class: "hover:tw-bg-semantic-action-background-primary-lightest active:tw-bg-semantic-action-background-primary-lighter tw-text-semantic-action-foreground-primary-default tw-bg-transparent "
  }, {
    intent: "primary",
    variant: "outline",
    class: "tw-text-semantic-action-foreground-primary-default tw-bg-semantic-action-background-neutral-white tw-border-semantic-action-border-primary-weak tw-border-y-density-action-default tw-border-x-density-action-default hover:tw-bg-semantic-action-background-primary-weakest active:tw-bg-semantic-action-background-primary-weaker active:tw-border-semantic-action-border-primary-weaker "
    // border-color on hover
  }]
}), mt = q(
  ({
    className: e,
    variant: t = "solid",
    size: n = "sm",
    intent: r = "primary",
    iconName: o = "",
    inverse: a = !1,
    ariaLabel: i,
    ...s
  }, l) => {
    const c = n === "md" ? "sm" : n;
    return /* @__PURE__ */ m(
      "button",
      {
        className: N(
          j1({ variant: t, inverse: a, size: n, intent: r }),
          e
        ),
        ref: l,
        ...s,
        "aria-label": i,
        children: /* @__PURE__ */ m(de, { icon: o, size: c })
      }
    );
  }
);
mt.displayName = "IconButton";
const G1 = oe("tw-absolute tw-left-0 tw-top-1/2 tw-z-10 tw-grid tw-h-[102%] tw--translate-y-1/2 tw-rounded-none tw-border-0 tw-border-transparent tw-bg-gradient-to-r tw-from-semantic-action-background-neutral-white tw-from-70% tw-mr-[24px] hover:tw-bg-transparent active:tw-bg-transparent", {
  variants: {
    state: {
      disabled: "tw-hidden",
      default: ""
    }
  }
}), U1 = oe("tw-absolute tw-right-0 tw-top-1/2 tw-z-10 tw-grid tw-h-[102%] tw--translate-y-1/2 tw-rounded-none tw-border-0 tw-border-transparent tw-bg-gradient-to-l tw-from-semantic-action-background-neutral-white tw-from-70% tw-ml-[24px] hover:tw-bg-transparent active:tw-bg-transparent", {
  variants: {
    state: {
      disabled: "tw-hidden",
      default: ""
    }
  }
}), eg = bt(
  null
);
function Yc() {
  const e = Xe(eg);
  if (!e)
    throw new Error("useSlidingArea must be used within a <SlidingArea />");
  return e;
}
const tg = q(
  ({ className: e, children: t, indexToSlideTo: n, snapToPrevious: r, ...o }, a) => {
    const [i, s] = Fo({
      axis: "x"
    }), [l, c] = ye(!1), [u, d] = ye(!1), f = ot((b) => {
      b && (c(b.canScrollPrev()), d(b.canScrollNext()));
    }, []), p = ot(() => {
      s == null || s.scrollPrev();
    }, [s]), h = ot(() => {
      s == null || s.scrollNext();
    }, [s]), g = ot(
      (b) => {
        b.key === "ArrowLeft" ? (b.preventDefault(), p()) : b.key === "ArrowRight" && (b.preventDefault(), h());
      },
      [p, h]
    ), w = Yo.map(t, (b) => ur(b) ? /* @__PURE__ */ m(rg, { children: tn(b) }) : b);
    return ke(() => {
      s && typeof n == "number" && s.scrollTo(r ? n - 1 : n);
    }, [s, n]), ke(() => {
      if (s)
        return f(s), s.on("reInit", f), s.on("select", f), () => {
          s == null || s.off("select", f);
        };
    }, [s, f]), /* @__PURE__ */ m(
      eg.Provider,
      {
        value: {
          SlidingAreaRef: i,
          api: s,
          scrollPrev: p,
          scrollNext: h,
          canScrollPrev: l,
          canScrollNext: u
        },
        children: /* @__PURE__ */ ee(
          "div",
          {
            ref: a,
            onKeyDownCapture: g,
            className: N("tw-px-2 tw-relative tw-max-w-full", e),
            role: "region",
            "aria-roledescription": "SlidingArea",
            ...o,
            children: [
              /* @__PURE__ */ m(og, {}),
              /* @__PURE__ */ m(ng, { children: w }),
              /* @__PURE__ */ m(ag, {})
            ]
          }
        )
      }
    );
  }
);
tg.displayName = "SlidingArea";
const ng = q(
  ({ className: e, ...t }, n) => {
    const { SlidingAreaRef: r } = Yc();
    return /* @__PURE__ */ m(
      "div",
      { ref: r, className: "tw-overflow-hidden tw-p-[4px]", children: /* @__PURE__ */ m("div", { ref: n, className: N("tw--ml-2 tw-flex", e), ...t }) }
    );
  }
);
ng.displayName = "SlidingAreaContent";
const rg = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    "div",
    {
      ref: n,
      role: "group",
      "aria-roledescription": "slide",
      className: N(
        "tw-min-w-0 tw-shrink-0 tw-grow-0 tw-content-center tw-pl-2",
        e
      ),
      ...t
    }
  )
);
rg.displayName = "SlidingAreaItem";
const og = q(
  ({ className: e, ...t }, n) => {
    const { scrollPrev: r, canScrollPrev: o } = Yc();
    return /* @__PURE__ */ m(
      mt,
      {
        ref: n,
        variant: "ghost",
        size: "md",
        className: N(
          G1({ state: o ? "default" : "disabled" }),
          e
        ),
        disabled: !o,
        ariaLabel: "Previous",
        onClick: r,
        intent: "neutral",
        iconName: "circle-chevron-left",
        ...t
      }
    );
  }
);
og.displayName = "SlidingAreaPrevious";
const ag = q(
  ({ className: e, ...t }, n) => {
    const { scrollNext: r, canScrollNext: o } = Yc();
    return /* @__PURE__ */ m(
      mt,
      {
        ref: n,
        variant: "ghost",
        size: "md",
        className: N(
          U1({
            state: o ? "default" : "disabled"
          }),
          e
        ),
        disabled: !o,
        ariaLabel: "Next",
        onClick: r,
        intent: "neutral",
        iconName: "circle-chevron-right",
        ...t
      }
    );
  }
);
ag.displayName = "SlidingAreaNext";
const q1 = oe("tw-inline-flex tw-rounded-md tw-bg-white tw-p-1 tw-shadow-lg tw-transition-all tw-duration-200 tw-ease-in-out hover:tw-shadow-xl", {
  variants: {
    position: {
      undefined: "",
      top: "tw-top-0",
      bottom: "tw-bottom-0"
    },
    displayMode: {
      buttons: "",
      dropdown: "",
      sliding: "tw-w-full tw-shadow-none hover:tw-shadow-none"
    }
  },
  defaultVariants: {
    position: "top",
    displayMode: "buttons"
  }
}), Y1 = oe("tw-flex tw-items-center tw-justify-center", {
  variants: {
    displayMode: {
      buttons: "",
      dropdown: "",
      sliding: "tw-w-full"
    }
  },
  defaultVariants: {
    displayMode: "buttons"
  }
}), Gd = oe("tw-whitespace-nowrap tw-transition-all tw-duration-200"), K1 = oe("tw-min-w-[160px]"), X1 = oe("tw-w-full tw-justify-start");
function ig(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
const x3 = q(
  ({
    className: e,
    links: t = [],
    displayMode: n = "buttons",
    position: r,
    offset: o = 24,
    pageOffset: a = 0,
    hideablePageOffset: i = 0,
    activeLink: s,
    zIndex: l = 10,
    onLinkClick: c,
    onScrollLinkChange: u,
    mobileBreakpoint: d = 768,
    slidingModeSnapToPrevious: f = !1,
    ...p
  }, h) => {
    var Y;
    const [g] = ye(s), [w, b] = ye(), [y, x] = ye(!1), [C, S] = ye(n), R = qe(null), [E, M] = ye(!1);
    ke(() => {
      const O = () => {
        typeof window < "u" && d && window.innerWidth < d ? S("sliding") : S(n);
      };
      if (typeof window < "u")
        return O(), window.addEventListener("resize", O), () => window.removeEventListener("resize", O);
    }, [n, d]);
    const F = ot(() => {
      if (!t.length || E) return;
      const O = window.scrollY + a + 30;
      let I = "";
      for (let W = t.length - 1; W >= 0; W--) {
        const A = t[W].href;
        if (!A.startsWith("#")) continue;
        const K = document.getElementById(A.substring(1));
        if (K) {
          const { top: k, bottom: $ } = K.getBoundingClientRect();
          if (k + window.scrollY <= O && $ > 100) {
            I = A;
            break;
          }
        }
      }
      I && I !== w && (b(I), u == null || u(I));
    }, [t, a, w, u, E]);
    ke(() => (window.addEventListener("scroll", F), () => window.removeEventListener("scroll", F)), [F]);
    const G = ot((O) => {
      if (O.startsWith("#")) {
        const I = O.substring(1), W = document.getElementById(I);
        if (W) {
          const A = W.offsetTop - a + i;
          M(!0), J1(A, () => M(!1)), b(O), c && c(O);
        }
      } else
        window.location.href = O;
      x(!1);
    }, [a, i, c]);
    ke(() => {
      g && requestAnimationFrame(() => G(g));
    }, [G, g]);
    const U = w && ((Y = t.find((O) => O.href === w)) == null ? void 0 : Y.label) || "Navigate", H = () => /* @__PURE__ */ m(
      "div",
      { className: "tw-flex tw-gap-1", children: t.map((O, I) => {
        const W = w === O.href;
        return /* @__PURE__ */ m(
          pt,
          {
            size: "md",
            variant: "ghost",
            "data-testid": O.label,
            className: N(
              Gd(),
              W ? "!tw-bg-[#202020] !tw-text-white hover:!tw-bg-[#202020] hover:!tw-text-white" : ""
            ),
            onClick: () => G(O.href),
            iconLeft: O.icon,
            children: O.label
          },
          I
        );
      }) }
    ), j = () => /* @__PURE__ */ ee(
      Km,
      { open: y, onOpenChange: x, children: [
        /* @__PURE__ */ m(
          Xm,
          { asChild: !0, children: /* @__PURE__ */ m(
            pt,
            {
              variant: "solid",
              intent: "neutral",
              iconRight: "chevron-down",
              size: "md",
              className: N(
                K1(),
                "!tw-bg-[#202020] !tw-text-white hover:!tw-bg-[#202020] hover:!tw-text-white"
              ),
              children: U
            }
          ) }
        ),
        /* @__PURE__ */ m(
          Wc,
          { className: "tw-p-1", children: /* @__PURE__ */ m(
            "div",
            { className: "tw-flex tw-flex-col tw-gap-1", children: t.map(
              (O, I) => /* @__PURE__ */ m(
                pt,
                {
                  variant: "ghost",
                  intent: w === O.href ? "primary" : "neutral",
                  className: X1(),
                  onClick: () => G(O.href),
                  iconLeft: O.icon,
                  "data-testid": O.label,
                  children: O.label
                },
                I
              )
            ) }
          ) }
        )
      ] }
    ), z = () => /* @__PURE__ */ m(
      tg,
      {
        indexToSlideTo: t.findIndex((O) => O.href === w),
        className: "tw--mx-4",
        snapToPrevious: f,
        children: t.map((O, I) => {
          const W = w === O.href;
          return /* @__PURE__ */ m(
            pt,
            {
              variant: "ghost",
              size: "md",
              "data-testid": O.label,
              className: N(
                Gd(),
                W ? "!tw-bg-[#202020] !tw-text-white hover:!tw-bg-[#202020] hover:!tw-text-white" : ""
              ),
              onClick: () => G(O.href),
              iconLeft: O.icon,
              children: O.label
            },
            I
          );
        })
      }
    ), Z = () => {
      switch (C) {
        case "sliding":
          return z();
        case "dropdown":
          return j();
        default:
          return H();
      }
    };
    return /* @__PURE__ */ m(
      "div",
      {
        ref: ig([h, R]),
        className: N(
          q1({
            position: r,
            displayMode: C
          }),
          e
        ),
        style: {
          ...r && { [r]: `${o}px` },
          zIndex: l
        },
        ...p,
        children: /* @__PURE__ */ m(
          "div",
          {
            className: Y1({
              displayMode: C
            }),
            children: Z()
          }
        )
      }
    );
  }
), J1 = (e, t) => {
  const n = window.scrollY, r = e - n, o = 300;
  let a = 0;
  const i = (s) => {
    a === 0 && (a = s);
    const l = s - a, c = Math.min(l / o, 1), u = c * (2 - c);
    window.scrollTo(0, n + r * u), l < o ? requestAnimationFrame(i) : t && t();
  };
  requestAnimationFrame(i);
}, Q1 = oe("tw-relative tw-w-full tw-rounded-density-action-sm tw-border-density-action-thin tw-py-density-action-padding-lg tw-pl-density-action-padding-xl tw-pr-density-action-padding-lg tw-text-sm [&>svg+div]:tw-translate-y-[-3px] [&>svg]:tw-absolute [&>svg]:tw-left-4 [&>svg]:tw-top-4 [&>svg~*]:tw-pl-7", {
  variants: {
    type: {
      neutral: " tw-border-semantic-action-border-primary-weaker tw-bg-semantic-action-background-neutral-white [&>div>div>h2]:tw-text-semantic-action-foreground-primary-strongest [&>div>span>svg]:tw-text-semantic-action-foreground-primary-default",
      info: "tw-border-semantic-action-border-info-weak tw-bg-semantic-action-background-info-weakest [&>div>div>h2]:tw-text-semantic-action-foreground-info-stronger [&>div>span>svg]:tw-text-semantic-action-foreground-primary-default",
      error: "tw-border-semantic-action-border-error-weak tw-bg-semantic-action-background-error-weakest [&>div>div>h2]:tw-text-semantic-action-foreground-error-stronger [&>div>span>svg]:tw-text-semantic-action-foreground-error-weak",
      warning: "tw-border-semantic-action-border-warning-weak tw-bg-semantic-action-background-warning-weakest [&>div>div>h2]:tw-text-semantic-action-foreground-warning-stronger [&>div>span>svg]:tw-text-semantic-action-foreground-warning-weak",
      success: "tw-border-semantic-action-border-success-weak tw-bg-semantic-action-background-success-weakest [&>div>div>h2]:tw-text-semantic-action-foreground-success-stronger [&>div>span>svg]:tw-text-semantic-action-foreground-success-weak"
    }
  },
  defaultVariants: {
    type: "neutral"
  }
}), sg = oe("", {
  variants: {
    size: {
      lg: "tw-body-lg-medium tw-font-normal",
      sm: "tw-body-md-regular "
    }
  }
}), Z1 = oe("", {
  variants: {
    variant: {
      xxs: ["tw-heading-sm"],
      md: ["tw-heading-md"],
      lg: ["tw-heading-lg"]
    }
  },
  defaultVariants: {
    variant: "lg"
  }
}), Kc = q(
  ({ className: e, level: t, variant: n = "lg", ...r }, o) => {
    const a = N(Z1({ variant: n }), e);
    return d0(t, { ...r, ref: o, className: a });
  }
);
Kc.displayName = "Heading";
var ek = "Separator", Ud = "horizontal", tk = ["horizontal", "vertical"], lg = v.forwardRef((e, t) => {
  const { decorative: n, orientation: r = Ud, ...o } = e, a = nk(r) ? r : Ud, s = n ? { role: "none" } : { "aria-orientation": a === "vertical" ? a : void 0, role: "separator" };
  return /* @__PURE__ */ m(
    ie.div,
    {
      "data-orientation": a,
      ...s,
      ...o,
      ref: t
    }
  );
});
lg.displayName = ek;
function nk(e) {
  return tk.includes(e);
}
var cg = lg;
const rk = oe("tw-shrink-0 ", {
  variants: {
    orientation: {
      horizontal: "tw-h-px tw-w-full",
      vertical: "tw-h-full tw-w-px"
    },
    color: {
      neutral: "",
      primary: ""
    },
    intensity: {
      weaker: "",
      weak: "",
      default: "",
      strong: "",
      stronger: ""
    }
  },
  compoundVariants: [{
    color: "neutral",
    intensity: "weaker",
    class: "tw-bg-components-separator-neutral-weaker"
  }, {
    color: "neutral",
    intensity: "weak",
    class: "tw-bg-components-separator-neutral-weak"
  }, {
    color: "neutral",
    intensity: "default",
    class: "tw-bg-components-separator-neutral-default"
  }, {
    color: "neutral",
    intensity: "strong",
    class: "tw-bg-components-separator-neutral-strong"
  }, {
    color: "neutral",
    intensity: "stronger",
    class: "tw-bg-components-separator-neutral-stronger"
  }, {
    color: "primary",
    intensity: "weaker",
    class: "tw-bg-components-separator-primary-weaker"
  }, {
    color: "primary",
    intensity: "weak",
    class: "tw-bg-components-separator-primary-weak"
  }, {
    color: "primary",
    intensity: "default",
    class: "tw-bg-components-separator-primary-default"
  }, {
    color: "primary",
    intensity: "strong",
    class: "tw-bg-components-separator-primary-strong"
  }, {
    color: "primary",
    intensity: "stronger",
    class: "tw-bg-components-separator-primary-stronger"
  }],
  defaultVariants: {
    orientation: "horizontal",
    color: "neutral",
    intensity: "default"
  }
}), ug = q(
  ({
    className: e,
    orientation: t = "horizontal",
    decorative: n = !0,
    color: r = "neutral",
    intensity: o = "default",
    ...a
  }, i) => /* @__PURE__ */ m(
    cg,
    {
      ref: i,
      decorative: n,
      className: N(
        rk({ orientation: t, color: r, intensity: o, className: e })
      ),
      ...a
    }
  )
);
ug.displayName = cg.displayName;
const Li = bt(void 0), ok = q(
  ({
    className: e,
    type: t = "neutral",
    size: n = "sm",
    hasSeparator: r = !0,
    showLeftIcon: o = !0,
    icon: a,
    ariaLive: i = "polite",
    showClose: s = !0,
    onDismiss: l,
    ...c
  }, u) => {
    const d = {
      neutral: "car",
      info: "circle-info",
      error: "octagon-exclamation",
      warning: "triangle-exclamation",
      success: "circle-check"
    };
    return /* @__PURE__ */ m(
      Li.Provider,
      { value: { ariaLive: i, type: t, size: n, hasSeparator: r }, children: /* @__PURE__ */ m(
        "div",
        {
          ref: u,
          role: "alert",
          "aria-live": i,
          className: N(Q1({ type: t }), e),
          ...c,
          children: /* @__PURE__ */ ee(
            "div",
            { className: "tw-flex tw-gap-density-action-gap-md", children: [
              o && /* @__PURE__ */ m(de, { icon: a || d[t], size: "xl" }),
              /* @__PURE__ */ m("div", { className: "tw-grid tw-flex-1  ", children: c.children }),
              s ? /* @__PURE__ */ m(
                mt,
                {
                  iconName: "xmark",
                  ariaLabel: "close",
                  variant: "ghost",
                  intent: "neutral",
                  className: "tw-justify-self-end",
                  onClick: l
                }
              ) : null
            ] }
          )
        }
      ) }
    );
  }
);
ok.displayName = "Alert";
const ak = q(
  ({ className: e, ...t }, n) => {
    const r = Xe(Li);
    if (!r)
      throw new Error(
        "Alert components must be rendered within an Alert component."
      );
    const { size: o } = r;
    return /* @__PURE__ */ m(
      Kc,
      {
        ref: n,
        level: "h2",
        variant: o === "sm" ? "xxs" : "md",
        children: t.children,
        className: N(
          "tw-pt-density-action-padding-2xs",
          "tw-pb-density-action-padding-lg",
          e
        )
      }
    );
  }
);
ak.displayName = "AlertHeading";
const ik = q(
  ({ className: e, ...t }, n) => {
    const r = Xe(Li);
    if (!r)
      throw new Error(
        "Alert components must be rendered within an Alert component."
      );
    const { size: o } = r;
    return /* @__PURE__ */ m(
      "div",
      {
        ref: n,
        className: N(
          sg({ size: o }),
          "tw-pb-density-action-padding-lg",
          e
        ),
        ...t
      }
    );
  }
);
ik.displayName = "AlertDescription";
const sk = q(
  ({ className: e, ...t }, n) => {
    const r = Xe(Li);
    if (!r)
      throw new Error(
        "Alert components must be rendered within an Alert component."
      );
    const { hasSeparator: o, size: a } = r;
    return /* @__PURE__ */ ee(
      "div",
      {
        ref: n,
        className: N(
          sg({ size: a }),
          "tw-justify-self-center tw-self-center tw-w-full ",
          e
        ),
        ...t,
        children: [
          o && /* @__PURE__ */ m(ug, { className: "tw-mb-density-action-padding-lg" }),
          t.children
        ]
      }
    );
  }
);
sk.displayName = "AlertContent";
var lk = "AspectRatio", Xc = v.forwardRef(
  (e, t) => {
    const { ratio: n = 1 / 1, style: r, ...o } = e;
    return /* @__PURE__ */ m(
      "div",
      {
        style: {
          // ensures inner element is contained
          position: "relative",
          // ensures padding bottom trick maths works
          width: "100%",
          paddingBottom: `${100 / n}%`
        },
        "data-radix-aspect-ratio-wrapper": "",
        children: /* @__PURE__ */ m(
          ie.div,
          {
            ...o,
            ref: t,
            style: {
              ...r,
              // ensures children expand in ratio
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            }
          }
        )
      }
    );
  }
);
Xc.displayName = lk;
var ck = Xc;
const uk = {
  fit: "fit"
}, dk = "[&>*]:tw-w-full [&>*]:tw-h-full tw-overflow-hidden ", fk = oe(dk, {
  variants: {
    fit: {
      fit: "[&>*]:tw-object-contain ",
      fill: "[&>*]:tw-object-cover "
    }
  },
  defaultVariants: uk
}), pk = q(
  ({ aspectRatio: e = "1:1", fit: t = "fit", className: n, children: r, ...o }, a) => {
    const [i, s] = ye([1, 1]), [l, c] = ye(null), u = qe(null);
    return ke(() => {
      if (!(e && u.current))
        return;
      const [d, f] = e.split(":");
      d && f && (s([parseInt(d), parseInt(f)]), l || c(u.current.clientHeight || null));
    }, [e, u]), ke(() => {
      if (!(u.current && l))
        return;
      const [d, f] = i, p = l * (f / d), h = (l - p) / 2;
      u.current.style.marginTop = h + "px";
    }, [u, l, i]), /* @__PURE__ */ m(
      "div",
      { className: `tw-inline-block tw-w-full ${n}`, ref: u, children: /* @__PURE__ */ m(
        Xc,
        {
          ratio: i[0] / i[1],
          ref: a,
          className: N(fk({ fit: t })),
          ...o,
          children: r
        }
      ) }
    );
  }
);
pk.displayName = ck.displayName;
var Jc = "Dialog", [dg, S3] = Ye(Jc), [mk, Bt] = dg(Jc), fg = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: i = !0
  } = e, s = v.useRef(null), l = v.useRef(null), [c = !1, u] = je({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ m(
    mk,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: Te(),
      titleId: Te(),
      descriptionId: Te(),
      open: c,
      onOpenChange: u,
      onOpenToggle: v.useCallback(() => u((d) => !d), [u]),
      modal: i,
      children: n
    }
  );
};
fg.displayName = Jc;
var pg = "DialogTrigger", mg = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Bt(pg, n), a = xe(t, o.triggerRef);
    return /* @__PURE__ */ m(
      ie.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": eu(o.open),
        ...r,
        ref: a,
        onClick: re(e.onClick, o.onOpenToggle)
      }
    );
  }
);
mg.displayName = pg;
var Qc = "DialogPortal", [gk, gg] = dg(Qc, {
  forceMount: void 0
}), hg = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, a = Bt(Qc, t);
  return /* @__PURE__ */ m(gk, { scope: t, forceMount: n, children: v.Children.map(r, (i) => /* @__PURE__ */ m(at, { present: n || a.open, children: /* @__PURE__ */ m(Jr, { asChild: !0, container: o, children: i }) })) });
};
hg.displayName = Qc;
var fi = "DialogOverlay", vg = v.forwardRef(
  (e, t) => {
    const n = gg(fi, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = Bt(fi, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ m(at, { present: r || a.open, children: /* @__PURE__ */ m(hk, { ...o, ref: t }) }) : null;
  }
);
vg.displayName = fi;
var hk = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Bt(fi, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ m(ea, { as: Nn, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ m(
        ie.div,
        {
          "data-state": eu(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), nr = "DialogContent", wg = v.forwardRef(
  (e, t) => {
    const n = gg(nr, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = Bt(nr, e.__scopeDialog);
    return /* @__PURE__ */ m(at, { present: r || a.open, children: a.modal ? /* @__PURE__ */ m(vk, { ...o, ref: t }) : /* @__PURE__ */ m(wk, { ...o, ref: t }) });
  }
);
wg.displayName = nr;
var vk = v.forwardRef(
  (e, t) => {
    const n = Bt(nr, e.__scopeDialog), r = v.useRef(null), o = xe(t, n.contentRef, r);
    return v.useEffect(() => {
      const a = r.current;
      if (a) return Di(a);
    }, []), /* @__PURE__ */ m(
      bg,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: re(e.onCloseAutoFocus, (a) => {
          var i;
          a.preventDefault(), (i = n.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: re(e.onPointerDownOutside, (a) => {
          const i = a.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && a.preventDefault();
        }),
        onFocusOutside: re(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), wk = v.forwardRef(
  (e, t) => {
    const n = Bt(nr, e.__scopeDialog), r = v.useRef(!1), o = v.useRef(!1);
    return /* @__PURE__ */ m(
      bg,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var l, c;
          (l = e.onInteractOutside) == null || l.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const i = a.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), bg = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...i } = e, s = Bt(nr, n), l = v.useRef(null), c = xe(t, l);
    return Pi(), /* @__PURE__ */ ee(Ne, { children: [
      /* @__PURE__ */ m(
        Xo,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ m(
            dr,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": eu(s.open),
              ...i,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ ee(Ne, { children: [
        /* @__PURE__ */ m(bk, { titleId: s.titleId }),
        /* @__PURE__ */ m(xk, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Zc = "DialogTitle", yg = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Bt(Zc, n);
    return /* @__PURE__ */ m(ie.h2, { id: o.titleId, ...r, ref: t });
  }
);
yg.displayName = Zc;
var xg = "DialogDescription", Sg = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Bt(xg, n);
    return /* @__PURE__ */ m(ie.p, { id: o.descriptionId, ...r, ref: t });
  }
);
Sg.displayName = xg;
var Cg = "DialogClose", Eg = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Bt(Cg, n);
    return /* @__PURE__ */ m(
      ie.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: re(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Eg.displayName = Cg;
function eu(e) {
  return e ? "open" : "closed";
}
var kg = "DialogTitleWarning", [C3, Rg] = h0(kg, {
  contentName: nr,
  titleName: Zc,
  docsSlug: "dialog"
}), bk = ({ titleId: e }) => {
  const t = Rg(kg), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return v.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, yk = "DialogDescriptionWarning", xk = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Rg(yk).contentName}}.`;
  return v.useEffect(() => {
    var a;
    const o = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, ra = fg, tu = mg, oa = hg, fr = vg, Mn = wg, aa = yg, ia = Sg, Fi = Eg;
const qd = 1, Sk = 0.9, Ck = 0.8, Ek = 0.17, Ms = 0.1, Os = 0.999, kk = 0.9999, Rk = 0.99, Pk = /[\\\/_+.#"@\[\(\{&]/, Nk = /[\\\/_+.#"@\[\(\{&]/g, Tk = /[\s-]/, Pg = /[\s-]/g;
function Ml(e, t, n, r, o, a, i) {
  if (a === t.length)
    return o === e.length ? qd : Rk;
  const s = `${o},${a}`;
  if (i[s] !== void 0)
    return i[s];
  const l = r.charAt(a);
  let c = n.indexOf(l, o), u = 0, d, f, p, h;
  for (; c >= 0; )
    d = Ml(e, t, n, r, c + 1, a + 1, i), d > u && (c === o ? d *= qd : Pk.test(e.charAt(c - 1)) ? (d *= Ck, p = e.slice(o, c - 1).match(Nk), p && o > 0 && (d *= Math.pow(Os, p.length))) : Tk.test(e.charAt(c - 1)) ? (d *= Sk, h = e.slice(o, c - 1).match(Pg), h && o > 0 && (d *= Math.pow(Os, h.length))) : (d *= Ek, o > 0 && (d *= Math.pow(Os, c - o))), e.charAt(c) !== t.charAt(a) && (d *= kk)), (d < Ms && n.charAt(c - 1) === r.charAt(a + 1) || r.charAt(a + 1) === r.charAt(a) && // allow duplicate letters. Ref #7428
    n.charAt(c - 1) !== r.charAt(a)) && (f = Ml(e, t, n, r, c + 1, a + 2, i), f * Ms > d && (d = f * Ms)), d > u && (u = d), c = n.indexOf(l, c + 1);
  return i[s] = u, u;
}
function Yd(e) {
  return e.toLowerCase().replace(Pg, " ");
}
function _k(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, Ml(e, t, Yd(e), Yd(t), 0, 0, {});
}
var Ol = { exports: {} }, Ds = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kd;
function Ik() {
  if (Kd) return Ds;
  Kd = 1;
  var e = B;
  function t(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, a = e.useLayoutEffect, i = e.useDebugValue;
  function s(d, f) {
    var p = f(), h = r({ inst: { value: p, getSnapshot: f } }), g = h[0].inst, w = h[1];
    return a(
      function() {
        g.value = p, g.getSnapshot = f, l(g) && w({ inst: g });
      },
      [d, p, f]
    ), o(
      function() {
        return l(g) && w({ inst: g }), d(function() {
          l(g) && w({ inst: g });
        });
      },
      [d]
    ), i(p), p;
  }
  function l(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var p = f();
      return !n(d, p);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return Ds.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, Ds;
}
var As = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xd;
function Mk() {
  return Xd || (Xd = 1, process.env.NODE_ENV !== "production" && function() {
    function e(p, h) {
      return p === h && (p !== 0 || 1 / p === 1 / h) || p !== p && h !== h;
    }
    function t(p, h) {
      u || o.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var g = h();
      if (!d) {
        var w = h();
        a(g, w) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      w = i({
        inst: { value: g, getSnapshot: h }
      });
      var b = w[0].inst, y = w[1];
      return l(
        function() {
          b.value = g, b.getSnapshot = h, n(b) && y({ inst: b });
        },
        [p, g, h]
      ), s(
        function() {
          return n(b) && y({ inst: b }), p(function() {
            n(b) && y({ inst: b });
          });
        },
        [p]
      ), c(g), g;
    }
    function n(p) {
      var h = p.getSnapshot;
      p = p.value;
      try {
        var g = h();
        return !a(p, g);
      } catch {
        return !0;
      }
    }
    function r(p, h) {
      return h();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = B, a = typeof Object.is == "function" ? Object.is : e, i = o.useState, s = o.useEffect, l = o.useLayoutEffect, c = o.useDebugValue, u = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    As.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), As;
}
process.env.NODE_ENV === "production" ? Ol.exports = Ik() : Ol.exports = Mk();
var Ng = Ol.exports;
const co = '[cmdk-group=""]', $s = '[cmdk-group-items=""]', Ok = '[cmdk-group-heading=""]', nu = '[cmdk-item=""]', Jd = `${nu}:not([aria-disabled="true"])`, Dl = "cmdk-item-select", Yn = "data-value", Dk = (e, t, n) => _k(e, t, n), Tg = v.createContext(void 0), sa = () => v.useContext(Tg), _g = v.createContext(void 0), ru = () => v.useContext(_g), Ig = v.createContext(void 0), Mg = v.forwardRef(
  (e, t) => {
    const n = Er(() => ({
      /** Value of the search query. */
      search: "",
      /** Currently selected item value. */
      value: e.value ?? e.defaultValue ?? "",
      filtered: {
        /** The count of all visible items. */
        count: 0,
        /** Map from visible item id to its search score. */
        items: /* @__PURE__ */ new Map(),
        /** Set of groups with at least one visible item. */
        groups: /* @__PURE__ */ new Set()
      }
    })), r = Er(() => /* @__PURE__ */ new Set()), o = Er(() => /* @__PURE__ */ new Map()), a = Er(
      () => /* @__PURE__ */ new Map()
    ), i = Er(() => /* @__PURE__ */ new Set()), s = Og(e), {
      label: l,
      children: c,
      value: u,
      onValueChange: d,
      filter: f,
      shouldFilter: p,
      loop: h,
      disablePointerSelection: g = !1,
      vimBindings: w = !0,
      ...b
    } = e, y = Te(), x = Te(), C = Te(), S = v.useRef(null), R = Gk();
    rr(() => {
      if (u !== void 0) {
        const k = u.trim();
        n.current.value = k, E.emit();
      }
    }, [u]), rr(() => {
      R(6, j);
    }, []);
    const E = v.useMemo(() => ({
      subscribe: (k) => (i.current.add(k), () => i.current.delete(k)),
      snapshot: () => n.current,
      setState: (k, $, P) => {
        var _, V, T;
        if (!Object.is(n.current[k], $)) {
          if (n.current[k] = $, k === "search")
            H(), G(), R(1, U);
          else if (k === "value" && (P || R(5, j), ((_ = s.current) == null ? void 0 : _.value) !== void 0)) {
            const L = $ ?? "";
            (T = (V = s.current).onValueChange) == null || T.call(V, L);
            return;
          }
          E.emit();
        }
      },
      emit: () => {
        i.current.forEach((k) => k());
      }
    }), []), M = v.useMemo(
      () => ({
        // Keep id → {value, keywords} mapping up-to-date
        value: (k, $, P) => {
          var _;
          $ !== ((_ = a.current.get(k)) == null ? void 0 : _.value) && (a.current.set(k, { value: $, keywords: P }), n.current.filtered.items.set(k, F($, P)), R(2, () => {
            G(), E.emit();
          }));
        },
        // Track item lifecycle (mount, unmount)
        item: (k, $) => (r.current.add(k), $ && (o.current.has($) ? o.current.get($).add(k) : o.current.set($, /* @__PURE__ */ new Set([k]))), R(3, () => {
          H(), G(), n.current.value || U(), E.emit();
        }), () => {
          a.current.delete(k), r.current.delete(k), n.current.filtered.items.delete(k);
          const P = z();
          R(4, () => {
            H(), (P == null ? void 0 : P.getAttribute("id")) === k && U(), E.emit();
          });
        }),
        // Track group lifecycle (mount, unmount)
        group: (k) => (o.current.has(k) || o.current.set(k, /* @__PURE__ */ new Set()), () => {
          a.current.delete(k), o.current.delete(k);
        }),
        filter: () => s.current.shouldFilter,
        label: l || e["aria-label"],
        getDisablePointerSelection: () => s.current.disablePointerSelection,
        listId: y,
        inputId: C,
        labelId: x,
        listInnerRef: S
      }),
      []
    );
    function F(k, $) {
      var _;
      const P = ((_ = s.current) == null ? void 0 : _.filter) ?? Dk;
      return k ? P(k, n.current.search, $) : 0;
    }
    function G() {
      if (!n.current.search || // Explicitly false, because true | undefined is the default
      s.current.shouldFilter === !1)
        return;
      const k = n.current.filtered.items, $ = [];
      n.current.filtered.groups.forEach((_) => {
        const V = o.current.get(_);
        let T = 0;
        V.forEach((L) => {
          const J = k.get(L);
          T = Math.max(J, T);
        }), $.push([_, T]);
      });
      const P = S.current;
      Z().sort((_, V) => {
        const T = _.getAttribute("id"), L = V.getAttribute("id");
        return (k.get(L) ?? 0) - (k.get(T) ?? 0);
      }).forEach((_) => {
        const V = _.closest($s);
        V ? V.appendChild(
          _.parentElement === V ? _ : _.closest(`${$s} > *`)
        ) : P.appendChild(
          _.parentElement === P ? _ : _.closest(`${$s} > *`)
        );
      }), $.sort((_, V) => V[1] - _[1]).forEach((_) => {
        var T;
        const V = (T = S.current) == null ? void 0 : T.querySelector(
          `${co}[${Yn}="${encodeURIComponent(_[0])}"]`
        );
        V == null || V.parentElement.appendChild(V);
      });
    }
    function U() {
      const k = Z().find(
        (P) => P.getAttribute("aria-disabled") !== "true"
      ), $ = k == null ? void 0 : k.getAttribute(Yn);
      E.setState("value", $ || void 0);
    }
    function H() {
      var $, P;
      if (!n.current.search || // Explicitly false, because true | undefined is the default
      s.current.shouldFilter === !1) {
        n.current.filtered.count = r.current.size;
        return;
      }
      n.current.filtered.groups = /* @__PURE__ */ new Set();
      let k = 0;
      for (const _ of r.current) {
        const V = (($ = a.current.get(_)) == null ? void 0 : $.value) ?? "", T = ((P = a.current.get(_)) == null ? void 0 : P.keywords) ?? [], L = F(V, T);
        n.current.filtered.items.set(_, L), L > 0 && k++;
      }
      for (const [_, V] of o.current)
        for (const T of V)
          if (n.current.filtered.items.get(T) > 0) {
            n.current.filtered.groups.add(_);
            break;
          }
      n.current.filtered.count = k;
    }
    function j() {
      var $, P, _;
      const k = z();
      k && ((($ = k.parentElement) == null ? void 0 : $.firstChild) === k && ((_ = (P = k.closest(co)) == null ? void 0 : P.querySelector(Ok)) == null || _.scrollIntoView({ block: "nearest" })), k.scrollIntoView({ block: "nearest" }));
    }
    function z() {
      var k;
      return (k = S.current) == null ? void 0 : k.querySelector(
        `${nu}[aria-selected="true"]`
      );
    }
    function Z() {
      var k;
      return Array.from(
        ((k = S.current) == null ? void 0 : k.querySelectorAll(Jd)) || []
      );
    }
    function Y(k) {
      const P = Z()[k];
      P && E.setState("value", P.getAttribute(Yn));
    }
    function O(k) {
      var T;
      const $ = z(), P = Z(), _ = P.findIndex((L) => L === $);
      let V = P[_ + k];
      (T = s.current) != null && T.loop && (V = _ + k < 0 ? P[P.length - 1] : _ + k === P.length ? P[0] : P[_ + k]), V && E.setState("value", V.getAttribute(Yn));
    }
    function I(k) {
      const $ = z();
      let P = $ == null ? void 0 : $.closest(co), _;
      for (; P && !_; )
        P = k > 0 ? Wk(P, co) : jk(P, co), _ = P == null ? void 0 : P.querySelector(Jd);
      _ ? E.setState("value", _.getAttribute(Yn)) : O(k);
    }
    const W = () => Y(Z().length - 1), A = (k) => {
      k.preventDefault(), k.metaKey ? W() : k.altKey ? I(1) : O(1);
    }, K = (k) => {
      k.preventDefault(), k.metaKey ? Y(0) : k.altKey ? I(-1) : O(-1);
    };
    return /* @__PURE__ */ ee(
      ie.div,
      {
        ref: t,
        tabIndex: -1,
        ...b,
        "cmdk-root": "",
        onKeyDown: (k) => {
          var $;
          if (($ = b.onKeyDown) == null || $.call(b, k), !k.defaultPrevented)
            switch (k.key) {
              case "n":
              case "j": {
                w && k.ctrlKey && A(k);
                break;
              }
              case "ArrowDown": {
                A(k);
                break;
              }
              case "p":
              case "k": {
                w && k.ctrlKey && K(k);
                break;
              }
              case "ArrowUp": {
                K(k);
                break;
              }
              case "Home": {
                k.preventDefault(), Y(0);
                break;
              }
              case "End": {
                k.preventDefault(), W();
                break;
              }
              case "Enter":
                if (!k.nativeEvent.isComposing && k.keyCode !== 229) {
                  k.preventDefault();
                  const P = z();
                  if (P) {
                    const _ = new Event(Dl);
                    P.dispatchEvent(_);
                  }
                }
            }
        },
        children: [
          /* @__PURE__ */ m(
            "label",
            {
              "cmdk-label": "",
              htmlFor: M.inputId,
              id: M.labelId,
              style: qk,
              children: l
            }
          ),
          zi(
            e,
            (k) => /* @__PURE__ */ m(
              _g.Provider,
              { value: E, children: /* @__PURE__ */ m(
                Tg.Provider,
                { value: M, children: k }
              ) }
            )
          )
        ]
      }
    );
  }
), Ak = v.forwardRef(
  (e, t) => {
    var C;
    const n = Te(), r = v.useRef(null), o = v.useContext(Ig), a = sa(), i = Og(e), s = ((C = i.current) == null ? void 0 : C.forceMount) ?? (o == null ? void 0 : o.forceMount);
    rr(() => {
      if (!s)
        return a.item(n, o == null ? void 0 : o.id);
    }, [s]);
    const l = Dg(
      n,
      r,
      [e.value, e.children, r],
      e.keywords
    ), c = ru(), u = or(
      (S) => S.value && S.value === l.current
    ), d = or(
      (S) => s || a.filter() === !1 ? !0 : S.search ? S.filtered.items.get(n) > 0 : !0
    );
    v.useEffect(() => {
      const S = r.current;
      S && S.dataset.checked === "true" && c.setState("value", l.current, !0);
    }, [c, l]), v.useEffect(() => {
      const S = r.current;
      if (!(!S || e.disabled))
        return S.addEventListener(Dl, f), () => S.removeEventListener(Dl, f);
    }, [d, e.onSelect, e.disabled]);
    function f() {
      var S, R;
      p(), (R = (S = i.current).onSelect) == null || R.call(S, l.current);
    }
    function p() {
      c.setState("value", l.current, !0);
    }
    if (!d) return null;
    const {
      disabled: h,
      value: g,
      onSelect: w,
      forceMount: b,
      keywords: y,
      ...x
    } = e;
    return /* @__PURE__ */ m(
      ie.div,
      {
        ref: $r([r, t]),
        ...x,
        id: n,
        "cmdk-item": "",
        role: "option",
        "aria-disabled": !!h,
        "aria-selected": !!u,
        "data-disabled": !!h,
        "data-selected": !!u,
        onPointerMove: h || a.getDisablePointerSelection() ? void 0 : p,
        onClick: h ? void 0 : f,
        children: e.children
      }
    );
  }
), $k = v.forwardRef(
  (e, t) => {
    const { heading: n, children: r, forceMount: o, ...a } = e, i = Te(), s = v.useRef(null), l = v.useRef(null), c = Te(), u = sa(), d = or(
      (p) => o || u.filter() === !1 ? !0 : p.search ? p.filtered.groups.has(i) : !0
    );
    rr(() => u.group(i), []), Dg(i, s, [e.value, e.heading, l]);
    const f = v.useMemo(
      () => ({ id: i, forceMount: o }),
      [o]
    );
    return /* @__PURE__ */ ee(
      ie.div,
      {
        ref: $r([s, t]),
        ...a,
        "cmdk-group": "",
        role: "presentation",
        hidden: d ? void 0 : !0,
        children: [
          n && /* @__PURE__ */ m(
            "div",
            {
              ref: l,
              "cmdk-group-heading": "",
              "aria-hidden": !0,
              id: c,
              children: n
            }
          ),
          zi(
            e,
            (p) => /* @__PURE__ */ m(
              "div",
              {
                "cmdk-group-items": "",
                role: "group",
                "aria-labelledby": n ? c : void 0,
                children: /* @__PURE__ */ m(
                  Ig.Provider,
                  { value: f, children: p }
                )
              }
            )
          )
        ]
      }
    );
  }
), Lk = v.forwardRef(
  (e, t) => {
    const { alwaysRender: n, ...r } = e, o = v.useRef(null), a = or((i) => !i.search);
    return !n && !a ? null : /* @__PURE__ */ m(
      ie.div,
      {
        ref: $r([o, t]),
        ...r,
        "cmdk-separator": "",
        role: "separator"
      }
    );
  }
), Fk = v.forwardRef(
  (e, t) => {
    const { onValueChange: n, ...r } = e, o = e.value != null, a = ru(), i = or((u) => u.search), s = or((u) => u.value), l = sa(), c = v.useMemo(() => {
      var d;
      const u = (d = l.listInnerRef.current) == null ? void 0 : d.querySelector(
        `${nu}[${Yn}="${encodeURIComponent(s)}"]`
      );
      return u == null ? void 0 : u.getAttribute("id");
    }, []);
    return v.useEffect(() => {
      e.value != null && a.setState("search", e.value);
    }, [e.value]), /* @__PURE__ */ m(
      ie.input,
      {
        ref: t,
        ...r,
        "cmdk-input": "",
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: !1,
        "aria-autocomplete": "list",
        role: "combobox",
        "aria-expanded": !0,
        "aria-controls": l.listId,
        "aria-labelledby": l.labelId,
        "aria-activedescendant": c,
        id: e.id || l.inputId,
        type: "text",
        value: o ? e.value : i,
        onChange: (u) => {
          o || a.setState("search", u.target.value), n == null || n(u.target.value);
        }
      }
    );
  }
), zk = v.forwardRef(
  (e, t) => {
    const { children: n, label: r = "Suggestions", ...o } = e, a = v.useRef(null), i = v.useRef(null), s = sa();
    return v.useEffect(() => {
      if (i.current && a.current) {
        const l = i.current, c = a.current;
        let u;
        const d = new ResizeObserver(() => {
          u = requestAnimationFrame(() => {
            const f = l.offsetHeight;
            c.style.setProperty(
              "--cmdk-list-height",
              f.toFixed(1) + "px"
            );
          });
        });
        return d.observe(l), () => {
          cancelAnimationFrame(u), d.unobserve(l);
        };
      }
    }, []), /* @__PURE__ */ m(
      ie.div,
      {
        ref: $r([a, t]),
        ...o,
        "cmdk-list": "",
        role: "listbox",
        "aria-label": r,
        id: s.listId,
        children: zi(
          e,
          (l) => /* @__PURE__ */ m(
            "div",
            {
              ref: $r([i, s.listInnerRef]),
              "cmdk-list-sizer": "",
              children: l
            }
          )
        )
      }
    );
  }
), Vk = v.forwardRef(
  (e, t) => {
    const {
      open: n,
      onOpenChange: r,
      overlayClassName: o,
      contentClassName: a,
      container: i,
      ...s
    } = e;
    return /* @__PURE__ */ m(
      ra,
      { open: n, onOpenChange: r, children: /* @__PURE__ */ ee(
        oa,
        { container: i, children: [
          /* @__PURE__ */ m(fr, { "cmdk-overlay": "", className: o }),
          /* @__PURE__ */ m(
            Mn,
            {
              "aria-label": e.label,
              "cmdk-dialog": "",
              className: a,
              children: /* @__PURE__ */ m(Mg, { ref: t, ...s })
            }
          )
        ] }
      ) }
    );
  }
), Bk = v.forwardRef(
  (e, t) => or((r) => r.filtered.count === 0) ? /* @__PURE__ */ m(
    ie.div,
    {
      ref: t,
      ...e,
      "cmdk-empty": "",
      role: "presentation"
    }
  ) : null
), Hk = v.forwardRef(
  (e, t) => {
    const { progress: n, children: r, label: o = "Loading...", ...a } = e;
    return /* @__PURE__ */ m(
      ie.div,
      {
        ref: t,
        ...a,
        "cmdk-loading": "",
        role: "progressbar",
        "aria-valuenow": n,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": o,
        children: zi(
          e,
          (i) => /* @__PURE__ */ m("div", { "aria-hidden": !0, children: i })
        )
      }
    );
  }
), Nt = Object.assign(Mg, {
  List: zk,
  Item: Ak,
  Input: Fk,
  Group: $k,
  Separator: Lk,
  Dialog: Vk,
  Empty: Bk,
  Loading: Hk
});
function Wk(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function jk(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function Og(e) {
  const t = v.useRef(e);
  return rr(() => {
    t.current = e;
  }), t;
}
const rr = typeof window > "u" ? v.useEffect : v.useLayoutEffect;
function Er(e) {
  const t = v.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function $r(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
function or(e) {
  const t = ru(), n = () => e(t.snapshot());
  return Ng.useSyncExternalStore(t.subscribe, n, n);
}
function Dg(e, t, n, r = []) {
  const o = v.useRef(), a = sa();
  return rr(() => {
    var l;
    const i = (() => {
      var c;
      for (const u of n) {
        if (typeof u == "string")
          return u.trim();
        if (typeof u == "object" && "current" in u)
          return u.current ? (c = u.current.textContent) == null ? void 0 : c.trim() : o.current;
      }
    })(), s = r.map((c) => c.trim());
    a.value(e, i, s), (l = t.current) == null || l.setAttribute(Yn, i), o.current = i;
  }), o;
}
const Gk = () => {
  const [e, t] = v.useState(), n = Er(() => /* @__PURE__ */ new Map());
  return rr(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function Uk(e) {
  const t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function zi({ asChild: e, children: t }, n) {
  return e && v.isValidElement(t) ? v.cloneElement(
    Uk(t),
    { ref: t.ref },
    n(t.props.children)
  ) : n(t);
}
const qk = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  borderWidth: "0"
}, Yk = oe("", {
  variants: {
    disabled: {
      true: " tw-pointer-events-none",
      false: ""
    }
  }
}), Kk = oe("tw-productiveFluid-body-body-md-regular placeholder:tw-text-foreground-muted tw-flex tw-h-full tw-w-full tw-px-density-formElement-padding-md tw-truncate tw-text-semantic-formElement-label-default placeholder:tw-text-foreground-muted placeholder:tw-text-semantic-formElement-label-light tw-text-left tw-bg-semantic-formElement-background-neutral-default tw-border-semantic-formElement-border-neutral-default tw-border-y-density-formElement-default tw-border-x-density-formElement-default tw-rounded-density-formElement-xs tw-border ", {
  variants: {
    disabled: {
      true: "tw-cursor-not-allowed tw-pointer-events-none tw-border-semantic-formElement-border-neutral-disabled tw-bg-semantic-formElement-background-neutral-disabled "
      //  tw-text-[#575757]
    },
    size: {
      md: "tw-productiveFluid-body-body-md-regular tw-h-[34px] ",
      lg: "tw-productiveFluid-body-body-lg-regular tw-h-density-formElement-lg "
    },
    invalid: {
      true: "tw-border-semantic-formElement-border-neutral-error"
    }
  }
}), Xk = oe(" tw-outline-none ", {
  variants: {
    disabled: {
      true: "tw-cursor-not-allowed tw-border-semantic-formElement-border-neutral-disabled tw-bg-semantic-formElement-background-neutral-disabled "
      //  tw-text-[#575757]
    },
    size: {
      md: "tw-productiveFluid-body-body-md-regular tw-h-[34px] ",
      lg: "tw-productiveFluid-body-body-lg-regular tw-h-density-formElement-lg "
    }
  }
}), Qd = oe("tw-mr-2", {
  variants: {
    checked: {
      true: "tw-opacity-100",
      false: "tw-opacity-0",
      undefined: "tw-opacity-0"
    }
  }
}), Jk = oe("tw-bg-semantic-formElement-background-neutral-default  tw-m-density-formElement-gap-sm tw-w-fit tw-rounded-density-formElement-sm tw-border-density-action-thin tw-border-semantic-formElement-border-neutral-default tw-p-2 tw-z-50 tw-absolute tw-overflow-y-auto", {
  variants: {
    multicolumn: {
      true: "[&>*]:tw-inline-flex",
      false: ""
    },
    listFullWidth: {
      true: "tw-w-full",
      false: ""
    }
  }
}), Qk = oe("tw-p-1 ", {
  variants: {
    showIcon: {
      true: "",
      false: "tw-px-2",
      undefined: "tw-px-2"
    },
    checked: {
      true: "tw-text-semantic-formElement-foreground-primary-default "
    }
  }
}), Zk = oe("tw-flex-1 tw-antialiased", {
  variants: {
    size: {
      md: "tw-label-md-bold",
      lg: "tw-label-lg-bold"
    },
    labelHidden: {
      hidden: "tw-sr-only"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), eR = "tw-text-xs tw-font-[500] tw-leading-[14px] tw-content-center";
let Fa;
const tR = new Uint8Array(16);
function nR() {
  if (!Fa && (Fa = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Fa))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Fa(tR);
}
const Qe = [];
for (let e = 0; e < 256; ++e)
  Qe.push((e + 256).toString(16).slice(1));
function rR(e, t = 0) {
  return Qe[e[t + 0]] + Qe[e[t + 1]] + Qe[e[t + 2]] + Qe[e[t + 3]] + "-" + Qe[e[t + 4]] + Qe[e[t + 5]] + "-" + Qe[e[t + 6]] + Qe[e[t + 7]] + "-" + Qe[e[t + 8]] + Qe[e[t + 9]] + "-" + Qe[e[t + 10]] + Qe[e[t + 11]] + Qe[e[t + 12]] + Qe[e[t + 13]] + Qe[e[t + 14]] + Qe[e[t + 15]];
}
const oR = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Zd = {
  randomUUID: oR
};
function Ir(e, t, n) {
  if (Zd.randomUUID && !e)
    return Zd.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || nR)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, rR(r);
}
const aR = {
  selectedItems: null,
  selectedValues: null,
  isMultiSelect: !1,
  handleSelect: () => {
  },
  searchValue: "",
  setSearchValue: () => {
  },
  setSelectedValues: () => {
  },
  disabled: !1,
  errorMessage: "",
  setErrorMessage: () => {
  }
}, Ag = bt(aR);
function iR({
  children: e,
  isMultiSelect: t = !1,
  onSelect: n,
  selectedItems: r,
  setSelectedItems: o,
  searchValue: a,
  setSearchValue: i,
  selectedValues: s,
  setSelectedValues: l,
  customFilter: c,
  errorMessage: u,
  setErrorMessage: d,
  disabled: f
}) {
  const [p, h] = ye(
    t ? [] : null
  ), g = r ?? p, w = o ?? h, b = (y, x) => {
    const C = t ? Array.isArray(s) ? x !== void 0 ? s.includes(x) ? s.filter((R) => R !== x) : [...s, x] : s : x !== void 0 ? [x] : [] : x !== void 0 ? x : void 0, S = t ? Array.isArray(g) ? g.includes(y) ? g.filter((R) => R !== y) : [...g, y] : [y] : y;
    l && C !== void 0 && l(C), w(S), n && n(S, C);
  };
  return /* @__PURE__ */ m(
    Ag.Provider,
    {
      value: {
        selectedItems: g,
        handleSelect: b,
        isMultiSelect: t,
        searchValue: a,
        setSearchValue: i,
        disabled: f,
        errorMessage: u,
        setErrorMessage: d
      },
      children: /* @__PURE__ */ m(
        $g,
        { customFilter: c, children: e }
      )
    }
  );
}
function Vi() {
  const e = Xe(Ag);
  if (!e)
    throw new Error(
      "useAutocompleteContext must be used within an AutocompleteProvider"
    );
  return e;
}
const sR = ({
  children: e,
  isMultiSelect: t = !1,
  customFilter: n,
  onSelect: r,
  handleOpen: o,
  isOpen: a,
  disabled: i,
  className: s,
  selectedItems: l,
  setSelectedItems: c
}) => {
  const u = qe(null), [d, f] = ye(""), [p, h] = ye(""), [g, w] = ye(
    null
  ), b = (S) => {
    i || (o && o(S), x(S));
  }, [y, x] = ye(a ?? !1), C = () => {
    setTimeout(() => {
      var S;
      (S = u.current) != null && S.contains(document.activeElement) || (b(!1), f(""));
    }, 0);
  };
  return ke(() => {
    const S = (R) => {
      var E;
      R.key === "Escape" && (b(!1), (E = u.current) == null || E.blur());
    };
    return document.addEventListener("keydown", S), () => {
      document.removeEventListener("keydown", S);
    };
  }, []), ke(() => {
    a !== void 0 && x(a);
  }, [a]), /* @__PURE__ */ m(
    "div",
    {
      ref: u,
      onFocus: () => b(!0),
      onBlur: C,
      className: N(Yk({ disabled: i }), s),
      "data-testid": "AutocompleteV2",
      children: /* @__PURE__ */ m(
        iR,
        {
          isMultiSelect: t,
          onSelect: r,
          selectedItems: l,
          setSelectedItems: c,
          searchValue: d,
          setSearchValue: f,
          setSelectedValues: w,
          selectedValues: g,
          customFilter: n,
          disabled: i,
          errorMessage: p,
          setErrorMessage: h,
          children: B.Children.map(e, (S) => B.isValidElement(S) ? S.type === Lg ? B.cloneElement(
            S,
            { disabled: i }
          ) : S.type === Fg ? B.cloneElement(
            S,
            { open: y }
          ) : S : S)
        }
      )
    }
  );
};
sR.useContext = Vi;
const $g = B.forwardRef(
  ({ customFilter: e, className: t, ...n }, r) => {
    const o = ot(
      (a, i) => e ? e(a, i) ? 1 : 0 : a.toLocaleLowerCase().includes(i.toLocaleLowerCase()) ? 1 : 0,
      [e]
    );
    return /* @__PURE__ */ m(
      Nt,
      {
        ref: r,
        className: N("tw-rounded-md tw-relative", t),
        filter: o,
        ...n
      }
    );
  }
);
$g.displayName = Nt.displayName;
const Lg = q(
  ({
    size: e = "md",
    className: t,
    children: n,
    icon: r,
    label: o,
    inputId: a,
    required: i,
    requiredText: s = "Required",
    errorMessage: l,
    sanitizeValue: c,
    ...u
  }, d) => {
    const {
      selectedItems: f,
      isMultiSelect: p,
      searchValue: h,
      setSearchValue: g,
      disabled: w,
      setErrorMessage: b
    } = Vi(), y = qe(`label-${Ir()}`), [x, C] = ye(!1), S = qe(null), R = () => C(!0), E = () => C(!1), M = () => {
      var H;
      C(!0), (H = S.current) == null || H.focus();
    }, F = (H) => !p && f && !x ? "" : H, G = !p && !x, U = (H) => {
      const j = c ? c(H) : H;
      g(j);
    };
    return ke(() => {
      l && b && b(l);
    }, [l]), /* @__PURE__ */ ee(
      "div",
      {
        className: N(
          "tw-flex tw-flex-col tw-items-start tw-relative tw-h-full "
        ),
        children: [
          (o || i) && /* @__PURE__ */ ee(
            "div",
            {
              className: `tw-flex tw-w-full tw-items-end tw-mb-2 ${o ? "tw-justify-between" : "tw-justify-end"}`,
              children: [
                o && /* @__PURE__ */ m(
                  "label",
                  {
                    htmlFor: y.current,
                    className: Zk({
                      size: e
                    }),
                    children: o
                  }
                ),
                i && /* @__PURE__ */ m("span", { className: eR, children: s })
              ]
            }
          ),
          /* @__PURE__ */ ee(
            "div",
            {
              className: N(
                "custom-text-input-focus-ring tw-group tw-rounded-sm tw-border tw-text-sm tw-flex tw-items-center",
                Kk({
                  disabled: w,
                  invalid: !!l
                })
              ),
              children: [
                G && /* @__PURE__ */ m(
                  "span",
                  {
                    className: `tw-pointer-events-none tw-absolute tw-left-2 tw-truncate ${r ? "tw-right-6" : "tw-right-1"} tw-bg-inherit`,
                    children: f
                  }
                ),
                n,
                /* @__PURE__ */ m(
                  Nt.Input,
                  {
                    ...u,
                    disabled: w,
                    ref: $r([S, d]),
                    onFocus: R,
                    onBlur: E,
                    className: N(
                      Xk({ size: e, disabled: w }),
                      "tw-w-full",
                      t
                    ),
                    placeholder: F(u.placeholder),
                    value: h,
                    onValueChange: U,
                    "data-testid": "AutocompleteInput",
                    id: a || y.current,
                    required: i
                  }
                ),
                r && /* @__PURE__ */ m(de, { icon: r, onClick: M })
              ]
            }
          ),
          l && /* @__PURE__ */ m(
            "span",
            { className: "tw-max-w-full tw-truncate tw-px-brand-0 tw-pt-2 tw-text-xs tw-font-medium tw-text-semantic-formElement-label-error", children: l }
          )
        ]
      }
    );
  }
);
Lg.displayName = Nt.Input.displayName;
const Fg = B.forwardRef(
  ({ className: e, children: t, open: n, scrollIntoView: r = !0, ...o }, a) => {
    const { errorMessage: i } = Vi();
    return ke(() => {
      if (!n || !r) return;
      const s = document.querySelector('[data-checked="true"]'), l = s == null ? void 0 : s.closest(".dropdown-container");
      if (s && l) {
        const c = s.offsetTop, u = s.offsetHeight, d = l.offsetHeight, f = c - d / 2 + u / 2;
        l.scrollTo({
          top: f,
          behavior: "smooth"
        });
      }
    }, [n]), n && /* @__PURE__ */ m(
      Nt.List,
      {
        tabIndex: -1,
        ref: a,
        className: N(
          `tw-mx-0 tw-z-50 tw-border dropdown-container ${i ? "tw-mt-[-20px]" : ""}`,
          Jk(),
          e
        ),
        "data-testid": "AutocompleteList",
        ...o,
        children: t
      }
    );
  }
);
Fg.displayName = Nt.List.displayName;
const lR = B.forwardRef(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ m(
    Nt.Group,
    {
      ref: r,
      className: N(
        "tw-text-foreground [&_[cmdk-group-heading]]:tw-text-muted-foreground tw-overflow-hidden tw-p-1 [&_[cmdk-group-heading]]:tw-px-2 [&_[cmdk-group-heading]]:tw-py-1.5 [&_[cmdk-group-heading]]:tw-text-xs [&_[cmdk-group-heading]]:tw-font-medium",
        e
      ),
      "cmdk-group-items": "",
      "data-testid": "AutocompleteGroup",
      ...n,
      children: t
    }
  )
);
lR.displayName = Nt.Group.displayName;
const cR = B.forwardRef(
  ({ className: e, iconVariant: t, option: n, value: r, ...o }, a) => {
    const { selectedItems: i, handleSelect: s, isMultiSelect: l } = Vi(), c = l ? Array.isArray(i) && i.includes(n) : i === n;
    return /* @__PURE__ */ m(
      Nt.Item,
      {
        ref: a,
        tabIndex: -1,
        onSelect: () => s(n, r),
        className: N(
          "data-[selected=true]:custom-autocomplete-focus-ring data-[selected=true]:tw-bg-semantic-formElement-background-neutral-stronger data-[disabled=true]:tw-pointer-events-none data-[disabled=true]:tw-opacity-50 tw-inline-flex tw-cursor-pointer tw-select-none tw-text-sm tw-outline-none",
          e
        ),
        "data-testid": "AutocompleteItem",
        "data-checked": c,
        "data-multiselect": l,
        ...o,
        children: /* @__PURE__ */ m(
          "span",
          { children: /* @__PURE__ */ ee(
            "div",
            {
              className: N(
                "tw-inline-flex tw-items-center tw-rounded-sm",
                Qk({
                  checked: c
                })
              ),
              children: [
                t && (t === "filled" ? /* @__PURE__ */ m(
                  de,
                  {
                    className: N(Qd({ checked: !0 })),
                    icon: c ? "checkbox-checked" : "checkbox-unchecked",
                    size: "sm"
                  }
                ) : /* @__PURE__ */ m(
                  de,
                  {
                    className: N(Qd({ checked: c })),
                    icon: "check",
                    size: "sm"
                  }
                )),
                /* @__PURE__ */ m("span", { id: "label", children: n })
              ]
            }
          ) }
        )
      }
    );
  }
);
cR.displayName = Nt.Item.displayName;
const uR = B.forwardRef(
  (e, t) => /* @__PURE__ */ m(
    Nt.Empty,
    {
      ref: t,
      className: "tw-text-center tw-text-sm",
      "data-testid": "AutocompleteEmpty",
      ...e
    }
  )
);
uR.displayName = Nt.Empty.displayName;
const dR = oe("tw-inline-flex tw-min-w-density-status-sm tw-cursor-default tw-items-center tw-justify-center tw-gap-density-action-gap-sm tw-font-medium tw-tracking-wide tw-subpixel-antialiased", {
  variants: {
    shape: {
      default: "tw-rounded-sm",
      round: "tw-rounded-full"
    },
    color: {
      neutral: "tw-bg-[#e2e4e6] tw-text-[#202020]",
      "neutral-dark": "tw-bg-[#646b73] tw-text-brand-neutral-white",
      green: "tw-bg-[#408557] tw-text-brand-neutral-white",
      blue: "tw-bg-[#326df8] tw-text-brand-neutral-white",
      sky: "tw-bg-[#d4dfff] tw-text-[#202020]",
      orange: "tw-bg-[#f79726] tw-text-[#202020]",
      yellow: "tw-bg-[#fbcf5e] tw-text-[#202020]",
      red: "tw-bg-[#cb4749] tw-text-brand-neutral-white"
    },
    size: {
      sm: "tw-h-[20px] tw-text-[10px] [&>span]:tw-drop-shadow-sm",
      md: "tw-label-xs-medium tw-h-[24px] [&>span]:tw-drop-shadow-md",
      lg: "tw-h-[28px] tw-text-[14px] [&>span]:tw-drop-shadow-md"
    }
  },
  compoundVariants: [{
    size: "sm",
    shape: "default",
    className: "tw-px-[4px]"
  }, {
    size: "sm",
    shape: "round",
    className: "tw-px-[8px]"
  }, {
    size: "md",
    shape: "default",
    className: "tw-px-[4px]"
  }, {
    size: "md",
    shape: "round",
    className: "tw-px-[8px]"
  }, {
    size: "lg",
    shape: "default",
    className: "tw-px-[8px]"
  }, {
    size: "lg",
    shape: "round",
    className: "tw-px-[12px]"
  }]
}), fR = "tw-size-density-status-icon-xs", zg = q(
  ({
    shape: e = "default",
    color: t = "neutral",
    size: n = "md",
    icon: r = "",
    className: o,
    ...a
  }, i) => /* @__PURE__ */ ee(
    "div",
    {
      ref: i,
      className: N(dR({ shape: e, color: t, size: n, className: o })),
      ...a,
      children: [
        r && /* @__PURE__ */ m(
          de,
          {
            icon: r,
            size: "sm",
            className: N(fR, o)
          }
        ),
        /* @__PURE__ */ m("span", { children: a.children })
      ]
    }
  )
), pR = "tw-text-semantic-action-foreground-primary-default hover:tw-text-semantic-action-foreground-primary-dark active:tw-text-semantic-action-foreground-primary-darker text-link-focus-ring tw-flex tw-items-center tw-text-nowrap tw-gap-density-action-gap-sm tw-w-fit hover:tw-underline focus:tw-underline custom-text-link-focus-ring", mR = oe(pR, {
  variants: {
    variant: {
      plain: "",
      underline: "tw-underline"
    },
    size: {
      xs: "tw-text-xs tw-font-semibold",
      sm: "tw-text-sm tw-font-regular",
      md: "tw-text-base tw-font-regular"
    },
    iconPosition: {
      left: "",
      right: "tw-flex-row-reverse"
    }
  },
  compoundVariants: [{
    variant: "plain",
    size: "xs",
    class: ""
  }, {
    variant: "plain",
    size: "sm",
    class: ""
  }, {
    variant: "plain",
    size: "md",
    class: ""
  }, {
    variant: "underline",
    size: "xs",
    class: ""
  }, {
    variant: "underline",
    size: "sm",
    class: ""
  }, {
    variant: "underline",
    size: "md",
    class: ""
  }]
}), Vg = q(
  ({
    className: e,
    variant: t = "plain",
    size: n = "sm",
    label: r = "",
    target: o,
    hrefUrl: a,
    icon: i,
    iconPosition: s = "left",
    ...l
  }, c) => {
    let u = "sm", d = "w-[12px] h-[12px]";
    return n === "md" && (u = n, d = ""), /* @__PURE__ */ ee(
      "a",
      {
        className: N(mR({ variant: t, iconPosition: s, size: n, className: e })),
        href: a,
        target: o,
        ref: c,
        ...l,
        children: [
          i ? /* @__PURE__ */ m(
            "span",
            { children: /* @__PURE__ */ m(de, { size: u, icon: i, className: d }) }
          ) : null,
          r
        ]
      }
    );
  }
), gR = "tw-gap-density-action-gap-md tw-flex tw-flex-wrap tw-items-center tw-break-words tw-text-xs tw-antialiased", hR = "tw-flex tw-justify-center", vR = "tw-font-[500]", wR = "tw-underline tw-underline-offset-2 tw-font-semibold", bR = q(
  ({ ...e }, t) => /* @__PURE__ */ m("nav", { ref: t, "aria-label": "breadcrumb", ...e })
);
bR.displayName = "Breadcrumb";
const yR = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m("ol", { ref: n, className: N(gR, e), ...t })
);
yR.displayName = "BreadcrumbList";
const xR = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m("li", { ref: n, className: N(hR, e), ...t })
);
xR.displayName = "BreadcrumbItem";
const SR = q(
  ({ className: e, hrefUrl: t, ...n }, r) => /* @__PURE__ */ m(
    Vg,
    {
      hrefUrl: t,
      ref: r,
      variant: "underline",
      size: "xs",
      className: N(wR, e),
      ...n
    }
  )
);
SR.displayName = "BreadcrumbLink";
const CR = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    "span",
    {
      ref: n,
      "aria-disabled": "true",
      "aria-current": "page",
      className: N(vR, e),
      ...t
    }
  )
);
CR.displayName = "BreadcrumbPage";
const ER = ({
  className: e,
  ...t
}) => /* @__PURE__ */ m(
  "li",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: N(e),
    ...t,
    children: "/"
  }
);
ER.displayName = "BreadcrumbSeparator";
var Ls = "rovingFocusGroup.onEntryFocus", kR = { bubbles: !1, cancelable: !0 }, Bi = "RovingFocusGroup", [Al, Bg, RR] = qr(Bi), [PR, an] = Ye(
  Bi,
  [RR]
), [NR, TR] = PR(Bi), Hg = v.forwardRef(
  (e, t) => /* @__PURE__ */ m(Al.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ m(Al.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ m(_R, { ...e, ref: t }) }) })
);
Hg.displayName = Bi;
var _R = v.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, f = v.useRef(null), p = xe(t, f), h = Ln(a), [g = null, w] = je({
    prop: i,
    defaultProp: s,
    onChange: l
  }), [b, y] = v.useState(!1), x = Ze(c), C = Bg(n), S = v.useRef(!1), [R, E] = v.useState(0);
  return v.useEffect(() => {
    const M = f.current;
    if (M)
      return M.addEventListener(Ls, x), () => M.removeEventListener(Ls, x);
  }, [x]), /* @__PURE__ */ m(
    NR,
    {
      scope: n,
      orientation: r,
      dir: h,
      loop: o,
      currentTabStopId: g,
      onItemFocus: v.useCallback(
        (M) => w(M),
        [w]
      ),
      onItemShiftTab: v.useCallback(() => y(!0), []),
      onFocusableItemAdd: v.useCallback(
        () => E((M) => M + 1),
        []
      ),
      onFocusableItemRemove: v.useCallback(
        () => E((M) => M - 1),
        []
      ),
      children: /* @__PURE__ */ m(
        ie.div,
        {
          tabIndex: b || R === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: p,
          style: { outline: "none", ...e.style },
          onMouseDown: re(e.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: re(e.onFocus, (M) => {
            const F = !S.current;
            if (M.target === M.currentTarget && F && !b) {
              const G = new CustomEvent(Ls, kR);
              if (M.currentTarget.dispatchEvent(G), !G.defaultPrevented) {
                const U = C().filter((Y) => Y.focusable), H = U.find((Y) => Y.active), j = U.find((Y) => Y.id === g), Z = [H, j, ...U].filter(
                  Boolean
                ).map((Y) => Y.ref.current);
                Gg(Z, u);
              }
            }
            S.current = !1;
          }),
          onBlur: re(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), Wg = "RovingFocusGroupItem", jg = v.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: a,
      ...i
    } = e, s = Te(), l = a || s, c = TR(Wg, n), u = c.currentTabStopId === l, d = Bg(n), { onFocusableItemAdd: f, onFocusableItemRemove: p } = c;
    return v.useEffect(() => {
      if (r)
        return f(), () => p();
    }, [r, f, p]), /* @__PURE__ */ m(
      Al.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ m(
          ie.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": c.orientation,
            ...i,
            ref: t,
            onMouseDown: re(e.onMouseDown, (h) => {
              r ? c.onItemFocus(l) : h.preventDefault();
            }),
            onFocus: re(e.onFocus, () => c.onItemFocus(l)),
            onKeyDown: re(e.onKeyDown, (h) => {
              if (h.key === "Tab" && h.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if (h.target !== h.currentTarget) return;
              const g = OR(h, c.orientation, c.dir);
              if (g !== void 0) {
                if (h.metaKey || h.ctrlKey || h.altKey || h.shiftKey) return;
                h.preventDefault();
                let b = d().filter((y) => y.focusable).map((y) => y.ref.current);
                if (g === "last") b.reverse();
                else if (g === "prev" || g === "next") {
                  g === "prev" && b.reverse();
                  const y = b.indexOf(h.currentTarget);
                  b = c.loop ? DR(b, y + 1) : b.slice(y + 1);
                }
                setTimeout(() => Gg(b));
              }
            })
          }
        )
      }
    );
  }
);
jg.displayName = Wg;
var IR = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function MR(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function OR(e, t, n) {
  const r = MR(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return IR[r];
}
function Gg(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function DR(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var la = Hg, ca = jg, $l = ["Enter", " "], AR = ["ArrowDown", "PageUp", "Home"], Ug = ["ArrowUp", "PageDown", "End"], $R = [...AR, ...Ug], LR = {
  ltr: [...$l, "ArrowRight"],
  rtl: [...$l, "ArrowLeft"]
}, FR = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, ua = "Menu", [zo, zR, VR] = qr(ua), [pr, ou] = Ye(ua, [
  VR,
  Fn,
  an
]), da = Fn(), qg = an(), [Yg, Vn] = pr(ua), [BR, fa] = pr(ua), Kg = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: a, modal: i = !0 } = e, s = da(t), [l, c] = v.useState(null), u = v.useRef(!1), d = Ze(a), f = Ln(o);
  return v.useEffect(() => {
    const p = () => {
      u.current = !0, document.addEventListener("pointerdown", h, { capture: !0, once: !0 }), document.addEventListener("pointermove", h, { capture: !0, once: !0 });
    }, h = () => u.current = !1;
    return document.addEventListener("keydown", p, { capture: !0 }), () => {
      document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", h, { capture: !0 }), document.removeEventListener("pointermove", h, { capture: !0 });
    };
  }, []), /* @__PURE__ */ m(Qo, { ...s, children: /* @__PURE__ */ m(
    Yg,
    {
      scope: t,
      open: n,
      onOpenChange: d,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ m(
        BR,
        {
          scope: t,
          onClose: v.useCallback(() => d(!1), [d]),
          isUsingKeyboardRef: u,
          dir: f,
          modal: i,
          children: r
        }
      )
    }
  ) });
};
Kg.displayName = ua;
var HR = "MenuAnchor", au = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = da(n);
    return /* @__PURE__ */ m(Zo, { ...o, ...r, ref: t });
  }
);
au.displayName = HR;
var iu = "MenuPortal", [WR, Xg] = pr(iu, {
  forceMount: void 0
}), Jg = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, a = Vn(iu, t);
  return /* @__PURE__ */ m(WR, { scope: t, forceMount: n, children: /* @__PURE__ */ m(at, { present: n || a.open, children: /* @__PURE__ */ m(Jr, { asChild: !0, container: o, children: r }) }) });
};
Jg.displayName = iu;
var Pt = "MenuContent", [jR, su] = pr(Pt), Qg = v.forwardRef(
  (e, t) => {
    const n = Xg(Pt, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Vn(Pt, e.__scopeMenu), i = fa(Pt, e.__scopeMenu);
    return /* @__PURE__ */ m(zo.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ m(at, { present: r || a.open, children: /* @__PURE__ */ m(zo.Slot, { scope: e.__scopeMenu, children: i.modal ? /* @__PURE__ */ m(GR, { ...o, ref: t }) : /* @__PURE__ */ m(UR, { ...o, ref: t }) }) }) });
  }
), GR = v.forwardRef(
  (e, t) => {
    const n = Vn(Pt, e.__scopeMenu), r = v.useRef(null), o = xe(t, r);
    return v.useEffect(() => {
      const a = r.current;
      if (a) return Di(a);
    }, []), /* @__PURE__ */ m(
      lu,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: re(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), UR = v.forwardRef((e, t) => {
  const n = Vn(Pt, e.__scopeMenu);
  return /* @__PURE__ */ m(
    lu,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), lu = v.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: a,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: u,
      onFocusOutside: d,
      onInteractOutside: f,
      onDismiss: p,
      disableOutsideScroll: h,
      ...g
    } = e, w = Vn(Pt, n), b = fa(Pt, n), y = da(n), x = qg(n), C = zR(n), [S, R] = v.useState(null), E = v.useRef(null), M = xe(t, E, w.onContentChange), F = v.useRef(0), G = v.useRef(""), U = v.useRef(0), H = v.useRef(null), j = v.useRef("right"), z = v.useRef(0), Z = h ? ea : v.Fragment, Y = h ? { as: Nn, allowPinchZoom: !0 } : void 0, O = (W) => {
      var T, L;
      const A = G.current + W, K = C().filter((J) => !J.disabled), k = document.activeElement, $ = (T = K.find((J) => J.ref.current === k)) == null ? void 0 : T.textValue, P = K.map((J) => J.textValue), _ = oP(P, A, $), V = (L = K.find((J) => J.textValue === _)) == null ? void 0 : L.ref.current;
      (function J(Q) {
        G.current = Q, window.clearTimeout(F.current), Q !== "" && (F.current = window.setTimeout(() => J(""), 1e3));
      })(A), V && setTimeout(() => V.focus());
    };
    v.useEffect(() => () => window.clearTimeout(F.current), []), Pi();
    const I = v.useCallback((W) => {
      var K, k;
      return j.current === ((K = H.current) == null ? void 0 : K.side) && iP(W, (k = H.current) == null ? void 0 : k.area);
    }, []);
    return /* @__PURE__ */ m(
      jR,
      {
        scope: n,
        searchRef: G,
        onItemEnter: v.useCallback(
          (W) => {
            I(W) && W.preventDefault();
          },
          [I]
        ),
        onItemLeave: v.useCallback(
          (W) => {
            var A;
            I(W) || ((A = E.current) == null || A.focus(), R(null));
          },
          [I]
        ),
        onTriggerLeave: v.useCallback(
          (W) => {
            I(W) && W.preventDefault();
          },
          [I]
        ),
        pointerGraceTimerRef: U,
        onPointerGraceIntentChange: v.useCallback((W) => {
          H.current = W;
        }, []),
        children: /* @__PURE__ */ m(Z, { ...Y, children: /* @__PURE__ */ m(
          Xo,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: re(a, (W) => {
              var A;
              W.preventDefault(), (A = E.current) == null || A.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ m(
              dr,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: c,
                onPointerDownOutside: u,
                onFocusOutside: d,
                onInteractOutside: f,
                onDismiss: p,
                children: /* @__PURE__ */ m(
                  la,
                  {
                    asChild: !0,
                    ...x,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: S,
                    onCurrentTabStopIdChange: R,
                    onEntryFocus: re(l, (W) => {
                      b.isUsingKeyboardRef.current || W.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ m(
                      Mi,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": gh(w.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...y,
                        ...g,
                        ref: M,
                        style: { outline: "none", ...g.style },
                        onKeyDown: re(g.onKeyDown, (W) => {
                          const K = W.target.closest("[data-radix-menu-content]") === W.currentTarget, k = W.ctrlKey || W.altKey || W.metaKey, $ = W.key.length === 1;
                          K && (W.key === "Tab" && W.preventDefault(), !k && $ && O(W.key));
                          const P = E.current;
                          if (W.target !== P || !$R.includes(W.key)) return;
                          W.preventDefault();
                          const V = C().filter((T) => !T.disabled).map((T) => T.ref.current);
                          Ug.includes(W.key) && V.reverse(), nP(V);
                        }),
                        onBlur: re(e.onBlur, (W) => {
                          W.currentTarget.contains(W.target) || (window.clearTimeout(F.current), G.current = "");
                        }),
                        onPointerMove: re(
                          e.onPointerMove,
                          Vo((W) => {
                            const A = W.target, K = z.current !== W.clientX;
                            if (W.currentTarget.contains(A) && K) {
                              const k = W.clientX > z.current ? "right" : "left";
                              j.current = k, z.current = W.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Qg.displayName = Pt;
var qR = "MenuGroup", cu = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ m(ie.div, { role: "group", ...r, ref: t });
  }
);
cu.displayName = qR;
var YR = "MenuLabel", Zg = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ m(ie.div, { ...r, ref: t });
  }
);
Zg.displayName = YR;
var pi = "MenuItem", ef = "menu.itemSelect", Hi = v.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, a = v.useRef(null), i = fa(pi, e.__scopeMenu), s = su(pi, e.__scopeMenu), l = xe(t, a), c = v.useRef(!1), u = () => {
      const d = a.current;
      if (!n && d) {
        const f = new CustomEvent(ef, { bubbles: !0, cancelable: !0 });
        d.addEventListener(ef, (p) => r == null ? void 0 : r(p), { once: !0 }), yc(d, f), f.defaultPrevented ? c.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ m(
      eh,
      {
        ...o,
        ref: l,
        disabled: n,
        onClick: re(e.onClick, u),
        onPointerDown: (d) => {
          var f;
          (f = e.onPointerDown) == null || f.call(e, d), c.current = !0;
        },
        onPointerUp: re(e.onPointerUp, (d) => {
          var f;
          c.current || (f = d.currentTarget) == null || f.click();
        }),
        onKeyDown: re(e.onKeyDown, (d) => {
          const f = s.searchRef.current !== "";
          n || f && d.key === " " || $l.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
Hi.displayName = pi;
var eh = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...a } = e, i = su(pi, n), s = qg(n), l = v.useRef(null), c = xe(t, l), [u, d] = v.useState(!1), [f, p] = v.useState("");
    return v.useEffect(() => {
      const h = l.current;
      h && p((h.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ m(
      zo.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? f,
        children: /* @__PURE__ */ m(ca, { asChild: !0, ...s, focusable: !r, children: /* @__PURE__ */ m(
          ie.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...a,
            ref: c,
            onPointerMove: re(
              e.onPointerMove,
              Vo((h) => {
                r ? i.onItemLeave(h) : (i.onItemEnter(h), h.defaultPrevented || h.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: re(
              e.onPointerLeave,
              Vo((h) => i.onItemLeave(h))
            ),
            onFocus: re(e.onFocus, () => d(!0)),
            onBlur: re(e.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), KR = "MenuCheckboxItem", th = v.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ m(ih, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ m(
      Hi,
      {
        role: "menuitemcheckbox",
        "aria-checked": mi(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": fu(n),
        onSelect: re(
          o.onSelect,
          () => r == null ? void 0 : r(mi(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
th.displayName = KR;
var nh = "MenuRadioGroup", [XR, JR] = pr(
  nh,
  { value: void 0, onValueChange: () => {
  } }
), rh = v.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, a = Ze(r);
    return /* @__PURE__ */ m(XR, { scope: e.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ m(cu, { ...o, ref: t }) });
  }
);
rh.displayName = nh;
var oh = "MenuRadioItem", ah = v.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = JR(oh, e.__scopeMenu), a = n === o.value;
    return /* @__PURE__ */ m(ih, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ m(
      Hi,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...r,
        ref: t,
        "data-state": fu(a),
        onSelect: re(
          r.onSelect,
          () => {
            var i;
            return (i = o.onValueChange) == null ? void 0 : i.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
ah.displayName = oh;
var uu = "MenuItemIndicator", [ih, QR] = pr(
  uu,
  { checked: !1 }
), sh = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, a = QR(uu, n);
    return /* @__PURE__ */ m(
      at,
      {
        present: r || mi(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ m(
          ie.span,
          {
            ...o,
            ref: t,
            "data-state": fu(a.checked)
          }
        )
      }
    );
  }
);
sh.displayName = uu;
var ZR = "MenuSeparator", lh = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ m(
      ie.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
lh.displayName = ZR;
var eP = "MenuArrow", ch = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = da(n);
    return /* @__PURE__ */ m(Oi, { ...o, ...r, ref: t });
  }
);
ch.displayName = eP;
var du = "MenuSub", [tP, uh] = pr(du), dh = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, a = Vn(du, t), i = da(t), [s, l] = v.useState(null), [c, u] = v.useState(null), d = Ze(o);
  return v.useEffect(() => (a.open === !1 && d(!1), () => d(!1)), [a.open, d]), /* @__PURE__ */ m(Qo, { ...i, children: /* @__PURE__ */ m(
    Yg,
    {
      scope: t,
      open: r,
      onOpenChange: d,
      content: c,
      onContentChange: u,
      children: /* @__PURE__ */ m(
        tP,
        {
          scope: t,
          contentId: Te(),
          triggerId: Te(),
          trigger: s,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
dh.displayName = du;
var ko = "MenuSubTrigger", fh = v.forwardRef(
  (e, t) => {
    const n = Vn(ko, e.__scopeMenu), r = fa(ko, e.__scopeMenu), o = uh(ko, e.__scopeMenu), a = su(ko, e.__scopeMenu), i = v.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: l } = a, c = { __scopeMenu: e.__scopeMenu }, u = v.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    return v.useEffect(() => u, [u]), v.useEffect(() => {
      const d = s.current;
      return () => {
        window.clearTimeout(d), l(null);
      };
    }, [s, l]), /* @__PURE__ */ m(au, { asChild: !0, ...c, children: /* @__PURE__ */ m(
      eh,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": gh(n.open),
        ...e,
        ref: Ei(t, o.onTriggerChange),
        onClick: (d) => {
          var f;
          (f = e.onClick) == null || f.call(e, d), !(e.disabled || d.defaultPrevented) && (d.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: re(
          e.onPointerMove,
          Vo((d) => {
            a.onItemEnter(d), !d.defaultPrevented && !e.disabled && !n.open && !i.current && (a.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: re(
          e.onPointerLeave,
          Vo((d) => {
            var p, h;
            u();
            const f = (p = n.content) == null ? void 0 : p.getBoundingClientRect();
            if (f) {
              const g = (h = n.content) == null ? void 0 : h.dataset.side, w = g === "right", b = w ? -5 : 5, y = f[w ? "left" : "right"], x = f[w ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + b, y: d.clientY },
                  { x: y, y: f.top },
                  { x, y: f.top },
                  { x, y: f.bottom },
                  { x: y, y: f.bottom }
                ],
                side: g
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(d), d.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: re(e.onKeyDown, (d) => {
          var p;
          const f = a.searchRef.current !== "";
          e.disabled || f && d.key === " " || LR[r.dir].includes(d.key) && (n.onOpenChange(!0), (p = n.content) == null || p.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
fh.displayName = ko;
var ph = "MenuSubContent", mh = v.forwardRef(
  (e, t) => {
    const n = Xg(Pt, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Vn(Pt, e.__scopeMenu), i = fa(Pt, e.__scopeMenu), s = uh(ph, e.__scopeMenu), l = v.useRef(null), c = xe(t, l);
    return /* @__PURE__ */ m(zo.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ m(at, { present: r || a.open, children: /* @__PURE__ */ m(zo.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ m(
      lu,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...o,
        ref: c,
        align: "start",
        side: i.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var d;
          i.isUsingKeyboardRef.current && ((d = l.current) == null || d.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: re(e.onFocusOutside, (u) => {
          u.target !== s.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: re(e.onEscapeKeyDown, (u) => {
          i.onClose(), u.preventDefault();
        }),
        onKeyDown: re(e.onKeyDown, (u) => {
          var p;
          const d = u.currentTarget.contains(u.target), f = FR[i.dir].includes(u.key);
          d && f && (a.onOpenChange(!1), (p = s.trigger) == null || p.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
mh.displayName = ph;
function gh(e) {
  return e ? "open" : "closed";
}
function mi(e) {
  return e === "indeterminate";
}
function fu(e) {
  return mi(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function nP(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function rP(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function oP(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = rP(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter((c) => c !== n));
  const l = i.find(
    (c) => c.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function aP(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a].x, l = t[a].y, c = t[i].x, u = t[i].y;
    l > r != u > r && n < (c - s) * (r - l) / (u - l) + s && (o = !o);
  }
  return o;
}
function iP(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return aP(n, t);
}
function Vo(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var hh = Kg, vh = au, wh = Jg, bh = Qg, yh = cu, xh = Zg, Sh = Hi, Ch = th, Eh = rh, kh = ah, Rh = sh, Ph = lh, Nh = ch, Th = dh, _h = fh, Ih = mh, pu = "DropdownMenu", [sP, E3] = Ye(
  pu,
  [ou]
), it = ou(), [lP, Mh] = sP(pu), Oh = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: a,
    onOpenChange: i,
    modal: s = !0
  } = e, l = it(t), c = v.useRef(null), [u = !1, d] = je({
    prop: o,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ m(
    lP,
    {
      scope: t,
      triggerId: Te(),
      triggerRef: c,
      contentId: Te(),
      open: u,
      onOpenChange: d,
      onOpenToggle: v.useCallback(() => d((f) => !f), [d]),
      modal: s,
      children: /* @__PURE__ */ m(hh, { ...l, open: u, onOpenChange: d, dir: r, modal: s, children: n })
    }
  );
};
Oh.displayName = pu;
var Dh = "DropdownMenuTrigger", Ah = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, a = Mh(Dh, n), i = it(n);
    return /* @__PURE__ */ m(vh, { asChild: !0, ...i, children: /* @__PURE__ */ m(
      ie.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: Ei(t, a.triggerRef),
        onPointerDown: re(e.onPointerDown, (s) => {
          !r && s.button === 0 && s.ctrlKey === !1 && (a.onOpenToggle(), a.open || s.preventDefault());
        }),
        onKeyDown: re(e.onKeyDown, (s) => {
          r || (["Enter", " "].includes(s.key) && a.onOpenToggle(), s.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
Ah.displayName = Dh;
var cP = "DropdownMenuPortal", $h = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = it(t);
  return /* @__PURE__ */ m(wh, { ...r, ...n });
};
$h.displayName = cP;
var Lh = "DropdownMenuContent", Fh = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Mh(Lh, n), a = it(n), i = v.useRef(!1);
    return /* @__PURE__ */ m(
      bh,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...a,
        ...r,
        ref: t,
        onCloseAutoFocus: re(e.onCloseAutoFocus, (s) => {
          var l;
          i.current || (l = o.triggerRef.current) == null || l.focus(), i.current = !1, s.preventDefault();
        }),
        onInteractOutside: re(e.onInteractOutside, (s) => {
          const l = s.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
          (!o.modal || u) && (i.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Fh.displayName = Lh;
var uP = "DropdownMenuGroup", zh = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = it(n);
    return /* @__PURE__ */ m(yh, { ...o, ...r, ref: t });
  }
);
zh.displayName = uP;
var dP = "DropdownMenuLabel", Vh = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = it(n);
    return /* @__PURE__ */ m(xh, { ...o, ...r, ref: t });
  }
);
Vh.displayName = dP;
var fP = "DropdownMenuItem", Bh = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = it(n);
    return /* @__PURE__ */ m(Sh, { ...o, ...r, ref: t });
  }
);
Bh.displayName = fP;
var pP = "DropdownMenuCheckboxItem", Hh = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = it(n);
  return /* @__PURE__ */ m(Ch, { ...o, ...r, ref: t });
});
Hh.displayName = pP;
var mP = "DropdownMenuRadioGroup", Wh = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = it(n);
  return /* @__PURE__ */ m(Eh, { ...o, ...r, ref: t });
});
Wh.displayName = mP;
var gP = "DropdownMenuRadioItem", jh = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = it(n);
  return /* @__PURE__ */ m(kh, { ...o, ...r, ref: t });
});
jh.displayName = gP;
var hP = "DropdownMenuItemIndicator", Gh = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = it(n);
  return /* @__PURE__ */ m(Rh, { ...o, ...r, ref: t });
});
Gh.displayName = hP;
var vP = "DropdownMenuSeparator", Uh = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = it(n);
  return /* @__PURE__ */ m(Ph, { ...o, ...r, ref: t });
});
Uh.displayName = vP;
var wP = "DropdownMenuArrow", bP = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = it(n);
    return /* @__PURE__ */ m(Nh, { ...o, ...r, ref: t });
  }
);
bP.displayName = wP;
var yP = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: a } = e, i = it(t), [s = !1, l] = je({
    prop: r,
    defaultProp: a,
    onChange: o
  });
  return /* @__PURE__ */ m(Th, { ...i, open: s, onOpenChange: l, children: n });
}, xP = "DropdownMenuSubTrigger", qh = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = it(n);
  return /* @__PURE__ */ m(_h, { ...o, ...r, ref: t });
});
qh.displayName = xP;
var SP = "DropdownMenuSubContent", Yh = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = it(n);
  return /* @__PURE__ */ m(
    Ih,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Yh.displayName = SP;
var Kh = Oh, mu = Ah, gu = $h, Wi = Fh, CP = zh, Xh = Vh, ji = Bh, Jh = Hh, EP = Wh, Qh = jh, kP = Gh, Zh = Uh, RP = yP, Gi = qh, Ui = Yh;
const PP = "tw-min-w-28 tw-flex tw-flex-col tw-rounded-density-action-default tw-bg-semantic-action-background-neutral-white tw-shadow tw-shadow-brand-depth-lightest ", NP = "tw-min-w-28 tw-whitespace-nowrap tw-productiveFluid-label-label-md-medium tw-flex tw-items-center tw-justify-between tw-gap-density-action-gap-md tw-py-density-action-padding-sm tw-px-density-action-padding-md tw-text-semantic-action-foreground-neutral-darkest hover:tw-bg-semantic-action-background-primary-lightest focus:tw-bg-semantic-action-background-primary-lightest tw-rounded-density-status-xs tw-h-8 custom-menu-item-focus-ring--inset ", TP = "tw-productiveFluid-body-body-xs-medium custom-text-link-focus-ring tw-flex tw-justify-center ", k3 = Kh, _P = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    mu,
    {
      ref: n,
      className: N(TP, e),
      ...t
    }
  )
);
_P.displayName = mu.displayName;
const IP = q(
  ({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ m(
    Gi,
    {
      ref: o,
      className: N(e),
      ...r,
      children: n
    }
  )
);
IP.displayName = Gi.displayName;
const MP = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    Ui,
    {
      ref: n,
      className: N(e),
      ...t
    }
  )
);
MP.displayName = Ui.displayName;
const OP = q(
  ({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ m(
    gu,
    { children: /* @__PURE__ */ m(
      Wi,
      {
        ref: r,
        sideOffset: t,
        className: N(PP, e),
        ...n
      }
    ) }
  )
);
OP.displayName = Wi.displayName;
const DP = q(
  ({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ m(
    ji,
    {
      ref: r,
      className: N(NP, e),
      ...n
    }
  )
);
DP.displayName = ji.displayName;
function he(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function wt(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function ct(e, t) {
  const n = he(e);
  return isNaN(t) ? wt(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function zt(e, t) {
  const n = he(e);
  if (isNaN(t)) return wt(e, NaN);
  if (!t)
    return n;
  const r = n.getDate(), o = wt(e, n.getTime());
  o.setMonth(n.getMonth() + t + 1, 0);
  const a = o.getDate();
  return r >= a ? o : (n.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    r
  ), n);
}
const hu = 6048e5, AP = 864e5, za = 43200, tf = 1440;
let $P = {};
function Qr() {
  return $P;
}
function rn(e, t) {
  var s, l, c, u;
  const n = Qr(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = he(e), a = o.getDay(), i = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - i), o.setHours(0, 0, 0, 0), o;
}
function ar(e) {
  return rn(e, { weekStartsOn: 1 });
}
function ev(e) {
  const t = he(e), n = t.getFullYear(), r = wt(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = ar(r), a = wt(e, 0);
  a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0);
  const i = ar(a);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function Lr(e) {
  const t = he(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Fr(e) {
  const t = he(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Jt(e, t) {
  const n = Lr(e), r = Lr(t), o = +n - Fr(n), a = +r - Fr(r);
  return Math.round((o - a) / AP);
}
function LP(e) {
  const t = ev(e), n = wt(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), ar(n);
}
function Ll(e, t) {
  const n = t * 7;
  return ct(e, n);
}
function FP(e, t) {
  return zt(e, t * 12);
}
function zP(e) {
  let t;
  return e.forEach(function(n) {
    const r = he(n);
    (t === void 0 || t < r || isNaN(Number(r))) && (t = r);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function VP(e) {
  let t;
  return e.forEach((n) => {
    const r = he(n);
    (!t || t > r || isNaN(+r)) && (t = r);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function ei(e, t) {
  const n = he(e), r = he(t), o = n.getTime() - r.getTime();
  return o < 0 ? -1 : o > 0 ? 1 : o;
}
function BP(e) {
  return wt(e, Date.now());
}
function gt(e, t) {
  const n = Lr(e), r = Lr(t);
  return +n == +r;
}
function vu(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function tv(e) {
  if (!vu(e) && typeof e != "number")
    return !1;
  const t = he(e);
  return !isNaN(Number(t));
}
function zr(e, t) {
  const n = he(e), r = he(t), o = n.getFullYear() - r.getFullYear(), a = n.getMonth() - r.getMonth();
  return o * 12 + a;
}
function HP(e, t, n) {
  const r = rn(e, n), o = rn(t, n), a = +r - Fr(r), i = +o - Fr(o);
  return Math.round((a - i) / hu);
}
function WP(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function jP(e, t) {
  return +he(e) - +he(t);
}
function GP(e) {
  const t = he(e);
  return t.setHours(23, 59, 59, 999), t;
}
function qi(e) {
  const t = he(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function UP(e) {
  const t = he(e);
  return +GP(t) == +qi(t);
}
function qP(e, t) {
  const n = he(e), r = he(t), o = ei(n, r), a = Math.abs(
    zr(n, r)
  );
  let i;
  if (a < 1)
    i = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - o * a);
    let s = ei(n, r) === -o;
    UP(he(e)) && a === 1 && ei(e, r) === 1 && (s = !1), i = o * (a - Number(s));
  }
  return i === 0 ? 0 : i;
}
function YP(e, t, n) {
  const r = jP(e, t) / 1e3;
  return WP(n == null ? void 0 : n.roundingMethod)(r);
}
function vt(e) {
  const t = he(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function nv(e) {
  const t = he(e), n = wt(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function wu(e, t) {
  var s, l, c, u;
  const n = Qr(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = he(e), a = o.getDay(), i = (a < r ? -7 : 0) + 6 - (a - r);
  return o.setDate(o.getDate() + i), o.setHours(23, 59, 59, 999), o;
}
function rv(e) {
  return wu(e, { weekStartsOn: 1 });
}
const KP = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, XP = (e, t, n) => {
  let r;
  const o = KP[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Fs(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const JP = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, QP = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ZP = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, eN = {
  date: Fs({
    formats: JP,
    defaultWidth: "full"
  }),
  time: Fs({
    formats: QP,
    defaultWidth: "full"
  }),
  dateTime: Fs({
    formats: ZP,
    defaultWidth: "full"
  })
}, tN = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, nN = (e, t, n, r) => tN[e];
function uo(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : i;
      o = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[i];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[a];
  };
}
const rN = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, oN = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, aN = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, iN = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, sN = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, lN = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, cN = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, uN = {
  ordinalNumber: cN,
  era: uo({
    values: rN,
    defaultWidth: "wide"
  }),
  quarter: uo({
    values: oN,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: uo({
    values: aN,
    defaultWidth: "wide"
  }),
  day: uo({
    values: iN,
    defaultWidth: "wide"
  }),
  dayPeriod: uo({
    values: sN,
    defaultWidth: "wide",
    formattingValues: lN,
    defaultFormattingWidth: "wide"
  })
};
function fo(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    const i = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? fN(s, (d) => d.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      dN(s, (d) => d.test(i))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = t.slice(i.length);
    return { value: c, rest: u };
  };
}
function dN(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function fN(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function pN(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const s = t.slice(o.length);
    return { value: i, rest: s };
  };
}
const mN = /^(\d+)(th|st|nd|rd)?/i, gN = /\d+/i, hN = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, vN = {
  any: [/^b/i, /^(a|c)/i]
}, wN = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, bN = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, yN = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, xN = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, SN = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, CN = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, EN = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, kN = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, RN = {
  ordinalNumber: pN({
    matchPattern: mN,
    parsePattern: gN,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: fo({
    matchPatterns: hN,
    defaultMatchWidth: "wide",
    parsePatterns: vN,
    defaultParseWidth: "any"
  }),
  quarter: fo({
    matchPatterns: wN,
    defaultMatchWidth: "wide",
    parsePatterns: bN,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: fo({
    matchPatterns: yN,
    defaultMatchWidth: "wide",
    parsePatterns: xN,
    defaultParseWidth: "any"
  }),
  day: fo({
    matchPatterns: SN,
    defaultMatchWidth: "wide",
    parsePatterns: CN,
    defaultParseWidth: "any"
  }),
  dayPeriod: fo({
    matchPatterns: EN,
    defaultMatchWidth: "any",
    parsePatterns: kN,
    defaultParseWidth: "any"
  })
}, bu = {
  code: "en-US",
  formatDistance: XP,
  formatLong: eN,
  formatRelative: nN,
  localize: uN,
  match: RN,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function PN(e) {
  const t = he(e);
  return Jt(t, nv(t)) + 1;
}
function ov(e) {
  const t = he(e), n = +ar(t) - +LP(t);
  return Math.round(n / hu) + 1;
}
function av(e, t) {
  var u, d, f, p;
  const n = he(e), r = n.getFullYear(), o = Qr(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((p = (f = o.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, i = wt(e, 0);
  i.setFullYear(r + 1, 0, a), i.setHours(0, 0, 0, 0);
  const s = rn(i, t), l = wt(e, 0);
  l.setFullYear(r, 0, a), l.setHours(0, 0, 0, 0);
  const c = rn(l, t);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= c.getTime() ? r : r - 1;
}
function NN(e, t) {
  var s, l, c, u;
  const n = Qr(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, o = av(e, t), a = wt(e, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), rn(a, t);
}
function iv(e, t) {
  const n = he(e), r = +rn(n, t) - +NN(n, t);
  return Math.round(r / hu) + 1;
}
function Ae(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const xn = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Ae(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Ae(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Ae(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Ae(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Ae(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Ae(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Ae(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Ae(o, t.length);
  }
}, yr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, nf = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return xn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = av(e, r), a = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const i = a % 100;
      return Ae(i, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : Ae(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = ev(e);
    return Ae(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Ae(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return Ae(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return Ae(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return xn.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return Ae(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = iv(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Ae(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = ov(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Ae(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : xn.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = PN(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Ae(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(a);
      case "ee":
        return Ae(a, 2);
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(a);
      case "cc":
        return Ae(a, t.length);
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return Ae(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = yr.noon : r === 0 ? o = yr.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = yr.evening : r >= 12 ? o = yr.afternoon : r >= 4 ? o = yr.morning : o = yr.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return xn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : xn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Ae(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Ae(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : xn.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : xn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return xn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return of(r);
      case "XXXX":
      case "XX":
        return qn(r);
      case "XXXXX":
      case "XXX":
      default:
        return qn(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return of(r);
      case "xxxx":
      case "xx":
        return qn(r);
      case "xxxxx":
      case "xxx":
      default:
        return qn(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + rf(r, ":");
      case "OOOO":
      default:
        return "GMT" + qn(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + rf(r, ":");
      case "zzzz":
      default:
        return "GMT" + qn(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return Ae(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return Ae(r, t.length);
  }
};
function rf(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(o) : n + String(o) + t + Ae(a, 2);
}
function of(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Ae(Math.abs(e) / 60, 2) : qn(e, t);
}
function qn(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Ae(Math.trunc(r / 60), 2), a = Ae(r % 60, 2);
  return n + o + t + a;
}
const af = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, sv = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, TN = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return af(e, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", af(r, t)).replace("{{time}}", sv(o, t));
}, _N = {
  p: sv,
  P: TN
}, IN = /^D+$/, MN = /^Y+$/, ON = ["D", "DD", "YY", "YYYY"];
function DN(e) {
  return IN.test(e);
}
function AN(e) {
  return MN.test(e);
}
function $N(e, t, n) {
  const r = LN(e, t, n);
  if (console.warn(r), ON.includes(e)) throw new RangeError(r);
}
function LN(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const FN = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, zN = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, VN = /^'([^]*?)'?$/, BN = /''/g, HN = /[a-zA-Z]/;
function Bn(e, t, n) {
  var u, d, f, p, h, g, w, b;
  const r = Qr(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? bu, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((p = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, i = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (h = n == null ? void 0 : n.locale) == null ? void 0 : h.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((b = (w = r.locale) == null ? void 0 : w.options) == null ? void 0 : b.weekStartsOn) ?? 0, s = he(e);
  if (!tv(s))
    throw new RangeError("Invalid time value");
  let l = t.match(zN).map((y) => {
    const x = y[0];
    if (x === "p" || x === "P") {
      const C = _N[x];
      return C(y, o.formatLong);
    }
    return y;
  }).join("").match(FN).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const x = y[0];
    if (x === "'")
      return { isToken: !1, value: WN(y) };
    if (nf[x])
      return { isToken: !0, value: y };
    if (x.match(HN))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + x + "`"
      );
    return { isToken: !1, value: y };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: o
  };
  return l.map((y) => {
    if (!y.isToken) return y.value;
    const x = y.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && AN(x) || !(n != null && n.useAdditionalDayOfYearTokens) && DN(x)) && $N(x, t, String(e));
    const C = nf[x[0]];
    return C(s, x, o.localize, c);
  }).join("");
}
function WN(e) {
  const t = e.match(VN);
  return t ? t[1].replace(BN, "'") : e;
}
function jN(e, t, n) {
  const r = Qr(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? bu, a = 2520, i = ei(e, t);
  if (isNaN(i))
    throw new RangeError("Invalid time value");
  const s = Object.assign({}, n, {
    addSuffix: n == null ? void 0 : n.addSuffix,
    comparison: i
  });
  let l, c;
  i > 0 ? (l = he(t), c = he(e)) : (l = he(e), c = he(t));
  const u = YP(c, l), d = (Fr(c) - Fr(l)) / 1e3, f = Math.round((u - d) / 60);
  let p;
  if (f < 2)
    return n != null && n.includeSeconds ? u < 5 ? o.formatDistance("lessThanXSeconds", 5, s) : u < 10 ? o.formatDistance("lessThanXSeconds", 10, s) : u < 20 ? o.formatDistance("lessThanXSeconds", 20, s) : u < 40 ? o.formatDistance("halfAMinute", 0, s) : u < 60 ? o.formatDistance("lessThanXMinutes", 1, s) : o.formatDistance("xMinutes", 1, s) : f === 0 ? o.formatDistance("lessThanXMinutes", 1, s) : o.formatDistance("xMinutes", f, s);
  if (f < 45)
    return o.formatDistance("xMinutes", f, s);
  if (f < 90)
    return o.formatDistance("aboutXHours", 1, s);
  if (f < tf) {
    const h = Math.round(f / 60);
    return o.formatDistance("aboutXHours", h, s);
  } else {
    if (f < a)
      return o.formatDistance("xDays", 1, s);
    if (f < za) {
      const h = Math.round(f / tf);
      return o.formatDistance("xDays", h, s);
    } else if (f < za * 2)
      return p = Math.round(f / za), o.formatDistance("aboutXMonths", p, s);
  }
  if (p = qP(c, l), p < 12) {
    const h = Math.round(f / za);
    return o.formatDistance("xMonths", h, s);
  } else {
    const h = p % 12, g = Math.trunc(p / 12);
    return h < 3 ? o.formatDistance("aboutXYears", g, s) : h < 9 ? o.formatDistance("overXYears", g, s) : o.formatDistance("almostXYears", g + 1, s);
  }
}
function GN(e, t) {
  return jN(e, BP(e), t);
}
function UN(e) {
  const t = he(e), n = t.getFullYear(), r = t.getMonth(), o = wt(e, 0);
  return o.setFullYear(n, r + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function qN(e) {
  return Math.trunc(+he(e) / 1e3);
}
function YN(e) {
  const t = he(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function KN(e, t) {
  return HP(
    YN(e),
    vt(e),
    t
  ) + 1;
}
function Fl(e, t) {
  const n = he(e), r = he(t);
  return n.getTime() > r.getTime();
}
function lv(e, t) {
  const n = he(e), r = he(t);
  return +n < +r;
}
function yu(e, t) {
  const n = he(e), r = he(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function XN(e, t) {
  const n = he(e), r = he(t);
  return n.getFullYear() === r.getFullYear();
}
function zs(e, t) {
  return ct(e, -t);
}
function Vs(e, t) {
  const n = he(e), r = n.getFullYear(), o = n.getDate(), a = wt(e, 0);
  a.setFullYear(r, t, 15), a.setHours(0, 0, 0, 0);
  const i = UN(a);
  return n.setMonth(t, Math.min(o, i)), n;
}
function sf(e, t) {
  const n = he(e);
  return isNaN(+n) ? wt(e, NaN) : (n.setFullYear(t), n);
}
var ge = function() {
  return ge = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, ge.apply(this, arguments);
};
function JN(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function cv(e, t, n) {
  for (var r = 0, o = t.length, a; r < o; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function pa(e) {
  return e.mode === "multiple";
}
function ma(e) {
  return e.mode === "range";
}
function Yi(e) {
  return e.mode === "single";
}
var QN = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function ZN(e, t) {
  return Bn(e, "LLLL y", t);
}
function eT(e, t) {
  return Bn(e, "d", t);
}
function tT(e, t) {
  return Bn(e, "LLLL", t);
}
function nT(e) {
  return "".concat(e);
}
function rT(e, t) {
  return Bn(e, "cccccc", t);
}
function oT(e, t) {
  return Bn(e, "yyyy", t);
}
var aT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: ZN,
  formatDay: eT,
  formatMonthCaption: tT,
  formatWeekNumber: nT,
  formatWeekdayName: rT,
  formatYearCaption: oT
}), iT = function(e, t, n) {
  return Bn(e, "do MMMM (EEEE)", n);
}, sT = function() {
  return "Month: ";
}, lT = function() {
  return "Go to next month";
}, cT = function() {
  return "Go to previous month";
}, uT = function(e, t) {
  return Bn(e, "cccc", t);
}, dT = function(e) {
  return "Week n. ".concat(e);
}, fT = function() {
  return "Year: ";
}, pT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: iT,
  labelMonthDropdown: sT,
  labelNext: lT,
  labelPrevious: cT,
  labelWeekNumber: dT,
  labelWeekday: uT,
  labelYearDropdown: fT
});
function mT() {
  var e = "buttons", t = QN, n = bu, r = {}, o = {}, a = 1, i = {}, s = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: aT,
    labels: pT,
    locale: n,
    modifiersClassNames: r,
    modifiers: o,
    numberOfMonths: a,
    styles: i,
    today: s,
    mode: "default"
  };
}
function gT(e) {
  var t = e.fromYear, n = e.toYear, r = e.fromMonth, o = e.toMonth, a = e.fromDate, i = e.toDate;
  return r ? a = vt(r) : t && (a = new Date(t, 0, 1)), o ? i = qi(o) : n && (i = new Date(n, 11, 31)), {
    fromDate: a ? Lr(a) : void 0,
    toDate: i ? Lr(i) : void 0
  };
}
var uv = bt(void 0);
function hT(e) {
  var t, n = e.initialProps, r = mT(), o = gT(n), a = o.fromDate, i = o.toDate, s = (t = n.captionLayout) !== null && t !== void 0 ? t : r.captionLayout;
  s !== "buttons" && (!a || !i) && (s = "buttons");
  var l;
  (Yi(n) || pa(n) || ma(n)) && (l = n.onSelect);
  var c = ge(ge(ge({}, r), n), { captionLayout: s, classNames: ge(ge({}, r.classNames), n.classNames), components: ge({}, n.components), formatters: ge(ge({}, r.formatters), n.formatters), fromDate: a, labels: ge(ge({}, r.labels), n.labels), mode: n.mode || r.mode, modifiers: ge(ge({}, r.modifiers), n.modifiers), modifiersClassNames: ge(ge({}, r.modifiersClassNames), n.modifiersClassNames), onSelect: l, styles: ge(ge({}, r.styles), n.styles), toDate: i });
  return m(uv.Provider, { value: c, children: e.children });
}
function $e() {
  var e = Xe(uv);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function dv(e) {
  var t = $e(), n = t.locale, r = t.classNames, o = t.styles, a = t.formatters.formatCaption;
  return m("div", { className: r.caption_label, style: o.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: a(e.displayMonth, { locale: n }) });
}
function vT(e) {
  return m("svg", ge({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: m("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function fv(e) {
  var t, n, r = e.onChange, o = e.value, a = e.children, i = e.caption, s = e.className, l = e.style, c = $e(), u = (n = (t = c.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && n !== void 0 ? n : vT;
  return ee("div", { className: s, style: l, children: [m("span", { className: c.classNames.vhidden, children: e["aria-label"] }), m("select", { name: e.name, "aria-label": e["aria-label"], className: c.classNames.dropdown, style: c.styles.dropdown, value: o, onChange: r, children: a }), ee("div", { className: c.classNames.caption_label, style: c.styles.caption_label, "aria-hidden": "true", children: [i, m(u, { className: c.classNames.dropdown_icon, style: c.styles.dropdown_icon })] })] });
}
function wT(e) {
  var t, n = $e(), r = n.fromDate, o = n.toDate, a = n.styles, i = n.locale, s = n.formatters.formatMonthCaption, l = n.classNames, c = n.components, u = n.labels.labelMonthDropdown;
  if (!r)
    return m(Ne, {});
  if (!o)
    return m(Ne, {});
  var d = [];
  if (XN(r, o))
    for (var f = vt(r), p = r.getMonth(); p <= o.getMonth(); p++)
      d.push(Vs(f, p));
  else
    for (var f = vt(/* @__PURE__ */ new Date()), p = 0; p <= 11; p++)
      d.push(Vs(f, p));
  var h = function(w) {
    var b = Number(w.target.value), y = Vs(vt(e.displayMonth), b);
    e.onChange(y);
  }, g = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : fv;
  return m(g, { name: "months", "aria-label": u(), className: l.dropdown_month, style: a.dropdown_month, onChange: h, value: e.displayMonth.getMonth(), caption: s(e.displayMonth, { locale: i }), children: d.map(function(w) {
    return m("option", { value: w.getMonth(), children: s(w, { locale: i }) }, w.getMonth());
  }) });
}
function bT(e) {
  var t, n = e.displayMonth, r = $e(), o = r.fromDate, a = r.toDate, i = r.locale, s = r.styles, l = r.classNames, c = r.components, u = r.formatters.formatYearCaption, d = r.labels.labelYearDropdown, f = [];
  if (!o)
    return m(Ne, {});
  if (!a)
    return m(Ne, {});
  for (var p = o.getFullYear(), h = a.getFullYear(), g = p; g <= h; g++)
    f.push(sf(nv(/* @__PURE__ */ new Date()), g));
  var w = function(y) {
    var x = sf(vt(n), Number(y.target.value));
    e.onChange(x);
  }, b = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : fv;
  return m(b, { name: "years", "aria-label": d(), className: l.dropdown_year, style: s.dropdown_year, onChange: w, value: n.getFullYear(), caption: u(n, { locale: i }), children: f.map(function(y) {
    return m("option", { value: y.getFullYear(), children: u(y, { locale: i }) }, y.getFullYear());
  }) });
}
function yT(e, t) {
  var n = ye(e), r = n[0], o = n[1], a = t === void 0 ? r : t;
  return [a, o];
}
function xT(e) {
  var t = e.month, n = e.defaultMonth, r = e.today, o = t || n || r || /* @__PURE__ */ new Date(), a = e.toDate, i = e.fromDate, s = e.numberOfMonths, l = s === void 0 ? 1 : s;
  if (a && zr(a, o) < 0) {
    var c = -1 * (l - 1);
    o = zt(a, c);
  }
  return i && zr(o, i) < 0 && (o = i), vt(o);
}
function ST() {
  var e = $e(), t = xT(e), n = yT(t, e.month), r = n[0], o = n[1], a = function(i) {
    var s;
    if (!e.disableNavigation) {
      var l = vt(i);
      o(l), (s = e.onMonthChange) === null || s === void 0 || s.call(e, l);
    }
  };
  return [r, a];
}
function CT(e, t) {
  for (var n = t.reverseMonths, r = t.numberOfMonths, o = vt(e), a = vt(zt(o, r)), i = zr(a, o), s = [], l = 0; l < i; l++) {
    var c = zt(o, l);
    s.push(c);
  }
  return n && (s = s.reverse()), s;
}
function ET(e, t) {
  if (!t.disableNavigation) {
    var n = t.toDate, r = t.pagedNavigation, o = t.numberOfMonths, a = o === void 0 ? 1 : o, i = r ? a : 1, s = vt(e);
    if (!n)
      return zt(s, i);
    var l = zr(n, e);
    if (!(l < a))
      return zt(s, i);
  }
}
function kT(e, t) {
  if (!t.disableNavigation) {
    var n = t.fromDate, r = t.pagedNavigation, o = t.numberOfMonths, a = o === void 0 ? 1 : o, i = r ? a : 1, s = vt(e);
    if (!n)
      return zt(s, -i);
    var l = zr(s, n);
    if (!(l <= 0))
      return zt(s, -i);
  }
}
var pv = bt(void 0);
function RT(e) {
  var t = $e(), n = ST(), r = n[0], o = n[1], a = CT(r, t), i = ET(r, t), s = kT(r, t), l = function(d) {
    return a.some(function(f) {
      return yu(d, f);
    });
  }, c = function(d, f) {
    l(d) || (f && lv(d, f) ? o(zt(d, 1 + t.numberOfMonths * -1)) : o(d));
  }, u = {
    currentMonth: r,
    displayMonths: a,
    goToMonth: o,
    goToDate: c,
    previousMonth: s,
    nextMonth: i,
    isDateDisplayed: l
  };
  return m(pv.Provider, { value: u, children: e.children });
}
function ga() {
  var e = Xe(pv);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function lf(e) {
  var t, n = $e(), r = n.classNames, o = n.styles, a = n.components, i = ga().goToMonth, s = function(u) {
    i(zt(u, e.displayIndex ? -e.displayIndex : 0));
  }, l = (t = a == null ? void 0 : a.CaptionLabel) !== null && t !== void 0 ? t : dv, c = m(l, { id: e.id, displayMonth: e.displayMonth });
  return ee("div", { className: r.caption_dropdowns, style: o.caption_dropdowns, children: [m("div", { className: r.vhidden, children: c }), m(wT, { onChange: s, displayMonth: e.displayMonth }), m(bT, { onChange: s, displayMonth: e.displayMonth })] });
}
function PT(e) {
  return m("svg", ge({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: m("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function NT(e) {
  return m("svg", ge({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: m("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var gi = q(function(e, t) {
  var n = $e(), r = n.classNames, o = n.styles, a = [r.button_reset, r.button];
  e.className && a.push(e.className);
  var i = a.join(" "), s = ge(ge({}, o.button_reset), o.button);
  return e.style && Object.assign(s, e.style), m("button", ge({}, e, { ref: t, type: "button", className: i, style: s }));
});
function TT(e) {
  var t, n, r = $e(), o = r.dir, a = r.locale, i = r.classNames, s = r.styles, l = r.labels, c = l.labelPrevious, u = l.labelNext, d = r.components;
  if (!e.nextMonth && !e.previousMonth)
    return m(Ne, {});
  var f = c(e.previousMonth, { locale: a }), p = [
    i.nav_button,
    i.nav_button_previous
  ].join(" "), h = u(e.nextMonth, { locale: a }), g = [
    i.nav_button,
    i.nav_button_next
  ].join(" "), w = (t = d == null ? void 0 : d.IconRight) !== null && t !== void 0 ? t : NT, b = (n = d == null ? void 0 : d.IconLeft) !== null && n !== void 0 ? n : PT;
  return ee("div", { className: i.nav, style: s.nav, children: [!e.hidePrevious && m(gi, { name: "previous-month", "aria-label": f, className: p, style: s.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: o === "rtl" ? m(w, { className: i.nav_icon, style: s.nav_icon }) : m(b, { className: i.nav_icon, style: s.nav_icon }) }), !e.hideNext && m(gi, { name: "next-month", "aria-label": h, className: g, style: s.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: o === "rtl" ? m(b, { className: i.nav_icon, style: s.nav_icon }) : m(w, { className: i.nav_icon, style: s.nav_icon }) })] });
}
function cf(e) {
  var t = $e().numberOfMonths, n = ga(), r = n.previousMonth, o = n.nextMonth, a = n.goToMonth, i = n.displayMonths, s = i.findIndex(function(h) {
    return yu(e.displayMonth, h);
  }), l = s === 0, c = s === i.length - 1, u = t > 1 && (l || !c), d = t > 1 && (c || !l), f = function() {
    r && a(r);
  }, p = function() {
    o && a(o);
  };
  return m(TT, { displayMonth: e.displayMonth, hideNext: u, hidePrevious: d, nextMonth: o, previousMonth: r, onPreviousClick: f, onNextClick: p });
}
function _T(e) {
  var t, n = $e(), r = n.classNames, o = n.disableNavigation, a = n.styles, i = n.captionLayout, s = n.components, l = (t = s == null ? void 0 : s.CaptionLabel) !== null && t !== void 0 ? t : dv, c;
  return o ? c = m(l, { id: e.id, displayMonth: e.displayMonth }) : i === "dropdown" ? c = m(lf, { displayMonth: e.displayMonth, id: e.id }) : i === "dropdown-buttons" ? c = ee(Ne, { children: [m(lf, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), m(cf, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : c = ee(Ne, { children: [m(l, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), m(cf, { displayMonth: e.displayMonth, id: e.id })] }), m("div", { className: r.caption, style: a.caption, children: c });
}
function IT(e) {
  var t = $e(), n = t.footer, r = t.styles, o = t.classNames.tfoot;
  return n ? m("tfoot", { className: o, style: r.tfoot, children: m("tr", { children: m("td", { colSpan: 8, children: n }) }) }) : m(Ne, {});
}
function MT(e, t, n) {
  for (var r = n ? ar(/* @__PURE__ */ new Date()) : rn(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), o = [], a = 0; a < 7; a++) {
    var i = ct(r, a);
    o.push(i);
  }
  return o;
}
function OT() {
  var e = $e(), t = e.classNames, n = e.styles, r = e.showWeekNumber, o = e.locale, a = e.weekStartsOn, i = e.ISOWeek, s = e.formatters.formatWeekdayName, l = e.labels.labelWeekday, c = MT(o, a, i);
  return ee("tr", { style: n.head_row, className: t.head_row, children: [r && m("td", { style: n.head_cell, className: t.head_cell }), c.map(function(u, d) {
    return m("th", { scope: "col", className: t.head_cell, style: n.head_cell, "aria-label": l(u, { locale: o }), children: s(u, { locale: o }) }, d);
  })] });
}
function DT() {
  var e, t = $e(), n = t.classNames, r = t.styles, o = t.components, a = (e = o == null ? void 0 : o.HeadRow) !== null && e !== void 0 ? e : OT;
  return m("thead", { style: r.head, className: n.head, children: m(a, {}) });
}
function AT(e) {
  var t = $e(), n = t.locale, r = t.formatters.formatDay;
  return m(Ne, { children: r(e.date, { locale: n }) });
}
var xu = bt(void 0);
function $T(e) {
  if (!pa(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return m(xu.Provider, { value: t, children: e.children });
  }
  return m(LT, { initialProps: e.initialProps, children: e.children });
}
function LT(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = t.min, a = t.max, i = function(c, u, d) {
    var f, p;
    (f = t.onDayClick) === null || f === void 0 || f.call(t, c, u, d);
    var h = !!(u.selected && o && (r == null ? void 0 : r.length) === o);
    if (!h) {
      var g = !!(!u.selected && a && (r == null ? void 0 : r.length) === a);
      if (!g) {
        var w = r ? cv([], r) : [];
        if (u.selected) {
          var b = w.findIndex(function(y) {
            return gt(c, y);
          });
          w.splice(b, 1);
        } else
          w.push(c);
        (p = t.onSelect) === null || p === void 0 || p.call(t, w, c, u, d);
      }
    }
  }, s = {
    disabled: []
  };
  r && s.disabled.push(function(c) {
    var u = a && r.length > a - 1, d = r.some(function(f) {
      return gt(f, c);
    });
    return !!(u && !d);
  });
  var l = {
    selected: r,
    onDayClick: i,
    modifiers: s
  };
  return m(xu.Provider, { value: l, children: n });
}
function Su() {
  var e = Xe(xu);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function FT(e, t) {
  var n = t || {}, r = n.from, o = n.to;
  return r && o ? gt(o, e) && gt(r, e) ? void 0 : gt(o, e) ? { from: o, to: void 0 } : gt(r, e) ? void 0 : Fl(r, e) ? { from: e, to: o } : { from: r, to: e } : o ? Fl(e, o) ? { from: o, to: e } : { from: e, to: o } : r ? lv(e, r) ? { from: e, to: r } : { from: r, to: e } : { from: e, to: void 0 };
}
var Cu = bt(void 0);
function zT(e) {
  if (!ma(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return m(Cu.Provider, { value: t, children: e.children });
  }
  return m(VT, { initialProps: e.initialProps, children: e.children });
}
function VT(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = r || {}, a = o.from, i = o.to, s = t.min, l = t.max, c = function(p, h, g) {
    var w, b;
    (w = t.onDayClick) === null || w === void 0 || w.call(t, p, h, g);
    var y = FT(p, r);
    (b = t.onSelect) === null || b === void 0 || b.call(t, y, p, h, g);
  }, u = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (a ? (u.range_start = [a], i ? (u.range_end = [i], gt(a, i) || (u.range_middle = [
    {
      after: a,
      before: i
    }
  ])) : u.range_end = [a]) : i && (u.range_start = [i], u.range_end = [i]), s && (a && !i && u.disabled.push({
    after: zs(a, s - 1),
    before: ct(a, s - 1)
  }), a && i && u.disabled.push({
    after: a,
    before: ct(a, s - 1)
  }), !a && i && u.disabled.push({
    after: zs(i, s - 1),
    before: ct(i, s - 1)
  })), l) {
    if (a && !i && (u.disabled.push({
      before: ct(a, -l + 1)
    }), u.disabled.push({
      after: ct(a, l - 1)
    })), a && i) {
      var d = Jt(i, a) + 1, f = l - d;
      u.disabled.push({
        before: zs(a, f)
      }), u.disabled.push({
        after: ct(i, f)
      });
    }
    !a && i && (u.disabled.push({
      before: ct(i, -l + 1)
    }), u.disabled.push({
      after: ct(i, l - 1)
    }));
  }
  return m(Cu.Provider, { value: { selected: r, onDayClick: c, modifiers: u }, children: n });
}
function Eu() {
  var e = Xe(Cu);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function ti(e) {
  return Array.isArray(e) ? cv([], e) : e !== void 0 ? [e] : [];
}
function BT(e) {
  var t = {};
  return Object.entries(e).forEach(function(n) {
    var r = n[0], o = n[1];
    t[r] = ti(o);
  }), t;
}
var Vt;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(Vt || (Vt = {}));
var HT = Vt.Selected, un = Vt.Disabled, WT = Vt.Hidden, jT = Vt.Today, Bs = Vt.RangeEnd, Hs = Vt.RangeMiddle, Ws = Vt.RangeStart, GT = Vt.Outside;
function UT(e, t, n) {
  var r, o = (r = {}, r[HT] = ti(e.selected), r[un] = ti(e.disabled), r[WT] = ti(e.hidden), r[jT] = [e.today], r[Bs] = [], r[Hs] = [], r[Ws] = [], r[GT] = [], r);
  return e.fromDate && o[un].push({ before: e.fromDate }), e.toDate && o[un].push({ after: e.toDate }), pa(e) ? o[un] = o[un].concat(t.modifiers[un]) : ma(e) && (o[un] = o[un].concat(n.modifiers[un]), o[Ws] = n.modifiers[Ws], o[Hs] = n.modifiers[Hs], o[Bs] = n.modifiers[Bs]), o;
}
var mv = bt(void 0);
function qT(e) {
  var t = $e(), n = Su(), r = Eu(), o = UT(t, n, r), a = BT(t.modifiers), i = ge(ge({}, o), a);
  return m(mv.Provider, { value: i, children: e.children });
}
function gv() {
  var e = Xe(mv);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function YT(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function KT(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function XT(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function JT(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function QT(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function ZT(e, t) {
  var n, r = t.from, o = t.to;
  if (r && o) {
    var a = Jt(o, r) < 0;
    a && (n = [o, r], r = n[0], o = n[1]);
    var i = Jt(e, r) >= 0 && Jt(o, e) >= 0;
    return i;
  }
  return o ? gt(o, e) : r ? gt(r, e) : !1;
}
function e_(e) {
  return vu(e);
}
function t_(e) {
  return Array.isArray(e) && e.every(vu);
}
function n_(e, t) {
  return t.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (e_(n))
      return gt(e, n);
    if (t_(n))
      return n.includes(e);
    if (KT(n))
      return ZT(e, n);
    if (QT(n))
      return n.dayOfWeek.includes(e.getDay());
    if (YT(n)) {
      var r = Jt(n.before, e), o = Jt(n.after, e), a = r > 0, i = o < 0, s = Fl(n.before, n.after);
      return s ? i && a : a || i;
    }
    return XT(n) ? Jt(e, n.after) > 0 : JT(n) ? Jt(n.before, e) > 0 : typeof n == "function" ? n(e) : !1;
  });
}
function ku(e, t, n) {
  var r = Object.keys(t).reduce(function(a, i) {
    var s = t[i];
    return n_(e, s) && a.push(i), a;
  }, []), o = {};
  return r.forEach(function(a) {
    return o[a] = !0;
  }), n && !yu(e, n) && (o.outside = !0), o;
}
function r_(e, t) {
  for (var n = vt(e[0]), r = qi(e[e.length - 1]), o, a, i = n; i <= r; ) {
    var s = ku(i, t), l = !s.disabled && !s.hidden;
    if (!l) {
      i = ct(i, 1);
      continue;
    }
    if (s.selected)
      return i;
    s.today && !a && (a = i), o || (o = i), i = ct(i, 1);
  }
  return a || o;
}
var o_ = 365;
function hv(e, t) {
  var n = t.moveBy, r = t.direction, o = t.context, a = t.modifiers, i = t.retry, s = i === void 0 ? { count: 0, lastFocused: e } : i, l = o.weekStartsOn, c = o.fromDate, u = o.toDate, d = o.locale, f = {
    day: ct,
    week: Ll,
    month: zt,
    year: FP,
    startOfWeek: function(w) {
      return o.ISOWeek ? ar(w) : rn(w, { locale: d, weekStartsOn: l });
    },
    endOfWeek: function(w) {
      return o.ISOWeek ? rv(w) : wu(w, { locale: d, weekStartsOn: l });
    }
  }, p = f[n](e, r === "after" ? 1 : -1);
  r === "before" && c ? p = zP([c, p]) : r === "after" && u && (p = VP([u, p]));
  var h = !0;
  if (a) {
    var g = ku(p, a);
    h = !g.disabled && !g.hidden;
  }
  return h ? p : s.count > o_ ? s.lastFocused : hv(p, {
    moveBy: n,
    direction: r,
    context: o,
    modifiers: a,
    retry: ge(ge({}, s), { count: s.count + 1 })
  });
}
var vv = bt(void 0);
function a_(e) {
  var t = ga(), n = gv(), r = ye(), o = r[0], a = r[1], i = ye(), s = i[0], l = i[1], c = r_(t.displayMonths, n), u = o ?? (s && t.isDateDisplayed(s)) ? s : c, d = function() {
    l(o), a(void 0);
  }, f = function(w) {
    a(w);
  }, p = $e(), h = function(w, b) {
    if (o) {
      var y = hv(o, {
        moveBy: w,
        direction: b,
        context: p,
        modifiers: n
      });
      gt(o, y) || (t.goToDate(y, o), f(y));
    }
  }, g = {
    focusedDay: o,
    focusTarget: u,
    blur: d,
    focus: f,
    focusDayAfter: function() {
      return h("day", "after");
    },
    focusDayBefore: function() {
      return h("day", "before");
    },
    focusWeekAfter: function() {
      return h("week", "after");
    },
    focusWeekBefore: function() {
      return h("week", "before");
    },
    focusMonthBefore: function() {
      return h("month", "before");
    },
    focusMonthAfter: function() {
      return h("month", "after");
    },
    focusYearBefore: function() {
      return h("year", "before");
    },
    focusYearAfter: function() {
      return h("year", "after");
    },
    focusStartOfWeek: function() {
      return h("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return h("endOfWeek", "after");
    }
  };
  return m(vv.Provider, { value: g, children: e.children });
}
function Ru() {
  var e = Xe(vv);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function i_(e, t) {
  var n = gv(), r = ku(e, n, t);
  return r;
}
var Pu = bt(void 0);
function s_(e) {
  if (!Yi(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return m(Pu.Provider, { value: t, children: e.children });
  }
  return m(l_, { initialProps: e.initialProps, children: e.children });
}
function l_(e) {
  var t = e.initialProps, n = e.children, r = function(a, i, s) {
    var l, c, u;
    if ((l = t.onDayClick) === null || l === void 0 || l.call(t, a, i, s), i.selected && !t.required) {
      (c = t.onSelect) === null || c === void 0 || c.call(t, void 0, a, i, s);
      return;
    }
    (u = t.onSelect) === null || u === void 0 || u.call(t, a, a, i, s);
  }, o = {
    selected: t.selected,
    onDayClick: r
  };
  return m(Pu.Provider, { value: o, children: n });
}
function wv() {
  var e = Xe(Pu);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function c_(e, t) {
  var n = $e(), r = wv(), o = Su(), a = Eu(), i = Ru(), s = i.focusDayAfter, l = i.focusDayBefore, c = i.focusWeekAfter, u = i.focusWeekBefore, d = i.blur, f = i.focus, p = i.focusMonthBefore, h = i.focusMonthAfter, g = i.focusYearBefore, w = i.focusYearAfter, b = i.focusStartOfWeek, y = i.focusEndOfWeek, x = function(O) {
    var I, W, A, K;
    Yi(n) ? (I = r.onDayClick) === null || I === void 0 || I.call(r, e, t, O) : pa(n) ? (W = o.onDayClick) === null || W === void 0 || W.call(o, e, t, O) : ma(n) ? (A = a.onDayClick) === null || A === void 0 || A.call(a, e, t, O) : (K = n.onDayClick) === null || K === void 0 || K.call(n, e, t, O);
  }, C = function(O) {
    var I;
    f(e), (I = n.onDayFocus) === null || I === void 0 || I.call(n, e, t, O);
  }, S = function(O) {
    var I;
    d(), (I = n.onDayBlur) === null || I === void 0 || I.call(n, e, t, O);
  }, R = function(O) {
    var I;
    (I = n.onDayMouseEnter) === null || I === void 0 || I.call(n, e, t, O);
  }, E = function(O) {
    var I;
    (I = n.onDayMouseLeave) === null || I === void 0 || I.call(n, e, t, O);
  }, M = function(O) {
    var I;
    (I = n.onDayPointerEnter) === null || I === void 0 || I.call(n, e, t, O);
  }, F = function(O) {
    var I;
    (I = n.onDayPointerLeave) === null || I === void 0 || I.call(n, e, t, O);
  }, G = function(O) {
    var I;
    (I = n.onDayTouchCancel) === null || I === void 0 || I.call(n, e, t, O);
  }, U = function(O) {
    var I;
    (I = n.onDayTouchEnd) === null || I === void 0 || I.call(n, e, t, O);
  }, H = function(O) {
    var I;
    (I = n.onDayTouchMove) === null || I === void 0 || I.call(n, e, t, O);
  }, j = function(O) {
    var I;
    (I = n.onDayTouchStart) === null || I === void 0 || I.call(n, e, t, O);
  }, z = function(O) {
    var I;
    (I = n.onDayKeyUp) === null || I === void 0 || I.call(n, e, t, O);
  }, Z = function(O) {
    var I;
    switch (O.key) {
      case "ArrowLeft":
        O.preventDefault(), O.stopPropagation(), n.dir === "rtl" ? s() : l();
        break;
      case "ArrowRight":
        O.preventDefault(), O.stopPropagation(), n.dir === "rtl" ? l() : s();
        break;
      case "ArrowDown":
        O.preventDefault(), O.stopPropagation(), c();
        break;
      case "ArrowUp":
        O.preventDefault(), O.stopPropagation(), u();
        break;
      case "PageUp":
        O.preventDefault(), O.stopPropagation(), O.shiftKey ? g() : p();
        break;
      case "PageDown":
        O.preventDefault(), O.stopPropagation(), O.shiftKey ? w() : h();
        break;
      case "Home":
        O.preventDefault(), O.stopPropagation(), b();
        break;
      case "End":
        O.preventDefault(), O.stopPropagation(), y();
        break;
    }
    (I = n.onDayKeyDown) === null || I === void 0 || I.call(n, e, t, O);
  }, Y = {
    onClick: x,
    onFocus: C,
    onBlur: S,
    onKeyDown: Z,
    onKeyUp: z,
    onMouseEnter: R,
    onMouseLeave: E,
    onPointerEnter: M,
    onPointerLeave: F,
    onTouchCancel: G,
    onTouchEnd: U,
    onTouchMove: H,
    onTouchStart: j
  };
  return Y;
}
function u_() {
  var e = $e(), t = wv(), n = Su(), r = Eu(), o = Yi(e) ? t.selected : pa(e) ? n.selected : ma(e) ? r.selected : void 0;
  return o;
}
function d_(e) {
  return Object.values(Vt).includes(e);
}
function f_(e, t) {
  var n = [e.classNames.day];
  return Object.keys(t).forEach(function(r) {
    var o = e.modifiersClassNames[r];
    if (o)
      n.push(o);
    else if (d_(r)) {
      var a = e.classNames["day_".concat(r)];
      a && n.push(a);
    }
  }), n;
}
function p_(e, t) {
  var n = ge({}, e.styles.day);
  return Object.keys(t).forEach(function(r) {
    var o;
    n = ge(ge({}, n), (o = e.modifiersStyles) === null || o === void 0 ? void 0 : o[r]);
  }), n;
}
function m_(e, t, n) {
  var r, o, a, i = $e(), s = Ru(), l = i_(e, t), c = c_(e, l), u = u_(), d = !!(i.onDayClick || i.mode !== "default");
  ke(function() {
    var R;
    l.outside || s.focusedDay && d && gt(s.focusedDay, e) && ((R = n.current) === null || R === void 0 || R.focus());
  }, [
    s.focusedDay,
    e,
    n,
    d,
    l.outside
  ]);
  var f = f_(i, l).join(" "), p = p_(i, l), h = !!(l.outside && !i.showOutsideDays || l.hidden), g = (a = (o = i.components) === null || o === void 0 ? void 0 : o.DayContent) !== null && a !== void 0 ? a : AT, w = m(g, { date: e, displayMonth: t, activeModifiers: l }), b = {
    style: p,
    className: f,
    children: w,
    role: "gridcell"
  }, y = s.focusTarget && gt(s.focusTarget, e) && !l.outside, x = s.focusedDay && gt(s.focusedDay, e), C = ge(ge(ge({}, b), (r = { disabled: l.disabled, role: "gridcell" }, r["aria-selected"] = l.selected, r.tabIndex = x || y ? 0 : -1, r)), c), S = {
    isButton: d,
    isHidden: h,
    activeModifiers: l,
    selectedDays: u,
    buttonProps: C,
    divProps: b
  };
  return S;
}
function g_(e) {
  var t = qe(null), n = m_(e.date, e.displayMonth, t);
  return n.isHidden ? m("div", { role: "gridcell" }) : n.isButton ? m(gi, ge({ name: "day", ref: t }, n.buttonProps)) : m("div", ge({}, n.divProps));
}
function h_(e) {
  var t = e.number, n = e.dates, r = $e(), o = r.onWeekNumberClick, a = r.styles, i = r.classNames, s = r.locale, l = r.labels.labelWeekNumber, c = r.formatters.formatWeekNumber, u = c(Number(t), { locale: s });
  if (!o)
    return m("span", { className: i.weeknumber, style: a.weeknumber, children: u });
  var d = l(Number(t), { locale: s }), f = function(p) {
    o(t, n, p);
  };
  return m(gi, { name: "week-number", "aria-label": d, className: i.weeknumber, style: a.weeknumber, onClick: f, children: u });
}
function v_(e) {
  var t, n, r = $e(), o = r.styles, a = r.classNames, i = r.showWeekNumber, s = r.components, l = (t = s == null ? void 0 : s.Day) !== null && t !== void 0 ? t : g_, c = (n = s == null ? void 0 : s.WeekNumber) !== null && n !== void 0 ? n : h_, u;
  return i && (u = m("td", { className: a.cell, style: o.cell, children: m(c, { number: e.weekNumber, dates: e.dates }) })), ee("tr", { className: a.row, style: o.row, children: [u, e.dates.map(function(d) {
    return m("td", { className: a.cell, style: o.cell, role: "presentation", children: m(l, { displayMonth: e.displayMonth, date: d }) }, qN(d));
  })] });
}
function uf(e, t, n) {
  for (var r = n != null && n.ISOWeek ? rv(t) : wu(t, n), o = n != null && n.ISOWeek ? ar(e) : rn(e, n), a = Jt(r, o), i = [], s = 0; s <= a; s++)
    i.push(ct(o, s));
  var l = i.reduce(function(c, u) {
    var d = n != null && n.ISOWeek ? ov(u) : iv(u, n), f = c.find(function(p) {
      return p.weekNumber === d;
    });
    return f ? (f.dates.push(u), c) : (c.push({
      weekNumber: d,
      dates: [u]
    }), c);
  }, []);
  return l;
}
function w_(e, t) {
  var n = uf(vt(e), qi(e), t);
  if (t != null && t.useFixedWeeks) {
    var r = KN(e, t);
    if (r < 6) {
      var o = n[n.length - 1], a = o.dates[o.dates.length - 1], i = Ll(a, 6 - r), s = uf(Ll(a, 1), i, t);
      n.push.apply(n, s);
    }
  }
  return n;
}
function b_(e) {
  var t, n, r, o = $e(), a = o.locale, i = o.classNames, s = o.styles, l = o.hideHead, c = o.fixedWeeks, u = o.components, d = o.weekStartsOn, f = o.firstWeekContainsDate, p = o.ISOWeek, h = w_(e.displayMonth, {
    useFixedWeeks: !!c,
    ISOWeek: p,
    locale: a,
    weekStartsOn: d,
    firstWeekContainsDate: f
  }), g = (t = u == null ? void 0 : u.Head) !== null && t !== void 0 ? t : DT, w = (n = u == null ? void 0 : u.Row) !== null && n !== void 0 ? n : v_, b = (r = u == null ? void 0 : u.Footer) !== null && r !== void 0 ? r : IT;
  return ee("table", { id: e.id, className: i.table, style: s.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!l && m(g, {}), m("tbody", { className: i.tbody, style: s.tbody, children: h.map(function(y) {
    return m(w, { displayMonth: e.displayMonth, dates: y.dates, weekNumber: y.weekNumber }, y.weekNumber);
  }) }), m(b, { displayMonth: e.displayMonth })] });
}
function y_() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var x_ = y_() ? bc : ke, js = !1, S_ = 0;
function df() {
  return "react-day-picker-".concat(++S_);
}
function C_(e) {
  var t, n = e ?? (js ? df() : null), r = ye(n), o = r[0], a = r[1];
  return x_(function() {
    o === null && a(df());
  }, []), ke(function() {
    js === !1 && (js = !0);
  }, []), (t = e ?? o) !== null && t !== void 0 ? t : void 0;
}
function E_(e) {
  var t, n, r = $e(), o = r.dir, a = r.classNames, i = r.styles, s = r.components, l = ga().displayMonths, c = C_(r.id ? "".concat(r.id, "-").concat(e.displayIndex) : void 0), u = r.id ? "".concat(r.id, "-grid-").concat(e.displayIndex) : void 0, d = [a.month], f = i.month, p = e.displayIndex === 0, h = e.displayIndex === l.length - 1, g = !p && !h;
  o === "rtl" && (t = [p, h], h = t[0], p = t[1]), p && (d.push(a.caption_start), f = ge(ge({}, f), i.caption_start)), h && (d.push(a.caption_end), f = ge(ge({}, f), i.caption_end)), g && (d.push(a.caption_between), f = ge(ge({}, f), i.caption_between));
  var w = (n = s == null ? void 0 : s.Caption) !== null && n !== void 0 ? n : _T;
  return ee("div", { className: d.join(" "), style: f, children: [m(w, { id: c, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), m(b_, { id: u, "aria-labelledby": c, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function k_(e) {
  var t = $e(), n = t.classNames, r = t.styles;
  return m("div", { className: n.months, style: r.months, children: e.children });
}
function R_(e) {
  var t, n, r = e.initialProps, o = $e(), a = Ru(), i = ga(), s = ye(!1), l = s[0], c = s[1];
  ke(function() {
    o.initialFocus && a.focusTarget && (l || (a.focus(a.focusTarget), c(!0)));
  }, [
    o.initialFocus,
    l,
    a.focus,
    a.focusTarget,
    a
  ]);
  var u = [o.classNames.root, o.className];
  o.numberOfMonths > 1 && u.push(o.classNames.multiple_months), o.showWeekNumber && u.push(o.classNames.with_weeknumber);
  var d = ge(ge({}, o.styles.root), o.style), f = Object.keys(r).filter(function(h) {
    return h.startsWith("data-");
  }).reduce(function(h, g) {
    var w;
    return ge(ge({}, h), (w = {}, w[g] = r[g], w));
  }, {}), p = (n = (t = r.components) === null || t === void 0 ? void 0 : t.Months) !== null && n !== void 0 ? n : k_;
  return m("div", ge({ className: u.join(" "), style: d, dir: o.dir, id: o.id, nonce: r.nonce, title: r.title, lang: r.lang }, f, { children: m(p, { children: i.displayMonths.map(function(h, g) {
    return m(E_, { displayIndex: g, displayMonth: h }, g);
  }) }) }));
}
function P_(e) {
  var t = e.children, n = JN(e, ["children"]);
  return m(hT, { initialProps: n, children: m(RT, { children: m(s_, { initialProps: n, children: m($T, { initialProps: n, children: m(zT, { initialProps: n, children: m(qT, { children: m(a_, { children: t }) }) }) }) }) }) });
}
function N_(e) {
  return m(P_, ge({}, e, { children: m(R_, { initialProps: e }) }));
}
function T_({
  className: e,
  classNames: t,
  showOutsideDays: n = !0,
  ...r
}) {
  return /* @__PURE__ */ m(
    N_,
    {
      showOutsideDays: n,
      className: N("tw-p-3 tw-inline-flex", e),
      classNames: {
        months: "tw-flex tw-flex-col sm:tw-flex-row tw-space-y-4 sm:tw-space-x-4 sm:tw-space-y-0",
        month: "tw-space-y-4",
        caption: "tw-flex tw-justify-center tw-pt-1 tw-relative tw-items-center",
        caption_label: "tw-text-sm tw-font-medium",
        nav: "tw-space-x-1 tw-flex tw-items-center",
        nav_button: N(
          "tw-h-7 tw-w-7 tw-bg-transparent tw-p-0 tw-opacity-50 hover:tw-opacity-100"
        ),
        nav_button_previous: "tw-absolute tw-left-1",
        nav_button_next: "tw-absolute tw-right-1",
        table: "tw-w-full tw-border-collapse tw-space-y-1",
        head_row: "tw-flex",
        head_cell: "tw-rounded-md tw-w-9 tw-font-normal tw-text-[0.8rem] tw-cursor-default",
        row: "tw-flex tw-w-full tw-mt-2",
        cell: "tw-h-9 tw-w-9 tw-text-center tw-text-sm tw-p-0 tw-relative [&:has([aria-selected].day-range-end)]:tw-rounded-r-md [&:has([aria-selected].day-outside)]:tw-bg-blue-400 [&:has([aria-selected])]:tw-bg-accent first:[&:has([aria-selected])]:tw-rounded-l-md last:[&:has([aria-selected])]:tw-rounded-r-md focus-within:tw-relative focus-within:tw-z-20",
        day: N(
          "tw-h-9 tw-w-9 tw-rounded-sm tw-p-0 tw-font-normal aria-selected:tw-opacity-100"
        ),
        day_range_end: "day-range-end",
        day_selected: "tw-bg-blue-800 tw-text-white tw-rounded hover:tw-bg-blue-700 hover:tw-text-white focus:tw-bg-blue-500 focus:tw-text-white",
        day_today: "tw-bg-blue-700 tw-text-white",
        day_outside: "day-outside tw-text-gray-400 tw-opacity-50 aria-selected:tw-bg-blue-400 aria-selected:tw-text-gray-800 aria-selected:tw-opacity-30",
        day_disabled: "tw-text-gray-500 tw-opacity-50",
        day_range_middle: "aria-selected:tw-bg-blue-500 aria-selected:tw-text-white",
        day_hidden: "tw-invisible",
        ...t
      },
      components: {
        IconLeft: ({ ...o }) => /* @__PURE__ */ m(de, { ...o, icon: "chevron-left" }),
        IconRight: ({ ...o }) => /* @__PURE__ */ m(de, { ...o, icon: "chevron-right" })
      },
      ...r
    }
  );
}
T_.displayName = "Calendar";
const __ = {
  active: !0,
  breakpoints: {},
  delay: 4e3,
  jump: !1,
  playOnInit: !0,
  stopOnFocusIn: !0,
  stopOnInteraction: !0,
  stopOnMouseEnter: !1,
  stopOnLastSnap: !1,
  rootNode: null
};
function I_(e, t) {
  const n = e.scrollSnapList();
  return typeof t == "number" ? n.map(() => t) : t(n, e);
}
function M_(e, t) {
  const n = e.rootNode();
  return t && t(n) || n;
}
function Nu(e = {}) {
  let t, n, r, o, a = null, i = 0, s = !1, l = !1, c = !1, u = !1;
  function d(z, Z) {
    n = z;
    const {
      mergeOptions: Y,
      optionsAtMedia: O
    } = Z, I = Y(__, Nu.globalOptions), W = Y(I, e);
    if (t = O(W), n.scrollSnapList().length <= 1) return;
    u = t.jump, r = !1, o = I_(n, t.delay);
    const {
      eventStore: A,
      ownerDocument: K
    } = n.internalEngine(), k = !!n.internalEngine().options.watchDrag, $ = M_(n, t.rootNode);
    A.add(K, "visibilitychange", b), k && n.on("pointerDown", x), k && !t.stopOnInteraction && n.on("pointerUp", C), t.stopOnMouseEnter && A.add($, "mouseenter", S), t.stopOnMouseEnter && !t.stopOnInteraction && A.add($, "mouseleave", R), t.stopOnFocusIn && n.on("slideFocusStart", w), t.stopOnFocusIn && !t.stopOnInteraction && A.add(n.containerNode(), "focusout", g), t.playOnInit && g();
  }
  function f() {
    n.off("pointerDown", x).off("pointerUp", C).off("slideFocusStart", w), w(), r = !0, s = !1;
  }
  function p() {
    const {
      ownerWindow: z
    } = n.internalEngine();
    z.clearTimeout(i), i = z.setTimeout(U, o[n.selectedScrollSnap()]), a = (/* @__PURE__ */ new Date()).getTime(), n.emit("autoplay:timerset");
  }
  function h() {
    const {
      ownerWindow: z
    } = n.internalEngine();
    z.clearTimeout(i), i = 0, a = null, n.emit("autoplay:timerstopped");
  }
  function g() {
    if (!r) {
      if (y()) {
        c = !0;
        return;
      }
      s || n.emit("autoplay:play"), p(), s = !0;
    }
  }
  function w() {
    r || (s && n.emit("autoplay:stop"), h(), s = !1);
  }
  function b() {
    if (y())
      return c = s, w();
    c && g();
  }
  function y() {
    const {
      ownerDocument: z
    } = n.internalEngine();
    return z.visibilityState === "hidden";
  }
  function x() {
    l || w();
  }
  function C() {
    l || g();
  }
  function S() {
    l = !0, w();
  }
  function R() {
    l = !1, g();
  }
  function E(z) {
    typeof z < "u" && (u = z), g();
  }
  function M() {
    s && w();
  }
  function F() {
    s && g();
  }
  function G() {
    return s;
  }
  function U() {
    const {
      index: z
    } = n.internalEngine(), Z = z.clone().add(1).get(), Y = n.scrollSnapList().length - 1, O = t.stopOnLastSnap && Z === Y;
    if (n.canScrollNext() ? n.scrollNext(u) : n.scrollTo(0, u), n.emit("autoplay:select"), O) return w();
    g();
  }
  function H() {
    if (!a) return null;
    const z = o[n.selectedScrollSnap()], Z = (/* @__PURE__ */ new Date()).getTime() - a;
    return z - Z;
  }
  return {
    name: "autoplay",
    options: e,
    init: d,
    destroy: f,
    play: E,
    stop: M,
    reset: F,
    isPlaying: G,
    timeUntilNext: H
  };
}
Nu.globalOptions = void 0;
const O_ = "tw-min-w-0 tw-shrink-0 tw-grow-0 tw-basis-full [&>img]:tw-size-full ", D_ = oe("tw-absolute tw-flex tw-w-full tw-flex-row-reverse tw-items-center tw-justify-center ", {
  variants: {
    position: {
      left: "!tw-justify-end tw-gap-density-action-gap-sm",
      right: "!tw-justify-start tw-gap-density-action-gap-sm",
      center: " tw-gap-density-action-gap-xl"
    }
  },
  defaultVariants: {
    position: "center"
  }
}), A_ = "tw-bg-background tw-flex tw-min-w-0 tw-shrink-0 tw-grow-0 [&>div>img]:tw-size-full [&>div>img]:tw-object-cover tw-pr-density-action-padding-sm tw-py-density-action-padding-sm [&>div]:tw-border-x-density-action-thin [&>div]:tw-border-y-density-action-thin [&>div]:tw-rounded-density-action-default [&>div]:tw-h-[64px] [&>div]:tw-w-[64px] [&>div]:hover:tw-border-semantic-action-border-primary-lighter ", $_ = oe(O_, {
  variants: {
    fit: {
      fit: "[&>img]:tw-object-contain ",
      // this centers the image, no cropping
      fill: "[&>img]:tw-object-cover "
      // this crops the image centered in the viewport
    }
  },
  defaultVariants: {
    fit: "fill"
  }
}), L_ = oe("tw-block tw-px-2 tw-py-3 tw-text-xs ", {
  variants: {
    position: {
      left: "tw-float-left",
      right: "tw-float-right",
      center: "tw-text-center"
    }
  },
  defaultVariants: {
    position: "left"
  }
}), bv = bt(null);
function Ki() {
  const e = Xe(bv);
  if (!e)
    throw new Error("useCarousel must be used within a <Carousel />");
  return e;
}
const F_ = q(
  ({
    className: e,
    children: t,
    autoplay: n = !1,
    autoplayProps: r,
    disableDrag: o,
    disableThumbnailsDrag: a,
    startIndex: i,
    loop: s,
    ...l
  }, c) => {
    const u = n ? [Nu({ delay: 3e3, stopOnInteraction: !0, ...r })] : [], [d, f] = Fo(
      {
        axis: "x",
        loop: s || n,
        // always loop on autoplay
        watchDrag: !o,
        startIndex: i || 0
      },
      u
    ), [p, h] = Fo({
      containScroll: "keepSnaps",
      dragFree: !0,
      watchDrag: !a
    }), [g, w] = ye(!1), [b, y] = ye(!1), [x, C] = ye(0), S = ot(
      (j) => {
        if (!j) return;
        const z = j.selectedScrollSnap();
        C(z), h == null || h.scrollTo(z), w(j.canScrollPrev()), y(j.canScrollNext());
      },
      [f, h]
    ), R = ot(() => {
      f == null || f.scrollNext();
    }, [f]), E = ot(() => {
      f == null || f.scrollPrev();
    }, [f]), M = ot(
      (j) => {
        j.key === "ArrowLeft" ? (j.preventDefault(), E()) : j.key === "ArrowRight" && (j.preventDefault(), R());
      },
      [E, R]
    ), F = ot(
      (j) => {
        !f || !h || f.scrollTo(j);
      },
      [f, h]
    );
    ke(() => {
      if (f)
        return S(f), f.on("reInit", S), f.on("select", S), () => {
          f.off("select", S);
        };
    }, [f, S]);
    const G = qe(null), U = qe(null), H = qe(null);
    return f0(c, () => ({
      containerRef: G,
      prevButtonRef: U,
      nextButtonRef: H
    })), /* @__PURE__ */ m(
      bv.Provider,
      {
        value: {
          carouselRef: d,
          api: f,
          thumbsRef: p,
          scrollNext: R,
          scrollPrev: E,
          canScrollNext: b,
          canScrollPrev: g,
          activeIndex: x,
          onThumbClick: F,
          handleKeyDown: M,
          prevButtonRef: U,
          nextButtonRef: H
        },
        children: /* @__PURE__ */ m(
          "div",
          {
            ref: G,
            tabIndex: 0,
            onKeyDownCapture: M,
            className: N("tw-relative tw-size-full", e),
            role: "region",
            "aria-roledescription": "carousel",
            ...l,
            children: t
          }
        )
      }
    );
  }
);
F_.displayName = "Carousel";
const z_ = q(
  ({
    className: e,
    variant: t = "arrow",
    children: n,
    arrowsPosition: r,
    ...o
  }, a) => {
    const {
      activeIndex: i,
      carouselRef: s,
      scrollNext: l,
      canScrollNext: c,
      scrollPrev: u,
      canScrollPrev: d,
      prevButtonRef: f,
      nextButtonRef: p
    } = Ki();
    return /* @__PURE__ */ ee(
      "div",
      {
        ref: s,
        className: "tw-size-full tw-overflow-hidden",
        "data-carouselactiveindex": i,
        children: [
          /* @__PURE__ */ m(
            "div",
            {
              ref: a,
              className: N(" tw-flex tw-h-full", e),
              ...o,
              children: n
            }
          ),
          t === "sideArrows" ? /* @__PURE__ */ ee(
            Ne,
            { children: [
              /* @__PURE__ */ m(
                mt,
                {
                  ref: p,
                  variant: "ghost",
                  size: "md",
                  intent: "neutral",
                  iconName: "chevron-right",
                  className: N(
                    "tw-absolute tw--right-[2.25rem] tw-top-1/2 tw--translate-y-1/2",
                    e
                  ),
                  disabled: !c,
                  ariaLabel: "Next",
                  "data-testid": "carouselButtonNext",
                  onClick: l,
                  ...o
                }
              ),
              /* @__PURE__ */ m(
                mt,
                {
                  ref: f,
                  variant: "ghost",
                  size: "md",
                  intent: "neutral",
                  iconName: "chevron-left",
                  className: N(
                    "tw-absolute tw--left-[2.25rem] tw-top-1/2 tw--translate-y-1/2",
                    e
                  ),
                  disabled: !d,
                  ariaLabel: "Previous",
                  "data-testid": "carouselButtonPrev",
                  onClick: u,
                  ...o
                }
              )
            ] }
          ) : t === "arrowsBelow" ? /* @__PURE__ */ ee(
            "div",
            {
              className: D_({ position: r }),
              children: [
                /* @__PURE__ */ m(
                  mt,
                  {
                    ref: p,
                    variant: "ghost",
                    size: "md",
                    intent: "neutral",
                    iconName: "chevron-right",
                    className: N(
                      "tw-relative tw--bottom-density-action-gap-sm",
                      e
                    ),
                    disabled: !c,
                    ariaLabel: "Next",
                    "data-testid": "carouselButtonNext",
                    onClick: l,
                    ...o
                  }
                ),
                /* @__PURE__ */ m(
                  mt,
                  {
                    ref: f,
                    variant: "ghost",
                    size: "md",
                    intent: "neutral",
                    iconName: "chevron-left",
                    className: N(
                      "tw-relative tw--bottom-density-action-gap-sm",
                      e
                    ),
                    disabled: !d,
                    ariaLabel: "Previous",
                    "data-testid": "carouselButtonPrev",
                    onClick: u,
                    ...o
                  }
                )
              ]
            }
          ) : null
        ]
      }
    );
  }
);
z_.displayName = "CarouselMainContainer";
const V_ = q(
  ({ className: e, fit: t = "fill", children: n, ...r }, o) => /* @__PURE__ */ m(
    "div",
    {
      ...r,
      ref: o,
      "aria-roledescription": "slide",
      "data-testid": "carouselMainItem",
      className: N($_({ fit: t }), e),
      children: n
    }
  )
);
V_.displayName = "CarouselMainItem";
const B_ = q(
  ({ className: e, children: t, ...n }, r) => {
    const { thumbsRef: o } = Ki();
    return /* @__PURE__ */ m(
      "div",
      {
        ...n,
        ref: o,
        className: "tw-width-full tw-overflow-hidden",
        "data-testid": "carouselThumbsContainer",
        children: /* @__PURE__ */ m(
          "div",
          { ref: r, className: N("tw-flex", e), children: t }
        )
      }
    );
  }
);
B_.displayName = "CarouselThumbsContainer";
const H_ = q(
  ({ className: e, index: t, children: n, ...r }, o) => {
    const { activeIndex: a, onThumbClick: i } = Ki(), s = a === t, l = s ? "tw-border-semantic-action-border-primary-default " : "tw-relative border-semantic-action-border-neutral-lighter";
    return /* @__PURE__ */ m(
      "div",
      {
        ...r,
        ref: o,
        onClick: () => i(t),
        "data-testid": "carouselThumbItem",
        "data-active": s,
        className: N(A_, e),
        children: /* @__PURE__ */ m("div", { className: `${l}`, children: n })
      }
    );
  }
);
H_.displayName = "CarouselThumbItem";
const W_ = q(
  ({ className: e, position: t }, n) => {
    var i;
    const { activeIndex: r, api: o } = Ki(), a = ((i = o == null ? void 0 : o.slideNodes()) == null ? void 0 : i.length) || 0;
    return /* @__PURE__ */ m(
      "span",
      {
        className: N(L_({ position: t }), e),
        "data-testid": "carouselCounter",
        ref: n,
        children: `${r + 1} / ${a}`
      }
    );
  }
);
W_.displayName = "CarouselCounter";
function Xi(e) {
  const t = v.useRef({ value: e, previous: e });
  return v.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var Tu = "Checkbox", [j_, R3] = Ye(Tu), [G_, U_] = j_(Tu), yv = v.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      form: u,
      ...d
    } = e, [f, p] = v.useState(null), h = xe(t, (C) => p(C)), g = v.useRef(!1), w = f ? u || !!f.closest("form") : !0, [b = !1, y] = je({
      prop: o,
      defaultProp: a,
      onChange: c
    }), x = v.useRef(b);
    return v.useEffect(() => {
      const C = f == null ? void 0 : f.form;
      if (C) {
        const S = () => y(x.current);
        return C.addEventListener("reset", S), () => C.removeEventListener("reset", S);
      }
    }, [f, y]), /* @__PURE__ */ ee(G_, { scope: n, state: b, disabled: s, children: [
      /* @__PURE__ */ m(
        ie.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": Pn(b) ? "mixed" : b,
          "aria-required": i,
          "data-state": Cv(b),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...d,
          ref: h,
          onKeyDown: re(e.onKeyDown, (C) => {
            C.key === "Enter" && C.preventDefault();
          }),
          onClick: re(e.onClick, (C) => {
            y((S) => Pn(S) ? !0 : !S), w && (g.current = C.isPropagationStopped(), g.current || C.stopPropagation());
          })
        }
      ),
      w && /* @__PURE__ */ m(
        q_,
        {
          control: f,
          bubbles: !g.current,
          name: r,
          value: l,
          checked: b,
          required: i,
          disabled: s,
          form: u,
          style: { transform: "translateX(-100%)" },
          defaultChecked: Pn(a) ? !1 : a
        }
      )
    ] });
  }
);
yv.displayName = Tu;
var xv = "CheckboxIndicator", Sv = v.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, a = U_(xv, n);
    return /* @__PURE__ */ m(at, { present: r || Pn(a.state) || a.state === !0, children: /* @__PURE__ */ m(
      ie.span,
      {
        "data-state": Cv(a.state),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
Sv.displayName = xv;
var q_ = (e) => {
  const { control: t, checked: n, bubbles: r = !0, defaultChecked: o, ...a } = e, i = v.useRef(null), s = Xi(n), l = Ii(t);
  v.useEffect(() => {
    const u = i.current, d = window.HTMLInputElement.prototype, p = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (s !== n && p) {
      const h = new Event("click", { bubbles: r });
      u.indeterminate = Pn(n), p.call(u, Pn(n) ? !1 : n), u.dispatchEvent(h);
    }
  }, [s, n, r]);
  const c = v.useRef(Pn(n) ? !1 : n);
  return /* @__PURE__ */ m(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: o ?? c.current,
      ...a,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Pn(e) {
  return e === "indeterminate";
}
function Cv(e) {
  return Pn(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var Ev = yv, Y_ = Sv;
const kv = {
  variant: "checked",
  size: "sm"
}, K_ = "tw-flex tw-gap-density-formElement-gap-sm tw-items-center", X_ = oe(K_, {
  variants: {
    variant: {
      unchecked: "",
      checked: "",
      indeterminate: ""
    },
    size: {
      sm: "tw-min-h-density-formElement-xs ",
      md: ""
    }
  },
  defaultVariants: kv
}), J_ = oe(["tw-relative", "tw-inline-flex", "tw-shrink-0", "tw-items-center", "tw-justify-center", "tw-border", "tw-border-neutral-500", "tw-rounded-sm", "tw-transition-colors", "tw-duration-150", "tw-ease-in-out", "hover:tw-border-neutral-400", "focus-visible:tw-outline", "focus-visible:tw-outline-2", "focus-visible:tw-outline-offset-2", "focus-visible:tw-outline-gray-900", "data-[disabled]:tw-cursor-not-allowed", "data-[disabled]:tw-border-neutral-400", "data-[disabled]:tw-bg-neutral-200", "data-[disabled]:hover:tw-border-neutral-400", "data-[disabled]:tw-opacity-50", "data-[disabled]:tw-pointer-events-auto"], {
  variants: {
    size: {
      sm: ["tw-size-4"],
      md: ["tw-size-5"]
    },
    intent: {
      primary: [],
      neutral: []
    },
    checked: {
      true: [],
      false: ["tw-bg-white"],
      indeterminate: []
    },
    disabled: {
      true: [],
      false: ["tw-cursor-pointer"]
    }
  },
  compoundVariants: [{
    intent: "primary",
    checked: !0,
    disabled: !1,
    className: ["tw-bg-semantic-formElement-background-primary-default", "tw-border-semantic-formElement-border-primary-default", "hover:tw-bg-semantic-formElement-background-primary-dark", "hover:tw-border-semantic-formElement-border-primary-dark", "active:tw-bg-semantic-formElement-background-primary-tertiary", "active:tw-border-semantic-formElement-border-primary-darker", "disabled:tw-text-semantic-formElement-foreground-primary-disabled", "disabled:tw-border-semantic-formElement-border-primary-disabled", "disabled:tw-bg-semantic-formElement-background-primary-disabled", "tw-text-white", "[&>span.icon:disabled]tw-text-semantic-formElement-foreground-primary-disabled"]
  }, {
    intent: "primary",
    checked: "indeterminate",
    disabled: !1,
    className: ["tw-bg-blue-500", "tw-border-blue-500", "hover:tw-bg-blue-600", "hover:tw-border-blue-600"]
  }, {
    intent: "neutral",
    checked: !0,
    disabled: !1,
    className: ["tw-bg-neutral-800", "tw-border-neutral-800", "tw-text-white", "hover:tw-bg-neutral-600", "hover:tw-border-neutral-600"]
  }, {
    intent: "neutral",
    checked: "indeterminate",
    disabled: !1,
    className: ["tw-bg-neutral-700", "tw-border-neutral-700", "hover:tw-bg-neutral-800", "hover:tw-border-neutral-800"]
  }, {
    checked: [!0, "indeterminate"],
    disabled: !0,
    className: ["tw-bg-semantic-formElement-background-primary-default", "tw-border-semantic-formElement-border-primary-default", "hover:tw-bg-semantic-formElement-background-primary-dark", "hover:tw-border-semantic-formElement-border-primary-dark", "active:tw-bg-semantic-formElement-background-primary-tertiary", "active:tw-border-semantic-formElement-border-primary-darker", "disabled:tw-text-semantic-formElement-foreground-neutral-disabled", "disabled:tw-border-semantic-formElement-border-neutral-disabled", "disabled:tw-bg-semantic-formElement-background-neutral-disabled", "tw-text-semantic-formElement-foreground-neutral-default", "[&>span.icon:disabled]tw-text-semantic-formElement-foreground-neutral-disabled"]
  }],
  defaultVariants: {
    size: "md",
    intent: "primary",
    checked: !1,
    disabled: !1
  }
}), Q_ = "tw-text-semantic-formElement-label-default tw-text-sm tw-leading-4 ", Z_ = oe(Q_, {
  variants: {
    variant: {
      unchecked: "",
      checked: "",
      indeterminate: ""
    },
    size: {
      sm: "tw-gap-density-formElement-gap-sm",
      md: "tw-gap-density-formElement-gap-md"
    },
    labelHidden: {
      hidden: "tw-sr-only "
    }
  },
  compoundVariants: [],
  defaultVariants: kv
}), Gs = "indeterminate", eI = () => /* @__PURE__ */ m(de, { icon: "check", size: "lg" }), tI = () => /* @__PURE__ */ m(de, { icon: "dash", size: "lg" }), nI = () => /* @__PURE__ */ m(de, { icon: "check", size: "sm" }), rI = () => /* @__PURE__ */ m(de, { icon: "dash", size: "sm" }), oI = (e) => ({
  check: e === "sm" ? /* @__PURE__ */ m(nI, {}) : /* @__PURE__ */ m(eI, {}),
  dash: e === "sm" ? /* @__PURE__ */ m(rI, {}) : /* @__PURE__ */ m(tI, {})
}), zl = q(
  ({
    size: e = "sm",
    label: t,
    isLabelHidden: n,
    className: r,
    checked: o = !1,
    onChange: a,
    intent: i = "primary",
    ...s
  }, l) => {
    const c = $n(), u = oI(e);
    o = o === void 0 ? "indeterminate" : o;
    const d = o === Gs ? Gs : o ? "checked" : "unchecked";
    return /* @__PURE__ */ ee(
      "span",
      {
        className: N(X_({ variant: d, size: e }), r),
        children: [
          /* @__PURE__ */ m(
            Ev,
            {
              checked: o,
              ref: l,
              className: N(
                J_({ checked: o, size: e, intent: i, disabled: s.disabled }),
                r
              ),
              onCheckedChange: a,
              ...s,
              id: c,
              children: /* @__PURE__ */ ee(
                Y_,
                {
                  className: N(
                    "tw-flex tw-items-center tw-justify-center tw-text-current -tw-mt-[1px]"
                  ),
                  children: [
                    o === Gs && u.dash,
                    o === !0 && u.check
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ m(
            "label",
            {
              htmlFor: c,
              className: N(
                Z_({
                  variant: d,
                  size: e,
                  labelHidden: n ? "hidden" : null
                }),
                r
              ),
              children: t
            }
          )
        ]
      }
    );
  }
);
zl.displayName = Ev.displayName;
const P3 = Dp, N3 = Cc, T3 = kc;
var ff = 1, aI = 0.9, iI = 0.8, sI = 0.17, Us = 0.1, qs = 0.999, lI = 0.9999, cI = 0.99, uI = /[\\\/_+.#"@\[\(\{&]/, dI = /[\\\/_+.#"@\[\(\{&]/g, fI = /[\s-]/, Rv = /[\s-]/g;
function Vl(e, t, n, r, o, a, i) {
  if (a === t.length) return o === e.length ? ff : cI;
  var s = `${o},${a}`;
  if (i[s] !== void 0) return i[s];
  for (var l = r.charAt(a), c = n.indexOf(l, o), u = 0, d, f, p, h; c >= 0; ) d = Vl(e, t, n, r, c + 1, a + 1, i), d > u && (c === o ? d *= ff : uI.test(e.charAt(c - 1)) ? (d *= iI, p = e.slice(o, c - 1).match(dI), p && o > 0 && (d *= Math.pow(qs, p.length))) : fI.test(e.charAt(c - 1)) ? (d *= aI, h = e.slice(o, c - 1).match(Rv), h && o > 0 && (d *= Math.pow(qs, h.length))) : (d *= sI, o > 0 && (d *= Math.pow(qs, c - o))), e.charAt(c) !== t.charAt(a) && (d *= lI)), (d < Us && n.charAt(c - 1) === r.charAt(a + 1) || r.charAt(a + 1) === r.charAt(a) && n.charAt(c - 1) !== r.charAt(a)) && (f = Vl(e, t, n, r, c + 1, a + 2, i), f * Us > d && (d = f * Us)), d > u && (u = d), c = n.indexOf(l, c + 1);
  return i[s] = u, u;
}
function pf(e) {
  return e.toLowerCase().replace(Rv, " ");
}
function pI(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, Vl(e, t, pf(e), pf(t), 0, 0, {});
}
var po = '[cmdk-group=""]', Ys = '[cmdk-group-items=""]', mI = '[cmdk-group-heading=""]', _u = '[cmdk-item=""]', mf = `${_u}:not([aria-disabled="true"])`, Bl = "cmdk-item-select", Kn = "data-value", gI = (e, t, n) => pI(e, t, n), Pv = v.createContext(void 0), ha = () => v.useContext(Pv), Nv = v.createContext(void 0), Iu = () => v.useContext(Nv), Tv = v.createContext(void 0), _v = v.forwardRef((e, t) => {
  let n = kr(() => {
    var k, $;
    return { search: "", value: ($ = (k = e.value) != null ? k : e.defaultValue) != null ? $ : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = kr(() => /* @__PURE__ */ new Set()), o = kr(() => /* @__PURE__ */ new Map()), a = kr(() => /* @__PURE__ */ new Map()), i = kr(() => /* @__PURE__ */ new Set()), s = Iv(e), { label: l, children: c, value: u, onValueChange: d, filter: f, shouldFilter: p, loop: h, disablePointerSelection: g = !1, vimBindings: w = !0, ...b } = e, y = Te(), x = Te(), C = Te(), S = v.useRef(null), R = RI();
  ir(() => {
    if (u !== void 0) {
      let k = u.trim();
      n.current.value = k, E.emit();
    }
  }, [u]), ir(() => {
    R(6, j);
  }, []);
  let E = v.useMemo(() => ({ subscribe: (k) => (i.current.add(k), () => i.current.delete(k)), snapshot: () => n.current, setState: (k, $, P) => {
    var _, V, T;
    if (!Object.is(n.current[k], $)) {
      if (n.current[k] = $, k === "search") H(), G(), R(1, U);
      else if (k === "value" && (P || R(5, j), ((_ = s.current) == null ? void 0 : _.value) !== void 0)) {
        let L = $ ?? "";
        (T = (V = s.current).onValueChange) == null || T.call(V, L);
        return;
      }
      E.emit();
    }
  }, emit: () => {
    i.current.forEach((k) => k());
  } }), []), M = v.useMemo(() => ({ value: (k, $, P) => {
    var _;
    $ !== ((_ = a.current.get(k)) == null ? void 0 : _.value) && (a.current.set(k, { value: $, keywords: P }), n.current.filtered.items.set(k, F($, P)), R(2, () => {
      G(), E.emit();
    }));
  }, item: (k, $) => (r.current.add(k), $ && (o.current.has($) ? o.current.get($).add(k) : o.current.set($, /* @__PURE__ */ new Set([k]))), R(3, () => {
    H(), G(), n.current.value || U(), E.emit();
  }), () => {
    a.current.delete(k), r.current.delete(k), n.current.filtered.items.delete(k);
    let P = z();
    R(4, () => {
      H(), (P == null ? void 0 : P.getAttribute("id")) === k && U(), E.emit();
    });
  }), group: (k) => (o.current.has(k) || o.current.set(k, /* @__PURE__ */ new Set()), () => {
    a.current.delete(k), o.current.delete(k);
  }), filter: () => s.current.shouldFilter, label: l || e["aria-label"], getDisablePointerSelection: () => s.current.disablePointerSelection, listId: y, inputId: C, labelId: x, listInnerRef: S }), []);
  function F(k, $) {
    var P, _;
    let V = (_ = (P = s.current) == null ? void 0 : P.filter) != null ? _ : gI;
    return k ? V(k, n.current.search, $) : 0;
  }
  function G() {
    if (!n.current.search || s.current.shouldFilter === !1) return;
    let k = n.current.filtered.items, $ = [];
    n.current.filtered.groups.forEach((_) => {
      let V = o.current.get(_), T = 0;
      V.forEach((L) => {
        let J = k.get(L);
        T = Math.max(J, T);
      }), $.push([_, T]);
    });
    let P = S.current;
    Z().sort((_, V) => {
      var T, L;
      let J = _.getAttribute("id"), Q = V.getAttribute("id");
      return ((T = k.get(Q)) != null ? T : 0) - ((L = k.get(J)) != null ? L : 0);
    }).forEach((_) => {
      let V = _.closest(Ys);
      V ? V.appendChild(_.parentElement === V ? _ : _.closest(`${Ys} > *`)) : P.appendChild(_.parentElement === P ? _ : _.closest(`${Ys} > *`));
    }), $.sort((_, V) => V[1] - _[1]).forEach((_) => {
      var V;
      let T = (V = S.current) == null ? void 0 : V.querySelector(`${po}[${Kn}="${encodeURIComponent(_[0])}"]`);
      T == null || T.parentElement.appendChild(T);
    });
  }
  function U() {
    let k = Z().find((P) => P.getAttribute("aria-disabled") !== "true"), $ = k == null ? void 0 : k.getAttribute(Kn);
    E.setState("value", $ || void 0);
  }
  function H() {
    var k, $, P, _;
    if (!n.current.search || s.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let V = 0;
    for (let T of r.current) {
      let L = ($ = (k = a.current.get(T)) == null ? void 0 : k.value) != null ? $ : "", J = (_ = (P = a.current.get(T)) == null ? void 0 : P.keywords) != null ? _ : [], Q = F(L, J);
      n.current.filtered.items.set(T, Q), Q > 0 && V++;
    }
    for (let [T, L] of o.current) for (let J of L) if (n.current.filtered.items.get(J) > 0) {
      n.current.filtered.groups.add(T);
      break;
    }
    n.current.filtered.count = V;
  }
  function j() {
    var k, $, P;
    let _ = z();
    _ && (((k = _.parentElement) == null ? void 0 : k.firstChild) === _ && ((P = ($ = _.closest(po)) == null ? void 0 : $.querySelector(mI)) == null || P.scrollIntoView({ block: "nearest" })), _.scrollIntoView({ block: "nearest" }));
  }
  function z() {
    var k;
    return (k = S.current) == null ? void 0 : k.querySelector(`${_u}[aria-selected="true"]`);
  }
  function Z() {
    var k;
    return Array.from(((k = S.current) == null ? void 0 : k.querySelectorAll(mf)) || []);
  }
  function Y(k) {
    let $ = Z()[k];
    $ && E.setState("value", $.getAttribute(Kn));
  }
  function O(k) {
    var $;
    let P = z(), _ = Z(), V = _.findIndex((L) => L === P), T = _[V + k];
    ($ = s.current) != null && $.loop && (T = V + k < 0 ? _[_.length - 1] : V + k === _.length ? _[0] : _[V + k]), T && E.setState("value", T.getAttribute(Kn));
  }
  function I(k) {
    let $ = z(), P = $ == null ? void 0 : $.closest(po), _;
    for (; P && !_; ) P = k > 0 ? EI(P, po) : kI(P, po), _ = P == null ? void 0 : P.querySelector(mf);
    _ ? E.setState("value", _.getAttribute(Kn)) : O(k);
  }
  let W = () => Y(Z().length - 1), A = (k) => {
    k.preventDefault(), k.metaKey ? W() : k.altKey ? I(1) : O(1);
  }, K = (k) => {
    k.preventDefault(), k.metaKey ? Y(0) : k.altKey ? I(-1) : O(-1);
  };
  return v.createElement(ie.div, { ref: t, tabIndex: -1, ...b, "cmdk-root": "", onKeyDown: (k) => {
    var $;
    if (($ = b.onKeyDown) == null || $.call(b, k), !k.defaultPrevented) switch (k.key) {
      case "n":
      case "j": {
        w && k.ctrlKey && A(k);
        break;
      }
      case "ArrowDown": {
        A(k);
        break;
      }
      case "p":
      case "k": {
        w && k.ctrlKey && K(k);
        break;
      }
      case "ArrowUp": {
        K(k);
        break;
      }
      case "Home": {
        k.preventDefault(), Y(0);
        break;
      }
      case "End": {
        k.preventDefault(), W();
        break;
      }
      case "Enter":
        if (!k.nativeEvent.isComposing && k.keyCode !== 229) {
          k.preventDefault();
          let P = z();
          if (P) {
            let _ = new Event(Bl);
            P.dispatchEvent(_);
          }
        }
    }
  } }, v.createElement("label", { "cmdk-label": "", htmlFor: M.inputId, id: M.labelId, style: NI }, l), Ji(e, (k) => v.createElement(Nv.Provider, { value: E }, v.createElement(Pv.Provider, { value: M }, k))));
}), hI = v.forwardRef((e, t) => {
  var n, r;
  let o = Te(), a = v.useRef(null), i = v.useContext(Tv), s = ha(), l = Iv(e), c = (r = (n = l.current) == null ? void 0 : n.forceMount) != null ? r : i == null ? void 0 : i.forceMount;
  ir(() => {
    if (!c) return s.item(o, i == null ? void 0 : i.id);
  }, [c]);
  let u = Mv(o, a, [e.value, e.children, a], e.keywords), d = Iu(), f = sr((R) => R.value && R.value === u.current), p = sr((R) => c || s.filter() === !1 ? !0 : R.search ? R.filtered.items.get(o) > 0 : !0);
  v.useEffect(() => {
    let R = a.current;
    if (!(!R || e.disabled)) return R.addEventListener(Bl, h), () => R.removeEventListener(Bl, h);
  }, [p, e.onSelect, e.disabled]);
  function h() {
    var R, E;
    g(), (E = (R = l.current).onSelect) == null || E.call(R, u.current);
  }
  function g() {
    d.setState("value", u.current, !0);
  }
  if (!p) return null;
  let { disabled: w, value: b, onSelect: y, forceMount: x, keywords: C, ...S } = e;
  return v.createElement(ie.div, { ref: Bo([a, t]), ...S, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!w, "aria-selected": !!f, "data-disabled": !!w, "data-selected": !!f, onPointerMove: w || s.getDisablePointerSelection() ? void 0 : g, onClick: w ? void 0 : h }, e.children);
}), vI = v.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: o, ...a } = e, i = Te(), s = v.useRef(null), l = v.useRef(null), c = Te(), u = ha(), d = sr((p) => o || u.filter() === !1 ? !0 : p.search ? p.filtered.groups.has(i) : !0);
  ir(() => u.group(i), []), Mv(i, s, [e.value, e.heading, l]);
  let f = v.useMemo(() => ({ id: i, forceMount: o }), [o]);
  return v.createElement(ie.div, { ref: Bo([s, t]), ...a, "cmdk-group": "", role: "presentation", hidden: d ? void 0 : !0 }, n && v.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: c }, n), Ji(e, (p) => v.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? c : void 0 }, v.createElement(Tv.Provider, { value: f }, p))));
}), wI = v.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, o = v.useRef(null), a = sr((i) => !i.search);
  return !n && !a ? null : v.createElement(ie.div, { ref: Bo([o, t]), ...r, "cmdk-separator": "", role: "separator" });
}), bI = v.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, o = e.value != null, a = Iu(), i = sr((u) => u.search), s = sr((u) => u.value), l = ha(), c = v.useMemo(() => {
    var u;
    let d = (u = l.listInnerRef.current) == null ? void 0 : u.querySelector(`${_u}[${Kn}="${encodeURIComponent(s)}"]`);
    return d == null ? void 0 : d.getAttribute("id");
  }, []);
  return v.useEffect(() => {
    e.value != null && a.setState("search", e.value);
  }, [e.value]), v.createElement(ie.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": c, id: l.inputId, type: "text", value: o ? e.value : i, onChange: (u) => {
    o || a.setState("search", u.target.value), n == null || n(u.target.value);
  } });
}), yI = v.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...o } = e, a = v.useRef(null), i = v.useRef(null), s = ha();
  return v.useEffect(() => {
    if (i.current && a.current) {
      let l = i.current, c = a.current, u, d = new ResizeObserver(() => {
        u = requestAnimationFrame(() => {
          let f = l.offsetHeight;
          c.style.setProperty("--cmdk-list-height", f.toFixed(1) + "px");
        });
      });
      return d.observe(l), () => {
        cancelAnimationFrame(u), d.unobserve(l);
      };
    }
  }, []), v.createElement(ie.div, { ref: Bo([a, t]), ...o, "cmdk-list": "", role: "listbox", "aria-label": r, id: s.listId }, Ji(e, (l) => v.createElement("div", { ref: Bo([i, s.listInnerRef]), "cmdk-list-sizer": "" }, l)));
}), xI = v.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: o, contentClassName: a, container: i, ...s } = e;
  return v.createElement(ra, { open: n, onOpenChange: r }, v.createElement(oa, { container: i }, v.createElement(fr, { "cmdk-overlay": "", className: o }), v.createElement(Mn, { "aria-label": e.label, "cmdk-dialog": "", className: a }, v.createElement(_v, { ref: t, ...s }))));
}), SI = v.forwardRef((e, t) => sr((n) => n.filtered.count === 0) ? v.createElement(ie.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), CI = v.forwardRef((e, t) => {
  let { progress: n, children: r, label: o = "Loading...", ...a } = e;
  return v.createElement(ie.div, { ref: t, ...a, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, Ji(e, (i) => v.createElement("div", { "aria-hidden": !0 }, i)));
}), yt = Object.assign(_v, { List: yI, Item: hI, Input: bI, Group: vI, Separator: wI, Dialog: xI, Empty: SI, Loading: CI });
function EI(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function kI(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function Iv(e) {
  let t = v.useRef(e);
  return ir(() => {
    t.current = e;
  }), t;
}
var ir = typeof window > "u" ? v.useEffect : v.useLayoutEffect;
function kr(e) {
  let t = v.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function Bo(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
function sr(e) {
  let t = Iu(), n = () => e(t.snapshot());
  return Ng.useSyncExternalStore(t.subscribe, n, n);
}
function Mv(e, t, n, r = []) {
  let o = v.useRef(), a = ha();
  return ir(() => {
    var i;
    let s = (() => {
      var c;
      for (let u of n) {
        if (typeof u == "string") return u.trim();
        if (typeof u == "object" && "current" in u) return u.current ? (c = u.current.textContent) == null ? void 0 : c.trim() : o.current;
      }
    })(), l = r.map((c) => c.trim());
    a.value(e, s, l), (i = t.current) == null || i.setAttribute(Kn, s), o.current = s;
  }), o;
}
var RI = () => {
  let [e, t] = v.useState(), n = kr(() => /* @__PURE__ */ new Map());
  return ir(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function PI(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function Ji({ asChild: e, children: t }, n) {
  return e && v.isValidElement(t) ? v.cloneElement(PI(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var NI = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const gf = "custom-density-static-min-w-320 tw-bg-white tw-transition-all data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] tw-fixed tw-left-[50%] tw-top-[50%] tw-z-50 grid tw-w-full tw-max-w-lg tw-translate-x-[-50%] tw-translate-y-[-50%] tw-duration-200 ", hf = "tw-grid tw-w-full custom-gap-density-static-gap-md tw-p-density-static-padding-md tw-rounded-density-static-xs tw-border-density-static-default tw-bg-semantic-static-background-neutral-default ", TI = "tw-font-bold tw-text-left ", _I = "tw-text-sm tw-text-left ", II = ra, _3 = ({
  children: e,
  ...t
}) => {
  const n = qe(null), [r, o] = ye();
  return ke(() => {
    var a;
    if (n.current) {
      const i = (a = n.current.nextElementSibling) == null ? void 0 : a.querySelector(
        '[data-state="open"]'
      );
      i && o(i.id);
    }
  }, []), /* @__PURE__ */ m(
    tu,
    { ...t, ref: n, "aria-controls": r, children: tn(e, {
      "aria-controls": r
    }) }
  );
}, MI = oa, OI = Fi, Hl = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    fr,
    {
      ref: n,
      className: N(
        "data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 tw-fixed tw-inset-0 tw-z-50 tw-bg-gradient-to-br tw-from-black/50 tw-to-black/60",
        e
      ),
      ...t
    }
  )
);
Hl.displayName = fr.displayName;
const Ov = q(
  ({ className: e, children: t, inline: n, ...r }, o) => {
    const a = $n();
    return /* @__PURE__ */ m(
      Ne,
      { children: n ? /* @__PURE__ */ ee(
        Ne,
        { children: [
          /* @__PURE__ */ m(Hl, {}),
          /* @__PURE__ */ m(
            Mn,
            {
              ref: o,
              className: N(gf, hf, e),
              ...r,
              id: a,
              children: t
            }
          )
        ] }
      ) : /* @__PURE__ */ ee(
        MI,
        { children: [
          /* @__PURE__ */ m(Hl, {}),
          /* @__PURE__ */ m(
            Mn,
            {
              ref: o,
              className: N(gf, hf, e),
              ...r,
              id: a,
              children: t
            }
          )
        ] }
      ) }
    );
  }
);
Ov.displayName = Mn.displayName;
const DI = ({
  className: e,
  ...t
}) => /* @__PURE__ */ m(
  "div",
  {
    className: N(
      "custom-gap-density-static-gap-xs tw-flex tw-flex-col ",
      e
    ),
    ...t
  }
);
DI.displayName = "DialogHeader";
const AI = ({
  className: e,
  ...t
}) => /* @__PURE__ */ m(
  "div",
  {
    className: N(
      "custom-gap-density-static-gap-sm tw-flex tw-justify-end",
      e
    ),
    ...t
  }
);
AI.displayName = "DialogFooter";
const $I = q(
  ({ className: e, hideClose: t = !1, ...n }, r) => /* @__PURE__ */ ee(
    "div",
    { className: "tw-flex tw-items-start tw-justify-between", children: [
      /* @__PURE__ */ m(
        aa,
        {
          ref: r,
          className: N(TI, e),
          ...n
        }
      ),
      !t && /* @__PURE__ */ m(
        OI,
        { asChild: !0, children: /* @__PURE__ */ m(
          mt,
          {
            size: "sm",
            variant: "ghost",
            intent: "neutral",
            ariaLabel: "close",
            iconName: "xmark"
          }
        ) }
      )
    ] }
  )
);
$I.displayName = aa.displayName;
const LI = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    ia,
    {
      ref: n,
      className: N(_I, e),
      ...t
    }
  )
);
LI.displayName = ia.displayName;
const FI = oe("tw-flex tw-h-full tw-w-full tw-flex-col tw-overflow-hidden tw-rounded-md tw-bg-white tw-text-semantic-formElement-label-default", {
  variants: {
    size: {
      default: "",
      sm: "tw-text-sm",
      lg: "tw-text-lg"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), zI = oe("tw-flex tw-items-center tw-border-b tw-px-3", {
  variants: {
    padding: {
      default: "tw-px-3",
      sm: "tw-px-2",
      lg: "tw-px-4"
    }
  },
  defaultVariants: {
    padding: "default"
  }
}), VI = oe("placeholder:tw-text-muted-foreground tw-flex tw-w-full tw-rounded-md tw-bg-transparent tw-px-2 tw-py-3 tw-text-sm tw-outline-none disabled:tw-cursor-not-allowed disabled:tw-opacity-50", {
  variants: {
    size: {
      default: "tw-h-11",
      sm: "tw-h-9 tw-text-xs",
      lg: "tw-h-12 tw-text-base"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), BI = oe("tw-overflow-y-auto tw-overflow-x-hidden", {
  variants: {
    maxHeight: {
      default: "",
      sm: "tw-max-h-40",
      md: "tw-max-h-60",
      lg: "tw-max-h-80"
    }
  },
  defaultVariants: {
    maxHeight: "default"
  }
}), HI = oe("tw-py-6 tw-text-center tw-text-sm", {
  variants: {
    variant: {
      default: "",
      subtle: "tw-italic tw-text-gray-500"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), WI = oe("tw-overflow-hidden tw-p-1 tw-text-semantic-formElement-label-default [&_[cmdk-group-heading]]:tw-px-2 [&_[cmdk-group-heading]]:tw-py-1.5 [&_[cmdk-group-heading]]:tw-text-xs [&_[cmdk-group-heading]]:tw-font-medium [&_[cmdk-group-heading]]:tw-text-semantic-formElement-label-weak", {
  variants: {
    spacing: {
      default: "tw-p-1",
      compact: "tw-p-0.5",
      loose: "tw-p-2"
    }
  },
  defaultVariants: {
    spacing: "default"
  }
}), jI = oe("tw-bg-border tw--mx-1 tw-h-px", {
  variants: {
    variant: {
      default: "",
      thick: "tw-h-0.5"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), GI = oe('[data-disabled="true"]:tw-pointer-events-none [data-disabled="true"]:tw-opacity-50 tw-relative tw-flex tw-cursor-pointer tw-select-none tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-text-sm tw-outline-none hover:tw-bg-semantic-action-border-primary-weaker data-[selected="true"]:tw-bg-semantic-action-background-neutral-weaker', {
  variants: {
    variant: {
      default: "",
      destructive: "tw-text-red-700 hover:tw-bg-red-100",
      accent: "tw-text-blue-700 hover:tw-bg-blue-100"
    },
    active: {
      true: "tw-bg-semantic-action-border-primary-weaker",
      false: ""
    }
  },
  defaultVariants: {
    variant: "default",
    active: !1
  }
}), UI = oe("tw-text-muted-foreground tw-ml-auto tw-text-xs tw-tracking-widest", {
  variants: {
    variant: {
      default: "",
      subtle: "tw-opacity-60",
      prominent: "tw-font-bold"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), Mu = q(
  ({ className: e, size: t, ...n }, r) => /* @__PURE__ */ m(
    yt,
    {
      ref: r,
      className: N(FI({ size: t }), e),
      ...n
    }
  )
);
Mu.displayName = yt.displayName;
const I3 = ({ children: e, ...t }) => /* @__PURE__ */ m(
  II,
  { ...t, children: /* @__PURE__ */ m(
    Ov,
    { className: "tw-overflow-hidden tw-p-0 tw-shadow-lg", children: /* @__PURE__ */ m(
      Mu,
      { className: "[&_[cmdk-group-heading]]:tw-px-2 [&_[cmdk-group-heading]]:tw-font-medium [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:tw-pt-0 [&_[cmdk-group]]:tw-px-2 [&_[cmdk-input-wrapper]_svg]:tw-h-5 [&_[cmdk-input-wrapper]_svg]:tw-w-5 [&_[cmdk-input]]:tw-h-12 [&_[cmdk-item]]:tw-px-2 [&_[cmdk-item]]:tw-py-3 [&_[cmdk-item]_svg]:tw-h-5 [&_[cmdk-item]_svg]:tw-w-5", children: e }
    ) }
  ) }
), qI = q(
  ({ className: e, size: t, padding: n, ...r }, o) => /* @__PURE__ */ ee(
    "div",
    {
      className: N(zI({ padding: n }), e),
      "cmdk-input-wrapper": "",
      children: [
        /* @__PURE__ */ m(de, { icon: "magnifying-glass", size: "sm" }),
        /* @__PURE__ */ m(
          yt.Input,
          {
            ref: o,
            className: N(VI({ size: t }), e),
            ...r
          }
        )
      ]
    }
  )
);
qI.displayName = yt.Input.displayName;
const Dv = q(
  ({ className: e, maxHeight: t, ...n }, r) => /* @__PURE__ */ m(
    yt.List,
    {
      ref: r,
      className: N(BI({ maxHeight: t }), e),
      ...n
    }
  )
);
Dv.displayName = yt.List.displayName;
const Av = q(
  ({ variant: e, className: t, ...n }, r) => /* @__PURE__ */ m(
    yt.Empty,
    {
      ref: r,
      className: N(HI({ variant: e }), t),
      ...n
    }
  )
);
Av.displayName = yt.Empty.displayName;
const $v = q(
  ({ className: e, spacing: t, ...n }, r) => /* @__PURE__ */ m(
    yt.Group,
    {
      ref: r,
      className: N(WI({ spacing: t }), e),
      ...n
    }
  )
);
$v.displayName = yt.Group.displayName;
const YI = q(
  ({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ m(
    yt.Separator,
    {
      ref: r,
      className: N(jI({ variant: t }), e),
      ...n
    }
  )
);
YI.displayName = yt.Separator.displayName;
const Lv = q(
  ({ className: e, variant: t, active: n, ...r }, o) => /* @__PURE__ */ m(
    yt.Item,
    {
      ref: o,
      className: N(GI({ variant: t, active: n }), e),
      ...r
    }
  )
);
Lv.displayName = yt.Item.displayName;
const KI = ({
  className: e,
  variant: t,
  ...n
}) => /* @__PURE__ */ m(
  "span",
  {
    className: N(UI({ variant: t }), e),
    ...n
  }
);
KI.displayName = "CommandShortcut";
const XI = "tw-border-semantic-static-background-neutral-secondary tw-border-y-density-static-default tw-border-x-density-static-default tw-flex", JI = oe(XI, {
  variants: {
    variant: {
      light: "tw-bg-semantic-static-background-neutral-default",
      ghost: "tw-border-none tw-bg-transparent",
      glass: "tw-bg-white/30 tw-backdrop-blur-lg"
    },
    padding: {
      none: "tw-p-0",
      xs: "tw-p-density-static-padding-xs",
      sm: "tw-p-density-static-padding-sm",
      md: "tw-p-density-static-padding-md",
      lg: "tw-p-density-static-padding-lg",
      xl: "tw-p-density-static-padding-xl"
    },
    borderRadius: {
      none: "tw-rounded-density-static-none",
      xs: "tw-rounded-density-static-xs",
      sm: "tw-rounded-density-static-sm",
      md: "tw-rounded-density-static-md",
      lg: "tw-rounded-density-static-lg",
      xl: "tw-rounded-density-static-xl",
      full: "tw-rounded-density-static-full"
    },
    shadow: {
      inset: "tw-shadow-[inset_0_2px_4px_0_rgba(23,35,102,0.15)]",
      none: "",
      1: "tw-shadow-[0_2px_4px_0_rgba(23,35,102,0.15)]",
      2: "tw-shadow-[0_6px_8px_0_rgba(23,35,102,0.15)]",
      3: "tw-shadow-[0_8px_12px_0_rgba(23,35,102,0.15)]",
      4: "tw-shadow-[0_12px_24px_0_rgba(23,35,102,0.20)]",
      5: "tw-shadow-[0_16px_40px_0_rgba(23,35,102,0.25)]"
    },
    direction: {
      row: "tw-flex-row",
      column: "tw-flex-col"
    },
    justify: {
      start: "tw-justify-start",
      center: "tw-justify-center",
      end: "tw-justify-end",
      "space-between": "tw-justify-between",
      "space-around": "tw-justify-around"
    },
    align: {
      start: "tw-items-start",
      center: "tw-items-center",
      end: "tw-items-end",
      stretch: "tw-items-stretch"
    },
    wrap: {
      true: "tw-flex-wrap",
      false: "tw-flex-nowrap"
    },
    clipContent: {
      true: "tw-overflow-hidden",
      false: "tw-overflow-visible"
    },
    gap: {
      none: "tw-gap-0",
      xs: "tw-gap-density-static-padding-xs",
      sm: "tw-gap-density-static-padding-sm",
      md: "tw-gap-density-static-padding-md",
      lg: "tw-gap-density-static-padding-lg",
      xl: "tw-gap-density-static-padding-xl"
    }
  },
  defaultVariants: {
    variant: "light",
    padding: "xs",
    borderRadius: "xs",
    shadow: "none",
    direction: "row",
    justify: "start",
    align: "start",
    wrap: !1,
    clipContent: !1,
    gap: "xs"
  }
}), QI = q(
  ({
    className: e,
    variant: t = "light",
    padding: n = "xs",
    borderRadius: r = "xs",
    shadow: o = "none",
    direction: a = "row",
    justify: i = "start",
    align: s = "start",
    wrap: l = !1,
    clipContent: c = !1,
    gap: u = "xs",
    style: d,
    ...f
  }, p) => /* @__PURE__ */ m(
    "div",
    {
      className: N(
        JI({
          variant: t,
          borderRadius: r,
          padding: n,
          shadow: o,
          direction: a,
          justify: i,
          align: s,
          wrap: l,
          clipContent: c,
          gap: u,
          className: e
        })
      ),
      style: d,
      ref: p,
      ...f,
      children: f.children
    }
  )
);
QI.displayName = "Container";
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function kn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Et(e, t) {
  return (n) => {
    t.setState((r) => ({
      ...r,
      [e]: kn(n, r[e])
    }));
  };
}
function Qi(e) {
  return e instanceof Function;
}
function ZI(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function eM(e, t) {
  const n = [], r = (o) => {
    o.forEach((a) => {
      n.push(a);
      const i = t(a);
      i != null && i.length && r(i);
    });
  };
  return r(e), n;
}
function fe(e, t, n) {
  let r = [], o;
  return (a) => {
    let i;
    n.key && n.debug && (i = Date.now());
    const s = e(a);
    if (!(s.length !== r.length || s.some((u, d) => r[d] !== u)))
      return o;
    r = s;
    let c;
    if (n.key && n.debug && (c = Date.now()), o = t(...s), n == null || n.onChange == null || n.onChange(o), n.key && n.debug && n != null && n.debug()) {
      const u = Math.round((Date.now() - i) * 100) / 100, d = Math.round((Date.now() - c) * 100) / 100, f = d / 16, p = (h, g) => {
        for (h = String(h); h.length < g; )
          h = " " + h;
        return h;
      };
      console.info(`%c⏱ ${p(d, 5)} /${p(u, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * f, 120))}deg 100% 31%);`, n == null ? void 0 : n.key);
    }
    return o;
  };
}
function pe(e, t, n, r) {
  return {
    debug: () => {
      var o;
      return (o = e == null ? void 0 : e.debugAll) != null ? o : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: r
  };
}
function tM(e, t, n, r) {
  const o = () => {
    var i;
    return (i = a.getValue()) != null ? i : e.options.renderFallbackValue;
  }, a = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(r),
    renderValue: o,
    getContext: fe(() => [e, n, t, a], (i, s, l, c) => ({
      table: i,
      column: s,
      row: l,
      cell: c,
      getValue: c.getValue,
      renderValue: c.renderValue
    }), pe(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((i) => {
    i.createCell == null || i.createCell(a, n, t, e);
  }, {}), a;
}
function nM(e, t, n, r) {
  var o, a;
  const s = {
    ...e._getDefaultColumnDef(),
    ...t
  }, l = s.accessorKey;
  let c = (o = (a = s.id) != null ? a : l ? typeof String.prototype.replaceAll == "function" ? l.replaceAll(".", "_") : l.replace(/\./g, "_") : void 0) != null ? o : typeof s.header == "string" ? s.header : void 0, u;
  if (s.accessorFn ? u = s.accessorFn : l && (l.includes(".") ? u = (f) => {
    let p = f;
    for (const g of l.split(".")) {
      var h;
      p = (h = p) == null ? void 0 : h[g], process.env.NODE_ENV !== "production" && p === void 0 && console.warn(`"${g}" in deeply nested key "${l}" returned undefined.`);
    }
    return p;
  } : u = (f) => f[s.accessorKey]), !c)
    throw process.env.NODE_ENV !== "production" ? new Error(s.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let d = {
    id: `${String(c)}`,
    accessorFn: u,
    parent: r,
    depth: n,
    columnDef: s,
    columns: [],
    getFlatColumns: fe(() => [!0], () => {
      var f;
      return [d, ...(f = d.columns) == null ? void 0 : f.flatMap((p) => p.getFlatColumns())];
    }, pe(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: fe(() => [e._getOrderColumnsFn()], (f) => {
      var p;
      if ((p = d.columns) != null && p.length) {
        let h = d.columns.flatMap((g) => g.getLeafColumns());
        return f(h);
      }
      return [d];
    }, pe(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const f of e._features)
    f.createColumn == null || f.createColumn(d, e);
  return d;
}
const nt = "debugHeaders";
function vf(e, t, n) {
  var r;
  let a = {
    id: (r = n.id) != null ? r : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const i = [], s = (l) => {
        l.subHeaders && l.subHeaders.length && l.subHeaders.map(s), i.push(l);
      };
      return s(a), i;
    },
    getContext: () => ({
      table: e,
      header: a,
      column: t
    })
  };
  return e._features.forEach((i) => {
    i.createHeader == null || i.createHeader(a, e);
  }), a;
}
const rM = {
  createTable: (e) => {
    e.getHeaderGroups = fe(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => {
      var a, i;
      const s = (a = r == null ? void 0 : r.map((d) => n.find((f) => f.id === d)).filter(Boolean)) != null ? a : [], l = (i = o == null ? void 0 : o.map((d) => n.find((f) => f.id === d)).filter(Boolean)) != null ? i : [], c = n.filter((d) => !(r != null && r.includes(d.id)) && !(o != null && o.includes(d.id)));
      return Va(t, [...s, ...c, ...l], e);
    }, pe(e.options, nt, "getHeaderGroups")), e.getCenterHeaderGroups = fe(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => (n = n.filter((a) => !(r != null && r.includes(a.id)) && !(o != null && o.includes(a.id))), Va(t, n, e, "center")), pe(e.options, nt, "getCenterHeaderGroups")), e.getLeftHeaderGroups = fe(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, r) => {
      var o;
      const a = (o = r == null ? void 0 : r.map((i) => n.find((s) => s.id === i)).filter(Boolean)) != null ? o : [];
      return Va(t, a, e, "left");
    }, pe(e.options, nt, "getLeftHeaderGroups")), e.getRightHeaderGroups = fe(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, r) => {
      var o;
      const a = (o = r == null ? void 0 : r.map((i) => n.find((s) => s.id === i)).filter(Boolean)) != null ? o : [];
      return Va(t, a, e, "right");
    }, pe(e.options, nt, "getRightHeaderGroups")), e.getFooterGroups = fe(() => [e.getHeaderGroups()], (t) => [...t].reverse(), pe(e.options, nt, "getFooterGroups")), e.getLeftFooterGroups = fe(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), pe(e.options, nt, "getLeftFooterGroups")), e.getCenterFooterGroups = fe(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), pe(e.options, nt, "getCenterFooterGroups")), e.getRightFooterGroups = fe(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), pe(e.options, nt, "getRightFooterGroups")), e.getFlatHeaders = fe(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), pe(e.options, nt, "getFlatHeaders")), e.getLeftFlatHeaders = fe(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), pe(e.options, nt, "getLeftFlatHeaders")), e.getCenterFlatHeaders = fe(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), pe(e.options, nt, "getCenterFlatHeaders")), e.getRightFlatHeaders = fe(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), pe(e.options, nt, "getRightFlatHeaders")), e.getCenterLeafHeaders = fe(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), pe(e.options, nt, "getCenterLeafHeaders")), e.getLeftLeafHeaders = fe(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), pe(e.options, nt, "getLeftLeafHeaders")), e.getRightLeafHeaders = fe(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), pe(e.options, nt, "getRightLeafHeaders")), e.getLeafHeaders = fe(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, r) => {
      var o, a, i, s, l, c;
      return [...(o = (a = t[0]) == null ? void 0 : a.headers) != null ? o : [], ...(i = (s = n[0]) == null ? void 0 : s.headers) != null ? i : [], ...(l = (c = r[0]) == null ? void 0 : c.headers) != null ? l : []].map((u) => u.getLeafHeaders()).flat();
    }, pe(e.options, nt, "getLeafHeaders"));
  }
};
function Va(e, t, n, r) {
  var o, a;
  let i = 0;
  const s = function(f, p) {
    p === void 0 && (p = 1), i = Math.max(i, p), f.filter((h) => h.getIsVisible()).forEach((h) => {
      var g;
      (g = h.columns) != null && g.length && s(h.columns, p + 1);
    }, 0);
  };
  s(e);
  let l = [];
  const c = (f, p) => {
    const h = {
      depth: p,
      id: [r, `${p}`].filter(Boolean).join("_"),
      headers: []
    }, g = [];
    f.forEach((w) => {
      const b = [...g].reverse()[0], y = w.column.depth === h.depth;
      let x, C = !1;
      if (y && w.column.parent ? x = w.column.parent : (x = w.column, C = !0), b && (b == null ? void 0 : b.column) === x)
        b.subHeaders.push(w);
      else {
        const S = vf(n, x, {
          id: [r, p, x.id, w == null ? void 0 : w.id].filter(Boolean).join("_"),
          isPlaceholder: C,
          placeholderId: C ? `${g.filter((R) => R.column === x).length}` : void 0,
          depth: p,
          index: g.length
        });
        S.subHeaders.push(w), g.push(S);
      }
      h.headers.push(w), w.headerGroup = h;
    }), l.push(h), p > 0 && c(g, p - 1);
  }, u = t.map((f, p) => vf(n, f, {
    depth: i,
    index: p
  }));
  c(u, i - 1), l.reverse();
  const d = (f) => f.filter((h) => h.column.getIsVisible()).map((h) => {
    let g = 0, w = 0, b = [0];
    h.subHeaders && h.subHeaders.length ? (b = [], d(h.subHeaders).forEach((x) => {
      let {
        colSpan: C,
        rowSpan: S
      } = x;
      g += C, b.push(S);
    })) : g = 1;
    const y = Math.min(...b);
    return w = w + y, h.colSpan = g, h.rowSpan = w, {
      colSpan: g,
      rowSpan: w
    };
  });
  return d((o = (a = l[0]) == null ? void 0 : a.headers) != null ? o : []), l;
}
const Ou = (e, t, n, r, o, a, i) => {
  let s = {
    id: t,
    index: r,
    original: n,
    depth: o,
    parentId: i,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (l) => {
      if (s._valuesCache.hasOwnProperty(l))
        return s._valuesCache[l];
      const c = e.getColumn(l);
      if (c != null && c.accessorFn)
        return s._valuesCache[l] = c.accessorFn(s.original, r), s._valuesCache[l];
    },
    getUniqueValues: (l) => {
      if (s._uniqueValuesCache.hasOwnProperty(l))
        return s._uniqueValuesCache[l];
      const c = e.getColumn(l);
      if (c != null && c.accessorFn)
        return c.columnDef.getUniqueValues ? (s._uniqueValuesCache[l] = c.columnDef.getUniqueValues(s.original, r), s._uniqueValuesCache[l]) : (s._uniqueValuesCache[l] = [s.getValue(l)], s._uniqueValuesCache[l]);
    },
    renderValue: (l) => {
      var c;
      return (c = s.getValue(l)) != null ? c : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => eM(s.subRows, (l) => l.subRows),
    getParentRow: () => s.parentId ? e.getRow(s.parentId, !0) : void 0,
    getParentRows: () => {
      let l = [], c = s;
      for (; ; ) {
        const u = c.getParentRow();
        if (!u) break;
        l.push(u), c = u;
      }
      return l.reverse();
    },
    getAllCells: fe(() => [e.getAllLeafColumns()], (l) => l.map((c) => tM(e, s, c, c.id)), pe(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: fe(() => [s.getAllCells()], (l) => l.reduce((c, u) => (c[u.column.id] = u, c), {}), pe(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let l = 0; l < e._features.length; l++) {
    const c = e._features[l];
    c == null || c.createRow == null || c.createRow(s, e);
  }
  return s;
}, oM = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, Fv = (e, t, n) => {
  var r, o;
  const a = n == null || (r = n.toString()) == null ? void 0 : r.toLowerCase();
  return !!(!((o = e.getValue(t)) == null || (o = o.toString()) == null || (o = o.toLowerCase()) == null) && o.includes(a));
};
Fv.autoRemove = (e) => At(e);
const zv = (e, t, n) => {
  var r;
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
zv.autoRemove = (e) => At(e);
const Vv = (e, t, n) => {
  var r;
  return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (n == null ? void 0 : n.toLowerCase());
};
Vv.autoRemove = (e) => At(e);
const Bv = (e, t, n) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(n);
};
Bv.autoRemove = (e) => At(e);
const Hv = (e, t, n) => !n.some((r) => {
  var o;
  return !((o = e.getValue(t)) != null && o.includes(r));
});
Hv.autoRemove = (e) => At(e) || !(e != null && e.length);
const Wv = (e, t, n) => n.some((r) => {
  var o;
  return (o = e.getValue(t)) == null ? void 0 : o.includes(r);
});
Wv.autoRemove = (e) => At(e) || !(e != null && e.length);
const jv = (e, t, n) => e.getValue(t) === n;
jv.autoRemove = (e) => At(e);
const Gv = (e, t, n) => e.getValue(t) == n;
Gv.autoRemove = (e) => At(e);
const Du = (e, t, n) => {
  let [r, o] = n;
  const a = e.getValue(t);
  return a >= r && a <= o;
};
Du.resolveFilterValue = (e) => {
  let [t, n] = e, r = typeof t != "number" ? parseFloat(t) : t, o = typeof n != "number" ? parseFloat(n) : n, a = t === null || Number.isNaN(r) ? -1 / 0 : r, i = n === null || Number.isNaN(o) ? 1 / 0 : o;
  if (a > i) {
    const s = a;
    a = i, i = s;
  }
  return [a, i];
};
Du.autoRemove = (e) => At(e) || At(e[0]) && At(e[1]);
const fn = {
  includesString: Fv,
  includesStringSensitive: zv,
  equalsString: Vv,
  arrIncludes: Bv,
  arrIncludesAll: Hv,
  arrIncludesSome: Wv,
  equals: jv,
  weakEquals: Gv,
  inNumberRange: Du
};
function At(e) {
  return e == null || e === "";
}
const aM = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: Et("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      return typeof r == "string" ? fn.includesString : typeof r == "number" ? fn.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? fn.equals : Array.isArray(r) ? fn.arrIncludes : fn.weakEquals;
    }, e.getFilterFn = () => {
      var n, r;
      return Qi(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = t.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? n : fn[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, r, o;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((r = t.options.enableColumnFilters) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((r) => r.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, r;
      return (n = (r = t.getState().columnFilters) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((r) => {
        const o = e.getFilterFn(), a = r == null ? void 0 : r.find((u) => u.id === e.id), i = kn(n, a ? a.value : void 0);
        if (wf(o, i, e)) {
          var s;
          return (s = r == null ? void 0 : r.filter((u) => u.id !== e.id)) != null ? s : [];
        }
        const l = {
          id: e.id,
          value: i
        };
        if (a) {
          var c;
          return (c = r == null ? void 0 : r.map((u) => u.id === e.id ? l : u)) != null ? c : [];
        }
        return r != null && r.length ? [...r, l] : [l];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), r = (o) => {
        var a;
        return (a = kn(t, o)) == null ? void 0 : a.filter((i) => {
          const s = n.find((l) => l.id === i.id);
          if (s) {
            const l = s.getFilterFn();
            if (wf(l, i.value, s))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (t) => {
      var n, r;
      e.setColumnFilters(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function wf(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const iM = (e, t, n) => n.reduce((r, o) => {
  const a = o.getValue(e);
  return r + (typeof a == "number" ? a : 0);
}, 0), sM = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const a = o.getValue(e);
    a != null && (r > a || r === void 0 && a >= a) && (r = a);
  }), r;
}, lM = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const a = o.getValue(e);
    a != null && (r < a || r === void 0 && a >= a) && (r = a);
  }), r;
}, cM = (e, t, n) => {
  let r, o;
  return n.forEach((a) => {
    const i = a.getValue(e);
    i != null && (r === void 0 ? i >= i && (r = o = i) : (r > i && (r = i), o < i && (o = i)));
  }), [r, o];
}, uM = (e, t) => {
  let n = 0, r = 0;
  if (t.forEach((o) => {
    let a = o.getValue(e);
    a != null && (a = +a) >= a && (++n, r += a);
  }), n) return r / n;
}, dM = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((a) => a.getValue(e));
  if (!ZI(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), o = n.sort((a, i) => a - i);
  return n.length % 2 !== 0 ? o[r] : (o[r - 1] + o[r]) / 2;
}, fM = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), pM = (e, t) => new Set(t.map((n) => n.getValue(e))).size, mM = (e, t) => t.length, Ks = {
  sum: iM,
  min: sM,
  max: lM,
  extent: cM,
  mean: uM,
  median: dM,
  unique: fM,
  uniqueCount: pM,
  count: mM
}, gM = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: Et("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((r) => r !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, r;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((r = t.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      if (typeof r == "number")
        return Ks.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return Ks.extent;
    }, e.getAggregationFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return Qi(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (r = t.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? n : Ks[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, r;
      e.setGrouping(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const r = t.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, r) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var o;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((o = n.subRows) != null && o.length);
    };
  }
};
function hM(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const r = e.filter((a) => !t.includes(a.id));
  return n === "remove" ? r : [...t.map((a) => e.find((i) => i.id === a)).filter(Boolean), ...r];
}
const vM = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: Et("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = fe((n) => [Io(t, n)], (n) => n.findIndex((r) => r.id === e.id), pe(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var r;
      return ((r = Io(t, n)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var r;
      const o = Io(t, n);
      return ((r = o[o.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = fe(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, r) => (o) => {
      let a = [];
      if (!(t != null && t.length))
        a = o;
      else {
        const i = [...t], s = [...o];
        for (; s.length && i.length; ) {
          const l = i.shift(), c = s.findIndex((u) => u.id === l);
          c > -1 && a.push(s.splice(c, 1)[0]);
        }
        a = [...a, ...s];
      }
      return hM(a, n, r);
    }, pe(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Xs = () => ({
  left: [],
  right: []
}), wM = {
  getInitialState: (e) => ({
    columnPinning: Xs(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: Et("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const r = e.getLeafColumns().map((o) => o.id).filter(Boolean);
      t.setColumnPinning((o) => {
        var a, i;
        if (n === "right") {
          var s, l;
          return {
            left: ((s = o == null ? void 0 : o.left) != null ? s : []).filter((d) => !(r != null && r.includes(d))),
            right: [...((l = o == null ? void 0 : o.right) != null ? l : []).filter((d) => !(r != null && r.includes(d))), ...r]
          };
        }
        if (n === "left") {
          var c, u;
          return {
            left: [...((c = o == null ? void 0 : o.left) != null ? c : []).filter((d) => !(r != null && r.includes(d))), ...r],
            right: ((u = o == null ? void 0 : o.right) != null ? u : []).filter((d) => !(r != null && r.includes(d)))
          };
        }
        return {
          left: ((a = o == null ? void 0 : o.left) != null ? a : []).filter((d) => !(r != null && r.includes(d))),
          right: ((i = o == null ? void 0 : o.right) != null ? i : []).filter((d) => !(r != null && r.includes(d)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var o, a, i;
      return ((o = r.columnDef.enablePinning) != null ? o : !0) && ((a = (i = t.options.enableColumnPinning) != null ? i : t.options.enablePinning) != null ? a : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((s) => s.id), {
        left: r,
        right: o
      } = t.getState().columnPinning, a = n.some((s) => r == null ? void 0 : r.includes(s)), i = n.some((s) => o == null ? void 0 : o.includes(s));
      return a ? "left" : i ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      return o ? (n = (r = t.getState().columnPinning) == null || (r = r[o]) == null ? void 0 : r.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = fe(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, r, o) => {
      const a = [...r ?? [], ...o ?? []];
      return n.filter((i) => !a.includes(i.column.id));
    }, pe(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = fe(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, r) => (r ?? []).map((a) => n.find((i) => i.column.id === a)).filter(Boolean).map((a) => ({
      ...a,
      position: "left"
    })), pe(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = fe(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, r) => (r ?? []).map((a) => n.find((i) => i.column.id === a)).filter(Boolean).map((a) => ({
      ...a,
      position: "right"
    })), pe(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, r;
      return e.setColumnPinning(t ? Xs() : (n = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? n : Xs());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const r = e.getState().columnPinning;
      if (!t) {
        var o, a;
        return !!((o = r.left) != null && o.length || (a = r.right) != null && a.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e.getLeftLeafColumns = fe(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), pe(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = fe(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), pe(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = fe(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r) => {
      const o = [...n ?? [], ...r ?? []];
      return t.filter((a) => !o.includes(a.id));
    }, pe(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, Ba = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, Js = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), bM = {
  getDefaultColumnDef: () => Ba,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: Js(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: Et("columnSizing", e),
    onColumnSizingInfoChange: Et("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, r, o;
      const a = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : Ba.minSize, (r = a ?? e.columnDef.size) != null ? r : Ba.size), (o = e.columnDef.maxSize) != null ? o : Ba.maxSize);
    }, e.getStart = fe((n) => [n, Io(t, n), t.getState().columnSizing], (n, r) => r.slice(0, e.getIndex(n)).reduce((o, a) => o + a.getSize(), 0), pe(t.options, "debugColumns", "getStart")), e.getAfter = fe((n) => [n, Io(t, n), t.getState().columnSizing], (n, r) => r.slice(e.getIndex(n) + 1).reduce((o, a) => o + a.getSize(), 0), pe(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: r,
          ...o
        } = n;
        return o;
      });
    }, e.getCanResize = () => {
      var n, r;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((r = t.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const r = (o) => {
        if (o.subHeaders.length)
          o.subHeaders.forEach(r);
        else {
          var a;
          n += (a = o.column.getSize()) != null ? a : 0;
        }
      };
      return r(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const r = t.getColumn(e.column.id), o = r == null ? void 0 : r.getCanResize();
      return (a) => {
        if (!r || !o || (a.persist == null || a.persist(), Qs(a) && a.touches && a.touches.length > 1))
          return;
        const i = e.getSize(), s = e ? e.getLeafHeaders().map((b) => [b.column.id, b.column.getSize()]) : [[r.id, r.getSize()]], l = Qs(a) ? Math.round(a.touches[0].clientX) : a.clientX, c = {}, u = (b, y) => {
          typeof y == "number" && (t.setColumnSizingInfo((x) => {
            var C, S;
            const R = t.options.columnResizeDirection === "rtl" ? -1 : 1, E = (y - ((C = x == null ? void 0 : x.startOffset) != null ? C : 0)) * R, M = Math.max(E / ((S = x == null ? void 0 : x.startSize) != null ? S : 0), -0.999999);
            return x.columnSizingStart.forEach((F) => {
              let [G, U] = F;
              c[G] = Math.round(Math.max(U + U * M, 0) * 100) / 100;
            }), {
              ...x,
              deltaOffset: E,
              deltaPercentage: M
            };
          }), (t.options.columnResizeMode === "onChange" || b === "end") && t.setColumnSizing((x) => ({
            ...x,
            ...c
          })));
        }, d = (b) => u("move", b), f = (b) => {
          u("end", b), t.setColumnSizingInfo((y) => ({
            ...y,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, p = n || typeof document < "u" ? document : null, h = {
          moveHandler: (b) => d(b.clientX),
          upHandler: (b) => {
            p == null || p.removeEventListener("mousemove", h.moveHandler), p == null || p.removeEventListener("mouseup", h.upHandler), f(b.clientX);
          }
        }, g = {
          moveHandler: (b) => (b.cancelable && (b.preventDefault(), b.stopPropagation()), d(b.touches[0].clientX), !1),
          upHandler: (b) => {
            var y;
            p == null || p.removeEventListener("touchmove", g.moveHandler), p == null || p.removeEventListener("touchend", g.upHandler), b.cancelable && (b.preventDefault(), b.stopPropagation()), f((y = b.touches[0]) == null ? void 0 : y.clientX);
          }
        }, w = yM() ? {
          passive: !1
        } : !1;
        Qs(a) ? (p == null || p.addEventListener("touchmove", g.moveHandler, w), p == null || p.addEventListener("touchend", g.upHandler, w)) : (p == null || p.addEventListener("mousemove", h.moveHandler, w), p == null || p.addEventListener("mouseup", h.upHandler, w)), t.setColumnSizingInfo((b) => ({
          ...b,
          startOffset: l,
          startSize: i,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: s,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? Js() : (n = e.initialState.columnSizingInfo) != null ? n : Js());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    };
  }
};
let Ha = null;
function yM() {
  if (typeof Ha == "boolean") return Ha;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return Ha = e, Ha;
}
function Qs(e) {
  return e.type === "touchstart";
}
const xM = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: Et("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((r) => ({
        ...r,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, r;
      const o = e.columns;
      return (n = o.length ? o.some((a) => a.getIsVisible()) : (r = t.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, r;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((r = t.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = fe(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), pe(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = fe(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, r, o) => [...n, ...r, ...o], pe(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, r) => fe(() => [r(), r().filter((o) => o.getIsVisible()).map((o) => o.id).join("_")], (o) => o.filter((a) => a.getIsVisible == null ? void 0 : a.getIsVisible()), pe(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var r;
      e.setColumnVisibility(n ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((o, a) => ({
        ...o,
        [a.id]: n || !(a.getCanHide != null && a.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      e.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
};
function Io(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const SM = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, CM = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: Et("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, r, o, a;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = t.options.enableGlobalFilter) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && ((a = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? a : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => fn.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: r
      } = e.options;
      return Qi(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[r]) != null ? t : fn[r];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, EM = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: Et("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var o, a;
      e.setExpanded(r ? {} : (o = (a = e.initialState) == null ? void 0 : a.expanded) != null ? o : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((o) => !o.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((a) => {
        const i = a.split(".");
        r = Math.max(r, i.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((r) => {
        var o;
        const a = r === !0 ? !0 : !!(r != null && r[e.id]);
        let i = {};
        if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((s) => {
          i[s] = !0;
        }) : i = r, n = (o = n) != null ? o : !a, !a && n)
          return {
            ...i,
            [e.id]: !0
          };
        if (a && !n) {
          const {
            [e.id]: s,
            ...l
          } = i;
          return l;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var n;
      const r = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : r === !0 || r != null && r[e.id]);
    }, e.getCanExpand = () => {
      var n, r, o;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((r = t.options.enableExpanding) != null ? r : !0) && !!((o = e.subRows) != null && o.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, r = e;
      for (; n && r.parentId; )
        r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, Wl = 0, jl = 10, Zs = () => ({
  pageIndex: Wl,
  pageSize: jl
}), kM = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...Zs(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: Et("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (r) => {
      const o = (a) => kn(r, a);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(o);
    }, e.resetPagination = (r) => {
      var o;
      e.setPagination(r ? Zs() : (o = e.initialState.pagination) != null ? o : Zs());
    }, e.setPageIndex = (r) => {
      e.setPagination((o) => {
        let a = kn(r, o.pageIndex);
        const i = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return a = Math.max(0, Math.min(a, i)), {
          ...o,
          pageIndex: a
        };
      });
    }, e.resetPageIndex = (r) => {
      var o, a;
      e.setPageIndex(r ? Wl : (o = (a = e.initialState) == null || (a = a.pagination) == null ? void 0 : a.pageIndex) != null ? o : Wl);
    }, e.resetPageSize = (r) => {
      var o, a;
      e.setPageSize(r ? jl : (o = (a = e.initialState) == null || (a = a.pagination) == null ? void 0 : a.pageSize) != null ? o : jl);
    }, e.setPageSize = (r) => {
      e.setPagination((o) => {
        const a = Math.max(1, kn(r, o.pageSize)), i = o.pageSize * o.pageIndex, s = Math.floor(i / a);
        return {
          ...o,
          pageIndex: s,
          pageSize: a
        };
      });
    }, e.setPageCount = (r) => e.setPagination((o) => {
      var a;
      let i = kn(r, (a = e.options.pageCount) != null ? a : -1);
      return typeof i == "number" && (i = Math.max(-1, i)), {
        ...o,
        pageCount: i
      };
    }), e.getPageOptions = fe(() => [e.getPageCount()], (r) => {
      let o = [];
      return r && r > 0 && (o = [...new Array(r)].fill(null).map((a, i) => i)), o;
    }, pe(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, o = e.getPageCount();
      return o === -1 ? !0 : o === 0 ? !1 : r < o - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, el = () => ({
  top: [],
  bottom: []
}), RM = {
  getInitialState: (e) => ({
    rowPinning: el(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: Et("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, r, o) => {
      const a = r ? e.getLeafRows().map((l) => {
        let {
          id: c
        } = l;
        return c;
      }) : [], i = o ? e.getParentRows().map((l) => {
        let {
          id: c
        } = l;
        return c;
      }) : [], s = /* @__PURE__ */ new Set([...i, e.id, ...a]);
      t.setRowPinning((l) => {
        var c, u;
        if (n === "bottom") {
          var d, f;
          return {
            top: ((d = l == null ? void 0 : l.top) != null ? d : []).filter((g) => !(s != null && s.has(g))),
            bottom: [...((f = l == null ? void 0 : l.bottom) != null ? f : []).filter((g) => !(s != null && s.has(g))), ...Array.from(s)]
          };
        }
        if (n === "top") {
          var p, h;
          return {
            top: [...((p = l == null ? void 0 : l.top) != null ? p : []).filter((g) => !(s != null && s.has(g))), ...Array.from(s)],
            bottom: ((h = l == null ? void 0 : l.bottom) != null ? h : []).filter((g) => !(s != null && s.has(g)))
          };
        }
        return {
          top: ((c = l == null ? void 0 : l.top) != null ? c : []).filter((g) => !(s != null && s.has(g))),
          bottom: ((u = l == null ? void 0 : l.bottom) != null ? u : []).filter((g) => !(s != null && s.has(g)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: o
      } = t.options;
      return typeof r == "function" ? r(e) : (n = r ?? o) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: r,
        bottom: o
      } = t.getState().rowPinning, a = n.some((s) => r == null ? void 0 : r.includes(s)), i = n.some((s) => o == null ? void 0 : o.includes(s));
      return a ? "top" : i ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      if (!o) return -1;
      const a = (n = o === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((i) => {
        let {
          id: s
        } = i;
        return s;
      });
      return (r = a == null ? void 0 : a.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, r;
      return e.setRowPinning(t ? el() : (n = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? n : el());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const r = e.getState().rowPinning;
      if (!t) {
        var o, a;
        return !!((o = r.top) != null && o.length || (a = r.bottom) != null && a.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, r) => {
      var o;
      return ((o = e.options.keepPinnedRows) == null || o ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((i) => {
          const s = e.getRow(i, !0);
          return s.getIsAllParentsExpanded() ? s : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((i) => t.find((s) => s.id === i))
      )).filter(Boolean).map((i) => ({
        ...i,
        position: r
      }));
    }, e.getTopRows = fe(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), pe(e.options, "debugRows", "getTopRows")), e.getBottomRows = fe(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), pe(e.options, "debugRows", "getBottomRows")), e.getCenterRows = fe(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, r) => {
      const o = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return t.filter((a) => !o.has(a.id));
    }, pe(e.options, "debugRows", "getCenterRows"));
  }
}, PM = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: Et("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const r = {
          ...n
        }, o = e.getPreGroupedRowModel().flatRows;
        return t ? o.forEach((a) => {
          a.getCanSelect() && (r[a.id] = !0);
        }) : o.forEach((a) => {
          delete r[a.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const r = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), o = {
        ...n
      };
      return e.getRowModel().rows.forEach((a) => {
        Gl(o, a.id, r, !0, e);
      }), o;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = fe(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? tl(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, pe(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = fe(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? tl(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, pe(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = fe(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? tl(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, pe(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let r = !!(t.length && Object.keys(n).length);
      return r && t.some((o) => o.getCanSelect() && !n[o.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((o) => o.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let r = !!t.length;
      return r && t.some((o) => !n[o.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, r) => {
      const o = e.getIsSelected();
      t.setRowSelection((a) => {
        var i;
        if (n = typeof n < "u" ? n : !o, e.getCanSelect() && o === n)
          return a;
        const s = {
          ...a
        };
        return Gl(s, e.id, n, (i = r == null ? void 0 : r.selectChildren) != null ? i : !0, t), s;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Au(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Ul(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Ul(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (r) => {
        var o;
        n && e.toggleSelected((o = r.target) == null ? void 0 : o.checked);
      };
    };
  }
}, Gl = (e, t, n, r, o) => {
  var a;
  const i = o.getRow(t, !0);
  n ? (i.getCanMultiSelect() || Object.keys(e).forEach((s) => delete e[s]), i.getCanSelect() && (e[t] = !0)) : delete e[t], r && (a = i.subRows) != null && a.length && i.getCanSelectSubRows() && i.subRows.forEach((s) => Gl(e, s.id, n, r, o));
};
function tl(e, t) {
  const n = e.getState().rowSelection, r = [], o = {}, a = function(i, s) {
    return i.map((l) => {
      var c;
      const u = Au(l, n);
      if (u && (r.push(l), o[l.id] = l), (c = l.subRows) != null && c.length && (l = {
        ...l,
        subRows: a(l.subRows)
      }), u)
        return l;
    }).filter(Boolean);
  };
  return {
    rows: a(t.rows),
    flatRows: r,
    rowsById: o
  };
}
function Au(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function Ul(e, t, n) {
  var r;
  if (!((r = e.subRows) != null && r.length)) return !1;
  let o = !0, a = !1;
  return e.subRows.forEach((i) => {
    if (!(a && !o) && (i.getCanSelect() && (Au(i, t) ? a = !0 : o = !1), i.subRows && i.subRows.length)) {
      const s = Ul(i, t);
      s === "all" ? a = !0 : (s === "some" && (a = !0), o = !1);
    }
  }), o ? "all" : a ? "some" : !1;
}
const ql = /([0-9]+)/gm, NM = (e, t, n) => Uv(On(e.getValue(n)).toLowerCase(), On(t.getValue(n)).toLowerCase()), TM = (e, t, n) => Uv(On(e.getValue(n)), On(t.getValue(n))), _M = (e, t, n) => $u(On(e.getValue(n)).toLowerCase(), On(t.getValue(n)).toLowerCase()), IM = (e, t, n) => $u(On(e.getValue(n)), On(t.getValue(n))), MM = (e, t, n) => {
  const r = e.getValue(n), o = t.getValue(n);
  return r > o ? 1 : r < o ? -1 : 0;
}, OM = (e, t, n) => $u(e.getValue(n), t.getValue(n));
function $u(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function On(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function Uv(e, t) {
  const n = e.split(ql).filter(Boolean), r = t.split(ql).filter(Boolean);
  for (; n.length && r.length; ) {
    const o = n.shift(), a = r.shift(), i = parseInt(o, 10), s = parseInt(a, 10), l = [i, s].sort();
    if (isNaN(l[0])) {
      if (o > a)
        return 1;
      if (a > o)
        return -1;
      continue;
    }
    if (isNaN(l[1]))
      return isNaN(i) ? -1 : 1;
    if (i > s)
      return 1;
    if (s > i)
      return -1;
  }
  return n.length - r.length;
}
const mo = {
  alphanumeric: NM,
  alphanumericCaseSensitive: TM,
  text: _M,
  textCaseSensitive: IM,
  datetime: MM,
  basic: OM
}, DM = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: Et("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const o of n) {
        const a = o == null ? void 0 : o.getValue(e.id);
        if (Object.prototype.toString.call(a) === "[object Date]")
          return mo.datetime;
        if (typeof a == "string" && (r = !0, a.split(ql).length > 1))
          return mo.alphanumeric;
      }
      return r ? mo.text : mo.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof (n == null ? void 0 : n.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return Qi(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (r = t.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? n : mo[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, r) => {
      const o = e.getNextSortingOrder(), a = typeof n < "u" && n !== null;
      t.setSorting((i) => {
        const s = i == null ? void 0 : i.find((p) => p.id === e.id), l = i == null ? void 0 : i.findIndex((p) => p.id === e.id);
        let c = [], u, d = a ? n : o === "desc";
        if (i != null && i.length && e.getCanMultiSort() && r ? s ? u = "toggle" : u = "add" : i != null && i.length && l !== i.length - 1 ? u = "replace" : s ? u = "toggle" : u = "replace", u === "toggle" && (a || o || (u = "remove")), u === "add") {
          var f;
          c = [...i, {
            id: e.id,
            desc: d
          }], c.splice(0, c.length - ((f = t.options.maxMultiSortColCount) != null ? f : Number.MAX_SAFE_INTEGER));
        } else u === "toggle" ? c = i.map((p) => p.id === e.id ? {
          ...p,
          desc: d
        } : p) : u === "remove" ? c = i.filter((p) => p.id !== e.id) : c = [{
          id: e.id,
          desc: d
        }];
        return c;
      });
    }, e.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = e.columnDef.sortDescFirst) != null ? r : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var r, o;
      const a = e.getFirstSortDir(), i = e.getIsSorted();
      return i ? i !== a && ((r = t.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (o = t.options.enableMultiRemove) != null) || o) ? !1 : i === "desc" ? "asc" : "desc" : a;
    }, e.getCanSort = () => {
      var n, r;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((r = t.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, r;
      return (n = (r = e.columnDef.enableMultiSort) != null ? r : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const r = (n = t.getState().sorting) == null ? void 0 : n.find((o) => o.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, r;
      return (n = (r = t.getState().sorting) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, r;
      e.setSorting(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, AM = [
  rM,
  xM,
  vM,
  wM,
  oM,
  aM,
  SM,
  //depends on ColumnFaceting
  CM,
  //depends on ColumnFiltering
  DM,
  gM,
  //depends on RowSorting
  EM,
  kM,
  RM,
  PM,
  bM
];
function $M(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...AM, ...(t = e._features) != null ? t : []];
  let o = {
    _features: r
  };
  const a = o._features.reduce((f, p) => Object.assign(f, p.getDefaultOptions == null ? void 0 : p.getDefaultOptions(o)), {}), i = (f) => o.options.mergeOptions ? o.options.mergeOptions(a, f) : {
    ...a,
    ...f
  };
  let l = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  o._features.forEach((f) => {
    var p;
    l = (p = f.getInitialState == null ? void 0 : f.getInitialState(l)) != null ? p : l;
  });
  const c = [];
  let u = !1;
  const d = {
    _features: r,
    options: {
      ...a,
      ...e
    },
    initialState: l,
    _queue: (f) => {
      c.push(f), u || (u = !0, Promise.resolve().then(() => {
        for (; c.length; )
          c.shift()();
        u = !1;
      }).catch((p) => setTimeout(() => {
        throw p;
      })));
    },
    reset: () => {
      o.setState(o.initialState);
    },
    setOptions: (f) => {
      const p = kn(f, o.options);
      o.options = i(p);
    },
    getState: () => o.options.state,
    setState: (f) => {
      o.options.onStateChange == null || o.options.onStateChange(f);
    },
    _getRowId: (f, p, h) => {
      var g;
      return (g = o.options.getRowId == null ? void 0 : o.options.getRowId(f, p, h)) != null ? g : `${h ? [h.id, p].join(".") : p}`;
    },
    getCoreRowModel: () => (o._getCoreRowModel || (o._getCoreRowModel = o.options.getCoreRowModel(o)), o._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => o.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (f, p) => {
      let h = (p ? o.getPrePaginationRowModel() : o.getRowModel()).rowsById[f];
      if (!h && (h = o.getCoreRowModel().rowsById[f], !h))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${f}`) : new Error();
      return h;
    },
    _getDefaultColumnDef: fe(() => [o.options.defaultColumn], (f) => {
      var p;
      return f = (p = f) != null ? p : {}, {
        header: (h) => {
          const g = h.header.column.columnDef;
          return g.accessorKey ? g.accessorKey : g.accessorFn ? g.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (h) => {
          var g, w;
          return (g = (w = h.renderValue()) == null || w.toString == null ? void 0 : w.toString()) != null ? g : null;
        },
        ...o._features.reduce((h, g) => Object.assign(h, g.getDefaultColumnDef == null ? void 0 : g.getDefaultColumnDef()), {}),
        ...f
      };
    }, pe(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => o.options.columns,
    getAllColumns: fe(() => [o._getColumnDefs()], (f) => {
      const p = function(h, g, w) {
        return w === void 0 && (w = 0), h.map((b) => {
          const y = nM(o, b, w, g), x = b;
          return y.columns = x.columns ? p(x.columns, y, w + 1) : [], y;
        });
      };
      return p(f);
    }, pe(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: fe(() => [o.getAllColumns()], (f) => f.flatMap((p) => p.getFlatColumns()), pe(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: fe(() => [o.getAllFlatColumns()], (f) => f.reduce((p, h) => (p[h.id] = h, p), {}), pe(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: fe(() => [o.getAllColumns(), o._getOrderColumnsFn()], (f, p) => {
      let h = f.flatMap((g) => g.getLeafColumns());
      return p(h);
    }, pe(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (f) => {
      const p = o._getAllFlatColumnsById()[f];
      return process.env.NODE_ENV !== "production" && !p && console.error(`[Table] Column with id '${f}' does not exist.`), p;
    }
  };
  Object.assign(o, d);
  for (let f = 0; f < o._features.length; f++) {
    const p = o._features[f];
    p == null || p.createTable == null || p.createTable(o);
  }
  return o;
}
function LM() {
  return (e) => fe(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(o, a, i) {
      a === void 0 && (a = 0);
      const s = [];
      for (let c = 0; c < o.length; c++) {
        const u = Ou(e, e._getRowId(o[c], c, i), o[c], c, a, void 0, i == null ? void 0 : i.id);
        if (n.flatRows.push(u), n.rowsById[u.id] = u, s.push(u), e.options.getSubRows) {
          var l;
          u.originalSubRows = e.options.getSubRows(o[c], c), (l = u.originalSubRows) != null && l.length && (u.subRows = r(u.originalSubRows, a + 1, u));
        }
      }
      return s;
    };
    return n.rows = r(t), n;
  }, pe(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function FM() {
  return (e) => fe(() => [e.getState().expanded, e.getPreExpandedRowModel(), e.options.paginateExpandedRows], (t, n, r) => !n.rows.length || t !== !0 && !Object.keys(t ?? {}).length || !r ? n : qv(n), pe(e.options, "debugTable", "getExpandedRowModel"));
}
function qv(e) {
  const t = [], n = (r) => {
    var o;
    t.push(r), (o = r.subRows) != null && o.length && r.getIsExpanded() && r.subRows.forEach(n);
  };
  return e.rows.forEach(n), {
    rows: t,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function zM(e, t, n) {
  return n.options.filterFromLeafRows ? VM(e, t, n) : BM(e, t, n);
}
function VM(e, t, n) {
  var r;
  const o = [], a = {}, i = (r = n.options.maxLeafRowFilterDepth) != null ? r : 100, s = function(l, c) {
    c === void 0 && (c = 0);
    const u = [];
    for (let f = 0; f < l.length; f++) {
      var d;
      let p = l[f];
      const h = Ou(n, p.id, p.original, p.index, p.depth, void 0, p.parentId);
      if (h.columnFilters = p.columnFilters, (d = p.subRows) != null && d.length && c < i) {
        if (h.subRows = s(p.subRows, c + 1), p = h, t(p) && !h.subRows.length) {
          u.push(p), a[p.id] = p, o.push(p);
          continue;
        }
        if (t(p) || h.subRows.length) {
          u.push(p), a[p.id] = p, o.push(p);
          continue;
        }
      } else
        p = h, t(p) && (u.push(p), a[p.id] = p, o.push(p));
    }
    return u;
  };
  return {
    rows: s(e),
    flatRows: o,
    rowsById: a
  };
}
function BM(e, t, n) {
  var r;
  const o = [], a = {}, i = (r = n.options.maxLeafRowFilterDepth) != null ? r : 100, s = function(l, c) {
    c === void 0 && (c = 0);
    const u = [];
    for (let f = 0; f < l.length; f++) {
      let p = l[f];
      if (t(p)) {
        var d;
        if ((d = p.subRows) != null && d.length && c < i) {
          const g = Ou(n, p.id, p.original, p.index, p.depth, void 0, p.parentId);
          g.subRows = s(p.subRows, c + 1), p = g;
        }
        u.push(p), o.push(p), a[p.id] = p;
      }
    }
    return u;
  };
  return {
    rows: s(e),
    flatRows: o,
    rowsById: a
  };
}
function HM() {
  return (e) => fe(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter], (t, n, r) => {
    if (!t.rows.length || !(n != null && n.length) && !r) {
      for (let f = 0; f < t.flatRows.length; f++)
        t.flatRows[f].columnFilters = {}, t.flatRows[f].columnFiltersMeta = {};
      return t;
    }
    const o = [], a = [];
    (n ?? []).forEach((f) => {
      var p;
      const h = e.getColumn(f.id);
      if (!h)
        return;
      const g = h.getFilterFn();
      if (!g) {
        process.env.NODE_ENV !== "production" && console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${h.id}.`);
        return;
      }
      o.push({
        id: f.id,
        filterFn: g,
        resolvedValue: (p = g.resolveFilterValue == null ? void 0 : g.resolveFilterValue(f.value)) != null ? p : f.value
      });
    });
    const i = (n ?? []).map((f) => f.id), s = e.getGlobalFilterFn(), l = e.getAllLeafColumns().filter((f) => f.getCanGlobalFilter());
    r && s && l.length && (i.push("__global__"), l.forEach((f) => {
      var p;
      a.push({
        id: f.id,
        filterFn: s,
        resolvedValue: (p = s.resolveFilterValue == null ? void 0 : s.resolveFilterValue(r)) != null ? p : r
      });
    }));
    let c, u;
    for (let f = 0; f < t.flatRows.length; f++) {
      const p = t.flatRows[f];
      if (p.columnFilters = {}, o.length)
        for (let h = 0; h < o.length; h++) {
          c = o[h];
          const g = c.id;
          p.columnFilters[g] = c.filterFn(p, g, c.resolvedValue, (w) => {
            p.columnFiltersMeta[g] = w;
          });
        }
      if (a.length) {
        for (let h = 0; h < a.length; h++) {
          u = a[h];
          const g = u.id;
          if (u.filterFn(p, g, u.resolvedValue, (w) => {
            p.columnFiltersMeta[g] = w;
          })) {
            p.columnFilters.__global__ = !0;
            break;
          }
        }
        p.columnFilters.__global__ !== !0 && (p.columnFilters.__global__ = !1);
      }
    }
    const d = (f) => {
      for (let p = 0; p < i.length; p++)
        if (f.columnFilters[i[p]] === !1)
          return !1;
      return !0;
    };
    return zM(t.rows, d, e);
  }, pe(e.options, "debugTable", "getFilteredRowModel", () => e._autoResetPageIndex()));
}
function WM(e) {
  return (t) => fe(() => [t.getState().pagination, t.getPrePaginationRowModel(), t.options.paginateExpandedRows ? void 0 : t.getState().expanded], (n, r) => {
    if (!r.rows.length)
      return r;
    const {
      pageSize: o,
      pageIndex: a
    } = n;
    let {
      rows: i,
      flatRows: s,
      rowsById: l
    } = r;
    const c = o * a, u = c + o;
    i = i.slice(c, u);
    let d;
    t.options.paginateExpandedRows ? d = {
      rows: i,
      flatRows: s,
      rowsById: l
    } : d = qv({
      rows: i,
      flatRows: s,
      rowsById: l
    }), d.flatRows = [];
    const f = (p) => {
      d.flatRows.push(p), p.subRows.length && p.subRows.forEach(f);
    };
    return d.rows.forEach(f), d;
  }, pe(t.options, "debugTable", "getPaginationRowModel"));
}
function jM() {
  return (e) => fe(() => [e.getState().sorting, e.getPreSortedRowModel()], (t, n) => {
    if (!n.rows.length || !(t != null && t.length))
      return n;
    const r = e.getState().sorting, o = [], a = r.filter((l) => {
      var c;
      return (c = e.getColumn(l.id)) == null ? void 0 : c.getCanSort();
    }), i = {};
    a.forEach((l) => {
      const c = e.getColumn(l.id);
      c && (i[l.id] = {
        sortUndefined: c.columnDef.sortUndefined,
        invertSorting: c.columnDef.invertSorting,
        sortingFn: c.getSortingFn()
      });
    });
    const s = (l) => {
      const c = l.map((u) => ({
        ...u
      }));
      return c.sort((u, d) => {
        for (let p = 0; p < a.length; p += 1) {
          var f;
          const h = a[p], g = i[h.id], w = g.sortUndefined, b = (f = h == null ? void 0 : h.desc) != null ? f : !1;
          let y = 0;
          if (w) {
            const x = u.getValue(h.id), C = d.getValue(h.id), S = x === void 0, R = C === void 0;
            if (S || R) {
              if (w === "first") return S ? -1 : 1;
              if (w === "last") return S ? 1 : -1;
              y = S && R ? 0 : S ? w : -w;
            }
          }
          if (y === 0 && (y = g.sortingFn(u, d, h.id)), y !== 0)
            return b && (y *= -1), g.invertSorting && (y *= -1), y;
        }
        return u.index - d.index;
      }), c.forEach((u) => {
        var d;
        o.push(u), (d = u.subRows) != null && d.length && (u.subRows = s(u.subRows));
      }), c;
    };
    return {
      rows: s(n.rows),
      flatRows: o,
      rowsById: n.rowsById
    };
  }, pe(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function bf(e, t) {
  return e ? GM(e) ? /* @__PURE__ */ v.createElement(e, t) : e : null;
}
function GM(e) {
  return UM(e) || typeof e == "function" || qM(e);
}
function UM(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function qM(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function YM(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = v.useState(() => ({
    current: $M(t)
  })), [r, o] = v.useState(() => n.current.initialState);
  return n.current.setOptions((a) => ({
    ...a,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (i) => {
      o(i), e.onStateChange == null || e.onStateChange(i);
    }
  })), n.current;
}
const KM = "tw-text-semantic-static-foreground-neutral-darkest tw-p-density-static-padding-xs tw-text-left tw-align-middle [&:has([role=checkbox])]:tw-pr-0 [&>[role=checkbox]]:tw-translate-y-[2px] ", XM = "tw-text-muted-foreground tw-mt-4 tw-caption-bottom tw-body-lg-medium tw-text-semantic-static-foreground-neutral-default ", JM = "tw-align-middle [&:has([role=checkbox])]:tw-pr-0 [&>[role=checkbox]]:tw-translate-y-[2px] ", QM = "[&_tr:last-child]:tw-border-0 ", ZM = "tw-transition-colors ", eO = "tw-w-full tw-body-md-regular tw-leading-5 [&>thead>tr]:tw-body-md-bold ", tO = oe(eO, {
  variants: {
    variant: {
      line: "[&>tbody>tr]:tw-border-y-density-static-default [&>tbody>tr]:tw-border-semantic-action-border-neutral-weaker tw-text-semantic-static-foreground-neutral-darkest [&>tbody>tr:nth-child(odd)]:tw-bg-semantic-static-background-neutral-default [&>tbody>tr:nth-child(even)]:tw-bg-semantic-static-background-neutral-default [&>tbody>tr:nth-child(odd).selected]:tw-bg-semantic-action-background-primary-weaker [&>tbody>tr:nth-child(even).selected]:tw-bg-semantic-action-background-primary-weaker [&>thead>tr]:tw-text-semantic-static-foreground-neutral-darkest [&>thead>tr]:tw-border-semantic-action-border-neutral-weaker [&>thead>tr]:tw-border-b-semantic-action-border-neutral-weaker ",
      // header border-color
      striped: "tw-text-semantic-static-foreground-neutral-darkest [&>thead>tr]:tw-text-semantic-static-foreground-primary-default [&>thead]:tw-border-b-tw-decoration-semantic-action-border-primary-lighter [&>thead>tr]:tw-border-semantic-action-border-neutral-weaker [&>tbody>tr]:tw-border-y tw-border-transparent ",
      // row border
      stripedBlue: "tw-text-semantic-static-foreground-neutral-darkest [&>thead>tr]:tw-text-semantic-static-foreground-neutral-darkest [&>thead]:tw-border-b-tw-decoration-semantic-action-border-primary-lighter [&>thead>tr]:tw-border-semantic-action-border-neutral-weaker [&>tbody>tr]:tw-border-y tw-border-transparent "
      // row border
    },
    stripedPattern: {
      firstWeak: "",
      firstStrong: ""
    },
    density: {
      expanded: "[&>tbody>tr>td]:tw-p-density-action-padding-md [&>thead>tr>th]:tw-p-density-action-padding-md ",
      default: "[&>tbody>tr>td]:tw-p-density-action-padding-sm [&>thead>tr>th]:tw-p-density-action-padding-sm ",
      compact: "[&>tbody>tr>td]:tw-p-density-action-padding-2xs [&>thead>tr>th]:tw-p-density-action-padding-2xs "
    },
    hoverEffect: {
      true: "[&>tbody>tr:nth-child(odd):hover]:tw-bg-semantic-action-background-primary-weakest [&>tbody>tr:nth-child(even):hover]:tw-bg-semantic-action-background-primary-weakest ",
      false: ""
      // no hover effect
    }
  },
  compoundVariants: [{
    variant: "striped",
    stripedPattern: "firstWeak",
    class: "[&>tbody>tr]:tw-border-transparent [&>tbody>tr:nth-child(odd)]:tw-bg-semantic-action-background-neutral-white [&>tbody>tr:nth-child(odd).selected]:tw-bg-semantic-action-background-primary-weaker [&>tbody>tr:nth-child(even)]:tw-bg-semantic-action-background-neutral-weakest [&>tbody>tr:nth-child(even).selected]:tw-bg-semantic-action-background-primary-weaker "
    // row(even) background-color selected
  }, {
    variant: "striped",
    stripedPattern: "firstStrong",
    class: "[&>tbody>tr]:tw-border-transparent [&>tbody>tr:nth-child(even)]:tw-bg-semantic-action-background-neutral-white [&>tbody>tr:nth-child(even).selected]:tw-bg-semantic-action-background-primary-weaker [&>tbody>tr:nth-child(odd)]:tw-bg-semantic-action-background-neutral-weakest [&>tbody>tr:nth-child(odd).selected]:tw-bg-semantic-action-background-primary-weaker "
    // row(even) background-color selected
  }, {
    variant: "stripedBlue",
    stripedPattern: "firstWeak",
    class: "[&>tbody>tr]:tw-border-transparent [&>tbody>tr:nth-child(odd)]:tw-bg-semantic-action-background-neutral-white [&>tbody>tr:nth-child(odd).selected]:tw-bg-semantic-action-background-primary-weaker [&>tbody>tr:nth-child(even)]:tw-bg-semantic-action-background-primary-2xweakest [&>tbody>tr:nth-child(even).selected]:tw-bg-semantic-action-background-primary-weaker "
    // row(even) background-color selected
  }, {
    variant: "stripedBlue",
    stripedPattern: "firstStrong",
    class: "[&>tbody>tr]:tw-border-transparent [&>tbody>tr:nth-child(even)]:tw-bg-semantic-action-background-neutral-white [&>tbody>tr:nth-child(even).selected]:tw-bg-semantic-action-background-primary-weaker [&>tbody>tr:nth-child(odd)]:tw-bg-semantic-action-background-primary-2xweakest [&>tbody>tr:nth-child(odd).selected]:tw-bg-semantic-action-background-primary-weaker "
    // row(even) background-color selected
  }],
  defaultVariants: {
    variant: "striped",
    stripedPattern: "firstWeak",
    hoverEffect: !0
  }
}), Yv = q(
  ({
    className: e,
    variant: t = "striped",
    stripedPattern: n = "firstWeak",
    density: r = "default",
    disableHoverEffect: o = !1,
    ...a
  }, i) => /* @__PURE__ */ m(
    "table",
    {
      ref: i,
      className: N(
        tO({ variant: t, stripedPattern: n, density: r, hoverEffect: !o }),
        e
      ),
      ...a
    }
  )
);
Yv.displayName = "Table";
const Kv = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m("thead", { ref: n, className: N(e), ...t })
);
Kv.displayName = "TableHeader";
const Xv = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    "tbody",
    {
      ref: n,
      className: N(QM, e),
      ...t
    }
  )
);
Xv.displayName = "TableBody";
const ni = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m("tr", { ref: n, className: N(ZM, e), ...t })
);
ni.displayName = "TableRow";
const Jv = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    "th",
    {
      ref: n,
      className: N(KM, e),
      ...t
    }
  )
);
Jv.displayName = "TableHead";
const Yl = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    "td",
    {
      ref: n,
      className: N(JM, e),
      ...t
    }
  )
);
Yl.displayName = "TableCell";
const nO = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    "caption",
    {
      ref: n,
      className: N(XM, e),
      ...t
    }
  )
);
nO.displayName = "TableCaption";
const rO = "active:!tw-bg-semantic-action-background-primary-weaker", oO = ({
  table: e,
  variant: t,
  stripedPattern: n,
  density: r,
  onRowClick: o,
  onRowClickInactiveTargetNames: a,
  renderExpandableRowData: i,
  mouseVisualEffects: s
}) => {
  const l = (u) => typeof u.header == "function", c = (u, d) => {
    const f = a || ["button", "a"];
    u.target instanceof HTMLElement && f.includes(u.target.nodeName.toLowerCase()) || o == null || o(d);
  };
  return /* @__PURE__ */ ee(
    Yv,
    {
      variant: t,
      stripedPattern: n,
      density: r,
      disableHoverEffect: !(s != null && s.hoverEffect),
      children: [
        /* @__PURE__ */ m(
          Kv,
          { children: e.getHeaderGroups().map(
            (u) => /* @__PURE__ */ m(
              ni,
              { children: u.headers.map((d) => {
                const f = d.column.columnDef;
                return /* @__PURE__ */ m(
                  Jv,
                  {
                    className: f.headerClassName,
                    children: d.column.columnDef.header ? bf(
                      d.column.columnDef.header,
                      d.getContext()
                    ) : ""
                  },
                  d.id
                );
              }) },
              u.id
            )
          ) }
        ),
        /* @__PURE__ */ m(
          Xv,
          { className: "tw-group", children: e.getRowModel().rows.map(
            (u) => /* @__PURE__ */ ee(
              p0,
              { children: [
                /* @__PURE__ */ m(
                  ni,
                  {
                    "data-state": u.getIsSelected() ? "selected" : "undefined",
                    className: md.cn(
                      u.getIsSelected() ? "selected" : "",
                      (s == null ? void 0 : s.activeEffect) && rO,
                      o ? "tw-cursor-pointer" : ""
                    ),
                    onClick: o && ((d) => c(d, u)),
                    children: u.getVisibleCells().map((d) => {
                      var g, w, b;
                      const f = d.column.columnDef, p = f.cellClassName ? f.cellClassName(u, d.column.columnDef) : "", h = l(f);
                      return /* @__PURE__ */ m(
                        Yl,
                        {
                          className: md.cn(
                            f.colClassName,
                            p,
                            (g = f.colClassName) != null && g.includes("tw-text-right") ? "!tw-pr-density-action-padding-xl" : "",
                            h ? (w = f.colClassName) != null && w.includes("tw-text-right") ? "!tw-pr-density-action-padding-xl" : (b = f.colClassName) != null && b.includes("tw-text-center") ? "!tw-px-density-action-padding-xl" : "!tw-pl-density-action-padding-xl" : ""
                          ),
                          children: bf(d.column.columnDef.cell, d.getContext())
                        },
                        d.id
                      );
                    })
                  }
                ),
                u.getIsExpanded() && u.original.expandableRowData && /* @__PURE__ */ m(
                  ni,
                  { children: /* @__PURE__ */ m(
                    Yl,
                    { colSpan: u.getVisibleCells().length, children: i ? i(u.original.expandableRowData) : JSON.stringify(u.original.expandableRowData) }
                  ) }
                )
              ] },
              u.id
            )
          ) }
        )
      ]
    }
  );
}, M3 = ({
  columns: e,
  data: t,
  variant: n = "striped",
  stripedPattern: r = "firstWeak",
  density: o = "default",
  selectableRows: a = !1,
  selectedRowIds: i = {},
  onRowSelectionChange: s,
  singleSelection: l,
  onRowClick: c,
  onRowClickInactiveTargetNames: u,
  enableRowSelection: d,
  initialSortingState: f = [],
  manualSorting: p = !1,
  pageIndex: h = 0,
  pageSize: g,
  filters: w,
  children: b,
  useIdAsIdentifier: y,
  onLoadMore: x,
  isLoadingMore: C = !1,
  loadMoreLoaderHidden: S = !1,
  expandableRows: R = !1,
  renderExpandableRowData: E,
  mouseVisualEffects: M = {
    activeEffect: !0,
    hoverEffect: !0
  }
}) => {
  const [F, G] = ye(f), U = (I) => d && d(I), H = !x && !!g, j = {
    id: "selection",
    header: ({ table: I }) => /* @__PURE__ */ m(
      "div",
      { className: "tw-pl-density-action-padding-md", children: !l && /* @__PURE__ */ m(
        zl,
        {
          label: "Select all",
          isLabelHidden: !0,
          className: "!tw-min-h-0 ",
          checked: I.getIsAllPageRowsSelected() ? !0 : I.getIsSomePageRowsSelected() ? "indeterminate" : !1,
          onCheckedChange: (W) => {
            I.toggleAllPageRowsSelected(!!W);
          },
          "aria-label": "Select all"
        }
      ) }
    ),
    cell: ({ row: I }) => U(I) ? /* @__PURE__ */ m(
      zl,
      {
        label: `Select row ${I.index}`,
        isLabelHidden: !0,
        className: "-tw-ml-[2px] !tw-min-h-0",
        checked: I.getIsSelected(),
        onCheckedChange: (W) => {
          l ? Y.setRowSelection(W ? { [I.id]: !0 } : {}) : I.toggleSelected(!!W);
        },
        "aria-label": "Select row"
      }
    ) : /* @__PURE__ */ m(Ne, {})
  }, z = {
    id: "expander",
    header: () => null,
    cell: ({ row: I }) => I.getCanExpand() ? /* @__PURE__ */ m(pt, { onClick: I.getToggleExpandedHandler(), variant: "ghost", iconLeft: I.getIsExpanded() ? "chevron-down" : "chevron-right" }) : null
  }, Z = wc(
    () => [
      ...a ? [j] : [],
      ...e.map((I) => ({
        ...I,
        filterFn: I.filterFn || "includesString",
        accessorKey: I.accessor
      })),
      ...R ? [z] : []
    ],
    [e, a, l, j]
  ), Y = YM({
    data: t,
    columns: Z,
    getRowId: (I, W) => y && I.id != null ? String(I.id) : String(W),
    state: {
      rowSelection: i,
      sorting: F,
      ...H && {
        pagination: {
          pageSize: g,
          pageIndex: h
        }
      },
      columnFilters: w
    },
    getCoreRowModel: LM(),
    enableRowSelection: d,
    onSortingChange: G,
    getSortedRowModel: jM(),
    manualSorting: p,
    onRowSelectionChange: s,
    getFilteredRowModel: HM(),
    ...H && { getPaginationRowModel: WM() },
    ...R && {
      getExpandedRowModel: FM(),
      enableExpanding: !0,
      getRowCanExpand: () => !0
    }
  }), O = qe(null);
  return ke(() => {
    if (!x || C) return;
    const I = new IntersectionObserver(([A]) => {
      A.isIntersecting && x();
    }, {
      rootMargin: "100px",
      threshold: 1
    }), W = O.current;
    return W && I.observe(W), () => {
      W && I.unobserve(W);
    };
  }, [x, C]), /* @__PURE__ */ ee(
    Ne,
    { children: [
      /* @__PURE__ */ m(
        oO,
        {
          table: Y,
          variant: n,
          stripedPattern: r,
          density: o,
          onRowClick: c,
          onRowClickInactiveTargetNames: u,
          renderExpandableRowData: E,
          mouseVisualEffects: M
        }
      ),
      b && b(Y),
      !!x && /* @__PURE__ */ m(
        "div",
        { ref: O, className: "tw-w-full tw-bg-transparent", children: C && !S && /* @__PURE__ */ m(
          "div",
          { className: "tw-flex tw-justify-center tw-pt-4 tw-pb-12", children: /* @__PURE__ */ m(nm, { size: "sm" }) }
        ) }
      )
    ] }
  );
}, O3 = [
  {
    header: "ID",
    accessor: "id",
    colClassName: ""
  },
  {
    header: "Status",
    accessor: "status",
    colClassName: ""
  },
  {
    header: "Email",
    accessor: "email",
    colClassName: "text-blue-500"
  },
  {
    header: "Amount",
    accessor: "amount",
    colClassName: ""
  }
], D3 = [
  {
    header: "ID",
    accessor: "id"
  },
  {
    header: "Part Number",
    accessor: "partNumber"
  },
  {
    header: ({ column: e }) => /* @__PURE__ */ ee(
      pt,
      {
        variant: "ghost",
        size: "md",
        onClick: () => e.toggleSorting(e.getIsSorted() === "asc"),
        children: [
          "Amount",
          e.getCanSort() && // Conditionally render the icon
          /* @__PURE__ */ m(
            Ne,
            { children: e.getIsSorted() === "desc" ? /* @__PURE__ */ m(de, { icon: "arrow-down", "aria-label": "sorted descending" }) : e.getIsSorted() === "asc" ? /* @__PURE__ */ m(de, { icon: "arrow-up", "aria-label": "sorted ascending" }) : /* @__PURE__ */ m(de, { icon: "arrow-down-up", "aria-label": "sorted ascending" }) }
          )
        ]
      }
    ),
    accessor: "amount"
  },
  {
    header: "Shipping Date",
    accessor: "shippingDate"
  },
  {
    header: "City",
    accessor: "city"
  }
], A3 = [
  {
    header: "ID",
    accessor: "id",
    colClassName: ""
  },
  {
    header: "Status",
    accessor: "status",
    colClassName: "",
    cell: ({ row: e }) => e.original.cell ? e.original.cell({ row: e }) : e.original.status
  },
  {
    header: "Email",
    accessor: "email"
  },
  {
    header: "Amount",
    accessor: "amount",
    colClassName: ""
  }
], $3 = [
  {
    header: "ID",
    accessor: "id",
    colClassName: ""
  },
  {
    header: "Status",
    accessor: "status",
    colClassName: "",
    cell: ({ row: e }) => e.original.cell ? e.original.cell({ row: e }) : e.original.status
  },
  {
    header: "Email",
    accessor: "email"
  },
  {
    header: "Amount",
    accessor: "amount",
    cellClassName: (e) => e.original.amount === 5180 ? "tw-bg-red-500" : "",
    colClassName: ""
  }
], L3 = [
  {
    header: "ID",
    accessor: "id",
    colClassName: ""
  },
  {
    header: ({ column: e }) => /* @__PURE__ */ ee(
      pt,
      {
        variant: "ghost",
        size: "md",
        onClick: () => e.toggleSorting(e.getIsSorted() === "asc"),
        children: [
          "Status",
          e.getCanSort() && // Conditionally render the icon
          /* @__PURE__ */ m(
            Ne,
            { children: e.getIsSorted() === "desc" ? /* @__PURE__ */ m(de, { icon: "arrow-down", "aria-label": "sorted descending" }) : e.getIsSorted() === "asc" ? /* @__PURE__ */ m(de, { icon: "arrow-up", "aria-label": "sorted ascending" }) : /* @__PURE__ */ m(de, { icon: "arrow-down-up", "aria-label": "sorted ascending" }) }
          )
        ]
      }
    ),
    accessor: "status",
    colClassName: "",
    cell: ({ row: e }) => e.original.cell ? e.original.cell({ row: e }) : e.original.status
  },
  {
    header: "Email",
    accessor: "email",
    colClassName: ""
  },
  {
    header: ({ column: e }) => /* @__PURE__ */ ee(
      pt,
      {
        variant: "ghost",
        size: "md",
        onClick: () => {
          e.getIsSorted() ? e.toggleSorting(e.getIsSorted() === "asc") : e.toggleSorting(!0);
        },
        children: [
          "Amount",
          e.getCanSort() && // Conditionally render the icon
          /* @__PURE__ */ m(
            Ne,
            { children: e.getIsSorted() === "desc" ? /* @__PURE__ */ m(de, { icon: "arrow-down", "aria-label": "sorted descending" }) : e.getIsSorted() === "asc" ? /* @__PURE__ */ m(de, { icon: "arrow-up", "aria-label": "sorted ascending" }) : /* @__PURE__ */ m(de, { icon: "arrow-down-up", "aria-label": "sorted ascending" }) }
          )
        ]
      }
    ),
    accessor: "amount",
    colClassName: ""
  }
], F3 = [
  {
    header: "ID",
    accessor: "id",
    colClassName: ""
  },
  {
    header: ({ column: e }) => /* @__PURE__ */ ee(
      pt,
      {
        variant: "ghost",
        size: "md",
        onClick: () => e.toggleSorting(e.getIsSorted() === "asc"),
        children: [
          "Current Status",
          e.getCanSort() && // Conditionally render the icon
          /* @__PURE__ */ m(
            Ne,
            { children: e.getIsSorted() === "desc" ? /* @__PURE__ */ m(de, { icon: "arrow-down", "aria-label": "sorted descending" }) : e.getIsSorted() === "asc" ? /* @__PURE__ */ m(de, { icon: "arrow-up", "aria-label": "sorted ascending" }) : /* @__PURE__ */ m(de, { icon: "arrow-down-up", "aria-label": "sorted ascending" }) }
          )
        ]
      }
    ),
    accessor: "status",
    colClassName: "!tw-text-center",
    headerClassName: "!tw-text-center",
    cell: ({ row: e }) => e.original.cell ? e.original.cell({ row: e }) : e.original.status
  },
  {
    header: "Email",
    accessor: "email",
    colClassName: ""
  },
  {
    header: ({ column: e }) => /* @__PURE__ */ ee(
      pt,
      {
        variant: "ghost",
        size: "md",
        onClick: () => e.toggleSorting(e.getIsSorted() === "asc"),
        children: [
          "Amount",
          e.getCanSort() && // Conditionally render the icon
          /* @__PURE__ */ m(
            Ne,
            { children: e.getIsSorted() === "desc" ? /* @__PURE__ */ m(de, { icon: "arrow-down", "aria-label": "sorted descending" }) : e.getIsSorted() === "asc" ? /* @__PURE__ */ m(de, { icon: "arrow-up", "aria-label": "sorted ascending" }) : /* @__PURE__ */ m(de, { icon: "arrow-down-up", "aria-label": "sorted ascending" }) }
          )
        ]
      }
    ),
    accessor: "amount",
    colClassName: "!tw-text-right",
    headerClassName: "!tw-text-right"
  }
], aO = {
  pending: "yellow",
  processing: "blue",
  failed: "red",
  success: "green"
  // Default or additional status
}, Wa = ({ row: e }) => {
  const t = aO[e.original.status];
  return /* @__PURE__ */ m(zg, { color: t, children: e.original.status });
}, z3 = [
  {
    id: "123",
    amount: 100,
    status: "pending",
    email: "m@example.com",
    cell: Wa,
    rowClassName: ""
  },
  {
    id: "321",
    amount: 180,
    status: "success",
    email: "m@example.com",
    cell: Wa
  },
  {
    id: "341",
    amount: 140,
    status: "failed",
    email: "m@example.com",
    cell: Wa
  },
  {
    id: "411",
    amount: 5180,
    status: "processing",
    email: "m@example.com",
    cell: Wa
  }
], V3 = [
  {
    id: "123",
    amount: 100,
    status: "pending",
    email: "m@example.com",
    rowClassName: ""
  },
  {
    id: "321",
    amount: 180,
    status: "success",
    email: "m@example.com"
  },
  {
    id: "341",
    amount: 140,
    status: "pending",
    email: "m@example.com"
  },
  {
    id: "411",
    amount: 5180,
    status: "success",
    email: "m@example.com"
  },
  {
    id: "124",
    amount: 101,
    status: "pending",
    email: "m@example.com",
    rowClassName: ""
  },
  {
    id: "322",
    amount: 181,
    status: "success",
    email: "m@example.com"
  },
  {
    id: "342",
    amount: 141,
    status: "pending",
    email: "m@example.com"
  },
  {
    id: "412",
    amount: 5181,
    status: "success",
    email: "m@example.com"
  },
  {
    id: "125",
    amount: 102,
    status: "pending",
    email: "m@example.com",
    rowClassName: ""
  },
  {
    id: "323",
    amount: 182,
    status: "success",
    email: "m@example.com"
  },
  {
    id: "343",
    amount: 142,
    status: "pending",
    email: "m@example.com"
  },
  {
    id: "413",
    amount: 5182,
    status: "success",
    email: "m@example.com"
  }
], B3 = [
  {
    id: "123",
    amount: 100,
    status: "pending",
    email: "m@example.com",
    rowClassName: ""
  },
  {
    id: "321",
    amount: 180,
    status: "success",
    email: "m@example.com",
    rowClassName: ""
  },
  {
    id: "341",
    amount: 140,
    status: "pending",
    email: "m@example.com",
    rowClassName: ""
  },
  {
    id: "411",
    amount: 5180,
    status: "success",
    email: "m@example.com",
    rowClassName: "!tw-bg-gray-300"
  }
], H3 = Array.from({ length: 50 }, (e, t) => {
  const n = ["Cracow", "Berlin", "Madrid", "Paris", "Amsterdam", "Vienna", "London", "Budapest", "Rome", "Prague"], r = n[t % n.length];
  return {
    id: t.toString(),
    partNumber: `${1e3 + t * 1234 % 9e3}-${2e3 + t * 4321 % 9e3}`,
    amount: (t * 17 + 5) % 101,
    shippingDate: new Date(2025, t % 12, 1 + t * 3 % 28, 8 + t % 10, t * 7 % 60).toISOString(),
    city: r
  };
}), W3 = Array.from({ length: 30 }, (e, t) => ({
  id: String(t),
  partNumber: `${6e3 + t}-${Math.floor(1e3 + Math.random() * 9e3)}`,
  amount: Math.floor(Math.random() * 100) + 1,
  shippingDate: new Date(
    2025,
    Math.floor(Math.random() * 12),
    Math.floor(Math.random() * 28) + 1
  ).toISOString(),
  city: ["Cracow", "Berlin", "London", "Paris", "Madrid", "Warsaw", "Rome"][Math.floor(Math.random() * 7)],
  expandableRowData: [
    {
      type: "delivery",
      message: "Urgent delivery required. Handle with care.",
      priority: "high"
    },
    {
      type: "shipping",
      message: "Delayed due to customs. Expected next week.",
      priority: "medium"
    },
    {
      type: "return",
      message: "Partially damaged in last shipment.",
      priority: "low"
    }
  ][Math.floor(Math.random() * 3)]
})), j3 = ({
  date: e,
  dateFormat: t = "US",
  showTime: n = !1,
  showDayOfWeek: r = !1,
  relative: o = !1,
  className: a
}) => {
  if (!e)
    return /* @__PURE__ */ m("span", { className: "tw-text-red-500", children: "Invalid date: no date provided" });
  const i = new Date(e);
  return !tv(i) || i.toString() === "Invalid Date" ? /* @__PURE__ */ m("span", { className: "tw-text-red-500", children: "Invalid date format" }) : o ? /* @__PURE__ */ m(
    "span",
    { className: a, children: GN(i, { addSuffix: !0 }) }
  ) : /* @__PURE__ */ m("span", { className: a, children: (() => {
    let l = t === "US" ? "MM/dd/yyyy" : "dd/MM/yyyy";
    return r && (l = `EEE, ${l}`), n && (l = `${l} hh:mm aa`), Bn(i, l);
  })() });
}, Qv = "tw-bg-brand-neutral-white tw-z-[100] tw-min-w-[12rem] tw-rounded-md tw-border tw-p-1 tw-shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=top]:slide-in-from-bottom-2 tw-duration-200", Lu = oe('tw-relative tw-flex tw-cursor-pointer tw-select-none tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-text-sm tw-outline-none tw-transition-colors hover:tw-bg-semantic-action-background-neutral-weaker data-[highlighted]:tw-bg-semantic-action-background-neutral-weaker data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50 data-[state="checked"]:tw-bg-semantic-action-background-primary-weakest'), iO = oe(`${Lu()} tw-relative tw-pl-8 data-[state="checked"]:tw-bg-transparent data-[highlighted]:!tw-bg-semantic-action-background-neutral-weaker `, {
  variants: {
    checked: {
      true: "tw-bg-transparent tw-font-[500]"
    }
  }
}), Zv = "tw-absolute tw-left-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", sO = "tw-text-semantic-fg-neutral-strong", lO = "tw-px-2 tw-py-1.5 tw-text-sm tw-font-semibold tw-text-semantic-fg-neutral-strong", cO = "tw--mx-1 tw-my-1 tw-h-px tw-bg-semantic-action-border-neutral-weak", uO = "tw-ml-auto tw-text-xs tw-tracking-widest tw-text-semantic-fg-neutral-weak", dO = "tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-text-sm tw-outline-none tw-transition-colors hover:tw-bg-semantic-action-background-neutral-weaker data-[state=open]:tw-bg-semantic-action-background-neutral-weaker", fO = Qv, pO = `${Lu()} tw-relative tw-pl-8`, mO = Zv, ew = ({ selected: e }) => /* @__PURE__ */ m(
  de,
  {
    size: "sm",
    icon: e ? "checkbox-checked" : "checkbox-unchecked",
    className: N("tw-items-center", !e && "tw-opacity-40")
  }
), G3 = Kh, U3 = mu, q3 = CP, Y3 = gu, K3 = RP, X3 = EP, gO = q(
  ({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ ee(
    Gi,
    {
      ref: o,
      className: N(dO, t && "tw-pl-8", e),
      ...r,
      children: [
        n,
        /* @__PURE__ */ m(de, { icon: "chevron-right", size: "sm", className: "tw-ml-auto" })
      ]
    }
  )
);
gO.displayName = Gi.displayName;
const hO = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    Ui,
    {
      ref: n,
      className: N(fO, e),
      ...t
    }
  )
);
hO.displayName = Ui.displayName;
const vO = q(
  ({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ m(
    gu,
    { children: /* @__PURE__ */ m(
      Wi,
      {
        ref: r,
        sideOffset: t,
        className: N(Qv, e),
        ...n
      }
    ) }
  )
);
vO.displayName = Wi.displayName;
const wO = q(
  ({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ m(
    ji,
    {
      ref: r,
      className: N(Lu(), t && "tw-pl-8", e),
      ...n
    }
  )
);
wO.displayName = ji.displayName;
const bO = q(
  ({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ ee(
    Jh,
    {
      ref: o,
      className: N(
        iO({ checked: !!n }),
        e
      ),
      checked: n,
      ...r,
      children: [
        /* @__PURE__ */ m(
          "span",
          { className: Zv, children: /* @__PURE__ */ m(ew, { selected: n === !0 }) }
        ),
        t
      ]
    }
  )
);
bO.displayName = Jh.displayName;
const yO = q(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ee(
    Qh,
    {
      ref: r,
      className: N(pO, e),
      ...n,
      children: [
        /* @__PURE__ */ m(
          "span",
          { className: mO, children: /* @__PURE__ */ m(
            kP,
            { children: /* @__PURE__ */ m(
              de,
              {
                icon: "check",
                size: "sm",
                className: sO
              }
            ) }
          ) }
        ),
        t
      ]
    }
  )
);
yO.displayName = Qh.displayName;
const xO = q(
  ({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ m(
    Xh,
    {
      ref: r,
      className: N(lO, t && "tw-pl-8", e),
      ...n
    }
  )
);
xO.displayName = Xh.displayName;
const SO = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    Zh,
    {
      ref: n,
      className: N(cO, e),
      ...t
    }
  )
);
SO.displayName = Zh.displayName;
const CO = ({
  className: e,
  ...t
}) => /* @__PURE__ */ m("span", { className: N(uO, e), ...t });
CO.displayName = "DropdownMenuShortcut";
function EO(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const tw = B.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), va = () => {
  const e = B.useContext(tw);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
EO(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function kO() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function RO() {
  return Fu(/^Mac/);
}
function PO() {
  return Fu(/^iPhone/);
}
function yf() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function NO() {
  return Fu(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  RO() && navigator.maxTouchPoints > 1;
}
function nw() {
  return PO() || NO();
}
function Fu(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const TO = 24, _O = typeof window < "u" ? bc : ke;
function xf(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const nl = typeof document < "u" && window.visualViewport;
function Sf(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function rw(e) {
  for (Sf(e) && (e = e.parentElement); e && !Sf(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const IO = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let ja = 0, rl;
function MO(e = {}) {
  let { isDisabled: t } = e;
  _O(() => {
    if (!t)
      return ja++, ja === 1 && nw() && (rl = OO()), () => {
        ja--, ja === 0 && (rl == null || rl());
      };
  }, [
    t
  ]);
}
function OO() {
  let e, t = 0, n = (d) => {
    e = rw(d.target), !(e === document.documentElement && e === document.body) && (t = d.changedTouches[0].pageY);
  }, r = (d) => {
    if (!e || e === document.documentElement || e === document.body) {
      d.preventDefault();
      return;
    }
    let f = d.changedTouches[0].pageY, p = e.scrollTop, h = e.scrollHeight - e.clientHeight;
    h !== 0 && ((p <= 0 && f > t || p >= h && f < t) && d.preventDefault(), t = f);
  }, o = (d) => {
    let f = d.target;
    Kl(f) && f !== document.activeElement && (d.preventDefault(), f.style.transform = "translateY(-2000px)", f.focus(), requestAnimationFrame(() => {
      f.style.transform = "";
    }));
  }, a = (d) => {
    let f = d.target;
    Kl(f) && (f.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      f.style.transform = "", nl && (nl.height < window.innerHeight ? requestAnimationFrame(() => {
        Cf(f);
      }) : nl.addEventListener("resize", () => Cf(f), {
        once: !0
      }));
    }));
  }, i = () => {
    window.scrollTo(0, 0);
  }, s = window.pageXOffset, l = window.pageYOffset, c = xf(DO(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let u = xf(go(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), go(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), go(document, "touchend", o, {
    passive: !1,
    capture: !0
  }), go(document, "focus", a, !0), go(window, "scroll", i));
  return () => {
    c(), u(), window.scrollTo(s, l);
  };
}
function DO(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function go(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function Cf(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = rw(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, o = e.getBoundingClientRect().top, a = e.getBoundingClientRect().bottom;
      const i = n.getBoundingClientRect().bottom + TO;
      a > i && (n.scrollTop += o - r);
    }
    e = n.parentElement;
  }
}
function Kl(e) {
  return e instanceof HTMLInputElement && !IO.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function AO(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function $O(...e) {
  return (t) => e.forEach((n) => AO(n, t));
}
function ow(...e) {
  return v.useCallback($O(...e), e);
}
const aw = /* @__PURE__ */ new WeakMap();
function Ue(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let r = {};
  Object.entries(t).forEach(([o, a]) => {
    if (o.startsWith("--")) {
      e.style.setProperty(o, a);
      return;
    }
    r[o] = e.style[o], e.style[o] = a;
  }), !n && aw.set(e, r);
}
function LO(e, t) {
  if (!e || !(e instanceof HTMLElement)) return;
  let n = aw.get(e);
  n && (e.style[t] = n[t]);
}
const Ge = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function Ga(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let o = r.match(/^matrix3d\((.+)\)$/);
  return o ? parseFloat(o[1].split(", ")[Ge(t) ? 13 : 12]) : (o = r.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[Ge(t) ? 5 : 4]) : null);
}
function FO(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function ol(e, t) {
  if (!e) return () => {
  };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function zO(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const He = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, iw = 0.4, VO = 0.25, BO = 100, sw = 8, Ua = 16, Xl = 26, al = "vaul-dragging";
function lw(e) {
  const t = B.useRef(e);
  return B.useEffect(() => {
    t.current = e;
  }), B.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function HO({ defaultProp: e, onChange: t }) {
  const n = B.useState(e), [r] = n, o = B.useRef(r), a = lw(t);
  return B.useEffect(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
function cw({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = HO({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, i = a ? e : r, s = lw(n), l = B.useCallback((c) => {
    if (a) {
      const d = typeof c == "function" ? c(e) : c;
      d !== e && s(d);
    } else
      o(c);
  }, [
    a,
    e,
    o,
    s
  ]);
  return [
    i,
    l
  ];
}
function WO({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: o, fadeFromIndex: a, onSnapPointChange: i, direction: s = "bottom", container: l, snapToSequentialPoint: c }) {
  const [u, d] = cw({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [f, p] = B.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  B.useEffect(() => {
    function E() {
      p({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", E), () => window.removeEventListener("resize", E);
  }, []);
  const h = B.useMemo(() => u === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    u
  ]), g = B.useMemo(() => {
    var E;
    return (E = n == null ? void 0 : n.findIndex((M) => M === u)) != null ? E : null;
  }, [
    n,
    u
  ]), w = n && n.length > 0 && (a || a === 0) && !Number.isNaN(a) && n[a] === u || !n, b = B.useMemo(() => {
    const E = l ? {
      width: l.getBoundingClientRect().width,
      height: l.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var M;
    return (M = n == null ? void 0 : n.map((F) => {
      const G = typeof F == "string";
      let U = 0;
      if (G && (U = parseInt(F, 10)), Ge(s)) {
        const j = G ? U : f ? F * E.height : 0;
        return f ? s === "bottom" ? E.height - j : -E.height + j : j;
      }
      const H = G ? U : f ? F * E.width : 0;
      return f ? s === "right" ? E.width - H : -E.width + H : H;
    })) != null ? M : [];
  }, [
    n,
    f,
    l
  ]), y = B.useMemo(() => g !== null ? b == null ? void 0 : b[g] : null, [
    b,
    g
  ]), x = B.useCallback((E) => {
    var M;
    const F = (M = b == null ? void 0 : b.findIndex((G) => G === E)) != null ? M : null;
    i(F), Ue(r.current, {
      transition: `transform ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      transform: Ge(s) ? `translate3d(0, ${E}px, 0)` : `translate3d(${E}px, 0, 0)`
    }), b && F !== b.length - 1 && a !== void 0 && F !== a && F < a ? Ue(o.current, {
      transition: `opacity ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      opacity: "0"
    }) : Ue(o.current, {
      transition: `opacity ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      opacity: "1"
    }), d(n == null ? void 0 : n[Math.max(F, 0)]);
  }, [
    r.current,
    n,
    b,
    a,
    o,
    d
  ]);
  B.useEffect(() => {
    if (u || e) {
      var E;
      const M = (E = n == null ? void 0 : n.findIndex((F) => F === e || F === u)) != null ? E : -1;
      b && M !== -1 && typeof b[M] == "number" && x(b[M]);
    }
  }, [
    u,
    e,
    n,
    b,
    x
  ]);
  function C({ draggedDistance: E, closeDrawer: M, velocity: F, dismissible: G }) {
    if (a === void 0) return;
    const U = s === "bottom" || s === "right" ? (y ?? 0) - E : (y ?? 0) + E, H = g === a - 1, j = g === 0, z = E > 0;
    if (H && Ue(o.current, {
      transition: `opacity ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`
    }), !c && F > 2 && !z) {
      G ? M() : x(b[0]);
      return;
    }
    if (!c && F > 2 && z && b && n) {
      x(b[n.length - 1]);
      return;
    }
    const Z = b == null ? void 0 : b.reduce((O, I) => typeof O != "number" || typeof I != "number" ? O : Math.abs(I - U) < Math.abs(O - U) ? I : O), Y = Ge(s) ? window.innerHeight : window.innerWidth;
    if (F > iw && Math.abs(E) < Y * 0.4) {
      const O = z ? 1 : -1;
      if (O > 0 && h && n) {
        x(b[n.length - 1]);
        return;
      }
      if (j && O < 0 && G && M(), g === null) return;
      x(b[g + O]);
      return;
    }
    x(Z);
  }
  function S({ draggedDistance: E }) {
    if (y === null) return;
    const M = s === "bottom" || s === "right" ? y - E : y + E;
    (s === "bottom" || s === "right") && M < b[b.length - 1] || (s === "top" || s === "left") && M > b[b.length - 1] || Ue(r.current, {
      transform: Ge(s) ? `translate3d(0, ${M}px, 0)` : `translate3d(${M}px, 0, 0)`
    });
  }
  function R(E, M) {
    if (!n || typeof g != "number" || !b || a === void 0) return null;
    const F = g === a - 1;
    if (g >= a && M)
      return 0;
    if (F && !M) return 1;
    if (!w && !F) return null;
    const U = F ? g + 1 : g - 1, H = F ? b[U] - b[U - 1] : b[U + 1] - b[U], j = E / Math.abs(H);
    return F ? 1 - j : j;
  }
  return {
    isLastSnapPoint: h,
    activeSnapPoint: u,
    shouldFade: w,
    getPercentageDragged: R,
    setActiveSnapPoint: d,
    activeSnapPointIndex: g,
    onRelease: C,
    onDrag: S,
    snapPointsOffset: b
  };
}
const jO = () => () => {
};
function GO() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: o } = va(), a = B.useRef(null), i = wc(() => document.body.style.backgroundColor, []);
  function s() {
    return (window.innerWidth - Xl) / window.innerWidth;
  }
  B.useEffect(() => {
    if (t && n) {
      a.current && clearTimeout(a.current);
      const l = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!l) return;
      zO(r && !o ? ol(document.body, {
        background: "black"
      }) : jO, ol(l, {
        transformOrigin: Ge(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${He.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${He.EASE.join(",")})`
      }));
      const c = ol(l, {
        borderRadius: `${sw}px`,
        overflow: "hidden",
        ...Ge(e) ? {
          transform: `scale(${s()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${s()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        c(), a.current = window.setTimeout(() => {
          i ? document.body.style.background = i : document.body.style.removeProperty("background");
        }, He.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    i
  ]);
}
let ho = null;
function UO({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: o, noBodyStyles: a }) {
  const [i, s] = B.useState(() => typeof window < "u" ? window.location.href : ""), l = B.useRef(0), c = B.useCallback(() => {
    if (yf() && ho === null && e && !a) {
      ho = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: d, innerHeight: f } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-l.current}px`,
        left: `${-d}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const p = f - window.innerHeight;
        p && l.current >= f && (document.body.style.top = `${-(l.current + p)}px`);
      }), 300);
    }
  }, [
    e
  ]), u = B.useCallback(() => {
    if (yf() && ho !== null && !a) {
      const d = -parseInt(document.body.style.top, 10), f = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, ho), window.requestAnimationFrame(() => {
        if (o && i !== window.location.href) {
          s(window.location.href);
          return;
        }
        window.scrollTo(f, d);
      }), ho = null;
    }
  }, [
    i
  ]);
  return B.useEffect(() => {
    function d() {
      l.current = window.scrollY;
    }
    return d(), window.addEventListener("scroll", d), () => {
      window.removeEventListener("scroll", d);
    };
  }, []), B.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || u();
      };
  }, [
    t,
    u
  ]), B.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && c(), t || window.setTimeout(() => {
      u();
    }, 500)) : u());
  }, [
    e,
    r,
    i,
    t,
    n,
    c,
    u
  ]), {
    restorePositionSetting: u
  };
}
function qO({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: o, snapPoints: a, shouldScaleBackground: i = !1, setBackgroundColorOnScale: s = !0, closeThreshold: l = VO, scrollLockTimeout: c = BO, dismissible: u = !0, handleOnly: d = !1, fadeFromIndex: f = a && a.length - 1, activeSnapPoint: p, setActiveSnapPoint: h, fixed: g, modal: w = !0, onClose: b, nested: y, noBodyStyles: x = !1, direction: C = "bottom", defaultOpen: S = !1, disablePreventScroll: R = !0, snapToSequentialPoint: E = !1, preventScrollRestoration: M = !1, repositionInputs: F = !0, onAnimationEnd: G, container: U, autoFocus: H = !1 }) {
  var j, z;
  const [Z = !1, Y] = cw({
    defaultProp: S,
    prop: e,
    onChange: (me) => {
      t == null || t(me), !me && !y && _a(), setTimeout(() => {
        G == null || G(me);
      }, He.DURATION * 1e3), me && !w && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), me || (document.body.style.pointerEvents = "auto");
    }
  }), [O, I] = B.useState(!1), [W, A] = B.useState(!1), [K, k] = B.useState(!1), $ = B.useRef(null), P = B.useRef(null), _ = B.useRef(null), V = B.useRef(null), T = B.useRef(null), L = B.useRef(!1), J = B.useRef(null), Q = B.useRef(0), ne = B.useRef(!1), D = B.useRef(!S), le = B.useRef(0), te = B.useRef(null), Se = B.useRef(((j = te.current) == null ? void 0 : j.getBoundingClientRect().height) || 0), Le = B.useRef(((z = te.current) == null ? void 0 : z.getBoundingClientRect().width) || 0), ze = B.useRef(0), lt = B.useCallback((me) => {
    a && me === kt.length - 1 && (P.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: _e, activeSnapPointIndex: Je, setActiveSnapPoint: Gt, onRelease: Tt, snapPointsOffset: kt, onDrag: gr, shouldFade: oo, getPercentageDragged: hs } = WO({
    snapPoints: a,
    activeSnapPointProp: p,
    setActiveSnapPointProp: h,
    drawerRef: te,
    fadeFromIndex: f,
    overlayRef: $,
    onSnapPointChange: lt,
    direction: C,
    container: U,
    snapToSequentialPoint: E
  });
  MO({
    isDisabled: !Z || W || !w || K || !O || !F || !R
  });
  const { restorePositionSetting: _a } = UO({
    isOpen: Z,
    modal: w,
    nested: y ?? !1,
    hasBeenOpened: O,
    preventScrollRestoration: M,
    noBodyStyles: x
  });
  function hr() {
    return (window.innerWidth - Xl) / window.innerWidth;
  }
  function ao(me) {
    var Pe, De;
    !u && !a || te.current && !te.current.contains(me.target) || (Se.current = ((Pe = te.current) == null ? void 0 : Pe.getBoundingClientRect().height) || 0, Le.current = ((De = te.current) == null ? void 0 : De.getBoundingClientRect().width) || 0, A(!0), _.current = /* @__PURE__ */ new Date(), nw() && window.addEventListener("touchend", () => L.current = !1, {
      once: !0
    }), me.target.setPointerCapture(me.pointerId), Q.current = Ge(C) ? me.pageY : me.pageX);
  }
  function sn(me, Pe) {
    var De;
    let Ee = me;
    const Ve = (De = window.getSelection()) == null ? void 0 : De.toString(), tt = te.current ? Ga(te.current, C) : null, Ke = /* @__PURE__ */ new Date();
    if (Ee.tagName === "SELECT" || Ee.hasAttribute("data-vaul-no-drag") || Ee.closest("[data-vaul-no-drag]"))
      return !1;
    if (C === "right" || C === "left")
      return !0;
    if (P.current && Ke.getTime() - P.current.getTime() < 500)
      return !1;
    if (tt !== null && (C === "bottom" ? tt > 0 : tt < 0))
      return !0;
    if (Ve && Ve.length > 0)
      return !1;
    if (T.current && Ke.getTime() - T.current.getTime() < c && tt === 0 || Pe)
      return T.current = Ke, !1;
    for (; Ee; ) {
      if (Ee.scrollHeight > Ee.clientHeight) {
        if (Ee.scrollTop !== 0)
          return T.current = /* @__PURE__ */ new Date(), !1;
        if (Ee.getAttribute("role") === "dialog")
          return !0;
      }
      Ee = Ee.parentNode;
    }
    return !0;
  }
  function io(me) {
    if (te.current && W) {
      const Pe = C === "bottom" || C === "right" ? 1 : -1, De = (Q.current - (Ge(C) ? me.pageY : me.pageX)) * Pe, Ee = De > 0, Ve = a && !u && !Ee;
      if (Ve && Je === 0) return;
      const tt = Math.abs(De), Ke = document.querySelector("[data-vaul-drawer-wrapper]"), Ut = C === "bottom" || C === "top" ? Se.current : Le.current;
      let _t = tt / Ut;
      const Gn = hs(tt, Ee);
      if (Gn !== null && (_t = Gn), Ve && _t >= 1 || !L.current && !sn(me.target, Ee)) return;
      if (te.current.classList.add(al), L.current = !0, Ue(te.current, {
        transition: "none"
      }), Ue($.current, {
        transition: "none"
      }), a && gr({
        draggedDistance: De
      }), Ee && !a) {
        const qt = FO(De), Ia = Math.min(qt * -1, 0) * Pe;
        Ue(te.current, {
          transform: Ge(C) ? `translate3d(0, ${Ia}px, 0)` : `translate3d(${Ia}px, 0, 0)`
        });
        return;
      }
      const wn = 1 - _t;
      if ((oo || f && Je === f - 1) && (r == null || r(me, _t), Ue($.current, {
        opacity: `${wn}`,
        transition: "none"
      }, !0)), Ke && $.current && i) {
        const qt = Math.min(hr() + _t * (1 - hr()), 1), Ia = 8 - _t * 8, pd = Math.max(0, 14 - _t * 14);
        Ue(Ke, {
          borderRadius: `${Ia}px`,
          transform: Ge(C) ? `scale(${qt}) translate3d(0, ${pd}px, 0)` : `scale(${qt}) translate3d(${pd}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!a) {
        const qt = tt * Pe;
        Ue(te.current, {
          transform: Ge(C) ? `translate3d(0, ${qt}px, 0)` : `translate3d(${qt}px, 0, 0)`
        });
      }
    }
  }
  B.useEffect(() => {
    window.requestAnimationFrame(() => {
      D.current = !0;
    });
  }, []), B.useEffect(() => {
    var me;
    function Pe() {
      if (!te.current || !F) return;
      const De = document.activeElement;
      if (Kl(De) || ne.current) {
        var Ee;
        const Ve = ((Ee = window.visualViewport) == null ? void 0 : Ee.height) || 0, tt = window.innerHeight;
        let Ke = tt - Ve;
        const Ut = te.current.getBoundingClientRect().height || 0, _t = Ut > tt * 0.8;
        ze.current || (ze.current = Ut);
        const Gn = te.current.getBoundingClientRect().top;
        if (Math.abs(le.current - Ke) > 60 && (ne.current = !ne.current), a && a.length > 0 && kt && Je) {
          const wn = kt[Je] || 0;
          Ke += wn;
        }
        if (le.current = Ke, Ut > Ve || ne.current) {
          const wn = te.current.getBoundingClientRect().height;
          let qt = wn;
          wn > Ve && (qt = Ve - (_t ? Gn : Xl)), g ? te.current.style.height = `${wn - Math.max(Ke, 0)}px` : te.current.style.height = `${Math.max(qt, Ve - Gn)}px`;
        } else kO() || (te.current.style.height = `${ze.current}px`);
        a && a.length > 0 && !ne.current ? te.current.style.bottom = "0px" : te.current.style.bottom = `${Math.max(Ke, 0)}px`;
      }
    }
    return (me = window.visualViewport) == null || me.addEventListener("resize", Pe), () => {
      var De;
      return (De = window.visualViewport) == null ? void 0 : De.removeEventListener("resize", Pe);
    };
  }, [
    Je,
    a,
    kt
  ]);
  function ln(me) {
    vs(), b == null || b(), me || Y(!1), setTimeout(() => {
      a && Gt(a[0]);
    }, He.DURATION * 1e3);
  }
  function jn() {
    if (!te.current) return;
    const me = document.querySelector("[data-vaul-drawer-wrapper]"), Pe = Ga(te.current, C);
    Ue(te.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`
    }), Ue($.current, {
      transition: `opacity ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      opacity: "1"
    }), i && Pe && Pe > 0 && Z && Ue(me, {
      borderRadius: `${sw}px`,
      overflow: "hidden",
      ...Ge(C) ? {
        transform: `scale(${hr()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${hr()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${He.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${He.EASE.join(",")})`
    }, !0);
  }
  function vs() {
    !W || !te.current || (te.current.classList.remove(al), L.current = !1, A(!1), V.current = /* @__PURE__ */ new Date());
  }
  function ws(me) {
    if (!W || !te.current) return;
    te.current.classList.remove(al), L.current = !1, A(!1), V.current = /* @__PURE__ */ new Date();
    const Pe = Ga(te.current, C);
    if (!me || !sn(me.target, !1) || !Pe || Number.isNaN(Pe) || _.current === null) return;
    const De = V.current.getTime() - _.current.getTime(), Ee = Q.current - (Ge(C) ? me.pageY : me.pageX), Ve = Math.abs(Ee) / De;
    if (Ve > 0.05 && (k(!0), setTimeout(() => {
      k(!1);
    }, 200)), a) {
      Tt({
        draggedDistance: Ee * (C === "bottom" || C === "right" ? 1 : -1),
        closeDrawer: ln,
        velocity: Ve,
        dismissible: u
      }), o == null || o(me, !0);
      return;
    }
    if (C === "bottom" || C === "right" ? Ee > 0 : Ee < 0) {
      jn(), o == null || o(me, !0);
      return;
    }
    if (Ve > iw) {
      ln(), o == null || o(me, !1);
      return;
    }
    var tt;
    const Ke = Math.min((tt = te.current.getBoundingClientRect().height) != null ? tt : 0, window.innerHeight);
    var Ut;
    const _t = Math.min((Ut = te.current.getBoundingClientRect().width) != null ? Ut : 0, window.innerWidth), Gn = C === "left" || C === "right";
    if (Math.abs(Pe) >= (Gn ? _t : Ke) * l) {
      ln(), o == null || o(me, !1);
      return;
    }
    o == null || o(me, !0), jn();
  }
  B.useEffect(() => (Z && (Ue(document.documentElement, {
    scrollBehavior: "auto"
  }), P.current = /* @__PURE__ */ new Date()), () => {
    LO(document.documentElement, "scrollBehavior");
  }), [
    Z
  ]);
  function bs(me) {
    const Pe = me ? (window.innerWidth - Ua) / window.innerWidth : 1, De = me ? -16 : 0;
    J.current && window.clearTimeout(J.current), Ue(te.current, {
      transition: `transform ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      transform: Ge(C) ? `scale(${Pe}) translate3d(0, ${De}px, 0)` : `scale(${Pe}) translate3d(${De}px, 0, 0)`
    }), !me && te.current && (J.current = setTimeout(() => {
      const Ee = Ga(te.current, C);
      Ue(te.current, {
        transition: "none",
        transform: Ge(C) ? `translate3d(0, ${Ee}px, 0)` : `translate3d(${Ee}px, 0, 0)`
      });
    }, 500));
  }
  function ys(me, Pe) {
    if (Pe < 0) return;
    const De = (window.innerWidth - Ua) / window.innerWidth, Ee = De + Pe * (1 - De), Ve = -16 + Pe * Ua;
    Ue(te.current, {
      transform: Ge(C) ? `scale(${Ee}) translate3d(0, ${Ve}px, 0)` : `scale(${Ee}) translate3d(${Ve}px, 0, 0)`,
      transition: "none"
    });
  }
  function xs(me, Pe) {
    const De = Ge(C) ? window.innerHeight : window.innerWidth, Ee = Pe ? (De - Ua) / De : 1, Ve = Pe ? -16 : 0;
    Pe && Ue(te.current, {
      transition: `transform ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      transform: Ge(C) ? `scale(${Ee}) translate3d(0, ${Ve}px, 0)` : `scale(${Ee}) translate3d(${Ve}px, 0, 0)`
    });
  }
  return B.useEffect(() => {
    w || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    w
  ]), /* @__PURE__ */ B.createElement(ra, {
    defaultOpen: S,
    onOpenChange: (me) => {
      !u && !me || (me ? I(!0) : ln(!0), Y(me));
    },
    open: Z
  }, /* @__PURE__ */ B.createElement(tw.Provider, {
    value: {
      activeSnapPoint: _e,
      snapPoints: a,
      setActiveSnapPoint: Gt,
      drawerRef: te,
      overlayRef: $,
      onOpenChange: t,
      onPress: ao,
      onRelease: ws,
      onDrag: io,
      dismissible: u,
      shouldAnimate: D,
      handleOnly: d,
      isOpen: Z,
      isDragging: W,
      shouldFade: oo,
      closeDrawer: ln,
      onNestedDrag: ys,
      onNestedOpenChange: bs,
      onNestedRelease: xs,
      keyboardIsOpen: ne,
      modal: w,
      snapPointsOffset: kt,
      activeSnapPointIndex: Je,
      direction: C,
      shouldScaleBackground: i,
      setBackgroundColorOnScale: s,
      noBodyStyles: x,
      container: U,
      autoFocus: H
    }
  }, n));
}
const uw = /* @__PURE__ */ B.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: o, shouldFade: a, isOpen: i, modal: s, shouldAnimate: l } = va(), c = ow(t, n), u = r && r.length > 0;
  if (!s)
    return null;
  const d = B.useCallback((f) => o(f), [
    o
  ]);
  return /* @__PURE__ */ B.createElement(fr, {
    onMouseUp: d,
    ref: c,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": i && u ? "true" : "false",
    "data-vaul-snap-points-overlay": i && a ? "true" : "false",
    "data-vaul-animate": l != null && l.current ? "true" : "false",
    ...e
  });
});
uw.displayName = "Drawer.Overlay";
const dw = /* @__PURE__ */ B.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, o) {
  const { drawerRef: a, onPress: i, onRelease: s, onDrag: l, keyboardIsOpen: c, snapPointsOffset: u, activeSnapPointIndex: d, modal: f, isOpen: p, direction: h, snapPoints: g, container: w, handleOnly: b, shouldAnimate: y, autoFocus: x } = va(), [C, S] = B.useState(!1), R = ow(o, a), E = B.useRef(null), M = B.useRef(null), F = B.useRef(!1), G = g && g.length > 0;
  GO();
  const U = (j, z, Z = 0) => {
    if (F.current) return !0;
    const Y = Math.abs(j.y), O = Math.abs(j.x), I = O > Y, W = [
      "bottom",
      "right"
    ].includes(z) ? 1 : -1;
    if (z === "left" || z === "right") {
      if (!(j.x * W < 0) && O >= 0 && O <= Z)
        return I;
    } else if (!(j.y * W < 0) && Y >= 0 && Y <= Z)
      return !I;
    return F.current = !0, !0;
  };
  B.useEffect(() => {
    G && window.requestAnimationFrame(() => {
      S(!0);
    });
  }, []);
  function H(j) {
    E.current = null, F.current = !1, s(j);
  }
  return /* @__PURE__ */ B.createElement(Mn, {
    "data-vaul-drawer-direction": h,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": C ? "true" : "false",
    "data-vaul-snap-points": p && G ? "true" : "false",
    "data-vaul-custom-container": w ? "true" : "false",
    "data-vaul-animate": y != null && y.current ? "true" : "false",
    ...r,
    ref: R,
    style: u && u.length > 0 ? {
      "--snap-point-height": `${u[d ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (j) => {
      b || (r.onPointerDown == null || r.onPointerDown.call(r, j), E.current = {
        x: j.pageX,
        y: j.pageY
      }, i(j));
    },
    onOpenAutoFocus: (j) => {
      n == null || n(j), x || j.preventDefault();
    },
    onPointerDownOutside: (j) => {
      if (e == null || e(j), !f || j.defaultPrevented) {
        j.preventDefault();
        return;
      }
      c.current && (c.current = !1);
    },
    onFocusOutside: (j) => {
      if (!f) {
        j.preventDefault();
        return;
      }
    },
    onPointerMove: (j) => {
      if (M.current = j, b || (r.onPointerMove == null || r.onPointerMove.call(r, j), !E.current)) return;
      const z = j.pageY - E.current.y, Z = j.pageX - E.current.x, Y = j.pointerType === "touch" ? 10 : 2;
      U({
        x: Z,
        y: z
      }, h, Y) ? l(j) : (Math.abs(Z) > Y || Math.abs(z) > Y) && (E.current = null);
    },
    onPointerUp: (j) => {
      r.onPointerUp == null || r.onPointerUp.call(r, j), E.current = null, F.current = !1, s(j);
    },
    onPointerOut: (j) => {
      r.onPointerOut == null || r.onPointerOut.call(r, j), H(M.current);
    },
    onContextMenu: (j) => {
      r.onContextMenu == null || r.onContextMenu.call(r, j), M.current && H(M.current);
    }
  });
});
dw.displayName = "Drawer.Content";
const YO = 250, KO = 120, XO = /* @__PURE__ */ B.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: o, isDragging: a, snapPoints: i, activeSnapPoint: s, setActiveSnapPoint: l, dismissible: c, handleOnly: u, isOpen: d, onPress: f, onDrag: p } = va(), h = B.useRef(null), g = B.useRef(!1);
  function w() {
    if (g.current) {
      x();
      return;
    }
    window.setTimeout(() => {
      b();
    }, KO);
  }
  function b() {
    if (a || e || g.current) {
      x();
      return;
    }
    if (x(), !i || i.length === 0) {
      c || o();
      return;
    }
    if (s === i[i.length - 1] && c) {
      o();
      return;
    }
    const S = i.findIndex((E) => E === s);
    if (S === -1) return;
    const R = i[S + 1];
    l(R);
  }
  function y() {
    h.current = window.setTimeout(() => {
      g.current = !0;
    }, YO);
  }
  function x() {
    h.current && window.clearTimeout(h.current), g.current = !1;
  }
  return /* @__PURE__ */ B.createElement("div", {
    onClick: w,
    onPointerCancel: x,
    onPointerDown: (C) => {
      u && f(C), y();
    },
    onPointerMove: (C) => {
      u && p(C);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": d ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ B.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
XO.displayName = "Drawer.Handle";
function JO(e) {
  const t = va(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ B.createElement(oa, {
    container: n,
    ...r
  });
}
const Ht = {
  Root: qO,
  Content: dw,
  Overlay: uw,
  Trigger: tu,
  Portal: JO,
  Close: Fi,
  Title: aa,
  Description: ia
}, QO = ({
  shouldScaleBackground: e = !0,
  ...t
}) => /* @__PURE__ */ m(
  Ht.Root,
  {
    shouldScaleBackground: e,
    ...t
  }
);
QO.displayName = "Drawer";
const J3 = Ht.Trigger, ZO = Ht.Portal, Q3 = Ht.Close, fw = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    Ht.Overlay,
    {
      ref: n,
      className: N("tw-fixed tw-inset-0 tw-z-50 tw-bg-black/80", e),
      ...t
    }
  )
);
fw.displayName = Ht.Overlay.displayName;
const eD = q(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ee(
    ZO,
    { children: [
      /* @__PURE__ */ m(fw, {}),
      /* @__PURE__ */ ee(
        Ht.Content,
        {
          ref: r,
          className: N(
            "tw-bg-[#ffffff] tw-fixed tw-inset-x-0 tw-bottom-0 tw-z-50 tw-mt-24 tw-flex tw-h-auto tw-flex-col tw-rounded-t-[10px] tw-border",
            e
          ),
          ...n,
          children: [
            /* @__PURE__ */ m("div", { className: "tw-mx-auto tw-mt-4 tw-h-2 tw-w-[100px] tw-rounded-full" }),
            t
          ]
        }
      )
    ] }
  )
);
eD.displayName = "DrawerContent";
const tD = ({
  className: e,
  ...t
}) => /* @__PURE__ */ m(
  "div",
  {
    className: N(
      "tw-grid tw-gap-1.5 tw-p-4 tw-text-center sm:tw-text-left",
      e
    ),
    ...t
  }
);
tD.displayName = "DrawerHeader";
const nD = ({
  className: e,
  ...t
}) => /* @__PURE__ */ m(
  "div",
  {
    className: N("tw-mt-auto tw-flex tw-flex-col tw-gap-2 tw-p-4", e),
    ...t
  }
);
nD.displayName = "DrawerFooter";
const rD = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    Ht.Title,
    {
      ref: n,
      className: N(
        "tw-text-lg tw-font-semibold tw-leading-none tw-tracking-tight",
        e
      ),
      ...t
    }
  )
);
rD.displayName = Ht.Title.displayName;
const oD = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    Ht.Description,
    {
      ref: n,
      className: N("tw-text-muted-foreground tw-text-sm", e),
      ...t
    }
  )
);
oD.displayName = Ht.Description.displayName;
const aD = oe("custom-text-input-focus-ring custom-input-field-width tw-box-border tw-truncate tw-rounded-density-formElement-xs tw-px-density-formElement-padding-md tw-text-left tw-text-semantic-formElement-label-default read-only:tw-placeholder-semantic-formElement-label-disabled disabled:tw-cursor-not-allowed tw-h-full", {
  variants: {
    fieldState: {
      invalid: "",
      valid: "",
      readOnly: "tw-text-gray-5 tw-bg-semantic-formElement-background-neutral-disabled"
    },
    size: {
      md: "",
      lg: "",
      xl: "tw-px-3"
    },
    variant: {
      default: "",
      solid: "tw-border tw-border-[#ECEDF7] tw-bg-[#ECEDF7]"
    }
  },
  defaultVariants: {
    fieldState: "valid",
    size: "md",
    variant: "default"
  }
}), iD = oe("tw-relative tw-flex tw-items-center tw-rounded-density-formElement-xs", {
  variants: {
    fieldState: {
      invalid: "tw-border-semantic-formElement-border-neutral-error",
      valid: "",
      readOnly: "tw-border-semantic-formElement-border-neutral-disabled tw-bg-semantic-formElement-background-neutral-disabled"
    },
    size: {
      md: "tw-body-md-regular tw-h-density-formElement-md",
      lg: "tw-body-lg-regular tw-h-density-formElement-lg",
      xl: "tw-body-lg-regular tw-h-12"
    },
    variant: {
      default: "tw-border-x-density-formElement-default tw-border-y-density-formElement-default tw-border-semantic-formElement-border-neutral-default tw-bg-transparent",
      solid: "tw-bg-semantic-primary-weaker tw-border tw-border-transparent tw-bg-[#ECEDF7]"
    }
  },
  defaultVariants: {
    size: "md",
    fieldState: "valid",
    variant: "default"
  }
}), sD = oe("custom-input-field-max-width tw-shrink-0 tw-content-center tw-truncate tw-rounded-l-density-formElement-xs tw-h-full", {
  variants: {
    size: {
      md: "tw-body-md-regular tw-p-density-formElement-padding-md",
      lg: "tw-body-lg-medium tw-p-density-formElement-padding-lg",
      xl: "tw-body-lg-medium tw-p-density-formElement-padding-xl"
    },
    variant: {
      default: "tw-border-r-density-formElement-default tw-border-semantic-formElement-border-neutral-default tw-bg-semantic-formElement-background-neutral-stronger",
      solid: "tw-border tw-border-[#ECEDF7] tw-bg-[#ECEDF7]"
    }
  },
  defaultVariants: {
    size: "md",
    variant: "default"
  }
}), lD = oe("tw-px-brand-0 tw-pt-2 tw-text-xs tw-font-medium", {
  variants: {
    fieldState: {
      invalid: "tw-text-semantic-formElement-label-error",
      valid: "",
      readOnly: "tw-text-semantic-formElement-label-disabled"
    },
    showFullErrorMessage: {
      true: "",
      false: "tw-truncate",
      undefined: "tw-truncate"
    }
  },
  defaultVariants: {
    fieldState: "valid"
  }
}), cD = oe("tw-shrink-0 tw-text-semantic-formElement-label-default", {
  variants: {
    fieldState: {
      invalid: "",
      valid: "",
      readOnly: "tw-text-semantic-formElement-label-disabledtw-bg-semantic-formElement-background-neutral-disabled"
    }
  },
  defaultVariants: {
    fieldState: "valid"
  }
}), uD = oe("tw-flex-1 tw-antialiased", {
  variants: {
    size: {
      md: "tw-label-md-bold",
      lg: "tw-label-lg-bold",
      xl: "tw-label-lg-bold"
    },
    labelHidden: {
      hidden: "tw-sr-only"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), dD = "tw-flex tw-flex-col", fD = "tw-text-xs tw-font-[500] tw-leading-[14px] tw-content-center", pD = "tw-text-pretty tw-truncate tw-text-sm", mD = "tw-truncate tw-text-xs tw-font-[500]", pw = q(
  ({
    className: e,
    label: t,
    helperText: n,
    prependText: r,
    descriptiveText: o,
    isLabelHidden: a = !1,
    requiredText: i = "Required",
    errorMessage: s,
    showFullErrorMessage: l,
    buttonIcon: c,
    buttonAriaLabel: u,
    iconLeft: d = "",
    iconRight: f = "",
    size: p = "md",
    variant: h = "default",
    inputId: g,
    onButtonClick: w,
    ...b
  }, y) => {
    const x = s ? "invalid" : b.readOnly ? "readOnly" : "valid", C = `desc-${Ir()}`, S = `label-${Ir()}`, R = d && !r, E = R ? "tw-pl-8" : "";
    return /* @__PURE__ */ ee(
      "div",
      { className: N(dD, e), children: [
        a ? null : /* @__PURE__ */ ee(
          "div",
          { className: "tw-mb-2 tw-flex tw-flex-col", children: [
            /* @__PURE__ */ ee(
              "div",
              { className: "tw-flex tw-w-full tw-items-end", children: [
                /* @__PURE__ */ m(
                  "label",
                  {
                    htmlFor: S,
                    className: N(
                      uD({
                        size: p,
                        labelHidden: a ? "hidden" : null
                      }),
                      e
                    ),
                    children: t
                  }
                ),
                b.required && /* @__PURE__ */ m("span", { className: fD, children: i })
              ] }
            ),
            o ? /* @__PURE__ */ m(
              "p",
              { className: pD, id: C, children: o }
            ) : null
          ] }
        ),
        /* @__PURE__ */ ee(
          "div",
          {
            className: N(
              iD({ fieldState: x, size: p, variant: h })
            ),
            children: [
              r ? /* @__PURE__ */ m(
                "span",
                { className: N(sD({ size: p, variant: h })), children: r }
              ) : null,
              R ? /* @__PURE__ */ m(
                de,
                {
                  icon: d,
                  "aria-label": d,
                  className: "tw-absolute tw-mx-2 tw-h-4 tw-w-4"
                }
              ) : null,
              /* @__PURE__ */ m(
                "input",
                {
                  className: N(
                    aD({ fieldState: x, size: p, variant: h }),
                    E,
                    f && "tw-pr-8"
                  ),
                  id: g || S,
                  type: "text",
                  "aria-describedby": C,
                  ref: y,
                  ...b
                }
              ),
              f ? /* @__PURE__ */ m(
                de,
                {
                  icon: f,
                  "aria-label": f,
                  className: "tw-pointer-events-none tw-absolute tw-right-0 tw-mx-2 tw-h-4 tw-w-4"
                }
              ) : null,
              c && w && u && /* @__PURE__ */ m(
                mt,
                {
                  onClick: w,
                  iconName: c,
                  size: p,
                  variant: "ghost",
                  intent: "neutral",
                  type: "button",
                  ariaLabel: u,
                  className: N(cD({ fieldState: x }))
                }
              )
            ]
          }
        ),
        s ? /* @__PURE__ */ m(
          "span",
          {
            className: N(
              lD({ fieldState: x, showFullErrorMessage: l })
            ),
            children: s
          }
        ) : n ? /* @__PURE__ */ m("span", { className: mD, children: n }) : null
      ] }
    );
  }
);
pw.displayName = "InputField";
const gD = q(
  ({ className: e, label: t, isLabelHidden: n = !0, ...r }, o) => /* @__PURE__ */ m(
    "label",
    {
      className: `${e} ${n && "tw-sr-only"}`,
      ref: o,
      ...r,
      children: t
    }
  )
);
var Zi = "Menubar", [Jl, hD, vD] = qr(Zi), [mw, Z3] = Ye(Zi, [
  vD,
  an
]), st = ou(), gw = an(), [wD, zu] = mw(Zi), hw = v.forwardRef(
  (e, t) => {
    const {
      __scopeMenubar: n,
      value: r,
      onValueChange: o,
      defaultValue: a,
      loop: i = !0,
      dir: s,
      ...l
    } = e, c = Ln(s), u = gw(n), [d = "", f] = je({
      prop: r,
      onChange: o,
      defaultProp: a
    }), [p, h] = v.useState(null);
    return /* @__PURE__ */ m(
      wD,
      {
        scope: n,
        value: d,
        onMenuOpen: v.useCallback(
          (g) => {
            f(g), h(g);
          },
          [f]
        ),
        onMenuClose: v.useCallback(() => f(""), [f]),
        onMenuToggle: v.useCallback(
          (g) => {
            f((w) => w ? "" : g), h(g);
          },
          [f]
        ),
        dir: c,
        loop: i,
        children: /* @__PURE__ */ m(Jl.Provider, { scope: n, children: /* @__PURE__ */ m(Jl.Slot, { scope: n, children: /* @__PURE__ */ m(
          la,
          {
            asChild: !0,
            ...u,
            orientation: "horizontal",
            loop: i,
            dir: c,
            currentTabStopId: p,
            onCurrentTabStopIdChange: h,
            children: /* @__PURE__ */ m(ie.div, { role: "menubar", ...l, ref: t })
          }
        ) }) })
      }
    );
  }
);
hw.displayName = Zi;
var Vu = "MenubarMenu", [bD, vw] = mw(Vu), ww = (e) => {
  const { __scopeMenubar: t, value: n, ...r } = e, o = Te(), a = n || o || "LEGACY_REACT_AUTO_VALUE", i = zu(Vu, t), s = st(t), l = v.useRef(null), c = v.useRef(!1), u = i.value === a;
  return v.useEffect(() => {
    u || (c.current = !1);
  }, [u]), /* @__PURE__ */ m(
    bD,
    {
      scope: t,
      value: a,
      triggerId: Te(),
      triggerRef: l,
      contentId: Te(),
      wasKeyboardTriggerOpenRef: c,
      children: /* @__PURE__ */ m(
        hh,
        {
          ...s,
          open: u,
          onOpenChange: (d) => {
            d || i.onMenuClose();
          },
          modal: !1,
          dir: i.dir,
          ...r
        }
      )
    }
  );
};
ww.displayName = Vu;
var Ql = "MenubarTrigger", bw = v.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, disabled: r = !1, ...o } = e, a = gw(n), i = st(n), s = zu(Ql, n), l = vw(Ql, n), c = v.useRef(null), u = xe(t, c, l.triggerRef), [d, f] = v.useState(!1), p = s.value === l.value;
    return /* @__PURE__ */ m(Jl.ItemSlot, { scope: n, value: l.value, disabled: r, children: /* @__PURE__ */ m(
      ca,
      {
        asChild: !0,
        ...a,
        focusable: !r,
        tabStopId: l.value,
        children: /* @__PURE__ */ m(vh, { asChild: !0, ...i, children: /* @__PURE__ */ m(
          ie.button,
          {
            type: "button",
            role: "menuitem",
            id: l.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": p,
            "aria-controls": p ? l.contentId : void 0,
            "data-highlighted": d ? "" : void 0,
            "data-state": p ? "open" : "closed",
            "data-disabled": r ? "" : void 0,
            disabled: r,
            ...o,
            ref: u,
            onPointerDown: re(e.onPointerDown, (h) => {
              !r && h.button === 0 && h.ctrlKey === !1 && (s.onMenuOpen(l.value), p || h.preventDefault());
            }),
            onPointerEnter: re(e.onPointerEnter, () => {
              var g;
              !!s.value && !p && (s.onMenuOpen(l.value), (g = c.current) == null || g.focus());
            }),
            onKeyDown: re(e.onKeyDown, (h) => {
              r || (["Enter", " "].includes(h.key) && s.onMenuToggle(l.value), h.key === "ArrowDown" && s.onMenuOpen(l.value), ["Enter", " ", "ArrowDown"].includes(h.key) && (l.wasKeyboardTriggerOpenRef.current = !0, h.preventDefault()));
            }),
            onFocus: re(e.onFocus, () => f(!0)),
            onBlur: re(e.onBlur, () => f(!1))
          }
        ) })
      }
    ) });
  }
);
bw.displayName = Ql;
var yD = "MenubarPortal", yw = (e) => {
  const { __scopeMenubar: t, ...n } = e, r = st(t);
  return /* @__PURE__ */ m(wh, { ...r, ...n });
};
yw.displayName = yD;
var Zl = "MenubarContent", xw = v.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, align: r = "start", ...o } = e, a = st(n), i = zu(Zl, n), s = vw(Zl, n), l = hD(n), c = v.useRef(!1);
    return /* @__PURE__ */ m(
      bh,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        "data-radix-menubar-content": "",
        ...a,
        ...o,
        ref: t,
        align: r,
        onCloseAutoFocus: re(e.onCloseAutoFocus, (u) => {
          var f;
          !!!i.value && !c.current && ((f = s.triggerRef.current) == null || f.focus()), c.current = !1, u.preventDefault();
        }),
        onFocusOutside: re(e.onFocusOutside, (u) => {
          const d = u.target;
          l().some((p) => {
            var h;
            return (h = p.ref.current) == null ? void 0 : h.contains(d);
          }) && u.preventDefault();
        }),
        onInteractOutside: re(e.onInteractOutside, () => {
          c.current = !0;
        }),
        onEntryFocus: (u) => {
          s.wasKeyboardTriggerOpenRef.current || u.preventDefault();
        },
        onKeyDown: re(
          e.onKeyDown,
          (u) => {
            if (["ArrowRight", "ArrowLeft"].includes(u.key)) {
              const d = u.target, f = d.hasAttribute("data-radix-menubar-subtrigger"), p = d.closest("[data-radix-menubar-content]") !== u.currentTarget, g = (i.dir === "rtl" ? "ArrowRight" : "ArrowLeft") === u.key;
              if (!g && f || p && g) return;
              let y = l().filter((S) => !S.disabled).map((S) => S.value);
              g && y.reverse();
              const x = y.indexOf(s.value);
              y = i.loop ? DD(y, x + 1) : y.slice(x + 1);
              const [C] = y;
              C && i.onMenuOpen(C);
            }
          },
          { checkForDefaultPrevented: !1 }
        ),
        style: {
          ...e.style,
          "--radix-menubar-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-menubar-content-available-width": "var(--radix-popper-available-width)",
          "--radix-menubar-content-available-height": "var(--radix-popper-available-height)",
          "--radix-menubar-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-menubar-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
xw.displayName = Zl;
var xD = "MenubarGroup", Sw = v.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = st(n);
    return /* @__PURE__ */ m(yh, { ...o, ...r, ref: t });
  }
);
Sw.displayName = xD;
var SD = "MenubarLabel", Cw = v.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = st(n);
    return /* @__PURE__ */ m(xh, { ...o, ...r, ref: t });
  }
);
Cw.displayName = SD;
var CD = "MenubarItem", Ew = v.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = st(n);
    return /* @__PURE__ */ m(Sh, { ...o, ...r, ref: t });
  }
);
Ew.displayName = CD;
var ED = "MenubarCheckboxItem", kw = v.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = st(n);
    return /* @__PURE__ */ m(Ch, { ...o, ...r, ref: t });
  }
);
kw.displayName = ED;
var kD = "MenubarRadioGroup", Rw = v.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = st(n);
    return /* @__PURE__ */ m(Eh, { ...o, ...r, ref: t });
  }
);
Rw.displayName = kD;
var RD = "MenubarRadioItem", Pw = v.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = st(n);
    return /* @__PURE__ */ m(kh, { ...o, ...r, ref: t });
  }
);
Pw.displayName = RD;
var PD = "MenubarItemIndicator", Nw = v.forwardRef((e, t) => {
  const { __scopeMenubar: n, ...r } = e, o = st(n);
  return /* @__PURE__ */ m(Rh, { ...o, ...r, ref: t });
});
Nw.displayName = PD;
var ND = "MenubarSeparator", Tw = v.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = st(n);
    return /* @__PURE__ */ m(Ph, { ...o, ...r, ref: t });
  }
);
Tw.displayName = ND;
var TD = "MenubarArrow", _D = v.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = st(n);
    return /* @__PURE__ */ m(Nh, { ...o, ...r, ref: t });
  }
);
_D.displayName = TD;
var ID = "MenubarSub", _w = (e) => {
  const { __scopeMenubar: t, children: n, open: r, onOpenChange: o, defaultOpen: a } = e, i = st(t), [s = !1, l] = je({
    prop: r,
    defaultProp: a,
    onChange: o
  });
  return /* @__PURE__ */ m(Th, { ...i, open: s, onOpenChange: l, children: n });
};
_w.displayName = ID;
var MD = "MenubarSubTrigger", Iw = v.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = st(n);
    return /* @__PURE__ */ m(
      _h,
      {
        "data-radix-menubar-subtrigger": "",
        ...o,
        ...r,
        ref: t
      }
    );
  }
);
Iw.displayName = MD;
var OD = "MenubarSubContent", Mw = v.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = st(n);
    return /* @__PURE__ */ m(
      Ih,
      {
        ...o,
        "data-radix-menubar-content": "",
        ...r,
        ref: t,
        style: {
          ...e.style,
          "--radix-menubar-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-menubar-content-available-width": "var(--radix-popper-available-width)",
          "--radix-menubar-content-available-height": "var(--radix-popper-available-height)",
          "--radix-menubar-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-menubar-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Mw.displayName = OD;
function DD(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Ow = hw, AD = ww, Dw = bw, Aw = yw, $w = xw, $D = Sw, Lw = Cw, Fw = Ew, zw = kw, LD = Rw, Vw = Pw, Bw = Nw, Hw = Tw, FD = _w, Ww = Iw, jw = Mw;
const e4 = AD, t4 = $D, n4 = Aw, r4 = FD, o4 = LD, zD = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    Ow,
    {
      ref: n,
      className: N(
        "tw-space-x-brand-12 tw-px-brand-12 tw-flex tw-h-[42px] tw-items-center tw-productiveFluid-interactive-interactive-md-medium",
        e
      ),
      ...t
    }
  )
);
zD.displayName = Ow.displayName;
const VD = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    Dw,
    {
      ref: n,
      className: N(
        "tw-flex tw-cursor-default tw-select-none tw-items-center custom-global-focus-ring tw-h-8 tw-rounded-sm tw-px-3 tw-py-1 tw-text-sm tw-outline-none  data-[state=open]:tw-bg-brand-neutral-200",
        e
      ),
      ...t
    }
  )
);
VD.displayName = Dw.displayName;
const BD = q(
  ({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ ee(
    Ww,
    {
      ref: o,
      className: N(
        "focus:tw-bg-neutral-200  tw-antialiased hover:tw-bg-neutral-200 tw-productiveFluid-interactive-interactive-md-medium tw-h-8 active:tw-bg-neutral-200 tw-justify-between data-[state=open]:tw-bg-neutral-200 tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded tw-px-2 tw-py-1.5 tw-outline-none tw-gap-2",
        t && "tw-pl-8",
        e
      ),
      ...r,
      children: [
        n,
        /* @__PURE__ */ m(de, { icon: "chevron-right", size: "sm" })
      ]
    }
  )
);
BD.displayName = Ww.displayName;
const HD = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    jw,
    {
      ref: n,
      className: N(
        "tw-bg-brand-neutral-white tw-max-w-[400px] tw-antialiased tw-max-h-screen tw-z-50 tw-min-w-[8rem] tw-overflow-hidden tw-rounded-sm tw-border tw-p-2 tw-shadow-lg tw-productiveFluid-interactive-interactive-md-medium",
        e
      ),
      ...t
    }
  )
);
HD.displayName = jw.displayName;
const WD = q(
  ({ className: e, align: t = "start", alignOffset: n = -4, sideOffset: r = 8, ...o }, a) => /* @__PURE__ */ m(
    Aw,
    { children: /* @__PURE__ */ m(
      $w,
      {
        ref: a,
        align: t,
        alignOffset: n,
        sideOffset: r,
        className: N(
          "tw-bg-brand-neutral-white tw-max-h-screen tw-z-50 tw-min-w-[12rem] tw-overflow-hidden tw-rounded-sm tw-border tw-border-neutral-300 tw-p-2 tw-shadow-lg tw-productiveFluid-interactive-interactive-md-medium",
          e
        ),
        ...o
      }
    ) }
  )
);
WD.displayName = $w.displayName;
const jD = q(
  ({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ m(
    Fw,
    {
      ref: r,
      className: N(
        "focus:tw-bg-neutral-200 tw-leading-6 tw-relative tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded tw-px-2 tw-py-1.5 tw-outline-none data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50 tw-justify-between",
        t && "tw-pl-8",
        e
      ),
      ...n
    }
  )
);
jD.displayName = Fw.displayName;
const GD = q(
  ({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ ee(
    zw,
    {
      ref: o,
      className: N(
        "focus:tw-bg-accent focus:tw-text-accent-foreground focus:tw-bg-semantic-action-background-neutral-weaker tw-relative tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-py-1.5 tw-pl-8 tw-pr-2 tw-outline-none data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50",
        e
      ),
      checked: n,
      ...r,
      children: [
        /* @__PURE__ */ m(
          "span",
          { className: "tw-absolute tw-left-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", children: /* @__PURE__ */ m(
            Bw,
            { children: /* @__PURE__ */ m(de, { icon: "check", size: "sm" }) }
          ) }
        ),
        t
      ]
    }
  )
);
GD.displayName = zw.displayName;
const UD = q(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ee(
    Vw,
    {
      ref: r,
      className: N(
        "focus:tw-bg-accent focus:tw-text-accent-foreground tw-relative tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-py-1.5 tw-pl-8 tw-pr-2 tw-text-sm tw-outline-none data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ m(
          "span",
          { className: "tw-absolute tw-left-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", children: /* @__PURE__ */ m(
            Bw,
            { children: /* @__PURE__ */ m("div", { children: "DOT" }) }
          ) }
        ),
        t
      ]
    }
  )
);
UD.displayName = Vw.displayName;
const qD = q(
  ({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ m(
    Lw,
    {
      ref: r,
      className: N(
        "tw-px-2 tw-py-1.5 tw-text-sm tw-font-semibold",
        t && "tw-pl-8",
        e
      ),
      ...n
    }
  )
);
qD.displayName = Lw.displayName;
const YD = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    Hw,
    {
      ref: n,
      className: N("tw--mx-1 tw-my-1 tw-h-px", e),
      ...t
    }
  )
);
YD.displayName = Hw.displayName;
const KD = ({
  className: e,
  ...t
}) => /* @__PURE__ */ m(
  "span",
  {
    className: N(
      "tw-text-muted-foreground tw-ml-auto tw-text-xs tw-tracking-widest",
      e
    ),
    ...t
  }
);
KD.displayname = "MenubarShortcut";
const a4 = ({
  checkboxPosition: e = "left",
  options: t,
  selectedValues: n = [],
  setSelectedValues: r,
  placeholder: o,
  trigger: a
}) => {
  const [i, s] = ye(!1), l = (d) => n.some((f) => f === d), c = ot(
    (d) => {
      r(
        l(d) ? n.filter((f) => f !== d) : [...n, d]
      );
    },
    [n, r]
  ), u = e === "right";
  return /* @__PURE__ */ ee(
    Km,
    { open: i, onOpenChange: s, children: [
      /* @__PURE__ */ m(
        Xm,
        { asChild: !0, children: a || /* @__PURE__ */ m(
          pt,
          { variant: "outline", size: "md", iconRight: "chevron-down", children: n.length === 0 ? o || "Select options..." : `${n.length} selected` }
        ) }
      ),
      /* @__PURE__ */ m(
        Wc,
        { className: "!tw-p-0", align: "start", children: /* @__PURE__ */ m(
          Mu,
          { loop: !0, children: /* @__PURE__ */ ee(
            Dv,
            { children: [
              /* @__PURE__ */ m(Av, { children: "No options found." }),
              /* @__PURE__ */ m(
                $v,
                { children: t.map(({ value: d, label: f }) => {
                  const p = l(d);
                  return /* @__PURE__ */ ee(
                    Lv,
                    {
                      onSelect: () => c(d),
                      tabIndex: 0,
                      value: d,
                      className: N(
                        "tw-flex tw-items-center",
                        p && "tw-font-[500]",
                        u ? "tw-justify-between tw-flex-row-reverse" : "tw-justify-start tw-flex-row"
                      ),
                      children: [
                        /* @__PURE__ */ m(
                          "div",
                          {
                            className: N(
                              "tw-flex tw-w-5 tw-shrink-0 tw-items-center tw-justify-center",
                              !u && "tw-mr-2"
                            ),
                            children: /* @__PURE__ */ m(ew, { selected: p })
                          }
                        ),
                        /* @__PURE__ */ m("span", { children: f })
                      ]
                    },
                    d
                  );
                }) }
              )
            ] }
          ) }
        ) }
      )
    ] }
  );
}, XD = "tw-flex tw-justify-between tw-productiveFluid-label-label-md-bold tw-text-nowrap tw-rounded-density-formElement-xs ", JD = "tw-productiveFluid-label-label-xs-medium ", QD = "tw-min-w-12 tw-text-right tw-productiveFluid-body-body-md-regular tw-h-density-formElement-md tw-rounded-density-formElement-xs tw-border-y-density-formElement-default tw-border-x-density-formElement-default tw-border-semantic-formElement-border-neutral-default tw-px-density-formElement-padding-md hover:tw-border-semantic-formElement-border-neutral-dark box-content custom-text-input-focus-ring", Ef = "tw-productiveFluid-label-label-xs-medium tw-text-semantic-formElement-label-default tw-text-nowrap ", ZD = oe("tw-flex tw-flex-col "), eA = "tw-bg-semantic-formElement-background-neutral-disabled tw-border-semantic-formElement-border-neutral-disabled tw-cursor-not-allowed ", tA = q(
  ({
    className: e,
    label: t,
    isLabelHidden: n = !1,
    isRequired: r,
    helperText: o = "",
    errorMessage: a = "",
    ...i
  }, s) => {
    const l = `${a && "tw-border-semantic-formElement-border-neutral-error"} ${i.readOnly && eA} ${e || ""}`, c = $n();
    return /* @__PURE__ */ ee(
      "div",
      { className: N(ZD({ className: e })), children: [
        /* @__PURE__ */ ee(
          "div",
          {
            className: `tw-flex tw-gap-brand-40 ${n ? "tw-justify-end" : "tw-justify-between"} `,
            children: [
              /* @__PURE__ */ m(
                "label",
                {
                  className: `${XD} ${n && "tw-sr-only"}  `,
                  htmlFor: c,
                  children: t
                }
              ),
              r && /* @__PURE__ */ m("span", { className: JD, children: "Required" })
            ]
          }
        ),
        /* @__PURE__ */ m(
          "input",
          {
            id: c,
            type: "number",
            className: `${QD} ${l}`,
            ref: s,
            ...i
          }
        ),
        a ? /* @__PURE__ */ m(
          "div",
          {
            className: `${Ef} tw-text-semantic-formElement-label-error`,
            children: a
          }
        ) : o ? /* @__PURE__ */ m("div", { className: Ef, children: o }) : null
      ] }
    );
  }
);
tA.displayName = "NumberStepper";
const nA = "tw-text-sm tw-font-[500] tw-size-density-action-height-md tw-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-density-action-default focus-visible:tw-outline-none custom-button-focus-ring tw-cursor-pointer ", wa = oe(nA, {
  variants: {
    variant: {
      activePage: "tw-text-semantic-action-foreground-neutral-white tw-bg-semantic-action-background-primary-default ",
      page: "tw-text-semantic-action-foreground-neutral-darkest hover:tw-bg-brand-neutral-2 active:tw-bg-semantic-action-background-neutral-lighter ",
      navigation: "hover:tw-bg-transparent active:tw-bg-transparent "
    },
    intent: {
      primary: "",
      neutral: "",
      disabled: "tw-cursor-not-allowed tw-pointer-events-none tw-text-brand-neutral-5 tw-bg-transparent "
    }
  },
  defaultVariants: {
    variant: "activePage",
    intent: "primary"
  }
}), rA = "tw-flex tw-justify-center tw-items-center tw-gap-x-density-action-gap-md ", oA = "tw-productiveFluid-label-label-md-regular tw-text-semantic-static-foreground-neutral-default ", aA = ({ className: e, ...t }) => /* @__PURE__ */ m(
  "nav",
  {
    role: "navigation",
    "aria-label": "pagination",
    className: e,
    ...t
  }
);
aA.displayName = "Pagination";
const iA = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m("ul", { ref: n, className: N(rA, e), ...t })
);
iA.displayName = "PaginationContent";
const sA = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m("li", { ref: n, className: N(e), ...t })
);
sA.displayName = "PaginationItem";
const lA = ({
  className: e,
  itemsStart: t = 0,
  itemsEnd: n = 0,
  itemsTotal: r = 0,
  itemName: o = "items",
  ...a
}) => t > 0 && n > 0 && r > 0 && /* @__PURE__ */ ee(
  "span",
  { className: N(oA, e), ...a, children: [
    t,
    "-",
    n,
    " of ",
    r,
    " ",
    o
  ] }
);
lA.displayName = "PaginationItemCount";
const ba = ({
  className: e,
  isActive: t,
  ...n
}) => /* @__PURE__ */ m(
  "a",
  {
    "aria-current": t ? "page" : void 0,
    role: "link",
    className: N(
      wa({
        variant: t ? "activePage" : "page",
        intent: t ? "primary" : "neutral"
      }),
      e
    ),
    ...n
  }
);
ba.displayName = "PaginationLink";
const cA = ({
  className: e,
  isDisabled: t,
  ...n
}) => /* @__PURE__ */ m(
  ba,
  {
    "aria-label": "Go to previous page",
    className: N(
      wa({
        variant: "navigation",
        intent: t ? "disabled" : "neutral"
      }),
      e
    ),
    ...n,
    children: /* @__PURE__ */ m(de, { icon: "chevron-left" })
  }
);
cA.displayName = "PaginationPrevious";
const uA = ({
  className: e,
  isDisabled: t,
  ...n
}) => /* @__PURE__ */ m(
  ba,
  {
    "aria-label": "Go to next page",
    className: N(
      wa({
        variant: "navigation",
        intent: t ? "disabled" : "neutral"
      }),
      e
    ),
    ...n,
    children: /* @__PURE__ */ m(de, { icon: "chevron-right" })
  }
);
uA.displayName = "PaginationNext";
const dA = ({
  className: e,
  isDisabled: t,
  ...n
}) => /* @__PURE__ */ m(
  ba,
  {
    "aria-label": "Go to first page",
    className: N(
      wa({
        variant: "navigation",
        intent: t ? "disabled" : "neutral"
      }),
      e
    ),
    ...n,
    children: /* @__PURE__ */ m(de, { icon: "chevrons-left" })
  }
);
dA.displayName = "PaginationStart";
const fA = ({
  className: e,
  isDisabled: t,
  ...n
}) => /* @__PURE__ */ m(
  ba,
  {
    "aria-label": "Go to last page",
    className: N(
      wa({
        variant: "navigation",
        intent: t ? "disabled" : "neutral"
      }),
      e
    ),
    ...n,
    children: /* @__PURE__ */ m(de, { icon: "chevrons-right" })
  }
);
fA.displayName = "PaginationEnd";
const pA = oe("tw-flex tw-flex-col tw-overflow-hidden tw-rounded-lg tw-border tw-border-neutral-200 tw-bg-white tw-shadow-sm", {
  variants: {
    size: {
      default: "tw-w-full tw-max-w-4xl",
      small: "tw-w-full tw-max-w-md",
      large: "tw-w-full tw-max-w-6xl"
    },
    layout: {
      horizontal: "",
      vertical: "tw-flex-row"
    }
  },
  defaultVariants: {
    size: "default",
    layout: "horizontal"
  }
}), mA = oe("tw-relative tw-border-neutral-200 tw-bg-neutral-50", {
  variants: {
    layout: {
      horizontal: "tw-flex tw-w-full tw-items-center tw-border-b",
      vertical: "tw-flex tw-h-[400px] tw-w-full tw-flex-col tw-overflow-y-auto tw-border-r"
    }
  },
  defaultVariants: {
    layout: "horizontal"
  }
}), gA = oe("tw-flex tw-shrink-0 tw-flex-col tw-border-2 tw-px-2 tw-py-2 tw-text-left tw-transition-all", {
  variants: {
    isActive: {
      true: "tw-border-brand-primary-7 tw-bg-white tw-shadow-lg",
      false: "tw-border-transparent hover:tw-bg-brand-primary-2"
    },
    layout: {
      horizontal: "tw-min-w-[180px] tw-rounded",
      vertical: "tw-w-full tw-rounded-none"
    }
  },
  defaultVariants: {
    isActive: !1,
    layout: "horizontal"
  }
}), hA = oe("tw-flex tw-h-[500px] tw-flex-col", {
  variants: {
    padding: {
      none: "",
      default: "tw-p-4"
    },
    layout: {
      horizontal: "tw-w-full",
      vertical: "tw-flex-1"
    }
  },
  defaultVariants: {
    padding: "none",
    layout: "horizontal"
  }
}), kf = oe("tw-flex tw-h-full tw-w-full tw-flex-col", {
  variants: {
    layout: {
      default: "",
      compact: ""
    }
  },
  defaultVariants: {
    layout: "default"
  }
}), vA = oe("tw-flex tw-h-full tw-w-full tw-flex-col tw-overflow-auto", {
  variants: {
    layout: {
      default: "",
      compact: ""
    }
  },
  defaultVariants: {
    layout: "default"
  }
}), wA = oe("tw-flex", {
  variants: {
    layout: {
      horizontal: "tw-scrollbar-hide tw-snap-x tw-snap-mandatory tw-gap-2 tw-overflow-x-auto tw-p-2",
      vertical: "tw-w-full tw-flex-col tw-overflow-y-auto"
    }
  },
  defaultVariants: {
    layout: "horizontal"
  }
}), bA = q(
  ({ className: e, layout: t = "horizontal", children: n, ...r }, o) => {
    const a = Yo.map(n, (i) => ur(i) ? tn(i, { layout: t }) : i);
    return /* @__PURE__ */ m(
      "div",
      {
        ref: o,
        className: N(
          pA({ layout: t }),
          t === "vertical" ? "tw-w-full" : "",
          // Ensure full width in vertical mode
          e
        ),
        ...r,
        children: a
      }
    );
  }
);
bA.displayName = "Playlist";
const yA = q(
  ({ className: e, layout: t = "horizontal", children: n, ...r }, o) => {
    const a = qe(null), [i, s] = ye(!1), [l, c] = ye(!1), u = () => {
      if (a.current) {
        const { scrollLeft: p, scrollWidth: h, clientWidth: g } = a.current;
        s(p > 0), c(p < h - g - 8);
      }
    }, d = (p) => {
      if (a.current) {
        const g = p === "left" ? a.current.scrollLeft - 200 : a.current.scrollLeft + 200;
        a.current.scrollTo({
          left: g,
          behavior: "smooth"
        });
      }
    };
    ke(() => (u(), window.addEventListener("resize", u), () => window.removeEventListener("resize", u)), []), ke(() => {
      const p = a.current;
      if (p)
        return p.addEventListener("scroll", u), () => p.removeEventListener("scroll", u);
    }, []);
    const f = Yo.map(n, (p) => ur(p) ? tn(p, { layout: t }) : p);
    return /* @__PURE__ */ ee(
      "div",
      { className: N(mA({ layout: t }), e), ...r, children: [
        t === "horizontal" && i && /* @__PURE__ */ m(
          mt,
          {
            variant: "solid",
            intent: "neutral",
            iconName: "chevron-left",
            size: "md",
            onClick: () => d("left"),
            ariaLabel: "Scroll items left"
          }
        ),
        /* @__PURE__ */ m(
          "div",
          {
            ref: a,
            className: N(wA({ layout: t })),
            onScroll: u,
            children: f
          }
        ),
        t === "horizontal" && l && /* @__PURE__ */ m(
          mt,
          {
            variant: "solid",
            intent: "neutral",
            iconName: "chevron-right",
            size: "md",
            onClick: () => d("right"),
            ariaLabel: "Scroll items right"
          }
        )
      ] }
    );
  }
);
yA.displayName = "PlaylistTabs";
const xA = q(
  ({ className: e, isActive: t = !1, title: n, runtime: r, layout: o, ...a }, i) => /* @__PURE__ */ m(
    "button",
    {
      ref: i,
      className: N(
        gA({ isActive: t, layout: o }),
        "tw-snap-start",
        e
      ),
      "aria-selected": t,
      role: "tab",
      ...a,
      children: /* @__PURE__ */ ee(
        "div",
        { className: "tw-flex tw-flex-col tw-justify-start tw-gap-1", children: [
          /* @__PURE__ */ m("h5", { className: "tw-line-clamp-2 tw-text-sm tw-font-medium", children: n }),
          r && /* @__PURE__ */ m(
            "caption",
            { className: "tw-text-left tw-text-xs tw-text-neutral-500", children: r }
          )
        ] }
      )
    }
  )
);
xA.displayName = "PlaylistTab";
const SA = q(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ m(
    "div",
    {
      ref: r,
      className: N(hA(), e),
      ...n,
      children: t
    }
  )
);
SA.displayName = "PlaylistContent";
const CA = q(
  ({
    className: e,
    videoUrl: t,
    title: n,
    description: r,
    autoplay: o = !0,
    showControls: a = !0,
    videoType: i = "html5",
    ...s
  }, l) => {
    const [c, u] = ye(!0), [d, f] = ye(!1), [p, h] = ye(!1), [g, w] = ye(!1), b = qe(null), y = qe(null), x = () => {
      h(!0), u(!1), console.error("Error loading video:", t);
    };
    if (ke(() => {
      h(!1), f(!1), u(!0);
    }, [t]), ke(() => {
      p && u(!1);
    }, [p]), ke(() => {
      if (d) {
        const S = setTimeout(() => {
          u(!1);
        }, 2e3);
        return () => clearTimeout(S);
      } else
        u(!0);
    }, [d]), ke(() => {
      if (o && b.current && i === "html5") {
        const S = b.current.play();
        S !== void 0 && S.then(() => {
          f(!0);
        }).catch((R) => {
          console.error("Error autoplaying video:", R), h(!0);
        });
      }
    }, [o, t, i]), ke(() => {
      const S = () => {
        const R = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
        w(R);
      };
      return document.addEventListener("fullscreenchange", S), document.addEventListener(
        "webkitfullscreenchange",
        S
      ), document.addEventListener("mozfullscreenchange", S), document.addEventListener("MSFullscreenChange", S), () => {
        document.removeEventListener(
          "fullscreenchange",
          S
        ), document.removeEventListener(
          "webkitfullscreenchange",
          S
        ), document.removeEventListener(
          "mozfullscreenchange",
          S
        ), document.removeEventListener(
          "MSFullscreenChange",
          S
        );
      };
    }, []), p)
      return /* @__PURE__ */ m(
        "div",
        {
          ref: l,
          className: N(kf(), e),
          ...s,
          children: /* @__PURE__ */ ee(
            "div",
            { className: "tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-bg-neutral-100 tw-p-4", children: [
              /* @__PURE__ */ m(
                de,
                {
                  icon: "image-slash",
                  size: "xl",
                  className: "tw-text-neutral-400"
                }
              ),
              /* @__PURE__ */ m(
                "h3",
                { className: "tw-text-lg tw-font-medium tw-text-neutral-700", children: "Unable to load video" }
              ),
              /* @__PURE__ */ m(
                "p",
                { className: "tw-text-sm tw-text-neutral-500 tw-text-center", children: "We're sorry, but we couldn't load this video. Please try again later or contact support if the problem persists." }
              )
            ] }
          )
        }
      );
    const C = () => {
      var S;
      return i === "vimeo" ? `https://player.vimeo.com/video/${t.split("/").pop()}?autoplay=${o ? 1 : 0}&controls=${a ? 1 : 0}` : i === "youtube" ? `https://www.youtube.com/embed/${(S = t.split("v=")[1]) == null ? void 0 : S.split("&")[0]}?autoplay=${o ? 1 : 0}&controls=${a ? 1 : 0}` : t;
    };
    return /* @__PURE__ */ m(
      "div",
      {
        ref: l,
        className: N(kf(), e),
        "data-testid": "playlist-video",
        ...s,
        children: /* @__PURE__ */ ee(
          "div",
          { className: "tw-relative tw-h-full tw-w-full tw-overflow-hidden", children: [
            i === "html5" ? /* @__PURE__ */ m(
              "video",
              {
                ref: b,
                className: "tw-h-full tw-w-full tw-object-contain",
                controls: a,
                src: t,
                muted: o,
                role: "video",
                onError: x,
                controlsList: "nodownload",
                onPlay: () => f(!0),
                onPause: () => f(!1),
                "data-playing": d,
                onLoadStart: () => h(!1),
                onLoadedData: () => h(!1),
                "data-testid": "playlist-video-player"
              }
            ) : /* @__PURE__ */ m(
              "iframe",
              {
                ref: y,
                className: "tw-h-full tw-w-full",
                src: C(),
                allow: "autoplay; fullscreen",
                allowFullScreen: !0,
                frameBorder: "0",
                onError: x,
                "data-testid": "playlist-video-embed"
              }
            ),
            /* @__PURE__ */ m(
              Gw,
              {
                title: n,
                description: r,
                isVisible: c
              }
            )
          ] }
        )
      }
    );
  }
);
CA.displayName = "PlaylistVideo";
const EA = q(
  ({ className: e, title: t, description: n, content: r = [], ctaButton: o, ...a }, i) => /* @__PURE__ */ m(
    "div",
    {
      ref: i,
      className: N(vA(), e),
      "data-testid": "playlist-article",
      ...a,
      children: /* @__PURE__ */ ee(
        "div",
        { className: "tw-p-4", children: [
          /* @__PURE__ */ m(
            "h3",
            {
              className: "tw-text-xl tw-font-medium",
              "data-testid": "playlist-article-title",
              children: t
            }
          ),
          n && /* @__PURE__ */ m(
            "p",
            {
              className: "tw-mt-2 tw-text-sm tw-text-neutral-600",
              "data-testid": "playlist-article-description",
              children: n
            }
          ),
          /* @__PURE__ */ m(
            "div",
            { className: "tw-mt-4 tw-space-y-3", children: r.map(
              (s, l) => /* @__PURE__ */ m(
                "p",
                {
                  className: "tw-text-sm",
                  "data-testid": `playlist-article-content-${l}`,
                  children: s
                },
                l
              )
            ) }
          ),
          o && /* @__PURE__ */ m(
            "div",
            { className: "tw-mt-6", children: o.variant === "link" ? /* @__PURE__ */ m(
              Vg,
              {
                hrefUrl: o.href || "#",
                target: o.target,
                label: o.label,
                variant: "underline",
                size: "sm",
                "data-testid": "playlist-article-cta"
              }
            ) : /* @__PURE__ */ m(
              pt,
              {
                onClick: o.onClick,
                "data-testid": "playlist-article-cta",
                children: o.label
              }
            ) }
          )
        ] }
      )
    }
  )
);
EA.displayName = "PlaylistArticle";
const Gw = q(
  ({ className: e, title: t, description: n, isVisible: r = !0, ...o }, a) => r ? /* @__PURE__ */ ee(
    "div",
    {
      ref: a,
      className: N(
        "tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-bg-black/50 tw-backdrop-blur-xl tw-text-white tw-px-4 tw-py-6 tw-transition-opacity",
        e
      ),
      "data-testid": "playlist-info-banner",
      ...o,
      children: [
        /* @__PURE__ */ m(
          "h3",
          {
            className: "tw-text-lg tw-font-medium",
            "data-testid": "playlist-info-banner-title",
            children: t
          }
        ),
        n && /* @__PURE__ */ m(
          "p",
          {
            className: "tw-mt-1 tw-text-sm",
            "data-testid": "playlist-info-banner-description",
            children: n
          }
        )
      ]
    }
  ) : null
);
Gw.displayName = "InfoBanner";
var Bu = "Radio", [kA, Uw] = Ye(Bu), [RA, PA] = kA(Bu), qw = v.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: o = !1,
      required: a,
      disabled: i,
      value: s = "on",
      onCheck: l,
      form: c,
      ...u
    } = e, [d, f] = v.useState(null), p = xe(t, (w) => f(w)), h = v.useRef(!1), g = d ? c || !!d.closest("form") : !0;
    return /* @__PURE__ */ ee(RA, { scope: n, checked: o, disabled: i, children: [
      /* @__PURE__ */ m(
        ie.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": Xw(o),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: s,
          ...u,
          ref: p,
          onClick: re(e.onClick, (w) => {
            o || l == null || l(), g && (h.current = w.isPropagationStopped(), h.current || w.stopPropagation());
          })
        }
      ),
      g && /* @__PURE__ */ m(
        NA,
        {
          control: d,
          bubbles: !h.current,
          name: r,
          value: s,
          checked: o,
          required: a,
          disabled: i,
          form: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
qw.displayName = Bu;
var Yw = "RadioIndicator", Kw = v.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: r, ...o } = e, a = PA(Yw, n);
    return /* @__PURE__ */ m(at, { present: r || a.checked, children: /* @__PURE__ */ m(
      ie.span,
      {
        "data-state": Xw(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
Kw.displayName = Yw;
var NA = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, a = v.useRef(null), i = Xi(n), s = Ii(t);
  return v.useEffect(() => {
    const l = a.current, c = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(c, "checked").set;
    if (i !== n && d) {
      const f = new Event("click", { bubbles: r });
      d.call(l, n), l.dispatchEvent(f);
    }
  }, [i, n, r]), /* @__PURE__ */ m(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: n,
      ...o,
      tabIndex: -1,
      ref: a,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Xw(e) {
  return e ? "checked" : "unchecked";
}
var TA = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Hu = "RadioGroup", [_A, i4] = Ye(Hu, [
  an,
  Uw
]), Jw = an(), Qw = Uw(), [IA, MA] = _A(Hu), Zw = v.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: o,
      value: a,
      required: i = !1,
      disabled: s = !1,
      orientation: l,
      dir: c,
      loop: u = !0,
      onValueChange: d,
      ...f
    } = e, p = Jw(n), h = Ln(c), [g, w] = je({
      prop: a,
      defaultProp: o,
      onChange: d
    });
    return /* @__PURE__ */ m(
      IA,
      {
        scope: n,
        name: r,
        required: i,
        disabled: s,
        value: g,
        onValueChange: w,
        children: /* @__PURE__ */ m(
          la,
          {
            asChild: !0,
            ...p,
            orientation: l,
            dir: h,
            loop: u,
            children: /* @__PURE__ */ m(
              ie.div,
              {
                role: "radiogroup",
                "aria-required": i,
                "aria-orientation": l,
                "data-disabled": s ? "" : void 0,
                dir: h,
                ...f,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
Zw.displayName = Hu;
var eb = "RadioGroupItem", tb = v.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: r, ...o } = e, a = MA(eb, n), i = a.disabled || r, s = Jw(n), l = Qw(n), c = v.useRef(null), u = xe(t, c), d = a.value === o.value, f = v.useRef(!1);
    return v.useEffect(() => {
      const p = (g) => {
        TA.includes(g.key) && (f.current = !0);
      }, h = () => f.current = !1;
      return document.addEventListener("keydown", p), document.addEventListener("keyup", h), () => {
        document.removeEventListener("keydown", p), document.removeEventListener("keyup", h);
      };
    }, []), /* @__PURE__ */ m(
      ca,
      {
        asChild: !0,
        ...s,
        focusable: !i,
        active: d,
        children: /* @__PURE__ */ m(
          qw,
          {
            disabled: i,
            required: a.required,
            checked: d,
            ...l,
            ...o,
            name: a.name,
            ref: u,
            onCheck: () => a.onValueChange(o.value),
            onKeyDown: re((p) => {
              p.key === "Enter" && p.preventDefault();
            }),
            onFocus: re(o.onFocus, () => {
              var p;
              f.current && ((p = c.current) == null || p.click());
            })
          }
        )
      }
    );
  }
);
tb.displayName = eb;
var OA = "RadioGroupIndicator", nb = v.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...r } = e, o = Qw(n);
    return /* @__PURE__ */ m(Kw, { ...o, ...r, ref: t });
  }
);
nb.displayName = OA;
var rb = Zw, Wu = tb, ob = nb;
const DA = oe("tw-mb-1 tw-flex tw-items-center", {
  variants: {
    disabled: {
      true: "tw-pointer-events-none"
    }
  }
}), ab = oe(
  "custom-global-focus-ring tw-h-4 tw-w-4 tw-rounded-full tw-border tw-border-brand-neutral-7 tw-bg-brand-neutral-white disabled:tw-border-semantic-formElement-border-neutral-disabled",
  {
    variants: {
      disabled: {
        true: "tw-bg-semantic-formElement-background-neutral-disabled"
      }
    }
  }
), AA = oe(
  `tw-focus-within:tw-ring-2 tw-focus-within:tw-ring-blue-500 tw-focus-within:tw-ring-offset-2 tw-flex  tw-cursor-pointer tw-items-start tw-gap-4 
tw-rounded-lg tw-border tw-p-4 tw-transition-all tw-duration-200 hover:tw-border-semantic-formElement-border-neutral-stronger`,
  {
    variants: {
      checked: {
        true: "tw-border-semantic-formElement-border-neutral-stronger tw-bg-semantic-formElement-background-neutral-strong "
      },
      disabled: {
        true: "tw-pointer-events-none tw-cursor-not-allowed tw-border-semantic-formElement-border-neutral-default tw-bg-semantic-formElement-background-neutral-disabled tw-text-semantic-action-foreground-neutral-weak"
      }
    },
    compoundVariants: [
      {
        checked: !0,
        disabled: !0,
        className: "!tw-border-semantic-formElement-border-neutral-disabled  !tw-bg-semantic-formElement-background-neutral-disabled "
      }
    ]
  }
), $A = "tw-ml-2 tw-productiveFluid-label-label-md-regular ", ib = "tw-flex tw-justify-center tw-items-center tw-transition-all ", LA = q(
  ({ label: e, children: t, className: n, defaultValue: r, ...o }, a) => /* @__PURE__ */ m(
    rb,
    {
      className: n,
      defaultValue: r,
      "aria-label": e,
      ref: a,
      ...o,
      children: t
    }
  )
);
LA.displayName = rb.displayName;
const s4 = q(
  ({
    label: e,
    value: t,
    className: n,
    checked: r,
    disabled: o,
    variant: a = "default",
    onSelect: i,
    children: s
  }, l) => a === "default" ? /* @__PURE__ */ m(
    FA,
    {
      label: e,
      onSelect: i,
      value: t,
      className: n,
      checked: r,
      disabled: o,
      ref: l
    }
  ) : /* @__PURE__ */ m(
    zA,
    {
      label: e,
      onSelect: i,
      value: t,
      className: n,
      checked: r,
      disabled: o,
      ref: l,
      children: s
    }
  )
), FA = q(
  ({ label: e, value: t, className: n, checked: r, disabled: o, onSelect: a }, i) => {
    const s = $n();
    return /* @__PURE__ */ ee(
      "div",
      {
        className: N(n, DA({ disabled: o })),
        onClick: () => {
          a(t);
        },
        children: [
          /* @__PURE__ */ m(
            Wu,
            {
              value: t,
              checked: r,
              disabled: o,
              className: N(ab({ disabled: o })),
              id: s,
              ref: i,
              children: /* @__PURE__ */ m(
                ob,
                { className: ib, children: /* @__PURE__ */ m(
                  "div",
                  {
                    className: `tw-h-2 tw-w-2 tw-rounded-full ${r && o ? (
                      // Dot color. Replace with token after retokenization
                      "tw-bg-[#959595]"
                    ) : "tw-bg-semantic-static-foreground-primary-default"}`
                  }
                ) }
              )
            }
          ),
          /* @__PURE__ */ m(
            "label",
            { className: $A, htmlFor: s, children: e }
          )
        ]
      }
    );
  }
), zA = q(
  ({ label: e, value: t, className: n, checked: r, disabled: o, onSelect: a, children: i }, s) => {
    const l = $n();
    return /* @__PURE__ */ ee(
      "label",
      {
        htmlFor: l,
        className: N(AA({ checked: r, disabled: o }), n),
        onClick: () => {
          a(t);
        },
        "aria-label": e,
        children: [
          /* @__PURE__ */ m(
            Wu,
            {
              value: t,
              checked: r,
              disabled: o,
              className: N(ab({ disabled: o }), "tw-min-w-4"),
              id: l,
              ref: s,
              children: /* @__PURE__ */ m(
                ob,
                {
                  className: N(ib),
                  children: /* @__PURE__ */ m(
                    "div",
                    {
                      className: `tw-h-2 tw-w-2 tw-rounded-full ${r && o ? (
                        // Dot color. Replace with token after retokenization
                        "tw-bg-[#959595]"
                      ) : "tw-bg-semantic-static-foreground-primary-default"}`
                    }
                  )
                }
              )
            }
          ),
          i
        ]
      }
    );
  }
), l4 = q(
  ({ label: e, value: t, className: n, checked: r, disabled: o, onSelect: a, children: i, asChild: s }, l) => {
    const c = $n();
    return /* @__PURE__ */ m(
      "label",
      {
        className: N(
          "tw-cursor-pointer",
          o && "tw-pointer-events-none tw-cursor-not-allowed",
          n
        ),
        htmlFor: c,
        onClick: () => {
          a(t);
        },
        "aria-label": e,
        children: /* @__PURE__ */ m(
          Wu,
          {
            value: t,
            checked: r,
            disabled: o,
            id: c,
            ref: l,
            asChild: !!s,
            children: i
          }
        )
      }
    );
  }
), {
  createElement: Vr,
  createContext: VA,
  forwardRef: sb,
  useCallback: dt,
  useContext: lb,
  useEffect: Qn,
  useImperativeHandle: cb,
  useLayoutEffect: BA,
  useMemo: HA,
  useRef: ft,
  useState: Mr
} = v, Rf = v[`useId${Math.random()}`.slice(0, 5)], WA = BA, es = VA(null);
es.displayName = "PanelGroupContext";
const Zn = WA, jA = typeof Rf == "function" ? Rf : () => null;
let GA = 0;
function ju(e = null) {
  const t = jA(), n = ft(e || t || null);
  return n.current === null && (n.current = "" + GA++), e ?? n.current;
}
function ub({
  children: e,
  className: t = "",
  collapsedSize: n,
  collapsible: r,
  defaultSize: o,
  forwardedRef: a,
  id: i,
  maxSize: s,
  minSize: l,
  onCollapse: c,
  onExpand: u,
  onResize: d,
  order: f,
  style: p,
  tagName: h = "div",
  ...g
}) {
  const w = lb(es);
  if (w === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  const {
    collapsePanel: b,
    expandPanel: y,
    getPanelSize: x,
    getPanelStyle: C,
    groupId: S,
    isPanelCollapsed: R,
    reevaluatePanelConstraints: E,
    registerPanel: M,
    resizePanel: F,
    unregisterPanel: G
  } = w, U = ju(i), H = ft({
    callbacks: {
      onCollapse: c,
      onExpand: u,
      onResize: d
    },
    constraints: {
      collapsedSize: n,
      collapsible: r,
      defaultSize: o,
      maxSize: s,
      minSize: l
    },
    id: U,
    idIsFromProps: i !== void 0,
    order: f
  });
  ft({
    didLogMissingDefaultSizeWarning: !1
  }).current.didLogMissingDefaultSizeWarning, Zn(() => {
    const {
      callbacks: Z,
      constraints: Y
    } = H.current, O = {
      ...Y
    };
    H.current.id = U, H.current.idIsFromProps = i !== void 0, H.current.order = f, Z.onCollapse = c, Z.onExpand = u, Z.onResize = d, Y.collapsedSize = n, Y.collapsible = r, Y.defaultSize = o, Y.maxSize = s, Y.minSize = l, (O.collapsedSize !== Y.collapsedSize || O.collapsible !== Y.collapsible || O.maxSize !== Y.maxSize || O.minSize !== Y.minSize) && E(H.current, O);
  }), Zn(() => {
    const Z = H.current;
    return M(Z), () => {
      G(Z);
    };
  }, [f, U, M, G]), cb(a, () => ({
    collapse: () => {
      b(H.current);
    },
    expand: (Z) => {
      y(H.current, Z);
    },
    getId() {
      return U;
    },
    getSize() {
      return x(H.current);
    },
    isCollapsed() {
      return R(H.current);
    },
    isExpanded() {
      return !R(H.current);
    },
    resize: (Z) => {
      F(H.current, Z);
    }
  }), [b, y, x, R, U, F]);
  const z = C(H.current, o);
  return Vr(h, {
    ...g,
    children: e,
    className: t,
    id: i,
    style: {
      ...z,
      ...p
    },
    // CSS selectors
    "data-panel": "",
    "data-panel-collapsible": r || void 0,
    "data-panel-group-id": S,
    "data-panel-id": U,
    "data-panel-size": parseFloat("" + z.flexGrow).toFixed(1)
  });
}
const db = sb((e, t) => Vr(ub, {
  ...e,
  forwardedRef: t
}));
ub.displayName = "Panel";
db.displayName = "forwardRef(Panel)";
let ec = null, Xn = null;
function UA(e, t) {
  if (t) {
    const n = (t & hb) !== 0, r = (t & vb) !== 0, o = (t & wb) !== 0, a = (t & bb) !== 0;
    if (n)
      return o ? "se-resize" : a ? "ne-resize" : "e-resize";
    if (r)
      return o ? "sw-resize" : a ? "nw-resize" : "w-resize";
    if (o)
      return "s-resize";
    if (a)
      return "n-resize";
  }
  switch (e) {
    case "horizontal":
      return "ew-resize";
    case "intersection":
      return "move";
    case "vertical":
      return "ns-resize";
  }
}
function qA() {
  Xn !== null && (document.head.removeChild(Xn), ec = null, Xn = null);
}
function il(e, t) {
  const n = UA(e, t);
  ec !== n && (ec = n, Xn === null && (Xn = document.createElement("style"), document.head.appendChild(Xn)), Xn.innerHTML = `*{cursor: ${n}!important;}`);
}
function fb(e) {
  return e.type === "keydown";
}
function pb(e) {
  return e.type.startsWith("pointer");
}
function mb(e) {
  return e.type.startsWith("mouse");
}
function ts(e) {
  if (pb(e)) {
    if (e.isPrimary)
      return {
        x: e.clientX,
        y: e.clientY
      };
  } else if (mb(e))
    return {
      x: e.clientX,
      y: e.clientY
    };
  return {
    x: 1 / 0,
    y: 1 / 0
  };
}
function YA() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
function KA(e, t, n) {
  return e.x < t.x + t.width && e.x + e.width > t.x && e.y < t.y + t.height && e.y + e.height > t.y;
}
function XA(e, t) {
  if (e === t) throw new Error("Cannot compare node with itself");
  const n = {
    a: Tf(e),
    b: Tf(t)
  };
  let r;
  for (; n.a.at(-1) === n.b.at(-1); )
    e = n.a.pop(), t = n.b.pop(), r = e;
  we(r, "Stacking order can only be calculated for elements with a common ancestor");
  const o = {
    a: Nf(Pf(n.a)),
    b: Nf(Pf(n.b))
  };
  if (o.a === o.b) {
    const a = r.childNodes, i = {
      a: n.a.at(-1),
      b: n.b.at(-1)
    };
    let s = a.length;
    for (; s--; ) {
      const l = a[s];
      if (l === i.a) return 1;
      if (l === i.b) return -1;
    }
  }
  return Math.sign(o.a - o.b);
}
const JA = /\b(?:position|zIndex|opacity|transform|webkitTransform|mixBlendMode|filter|webkitFilter|isolation)\b/;
function QA(e) {
  var t;
  const n = getComputedStyle((t = gb(e)) !== null && t !== void 0 ? t : e).display;
  return n === "flex" || n === "inline-flex";
}
function ZA(e) {
  const t = getComputedStyle(e);
  return !!(t.position === "fixed" || t.zIndex !== "auto" && (t.position !== "static" || QA(e)) || +t.opacity < 1 || "transform" in t && t.transform !== "none" || "webkitTransform" in t && t.webkitTransform !== "none" || "mixBlendMode" in t && t.mixBlendMode !== "normal" || "filter" in t && t.filter !== "none" || "webkitFilter" in t && t.webkitFilter !== "none" || "isolation" in t && t.isolation === "isolate" || JA.test(t.willChange) || t.webkitOverflowScrolling === "touch");
}
function Pf(e) {
  let t = e.length;
  for (; t--; ) {
    const n = e[t];
    if (we(n, "Missing node"), ZA(n)) return n;
  }
  return null;
}
function Nf(e) {
  return e && Number(getComputedStyle(e).zIndex) || 0;
}
function Tf(e) {
  const t = [];
  for (; e; )
    t.push(e), e = gb(e);
  return t;
}
function gb(e) {
  const {
    parentNode: t
  } = e;
  return t && t instanceof ShadowRoot ? t.host : t;
}
const hb = 1, vb = 2, wb = 4, bb = 8, e2 = YA() === "coarse";
let $t = [], Or = !1, Cn = /* @__PURE__ */ new Map(), ns = /* @__PURE__ */ new Map();
const Ho = /* @__PURE__ */ new Set();
function t2(e, t, n, r, o) {
  var a;
  const {
    ownerDocument: i
  } = t, s = {
    direction: n,
    element: t,
    hitAreaMargins: r,
    setResizeHandlerState: o
  }, l = (a = Cn.get(i)) !== null && a !== void 0 ? a : 0;
  return Cn.set(i, l + 1), Ho.add(s), hi(), function() {
    var u;
    ns.delete(e), Ho.delete(s);
    const d = (u = Cn.get(i)) !== null && u !== void 0 ? u : 1;
    if (Cn.set(i, d - 1), hi(), d === 1 && Cn.delete(i), $t.includes(s)) {
      const f = $t.indexOf(s);
      f >= 0 && $t.splice(f, 1), Uu(), o("up", !0, null);
    }
  };
}
function _f(e) {
  const {
    target: t
  } = e, {
    x: n,
    y: r
  } = ts(e);
  Or = !0, Gu({
    target: t,
    x: n,
    y: r
  }), hi(), $t.length > 0 && (vi("down", e), e.preventDefault(), e.stopPropagation());
}
function vo(e) {
  const {
    x: t,
    y: n
  } = ts(e);
  if (Or && e.buttons === 0 && (Or = !1, vi("up", e)), !Or) {
    const {
      target: r
    } = e;
    Gu({
      target: r,
      x: t,
      y: n
    });
  }
  vi("move", e), Uu(), $t.length > 0 && e.preventDefault();
}
function xr(e) {
  const {
    target: t
  } = e, {
    x: n,
    y: r
  } = ts(e);
  ns.clear(), Or = !1, $t.length > 0 && e.preventDefault(), vi("up", e), Gu({
    target: t,
    x: n,
    y: r
  }), Uu(), hi();
}
function Gu({
  target: e,
  x: t,
  y: n
}) {
  $t.splice(0);
  let r = null;
  (e instanceof HTMLElement || e instanceof SVGElement) && (r = e), Ho.forEach((o) => {
    const {
      element: a,
      hitAreaMargins: i
    } = o, s = a.getBoundingClientRect(), {
      bottom: l,
      left: c,
      right: u,
      top: d
    } = s, f = e2 ? i.coarse : i.fine;
    if (t >= c - f && t <= u + f && n >= d - f && n <= l + f) {
      if (r !== null && document.contains(r) && a !== r && !a.contains(r) && !r.contains(a) && // Calculating stacking order has a cost, so we should avoid it if possible
      // That is why we only check potentially intersecting handles,
      // and why we skip if the event target is within the handle's DOM
      XA(r, a) > 0) {
        let h = r, g = !1;
        for (; h && !h.contains(a); ) {
          if (KA(h.getBoundingClientRect(), s)) {
            g = !0;
            break;
          }
          h = h.parentElement;
        }
        if (g)
          return;
      }
      $t.push(o);
    }
  });
}
function sl(e, t) {
  ns.set(e, t);
}
function Uu() {
  let e = !1, t = !1;
  $t.forEach((r) => {
    const {
      direction: o
    } = r;
    o === "horizontal" ? e = !0 : t = !0;
  });
  let n = 0;
  ns.forEach((r) => {
    n |= r;
  }), e && t ? il("intersection", n) : e ? il("horizontal", n) : t ? il("vertical", n) : qA();
}
function hi() {
  Cn.forEach((e, t) => {
    const {
      body: n
    } = t;
    n.removeEventListener("contextmenu", xr), n.removeEventListener("pointerdown", _f), n.removeEventListener("pointerleave", vo), n.removeEventListener("pointermove", vo);
  }), window.removeEventListener("pointerup", xr), window.removeEventListener("pointercancel", xr), Ho.size > 0 && (Or ? ($t.length > 0 && Cn.forEach((e, t) => {
    const {
      body: n
    } = t;
    e > 0 && (n.addEventListener("contextmenu", xr), n.addEventListener("pointerleave", vo), n.addEventListener("pointermove", vo));
  }), window.addEventListener("pointerup", xr), window.addEventListener("pointercancel", xr)) : Cn.forEach((e, t) => {
    const {
      body: n
    } = t;
    e > 0 && (n.addEventListener("pointerdown", _f, {
      capture: !0
    }), n.addEventListener("pointermove", vo));
  }));
}
function vi(e, t) {
  Ho.forEach((n) => {
    const {
      setResizeHandlerState: r
    } = n, o = $t.includes(n);
    r(e, o, t);
  });
}
function n2() {
  const [e, t] = Mr(0);
  return dt(() => t((n) => n + 1), []);
}
function we(e, t) {
  if (!e)
    throw console.error(t), Error(t);
}
const qu = 10;
function lr(e, t, n = qu) {
  return e.toFixed(n) === t.toFixed(n) ? 0 : e > t ? 1 : -1;
}
function pn(e, t, n = qu) {
  return lr(e, t, n) === 0;
}
function xt(e, t, n) {
  return lr(e, t, n) === 0;
}
function r2(e, t, n) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++) {
    const o = e[r], a = t[r];
    if (!xt(o, a, n))
      return !1;
  }
  return !0;
}
function Pr({
  panelConstraints: e,
  panelIndex: t,
  size: n
}) {
  const r = e[t];
  we(r != null, `Panel constraints not found for index ${t}`);
  let {
    collapsedSize: o = 0,
    collapsible: a,
    maxSize: i = 100,
    minSize: s = 0
  } = r;
  if (lr(n, s) < 0)
    if (a) {
      const l = (o + s) / 2;
      lr(n, l) < 0 ? n = o : n = s;
    } else
      n = s;
  return n = Math.min(i, n), n = parseFloat(n.toFixed(qu)), n;
}
function Ro({
  delta: e,
  initialLayout: t,
  panelConstraints: n,
  pivotIndices: r,
  prevLayout: o,
  trigger: a
}) {
  if (xt(e, 0))
    return t;
  const i = [...t], [s, l] = r;
  we(s != null, "Invalid first pivot index"), we(l != null, "Invalid second pivot index");
  let c = 0;
  if (a === "keyboard") {
    {
      const d = e < 0 ? l : s, f = n[d];
      we(f, `Panel constraints not found for index ${d}`);
      const {
        collapsedSize: p = 0,
        collapsible: h,
        minSize: g = 0
      } = f;
      if (h) {
        const w = t[d];
        if (we(w != null, `Previous layout not found for panel index ${d}`), xt(w, p)) {
          const b = g - w;
          lr(b, Math.abs(e)) > 0 && (e = e < 0 ? 0 - b : b);
        }
      }
    }
    {
      const d = e < 0 ? s : l, f = n[d];
      we(f, `No panel constraints found for index ${d}`);
      const {
        collapsedSize: p = 0,
        collapsible: h,
        minSize: g = 0
      } = f;
      if (h) {
        const w = t[d];
        if (we(w != null, `Previous layout not found for panel index ${d}`), xt(w, g)) {
          const b = w - p;
          lr(b, Math.abs(e)) > 0 && (e = e < 0 ? 0 - b : b);
        }
      }
    }
  }
  {
    const d = e < 0 ? 1 : -1;
    let f = e < 0 ? l : s, p = 0;
    for (; ; ) {
      const g = t[f];
      we(g != null, `Previous layout not found for panel index ${f}`);
      const b = Pr({
        panelConstraints: n,
        panelIndex: f,
        size: 100
      }) - g;
      if (p += b, f += d, f < 0 || f >= n.length)
        break;
    }
    const h = Math.min(Math.abs(e), Math.abs(p));
    e = e < 0 ? 0 - h : h;
  }
  {
    let f = e < 0 ? s : l;
    for (; f >= 0 && f < n.length; ) {
      const p = Math.abs(e) - Math.abs(c), h = t[f];
      we(h != null, `Previous layout not found for panel index ${f}`);
      const g = h - p, w = Pr({
        panelConstraints: n,
        panelIndex: f,
        size: g
      });
      if (!xt(h, w) && (c += h - w, i[f] = w, c.toPrecision(3).localeCompare(Math.abs(e).toPrecision(3), void 0, {
        numeric: !0
      }) >= 0))
        break;
      e < 0 ? f-- : f++;
    }
  }
  if (r2(o, i))
    return o;
  {
    const d = e < 0 ? l : s, f = t[d];
    we(f != null, `Previous layout not found for panel index ${d}`);
    const p = f + c, h = Pr({
      panelConstraints: n,
      panelIndex: d,
      size: p
    });
    if (i[d] = h, !xt(h, p)) {
      let g = p - h, b = e < 0 ? l : s;
      for (; b >= 0 && b < n.length; ) {
        const y = i[b];
        we(y != null, `Previous layout not found for panel index ${b}`);
        const x = y + g, C = Pr({
          panelConstraints: n,
          panelIndex: b,
          size: x
        });
        if (xt(y, C) || (g -= C - y, i[b] = C), xt(g, 0))
          break;
        e > 0 ? b-- : b++;
      }
    }
  }
  const u = i.reduce((d, f) => f + d, 0);
  return xt(u, 100) ? i : o;
}
function o2({
  layout: e,
  panelsArray: t,
  pivotIndices: n
}) {
  let r = 0, o = 100, a = 0, i = 0;
  const s = n[0];
  we(s != null, "No pivot index found"), t.forEach((d, f) => {
    const {
      constraints: p
    } = d, {
      maxSize: h = 100,
      minSize: g = 0
    } = p;
    f === s ? (r = g, o = h) : (a += g, i += h);
  });
  const l = Math.min(o, 100 - a), c = Math.max(r, 100 - i), u = e[s];
  return {
    valueMax: l,
    valueMin: c,
    valueNow: u
  };
}
function Wo(e, t = document) {
  return Array.from(t.querySelectorAll(`[data-panel-resize-handle-id][data-panel-group-id="${e}"]`));
}
function yb(e, t, n = document) {
  const o = Wo(e, n).findIndex((a) => a.getAttribute("data-panel-resize-handle-id") === t);
  return o ?? null;
}
function xb(e, t, n) {
  const r = yb(e, t, n);
  return r != null ? [r, r + 1] : [-1, -1];
}
function Sb(e, t = document) {
  var n;
  if (t instanceof HTMLElement && (t == null || (n = t.dataset) === null || n === void 0 ? void 0 : n.panelGroupId) == e)
    return t;
  const r = t.querySelector(`[data-panel-group][data-panel-group-id="${e}"]`);
  return r || null;
}
function rs(e, t = document) {
  const n = t.querySelector(`[data-panel-resize-handle-id="${e}"]`);
  return n || null;
}
function a2(e, t, n, r = document) {
  var o, a, i, s;
  const l = rs(t, r), c = Wo(e, r), u = l ? c.indexOf(l) : -1, d = (o = (a = n[u]) === null || a === void 0 ? void 0 : a.id) !== null && o !== void 0 ? o : null, f = (i = (s = n[u + 1]) === null || s === void 0 ? void 0 : s.id) !== null && i !== void 0 ? i : null;
  return [d, f];
}
function i2({
  committedValuesRef: e,
  eagerValuesRef: t,
  groupId: n,
  layout: r,
  panelDataArray: o,
  panelGroupElement: a,
  setLayout: i
}) {
  const s = ft({
    didWarnAboutMissingResizeHandle: !1
  });
  Zn(() => {
    if (!a)
      return;
    const l = Wo(n, a);
    for (let c = 0; c < o.length - 1; c++) {
      const {
        valueMax: u,
        valueMin: d,
        valueNow: f
      } = o2({
        layout: r,
        panelsArray: o,
        pivotIndices: [c, c + 1]
      }), p = l[c];
      if (p == null) {
        const {
          didWarnAboutMissingResizeHandle: h
        } = s.current;
        h || (s.current.didWarnAboutMissingResizeHandle = !0, console.warn(`WARNING: Missing resize handle for PanelGroup "${n}"`));
      } else {
        const h = o[c];
        we(h, `No panel data found for index "${c}"`), p.setAttribute("aria-controls", h.id), p.setAttribute("aria-valuemax", "" + Math.round(u)), p.setAttribute("aria-valuemin", "" + Math.round(d)), p.setAttribute("aria-valuenow", f != null ? "" + Math.round(f) : "");
      }
    }
    return () => {
      l.forEach((c, u) => {
        c.removeAttribute("aria-controls"), c.removeAttribute("aria-valuemax"), c.removeAttribute("aria-valuemin"), c.removeAttribute("aria-valuenow");
      });
    };
  }, [n, r, o, a]), Qn(() => {
    if (!a)
      return;
    const l = t.current;
    we(l, "Eager values not found");
    const {
      panelDataArray: c
    } = l, u = Sb(n, a);
    we(u != null, `No group found for id "${n}"`);
    const d = Wo(n, a);
    we(d, `No resize handles found for group id "${n}"`);
    const f = d.map((p) => {
      const h = p.getAttribute("data-panel-resize-handle-id");
      we(h, "Resize handle element has no handle id attribute");
      const [g, w] = a2(n, h, c, a);
      if (g == null || w == null)
        return () => {
        };
      const b = (y) => {
        if (!y.defaultPrevented)
          switch (y.key) {
            case "Enter": {
              y.preventDefault();
              const x = c.findIndex((C) => C.id === g);
              if (x >= 0) {
                const C = c[x];
                we(C, `No panel data found for index ${x}`);
                const S = r[x], {
                  collapsedSize: R = 0,
                  collapsible: E,
                  minSize: M = 0
                } = C.constraints;
                if (S != null && E) {
                  const F = Ro({
                    delta: xt(S, R) ? M - R : R - S,
                    initialLayout: r,
                    panelConstraints: c.map((G) => G.constraints),
                    pivotIndices: xb(n, h, a),
                    prevLayout: r,
                    trigger: "keyboard"
                  });
                  r !== F && i(F);
                }
              }
              break;
            }
          }
      };
      return p.addEventListener("keydown", b), () => {
        p.removeEventListener("keydown", b);
      };
    });
    return () => {
      f.forEach((p) => p());
    };
  }, [a, e, t, n, r, o, i]);
}
function ll(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Cb(e, t) {
  const n = e === "horizontal", {
    x: r,
    y: o
  } = ts(t);
  return n ? r : o;
}
function s2(e, t, n, r, o) {
  const a = n === "horizontal", i = rs(t, o);
  we(i, `No resize handle element found for id "${t}"`);
  const s = i.getAttribute("data-panel-group-id");
  we(s, "Resize handle element has no group id attribute");
  let {
    initialCursorPosition: l
  } = r;
  const c = Cb(n, e), u = Sb(s, o);
  we(u, `No group element found for id "${s}"`);
  const d = u.getBoundingClientRect(), f = a ? d.width : d.height;
  return (c - l) / f * 100;
}
function l2(e, t, n, r, o, a) {
  if (fb(e)) {
    const i = n === "horizontal";
    let s = 0;
    e.shiftKey ? s = 100 : o != null ? s = o : s = 10;
    let l = 0;
    switch (e.key) {
      case "ArrowDown":
        l = i ? 0 : s;
        break;
      case "ArrowLeft":
        l = i ? -s : 0;
        break;
      case "ArrowRight":
        l = i ? s : 0;
        break;
      case "ArrowUp":
        l = i ? 0 : -s;
        break;
      case "End":
        l = 100;
        break;
      case "Home":
        l = -100;
        break;
    }
    return l;
  } else
    return r == null ? 0 : s2(e, t, n, r, a);
}
function c2({
  panelDataArray: e
}) {
  const t = Array(e.length), n = e.map((a) => a.constraints);
  let r = 0, o = 100;
  for (let a = 0; a < e.length; a++) {
    const i = n[a];
    we(i, `Panel constraints not found for index ${a}`);
    const {
      defaultSize: s
    } = i;
    s != null && (r++, t[a] = s, o -= s);
  }
  for (let a = 0; a < e.length; a++) {
    const i = n[a];
    we(i, `Panel constraints not found for index ${a}`);
    const {
      defaultSize: s
    } = i;
    if (s != null)
      continue;
    const l = e.length - r, c = o / l;
    r++, t[a] = c, o -= c;
  }
  return t;
}
function Sr(e, t, n) {
  t.forEach((r, o) => {
    const a = e[o];
    we(a, `Panel data not found for index ${o}`);
    const {
      callbacks: i,
      constraints: s,
      id: l
    } = a, {
      collapsedSize: c = 0,
      collapsible: u
    } = s, d = n[l];
    if (d == null || r !== d) {
      n[l] = r;
      const {
        onCollapse: f,
        onExpand: p,
        onResize: h
      } = i;
      h && h(r, d), u && (f || p) && (p && (d == null || pn(d, c)) && !pn(r, c) && p(), f && (d == null || !pn(d, c)) && pn(r, c) && f());
    }
  });
}
function qa(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] != t[n])
      return !1;
  return !0;
}
function u2({
  defaultSize: e,
  dragState: t,
  layout: n,
  panelData: r,
  panelIndex: o,
  precision: a = 3
}) {
  const i = n[o];
  let s;
  return i == null ? s = e != null ? e.toPrecision(a) : "1" : r.length === 1 ? s = "1" : s = i.toPrecision(a), {
    flexBasis: 0,
    flexGrow: s,
    flexShrink: 1,
    // Without this, Panel sizes may be unintentionally overridden by their content
    overflow: "hidden",
    // Disable pointer events inside of a panel during resize
    // This avoid edge cases like nested iframes
    pointerEvents: t !== null ? "none" : void 0
  };
}
function d2(e, t = 10) {
  let n = null;
  return (...o) => {
    n !== null && clearTimeout(n), n = setTimeout(() => {
      e(...o);
    }, t);
  };
}
function If(e) {
  try {
    if (typeof localStorage < "u")
      e.getItem = (t) => localStorage.getItem(t), e.setItem = (t, n) => {
        localStorage.setItem(t, n);
      };
    else
      throw new Error("localStorage not supported in this environment");
  } catch (t) {
    console.error(t), e.getItem = () => null, e.setItem = () => {
    };
  }
}
function Eb(e) {
  return `react-resizable-panels:${e}`;
}
function kb(e) {
  return e.map((t) => {
    const {
      constraints: n,
      id: r,
      idIsFromProps: o,
      order: a
    } = t;
    return o ? r : a ? `${a}:${JSON.stringify(n)}` : JSON.stringify(n);
  }).sort((t, n) => t.localeCompare(n)).join(",");
}
function Rb(e, t) {
  try {
    const n = Eb(e), r = t.getItem(n);
    if (r) {
      const o = JSON.parse(r);
      if (typeof o == "object" && o != null)
        return o;
    }
  } catch {
  }
  return null;
}
function f2(e, t, n) {
  var r, o;
  const a = (r = Rb(e, n)) !== null && r !== void 0 ? r : {}, i = kb(t);
  return (o = a[i]) !== null && o !== void 0 ? o : null;
}
function p2(e, t, n, r, o) {
  var a;
  const i = Eb(e), s = kb(t), l = (a = Rb(e, o)) !== null && a !== void 0 ? a : {};
  l[s] = {
    expandToSizes: Object.fromEntries(n.entries()),
    layout: r
  };
  try {
    o.setItem(i, JSON.stringify(l));
  } catch (c) {
    console.error(c);
  }
}
function m2({
  panelConstraints: e,
  panelId: t,
  panelIndex: n
}) {
  {
    const r = [], o = e[n];
    we(o, `No panel constraints found for index ${n}`);
    const {
      collapsedSize: a = 0,
      collapsible: i = !1,
      defaultSize: s,
      maxSize: l = 100,
      minSize: c = 0
    } = o;
    if (c > l && r.push(`min size (${c}%) should not be greater than max size (${l}%)`), s != null && (s < 0 ? r.push("default size should not be less than 0") : s < c && (!i || s !== a) && r.push("default size should not be less than min size"), s > 100 ? r.push("default size should not be greater than 100") : s > l && r.push("default size should not be greater than max size")), a > c && r.push("collapsed size should not be greater than min size"), r.length > 0) {
      const u = t != null ? `Panel "${t}"` : "Panel";
      return console.warn(`${u} has an invalid configuration:

${r.join(`
`)}`), !1;
    }
  }
  return !0;
}
function Mf({
  layout: e,
  panelConstraints: t
}) {
  const n = [...e], r = n.reduce((a, i) => a + i, 0);
  if (n.length !== t.length)
    throw Error(`Invalid ${t.length} panel layout: ${n.map((a) => `${a}%`).join(", ")}`);
  if (!xt(r, 100) && n.length > 0) {
    console.warn(`WARNING: Invalid layout total size: ${n.map((a) => `${a}%`).join(", ")}. Layout normalization will be applied.`);
    for (let a = 0; a < t.length; a++) {
      const i = n[a];
      we(i != null, `No layout data found for index ${a}`);
      const s = 100 / r * i;
      n[a] = s;
    }
  }
  let o = 0;
  for (let a = 0; a < t.length; a++) {
    const i = n[a];
    we(i != null, `No layout data found for index ${a}`);
    const s = Pr({
      panelConstraints: t,
      panelIndex: a,
      size: i
    });
    i != s && (o += i - s, n[a] = s);
  }
  if (!xt(o, 0))
    for (let a = 0; a < t.length; a++) {
      const i = n[a];
      we(i != null, `No layout data found for index ${a}`);
      const s = i + o, l = Pr({
        panelConstraints: t,
        panelIndex: a,
        size: s
      });
      if (i !== l && (o -= l - i, n[a] = l, xt(o, 0)))
        break;
    }
  return n;
}
const g2 = 100, Po = {
  getItem: (e) => (If(Po), Po.getItem(e)),
  setItem: (e, t) => {
    If(Po), Po.setItem(e, t);
  }
}, Of = {};
function Pb({
  autoSaveId: e = null,
  children: t,
  className: n = "",
  direction: r,
  forwardedRef: o,
  id: a = null,
  onLayout: i = null,
  keyboardResizeBy: s = null,
  storage: l = Po,
  style: c,
  tagName: u = "div",
  ...d
}) {
  const f = ju(a), p = ft(null), [h, g] = Mr(null), [w, b] = Mr([]), y = n2(), x = ft({}), C = ft(/* @__PURE__ */ new Map()), S = ft(0), R = ft({
    autoSaveId: e,
    direction: r,
    dragState: h,
    id: f,
    keyboardResizeBy: s,
    onLayout: i,
    storage: l
  }), E = ft({
    layout: w,
    panelDataArray: [],
    panelDataArrayChanged: !1
  }), M = ft({
    didLogIdAndOrderWarning: !1,
    didLogPanelConstraintsWarning: !1,
    prevPanelIds: []
  });
  cb(o, () => ({
    getId: () => R.current.id,
    getLayout: () => {
      const {
        layout: P
      } = E.current;
      return P;
    },
    setLayout: (P) => {
      const {
        onLayout: _
      } = R.current, {
        layout: V,
        panelDataArray: T
      } = E.current, L = Mf({
        layout: P,
        panelConstraints: T.map((J) => J.constraints)
      });
      ll(V, L) || (b(L), E.current.layout = L, _ && _(L), Sr(T, L, x.current));
    }
  }), []), Zn(() => {
    R.current.autoSaveId = e, R.current.direction = r, R.current.dragState = h, R.current.id = f, R.current.onLayout = i, R.current.storage = l;
  }), i2({
    committedValuesRef: R,
    eagerValuesRef: E,
    groupId: f,
    layout: w,
    panelDataArray: E.current.panelDataArray,
    setLayout: b,
    panelGroupElement: p.current
  }), Qn(() => {
    const {
      panelDataArray: P
    } = E.current;
    if (e) {
      if (w.length === 0 || w.length !== P.length)
        return;
      let _ = Of[e];
      _ == null && (_ = d2(p2, g2), Of[e] = _);
      const V = [...P], T = new Map(C.current);
      _(e, V, T, w, l);
    }
  }, [e, w, l]), Qn(() => {
    {
      const {
        panelDataArray: P
      } = E.current, {
        didLogIdAndOrderWarning: _,
        didLogPanelConstraintsWarning: V,
        prevPanelIds: T
      } = M.current;
      if (!_) {
        const L = P.map(({
          id: Q
        }) => Q);
        M.current.prevPanelIds = L, T.length > 0 && !ll(T, L) && P.find(({
          idIsFromProps: Q,
          order: ne
        }) => !Q || ne == null) && (M.current.didLogIdAndOrderWarning = !0, console.warn("WARNING: Panel id and order props recommended when panels are dynamically rendered"));
      }
      if (!V) {
        const L = P.map((J) => J.constraints);
        for (let J = 0; J < L.length; J++) {
          const Q = P[J];
          if (we(Q, `Panel data not found for index ${J}`), !m2({
            panelConstraints: L,
            panelId: Q.id,
            panelIndex: J
          })) {
            M.current.didLogPanelConstraintsWarning = !0;
            break;
          }
        }
      }
    }
  });
  const F = dt((P) => {
    const {
      onLayout: _
    } = R.current, {
      layout: V,
      panelDataArray: T
    } = E.current;
    if (P.constraints.collapsible) {
      const L = T.map((D) => D.constraints), {
        collapsedSize: J = 0,
        panelSize: Q,
        pivotIndices: ne
      } = Un(T, P, V);
      if (we(Q != null, `Panel size not found for panel "${P.id}"`), !pn(Q, J)) {
        C.current.set(P.id, Q);
        const le = Rr(T, P) === T.length - 1 ? Q - J : J - Q, te = Ro({
          delta: le,
          initialLayout: V,
          panelConstraints: L,
          pivotIndices: ne,
          prevLayout: V,
          trigger: "imperative-api"
        });
        qa(V, te) || (b(te), E.current.layout = te, _ && _(te), Sr(T, te, x.current));
      }
    }
  }, []), G = dt((P, _) => {
    const {
      onLayout: V
    } = R.current, {
      layout: T,
      panelDataArray: L
    } = E.current;
    if (P.constraints.collapsible) {
      const J = L.map((Se) => Se.constraints), {
        collapsedSize: Q = 0,
        panelSize: ne = 0,
        minSize: D = 0,
        pivotIndices: le
      } = Un(L, P, T), te = _ ?? D;
      if (pn(ne, Q)) {
        const Se = C.current.get(P.id), Le = Se != null && Se >= te ? Se : te, lt = Rr(L, P) === L.length - 1 ? ne - Le : Le - ne, _e = Ro({
          delta: lt,
          initialLayout: T,
          panelConstraints: J,
          pivotIndices: le,
          prevLayout: T,
          trigger: "imperative-api"
        });
        qa(T, _e) || (b(_e), E.current.layout = _e, V && V(_e), Sr(L, _e, x.current));
      }
    }
  }, []), U = dt((P) => {
    const {
      layout: _,
      panelDataArray: V
    } = E.current, {
      panelSize: T
    } = Un(V, P, _);
    return we(T != null, `Panel size not found for panel "${P.id}"`), T;
  }, []), H = dt((P, _) => {
    const {
      panelDataArray: V
    } = E.current, T = Rr(V, P);
    return u2({
      defaultSize: _,
      dragState: h,
      layout: w,
      panelData: V,
      panelIndex: T
    });
  }, [h, w]), j = dt((P) => {
    const {
      layout: _,
      panelDataArray: V
    } = E.current, {
      collapsedSize: T = 0,
      collapsible: L,
      panelSize: J
    } = Un(V, P, _);
    return we(J != null, `Panel size not found for panel "${P.id}"`), L === !0 && pn(J, T);
  }, []), z = dt((P) => {
    const {
      layout: _,
      panelDataArray: V
    } = E.current, {
      collapsedSize: T = 0,
      collapsible: L,
      panelSize: J
    } = Un(V, P, _);
    return we(J != null, `Panel size not found for panel "${P.id}"`), !L || lr(J, T) > 0;
  }, []), Z = dt((P) => {
    const {
      panelDataArray: _
    } = E.current;
    _.push(P), _.sort((V, T) => {
      const L = V.order, J = T.order;
      return L == null && J == null ? 0 : L == null ? -1 : J == null ? 1 : L - J;
    }), E.current.panelDataArrayChanged = !0, y();
  }, [y]);
  Zn(() => {
    if (E.current.panelDataArrayChanged) {
      E.current.panelDataArrayChanged = !1;
      const {
        autoSaveId: P,
        onLayout: _,
        storage: V
      } = R.current, {
        layout: T,
        panelDataArray: L
      } = E.current;
      let J = null;
      if (P) {
        const ne = f2(P, L, V);
        ne && (C.current = new Map(Object.entries(ne.expandToSizes)), J = ne.layout);
      }
      J == null && (J = c2({
        panelDataArray: L
      }));
      const Q = Mf({
        layout: J,
        panelConstraints: L.map((ne) => ne.constraints)
      });
      ll(T, Q) || (b(Q), E.current.layout = Q, _ && _(Q), Sr(L, Q, x.current));
    }
  }), Zn(() => {
    const P = E.current;
    return () => {
      P.layout = [];
    };
  }, []);
  const Y = dt((P) => {
    let _ = !1;
    const V = p.current;
    return V && window.getComputedStyle(V, null).getPropertyValue("direction") === "rtl" && (_ = !0), function(L) {
      L.preventDefault();
      const J = p.current;
      if (!J)
        return () => null;
      const {
        direction: Q,
        dragState: ne,
        id: D,
        keyboardResizeBy: le,
        onLayout: te
      } = R.current, {
        layout: Se,
        panelDataArray: Le
      } = E.current, {
        initialLayout: ze
      } = ne ?? {}, lt = xb(D, P, J);
      let _e = l2(L, P, Q, ne, le, J);
      const Je = Q === "horizontal";
      Je && _ && (_e = -_e);
      const Gt = Le.map((gr) => gr.constraints), Tt = Ro({
        delta: _e,
        initialLayout: ze ?? Se,
        panelConstraints: Gt,
        pivotIndices: lt,
        prevLayout: Se,
        trigger: fb(L) ? "keyboard" : "mouse-or-touch"
      }), kt = !qa(Se, Tt);
      (pb(L) || mb(L)) && S.current != _e && (S.current = _e, !kt && _e !== 0 ? Je ? sl(P, _e < 0 ? hb : vb) : sl(P, _e < 0 ? wb : bb) : sl(P, 0)), kt && (b(Tt), E.current.layout = Tt, te && te(Tt), Sr(Le, Tt, x.current));
    };
  }, []), O = dt((P, _) => {
    const {
      onLayout: V
    } = R.current, {
      layout: T,
      panelDataArray: L
    } = E.current, J = L.map((Se) => Se.constraints), {
      panelSize: Q,
      pivotIndices: ne
    } = Un(L, P, T);
    we(Q != null, `Panel size not found for panel "${P.id}"`);
    const le = Rr(L, P) === L.length - 1 ? Q - _ : _ - Q, te = Ro({
      delta: le,
      initialLayout: T,
      panelConstraints: J,
      pivotIndices: ne,
      prevLayout: T,
      trigger: "imperative-api"
    });
    qa(T, te) || (b(te), E.current.layout = te, V && V(te), Sr(L, te, x.current));
  }, []), I = dt((P, _) => {
    const {
      layout: V,
      panelDataArray: T
    } = E.current, {
      collapsedSize: L = 0,
      collapsible: J
    } = _, {
      collapsedSize: Q = 0,
      collapsible: ne,
      maxSize: D = 100,
      minSize: le = 0
    } = P.constraints, {
      panelSize: te
    } = Un(T, P, V);
    te != null && (J && ne && pn(te, L) ? pn(L, Q) || O(P, Q) : te < le ? O(P, le) : te > D && O(P, D));
  }, [O]), W = dt((P, _) => {
    const {
      direction: V
    } = R.current, {
      layout: T
    } = E.current;
    if (!p.current)
      return;
    const L = rs(P, p.current);
    we(L, `Drag handle element not found for id "${P}"`);
    const J = Cb(V, _);
    g({
      dragHandleId: P,
      dragHandleRect: L.getBoundingClientRect(),
      initialCursorPosition: J,
      initialLayout: T
    });
  }, []), A = dt(() => {
    g(null);
  }, []), K = dt((P) => {
    const {
      panelDataArray: _
    } = E.current, V = Rr(_, P);
    V >= 0 && (_.splice(V, 1), delete x.current[P.id], E.current.panelDataArrayChanged = !0, y());
  }, [y]), k = HA(() => ({
    collapsePanel: F,
    direction: r,
    dragState: h,
    expandPanel: G,
    getPanelSize: U,
    getPanelStyle: H,
    groupId: f,
    isPanelCollapsed: j,
    isPanelExpanded: z,
    reevaluatePanelConstraints: I,
    registerPanel: Z,
    registerResizeHandle: Y,
    resizePanel: O,
    startDragging: W,
    stopDragging: A,
    unregisterPanel: K,
    panelGroupElement: p.current
  }), [F, h, r, G, U, H, f, j, z, I, Z, Y, O, W, A, K]), $ = {
    display: "flex",
    flexDirection: r === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return Vr(es.Provider, {
    value: k
  }, Vr(u, {
    ...d,
    children: t,
    className: n,
    id: a,
    ref: p,
    style: {
      ...$,
      ...c
    },
    // CSS selectors
    "data-panel-group": "",
    "data-panel-group-direction": r,
    "data-panel-group-id": f
  }));
}
const Nb = sb((e, t) => Vr(Pb, {
  ...e,
  forwardedRef: t
}));
Pb.displayName = "PanelGroup";
Nb.displayName = "forwardRef(PanelGroup)";
function Rr(e, t) {
  return e.findIndex((n) => n === t || n.id === t.id);
}
function Un(e, t, n) {
  const r = Rr(e, t), a = r === e.length - 1 ? [r - 1, r] : [r, r + 1], i = n[r];
  return {
    ...t.constraints,
    panelSize: i,
    pivotIndices: a
  };
}
function h2({
  disabled: e,
  handleId: t,
  resizeHandler: n,
  panelGroupElement: r
}) {
  Qn(() => {
    if (e || n == null || r == null)
      return;
    const o = rs(t, r);
    if (o == null)
      return;
    const a = (i) => {
      if (!i.defaultPrevented)
        switch (i.key) {
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
          case "ArrowUp":
          case "End":
          case "Home": {
            i.preventDefault(), n(i);
            break;
          }
          case "F6": {
            i.preventDefault();
            const s = o.getAttribute("data-panel-group-id");
            we(s, `No group element found for id "${s}"`);
            const l = Wo(s, r), c = yb(s, t, r);
            we(c !== null, `No resize element found for id "${t}"`);
            const u = i.shiftKey ? c > 0 ? c - 1 : l.length - 1 : c + 1 < l.length ? c + 1 : 0;
            l[u].focus();
            break;
          }
        }
    };
    return o.addEventListener("keydown", a), () => {
      o.removeEventListener("keydown", a);
    };
  }, [r, e, t, n]);
}
function Tb({
  children: e = null,
  className: t = "",
  disabled: n = !1,
  hitAreaMargins: r,
  id: o,
  onBlur: a,
  onDragging: i,
  onFocus: s,
  style: l = {},
  tabIndex: c = 0,
  tagName: u = "div",
  ...d
}) {
  var f, p;
  const h = ft(null), g = ft({
    onDragging: i
  });
  Qn(() => {
    g.current.onDragging = i;
  });
  const w = lb(es);
  if (w === null)
    throw Error("PanelResizeHandle components must be rendered within a PanelGroup container");
  const {
    direction: b,
    groupId: y,
    registerResizeHandle: x,
    startDragging: C,
    stopDragging: S,
    panelGroupElement: R
  } = w, E = ju(o), [M, F] = Mr("inactive"), [G, U] = Mr(!1), [H, j] = Mr(null), z = ft({
    state: M
  });
  Zn(() => {
    z.current.state = M;
  }), Qn(() => {
    if (n)
      j(null);
    else {
      const I = x(E);
      j(() => I);
    }
  }, [n, E, x]);
  const Z = (f = r == null ? void 0 : r.coarse) !== null && f !== void 0 ? f : 15, Y = (p = r == null ? void 0 : r.fine) !== null && p !== void 0 ? p : 5;
  return Qn(() => {
    if (n || H == null)
      return;
    const I = h.current;
    return we(I, "Element ref not attached"), t2(E, I, b, {
      coarse: Z,
      fine: Y
    }, (A, K, k) => {
      if (K)
        switch (A) {
          case "down": {
            F("drag"), we(k, 'Expected event to be defined for "down" action'), C(E, k);
            const {
              onDragging: $
            } = g.current;
            $ && $(!0);
            break;
          }
          case "move": {
            const {
              state: $
            } = z.current;
            $ !== "drag" && F("hover"), we(k, 'Expected event to be defined for "move" action'), H(k);
            break;
          }
          case "up": {
            F("hover"), S();
            const {
              onDragging: $
            } = g.current;
            $ && $(!1);
            break;
          }
        }
      else
        F("inactive");
    });
  }, [Z, b, n, Y, x, E, H, C, S]), h2({
    disabled: n,
    handleId: E,
    resizeHandler: H,
    panelGroupElement: R
  }), Vr(u, {
    ...d,
    children: e,
    className: t,
    id: o,
    onBlur: () => {
      U(!1), a == null || a();
    },
    onFocus: () => {
      U(!0), s == null || s();
    },
    ref: h,
    role: "separator",
    style: {
      ...{
        touchAction: "none",
        userSelect: "none"
      },
      ...l
    },
    tabIndex: c,
    // CSS selectors
    "data-panel-group-direction": b,
    "data-panel-group-id": y,
    "data-resize-handle": "",
    "data-resize-handle-active": M === "drag" ? "pointer" : G ? "keyboard" : void 0,
    "data-resize-handle-state": M,
    "data-panel-resize-handle-enabled": !n,
    "data-panel-resize-handle-id": E
  });
}
Tb.displayName = "PanelResizeHandle";
const c4 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ m(
  Nb,
  {
    className: N(
      "tw-flex tw-h-full tw-w-full data-[panel-group-direction=vertical]:tw-flex-col",
      e
    ),
    ...t
  }
), u4 = db, d4 = ({
  withHandle: e,
  className: t,
  ...n
}) => /* @__PURE__ */ m(
  Tb,
  {
    className: N(
      "tw-relative tw-flex tw-w-px tw-items-center tw-justify-center tw-bg-gray-600 after:tw-absolute after:tw-inset-y-0 after:tw-left-1/2 after:tw-w-1 after:-tw-translate-x-1/2 focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-1 data-[panel-group-direction=vertical]:tw-h-px data-[panel-group-direction=vertical]:tw-w-full data-[panel-group-direction=vertical]:after:tw-left-0 data-[panel-group-direction=vertical]:after:tw-h-1 data-[panel-group-direction=vertical]:after:tw-w-full data-[panel-group-direction=vertical]:after:-tw-translate-y-1/2 data-[panel-group-direction=vertical]:after:tw-translate-x-0 [&[data-panel-group-direction=vertical]>div]:tw-rotate-90",
      t
    ),
    ...n,
    children: e && /* @__PURE__ */ m(
      "div",
      { className: "tw-z-10 tw-flex tw-h-4 tw-w-3 tw-items-center tw-justify-center tw-rounded-sm tw-border tw-bg-white tw-p-2 tw-transition-all hover:tw-border-brand-primary-7 hover:tw-shadow-lg", children: /* @__PURE__ */ m(de, { icon: "grip-lines-vertical" }) }
    )
  }
), v2 = oe(
  "tw-border tw-border-r-0 custom-text-input-focus-ring tw-rounded-density-formElement-xs tw-border-semantic-formElement-border-neutral-default  tw-flex tw-w-full tw-flex-wrap tw-items-center tw-h-full",
  {
    variants: {
      disabled: {
        true: "tw-cursor-not-allowed tw-bg-semantic-formElement-background-neutral-disabled tw-text-[#575757] [&>*]:tw-cursor-not-allowed"
      }
    }
  }
), w2 = oe(
  "tw-border tw-rounded-density-formElement-xs tw-border-semantic-formElement-border-neutral-default tw-flex tw-items-center tw-absolute tw-mt-1 tw-bg-white ",
  {
    variants: {
      open: {
        true: "tw-absolute ",
        fasle: "",
        undefined: ""
      }
    }
  }
), b2 = oe(
  `tw-relative tw-inline-flex tw-cursor-pointer tw-select-none tw-items-center tw-px-2 tw-py-1 tw-text-sm tw-outline-none 
      hover:tw-bg-[#f7f8ff]`,
  {
    variants: {
      selected: {
        true: "tw-bg-[#f7f8ff] data-[selected=true]:tw-bg-[#f7f8ff]"
      },
      variant: {
        primary: "",
        checkbox: "",
        icon: ""
      }
    }
  }
), f4 = ({
  className: e,
  children: t,
  onOpenChange: n,
  open: r = !1
}) => {
  const o = qe(null), a = qe(null), [i, s] = ye(r ?? !1), l = ot(
    (g) => {
      var w, b, y, x;
      g.key === "Escape" ? (u(), (w = o.current) == null || w.focus()) : g.key === "ArrowDown" ? f(g) : g.key === "ArrowUp" ? p(g) : g.key === "Backspace" ? (((b = o.current) == null ? void 0 : b.value.length) === 1 && u(), (y = o.current) == null || y.focus()) : (g.key === "Delete" || /^[a-zA-Z0-9]$/.test(g.key)) && ((x = o.current) == null || x.focus());
    },
    []
  ), c = ot((g) => {
    o.current && !o.current.contains(g.target) && a.current && !a.current.contains(g.target) && u();
  }, []), u = () => {
    n ? n(!1) : s(!1);
  };
  ke(() => (document.addEventListener("mousedown", c), () => {
    document.removeEventListener("mousedown", c);
  }), [c]), ke(() => {
    r !== void 0 && s(r);
  }, [r]);
  const d = (g) => {
    const w = g.currentTarget;
    h().forEach((y) => y.tabIndex = -1), w.tabIndex = 0;
  }, f = (g) => {
    g.preventDefault();
    const w = h(), b = document.activeElement, y = w.indexOf(b), x = w[(y + 1) % w.length];
    w.forEach((C) => C.tabIndex = -1), x.tabIndex = 0, x.focus();
  }, p = (g) => {
    g.preventDefault();
    const w = h(), b = document.activeElement, y = w.indexOf(b), x = w[(y - 1 + w.length) % w.length];
    w.forEach((C) => C.tabIndex = -1), x.tabIndex = 0, x.focus();
  }, h = () => {
    var g;
    return Array.from(((g = a.current) == null ? void 0 : g.querySelectorAll("button")) || []);
  };
  return /* @__PURE__ */ m(
    "div",
    { className: N("tw-relative", e), onKeyDown: l, children: Yo.map(t, (g) => {
      if (ur(g)) {
        if (g.type === y2)
          return tn(
            g,
            {
              ref: o
            }
          );
        if (g.type === x2)
          return tn(
            g,
            {
              ref: a,
              open: i,
              moveTabIndexToButton: d
            }
          );
      }
      return g;
    }) }
  );
}, y2 = q(
  ({ className: e, children: t, disabled: n, inputId: r, ...o }, a) => /* @__PURE__ */ ee(
    "div",
    { className: N(v2({ disabled: n }), e), children: [
      t,
      /* @__PURE__ */ m(
        pw,
        {
          ref: a,
          disabled: n,
          inputId: r,
          autoComplete: "off",
          className: "tw-mx-px tw-w-full tw-flex-1 [&>div]:tw-mb-0 [&>div]:tw-border-none [&_*_input]:tw-text-[16px] [&_*_input]:!tw-outline-none [&_*_input]:focus-within:!tw-outline-transparent",
          ...o,
          label: ""
        }
      )
    ] }
  )
), x2 = q(
  (e, t) => {
    const { className: n, children: r, open: o, moveTabIndexToButton: a, ...i } = e;
    return o && /* @__PURE__ */ m(
      "div",
      { ref: t, className: N(w2({ open: o }), n), ...i, children: Yo.map(r, (s) => ur(s) && s.type === S2 ? tn(
        s,
        {
          onClick: a
        }
      ) : s) }
    );
  }
), S2 = q(
  ({ className: e, onSelect: t, selected: n, label: r, icon: o, children: a, ...i }, s) => /* @__PURE__ */ ee(
    "button",
    {
      ref: s,
      onClick: () => {
        t && t(r);
      },
      title: r,
      "data-testid": "typeahead-button",
      tabIndex: -1,
      className: N(
        "custom-button-focus-ring",
        b2({
          selected: n
        }),
        e
      ),
      ...i,
      children: [
        o && /* @__PURE__ */ m(de, { className: "tw-mr-2", icon: o, size: "sm" }),
        /* @__PURE__ */ m(
          "span",
          { className: "tw-overflow-hidden tw-truncate tw-text-nowrap", children: r }
        ),
        a
      ]
    }
  )
);
function Df(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
var C2 = "VisuallyHidden", ya = v.forwardRef(
  (e, t) => /* @__PURE__ */ m(
    ie.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
ya.displayName = C2;
var E2 = ya, k2 = [" ", "Enter", "ArrowUp", "ArrowDown"], R2 = [" ", "Enter"], xa = "Select", [os, as, P2] = qr(xa), [Zr, p4] = Ye(xa, [
  P2,
  Fn
]), is = Fn(), [N2, Hn] = Zr(xa), [T2, _2] = Zr(xa), _b = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    value: i,
    defaultValue: s,
    onValueChange: l,
    dir: c,
    name: u,
    autoComplete: d,
    disabled: f,
    required: p,
    form: h
  } = e, g = is(t), [w, b] = v.useState(null), [y, x] = v.useState(null), [C, S] = v.useState(!1), R = Ln(c), [E = !1, M] = je({
    prop: r,
    defaultProp: o,
    onChange: a
  }), [F, G] = je({
    prop: i,
    defaultProp: s,
    onChange: l
  }), U = v.useRef(null), H = w ? h || !!w.closest("form") : !0, [j, z] = v.useState(/* @__PURE__ */ new Set()), Z = Array.from(j).map((Y) => Y.props.value).join(";");
  return /* @__PURE__ */ m(Qo, { ...g, children: /* @__PURE__ */ ee(
    N2,
    {
      required: p,
      scope: t,
      trigger: w,
      onTriggerChange: b,
      valueNode: y,
      onValueNodeChange: x,
      valueNodeHasChildren: C,
      onValueNodeHasChildrenChange: S,
      contentId: Te(),
      value: F,
      onValueChange: G,
      open: E,
      onOpenChange: M,
      dir: R,
      triggerPointerDownPosRef: U,
      disabled: f,
      children: [
        /* @__PURE__ */ m(os.Provider, { scope: t, children: /* @__PURE__ */ m(
          T2,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: v.useCallback((Y) => {
              z((O) => new Set(O).add(Y));
            }, []),
            onNativeOptionRemove: v.useCallback((Y) => {
              z((O) => {
                const I = new Set(O);
                return I.delete(Y), I;
              });
            }, []),
            children: n
          }
        ) }),
        H ? /* @__PURE__ */ ee(
          ty,
          {
            "aria-hidden": !0,
            required: p,
            tabIndex: -1,
            name: u,
            autoComplete: d,
            value: F,
            onChange: (Y) => G(Y.target.value),
            disabled: f,
            form: h,
            children: [
              F === void 0 ? /* @__PURE__ */ m("option", { value: "" }) : null,
              Array.from(j)
            ]
          },
          Z
        ) : null
      ]
    }
  ) });
};
_b.displayName = xa;
var Ib = "SelectTrigger", Mb = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, a = is(n), i = Hn(Ib, n), s = i.disabled || r, l = xe(t, i.onTriggerChange), c = as(n), u = v.useRef("touch"), [d, f, p] = ny((g) => {
      const w = c().filter((x) => !x.disabled), b = w.find((x) => x.value === i.value), y = ry(w, g, b);
      y !== void 0 && i.onValueChange(y.value);
    }), h = (g) => {
      s || (i.onOpenChange(!0), p()), g && (i.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ m(Zo, { asChild: !0, ...a, children: /* @__PURE__ */ m(
      ie.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": ey(i.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: re(o.onClick, (g) => {
          g.currentTarget.focus(), u.current !== "mouse" && h(g);
        }),
        onPointerDown: re(o.onPointerDown, (g) => {
          u.current = g.pointerType;
          const w = g.target;
          w.hasPointerCapture(g.pointerId) && w.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (h(g), g.preventDefault());
        }),
        onKeyDown: re(o.onKeyDown, (g) => {
          const w = d.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && f(g.key), !(w && g.key === " ") && k2.includes(g.key) && (h(), g.preventDefault());
        })
      }
    ) });
  }
);
Mb.displayName = Ib;
var Ob = "SelectValue", Db = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: a, placeholder: i = "", ...s } = e, l = Hn(Ob, n), { onValueNodeHasChildrenChange: c } = l, u = a !== void 0, d = xe(t, l.onValueNodeChange);
    return et(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ m(
      ie.span,
      {
        ...s,
        ref: d,
        style: { pointerEvents: "none" },
        children: ey(l.value) ? /* @__PURE__ */ m(Ne, { children: i }) : a
      }
    );
  }
);
Db.displayName = Ob;
var I2 = "SelectIcon", M2 = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ m(ie.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
M2.displayName = I2;
var O2 = "SelectPortal", Ab = (e) => /* @__PURE__ */ m(Jr, { asChild: !0, ...e });
Ab.displayName = O2;
var cr = "SelectContent", $b = v.forwardRef(
  (e, t) => {
    const n = Hn(cr, e.__scopeSelect), [r, o] = v.useState();
    if (et(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const a = r;
      return a ? Rn.createPortal(
        /* @__PURE__ */ m(Lb, { scope: e.__scopeSelect, children: /* @__PURE__ */ m(os.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ m("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ m(Fb, { ...e, ref: t });
  }
);
$b.displayName = cr;
var It = 10, [Lb, Wn] = Zr(cr), D2 = "SelectContentImpl", Fb = v.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: p,
      sticky: h,
      hideWhenDetached: g,
      avoidCollisions: w,
      //
      ...b
    } = e, y = Hn(cr, n), [x, C] = v.useState(null), [S, R] = v.useState(null), E = xe(t, (T) => C(T)), [M, F] = v.useState(null), [G, U] = v.useState(
      null
    ), H = as(n), [j, z] = v.useState(!1), Z = v.useRef(!1);
    v.useEffect(() => {
      if (x) return Di(x);
    }, [x]), Pi();
    const Y = v.useCallback(
      (T) => {
        const [L, ...J] = H().map((D) => D.ref.current), [Q] = J.slice(-1), ne = document.activeElement;
        for (const D of T)
          if (D === ne || (D == null || D.scrollIntoView({ block: "nearest" }), D === L && S && (S.scrollTop = 0), D === Q && S && (S.scrollTop = S.scrollHeight), D == null || D.focus(), document.activeElement !== ne)) return;
      },
      [H, S]
    ), O = v.useCallback(
      () => Y([M, x]),
      [Y, M, x]
    );
    v.useEffect(() => {
      j && O();
    }, [j, O]);
    const { onOpenChange: I, triggerPointerDownPosRef: W } = y;
    v.useEffect(() => {
      if (x) {
        let T = { x: 0, y: 0 };
        const L = (Q) => {
          var ne, D;
          T = {
            x: Math.abs(Math.round(Q.pageX) - (((ne = W.current) == null ? void 0 : ne.x) ?? 0)),
            y: Math.abs(Math.round(Q.pageY) - (((D = W.current) == null ? void 0 : D.y) ?? 0))
          };
        }, J = (Q) => {
          T.x <= 10 && T.y <= 10 ? Q.preventDefault() : x.contains(Q.target) || I(!1), document.removeEventListener("pointermove", L), W.current = null;
        };
        return W.current !== null && (document.addEventListener("pointermove", L), document.addEventListener("pointerup", J, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", L), document.removeEventListener("pointerup", J, { capture: !0 });
        };
      }
    }, [x, I, W]), v.useEffect(() => {
      const T = () => I(!1);
      return window.addEventListener("blur", T), window.addEventListener("resize", T), () => {
        window.removeEventListener("blur", T), window.removeEventListener("resize", T);
      };
    }, [I]);
    const [A, K] = ny((T) => {
      const L = H().filter((ne) => !ne.disabled), J = L.find((ne) => ne.ref.current === document.activeElement), Q = ry(L, T, J);
      Q && setTimeout(() => Q.ref.current.focus());
    }), k = v.useCallback(
      (T, L, J) => {
        const Q = !Z.current && !J;
        (y.value !== void 0 && y.value === L || Q) && (F(T), Q && (Z.current = !0));
      },
      [y.value]
    ), $ = v.useCallback(() => x == null ? void 0 : x.focus(), [x]), P = v.useCallback(
      (T, L, J) => {
        const Q = !Z.current && !J;
        (y.value !== void 0 && y.value === L || Q) && U(T);
      },
      [y.value]
    ), _ = r === "popper" ? tc : zb, V = _ === tc ? {
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: p,
      sticky: h,
      hideWhenDetached: g,
      avoidCollisions: w
    } : {};
    return /* @__PURE__ */ m(
      Lb,
      {
        scope: n,
        content: x,
        viewport: S,
        onViewportChange: R,
        itemRefCallback: k,
        selectedItem: M,
        onItemLeave: $,
        itemTextRefCallback: P,
        focusSelectedItem: O,
        selectedItemText: G,
        position: r,
        isPositioned: j,
        searchRef: A,
        children: /* @__PURE__ */ m(ea, { as: Nn, allowPinchZoom: !0, children: /* @__PURE__ */ m(
          Xo,
          {
            asChild: !0,
            trapped: y.open,
            onMountAutoFocus: (T) => {
              T.preventDefault();
            },
            onUnmountAutoFocus: re(o, (T) => {
              var L;
              (L = y.trigger) == null || L.focus({ preventScroll: !0 }), T.preventDefault();
            }),
            children: /* @__PURE__ */ m(
              dr,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: i,
                onFocusOutside: (T) => T.preventDefault(),
                onDismiss: () => y.onOpenChange(!1),
                children: /* @__PURE__ */ m(
                  _,
                  {
                    role: "listbox",
                    id: y.contentId,
                    "data-state": y.open ? "open" : "closed",
                    dir: y.dir,
                    onContextMenu: (T) => T.preventDefault(),
                    ...b,
                    ...V,
                    onPlaced: () => z(!0),
                    ref: E,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: re(b.onKeyDown, (T) => {
                      const L = T.ctrlKey || T.altKey || T.metaKey;
                      if (T.key === "Tab" && T.preventDefault(), !L && T.key.length === 1 && K(T.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(T.key)) {
                        let Q = H().filter((ne) => !ne.disabled).map((ne) => ne.ref.current);
                        if (["ArrowUp", "End"].includes(T.key) && (Q = Q.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(T.key)) {
                          const ne = T.target, D = Q.indexOf(ne);
                          Q = Q.slice(D + 1);
                        }
                        setTimeout(() => Y(Q)), T.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Fb.displayName = D2;
var A2 = "SelectItemAlignedPosition", zb = v.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, a = Hn(cr, n), i = Wn(cr, n), [s, l] = v.useState(null), [c, u] = v.useState(null), d = xe(t, (E) => u(E)), f = as(n), p = v.useRef(!1), h = v.useRef(!0), { viewport: g, selectedItem: w, selectedItemText: b, focusSelectedItem: y } = i, x = v.useCallback(() => {
    if (a.trigger && a.valueNode && s && c && g && w && b) {
      const E = a.trigger.getBoundingClientRect(), M = c.getBoundingClientRect(), F = a.valueNode.getBoundingClientRect(), G = b.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const ne = G.left - M.left, D = F.left - ne, le = E.left - D, te = E.width + le, Se = Math.max(te, M.width), Le = window.innerWidth - It, ze = Df(D, [
          It,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(It, Le - Se)
        ]);
        s.style.minWidth = te + "px", s.style.left = ze + "px";
      } else {
        const ne = M.right - G.right, D = window.innerWidth - F.right - ne, le = window.innerWidth - E.right - D, te = E.width + le, Se = Math.max(te, M.width), Le = window.innerWidth - It, ze = Df(D, [
          It,
          Math.max(It, Le - Se)
        ]);
        s.style.minWidth = te + "px", s.style.right = ze + "px";
      }
      const U = f(), H = window.innerHeight - It * 2, j = g.scrollHeight, z = window.getComputedStyle(c), Z = parseInt(z.borderTopWidth, 10), Y = parseInt(z.paddingTop, 10), O = parseInt(z.borderBottomWidth, 10), I = parseInt(z.paddingBottom, 10), W = Z + Y + j + I + O, A = Math.min(w.offsetHeight * 5, W), K = window.getComputedStyle(g), k = parseInt(K.paddingTop, 10), $ = parseInt(K.paddingBottom, 10), P = E.top + E.height / 2 - It, _ = H - P, V = w.offsetHeight / 2, T = w.offsetTop + V, L = Z + Y + T, J = W - L;
      if (L <= P) {
        const ne = U.length > 0 && w === U[U.length - 1].ref.current;
        s.style.bottom = "0px";
        const D = c.clientHeight - g.offsetTop - g.offsetHeight, le = Math.max(
          _,
          V + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (ne ? $ : 0) + D + O
        ), te = L + le;
        s.style.height = te + "px";
      } else {
        const ne = U.length > 0 && w === U[0].ref.current;
        s.style.top = "0px";
        const le = Math.max(
          P,
          Z + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (ne ? k : 0) + V
        ) + J;
        s.style.height = le + "px", g.scrollTop = L - P + g.offsetTop;
      }
      s.style.margin = `${It}px 0`, s.style.minHeight = A + "px", s.style.maxHeight = H + "px", r == null || r(), requestAnimationFrame(() => p.current = !0);
    }
  }, [
    f,
    a.trigger,
    a.valueNode,
    s,
    c,
    g,
    w,
    b,
    a.dir,
    r
  ]);
  et(() => x(), [x]);
  const [C, S] = v.useState();
  et(() => {
    c && S(window.getComputedStyle(c).zIndex);
  }, [c]);
  const R = v.useCallback(
    (E) => {
      E && h.current === !0 && (x(), y == null || y(), h.current = !1);
    },
    [x, y]
  );
  return /* @__PURE__ */ m(
    L2,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: p,
      onScrollButtonChange: R,
      children: /* @__PURE__ */ m(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: C
          },
          children: /* @__PURE__ */ m(
            ie.div,
            {
              ...o,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
zb.displayName = A2;
var $2 = "SelectPopperPosition", tc = v.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = It,
    ...a
  } = e, i = is(n);
  return /* @__PURE__ */ m(
    Mi,
    {
      ...i,
      ...a,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
tc.displayName = $2;
var [L2, Yu] = Zr(cr, {}), nc = "SelectViewport", Vb = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, a = Wn(nc, n), i = Yu(nc, n), s = xe(t, a.onViewportChange), l = v.useRef(0);
    return /* @__PURE__ */ ee(Ne, { children: [
      /* @__PURE__ */ m(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ m(os.Slot, { scope: n, children: /* @__PURE__ */ m(
        ie.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: re(o.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: f } = i;
            if (f != null && f.current && d) {
              const p = Math.abs(l.current - u.scrollTop);
              if (p > 0) {
                const h = window.innerHeight - It * 2, g = parseFloat(d.style.minHeight), w = parseFloat(d.style.height), b = Math.max(g, w);
                if (b < h) {
                  const y = b + p, x = Math.min(h, y), C = y - x;
                  d.style.height = x + "px", d.style.bottom === "0px" && (u.scrollTop = C > 0 ? C : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Vb.displayName = nc;
var Bb = "SelectGroup", [F2, z2] = Zr(Bb), Hb = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = Te();
    return /* @__PURE__ */ m(F2, { scope: n, id: o, children: /* @__PURE__ */ m(ie.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
Hb.displayName = Bb;
var Wb = "SelectLabel", jb = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = z2(Wb, n);
    return /* @__PURE__ */ m(ie.div, { id: o.id, ...r, ref: t });
  }
);
jb.displayName = Wb;
var wi = "SelectItem", [V2, Gb] = Zr(wi), Ub = v.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: a,
      ...i
    } = e, s = Hn(wi, n), l = Wn(wi, n), c = s.value === r, [u, d] = v.useState(a ?? ""), [f, p] = v.useState(!1), h = xe(
      t,
      (y) => {
        var x;
        return (x = l.itemRefCallback) == null ? void 0 : x.call(l, y, r, o);
      }
    ), g = Te(), w = v.useRef("touch"), b = () => {
      o || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ m(
      V2,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: g,
        isSelected: c,
        onItemTextChange: v.useCallback((y) => {
          d((x) => x || ((y == null ? void 0 : y.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ m(
          os.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: u,
            children: /* @__PURE__ */ m(
              ie.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": f ? "" : void 0,
                "aria-selected": c && f,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...i,
                ref: h,
                onFocus: re(i.onFocus, () => p(!0)),
                onBlur: re(i.onBlur, () => p(!1)),
                onClick: re(i.onClick, () => {
                  w.current !== "mouse" && b();
                }),
                onPointerUp: re(i.onPointerUp, () => {
                  w.current === "mouse" && b();
                }),
                onPointerDown: re(i.onPointerDown, (y) => {
                  w.current = y.pointerType;
                }),
                onPointerMove: re(i.onPointerMove, (y) => {
                  var x;
                  w.current = y.pointerType, o ? (x = l.onItemLeave) == null || x.call(l) : w.current === "mouse" && y.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: re(i.onPointerLeave, (y) => {
                  var x;
                  y.currentTarget === document.activeElement && ((x = l.onItemLeave) == null || x.call(l));
                }),
                onKeyDown: re(i.onKeyDown, (y) => {
                  var C;
                  ((C = l.searchRef) == null ? void 0 : C.current) !== "" && y.key === " " || (R2.includes(y.key) && b(), y.key === " " && y.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Ub.displayName = wi;
var No = "SelectItemText", qb = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...a } = e, i = Hn(No, n), s = Wn(No, n), l = Gb(No, n), c = _2(No, n), [u, d] = v.useState(null), f = xe(
      t,
      (b) => d(b),
      l.onItemTextChange,
      (b) => {
        var y;
        return (y = s.itemTextRefCallback) == null ? void 0 : y.call(s, b, l.value, l.disabled);
      }
    ), p = u == null ? void 0 : u.textContent, h = v.useMemo(
      () => /* @__PURE__ */ m("option", { value: l.value, disabled: l.disabled, children: p }, l.value),
      [l.disabled, l.value, p]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: w } = c;
    return et(() => (g(h), () => w(h)), [g, w, h]), /* @__PURE__ */ ee(Ne, { children: [
      /* @__PURE__ */ m(ie.span, { id: l.textId, ...a, ref: f }),
      l.isSelected && i.valueNode && !i.valueNodeHasChildren ? Rn.createPortal(a.children, i.valueNode) : null
    ] });
  }
);
qb.displayName = No;
var Yb = "SelectItemIndicator", Kb = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return Gb(Yb, n).isSelected ? /* @__PURE__ */ m(ie.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
Kb.displayName = Yb;
var rc = "SelectScrollUpButton", Xb = v.forwardRef((e, t) => {
  const n = Wn(rc, e.__scopeSelect), r = Yu(rc, e.__scopeSelect), [o, a] = v.useState(!1), i = xe(t, r.onScrollButtonChange);
  return et(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollTop > 0;
        a(c);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ m(
    Qb,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
Xb.displayName = rc;
var oc = "SelectScrollDownButton", Jb = v.forwardRef((e, t) => {
  const n = Wn(oc, e.__scopeSelect), r = Yu(oc, e.__scopeSelect), [o, a] = v.useState(!1), i = xe(t, r.onScrollButtonChange);
  return et(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        a(u);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ m(
    Qb,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
Jb.displayName = oc;
var Qb = v.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, a = Wn("SelectScrollButton", n), i = v.useRef(null), s = as(n), l = v.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return v.useEffect(() => () => l(), [l]), et(() => {
    var u;
    const c = s().find((d) => d.ref.current === document.activeElement);
    (u = c == null ? void 0 : c.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ m(
    ie.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: re(o.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(r, 50));
      }),
      onPointerMove: re(o.onPointerMove, () => {
        var c;
        (c = a.onItemLeave) == null || c.call(a), i.current === null && (i.current = window.setInterval(r, 50));
      }),
      onPointerLeave: re(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), B2 = "SelectSeparator", Zb = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ m(ie.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
Zb.displayName = B2;
var ac = "SelectArrow", H2 = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = is(n), a = Hn(ac, n), i = Wn(ac, n);
    return a.open && i.position === "popper" ? /* @__PURE__ */ m(Oi, { ...o, ...r, ref: t }) : null;
  }
);
H2.displayName = ac;
function ey(e) {
  return e === "" || e === void 0;
}
var ty = v.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = v.useRef(null), a = xe(t, o), i = Xi(n);
    return v.useEffect(() => {
      const s = o.current, l = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (i !== n && u) {
        const d = new Event("change", { bubbles: !0 });
        u.call(s, n), s.dispatchEvent(d);
      }
    }, [i, n]), /* @__PURE__ */ m(ya, { asChild: !0, children: /* @__PURE__ */ m("select", { ...r, ref: a, defaultValue: n }) });
  }
);
ty.displayName = "BubbleSelect";
function ny(e) {
  const t = Ze(e), n = v.useRef(""), r = v.useRef(0), o = v.useCallback(
    (i) => {
      const s = n.current + i;
      t(s), function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [t]
  ), a = v.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return v.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, a];
}
function ry(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = W2(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter((c) => c !== n));
  const l = i.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function W2(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var j2 = _b, oy = Mb, G2 = Db, ay = Ab, iy = $b, sy = Vb, U2 = Hb, ly = jb, cy = Ub, q2 = qb, Y2 = Kb, uy = Xb, dy = Jb, fy = Zb;
const K2 = "tw-min-w-28 tw-flex tw-flex-col tw-rounded tw-bg-white/90 tw-backdrop-blur-xl tw-shadow-xl tw-z-[100] data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 tw-duration-200", X2 = 'tw-text-sm tw-transition-all tw-duration-100 tw-h-9 tw-flex tw-cursor-pointer tw-gap-2 tw-justify-between tw-items-center hover:tw-bg-brand-primary-1 focus:tw-bg-brand-primary-1 tw-outline-none tw-rounded-sm [&>div]:tw-px-2 data-[highlighted]:tw-bg-semantic-action-background-neutral-weaker data-[state="checked"]:tw-bg-semantic-action-background-primary-weakest', J2 = "tw-min-w-28 tw-p-1 tw-rounded-md tw-text-base tw-border-density-action-thin tw-border-semantic-action-border-neutral-lighter ", py = "tw-flex tw-justify-center tw-items-center tw-overflow-visible tw-bg-semantic-action-background-neutral-white tw-cursor-default tw-h-density-action-height-sm tw-rounded-es-density-action-default ", Q2 = "[&_*_input]:tw-bg-semantic-formElement-background-neutral-default", m4 = j2, g4 = U2, h4 = G2, v4 = ay, w4 = sy, Z2 = q(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ m(
    oy,
    { ref: r, ...n, className: N(Q2), children: t }
  )
);
Z2.displayName = oy.displayName;
const my = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    uy,
    {
      ref: n,
      className: N(py, e),
      ...t,
      children: /* @__PURE__ */ m(de, { icon: "chevron-up", size: "sm" })
    }
  )
);
my.displayName = uy.displayName;
const gy = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    dy,
    {
      ref: n,
      className: N(py, e),
      ...t,
      children: /* @__PURE__ */ m(de, { icon: "chevron-down", size: "sm" })
    }
  )
);
gy.displayName = dy.displayName;
const e$ = q(
  ({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ m(
    ay,
    { children: /* @__PURE__ */ ee(
      iy,
      {
        ref: o,
        className: N(
          K2,
          n === "popper" && "tw-w-[var(--radix-select-trigger-width)] data-[side=bottom]:tw-translate-y-1 data-[side=left]:tw--translate-x-1 data-[side=right]:tw-translate-x-1 data-[side=top]:tw--translate-y-1",
          e
        ),
        position: n,
        ...r,
        children: [
          /* @__PURE__ */ m(my, {}),
          /* @__PURE__ */ m(
            sy,
            {
              className: N(
                J2,
                n === "popper" && "tw-h-[var(--radix-select-trigger-height)] tw-w-full tw-min-w-[var(--radix-select-trigger-width)]"
              ),
              children: t
            }
          ),
          /* @__PURE__ */ m(gy, {})
        ]
      }
    ) }
  )
);
e$.displayName = iy.displayName;
const t$ = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(ly, { ref: n, className: N("", e), ...t })
);
t$.displayName = ly.displayName;
const n$ = q(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ee(
    cy,
    {
      ref: r,
      className: N(X2, e),
      ...n,
      children: [
        /* @__PURE__ */ m(
          "div",
          { className: "tw-flex tw-h-full tw-max-w-[100vw-50vw] tw-items-center tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap ", children: /* @__PURE__ */ m(q2, { children: t }) }
        ),
        /* @__PURE__ */ m(
          Y2,
          { children: /* @__PURE__ */ m(de, { icon: "check", size: "sm", className: "tw-mr-2" }) }
        )
      ]
    }
  )
);
n$.displayName = cy.displayName;
const r$ = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    fy,
    {
      ref: n,
      className: N("tw--mx-1 tw-my-1 tw-h-px", e),
      ...t
    }
  )
);
r$.displayName = fy.displayName;
const o$ = "tw-fixed tw-inset-0 tw-z-50 tw-bg-black/80 data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0", a$ = "tw-flex tw-flex-col tw-gap-density-static-gap-md tw-bg-semantic-static-background-neutral-default ", i$ = "tw-grid tw-gap-density-static-gap-xs ", s$ = "tw-productiveFluid-body-body-md-regular tw-text-left", l$ = "tw-flex tw-flex-col-reverse tw-gap-density-static-gap-xs  sm:tw-flex-row sm:tw-justify-end sm:tw-space-x-2 ", c$ = oe("tw-fixed tw-z-50 tw-gap-4 tw-bg-semantic-static-background-neutral-default tw-p-6 tw-shadow-lg tw-transition tw-ease-in-out data-[state=closed]:tw-duration-300 data-[state=open]:tw-duration-500 data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-opacity-0 data-[state=open]:tw-opacity-100", {
  variants: {
    side: {
      bottom: "tw-inset-x-0 tw-bottom-0 tw-border-t data-[state=closed]:tw-slide-out-to-bottom data-[state=open]:tw-slide-in-from-bottom",
      left: "tw-inset-y-0 tw-left-0 tw-h-full tw-w-[75%] tw-border-r data-[state=closed]:tw-slide-out-to-left data-[state=open]:tw-slide-in-from-left sm:tw-max-w-sm",
      right: "tw-inset-y-0 tw-right-0 tw-h-full tw-w-[75%] tw-border-l data-[state=closed]:tw-slide-out-to-right data-[state=open]:tw-slide-in-from-right sm:tw-max-w-sm"
    }
  },
  defaultVariants: {
    side: "right"
  }
}), b4 = ra, y4 = ({ children: e, ...t }) => {
  const [n, r] = ye(void 0);
  return ke(() => {
    r(t["aria-controls"]);
  }, [t["aria-controls"]]), /* @__PURE__ */ m(
    tu,
    { ...t, "aria-controls": n, children: tn(e, {
      "aria-controls": n
    }) }
  );
}, x4 = Fi, u$ = oa, hy = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    fr,
    {
      ref: n,
      className: N(o$, e),
      ...t
    }
  )
);
hy.displayName = fr.displayName;
const d$ = q(
  ({ side: e = "right", className: t, children: n, ...r }, o) => {
    const a = $n();
    return /* @__PURE__ */ ee(
      u$,
      { children: [
        /* @__PURE__ */ m(hy, {}),
        /* @__PURE__ */ m(
          Mn,
          {
            ref: o,
            id: a,
            className: N(c$({ side: e }), a$, t),
            ...r,
            children: n
          }
        )
      ] }
    );
  }
);
d$.displayName = Mn.displayName;
const f$ = ({
  className: e,
  ...t
}) => /* @__PURE__ */ m("div", { className: N(i$, e), ...t });
f$.displayName = "SheetHeader";
const p$ = ({
  className: e,
  ...t
}) => /* @__PURE__ */ m("div", { className: N(l$, e), ...t });
p$.displayName = "SheetFooter";
const m$ = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ ee(
    "div",
    { className: "tw-flex tw-items-start tw-justify-between", children: [
      /* @__PURE__ */ m(
        aa,
        {
          ref: n,
          className: N(
            "tw-productiveFluid-heading-heading-lg tw-text-left",
            e
          ),
          ...t
        }
      ),
      /* @__PURE__ */ m(
        Fi,
        { asChild: !0, children: /* @__PURE__ */ m(
          mt,
          {
            size: "sm",
            variant: "ghost",
            intent: "neutral",
            ariaLabel: "close",
            iconName: "xmark"
          }
        ) }
      )
    ] }
  )
);
m$.displayName = aa.displayName;
const g$ = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    ia,
    {
      ref: n,
      className: N(s$, e),
      ...t
    }
  )
);
g$.displayName = ia.displayName;
const wo = oe("tw-animate-pulse tw-rounded-md tw-border tw-bg-gray-200 ", {
  variants: {
    type: {
      header: "tw-h-[32px] tw-w-[280px]",
      paragraph: "tw-h-[24px] tw-w-[600px]",
      button: "tw-h-[32px] tw-w-[120px]",
      image: "tw-h-[180px] tw-w-[180px]",
      avatar: "tw-h-[80px] tw-w-[80px] tw-rounded-full"
    }
  },
  defaultVariants: {
    type: "header"
  }
}), S4 = ({
  type: e = "header",
  className: t,
  ...n
}) => e === "paragraph" ? /* @__PURE__ */ ee(
  "div",
  { className: "tw-flex tw-flex-col tw-gap-[16px]", children: [
    /* @__PURE__ */ m("div", { className: N(wo({ type: e, className: t })), ...n }),
    /* @__PURE__ */ m("div", { className: N(wo({ type: e, className: t })), ...n }),
    /* @__PURE__ */ m("div", { className: N(wo({ type: e, className: t })), ...n }),
    /* @__PURE__ */ m("div", { className: N(wo({ type: e, className: t })), ...n })
  ] }
) : /* @__PURE__ */ m("div", { className: N(wo({ type: e, className: t })), ...n });
var Ku = "Switch", [h$, C4] = Ye(Ku), [v$, w$] = h$(Ku), vy = v.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      form: u,
      ...d
    } = e, [f, p] = v.useState(null), h = xe(t, (x) => p(x)), g = v.useRef(!1), w = f ? u || !!f.closest("form") : !0, [b = !1, y] = je({
      prop: o,
      defaultProp: a,
      onChange: c
    });
    return /* @__PURE__ */ ee(v$, { scope: n, checked: b, disabled: s, children: [
      /* @__PURE__ */ m(
        ie.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": b,
          "aria-required": i,
          "data-state": yy(b),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...d,
          ref: h,
          onClick: re(e.onClick, (x) => {
            y((C) => !C), w && (g.current = x.isPropagationStopped(), g.current || x.stopPropagation());
          })
        }
      ),
      w && /* @__PURE__ */ m(
        b$,
        {
          control: f,
          bubbles: !g.current,
          name: r,
          value: l,
          checked: b,
          required: i,
          disabled: s,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
vy.displayName = Ku;
var wy = "SwitchThumb", by = v.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, o = w$(wy, n);
    return /* @__PURE__ */ m(
      ie.span,
      {
        "data-state": yy(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
by.displayName = wy;
var b$ = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, a = v.useRef(null), i = Xi(n), s = Ii(t);
  return v.useEffect(() => {
    const l = a.current, c = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(c, "checked").set;
    if (i !== n && d) {
      const f = new Event("click", { bubbles: r });
      d.call(l, n), l.dispatchEvent(f);
    }
  }, [i, n, r]), /* @__PURE__ */ m(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...o,
      tabIndex: -1,
      ref: a,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function yy(e) {
  return e ? "checked" : "unchecked";
}
var xy = vy, y$ = by;
const x$ = oe(["custom-switch-focus-ring tw-inline-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-rounded-sm tw-border-2 tw-border-transparent tw-bg-neutral-300 tw-p-0 hover:tw-bg-brand-primary-5 focus-visible:tw-outline-none disabled:tw-cursor-not-allowed disabled:tw-opacity-50 data-[state=checked]:tw-justify-end data-[state=checked]:tw-bg-brand-primary-6"], {
  variants: {
    size: {
      sm: "tw-h-4 tw-w-7",
      md: "tw-h-6 tw-w-11"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), S$ = oe(["tw-rounded-sm tw-bg-brand-neutral-white tw-ring-0 tw-transition-all tw-ease-in-out"], {
  variants: {
    size: {
      sm: "tw-h-full tw-w-3 hover:tw-shadow",
      md: "tw-h-full tw-w-5 hover:tw-shadow"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), C$ = oe("tw-label-md-regular tw-pl-density-action-gap-md", {
  variants: {
    isLabelHidden: {
      true: "tw-sr-only"
    }
  }
}), E$ = q(
  ({ className: e, size: t, label: n, isLabelHidden: r, ...o }, a) => {
    const i = $n();
    return /* @__PURE__ */ ee(
      "div",
      { className: "tw-flex tw-items-center", children: [
        /* @__PURE__ */ m(
          xy,
          {
            className: N(x$({ size: t, className: e })),
            ...o,
            ref: a,
            id: i,
            children: /* @__PURE__ */ m(
              y$,
              {
                className: N(S$({ size: t, className: e }))
              }
            )
          }
        ),
        /* @__PURE__ */ m(
          "label",
          {
            htmlFor: i,
            className: N(C$({ isLabelHidden: r, className: e })),
            children: n
          }
        )
      ] }
    );
  }
);
E$.displayName = xy.displayName;
var Xu = "Tabs", [k$, E4] = Ye(Xu, [
  an
]), Sy = an(), [R$, Ju] = k$(Xu), Cy = v.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: o,
      defaultValue: a,
      orientation: i = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = e, u = Ln(s), [d, f] = je({
      prop: r,
      onChange: o,
      defaultProp: a
    });
    return /* @__PURE__ */ m(
      R$,
      {
        scope: n,
        baseId: Te(),
        value: d,
        onValueChange: f,
        orientation: i,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ m(
          ie.div,
          {
            dir: u,
            "data-orientation": i,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
Cy.displayName = Xu;
var Ey = "TabsList", ky = v.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...o } = e, a = Ju(Ey, n), i = Sy(n);
    return /* @__PURE__ */ m(
      la,
      {
        asChild: !0,
        ...i,
        orientation: a.orientation,
        dir: a.dir,
        loop: r,
        children: /* @__PURE__ */ m(
          ie.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
ky.displayName = Ey;
var Ry = "TabsTrigger", Py = v.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: o = !1, ...a } = e, i = Ju(Ry, n), s = Sy(n), l = _y(i.baseId, r), c = Iy(i.baseId, r), u = r === i.value;
    return /* @__PURE__ */ m(
      ca,
      {
        asChild: !0,
        ...s,
        focusable: !o,
        active: u,
        children: /* @__PURE__ */ m(
          ie.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: l,
            ...a,
            ref: t,
            onMouseDown: re(e.onMouseDown, (d) => {
              !o && d.button === 0 && d.ctrlKey === !1 ? i.onValueChange(r) : d.preventDefault();
            }),
            onKeyDown: re(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && i.onValueChange(r);
            }),
            onFocus: re(e.onFocus, () => {
              const d = i.activationMode !== "manual";
              !u && !o && d && i.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
Py.displayName = Ry;
var Ny = "TabsContent", Ty = v.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: o, children: a, ...i } = e, s = Ju(Ny, n), l = _y(s.baseId, r), c = Iy(s.baseId, r), u = r === s.value, d = v.useRef(u);
    return v.useEffect(() => {
      const f = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(f);
    }, []), /* @__PURE__ */ m(at, { present: o || u, children: ({ present: f }) => /* @__PURE__ */ m(
      ie.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !f,
        id: c,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: f && a
      }
    ) });
  }
);
Ty.displayName = Ny;
function _y(e, t) {
  return `${e}-trigger-${t}`;
}
function Iy(e, t) {
  return `${e}-content-${t}`;
}
var My = Cy, Oy = ky, Dy = Py, Ay = Ty;
const P$ = "tw-flex tw-items-center custom-global-focus-ring tw-rounded-t-density-action-default tw-gap-density-action-gap-md tw-border-density-action-default tw-border-x-0 tw-border-t-transparent tw-border-b-transparent tw-text-semantic-action-foreground-neutral-strong  ", N$ = "tw-px-density-action-padding-sm tw-text-xs tw-font-semibold ", T$ = "tw-rounded-b-density-static-none tw-h-density-action-height-md tw-bg-semantic-action-background-primary-2xweakesttw-border-y-semantic-action-background-primary-lightest tw-border-x-semantic-action-background-primary-lightest tw-px-density-action-padding-md ", _$ = "data-[state=active]:tw-bg-semantic-action-background-primary-strongest data-[state=active]:tw-text-semantic-action-foreground-neutral-white data-[state=active]:tw-border-y-semantic-action-background-primary-strongest data-[state=active]:tw-border-x-semantic-action-background-primary-strongest ", I$ = "hover:tw-bg-semantic-action-background-primary-weaker hover:tw-border-y-semantic-action-background-primary-weaker hover:tw-border-x-semantic-action-background-primary-weaker ", Af = "tw-text-sm tw-font-medium tw-rounded-density-static-none tw-h-density-action-height-md tw-bg-transparent data-[state=active]:tw-border-b-semantic-action-foreground-primary-default data-[state=active]: tw-rounded-nonehover:tw-border-b-semantic-action-foreground-neutral-darkest ", M$ = "tw-rounded-b-density-action-full tw-box-content tw-h-density-action-height-md tw-rounded-t-density-action-full tw-py-0 tw-px-density-action-padding-md  ", $f = "data-[state=active]:tw-bg-semantic-action-background-primary-default data-[state=active]:tw-text-semantic-action-foreground-neutral-white ", O$ = "!tw-leading-none !tw-min-w-6 ", D$ = oe(P$, {
  variants: {
    variant: {
      "with-rule": `tw-h-density-action-height-md ${T$} ${_$} ${I$} `,
      "with-rule-ghost": ` ${Af} tw-px-density-action-padding-sm  `,
      "single-pill": ` ${M$} ${$f} hover:tw-text-semantic-action-foreground-primary-default tw-font-semibold tw-text-xs`,
      "pill-separate": `tw-rounded-b-density-action-full tw-rounded-t-density-action-full tw-bg-semantic-action-background-neutral-weaker tw-py-density-action-padding-xs tw-px-density-action-padding-md tw-font-semibold tw-text-xs ${$f}`,
      line: `${N$} ${Af}  data-[state=active]:tw-text-semantic-action-foreground-primary-default `
    },
    disabled: {
      true: "tw-text-semantic-action-foreground-neutral-weak hover:tw-text-semantic-action-foreground-neutral-weak",
      false: ""
    }
  },
  compoundVariants: [{
    variant: "with-rule",
    disabled: !0,
    className: "hover:tw-bg-transparent hover:tw-border-t-transparent hover:tw-border-b-transparent "
  }]
}), A$ = oe("tw-inline-flex tw-items-end tw-gap-density-action-gap-sm ", {
  variants: {
    variant: {
      "with-rule": "",
      "with-rule-ghost": "",
      "single-pill": "tw-rounded-b-density-action-full tw-rounded-t-density-action-full tw-border-density-action-thin tw-border-semantic-action-border-neutral-weak tw-bg-brand-neutral-white tw-p-density-action-padding-2xs ",
      "pill-separate": "tw-gap-density-action-gap-sm ",
      line: ""
    }
  }
}), Lf = "tw-mx-density-action-padding-md tw-border-x-transparent tw-border-y-transparent", $$ = oe("tw-border-y-density-action-thin tw-border-b-0 tw-pt-density-action-height-sm ", {
  variants: {
    variant: {
      "with-rule": "tw-border-t-semantic-action-foreground-primary-strongest ",
      "with-rule-ghost": "tw-border-t-gray-300",
      // tw-border-t-semantic-action-background-neutral-light
      "single-pill": `${Lf} `,
      "pill-separate": `${Lf} `,
      line: "tw-border-x-transparent tw-border-y-transparent"
    }
  }
}), ss = bt(
  void 0
), L$ = q(
  ({ activationMode: e, variant: t = "with-rule", ...n }, r) => /* @__PURE__ */ m(
    ss.Provider,
    { value: { variant: t }, children: /* @__PURE__ */ m(
      My,
      {
        ref: r,
        ...n,
        activationMode: e || "manual"
      }
    ) }
  )
);
L$.displayName = My.displayName;
const F$ = q(
  ({ className: e, ...t }, n) => {
    const r = Xe(ss);
    if (!r)
      throw new Error(
        "TabsTrigger must be used within a Tabs with a provided variant."
      );
    const { variant: o } = r;
    return /* @__PURE__ */ m(
      Oy,
      {
        ref: n,
        className: N(A$({ variant: o }), e),
        ...t
      }
    );
  }
);
F$.displayName = Oy.displayName;
const z$ = q(
  ({ className: e, badgeText: t, children: n, disabled: r, ...o }, a) => {
    const i = Xe(ss);
    if (!i)
      throw new Error(
        "TabsTrigger must be used within a Tabs with a provided variant."
      );
    const { variant: s } = i;
    return /* @__PURE__ */ ee(
      Dy,
      {
        ref: a,
        className: N(
          D$({ variant: s, disabled: r }),
          t && s === "pill-separate" && "!tw-pr-0",
          "tw-group",
          e
        ),
        disabled: r,
        ...o,
        children: [
          n,
          t && /* @__PURE__ */ m(
            zg,
            { size: "sm", color: "sky", shape: "round", className: O$, children: t }
          )
        ]
      }
    );
  }
);
z$.displayName = Dy.displayName;
const V$ = q(
  ({ className: e, ...t }, n) => {
    const r = Xe(ss);
    if (!r)
      throw new Error(
        "TabsContent must be used within a Tabs with a provided variant."
      );
    const { variant: o } = r;
    return /* @__PURE__ */ m(
      Ay,
      {
        ref: n,
        className: N($$({ variant: o }), e),
        ...t
      }
    );
  }
);
V$.displayName = Ay.displayName;
const B$ = oe("tw-inline-flex tw-h-6 tw-max-h-6 tw-items-center tw-gap-2 tw-overflow-hidden tw-rounded-sm tw-border tw-pl-2 tw-text-[12px] tw-font-medium", {
  variants: {
    borderless: {
      true: "tw-border-transparent tw-bg-neutral-100",
      false: "tw-border-[#ADADAD] tw-bg-neutral-50"
    }
  },
  defaultVariants: {
    borderless: !1
  }
}), H$ = q(
  ({
    className: e,
    label: t,
    icon: n,
    borderless: r = !1,
    buttonAction: o,
    buttonRef: a,
    ...i
  }, s) => /* @__PURE__ */ ee(
    "div",
    {
      ref: s,
      ...i,
      className: N(B$({ borderless: r }), e),
      children: [
        n ? /* @__PURE__ */ m(de, { icon: n, size: "sm" }) : null,
        /* @__PURE__ */ m(
          "span",
          { className: "tw-select-none tw-truncate", title: t, children: t }
        ),
        /* @__PURE__ */ m(
          mt,
          {
            ref: a,
            className: "custom-button-focus-ring--inset",
            onClick: o,
            intent: "neutral",
            variant: "ghost",
            iconName: "xmark",
            ariaLabel: `Remove ${t}`,
            size: "sm"
          }
        )
      ]
    }
  )
);
H$.displayName = "Tag";
const W$ = "tw-border-x-density-formElement-default tw-border-y-density-formElement-default tw-rounded-density-formElement-xs tw-p-density-formElement-padding-md tw-transition-colors tw-ease-in-out tw-duration-200 custom-text-input-focus-ring hover:tw-border-semantic-formElement-border-neutral-dark active:tw-border-semantic-formElement-border-primary-default  ", j$ = oe(W$, {
  variants: {
    type: {
      auto: "tw-min-h-30 tw-resize-none",
      fixed: " tw-resize-none",
      resize: ""
    },
    resize: {
      vertical: "",
      horizontal: "",
      both: ""
    },
    size: {
      md: "tw-body-md-regular",
      lg: "tw-body-lg-regular"
    },
    fieldState: {
      error: "tw-border-semantic-formElement-border-neutral-error hover:tw-border-semantic-formElement-border-neutral-error active:tw-border-semantic-formElement-border-neutral-error tw-bg-semantic-formElement-background-neutral-default tw-placeholder-semantic-formElement-label-light ",
      readOnly: "tw-border-semantic-formElement-border-neutral-disabled tw-bg-semantic-formElement-background-neutral-disabled tw-placeholder-semantic-formElement-label-disabled ",
      valid: "tw-border-semantic-formElement-border-neutral-default tw-bg-semantic-formElement-background-neutral-default tw-placeholder-semantic-formElement-label-light "
    }
  },
  defaultVariants: {
    size: "md",
    type: "auto"
  },
  compoundVariants: [{
    type: "resize",
    resize: "vertical",
    className: "tw-resize-y"
  }, {
    type: "resize",
    resize: "horizontal",
    className: "tw-resize-x"
  }, {
    type: "resize",
    resize: "both",
    className: "tw-resize"
  }]
}), G$ = "tw-inline-flex tw-flex-col tw-gap-density-formElement-gap-md ", U$ = "tw-flex tw-flex-row tw-gap-density-formElement-gap-md tw-items-end ", q$ = oe(U$, {
  variants: {
    hidden: {
      true: "tw-justify-end tw-gap-density-formElement-gap-md",
      false: "tw-justify-between"
    }
  },
  defaultVariants: {
    hidden: !1
  }
}), Y$ = "tw-text-semantic-formElement-label-default ", K$ = oe(Y$, {
  variants: {
    size: {
      md: "tw-label-md-bold ",
      lg: "tw-label-lg-bold "
    }
  },
  defaultVariants: {
    size: "md"
  }
}), X$ = "tw-label-xs-medium", J$ = "tw-text-xs", Ff = oe(J$, {
  variants: {
    fieldState: {
      error: "tw-text-semantic-formElement-label-error",
      readOnly: "",
      valid: ""
    }
  }
}), Q$ = q(
  ({
    className: e,
    placeholder: t,
    errorMessage: n,
    disabled: r,
    type: o = "fixed",
    size: a = "md",
    isLabelHidden: i = !1,
    readOnly: s = !1,
    charMax: l,
    helperText: c,
    labelText: u,
    value: d = "",
    resize: f,
    charCountText: p = "characters",
    onChange: h,
    ...g
  }, w) => {
    const b = `helper-${Ir()}`, y = `error-${Ir()}`, x = `input-${Ir()}`, C = n ? "error" : s ? "readOnly" : "valid", [S, R] = ye(d.length), E = `${S}/${l} ${p}`, M = qe(null);
    ke(() => {
      if (R(d.length), o === "auto" && M.current) {
        M.current.style.height = "auto";
        const U = Math.min(
          Math.max(M.current.scrollHeight, 4 * 24),
          // 4 lines (96px)
          8 * 24
          // 8 lines (192px)
        );
        M.current.style.height = `${U}px`;
      }
    }, [d, o]);
    const F = (U) => {
      R(U.target.value.length), h(U);
    }, G = [
      c ? b : null,
      n ? y : null
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ ee(
      "div",
      { className: N(G$, e), children: [
        /* @__PURE__ */ ee(
          "div",
          { className: q$({ hidden: i }), children: [
            /* @__PURE__ */ m(
              gD,
              {
                className: N(K$({ size: a })),
                label: u,
                htmlFor: x,
                isLabelHidden: i
              }
            ),
            l ? /* @__PURE__ */ m("span", { className: X$, children: E }) : null
          ] }
        ),
        /* @__PURE__ */ m(
          "textarea",
          {
            ref: ig([w, M]),
            className: N(j$({ type: o, size: a, fieldState: C, resize: f })),
            id: x,
            value: d,
            placeholder: t,
            readOnly: s,
            onChange: F,
            "aria-describedby": G || "",
            maxLength: l || void 0,
            ...g
          }
        ),
        n ? /* @__PURE__ */ m(
          "span",
          {
            id: y,
            className: N(Ff({ fieldState: C })),
            children: n
          }
        ) : c ? /* @__PURE__ */ m(
          "span",
          {
            id: b,
            className: N(Ff({ fieldState: C })),
            children: c
          }
        ) : null
      ] }
    );
  }
);
Q$.displayName = "Textarea";
var Qu = "ToastProvider", [Zu, Z$, eL] = qr("Toast"), [$y, k4] = Ye("Toast", [eL]), [tL, ls] = $y(Qu), Ly = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: a = 50,
    children: i
  } = e, [s, l] = v.useState(null), [c, u] = v.useState(0), d = v.useRef(!1), f = v.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${Qu}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ m(Zu.Provider, { scope: t, children: /* @__PURE__ */ m(
    tL,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: a,
      toastCount: c,
      viewport: s,
      onViewportChange: l,
      onToastAdd: v.useCallback(() => u((p) => p + 1), []),
      onToastRemove: v.useCallback(() => u((p) => p - 1), []),
      isFocusedToastEscapeKeyDownRef: d,
      isClosePausedRef: f,
      children: i
    }
  ) });
};
Ly.displayName = Qu;
var Fy = "ToastViewport", nL = ["F8"], ic = "toast.viewportPause", sc = "toast.viewportResume", zy = v.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = nL,
      label: o = "Notifications ({hotkey})",
      ...a
    } = e, i = ls(Fy, n), s = Z$(n), l = v.useRef(null), c = v.useRef(null), u = v.useRef(null), d = v.useRef(null), f = xe(t, d, i.onViewportChange), p = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), h = i.toastCount > 0;
    v.useEffect(() => {
      const w = (b) => {
        var x;
        r.length !== 0 && r.every((C) => b[C] || b.code === C) && ((x = d.current) == null || x.focus());
      };
      return document.addEventListener("keydown", w), () => document.removeEventListener("keydown", w);
    }, [r]), v.useEffect(() => {
      const w = l.current, b = d.current;
      if (h && w && b) {
        const y = () => {
          if (!i.isClosePausedRef.current) {
            const R = new CustomEvent(ic);
            b.dispatchEvent(R), i.isClosePausedRef.current = !0;
          }
        }, x = () => {
          if (i.isClosePausedRef.current) {
            const R = new CustomEvent(sc);
            b.dispatchEvent(R), i.isClosePausedRef.current = !1;
          }
        }, C = (R) => {
          !w.contains(R.relatedTarget) && x();
        }, S = () => {
          w.contains(document.activeElement) || x();
        };
        return w.addEventListener("focusin", y), w.addEventListener("focusout", C), w.addEventListener("pointermove", y), w.addEventListener("pointerleave", S), window.addEventListener("blur", y), window.addEventListener("focus", x), () => {
          w.removeEventListener("focusin", y), w.removeEventListener("focusout", C), w.removeEventListener("pointermove", y), w.removeEventListener("pointerleave", S), window.removeEventListener("blur", y), window.removeEventListener("focus", x);
        };
      }
    }, [h, i.isClosePausedRef]);
    const g = v.useCallback(
      ({ tabbingDirection: w }) => {
        const y = s().map((x) => {
          const C = x.ref.current, S = [C, ...hL(C)];
          return w === "forwards" ? S : S.reverse();
        });
        return (w === "forwards" ? y.reverse() : y).flat();
      },
      [s]
    );
    return v.useEffect(() => {
      const w = d.current;
      if (w) {
        const b = (y) => {
          var S, R, E;
          const x = y.altKey || y.ctrlKey || y.metaKey;
          if (y.key === "Tab" && !x) {
            const M = document.activeElement, F = y.shiftKey;
            if (y.target === w && F) {
              (S = c.current) == null || S.focus();
              return;
            }
            const H = g({ tabbingDirection: F ? "backwards" : "forwards" }), j = H.findIndex((z) => z === M);
            cl(H.slice(j + 1)) ? y.preventDefault() : F ? (R = c.current) == null || R.focus() : (E = u.current) == null || E.focus();
          }
        };
        return w.addEventListener("keydown", b), () => w.removeEventListener("keydown", b);
      }
    }, [s, g]), /* @__PURE__ */ ee(
      eC,
      {
        ref: l,
        role: "region",
        "aria-label": o.replace("{hotkey}", p),
        tabIndex: -1,
        style: { pointerEvents: h ? void 0 : "none" },
        children: [
          h && /* @__PURE__ */ m(
            lc,
            {
              ref: c,
              onFocusFromOutsideViewport: () => {
                const w = g({
                  tabbingDirection: "forwards"
                });
                cl(w);
              }
            }
          ),
          /* @__PURE__ */ m(Zu.Slot, { scope: n, children: /* @__PURE__ */ m(ie.ol, { tabIndex: -1, ...a, ref: f }) }),
          h && /* @__PURE__ */ m(
            lc,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const w = g({
                  tabbingDirection: "backwards"
                });
                cl(w);
              }
            }
          )
        ]
      }
    );
  }
);
zy.displayName = Fy;
var Vy = "ToastFocusProxy", lc = v.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, a = ls(Vy, n);
    return /* @__PURE__ */ m(
      ya,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (i) => {
          var c;
          const s = i.relatedTarget;
          !((c = a.viewport) != null && c.contains(s)) && r();
        }
      }
    );
  }
);
lc.displayName = Vy;
var cs = "Toast", rL = "toast.swipeStart", oL = "toast.swipeMove", aL = "toast.swipeCancel", iL = "toast.swipeEnd", By = v.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: o, onOpenChange: a, ...i } = e, [s = !0, l] = je({
      prop: r,
      defaultProp: o,
      onChange: a
    });
    return /* @__PURE__ */ m(at, { present: n || s, children: /* @__PURE__ */ m(
      cL,
      {
        open: s,
        ...i,
        ref: t,
        onClose: () => l(!1),
        onPause: Ze(e.onPause),
        onResume: Ze(e.onResume),
        onSwipeStart: re(e.onSwipeStart, (c) => {
          c.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: re(e.onSwipeMove, (c) => {
          const { x: u, y: d } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "move"), c.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${d}px`);
        }),
        onSwipeCancel: re(e.onSwipeCancel, (c) => {
          c.currentTarget.setAttribute("data-swipe", "cancel"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: re(e.onSwipeEnd, (c) => {
          const { x: u, y: d } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "end"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${d}px`), l(!1);
        })
      }
    ) });
  }
);
By.displayName = cs;
var [sL, lL] = $y(cs, {
  onClose() {
  }
}), cL = v.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: o,
      open: a,
      onClose: i,
      onEscapeKeyDown: s,
      onPause: l,
      onResume: c,
      onSwipeStart: u,
      onSwipeMove: d,
      onSwipeCancel: f,
      onSwipeEnd: p,
      ...h
    } = e, g = ls(cs, n), [w, b] = v.useState(null), y = xe(t, (z) => b(z)), x = v.useRef(null), C = v.useRef(null), S = o || g.duration, R = v.useRef(0), E = v.useRef(S), M = v.useRef(0), { onToastAdd: F, onToastRemove: G } = g, U = Ze(() => {
      var Z;
      (w == null ? void 0 : w.contains(document.activeElement)) && ((Z = g.viewport) == null || Z.focus()), i();
    }), H = v.useCallback(
      (z) => {
        !z || z === 1 / 0 || (window.clearTimeout(M.current), R.current = (/* @__PURE__ */ new Date()).getTime(), M.current = window.setTimeout(U, z));
      },
      [U]
    );
    v.useEffect(() => {
      const z = g.viewport;
      if (z) {
        const Z = () => {
          H(E.current), c == null || c();
        }, Y = () => {
          const O = (/* @__PURE__ */ new Date()).getTime() - R.current;
          E.current = E.current - O, window.clearTimeout(M.current), l == null || l();
        };
        return z.addEventListener(ic, Y), z.addEventListener(sc, Z), () => {
          z.removeEventListener(ic, Y), z.removeEventListener(sc, Z);
        };
      }
    }, [g.viewport, S, l, c, H]), v.useEffect(() => {
      a && !g.isClosePausedRef.current && H(S);
    }, [a, S, g.isClosePausedRef, H]), v.useEffect(() => (F(), () => G()), [F, G]);
    const j = v.useMemo(() => w ? qy(w) : null, [w]);
    return g.viewport ? /* @__PURE__ */ ee(Ne, { children: [
      j && /* @__PURE__ */ m(
        uL,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: j
        }
      ),
      /* @__PURE__ */ m(sL, { scope: n, onClose: U, children: Rn.createPortal(
        /* @__PURE__ */ m(Zu.ItemSlot, { scope: n, children: /* @__PURE__ */ m(
          ZS,
          {
            asChild: !0,
            onEscapeKeyDown: re(s, () => {
              g.isFocusedToastEscapeKeyDownRef.current || U(), g.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ m(
              ie.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": a ? "open" : "closed",
                "data-swipe-direction": g.swipeDirection,
                ...h,
                ref: y,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: re(e.onKeyDown, (z) => {
                  z.key === "Escape" && (s == null || s(z.nativeEvent), z.nativeEvent.defaultPrevented || (g.isFocusedToastEscapeKeyDownRef.current = !0, U()));
                }),
                onPointerDown: re(e.onPointerDown, (z) => {
                  z.button === 0 && (x.current = { x: z.clientX, y: z.clientY });
                }),
                onPointerMove: re(e.onPointerMove, (z) => {
                  if (!x.current) return;
                  const Z = z.clientX - x.current.x, Y = z.clientY - x.current.y, O = !!C.current, I = ["left", "right"].includes(g.swipeDirection), W = ["left", "up"].includes(g.swipeDirection) ? Math.min : Math.max, A = I ? W(0, Z) : 0, K = I ? 0 : W(0, Y), k = z.pointerType === "touch" ? 10 : 2, $ = { x: A, y: K }, P = { originalEvent: z, delta: $ };
                  O ? (C.current = $, Ya(oL, d, P, {
                    discrete: !1
                  })) : zf($, g.swipeDirection, k) ? (C.current = $, Ya(rL, u, P, {
                    discrete: !1
                  }), z.target.setPointerCapture(z.pointerId)) : (Math.abs(Z) > k || Math.abs(Y) > k) && (x.current = null);
                }),
                onPointerUp: re(e.onPointerUp, (z) => {
                  const Z = C.current, Y = z.target;
                  if (Y.hasPointerCapture(z.pointerId) && Y.releasePointerCapture(z.pointerId), C.current = null, x.current = null, Z) {
                    const O = z.currentTarget, I = { originalEvent: z, delta: Z };
                    zf(Z, g.swipeDirection, g.swipeThreshold) ? Ya(iL, p, I, {
                      discrete: !0
                    }) : Ya(
                      aL,
                      f,
                      I,
                      {
                        discrete: !0
                      }
                    ), O.addEventListener("click", (W) => W.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        g.viewport
      ) })
    ] }) : null;
  }
), uL = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = ls(cs, t), [a, i] = v.useState(!1), [s, l] = v.useState(!1);
  return mL(() => i(!0)), v.useEffect(() => {
    const c = window.setTimeout(() => l(!0), 1e3);
    return () => window.clearTimeout(c);
  }, []), s ? null : /* @__PURE__ */ m(Jr, { asChild: !0, children: /* @__PURE__ */ m(ya, { ...r, children: a && /* @__PURE__ */ ee(Ne, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, dL = "ToastTitle", Hy = v.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ m(ie.div, { ...r, ref: t });
  }
);
Hy.displayName = dL;
var fL = "ToastDescription", Wy = v.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ m(ie.div, { ...r, ref: t });
  }
);
Wy.displayName = fL;
var jy = "ToastAction", pL = v.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ m(Uy, { altText: n, asChild: !0, children: /* @__PURE__ */ m(ed, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${jy}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
pL.displayName = jy;
var Gy = "ToastClose", ed = v.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, o = lL(Gy, n);
    return /* @__PURE__ */ m(Uy, { asChild: !0, children: /* @__PURE__ */ m(
      ie.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: re(e.onClick, o.onClose)
      }
    ) });
  }
);
ed.displayName = Gy;
var Uy = v.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ m(
    ie.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: t
    }
  );
});
function qy(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), gL(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", a = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (a) {
          const i = r.dataset.radixToastAnnounceAlt;
          i && t.push(i);
        } else
          t.push(...qy(r));
    }
  }), t;
}
function Ya(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, a = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? yc(o, a) : o.dispatchEvent(a);
}
var zf = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), a = r > o;
  return t === "left" || t === "right" ? a && r > n : !a && o > n;
};
function mL(e = () => {
}) {
  const t = Ze(e);
  et(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function gL(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function hL(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function cl(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var vL = Ly, Yy = zy, Ky = By, wL = Hy, Xy = Wy, Jy = ed;
const bL = "tw-group tw-pointer-events-auto tw-relative tw-flex tw-w-full tw-items-center tw-space-x-2  tw-overflow-hidden tw-rounded-density-action-sm tw-border-density-action-thin tw-p-density-action-padding-md tw-pl-density-action-padding-lg tw-shadow-lg tw-transition-all data-[swipe=cancel]:tw-translate-x-0 data-[swipe=end]:tw-translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:tw-transition-none data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[swipe=end]:tw-animate-out data-[state=closed]:tw-fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:tw-slide-in-from-bottom-full ", yL = oe(bL + "tw-m-density-action-gap-md", {
  variants: {
    toastType: {
      neutral: "tw-border-semantic-action-border-primary-weak tw-bg-semantic-action-background-neutral-white [&>div>div>h2]:tw-text-semantic-action-foreground-primary-strongest [&>div>span>svg]:tw-text-semantic-action-foreground-primary-default",
      info: "tw-border-semantic-action-border-info-weak tw-bg-semantic-action-background-info-weakest [&>div>div>h2]:tw-text-semantic-action-foreground-info-stronger [&>div>span>svg]:tw-text-semantic-action-foreground-info-weak",
      error: "tw-border-semantic-action-border-error-weak tw-bg-semantic-action-background-error-weakest [&>div>div>h2]:tw-text-semantic-action-foreground-error-stronger [&>div>span>svg]:tw-text-semantic-action-foreground-error-weak",
      warning: "tw-border-semantic-action-border-warning-weak tw-bg-semantic-action-background-warning-weakest [&>div>div>h2]:tw-text-semantic-action-foreground-warning-stronger [&>div>span>svg]:tw-text-semantic-action-foreground-warning-weak",
      success: "tw-border-semantic-action-border-success-weak tw-bg-semantic-action-background-success-weakest [&>div>div>h2]:tw-text-semantic-action-foreground-success-stronger [&>div>span>svg]:tw-text-semantic-action-foreground-success-weak"
    }
  }
}), xL = oe("", {
  variants: {
    position: {
      "top-right": "tw-top-0 tw-right-0 tw-flex-col",
      "top-left": "tw-top-0 tw-left-0 tw-flex-col",
      "bottom-right": "tw-bottom-0 tw-right-0 tw-flex-col-reverse",
      "bottom-left": "tw-bottom-0 tw-left-0 tw-flex-col-reverse"
    }
  }
}), SL = oe("", {
  variants: {
    toastType: {
      neutral: "tw-bg-semantic-action-foreground-primary-default",
      info: "tw-bg-semantic-action-foreground-info-default",
      error: "tw-bg-semantic-action-foreground-error-default",
      warning: "tw-bg-semantic-action-foreground-warning-default",
      success: "tw-bg-semantic-action-foreground-success-default"
    }
  }
}), CL = vL, Qy = q(
  ({ className: e, position: t = "bottom-right", ...n }, r) => /* @__PURE__ */ m(
    Yy,
    {
      ref: r,
      className: N(
        "tw-fixed tw-z-[100] tw-max-h-screen tw-w-full tw-p-4 md:tw-max-w-[420px]",
        xL({ position: t }),
        e
      ),
      ...n
    }
  )
);
Qy.displayName = Yy.displayName;
const Zy = q(
  ({
    className: e,
    toastType: t = "neutral",
    showLeftIcon: n = !0,
    icon: r,
    button: o = !1,
    description: a,
    duration: i = 5e3,
    ...s
  }, l) => /* @__PURE__ */ m(
    Ky,
    {
      ref: l,
      className: N(yL({ toastType: t }), e),
      duration: i,
      ...s
    }
  )
);
Zy.displayName = Ky.displayName;
const ex = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    Jy,
    {
      ref: n,
      className: N(
        "tw-text-foreground/50 hover:tw-text-foreground tw-absolute tw-right-2 tw-top-2 tw-rounded-md tw-opacity-0 tw-transition-opacity focus:tw-opacity-100 group-hover:tw-opacity-100 group-[.destructive]:tw-text-red-300 group-[.destructive]:hover:tw-text-red-50 group-[.destructive]:focus:tw-ring-red-400 group-[.destructive]:focus:tw-ring-offset-red-600 custom-button-focus-ring",
        e
      ),
      "toast-close": "",
      "aria-label": "close",
      ...t,
      children: /* @__PURE__ */ m(
        "div",
        { className: "tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-sm hover:tw-bg-semantic-action-background-neutral-weaker", children: /* @__PURE__ */ m(
          de,
          {
            icon: "xmark",
            className: "tw-size-density-action-height-md tw-justify-self-end "
          }
        ) }
      )
    }
  )
);
ex.displayName = Jy.displayName;
const tx = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    Kc,
    {
      ref: n,
      level: "h2",
      variant: "xxs",
      children: t.children,
      className: N("tw-pt-1")
    }
  )
);
tx.displayName = wL.displayName;
const nx = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    Xy,
    {
      ref: n,
      className: N("tw-body-md-regular ", e),
      ...t
    }
  )
);
nx.displayName = Xy.displayName;
const rx = ({ duration: e, toastType: t }) => /* @__PURE__ */ m(
  "div",
  { className: "tw-absolute tw-bottom-0 -tw-left-2 tw-w-full tw-h-1", children: /* @__PURE__ */ m(
    "div",
    {
      className: N(SL({ toastType: t }), "tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-animate-timeout-bar"),
      style: {
        animationDuration: `${e}ms`
      }
    }
  ) }
);
rx.displayName = "ToastTimeoutIndicator";
const EL = 1, kL = 1e6;
let ul = 0;
function RL() {
  return ul = (ul + 1) % Number.MAX_SAFE_INTEGER, ul.toString();
}
const dl = /* @__PURE__ */ new Map(), Vf = (e) => {
  if (dl.has(e))
    return;
  const t = setTimeout(() => {
    dl.delete(e), Mo({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, kL);
  dl.set(e, t);
}, PL = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, EL)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map(
          (n) => n.id === t.toast.id ? { ...n, ...t.toast } : n
        )
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return n ? Vf(n) : e.toasts.forEach((r) => {
        Vf(r.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, ri = [];
let oi = { toasts: [] };
function Mo(e) {
  oi = PL(oi, e), ri.forEach((t) => {
    t(oi);
  });
}
function NL({ ...e }) {
  const t = RL(), n = (o) => Mo({
    type: "UPDATE_TOAST",
    toast: { ...o, id: t }
  }), r = () => Mo({ type: "DISMISS_TOAST", toastId: t });
  return Mo({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (o) => {
        o || r();
      }
    }
  }), {
    id: t,
    dismiss: r,
    update: n
  };
}
function TL() {
  const [e, t] = ye(oi);
  return ke(() => (ri.push(t), () => {
    const n = ri.indexOf(t);
    n > -1 && ri.splice(n, 1);
  }), [e]), {
    ...e,
    toast: NL,
    dismiss: (n) => Mo({ type: "DISMISS_TOAST", toastId: n })
  };
}
function R4() {
  const { toasts: e } = TL();
  let t = "bottom-right";
  const n = {
    neutral: "car",
    info: "circle-info",
    error: "octagon-exclamation",
    warning: "triangle-exclamation",
    success: "circle-check"
  };
  return /* @__PURE__ */ ee(
    CL,
    { children: [
      e.map(function({
        id: r,
        title: o,
        description: a,
        toastType: i = "neutral",
        icon: s,
        showLeftIcon: l = !0,
        button: c,
        position: u = "bottom-right",
        actionButton: d,
        duration: f,
        showIndicator: p,
        ...h
      }) {
        return t = u, /* @__PURE__ */ ee(
          Zy,
          {
            description: a,
            toastType: i,
            ...h,
            children: [
              /* @__PURE__ */ ee(
                "div",
                { className: "tw-flex tw-items-start tw-gap-density-action-gap-md", children: [
                  l && /* @__PURE__ */ m(de, { icon: s || n[i], size: "xl" }),
                  /* @__PURE__ */ ee(
                    "div",
                    { className: "tw-grid tw-gap-density-action-gap-md ", children: [
                      o && /* @__PURE__ */ m(tx, { children: o }),
                      a ? /* @__PURE__ */ m(nx, { children: a }) : /* @__PURE__ */ m(
                        "p",
                        { className: "tw-text-red-600", children: "Please, provide a description" }
                      ),
                      c && /* @__PURE__ */ m(
                        "div",
                        { className: "tw-w-fit tw-pb-density-action-padding-2xs", children: /* @__PURE__ */ m(
                          pt,
                          {
                            size: "sm",
                            variant: "solid",
                            intent: i !== "error" ? "primary" : "destructive",
                            onClick: d,
                            children: c
                          }
                        ) }
                      )
                    ] }
                  ),
                  /* @__PURE__ */ m(ex, {})
                ] }
              ),
              p && f && /* @__PURE__ */ m(rx, { duration: f, toastType: i })
            ]
          },
          r
        );
      }),
      /* @__PURE__ */ m(Qy, { "data-testid": "toast-provider", position: t })
    ] }
  );
}
var _L = "Toggle", td = v.forwardRef((e, t) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: o, ...a } = e, [i = !1, s] = je({
    prop: n,
    onChange: o,
    defaultProp: r
  });
  return /* @__PURE__ */ m(
    ie.button,
    {
      type: "button",
      "aria-pressed": i,
      "data-state": i ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...a,
      ref: t,
      onClick: re(e.onClick, () => {
        e.disabled || s(!i);
      })
    }
  );
});
td.displayName = _L;
var ox = td;
const ax = oe("tw-inline-flex tw-items-center tw-justify-center tw-rounded-sm tw-text-sm tw-font-medium tw-transition-colors custom-button-focus-ring disabled:tw-pointer-events-none disabled:tw-opacity-50", {
  variants: {
    variant: {
      default: "",
      outline: "",
      joint: ""
    },
    size: {
      sm: "tw-h-density-action-height-sm tw-px-density-action-padding-sm tw-text-xs",
      default: "tw-h-density-action-height-md tw-px-density-action-padding-md",
      lg: "tw-h-density-action-height-lg tw-px-density-action-padding-lg"
    }
  },
  compoundVariants: [{
    variant: "default",
    class: "tw-bg-transparent hover:tw-bg-semantic-action-background-neutral-weakest hover:tw-text-semantic-action-foreground-neutral-strongest data-[state=on]:tw-bg-semantic-action-background-neutral-weaker data-[state=on]:tw-border-semantic-action-border-neutral-default data-[state=on]:tw-text-semantic-action-foreground-neutral-strongest data-[state=on]:tw-shadow-inner"
  }, {
    variant: "outline",
    class: "tw-border tw-border-semantic-action-border-neutral-weak tw-bg-transparent hover:tw-bg-semantic-action-background-neutral-weakest hover:tw-border-semantic-action-border-neutral-default data-[state=on]:tw-bg-semantic-action-background-neutral-weaker data-[state=on]:tw-border-semantic-action-border-neutral-default data-[state=on]:tw-text-semantic-action-foreground-neutral-strongest data-[state=on]:tw-shadow-inner"
  }, {
    variant: "joint",
    class: "tw-border-r tw-border-r-semantic-action-border-neutral-weak !tw-rounded-none last-of-type:tw-border-none tw-bg-transparent hover:tw-bg-semantic-action-background-neutral-weakest hover:tw-border-semantic-action-border-neutral-default data-[state=on]:tw-bg-semantic-action-background-neutral-weaker data-[state=on]:tw-border-semantic-action-border-neutral-default data-[state=on]:tw-text-semantic-action-foreground-neutral-strongest data-[state=on]:tw-shadow-inner"
  }],
  defaultVariants: {
    variant: "default",
    size: "default"
  }
}), IL = q(
  ({ className: e, variant: t, size: n, ...r }, o) => /* @__PURE__ */ m(
    ox,
    {
      ref: o,
      className: N(ax({ variant: t, size: n, className: e })),
      ...r
    }
  )
);
IL.displayName = ox.displayName;
var eo = "ToggleGroup", [ix, P4] = Ye(eo, [
  an
]), sx = an(), nd = B.forwardRef((e, t) => {
  const { type: n, ...r } = e;
  if (n === "single")
    return /* @__PURE__ */ m(ML, { ...r, ref: t });
  if (n === "multiple")
    return /* @__PURE__ */ m(OL, { ...r, ref: t });
  throw new Error(`Missing prop \`type\` expected on \`${eo}\``);
});
nd.displayName = eo;
var [lx, cx] = ix(eo), ML = B.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...a
  } = e, [i, s] = je({
    prop: n,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ m(
    lx,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: i ? [i] : [],
      onItemActivate: s,
      onItemDeactivate: B.useCallback(() => s(""), [s]),
      children: /* @__PURE__ */ m(ux, { ...a, ref: t })
    }
  );
}), OL = B.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...a
  } = e, [i = [], s] = je({
    prop: n,
    defaultProp: r,
    onChange: o
  }), l = B.useCallback(
    (u) => s((d = []) => [...d, u]),
    [s]
  ), c = B.useCallback(
    (u) => s((d = []) => d.filter((f) => f !== u)),
    [s]
  );
  return /* @__PURE__ */ m(
    lx,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: i,
      onItemActivate: l,
      onItemDeactivate: c,
      children: /* @__PURE__ */ m(ux, { ...a, ref: t })
    }
  );
});
nd.displayName = eo;
var [DL, AL] = ix(eo), ux = B.forwardRef(
  (e, t) => {
    const {
      __scopeToggleGroup: n,
      disabled: r = !1,
      rovingFocus: o = !0,
      orientation: a,
      dir: i,
      loop: s = !0,
      ...l
    } = e, c = sx(n), u = Ln(i), d = { role: "group", dir: u, ...l };
    return /* @__PURE__ */ m(DL, { scope: n, rovingFocus: o, disabled: r, children: o ? /* @__PURE__ */ m(
      la,
      {
        asChild: !0,
        ...c,
        orientation: a,
        dir: u,
        loop: s,
        children: /* @__PURE__ */ m(ie.div, { ...d, ref: t })
      }
    ) : /* @__PURE__ */ m(ie.div, { ...d, ref: t }) });
  }
), bi = "ToggleGroupItem", dx = B.forwardRef(
  (e, t) => {
    const n = cx(bi, e.__scopeToggleGroup), r = AL(bi, e.__scopeToggleGroup), o = sx(e.__scopeToggleGroup), a = n.value.includes(e.value), i = r.disabled || e.disabled, s = { ...e, pressed: a, disabled: i }, l = B.useRef(null);
    return r.rovingFocus ? /* @__PURE__ */ m(
      ca,
      {
        asChild: !0,
        ...o,
        focusable: !i,
        active: a,
        ref: l,
        children: /* @__PURE__ */ m(Bf, { ...s, ref: t })
      }
    ) : /* @__PURE__ */ m(Bf, { ...s, ref: t });
  }
);
dx.displayName = bi;
var Bf = B.forwardRef(
  (e, t) => {
    const { __scopeToggleGroup: n, value: r, ...o } = e, a = cx(bi, n), i = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, s = a.type === "single" ? i : void 0;
    return /* @__PURE__ */ m(
      td,
      {
        ...s,
        ...o,
        ref: t,
        onPressedChange: (l) => {
          l ? a.onItemActivate(r) : a.onItemDeactivate(r);
        }
      }
    );
  }
), fx = nd, px = dx;
const $L = oe("tw-inline-flex tw-items-center tw-justify-center tw-gap-1", {
  variants: {
    variant: {
      default: "",
      outline: "",
      joint: "tw-border tw-border-semantic-action-border-neutral-weak !tw-gap-0 tw-rounded !tw-rounded-sm "
    },
    align: {
      center: "tw-justify-center",
      start: "tw-justify-start",
      end: "tw-justify-end"
    }
  },
  defaultVariants: {
    align: "center"
  }
}), mx = bt(
  {
    size: "default",
    variant: "default"
  }
), LL = q(
  ({ className: e, variant: t, size: n, align: r, children: o, ...a }, i) => /* @__PURE__ */ m(
    fx,
    {
      ref: i,
      className: N($L({ align: r, variant: t, className: e })),
      ...a,
      children: /* @__PURE__ */ m(
        mx.Provider,
        { value: { variant: t, size: n }, children: o }
      )
    }
  )
);
LL.displayName = fx.displayName;
const FL = q(
  ({ className: e, children: t, variant: n, size: r, ...o }, a) => {
    const i = Xe(mx);
    return /* @__PURE__ */ m(
      px,
      {
        ref: a,
        className: N(
          ax({
            variant: i.variant || n,
            size: i.size || r
          }),
          e
        ),
        ...o,
        children: t
      }
    );
  }
);
FL.displayName = px.displayName;
var [us, N4] = Ye("Tooltip", [
  Fn
]), ds = Fn(), gx = "TooltipProvider", zL = 700, cc = "tooltip.open", [VL, rd] = us(gx), hx = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = zL,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: a
  } = e, [i, s] = v.useState(!0), l = v.useRef(!1), c = v.useRef(0);
  return v.useEffect(() => {
    const u = c.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ m(
    VL,
    {
      scope: t,
      isOpenDelayed: i,
      delayDuration: n,
      onOpen: v.useCallback(() => {
        window.clearTimeout(c.current), s(!1);
      }, []),
      onClose: v.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => s(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: l,
      onPointerInTransitChange: v.useCallback((u) => {
        l.current = u;
      }, []),
      disableHoverableContent: o,
      children: a
    }
  );
};
hx.displayName = gx;
var fs = "Tooltip", [BL, ps] = us(fs), vx = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o = !1,
    onOpenChange: a,
    disableHoverableContent: i,
    delayDuration: s
  } = e, l = rd(fs, e.__scopeTooltip), c = ds(t), [u, d] = v.useState(null), f = Te(), p = v.useRef(0), h = i ?? l.disableHoverableContent, g = s ?? l.delayDuration, w = v.useRef(!1), [b = !1, y] = je({
    prop: r,
    defaultProp: o,
    onChange: (E) => {
      E ? (l.onOpen(), document.dispatchEvent(new CustomEvent(cc))) : l.onClose(), a == null || a(E);
    }
  }), x = v.useMemo(() => b ? w.current ? "delayed-open" : "instant-open" : "closed", [b]), C = v.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, w.current = !1, y(!0);
  }, [y]), S = v.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, y(!1);
  }, [y]), R = v.useCallback(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      w.current = !0, y(!0), p.current = 0;
    }, g);
  }, [g, y]);
  return v.useEffect(() => () => {
    p.current && (window.clearTimeout(p.current), p.current = 0);
  }, []), /* @__PURE__ */ m(Qo, { ...c, children: /* @__PURE__ */ m(
    BL,
    {
      scope: t,
      contentId: f,
      open: b,
      stateAttribute: x,
      trigger: u,
      onTriggerChange: d,
      onTriggerEnter: v.useCallback(() => {
        l.isOpenDelayed ? R() : C();
      }, [l.isOpenDelayed, R, C]),
      onTriggerLeave: v.useCallback(() => {
        h ? S() : (window.clearTimeout(p.current), p.current = 0);
      }, [S, h]),
      onOpen: C,
      onClose: S,
      disableHoverableContent: h,
      children: n
    }
  ) });
};
vx.displayName = fs;
var uc = "TooltipTrigger", wx = v.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = ps(uc, n), a = rd(uc, n), i = ds(n), s = v.useRef(null), l = xe(t, s, o.onTriggerChange), c = v.useRef(!1), u = v.useRef(!1), d = v.useCallback(() => c.current = !1, []);
    return v.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ m(Zo, { asChild: !0, ...i, children: /* @__PURE__ */ m(
      ie.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: re(e.onPointerMove, (f) => {
          f.pointerType !== "touch" && !u.current && !a.isPointerInTransitRef.current && (o.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: re(e.onPointerLeave, () => {
          o.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: re(e.onPointerDown, () => {
          c.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: re(e.onFocus, () => {
          c.current || o.onOpen();
        }),
        onBlur: re(e.onBlur, o.onClose),
        onClick: re(e.onClick, o.onClose)
      }
    ) });
  }
);
wx.displayName = uc;
var HL = "TooltipPortal", [T4, WL] = us(HL, {
  forceMount: void 0
}), Br = "TooltipContent", bx = v.forwardRef(
  (e, t) => {
    const n = WL(Br, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...a } = e, i = ps(Br, e.__scopeTooltip);
    return /* @__PURE__ */ m(at, { present: r || i.open, children: i.disableHoverableContent ? /* @__PURE__ */ m(yx, { side: o, ...a, ref: t }) : /* @__PURE__ */ m(jL, { side: o, ...a, ref: t }) });
  }
), jL = v.forwardRef((e, t) => {
  const n = ps(Br, e.__scopeTooltip), r = rd(Br, e.__scopeTooltip), o = v.useRef(null), a = xe(t, o), [i, s] = v.useState(null), { trigger: l, onClose: c } = n, u = o.current, { onPointerInTransitChange: d } = r, f = v.useCallback(() => {
    s(null), d(!1);
  }, [d]), p = v.useCallback(
    (h, g) => {
      const w = h.currentTarget, b = { x: h.clientX, y: h.clientY }, y = qL(b, w.getBoundingClientRect()), x = YL(b, y), C = KL(g.getBoundingClientRect()), S = JL([...x, ...C]);
      s(S), d(!0);
    },
    [d]
  );
  return v.useEffect(() => () => f(), [f]), v.useEffect(() => {
    if (l && u) {
      const h = (w) => p(w, u), g = (w) => p(w, l);
      return l.addEventListener("pointerleave", h), u.addEventListener("pointerleave", g), () => {
        l.removeEventListener("pointerleave", h), u.removeEventListener("pointerleave", g);
      };
    }
  }, [l, u, p, f]), v.useEffect(() => {
    if (i) {
      const h = (g) => {
        const w = g.target, b = { x: g.clientX, y: g.clientY }, y = (l == null ? void 0 : l.contains(w)) || (u == null ? void 0 : u.contains(w)), x = !XL(b, i);
        y ? f() : x && (f(), c());
      };
      return document.addEventListener("pointermove", h), () => document.removeEventListener("pointermove", h);
    }
  }, [l, u, i, c, f]), /* @__PURE__ */ m(yx, { ...e, ref: a });
}), [GL, UL] = us(fs, { isInside: !1 }), yx = v.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      ...s
    } = e, l = ps(Br, n), c = ds(n), { onClose: u } = l;
    return v.useEffect(() => (document.addEventListener(cc, u), () => document.removeEventListener(cc, u)), [u]), v.useEffect(() => {
      if (l.trigger) {
        const d = (f) => {
          const p = f.target;
          p != null && p.contains(l.trigger) && u();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [l.trigger, u]), /* @__PURE__ */ m(
      dr,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: i,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ ee(
          Mi,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ m(_p, { children: r }),
              /* @__PURE__ */ m(GL, { scope: n, isInside: !0, children: /* @__PURE__ */ m(E2, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
bx.displayName = Br;
var xx = "TooltipArrow", Sx = v.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = ds(n);
    return UL(
      xx,
      n
    ).isInside ? null : /* @__PURE__ */ m(Oi, { ...o, ...r, ref: t });
  }
);
Sx.displayName = xx;
function qL(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function YL(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function KL(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function XL(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a].x, l = t[a].y, c = t[i].x, u = t[i].y;
    l > r != u > r && n < (c - s) * (r - l) / (u - l) + s && (o = !o);
  }
  return o;
}
function JL(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), QL(t);
}
function QL(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], i = t[t.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], i = n[n.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var ZL = hx, eF = vx, tF = wx, nF = bx, rF = Sx;
const oF = "tw-p-2 tw-bg-semantic-static-background-neutral-inverted tw-rounded-sm tw-productiveFluid-label-label-xs-medium tw-text-semantic-static-foreground-neutral-inverted tw-drop-shadow-lg custom-tooltip-max-width tw-text-pretty tw-text-xs tw-text-ellipsis tw-z-[100] ", aF = oe(oF, {
  variants: {
    color: {
      default: "",
      inverted: "tw-bg-semantic-static-background-neutral-default tw-text-semantic-static-foreground-neutral-default "
    }
  },
  defaultVariants: {
    color: "default"
  }
}), iF = "tw-fill-semantic-static-background-neutral-inverted tw-w-12tw-h-6 ", sF = oe(iF, {
  variants: {
    color: {
      default: "",
      inverted: "tw-fill-semantic-static-background-neutral-default "
    }
  },
  defaultVariants: {
    color: "default"
  }
}), lF = q(
  ({
    className: e,
    content: t,
    relativePosition: n,
    color: r = "default",
    delayDuration: o = 400,
    ...a
  }, i) => /* @__PURE__ */ m(
    ZL,
    { delayDuration: o, children: /* @__PURE__ */ ee(
      eF,
      { children: [
        /* @__PURE__ */ m(
          tF,
          { asChild: !0, children: a.children }
        ),
        /* @__PURE__ */ ee(
          nF,
          {
            role: "tooltip",
            tabIndex: -1,
            ref: i,
            side: n,
            sideOffset: 8,
            className: N(aF({ color: r }), e),
            ...a,
            children: [
              t,
              /* @__PURE__ */ m(rF, { className: N(sF({ color: r })) })
            ]
          }
        )
      ] }
    ) }
  )
);
lF.displayName = "Tooltip";
function Cx(e) {
  return (t) => typeof t === e;
}
var cF = Cx("function"), uF = (e) => e === null, Hf = (e) => Object.prototype.toString.call(e).slice(8, -1) === "RegExp", Wf = (e) => !dF(e) && !uF(e) && (cF(e) || typeof e == "object"), dF = Cx("undefined");
function fF(e, t) {
  const { length: n } = e;
  if (n !== t.length)
    return !1;
  for (let r = n; r-- !== 0; )
    if (!ut(e[r], t[r]))
      return !1;
  return !0;
}
function pF(e, t) {
  if (e.byteLength !== t.byteLength)
    return !1;
  const n = new DataView(e.buffer), r = new DataView(t.buffer);
  let o = e.byteLength;
  for (; o--; )
    if (n.getUint8(o) !== r.getUint8(o))
      return !1;
  return !0;
}
function mF(e, t) {
  if (e.size !== t.size)
    return !1;
  for (const n of e.entries())
    if (!t.has(n[0]))
      return !1;
  for (const n of e.entries())
    if (!ut(n[1], t.get(n[0])))
      return !1;
  return !0;
}
function gF(e, t) {
  if (e.size !== t.size)
    return !1;
  for (const n of e.entries())
    if (!t.has(n[0]))
      return !1;
  return !0;
}
function ut(e, t) {
  if (e === t)
    return !0;
  if (e && Wf(e) && t && Wf(t)) {
    if (e.constructor !== t.constructor)
      return !1;
    if (Array.isArray(e) && Array.isArray(t))
      return fF(e, t);
    if (e instanceof Map && t instanceof Map)
      return mF(e, t);
    if (e instanceof Set && t instanceof Set)
      return gF(e, t);
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t))
      return pF(e, t);
    if (Hf(e) && Hf(t))
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    const n = Object.keys(e), r = Object.keys(t);
    if (n.length !== r.length)
      return !1;
    for (let o = n.length; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, n[o]))
        return !1;
    for (let o = n.length; o-- !== 0; ) {
      const a = n[o];
      if (!(a === "_owner" && e.$$typeof) && !ut(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return Number.isNaN(e) && Number.isNaN(t) ? !0 : e === t;
}
var hF = [
  "Array",
  "ArrayBuffer",
  "AsyncFunction",
  "AsyncGenerator",
  "AsyncGeneratorFunction",
  "Date",
  "Error",
  "Function",
  "Generator",
  "GeneratorFunction",
  "HTMLElement",
  "Map",
  "Object",
  "Promise",
  "RegExp",
  "Set",
  "WeakMap",
  "WeakSet"
], vF = [
  "bigint",
  "boolean",
  "null",
  "number",
  "string",
  "symbol",
  "undefined"
];
function ms(e) {
  const t = Object.prototype.toString.call(e).slice(8, -1);
  if (/HTML\w+Element/.test(t))
    return "HTMLElement";
  if (wF(t))
    return t;
}
function Wt(e) {
  return (t) => ms(t) === e;
}
function wF(e) {
  return hF.includes(e);
}
function to(e) {
  return (t) => typeof t === e;
}
function bF(e) {
  return vF.includes(e);
}
var yF = [
  "innerHTML",
  "ownerDocument",
  "style",
  "attributes",
  "nodeValue"
];
function se(e) {
  if (e === null)
    return "null";
  switch (typeof e) {
    case "bigint":
      return "bigint";
    case "boolean":
      return "boolean";
    case "number":
      return "number";
    case "string":
      return "string";
    case "symbol":
      return "symbol";
    case "undefined":
      return "undefined";
  }
  if (se.array(e))
    return "Array";
  if (se.plainFunction(e))
    return "Function";
  const t = ms(e);
  return t || "Object";
}
se.array = Array.isArray;
se.arrayOf = (e, t) => !se.array(e) && !se.function(t) ? !1 : e.every((n) => t(n));
se.asyncGeneratorFunction = (e) => ms(e) === "AsyncGeneratorFunction";
se.asyncFunction = Wt("AsyncFunction");
se.bigint = to("bigint");
se.boolean = (e) => e === !0 || e === !1;
se.date = Wt("Date");
se.defined = (e) => !se.undefined(e);
se.domElement = (e) => se.object(e) && !se.plainObject(e) && e.nodeType === 1 && se.string(e.nodeName) && yF.every((t) => t in e);
se.empty = (e) => se.string(e) && e.length === 0 || se.array(e) && e.length === 0 || se.object(e) && !se.map(e) && !se.set(e) && Object.keys(e).length === 0 || se.set(e) && e.size === 0 || se.map(e) && e.size === 0;
se.error = Wt("Error");
se.function = to("function");
se.generator = (e) => se.iterable(e) && se.function(e.next) && se.function(e.throw);
se.generatorFunction = Wt("GeneratorFunction");
se.instanceOf = (e, t) => !e || !t ? !1 : Object.getPrototypeOf(e) === t.prototype;
se.iterable = (e) => !se.nullOrUndefined(e) && se.function(e[Symbol.iterator]);
se.map = Wt("Map");
se.nan = (e) => Number.isNaN(e);
se.null = (e) => e === null;
se.nullOrUndefined = (e) => se.null(e) || se.undefined(e);
se.number = (e) => to("number")(e) && !se.nan(e);
se.numericString = (e) => se.string(e) && e.length > 0 && !Number.isNaN(Number(e));
se.object = (e) => !se.nullOrUndefined(e) && (se.function(e) || typeof e == "object");
se.oneOf = (e, t) => se.array(e) ? e.indexOf(t) > -1 : !1;
se.plainFunction = Wt("Function");
se.plainObject = (e) => {
  if (ms(e) !== "Object")
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t === Object.getPrototypeOf({});
};
se.primitive = (e) => se.null(e) || bF(typeof e);
se.promise = Wt("Promise");
se.propertyOf = (e, t, n) => {
  if (!se.object(e) || !t)
    return !1;
  const r = e[t];
  return se.function(n) ? n(r) : se.defined(r);
};
se.regexp = Wt("RegExp");
se.set = Wt("Set");
se.string = to("string");
se.symbol = to("symbol");
se.undefined = to("undefined");
se.weakMap = Wt("WeakMap");
se.weakSet = Wt("WeakSet");
var ce = se;
function xF(...e) {
  return e.every((t) => ce.string(t) || ce.array(t) || ce.plainObject(t));
}
function SF(e, t, n) {
  return Ex(e, t) ? [e, t].every(ce.array) ? !e.some(Yf(n)) && t.some(Yf(n)) : [e, t].every(ce.plainObject) ? !Object.entries(e).some(qf(n)) && Object.entries(t).some(qf(n)) : t === n : !1;
}
function jf(e, t, n) {
  const { actual: r, key: o, previous: a, type: i } = n, s = Qt(e, o), l = Qt(t, o);
  let c = [s, l].every(ce.number) && (i === "increased" ? s < l : s > l);
  return ce.undefined(r) || (c = c && l === r), ce.undefined(a) || (c = c && s === a), c;
}
function Gf(e, t, n) {
  const { key: r, type: o, value: a } = n, i = Qt(e, r), s = Qt(t, r), l = o === "added" ? i : s, c = o === "added" ? s : i;
  if (!ce.nullOrUndefined(a)) {
    if (ce.defined(l)) {
      if (ce.array(l) || ce.plainObject(l))
        return SF(l, c, a);
    } else
      return ut(c, a);
    return !1;
  }
  return [i, s].every(ce.array) ? !c.every(od(l)) : [i, s].every(ce.plainObject) ? CF(Object.keys(l), Object.keys(c)) : ![i, s].every((u) => ce.primitive(u) && ce.defined(u)) && (o === "added" ? !ce.defined(i) && ce.defined(s) : ce.defined(i) && !ce.defined(s));
}
function Uf(e, t, { key: n } = {}) {
  let r = Qt(e, n), o = Qt(t, n);
  if (!Ex(r, o))
    throw new TypeError("Inputs have different types");
  if (!xF(r, o))
    throw new TypeError("Inputs don't have length");
  return [r, o].every(ce.plainObject) && (r = Object.keys(r), o = Object.keys(o)), [r, o];
}
function qf(e) {
  return ([t, n]) => ce.array(e) ? ut(e, n) || e.some((r) => ut(r, n) || ce.array(n) && od(n)(r)) : ce.plainObject(e) && e[t] ? !!e[t] && ut(e[t], n) : ut(e, n);
}
function CF(e, t) {
  return t.some((n) => !e.includes(n));
}
function Yf(e) {
  return (t) => ce.array(e) ? e.some((n) => ut(n, t) || ce.array(t) && od(t)(n)) : ut(e, t);
}
function bo(e, t) {
  return ce.array(e) ? e.some((n) => ut(n, t)) : ut(e, t);
}
function od(e) {
  return (t) => e.some((n) => ut(n, t));
}
function Ex(...e) {
  return e.every(ce.array) || e.every(ce.number) || e.every(ce.plainObject) || e.every(ce.string);
}
function Qt(e, t) {
  return ce.plainObject(e) || ce.array(e) ? ce.string(t) ? t.split(".").reduce((r, o) => r && r[o], e) : ce.number(t) ? e[t] : e : e;
}
function yi(e, t) {
  if ([e, t].some(ce.nullOrUndefined))
    throw new Error("Missing required parameters");
  if (![e, t].every((u) => ce.plainObject(u) || ce.array(u)))
    throw new Error("Expected plain objects or array");
  return { added: (u, d) => {
    try {
      return Gf(e, t, { key: u, type: "added", value: d });
    } catch {
      return !1;
    }
  }, changed: (u, d, f) => {
    try {
      const p = Qt(e, u), h = Qt(t, u), g = ce.defined(d), w = ce.defined(f);
      if (g || w) {
        const b = w ? bo(f, p) : !bo(d, p), y = bo(d, h);
        return b && y;
      }
      return [p, h].every(ce.array) || [p, h].every(ce.plainObject) ? !ut(p, h) : p !== h;
    } catch {
      return !1;
    }
  }, changedFrom: (u, d, f) => {
    if (!ce.defined(u))
      return !1;
    try {
      const p = Qt(e, u), h = Qt(t, u), g = ce.defined(f);
      return bo(d, p) && (g ? bo(f, h) : !g);
    } catch {
      return !1;
    }
  }, decreased: (u, d, f) => {
    if (!ce.defined(u))
      return !1;
    try {
      return jf(e, t, { key: u, actual: d, previous: f, type: "decreased" });
    } catch {
      return !1;
    }
  }, emptied: (u) => {
    try {
      const [d, f] = Uf(e, t, { key: u });
      return !!d.length && !f.length;
    } catch {
      return !1;
    }
  }, filled: (u) => {
    try {
      const [d, f] = Uf(e, t, { key: u });
      return !d.length && !!f.length;
    } catch {
      return !1;
    }
  }, increased: (u, d, f) => {
    if (!ce.defined(u))
      return !1;
    try {
      return jf(e, t, { key: u, actual: d, previous: f, type: "increased" });
    } catch {
      return !1;
    }
  }, removed: (u, d) => {
    try {
      return Gf(e, t, { key: u, type: "removed", value: d });
    } catch {
      return !1;
    }
  } };
}
var EF = new Error("Element already at target scroll position"), kF = new Error("Scroll cancelled"), RF = Math.min, Kf = Date.now, PF = {
  left: Xf("scrollLeft"),
  top: Xf("scrollTop")
};
function Xf(e) {
  return function(n, r, o, a) {
    o = o || {}, typeof o == "function" && (a = o, o = {}), typeof a != "function" && (a = TF);
    var i = Kf(), s = n[e], l = o.ease || NF, c = isNaN(o.duration) ? 350 : +o.duration, u = !1;
    return s === r ? a(EF, n[e]) : requestAnimationFrame(f), d;
    function d() {
      u = !0;
    }
    function f(p) {
      if (u) return a(kF, n[e]);
      var h = Kf(), g = RF(1, (h - i) / c), w = l(g);
      n[e] = w * (r - s) + s, g < 1 ? requestAnimationFrame(f) : requestAnimationFrame(function() {
        a(null, n[e]);
      });
    }
  };
}
function NF(e) {
  return 0.5 * (1 - Math.cos(Math.PI * e));
}
function TF() {
}
const _F = /* @__PURE__ */ Ko(PF);
var kx = { exports: {} };
(function(e) {
  (function(t, n) {
    e.exports ? e.exports = n() : t.Scrollparent = n();
  })(g0, function() {
    function t(r) {
      var o = getComputedStyle(r, null).getPropertyValue("overflow");
      return o.indexOf("scroll") > -1 || o.indexOf("auto") > -1;
    }
    function n(r) {
      if (r instanceof HTMLElement || r instanceof SVGElement) {
        for (var o = r.parentNode; o.parentNode; ) {
          if (t(o))
            return o;
          o = o.parentNode;
        }
        return document.scrollingElement || document.documentElement;
      }
    }
    return n;
  });
})(kx);
var IF = kx.exports;
const Rx = /* @__PURE__ */ Ko(IF);
var MF = function(e) {
  return Object.prototype.hasOwnProperty.call(e, "props");
}, OF = function(e, t) {
  return e + jo(t);
}, jo = function(e) {
  return e === null || typeof e == "boolean" || typeof e > "u" ? "" : typeof e == "number" ? e.toString() : typeof e == "string" ? e : Array.isArray(e) ? e.reduce(OF, "") : MF(e) && Object.prototype.hasOwnProperty.call(e.props, "children") ? jo(e.props.children) : "";
};
jo.default = jo;
var DF = jo;
const Jf = /* @__PURE__ */ Ko(DF);
var AF = function(t) {
  return $F(t) && !LF(t);
};
function $F(e) {
  return !!e && typeof e == "object";
}
function LF(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || VF(e);
}
var FF = typeof Symbol == "function" && Symbol.for, zF = FF ? Symbol.for("react.element") : 60103;
function VF(e) {
  return e.$$typeof === zF;
}
function BF(e) {
  return Array.isArray(e) ? [] : {};
}
function Go(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? Hr(BF(e), e, t) : e;
}
function HF(e, t, n) {
  return e.concat(t).map(function(r) {
    return Go(r, n);
  });
}
function WF(e, t) {
  if (!t.customMerge)
    return Hr;
  var n = t.customMerge(e);
  return typeof n == "function" ? n : Hr;
}
function jF(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.propertyIsEnumerable.call(e, t);
  }) : [];
}
function Qf(e) {
  return Object.keys(e).concat(jF(e));
}
function Px(e, t) {
  try {
    return t in e;
  } catch {
    return !1;
  }
}
function GF(e, t) {
  return Px(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}
function UF(e, t, n) {
  var r = {};
  return n.isMergeableObject(e) && Qf(e).forEach(function(o) {
    r[o] = Go(e[o], n);
  }), Qf(t).forEach(function(o) {
    GF(e, o) || (Px(e, o) && n.isMergeableObject(t[o]) ? r[o] = WF(o, n)(e[o], t[o], n) : r[o] = Go(t[o], n));
  }), r;
}
function Hr(e, t, n) {
  n = n || {}, n.arrayMerge = n.arrayMerge || HF, n.isMergeableObject = n.isMergeableObject || AF, n.cloneUnlessOtherwiseSpecified = Go;
  var r = Array.isArray(t), o = Array.isArray(e), a = r === o;
  return a ? r ? n.arrayMerge(e, t, n) : UF(e, t, n) : Go(t, n);
}
Hr.all = function(t, n) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(r, o) {
    return Hr(r, o, n);
  }, {});
};
var qF = Hr, YF = qF;
const Ot = /* @__PURE__ */ Ko(YF);
var dc = { exports: {} }, Ka = { exports: {} }, Ie = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zf;
function KF() {
  if (Zf) return Ie;
  Zf = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function x(S) {
    if (typeof S == "object" && S !== null) {
      var R = S.$$typeof;
      switch (R) {
        case t:
          switch (S = S.type, S) {
            case l:
            case c:
            case r:
            case a:
            case o:
            case d:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case s:
                case u:
                case h:
                case p:
                case i:
                  return S;
                default:
                  return R;
              }
          }
        case n:
          return R;
      }
    }
  }
  function C(S) {
    return x(S) === c;
  }
  return Ie.AsyncMode = l, Ie.ConcurrentMode = c, Ie.ContextConsumer = s, Ie.ContextProvider = i, Ie.Element = t, Ie.ForwardRef = u, Ie.Fragment = r, Ie.Lazy = h, Ie.Memo = p, Ie.Portal = n, Ie.Profiler = a, Ie.StrictMode = o, Ie.Suspense = d, Ie.isAsyncMode = function(S) {
    return C(S) || x(S) === l;
  }, Ie.isConcurrentMode = C, Ie.isContextConsumer = function(S) {
    return x(S) === s;
  }, Ie.isContextProvider = function(S) {
    return x(S) === i;
  }, Ie.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === t;
  }, Ie.isForwardRef = function(S) {
    return x(S) === u;
  }, Ie.isFragment = function(S) {
    return x(S) === r;
  }, Ie.isLazy = function(S) {
    return x(S) === h;
  }, Ie.isMemo = function(S) {
    return x(S) === p;
  }, Ie.isPortal = function(S) {
    return x(S) === n;
  }, Ie.isProfiler = function(S) {
    return x(S) === a;
  }, Ie.isStrictMode = function(S) {
    return x(S) === o;
  }, Ie.isSuspense = function(S) {
    return x(S) === d;
  }, Ie.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === r || S === c || S === a || S === o || S === d || S === f || typeof S == "object" && S !== null && (S.$$typeof === h || S.$$typeof === p || S.$$typeof === i || S.$$typeof === s || S.$$typeof === u || S.$$typeof === w || S.$$typeof === b || S.$$typeof === y || S.$$typeof === g);
  }, Ie.typeOf = x, Ie;
}
var Me = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ep;
function XF() {
  return ep || (ep = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function x(D) {
      return typeof D == "string" || typeof D == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      D === r || D === c || D === a || D === o || D === d || D === f || typeof D == "object" && D !== null && (D.$$typeof === h || D.$$typeof === p || D.$$typeof === i || D.$$typeof === s || D.$$typeof === u || D.$$typeof === w || D.$$typeof === b || D.$$typeof === y || D.$$typeof === g);
    }
    function C(D) {
      if (typeof D == "object" && D !== null) {
        var le = D.$$typeof;
        switch (le) {
          case t:
            var te = D.type;
            switch (te) {
              case l:
              case c:
              case r:
              case a:
              case o:
              case d:
                return te;
              default:
                var Se = te && te.$$typeof;
                switch (Se) {
                  case s:
                  case u:
                  case h:
                  case p:
                  case i:
                    return Se;
                  default:
                    return le;
                }
            }
          case n:
            return le;
        }
      }
    }
    var S = l, R = c, E = s, M = i, F = t, G = u, U = r, H = h, j = p, z = n, Z = a, Y = o, O = d, I = !1;
    function W(D) {
      return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(D) || C(D) === l;
    }
    function A(D) {
      return C(D) === c;
    }
    function K(D) {
      return C(D) === s;
    }
    function k(D) {
      return C(D) === i;
    }
    function $(D) {
      return typeof D == "object" && D !== null && D.$$typeof === t;
    }
    function P(D) {
      return C(D) === u;
    }
    function _(D) {
      return C(D) === r;
    }
    function V(D) {
      return C(D) === h;
    }
    function T(D) {
      return C(D) === p;
    }
    function L(D) {
      return C(D) === n;
    }
    function J(D) {
      return C(D) === a;
    }
    function Q(D) {
      return C(D) === o;
    }
    function ne(D) {
      return C(D) === d;
    }
    Me.AsyncMode = S, Me.ConcurrentMode = R, Me.ContextConsumer = E, Me.ContextProvider = M, Me.Element = F, Me.ForwardRef = G, Me.Fragment = U, Me.Lazy = H, Me.Memo = j, Me.Portal = z, Me.Profiler = Z, Me.StrictMode = Y, Me.Suspense = O, Me.isAsyncMode = W, Me.isConcurrentMode = A, Me.isContextConsumer = K, Me.isContextProvider = k, Me.isElement = $, Me.isForwardRef = P, Me.isFragment = _, Me.isLazy = V, Me.isMemo = T, Me.isPortal = L, Me.isProfiler = J, Me.isStrictMode = Q, Me.isSuspense = ne, Me.isValidElementType = x, Me.typeOf = C;
  }()), Me;
}
var tp;
function Nx() {
  return tp || (tp = 1, process.env.NODE_ENV === "production" ? Ka.exports = KF() : Ka.exports = XF()), Ka.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var fl, np;
function JF() {
  if (np) return fl;
  np = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(i).map(function(u) {
        return i[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return fl = o() ? Object.assign : function(a, i) {
    for (var s, l = r(a), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (e) {
        c = e(s);
        for (var f = 0; f < c.length; f++)
          n.call(s, c[f]) && (l[c[f]] = s[c[f]]);
      }
    }
    return l;
  }, fl;
}
var pl, rp;
function ad() {
  if (rp) return pl;
  rp = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return pl = e, pl;
}
var ml, op;
function Tx() {
  return op || (op = 1, ml = Function.call.bind(Object.prototype.hasOwnProperty)), ml;
}
var gl, ap;
function QF() {
  if (ap) return gl;
  ap = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = ad(), n = {}, r = Tx();
    e = function(a) {
      var i = "Warning: " + a;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(a, i, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in a)
        if (r(a, u)) {
          var d;
          try {
            if (typeof a[u] != "function") {
              var f = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = a[u](i, u, l, s, null, t);
          } catch (h) {
            d = h;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + s + " type: " + d.message + (p ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, gl = o, gl;
}
var hl, ip;
function ZF() {
  if (ip) return hl;
  ip = 1;
  var e = Nx(), t = JF(), n = ad(), r = Tx(), o = QF(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return hl = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(A) {
      var K = A && (c && A[c] || A[u]);
      if (typeof K == "function")
        return K;
    }
    var f = "<<anonymous>>", p = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: y(),
      arrayOf: x,
      element: C(),
      elementType: S(),
      instanceOf: R,
      node: G(),
      objectOf: M,
      oneOf: E,
      oneOfType: F,
      shape: H,
      exact: j
    };
    function h(A, K) {
      return A === K ? A !== 0 || 1 / A === 1 / K : A !== A && K !== K;
    }
    function g(A, K) {
      this.message = A, this.data = K && typeof K == "object" ? K : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function w(A) {
      if (process.env.NODE_ENV !== "production")
        var K = {}, k = 0;
      function $(_, V, T, L, J, Q, ne) {
        if (L = L || f, Q = Q || T, ne !== n) {
          if (l) {
            var D = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw D.name = "Invariant Violation", D;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var le = L + ":" + T;
            !K[le] && // Avoid spamming the console because they are often not actionable except for lib authors
            k < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + Q + "` prop on `" + L + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), K[le] = !0, k++);
          }
        }
        return V[T] == null ? _ ? V[T] === null ? new g("The " + J + " `" + Q + "` is marked as required " + ("in `" + L + "`, but its value is `null`.")) : new g("The " + J + " `" + Q + "` is marked as required in " + ("`" + L + "`, but its value is `undefined`.")) : null : A(V, T, L, J, Q);
      }
      var P = $.bind(null, !1);
      return P.isRequired = $.bind(null, !0), P;
    }
    function b(A) {
      function K(k, $, P, _, V, T) {
        var L = k[$], J = Y(L);
        if (J !== A) {
          var Q = O(L);
          return new g(
            "Invalid " + _ + " `" + V + "` of type " + ("`" + Q + "` supplied to `" + P + "`, expected ") + ("`" + A + "`."),
            { expectedType: A }
          );
        }
        return null;
      }
      return w(K);
    }
    function y() {
      return w(i);
    }
    function x(A) {
      function K(k, $, P, _, V) {
        if (typeof A != "function")
          return new g("Property `" + V + "` of component `" + P + "` has invalid PropType notation inside arrayOf.");
        var T = k[$];
        if (!Array.isArray(T)) {
          var L = Y(T);
          return new g("Invalid " + _ + " `" + V + "` of type " + ("`" + L + "` supplied to `" + P + "`, expected an array."));
        }
        for (var J = 0; J < T.length; J++) {
          var Q = A(T, J, P, _, V + "[" + J + "]", n);
          if (Q instanceof Error)
            return Q;
        }
        return null;
      }
      return w(K);
    }
    function C() {
      function A(K, k, $, P, _) {
        var V = K[k];
        if (!s(V)) {
          var T = Y(V);
          return new g("Invalid " + P + " `" + _ + "` of type " + ("`" + T + "` supplied to `" + $ + "`, expected a single ReactElement."));
        }
        return null;
      }
      return w(A);
    }
    function S() {
      function A(K, k, $, P, _) {
        var V = K[k];
        if (!e.isValidElementType(V)) {
          var T = Y(V);
          return new g("Invalid " + P + " `" + _ + "` of type " + ("`" + T + "` supplied to `" + $ + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return w(A);
    }
    function R(A) {
      function K(k, $, P, _, V) {
        if (!(k[$] instanceof A)) {
          var T = A.name || f, L = W(k[$]);
          return new g("Invalid " + _ + " `" + V + "` of type " + ("`" + L + "` supplied to `" + P + "`, expected ") + ("instance of `" + T + "`."));
        }
        return null;
      }
      return w(K);
    }
    function E(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), i;
      function K(k, $, P, _, V) {
        for (var T = k[$], L = 0; L < A.length; L++)
          if (h(T, A[L]))
            return null;
        var J = JSON.stringify(A, function(ne, D) {
          var le = O(D);
          return le === "symbol" ? String(D) : D;
        });
        return new g("Invalid " + _ + " `" + V + "` of value `" + String(T) + "` " + ("supplied to `" + P + "`, expected one of " + J + "."));
      }
      return w(K);
    }
    function M(A) {
      function K(k, $, P, _, V) {
        if (typeof A != "function")
          return new g("Property `" + V + "` of component `" + P + "` has invalid PropType notation inside objectOf.");
        var T = k[$], L = Y(T);
        if (L !== "object")
          return new g("Invalid " + _ + " `" + V + "` of type " + ("`" + L + "` supplied to `" + P + "`, expected an object."));
        for (var J in T)
          if (r(T, J)) {
            var Q = A(T, J, P, _, V + "." + J, n);
            if (Q instanceof Error)
              return Q;
          }
        return null;
      }
      return w(K);
    }
    function F(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var K = 0; K < A.length; K++) {
        var k = A[K];
        if (typeof k != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + I(k) + " at index " + K + "."
          ), i;
      }
      function $(P, _, V, T, L) {
        for (var J = [], Q = 0; Q < A.length; Q++) {
          var ne = A[Q], D = ne(P, _, V, T, L, n);
          if (D == null)
            return null;
          D.data && r(D.data, "expectedType") && J.push(D.data.expectedType);
        }
        var le = J.length > 0 ? ", expected one of type [" + J.join(", ") + "]" : "";
        return new g("Invalid " + T + " `" + L + "` supplied to " + ("`" + V + "`" + le + "."));
      }
      return w($);
    }
    function G() {
      function A(K, k, $, P, _) {
        return z(K[k]) ? null : new g("Invalid " + P + " `" + _ + "` supplied to " + ("`" + $ + "`, expected a ReactNode."));
      }
      return w(A);
    }
    function U(A, K, k, $, P) {
      return new g(
        (A || "React class") + ": " + K + " type `" + k + "." + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + P + "`."
      );
    }
    function H(A) {
      function K(k, $, P, _, V) {
        var T = k[$], L = Y(T);
        if (L !== "object")
          return new g("Invalid " + _ + " `" + V + "` of type `" + L + "` " + ("supplied to `" + P + "`, expected `object`."));
        for (var J in A) {
          var Q = A[J];
          if (typeof Q != "function")
            return U(P, _, V, J, O(Q));
          var ne = Q(T, J, P, _, V + "." + J, n);
          if (ne)
            return ne;
        }
        return null;
      }
      return w(K);
    }
    function j(A) {
      function K(k, $, P, _, V) {
        var T = k[$], L = Y(T);
        if (L !== "object")
          return new g("Invalid " + _ + " `" + V + "` of type `" + L + "` " + ("supplied to `" + P + "`, expected `object`."));
        var J = t({}, k[$], A);
        for (var Q in J) {
          var ne = A[Q];
          if (r(A, Q) && typeof ne != "function")
            return U(P, _, V, Q, O(ne));
          if (!ne)
            return new g(
              "Invalid " + _ + " `" + V + "` key `" + Q + "` supplied to `" + P + "`.\nBad object: " + JSON.stringify(k[$], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(A), null, "  ")
            );
          var D = ne(T, Q, P, _, V + "." + Q, n);
          if (D)
            return D;
        }
        return null;
      }
      return w(K);
    }
    function z(A) {
      switch (typeof A) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !A;
        case "object":
          if (Array.isArray(A))
            return A.every(z);
          if (A === null || s(A))
            return !0;
          var K = d(A);
          if (K) {
            var k = K.call(A), $;
            if (K !== A.entries) {
              for (; !($ = k.next()).done; )
                if (!z($.value))
                  return !1;
            } else
              for (; !($ = k.next()).done; ) {
                var P = $.value;
                if (P && !z(P[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Z(A, K) {
      return A === "symbol" ? !0 : K ? K["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && K instanceof Symbol : !1;
    }
    function Y(A) {
      var K = typeof A;
      return Array.isArray(A) ? "array" : A instanceof RegExp ? "object" : Z(K, A) ? "symbol" : K;
    }
    function O(A) {
      if (typeof A > "u" || A === null)
        return "" + A;
      var K = Y(A);
      if (K === "object") {
        if (A instanceof Date)
          return "date";
        if (A instanceof RegExp)
          return "regexp";
      }
      return K;
    }
    function I(A) {
      var K = O(A);
      switch (K) {
        case "array":
        case "object":
          return "an " + K;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + K;
        default:
          return K;
      }
    }
    function W(A) {
      return !A.constructor || !A.constructor.name ? f : A.constructor.name;
    }
    return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
  }, hl;
}
var vl, sp;
function e5() {
  if (sp) return vl;
  sp = 1;
  var e = ad();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, vl = function() {
    function r(i, s, l, c, u, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, vl;
}
if (process.env.NODE_ENV !== "production") {
  var t5 = Nx(), n5 = !0;
  dc.exports = ZF()(t5.isElement, n5);
} else
  dc.exports = e5()();
var r5 = dc.exports;
const ae = /* @__PURE__ */ Ko(r5);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var Sa = typeof window < "u" && typeof document < "u" && typeof navigator < "u", o5 = function() {
  for (var e = ["Edge", "Trident", "Firefox"], t = 0; t < e.length; t += 1)
    if (Sa && navigator.userAgent.indexOf(e[t]) >= 0)
      return 1;
  return 0;
}();
function a5(e) {
  var t = !1;
  return function() {
    t || (t = !0, window.Promise.resolve().then(function() {
      t = !1, e();
    }));
  };
}
function i5(e) {
  var t = !1;
  return function() {
    t || (t = !0, setTimeout(function() {
      t = !1, e();
    }, o5));
  };
}
var s5 = Sa && window.Promise, l5 = s5 ? a5 : i5;
function _x(e) {
  var t = {};
  return e && t.toString.call(e) === "[object Function]";
}
function mr(e, t) {
  if (e.nodeType !== 1)
    return [];
  var n = e.ownerDocument.defaultView, r = n.getComputedStyle(e, null);
  return t ? r[t] : r;
}
function id(e) {
  return e.nodeName === "HTML" ? e : e.parentNode || e.host;
}
function Ca(e) {
  if (!e)
    return document.body;
  switch (e.nodeName) {
    case "HTML":
    case "BODY":
      return e.ownerDocument.body;
    case "#document":
      return e.body;
  }
  var t = mr(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /(auto|scroll|overlay)/.test(n + o + r) ? e : Ca(id(e));
}
function Ix(e) {
  return e && e.referenceNode ? e.referenceNode : e;
}
var lp = Sa && !!(window.MSInputMethodContext && document.documentMode), cp = Sa && /MSIE 10/.test(navigator.userAgent);
function no(e) {
  return e === 11 ? lp : e === 10 ? cp : lp || cp;
}
function Wr(e) {
  if (!e)
    return document.documentElement;
  for (var t = no(10) ? document.body : null, n = e.offsetParent || null; n === t && e.nextElementSibling; )
    n = (e = e.nextElementSibling).offsetParent;
  var r = n && n.nodeName;
  return !r || r === "BODY" || r === "HTML" ? e ? e.ownerDocument.documentElement : document.documentElement : ["TH", "TD", "TABLE"].indexOf(n.nodeName) !== -1 && mr(n, "position") === "static" ? Wr(n) : n;
}
function c5(e) {
  var t = e.nodeName;
  return t === "BODY" ? !1 : t === "HTML" || Wr(e.firstElementChild) === e;
}
function fc(e) {
  return e.parentNode !== null ? fc(e.parentNode) : e;
}
function xi(e, t) {
  if (!e || !e.nodeType || !t || !t.nodeType)
    return document.documentElement;
  var n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING, r = n ? e : t, o = n ? t : e, a = document.createRange();
  a.setStart(r, 0), a.setEnd(o, 0);
  var i = a.commonAncestorContainer;
  if (e !== i && t !== i || r.contains(o))
    return c5(i) ? i : Wr(i);
  var s = fc(e);
  return s.host ? xi(s.host, t) : xi(e, fc(t).host);
}
function jr(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top", n = t === "top" ? "scrollTop" : "scrollLeft", r = e.nodeName;
  if (r === "BODY" || r === "HTML") {
    var o = e.ownerDocument.documentElement, a = e.ownerDocument.scrollingElement || o;
    return a[n];
  }
  return e[n];
}
function u5(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = jr(t, "top"), o = jr(t, "left"), a = n ? -1 : 1;
  return e.top += r * a, e.bottom += r * a, e.left += o * a, e.right += o * a, e;
}
function up(e, t) {
  var n = t === "x" ? "Left" : "Top", r = n === "Left" ? "Right" : "Bottom";
  return parseFloat(e["border" + n + "Width"]) + parseFloat(e["border" + r + "Width"]);
}
function dp(e, t, n, r) {
  return Math.max(t["offset" + e], t["scroll" + e], n["client" + e], n["offset" + e], n["scroll" + e], no(10) ? parseInt(n["offset" + e]) + parseInt(r["margin" + (e === "Height" ? "Top" : "Left")]) + parseInt(r["margin" + (e === "Height" ? "Bottom" : "Right")]) : 0);
}
function Mx(e) {
  var t = e.body, n = e.documentElement, r = no(10) && getComputedStyle(n);
  return {
    height: dp("Height", t, n, r),
    width: dp("Width", t, n, r)
  };
}
var d5 = function(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}, f5 = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}(), Gr = function(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}, Rt = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
};
function Dn(e) {
  return Rt({}, e, {
    right: e.left + e.width,
    bottom: e.top + e.height
  });
}
function pc(e) {
  var t = {};
  try {
    if (no(10)) {
      t = e.getBoundingClientRect();
      var n = jr(e, "top"), r = jr(e, "left");
      t.top += n, t.left += r, t.bottom += n, t.right += r;
    } else
      t = e.getBoundingClientRect();
  } catch {
  }
  var o = {
    left: t.left,
    top: t.top,
    width: t.right - t.left,
    height: t.bottom - t.top
  }, a = e.nodeName === "HTML" ? Mx(e.ownerDocument) : {}, i = a.width || e.clientWidth || o.width, s = a.height || e.clientHeight || o.height, l = e.offsetWidth - i, c = e.offsetHeight - s;
  if (l || c) {
    var u = mr(e);
    l -= up(u, "x"), c -= up(u, "y"), o.width -= l, o.height -= c;
  }
  return Dn(o);
}
function sd(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = no(10), o = t.nodeName === "HTML", a = pc(e), i = pc(t), s = Ca(e), l = mr(t), c = parseFloat(l.borderTopWidth), u = parseFloat(l.borderLeftWidth);
  n && o && (i.top = Math.max(i.top, 0), i.left = Math.max(i.left, 0));
  var d = Dn({
    top: a.top - i.top - c,
    left: a.left - i.left - u,
    width: a.width,
    height: a.height
  });
  if (d.marginTop = 0, d.marginLeft = 0, !r && o) {
    var f = parseFloat(l.marginTop), p = parseFloat(l.marginLeft);
    d.top -= c - f, d.bottom -= c - f, d.left -= u - p, d.right -= u - p, d.marginTop = f, d.marginLeft = p;
  }
  return (r && !n ? t.contains(s) : t === s && s.nodeName !== "BODY") && (d = u5(d, t)), d;
}
function p5(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = e.ownerDocument.documentElement, r = sd(e, n), o = Math.max(n.clientWidth, window.innerWidth || 0), a = Math.max(n.clientHeight, window.innerHeight || 0), i = t ? 0 : jr(n), s = t ? 0 : jr(n, "left"), l = {
    top: i - r.top + r.marginTop,
    left: s - r.left + r.marginLeft,
    width: o,
    height: a
  };
  return Dn(l);
}
function Ox(e) {
  var t = e.nodeName;
  if (t === "BODY" || t === "HTML")
    return !1;
  if (mr(e, "position") === "fixed")
    return !0;
  var n = id(e);
  return n ? Ox(n) : !1;
}
function Dx(e) {
  if (!e || !e.parentElement || no())
    return document.documentElement;
  for (var t = e.parentElement; t && mr(t, "transform") === "none"; )
    t = t.parentElement;
  return t || document.documentElement;
}
function ld(e, t, n, r) {
  var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, a = { top: 0, left: 0 }, i = o ? Dx(e) : xi(e, Ix(t));
  if (r === "viewport")
    a = p5(i, o);
  else {
    var s = void 0;
    r === "scrollParent" ? (s = Ca(id(t)), s.nodeName === "BODY" && (s = e.ownerDocument.documentElement)) : r === "window" ? s = e.ownerDocument.documentElement : s = r;
    var l = sd(s, i, o);
    if (s.nodeName === "HTML" && !Ox(i)) {
      var c = Mx(e.ownerDocument), u = c.height, d = c.width;
      a.top += l.top - l.marginTop, a.bottom = u + l.top, a.left += l.left - l.marginLeft, a.right = d + l.left;
    } else
      a = l;
  }
  n = n || 0;
  var f = typeof n == "number";
  return a.left += f ? n : n.left || 0, a.top += f ? n : n.top || 0, a.right -= f ? n : n.right || 0, a.bottom -= f ? n : n.bottom || 0, a;
}
function m5(e) {
  var t = e.width, n = e.height;
  return t * n;
}
function Ax(e, t, n, r, o) {
  var a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (e.indexOf("auto") === -1)
    return e;
  var i = ld(n, r, a, o), s = {
    top: {
      width: i.width,
      height: t.top - i.top
    },
    right: {
      width: i.right - t.right,
      height: i.height
    },
    bottom: {
      width: i.width,
      height: i.bottom - t.bottom
    },
    left: {
      width: t.left - i.left,
      height: i.height
    }
  }, l = Object.keys(s).map(function(f) {
    return Rt({
      key: f
    }, s[f], {
      area: m5(s[f])
    });
  }).sort(function(f, p) {
    return p.area - f.area;
  }), c = l.filter(function(f) {
    var p = f.width, h = f.height;
    return p >= n.clientWidth && h >= n.clientHeight;
  }), u = c.length > 0 ? c[0].key : l[0].key, d = e.split("-")[1];
  return u + (d ? "-" + d : "");
}
function $x(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, o = r ? Dx(t) : xi(t, Ix(n));
  return sd(n, o, r);
}
function Lx(e) {
  var t = e.ownerDocument.defaultView, n = t.getComputedStyle(e), r = parseFloat(n.marginTop || 0) + parseFloat(n.marginBottom || 0), o = parseFloat(n.marginLeft || 0) + parseFloat(n.marginRight || 0), a = {
    width: e.offsetWidth + o,
    height: e.offsetHeight + r
  };
  return a;
}
function Si(e) {
  var t = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return e.replace(/left|right|bottom|top/g, function(n) {
    return t[n];
  });
}
function Fx(e, t, n) {
  n = n.split("-")[0];
  var r = Lx(e), o = {
    width: r.width,
    height: r.height
  }, a = ["right", "left"].indexOf(n) !== -1, i = a ? "top" : "left", s = a ? "left" : "top", l = a ? "height" : "width", c = a ? "width" : "height";
  return o[i] = t[i] + t[l] / 2 - r[l] / 2, n === s ? o[s] = t[s] - r[c] : o[s] = t[Si(s)], o;
}
function Ea(e, t) {
  return Array.prototype.find ? e.find(t) : e.filter(t)[0];
}
function g5(e, t, n) {
  if (Array.prototype.findIndex)
    return e.findIndex(function(o) {
      return o[t] === n;
    });
  var r = Ea(e, function(o) {
    return o[t] === n;
  });
  return e.indexOf(r);
}
function zx(e, t, n) {
  var r = n === void 0 ? e : e.slice(0, g5(e, "name", n));
  return r.forEach(function(o) {
    o.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    var a = o.function || o.fn;
    o.enabled && _x(a) && (t.offsets.popper = Dn(t.offsets.popper), t.offsets.reference = Dn(t.offsets.reference), t = a(t, o));
  }), t;
}
function h5() {
  if (!this.state.isDestroyed) {
    var e = {
      instance: this,
      styles: {},
      arrowStyles: {},
      attributes: {},
      flipped: !1,
      offsets: {}
    };
    e.offsets.reference = $x(this.state, this.popper, this.reference, this.options.positionFixed), e.placement = Ax(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), e.originalPlacement = e.placement, e.positionFixed = this.options.positionFixed, e.offsets.popper = Fx(this.popper, e.offsets.reference, e.placement), e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", e = zx(this.modifiers, e), this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0, this.options.onCreate(e));
  }
}
function Vx(e, t) {
  return e.some(function(n) {
    var r = n.name, o = n.enabled;
    return o && r === t;
  });
}
function cd(e) {
  for (var t = [!1, "ms", "Webkit", "Moz", "O"], n = e.charAt(0).toUpperCase() + e.slice(1), r = 0; r < t.length; r++) {
    var o = t[r], a = o ? "" + o + n : e;
    if (typeof document.body.style[a] < "u")
      return a;
  }
  return null;
}
function v5() {
  return this.state.isDestroyed = !0, Vx(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[cd("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
}
function Bx(e) {
  var t = e.ownerDocument;
  return t ? t.defaultView : window;
}
function Hx(e, t, n, r) {
  var o = e.nodeName === "BODY", a = o ? e.ownerDocument.defaultView : e;
  a.addEventListener(t, n, { passive: !0 }), o || Hx(Ca(a.parentNode), t, n, r), r.push(a);
}
function w5(e, t, n, r) {
  n.updateBound = r, Bx(e).addEventListener("resize", n.updateBound, { passive: !0 });
  var o = Ca(e);
  return Hx(o, "scroll", n.updateBound, n.scrollParents), n.scrollElement = o, n.eventsEnabled = !0, n;
}
function b5() {
  this.state.eventsEnabled || (this.state = w5(this.reference, this.options, this.state, this.scheduleUpdate));
}
function y5(e, t) {
  return Bx(e).removeEventListener("resize", t.updateBound), t.scrollParents.forEach(function(n) {
    n.removeEventListener("scroll", t.updateBound);
  }), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, t;
}
function x5() {
  this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = y5(this.reference, this.state));
}
function ud(e) {
  return e !== "" && !isNaN(parseFloat(e)) && isFinite(e);
}
function mc(e, t) {
  Object.keys(t).forEach(function(n) {
    var r = "";
    ["width", "height", "top", "right", "bottom", "left"].indexOf(n) !== -1 && ud(t[n]) && (r = "px"), e.style[n] = t[n] + r;
  });
}
function S5(e, t) {
  Object.keys(t).forEach(function(n) {
    var r = t[n];
    r !== !1 ? e.setAttribute(n, t[n]) : e.removeAttribute(n);
  });
}
function C5(e) {
  return mc(e.instance.popper, e.styles), S5(e.instance.popper, e.attributes), e.arrowElement && Object.keys(e.arrowStyles).length && mc(e.arrowElement, e.arrowStyles), e;
}
function E5(e, t, n, r, o) {
  var a = $x(o, t, e, n.positionFixed), i = Ax(n.placement, a, t, e, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
  return t.setAttribute("x-placement", i), mc(t, { position: n.positionFixed ? "fixed" : "absolute" }), n;
}
function k5(e, t) {
  var n = e.offsets, r = n.popper, o = n.reference, a = Math.round, i = Math.floor, s = function(b) {
    return b;
  }, l = a(o.width), c = a(r.width), u = ["left", "right"].indexOf(e.placement) !== -1, d = e.placement.indexOf("-") !== -1, f = l % 2 === c % 2, p = l % 2 === 1 && c % 2 === 1, h = t ? u || d || f ? a : i : s, g = t ? a : s;
  return {
    left: h(p && !d && t ? r.left - 1 : r.left),
    top: g(r.top),
    bottom: g(r.bottom),
    right: h(r.right)
  };
}
var R5 = Sa && /Firefox/i.test(navigator.userAgent);
function P5(e, t) {
  var n = t.x, r = t.y, o = e.offsets.popper, a = Ea(e.instance.modifiers, function(x) {
    return x.name === "applyStyle";
  }).gpuAcceleration;
  a !== void 0 && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  var i = a !== void 0 ? a : t.gpuAcceleration, s = Wr(e.instance.popper), l = pc(s), c = {
    position: o.position
  }, u = k5(e, window.devicePixelRatio < 2 || !R5), d = n === "bottom" ? "top" : "bottom", f = r === "right" ? "left" : "right", p = cd("transform"), h = void 0, g = void 0;
  if (d === "bottom" ? s.nodeName === "HTML" ? g = -s.clientHeight + u.bottom : g = -l.height + u.bottom : g = u.top, f === "right" ? s.nodeName === "HTML" ? h = -s.clientWidth + u.right : h = -l.width + u.right : h = u.left, i && p)
    c[p] = "translate3d(" + h + "px, " + g + "px, 0)", c[d] = 0, c[f] = 0, c.willChange = "transform";
  else {
    var w = d === "bottom" ? -1 : 1, b = f === "right" ? -1 : 1;
    c[d] = g * w, c[f] = h * b, c.willChange = d + ", " + f;
  }
  var y = {
    "x-placement": e.placement
  };
  return e.attributes = Rt({}, y, e.attributes), e.styles = Rt({}, c, e.styles), e.arrowStyles = Rt({}, e.offsets.arrow, e.arrowStyles), e;
}
function Wx(e, t, n) {
  var r = Ea(e, function(s) {
    var l = s.name;
    return l === t;
  }), o = !!r && e.some(function(s) {
    return s.name === n && s.enabled && s.order < r.order;
  });
  if (!o) {
    var a = "`" + t + "`", i = "`" + n + "`";
    console.warn(i + " modifier is required by " + a + " modifier in order to work, be sure to include it before " + a + "!");
  }
  return o;
}
function N5(e, t) {
  var n;
  if (!Wx(e.instance.modifiers, "arrow", "keepTogether"))
    return e;
  var r = t.element;
  if (typeof r == "string") {
    if (r = e.instance.popper.querySelector(r), !r)
      return e;
  } else if (!e.instance.popper.contains(r))
    return console.warn("WARNING: `arrow.element` must be child of its popper element!"), e;
  var o = e.placement.split("-")[0], a = e.offsets, i = a.popper, s = a.reference, l = ["left", "right"].indexOf(o) !== -1, c = l ? "height" : "width", u = l ? "Top" : "Left", d = u.toLowerCase(), f = l ? "left" : "top", p = l ? "bottom" : "right", h = Lx(r)[c];
  s[p] - h < i[d] && (e.offsets.popper[d] -= i[d] - (s[p] - h)), s[d] + h > i[p] && (e.offsets.popper[d] += s[d] + h - i[p]), e.offsets.popper = Dn(e.offsets.popper);
  var g = s[d] + s[c] / 2 - h / 2, w = mr(e.instance.popper), b = parseFloat(w["margin" + u]), y = parseFloat(w["border" + u + "Width"]), x = g - e.offsets.popper[d] - b - y;
  return x = Math.max(Math.min(i[c] - h, x), 0), e.arrowElement = r, e.offsets.arrow = (n = {}, Gr(n, d, Math.round(x)), Gr(n, f, ""), n), e;
}
function T5(e) {
  return e === "end" ? "start" : e === "start" ? "end" : e;
}
var jx = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"], wl = jx.slice(3);
function fp(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = wl.indexOf(e), r = wl.slice(n + 1).concat(wl.slice(0, n));
  return t ? r.reverse() : r;
}
var bl = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function _5(e, t) {
  if (Vx(e.instance.modifiers, "inner") || e.flipped && e.placement === e.originalPlacement)
    return e;
  var n = ld(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed), r = e.placement.split("-")[0], o = Si(r), a = e.placement.split("-")[1] || "", i = [];
  switch (t.behavior) {
    case bl.FLIP:
      i = [r, o];
      break;
    case bl.CLOCKWISE:
      i = fp(r);
      break;
    case bl.COUNTERCLOCKWISE:
      i = fp(r, !0);
      break;
    default:
      i = t.behavior;
  }
  return i.forEach(function(s, l) {
    if (r !== s || i.length === l + 1)
      return e;
    r = e.placement.split("-")[0], o = Si(r);
    var c = e.offsets.popper, u = e.offsets.reference, d = Math.floor, f = r === "left" && d(c.right) > d(u.left) || r === "right" && d(c.left) < d(u.right) || r === "top" && d(c.bottom) > d(u.top) || r === "bottom" && d(c.top) < d(u.bottom), p = d(c.left) < d(n.left), h = d(c.right) > d(n.right), g = d(c.top) < d(n.top), w = d(c.bottom) > d(n.bottom), b = r === "left" && p || r === "right" && h || r === "top" && g || r === "bottom" && w, y = ["top", "bottom"].indexOf(r) !== -1, x = !!t.flipVariations && (y && a === "start" && p || y && a === "end" && h || !y && a === "start" && g || !y && a === "end" && w), C = !!t.flipVariationsByContent && (y && a === "start" && h || y && a === "end" && p || !y && a === "start" && w || !y && a === "end" && g), S = x || C;
    (f || b || S) && (e.flipped = !0, (f || b) && (r = i[l + 1]), S && (a = T5(a)), e.placement = r + (a ? "-" + a : ""), e.offsets.popper = Rt({}, e.offsets.popper, Fx(e.instance.popper, e.offsets.reference, e.placement)), e = zx(e.instance.modifiers, e, "flip"));
  }), e;
}
function I5(e) {
  var t = e.offsets, n = t.popper, r = t.reference, o = e.placement.split("-")[0], a = Math.floor, i = ["top", "bottom"].indexOf(o) !== -1, s = i ? "right" : "bottom", l = i ? "left" : "top", c = i ? "width" : "height";
  return n[s] < a(r[l]) && (e.offsets.popper[l] = a(r[l]) - n[c]), n[l] > a(r[s]) && (e.offsets.popper[l] = a(r[s])), e;
}
function M5(e, t, n, r) {
  var o = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), a = +o[1], i = o[2];
  if (!a)
    return e;
  if (i.indexOf("%") === 0) {
    var s = void 0;
    switch (i) {
      case "%p":
        s = n;
        break;
      case "%":
      case "%r":
      default:
        s = r;
    }
    var l = Dn(s);
    return l[t] / 100 * a;
  } else if (i === "vh" || i === "vw") {
    var c = void 0;
    return i === "vh" ? c = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : c = Math.max(document.documentElement.clientWidth, window.innerWidth || 0), c / 100 * a;
  } else
    return a;
}
function O5(e, t, n, r) {
  var o = [0, 0], a = ["right", "left"].indexOf(r) !== -1, i = e.split(/(\+|\-)/).map(function(u) {
    return u.trim();
  }), s = i.indexOf(Ea(i, function(u) {
    return u.search(/,|\s/) !== -1;
  }));
  i[s] && i[s].indexOf(",") === -1 && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  var l = /\s*,\s*|\s+/, c = s !== -1 ? [i.slice(0, s).concat([i[s].split(l)[0]]), [i[s].split(l)[1]].concat(i.slice(s + 1))] : [i];
  return c = c.map(function(u, d) {
    var f = (d === 1 ? !a : a) ? "height" : "width", p = !1;
    return u.reduce(function(h, g) {
      return h[h.length - 1] === "" && ["+", "-"].indexOf(g) !== -1 ? (h[h.length - 1] = g, p = !0, h) : p ? (h[h.length - 1] += g, p = !1, h) : h.concat(g);
    }, []).map(function(h) {
      return M5(h, f, t, n);
    });
  }), c.forEach(function(u, d) {
    u.forEach(function(f, p) {
      ud(f) && (o[d] += f * (u[p - 1] === "-" ? -1 : 1));
    });
  }), o;
}
function D5(e, t) {
  var n = t.offset, r = e.placement, o = e.offsets, a = o.popper, i = o.reference, s = r.split("-")[0], l = void 0;
  return ud(+n) ? l = [+n, 0] : l = O5(n, a, i, s), s === "left" ? (a.top += l[0], a.left -= l[1]) : s === "right" ? (a.top += l[0], a.left += l[1]) : s === "top" ? (a.left += l[0], a.top -= l[1]) : s === "bottom" && (a.left += l[0], a.top += l[1]), e.popper = a, e;
}
function A5(e, t) {
  var n = t.boundariesElement || Wr(e.instance.popper);
  e.instance.reference === n && (n = Wr(n));
  var r = cd("transform"), o = e.instance.popper.style, a = o.top, i = o.left, s = o[r];
  o.top = "", o.left = "", o[r] = "";
  var l = ld(e.instance.popper, e.instance.reference, t.padding, n, e.positionFixed);
  o.top = a, o.left = i, o[r] = s, t.boundaries = l;
  var c = t.priority, u = e.offsets.popper, d = {
    primary: function(p) {
      var h = u[p];
      return u[p] < l[p] && !t.escapeWithReference && (h = Math.max(u[p], l[p])), Gr({}, p, h);
    },
    secondary: function(p) {
      var h = p === "right" ? "left" : "top", g = u[h];
      return u[p] > l[p] && !t.escapeWithReference && (g = Math.min(u[h], l[p] - (p === "right" ? u.width : u.height))), Gr({}, h, g);
    }
  };
  return c.forEach(function(f) {
    var p = ["left", "top"].indexOf(f) !== -1 ? "primary" : "secondary";
    u = Rt({}, u, d[p](f));
  }), e.offsets.popper = u, e;
}
function $5(e) {
  var t = e.placement, n = t.split("-")[0], r = t.split("-")[1];
  if (r) {
    var o = e.offsets, a = o.reference, i = o.popper, s = ["bottom", "top"].indexOf(n) !== -1, l = s ? "left" : "top", c = s ? "width" : "height", u = {
      start: Gr({}, l, a[l]),
      end: Gr({}, l, a[l] + a[c] - i[c])
    };
    e.offsets.popper = Rt({}, i, u[r]);
  }
  return e;
}
function L5(e) {
  if (!Wx(e.instance.modifiers, "hide", "preventOverflow"))
    return e;
  var t = e.offsets.reference, n = Ea(e.instance.modifiers, function(r) {
    return r.name === "preventOverflow";
  }).boundaries;
  if (t.bottom < n.top || t.left > n.right || t.top > n.bottom || t.right < n.left) {
    if (e.hide === !0)
      return e;
    e.hide = !0, e.attributes["x-out-of-boundaries"] = "";
  } else {
    if (e.hide === !1)
      return e;
    e.hide = !1, e.attributes["x-out-of-boundaries"] = !1;
  }
  return e;
}
function F5(e) {
  var t = e.placement, n = t.split("-")[0], r = e.offsets, o = r.popper, a = r.reference, i = ["left", "right"].indexOf(n) !== -1, s = ["top", "left"].indexOf(n) === -1;
  return o[i ? "left" : "top"] = a[n] - (s ? o[i ? "width" : "height"] : 0), e.placement = Si(t), e.offsets.popper = Dn(o), e;
}
var z5 = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: $5
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: D5,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: A5,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ["left", "right", "top", "bottom"],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: "scrollParent"
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: I5
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: N5,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: "[x-arrow]"
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: _5,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: "flip",
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: "viewport",
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: !1,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: !1
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: !1,
    /** @prop {ModifierFn} */
    fn: F5
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: L5
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: P5,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: !0,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: "bottom",
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: "right"
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: C5,
    /** @prop {Function} */
    onLoad: E5,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: void 0
  }
}, V5 = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: "bottom",
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: !1,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: !0,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: !1,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function() {
  },
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function() {
  },
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: z5
}, Uo = function() {
  function e(t, n) {
    var r = this, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    d5(this, e), this.scheduleUpdate = function() {
      return requestAnimationFrame(r.update);
    }, this.update = l5(this.update.bind(this)), this.options = Rt({}, e.Defaults, o), this.state = {
      isDestroyed: !1,
      isCreated: !1,
      scrollParents: []
    }, this.reference = t && t.jquery ? t[0] : t, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(Rt({}, e.Defaults.modifiers, o.modifiers)).forEach(function(i) {
      r.options.modifiers[i] = Rt({}, e.Defaults.modifiers[i] || {}, o.modifiers ? o.modifiers[i] : {});
    }), this.modifiers = Object.keys(this.options.modifiers).map(function(i) {
      return Rt({
        name: i
      }, r.options.modifiers[i]);
    }).sort(function(i, s) {
      return i.order - s.order;
    }), this.modifiers.forEach(function(i) {
      i.enabled && _x(i.onLoad) && i.onLoad(r.reference, r.popper, r.options, i, r.state);
    }), this.update();
    var a = this.options.eventsEnabled;
    a && this.enableEventListeners(), this.state.eventsEnabled = a;
  }
  return f5(e, [{
    key: "update",
    value: function() {
      return h5.call(this);
    }
  }, {
    key: "destroy",
    value: function() {
      return v5.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function() {
      return b5.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function() {
      return x5.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */
    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]), e;
}();
Uo.Utils = (typeof window < "u" ? window : global).PopperUtils;
Uo.placements = jx;
Uo.Defaults = V5;
var B5 = [
  "innerHTML",
  "ownerDocument",
  "style",
  "attributes",
  "nodeValue"
], H5 = [
  "Array",
  "ArrayBuffer",
  "AsyncFunction",
  "AsyncGenerator",
  "AsyncGeneratorFunction",
  "Date",
  "Error",
  "Function",
  "Generator",
  "GeneratorFunction",
  "HTMLElement",
  "Map",
  "Object",
  "Promise",
  "RegExp",
  "Set",
  "WeakMap",
  "WeakSet"
], W5 = [
  "bigint",
  "boolean",
  "null",
  "number",
  "string",
  "symbol",
  "undefined"
];
function gs(e) {
  var t = Object.prototype.toString.call(e).slice(8, -1);
  if (/HTML\w+Element/.test(t))
    return "HTMLElement";
  if (j5(t))
    return t;
}
function jt(e) {
  return function(t) {
    return gs(t) === e;
  };
}
function j5(e) {
  return H5.includes(e);
}
function ro(e) {
  return function(t) {
    return typeof t === e;
  };
}
function G5(e) {
  return W5.includes(e);
}
function X(e) {
  if (e === null)
    return "null";
  switch (typeof e) {
    case "bigint":
      return "bigint";
    case "boolean":
      return "boolean";
    case "number":
      return "number";
    case "string":
      return "string";
    case "symbol":
      return "symbol";
    case "undefined":
      return "undefined";
  }
  if (X.array(e))
    return "Array";
  if (X.plainFunction(e))
    return "Function";
  var t = gs(e);
  return t || "Object";
}
X.array = Array.isArray;
X.arrayOf = function(e, t) {
  return !X.array(e) && !X.function(t) ? !1 : e.every(function(n) {
    return t(n);
  });
};
X.asyncGeneratorFunction = function(e) {
  return gs(e) === "AsyncGeneratorFunction";
};
X.asyncFunction = jt("AsyncFunction");
X.bigint = ro("bigint");
X.boolean = function(e) {
  return e === !0 || e === !1;
};
X.date = jt("Date");
X.defined = function(e) {
  return !X.undefined(e);
};
X.domElement = function(e) {
  return X.object(e) && !X.plainObject(e) && e.nodeType === 1 && X.string(e.nodeName) && B5.every(function(t) {
    return t in e;
  });
};
X.empty = function(e) {
  return X.string(e) && e.length === 0 || X.array(e) && e.length === 0 || X.object(e) && !X.map(e) && !X.set(e) && Object.keys(e).length === 0 || X.set(e) && e.size === 0 || X.map(e) && e.size === 0;
};
X.error = jt("Error");
X.function = ro("function");
X.generator = function(e) {
  return X.iterable(e) && X.function(e.next) && X.function(e.throw);
};
X.generatorFunction = jt("GeneratorFunction");
X.instanceOf = function(e, t) {
  return !e || !t ? !1 : Object.getPrototypeOf(e) === t.prototype;
};
X.iterable = function(e) {
  return !X.nullOrUndefined(e) && X.function(e[Symbol.iterator]);
};
X.map = jt("Map");
X.nan = function(e) {
  return Number.isNaN(e);
};
X.null = function(e) {
  return e === null;
};
X.nullOrUndefined = function(e) {
  return X.null(e) || X.undefined(e);
};
X.number = function(e) {
  return ro("number")(e) && !X.nan(e);
};
X.numericString = function(e) {
  return X.string(e) && e.length > 0 && !Number.isNaN(Number(e));
};
X.object = function(e) {
  return !X.nullOrUndefined(e) && (X.function(e) || typeof e == "object");
};
X.oneOf = function(e, t) {
  return X.array(e) ? e.indexOf(t) > -1 : !1;
};
X.plainFunction = jt("Function");
X.plainObject = function(e) {
  if (gs(e) !== "Object")
    return !1;
  var t = Object.getPrototypeOf(e);
  return t === null || t === Object.getPrototypeOf({});
};
X.primitive = function(e) {
  return X.null(e) || G5(typeof e);
};
X.promise = jt("Promise");
X.propertyOf = function(e, t, n) {
  if (!X.object(e) || !t)
    return !1;
  var r = e[t];
  return X.function(n) ? n(r) : X.defined(r);
};
X.regexp = jt("RegExp");
X.set = jt("Set");
X.string = ro("string");
X.symbol = ro("symbol");
X.undefined = ro("undefined");
X.weakMap = jt("WeakMap");
X.weakSet = jt("WeakSet");
function Gx(e) {
  return function(t) {
    return typeof t === e;
  };
}
var U5 = Gx("function"), q5 = function(e) {
  return e === null;
}, pp = function(e) {
  return Object.prototype.toString.call(e).slice(8, -1) === "RegExp";
}, mp = function(e) {
  return !Y5(e) && !q5(e) && (U5(e) || typeof e == "object");
}, Y5 = Gx("undefined"), gc = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function K5(e, t) {
  var n = e.length;
  if (n !== t.length)
    return !1;
  for (var r = n; r-- !== 0; )
    if (!ht(e[r], t[r]))
      return !1;
  return !0;
}
function X5(e, t) {
  if (e.byteLength !== t.byteLength)
    return !1;
  for (var n = new DataView(e.buffer), r = new DataView(t.buffer), o = e.byteLength; o--; )
    if (n.getUint8(o) !== r.getUint8(o))
      return !1;
  return !0;
}
function J5(e, t) {
  var n, r, o, a;
  if (e.size !== t.size)
    return !1;
  try {
    for (var i = gc(e.entries()), s = i.next(); !s.done; s = i.next()) {
      var l = s.value;
      if (!t.has(l[0]))
        return !1;
    }
  } catch (d) {
    n = { error: d };
  } finally {
    try {
      s && !s.done && (r = i.return) && r.call(i);
    } finally {
      if (n) throw n.error;
    }
  }
  try {
    for (var c = gc(e.entries()), u = c.next(); !u.done; u = c.next()) {
      var l = u.value;
      if (!ht(l[1], t.get(l[0])))
        return !1;
    }
  } catch (d) {
    o = { error: d };
  } finally {
    try {
      u && !u.done && (a = c.return) && a.call(c);
    } finally {
      if (o) throw o.error;
    }
  }
  return !0;
}
function Q5(e, t) {
  var n, r;
  if (e.size !== t.size)
    return !1;
  try {
    for (var o = gc(e.entries()), a = o.next(); !a.done; a = o.next()) {
      var i = a.value;
      if (!t.has(i[0]))
        return !1;
    }
  } catch (s) {
    n = { error: s };
  } finally {
    try {
      a && !a.done && (r = o.return) && r.call(o);
    } finally {
      if (n) throw n.error;
    }
  }
  return !0;
}
function ht(e, t) {
  if (e === t)
    return !0;
  if (e && mp(e) && t && mp(t)) {
    if (e.constructor !== t.constructor)
      return !1;
    if (Array.isArray(e) && Array.isArray(t))
      return K5(e, t);
    if (e instanceof Map && t instanceof Map)
      return J5(e, t);
    if (e instanceof Set && t instanceof Set)
      return Q5(e, t);
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t))
      return X5(e, t);
    if (pp(e) && pp(t))
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    var n = Object.keys(e), r = Object.keys(t);
    if (n.length !== r.length)
      return !1;
    for (var o = n.length; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, n[o]))
        return !1;
    for (var o = n.length; o-- !== 0; ) {
      var a = n[o];
      if (!(a === "_owner" && e.$$typeof) && !ht(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return Number.isNaN(e) && Number.isNaN(t) ? !0 : e === t;
}
function Z5() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.every(function(n) {
    return X.string(n) || X.array(n) || X.plainObject(n);
  });
}
function ez(e, t, n) {
  return Ux(e, t) ? [e, t].every(X.array) ? !e.some(bp(n)) && t.some(bp(n)) : [e, t].every(X.plainObject) ? !Object.entries(e).some(wp(n)) && Object.entries(t).some(wp(n)) : t === n : !1;
}
function gp(e, t, n) {
  var r = n.actual, o = n.key, a = n.previous, i = n.type, s = Zt(e, o), l = Zt(t, o), c = [s, l].every(X.number) && (i === "increased" ? s < l : s > l);
  return X.undefined(r) || (c = c && l === r), X.undefined(a) || (c = c && s === a), c;
}
function hp(e, t, n) {
  var r = n.key, o = n.type, a = n.value, i = Zt(e, r), s = Zt(t, r), l = o === "added" ? i : s, c = o === "added" ? s : i;
  if (!X.nullOrUndefined(a)) {
    if (X.defined(l)) {
      if (X.array(l) || X.plainObject(l))
        return ez(l, c, a);
    } else
      return ht(c, a);
    return !1;
  }
  return [i, s].every(X.array) ? !c.every(dd(l)) : [i, s].every(X.plainObject) ? tz(Object.keys(l), Object.keys(c)) : ![i, s].every(function(u) {
    return X.primitive(u) && X.defined(u);
  }) && (o === "added" ? !X.defined(i) && X.defined(s) : X.defined(i) && !X.defined(s));
}
function vp(e, t, n) {
  var r = n === void 0 ? {} : n, o = r.key, a = Zt(e, o), i = Zt(t, o);
  if (!Ux(a, i))
    throw new TypeError("Inputs have different types");
  if (!Z5(a, i))
    throw new TypeError("Inputs don't have length");
  return [a, i].every(X.plainObject) && (a = Object.keys(a), i = Object.keys(i)), [a, i];
}
function wp(e) {
  return function(t) {
    var n = t[0], r = t[1];
    return X.array(e) ? ht(e, r) || e.some(function(o) {
      return ht(o, r) || X.array(r) && dd(r)(o);
    }) : X.plainObject(e) && e[n] ? !!e[n] && ht(e[n], r) : ht(e, r);
  };
}
function tz(e, t) {
  return t.some(function(n) {
    return !e.includes(n);
  });
}
function bp(e) {
  return function(t) {
    return X.array(e) ? e.some(function(n) {
      return ht(n, t) || X.array(t) && dd(t)(n);
    }) : ht(e, t);
  };
}
function yo(e, t) {
  return X.array(e) ? e.some(function(n) {
    return ht(n, t);
  }) : ht(e, t);
}
function dd(e) {
  return function(t) {
    return e.some(function(n) {
      return ht(n, t);
    });
  };
}
function Ux() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.every(X.array) || e.every(X.number) || e.every(X.plainObject) || e.every(X.string);
}
function Zt(e, t) {
  if (X.plainObject(e) || X.array(e)) {
    if (X.string(t)) {
      var n = t.split(".");
      return n.reduce(function(r, o) {
        return r && r[o];
      }, e);
    }
    return X.number(t) ? e[t] : e;
  }
  return e;
}
function nz(e, t) {
  if ([e, t].some(X.nullOrUndefined))
    throw new Error("Missing required parameters");
  if (![e, t].every(function(d) {
    return X.plainObject(d) || X.array(d);
  }))
    throw new Error("Expected plain objects or array");
  var n = function(d, f) {
    try {
      return hp(e, t, { key: d, type: "added", value: f });
    } catch {
      return !1;
    }
  }, r = function(d, f, p) {
    try {
      var h = Zt(e, d), g = Zt(t, d), w = X.defined(f), b = X.defined(p);
      if (w || b) {
        var y = b ? yo(p, h) : !yo(f, h), x = yo(f, g);
        return y && x;
      }
      return [h, g].every(X.array) || [h, g].every(X.plainObject) ? !ht(h, g) : h !== g;
    } catch {
      return !1;
    }
  }, o = function(d, f, p) {
    if (!X.defined(d))
      return !1;
    try {
      var h = Zt(e, d), g = Zt(t, d), w = X.defined(p);
      return yo(f, h) && (w ? yo(p, g) : !w);
    } catch {
      return !1;
    }
  }, a = function(d, f) {
    return X.defined(d) ? (process.env.NODE_ENV === "development" && console.warn("`changedTo` is deprecated! Replace it with `change`"), r(d, f)) : !1;
  }, i = function(d, f, p) {
    if (!X.defined(d))
      return !1;
    try {
      return gp(e, t, { key: d, actual: f, previous: p, type: "decreased" });
    } catch {
      return !1;
    }
  }, s = function(d) {
    try {
      var f = vp(e, t, { key: d }), p = f[0], h = f[1];
      return !!p.length && !h.length;
    } catch {
      return !1;
    }
  }, l = function(d) {
    try {
      var f = vp(e, t, { key: d }), p = f[0], h = f[1];
      return !p.length && !!h.length;
    } catch {
      return !1;
    }
  }, c = function(d, f, p) {
    if (!X.defined(d))
      return !1;
    try {
      return gp(e, t, { key: d, actual: f, previous: p, type: "increased" });
    } catch {
      return !1;
    }
  }, u = function(d, f) {
    try {
      return hp(e, t, { key: d, type: "removed", value: f });
    } catch {
      return !1;
    }
  };
  return { added: n, changed: r, changedFrom: o, changedTo: a, decreased: i, emptied: s, filled: l, increased: c, removed: u };
}
function yp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Be(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yp(Object(n), !0).forEach(function(r) {
      rt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yp(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ka(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function rz(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Yx(r.key), r);
  }
}
function Ra(e, t, n) {
  return t && rz(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function rt(e, t, n) {
  return t = Yx(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Pa(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && hc(e, t);
}
function Ci(e) {
  return Ci = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ci(e);
}
function hc(e, t) {
  return hc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, hc(e, t);
}
function oz() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function az(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function qx(e, t) {
  if (e == null) return {};
  var n = az(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      r = a[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function dn(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function iz(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return dn(e);
}
function Na(e) {
  var t = oz();
  return function() {
    var r = Ci(e), o;
    if (t) {
      var a = Ci(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return iz(this, o);
  };
}
function sz(e, t) {
  if (typeof e != "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Yx(e) {
  var t = sz(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var lz = { flip: { padding: 20 }, preventOverflow: { padding: 10 } }, cz = "The typeValidator argument must be a function with the signature function(props, propName, componentName).", uz = "The error message is optional, but must be a string if provided.";
function dz(e, t, n, r) {
  return typeof e == "boolean" ? e : typeof e == "function" ? e(t, n, r) : e ? !!e : !1;
}
function fz(e, t) {
  return Object.hasOwnProperty.call(e, t);
}
function pz(e, t, n, r) {
  return new Error("Required ".concat(e[t], " `").concat(t, "` was not specified in `").concat(n, "`."));
}
function mz(e, t) {
  if (typeof e != "function")
    throw new TypeError(cz);
  if (t)
    throw new TypeError(uz);
}
function xp(e, t, n) {
  return mz(e, n), function(r, o, a) {
    for (var i = arguments.length, s = new Array(i > 3 ? i - 3 : 0), l = 3; l < i; l++)
      s[l - 3] = arguments[l];
    return dz(t, r, o, a) ? fz(r, o) ? e.apply(void 0, [r, o, a].concat(s)) : pz(r, o, a) : e.apply(void 0, [r, o, a].concat(s));
  };
}
var Re = { INIT: "init", IDLE: "idle", OPENING: "opening", OPEN: "open", CLOSING: "closing" }, xo = To.createPortal !== void 0;
function Yt() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function yl() {
  return "ontouchstart" in window && /Mobi/.test(navigator.userAgent);
}
function Xa(e) {
  var t = e.title, n = e.data, r = e.warn, o = r === void 0 ? !1 : r, a = e.debug, i = a === void 0 ? !1 : a, s = o ? console.warn || console.error : console.log;
  i && t && n && (console.groupCollapsed("%creact-floater: ".concat(t), "color: #9b00ff; font-weight: bold; font-size: 12px;"), Array.isArray(n) ? n.forEach(function(l) {
    X.plainObject(l) && l.key ? s.apply(console, [l.key, l.value]) : s.apply(console, [l]);
  }) : s.apply(console, [n]), console.groupEnd());
}
function gz(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  e.addEventListener(t, n, r);
}
function hz(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  e.removeEventListener(t, n, r);
}
function vz(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, o;
  o = function(i) {
    n(i), hz(e, t, o);
  }, gz(e, t, o, r);
}
function Sp() {
}
var Kx = /* @__PURE__ */ function(e) {
  Pa(n, e);
  var t = Na(n);
  function n() {
    return ka(this, n), t.apply(this, arguments);
  }
  return Ra(n, [{ key: "componentDidMount", value: function() {
    Yt() && (this.node || this.appendNode(), xo || this.renderPortal());
  } }, { key: "componentDidUpdate", value: function() {
    Yt() && (xo || this.renderPortal());
  } }, { key: "componentWillUnmount", value: function() {
    !Yt() || !this.node || (xo || To.unmountComponentAtNode(this.node), this.node && this.node.parentNode === document.body && (document.body.removeChild(this.node), this.node = void 0));
  } }, { key: "appendNode", value: function() {
    var o = this.props, a = o.id, i = o.zIndex;
    this.node || (this.node = document.createElement("div"), a && (this.node.id = a), i && (this.node.style.zIndex = i), document.body.appendChild(this.node));
  } }, { key: "renderPortal", value: function() {
    if (!Yt()) return null;
    var o = this.props, a = o.children, i = o.setRef;
    if (this.node || this.appendNode(), xo)
      return /* @__PURE__ */ To.createPortal(a, this.node);
    var s = To.unstable_renderSubtreeIntoContainer(this, a.length > 1 ? /* @__PURE__ */ B.createElement("div", null, a) : a[0], this.node);
    return i(s), null;
  } }, { key: "renderReact16", value: function() {
    var o = this.props, a = o.hasChildren, i = o.placement, s = o.target;
    return a ? this.renderPortal() : s || i === "center" ? this.renderPortal() : null;
  } }, { key: "render", value: function() {
    return xo ? this.renderReact16() : null;
  } }]), n;
}(B.Component);
rt(Kx, "propTypes", { children: ae.oneOfType([ae.element, ae.array]), hasChildren: ae.bool, id: ae.oneOfType([ae.string, ae.number]), placement: ae.string, setRef: ae.func.isRequired, target: ae.oneOfType([ae.object, ae.string]), zIndex: ae.number });
var Xx = /* @__PURE__ */ function(e) {
  Pa(n, e);
  var t = Na(n);
  function n() {
    return ka(this, n), t.apply(this, arguments);
  }
  return Ra(n, [{ key: "parentStyle", get: function() {
    var o = this.props, a = o.placement, i = o.styles, s = i.arrow.length, l = { pointerEvents: "none", position: "absolute", width: "100%" };
    return a.startsWith("top") ? (l.bottom = 0, l.left = 0, l.right = 0, l.height = s) : a.startsWith("bottom") ? (l.left = 0, l.right = 0, l.top = 0, l.height = s) : a.startsWith("left") ? (l.right = 0, l.top = 0, l.bottom = 0) : a.startsWith("right") && (l.left = 0, l.top = 0), l;
  } }, { key: "render", value: function() {
    var o = this.props, a = o.placement, i = o.setArrowRef, s = o.styles, l = s.arrow, c = l.color, u = l.display, d = l.length, f = l.margin, p = l.position, h = l.spread, g = { display: u, position: p }, w, b = h, y = d;
    return a.startsWith("top") ? (w = "0,0 ".concat(b / 2, ",").concat(y, " ").concat(b, ",0"), g.bottom = 0, g.marginLeft = f, g.marginRight = f) : a.startsWith("bottom") ? (w = "".concat(b, ",").concat(y, " ").concat(b / 2, ",0 0,").concat(y), g.top = 0, g.marginLeft = f, g.marginRight = f) : a.startsWith("left") ? (y = h, b = d, w = "0,0 ".concat(b, ",").concat(y / 2, " 0,").concat(y), g.right = 0, g.marginTop = f, g.marginBottom = f) : a.startsWith("right") && (y = h, b = d, w = "".concat(b, ",").concat(y, " ").concat(b, ",0 0,").concat(y / 2), g.left = 0, g.marginTop = f, g.marginBottom = f), /* @__PURE__ */ B.createElement("div", { className: "__floater__arrow", style: this.parentStyle }, /* @__PURE__ */ B.createElement("span", { ref: i, style: g }, /* @__PURE__ */ B.createElement("svg", { width: b, height: y, version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ B.createElement("polygon", { points: w, fill: c }))));
  } }]), n;
}(B.Component);
rt(Xx, "propTypes", { placement: ae.string.isRequired, setArrowRef: ae.func.isRequired, styles: ae.object.isRequired });
var wz = ["color", "height", "width"];
function Jx(e) {
  var t = e.handleClick, n = e.styles, r = n.color, o = n.height, a = n.width, i = qx(n, wz);
  return /* @__PURE__ */ B.createElement("button", { "aria-label": "close", onClick: t, style: i, type: "button" }, /* @__PURE__ */ B.createElement("svg", { width: "".concat(a, "px"), height: "".concat(o, "px"), viewBox: "0 0 18 18", version: "1.1", xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMid" }, /* @__PURE__ */ B.createElement("g", null, /* @__PURE__ */ B.createElement("path", { d: "M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z", fill: r }))));
}
Jx.propTypes = { handleClick: ae.func.isRequired, styles: ae.object.isRequired };
function Qx(e) {
  var t = e.content, n = e.footer, r = e.handleClick, o = e.open, a = e.positionWrapper, i = e.showCloseButton, s = e.title, l = e.styles, c = { content: /* @__PURE__ */ B.isValidElement(t) ? t : /* @__PURE__ */ B.createElement("div", { className: "__floater__content", style: l.content }, t) };
  return s && (c.title = /* @__PURE__ */ B.isValidElement(s) ? s : /* @__PURE__ */ B.createElement("div", { className: "__floater__title", style: l.title }, s)), n && (c.footer = /* @__PURE__ */ B.isValidElement(n) ? n : /* @__PURE__ */ B.createElement("div", { className: "__floater__footer", style: l.footer }, n)), (i || a) && !X.boolean(o) && (c.close = /* @__PURE__ */ B.createElement(Jx, { styles: l.close, handleClick: r })), /* @__PURE__ */ B.createElement("div", { className: "__floater__container", style: l.container }, c.close, c.title, c.content, c.footer);
}
Qx.propTypes = { content: ae.node.isRequired, footer: ae.node, handleClick: ae.func.isRequired, open: ae.bool, positionWrapper: ae.bool.isRequired, showCloseButton: ae.bool.isRequired, styles: ae.object.isRequired, title: ae.node };
var Zx = /* @__PURE__ */ function(e) {
  Pa(n, e);
  var t = Na(n);
  function n() {
    return ka(this, n), t.apply(this, arguments);
  }
  return Ra(n, [{ key: "style", get: function() {
    var o = this.props, a = o.disableAnimation, i = o.component, s = o.placement, l = o.hideArrow, c = o.status, u = o.styles, d = u.arrow.length, f = u.floater, p = u.floaterCentered, h = u.floaterClosing, g = u.floaterOpening, w = u.floaterWithAnimation, b = u.floaterWithComponent, y = {};
    return l || (s.startsWith("top") ? y.padding = "0 0 ".concat(d, "px") : s.startsWith("bottom") ? y.padding = "".concat(d, "px 0 0") : s.startsWith("left") ? y.padding = "0 ".concat(d, "px 0 0") : s.startsWith("right") && (y.padding = "0 0 0 ".concat(d, "px"))), [Re.OPENING, Re.OPEN].indexOf(c) !== -1 && (y = Be(Be({}, y), g)), c === Re.CLOSING && (y = Be(Be({}, y), h)), c === Re.OPEN && !a && (y = Be(Be({}, y), w)), s === "center" && (y = Be(Be({}, y), p)), i && (y = Be(Be({}, y), b)), Be(Be({}, f), y);
  } }, { key: "render", value: function() {
    var o = this.props, a = o.component, i = o.handleClick, s = o.hideArrow, l = o.setFloaterRef, c = o.status, u = {}, d = ["__floater"];
    return a ? /* @__PURE__ */ B.isValidElement(a) ? u.content = /* @__PURE__ */ B.cloneElement(a, { closeFn: i }) : u.content = a({ closeFn: i }) : u.content = /* @__PURE__ */ B.createElement(Qx, this.props), c === Re.OPEN && d.push("__floater__open"), s || (u.arrow = /* @__PURE__ */ B.createElement(Xx, this.props)), /* @__PURE__ */ B.createElement("div", { ref: l, className: d.join(" "), style: this.style }, /* @__PURE__ */ B.createElement("div", { className: "__floater__body" }, u.content, u.arrow));
  } }]), n;
}(B.Component);
rt(Zx, "propTypes", { component: ae.oneOfType([ae.func, ae.element]), content: ae.node, disableAnimation: ae.bool.isRequired, footer: ae.node, handleClick: ae.func.isRequired, hideArrow: ae.bool.isRequired, open: ae.bool, placement: ae.string.isRequired, positionWrapper: ae.bool.isRequired, setArrowRef: ae.func.isRequired, setFloaterRef: ae.func.isRequired, showCloseButton: ae.bool, status: ae.string.isRequired, styles: ae.object.isRequired, title: ae.node });
var e0 = /* @__PURE__ */ function(e) {
  Pa(n, e);
  var t = Na(n);
  function n() {
    return ka(this, n), t.apply(this, arguments);
  }
  return Ra(n, [{ key: "render", value: function() {
    var o = this.props, a = o.children, i = o.handleClick, s = o.handleMouseEnter, l = o.handleMouseLeave, c = o.setChildRef, u = o.setWrapperRef, d = o.style, f = o.styles, p;
    if (a)
      if (B.Children.count(a) === 1)
        if (!/* @__PURE__ */ B.isValidElement(a))
          p = /* @__PURE__ */ B.createElement("span", null, a);
        else {
          var h = X.function(a.type) ? "innerRef" : "ref";
          p = /* @__PURE__ */ B.cloneElement(B.Children.only(a), rt({}, h, c));
        }
      else
        p = a;
    return p ? /* @__PURE__ */ B.createElement("span", { ref: u, style: Be(Be({}, f), d), onClick: i, onMouseEnter: s, onMouseLeave: l }, p) : null;
  } }]), n;
}(B.Component);
rt(e0, "propTypes", { children: ae.node, handleClick: ae.func.isRequired, handleMouseEnter: ae.func.isRequired, handleMouseLeave: ae.func.isRequired, setChildRef: ae.func.isRequired, setWrapperRef: ae.func.isRequired, style: ae.object, styles: ae.object.isRequired });
var bz = { zIndex: 100 };
function yz(e) {
  var t = Ot(bz, e.options || {});
  return { wrapper: { cursor: "help", display: "inline-flex", flexDirection: "column", zIndex: t.zIndex }, wrapperPosition: { left: -1e3, position: "absolute", top: -1e3, visibility: "hidden" }, floater: { display: "inline-block", filter: "drop-shadow(0 0 3px rgba(0, 0, 0, 0.3))", maxWidth: 300, opacity: 0, position: "relative", transition: "opacity 0.3s", visibility: "hidden", zIndex: t.zIndex }, floaterOpening: { opacity: 1, visibility: "visible" }, floaterWithAnimation: { opacity: 1, transition: "opacity 0.3s, transform 0.2s", visibility: "visible" }, floaterWithComponent: { maxWidth: "100%" }, floaterClosing: { opacity: 0, visibility: "visible" }, floaterCentered: { left: "50%", position: "fixed", top: "50%", transform: "translate(-50%, -50%)" }, container: { backgroundColor: "#fff", color: "#666", minHeight: 60, minWidth: 200, padding: 20, position: "relative", zIndex: 10 }, title: { borderBottom: "1px solid #555", color: "#555", fontSize: 18, marginBottom: 5, paddingBottom: 6, paddingRight: 18 }, content: { fontSize: 15 }, close: { backgroundColor: "transparent", border: 0, borderRadius: 0, color: "#555", fontSize: 0, height: 15, outline: "none", padding: 10, position: "absolute", right: 0, top: 0, width: 15, WebkitAppearance: "none" }, footer: { borderTop: "1px solid #ccc", fontSize: 13, marginTop: 10, paddingTop: 5 }, arrow: { color: "#fff", display: "inline-flex", length: 16, margin: 8, position: "absolute", spread: 32 }, options: t };
}
var xz = ["arrow", "flip", "offset"], Sz = ["position", "top", "right", "bottom", "left"], fd = /* @__PURE__ */ function(e) {
  Pa(n, e);
  var t = Na(n);
  function n(r) {
    var o;
    return ka(this, n), o = t.call(this, r), rt(dn(o), "setArrowRef", function(a) {
      o.arrowRef = a;
    }), rt(dn(o), "setChildRef", function(a) {
      o.childRef = a;
    }), rt(dn(o), "setFloaterRef", function(a) {
      o.floaterRef = a;
    }), rt(dn(o), "setWrapperRef", function(a) {
      o.wrapperRef = a;
    }), rt(dn(o), "handleTransitionEnd", function() {
      var a = o.state.status, i = o.props.callback;
      o.wrapperPopper && o.wrapperPopper.instance.update(), o.setState({ status: a === Re.OPENING ? Re.OPEN : Re.IDLE }, function() {
        var s = o.state.status;
        i(s === Re.OPEN ? "open" : "close", o.props);
      });
    }), rt(dn(o), "handleClick", function() {
      var a = o.props, i = a.event, s = a.open;
      if (!X.boolean(s)) {
        var l = o.state, c = l.positionWrapper, u = l.status;
        (o.event === "click" || o.event === "hover" && c) && (Xa({ title: "click", data: [{ event: i, status: u === Re.OPEN ? "closing" : "opening" }], debug: o.debug }), o.toggle());
      }
    }), rt(dn(o), "handleMouseEnter", function() {
      var a = o.props, i = a.event, s = a.open;
      if (!(X.boolean(s) || yl())) {
        var l = o.state.status;
        o.event === "hover" && l === Re.IDLE && (Xa({ title: "mouseEnter", data: [{ key: "originalEvent", value: i }], debug: o.debug }), clearTimeout(o.eventDelayTimeout), o.toggle());
      }
    }), rt(dn(o), "handleMouseLeave", function() {
      var a = o.props, i = a.event, s = a.eventDelay, l = a.open;
      if (!(X.boolean(l) || yl())) {
        var c = o.state, u = c.status, d = c.positionWrapper;
        o.event === "hover" && (Xa({ title: "mouseLeave", data: [{ key: "originalEvent", value: i }], debug: o.debug }), s ? [Re.OPENING, Re.OPEN].indexOf(u) !== -1 && !d && !o.eventDelayTimeout && (o.eventDelayTimeout = setTimeout(function() {
          delete o.eventDelayTimeout, o.toggle();
        }, s * 1e3)) : o.toggle(Re.IDLE));
      }
    }), o.state = { currentPlacement: r.placement, needsUpdate: !1, positionWrapper: r.wrapperOptions.position && !!r.target, status: Re.INIT, statusWrapper: Re.INIT }, o._isMounted = !1, o.hasMounted = !1, Yt() && window.addEventListener("load", function() {
      o.popper && o.popper.instance.update(), o.wrapperPopper && o.wrapperPopper.instance.update();
    }), o;
  }
  return Ra(n, [{ key: "componentDidMount", value: function() {
    if (Yt()) {
      var o = this.state.positionWrapper, a = this.props, i = a.children, s = a.open, l = a.target;
      this._isMounted = !0, Xa({ title: "init", data: { hasChildren: !!i, hasTarget: !!l, isControlled: X.boolean(s), positionWrapper: o, target: this.target, floater: this.floaterRef }, debug: this.debug }), this.hasMounted || (this.initPopper(), this.hasMounted = !0), !i && l && X.boolean(s);
    }
  } }, { key: "componentDidUpdate", value: function(o, a) {
    if (Yt()) {
      var i = this.props, s = i.autoOpen, l = i.open, c = i.target, u = i.wrapperOptions, d = nz(a, this.state), f = d.changedFrom, p = d.changed;
      if (o.open !== l) {
        var h;
        X.boolean(l) && (h = l ? Re.OPENING : Re.CLOSING), this.toggle(h);
      }
      (o.wrapperOptions.position !== u.position || o.target !== c) && this.changeWrapperPosition(this.props), p("status", Re.IDLE) && l ? this.toggle(Re.OPEN) : f("status", Re.INIT, Re.IDLE) && s && this.toggle(Re.OPEN), this.popper && p("status", Re.OPENING) && this.popper.instance.update(), this.floaterRef && (p("status", Re.OPENING) || p("status", Re.CLOSING)) && vz(this.floaterRef, "transitionend", this.handleTransitionEnd), p("needsUpdate", !0) && this.rebuildPopper();
    }
  } }, { key: "componentWillUnmount", value: function() {
    Yt() && (this._isMounted = !1, this.popper && this.popper.instance.destroy(), this.wrapperPopper && this.wrapperPopper.instance.destroy());
  } }, { key: "initPopper", value: function() {
    var o = this, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.target, i = this.state.positionWrapper, s = this.props, l = s.disableFlip, c = s.getPopper, u = s.hideArrow, d = s.offset, f = s.placement, p = s.wrapperOptions, h = f === "top" || f === "bottom" ? "flip" : ["right", "bottom-end", "top-end", "left", "top-start", "bottom-start"];
    if (f === "center")
      this.setState({ status: Re.IDLE });
    else if (a && this.floaterRef) {
      var g = this.options, w = g.arrow, b = g.flip, y = g.offset, x = qx(g, xz);
      new Uo(a, this.floaterRef, { placement: f, modifiers: Be({ arrow: Be({ enabled: !u, element: this.arrowRef }, w), flip: Be({ enabled: !l, behavior: h }, b), offset: Be({ offset: "0, ".concat(d, "px") }, y) }, x), onCreate: function(R) {
        var E;
        if (o.popper = R, !((E = o.floaterRef) !== null && E !== void 0 && E.isConnected)) {
          o.setState({ needsUpdate: !0 });
          return;
        }
        c(R, "floater"), o._isMounted && o.setState({ currentPlacement: R.placement, status: Re.IDLE }), f !== R.placement && setTimeout(function() {
          R.instance.update();
        }, 1);
      }, onUpdate: function(R) {
        o.popper = R;
        var E = o.state.currentPlacement;
        o._isMounted && R.placement !== E && o.setState({ currentPlacement: R.placement });
      } });
    }
    if (i) {
      var C = X.undefined(p.offset) ? 0 : p.offset;
      new Uo(this.target, this.wrapperRef, { placement: p.placement || f, modifiers: { arrow: { enabled: !1 }, offset: { offset: "0, ".concat(C, "px") }, flip: { enabled: !1 } }, onCreate: function(R) {
        o.wrapperPopper = R, o._isMounted && o.setState({ statusWrapper: Re.IDLE }), c(R, "wrapper"), f !== R.placement && setTimeout(function() {
          R.instance.update();
        }, 1);
      } });
    }
  } }, { key: "rebuildPopper", value: function() {
    var o = this;
    this.floaterRefInterval = setInterval(function() {
      var a;
      (a = o.floaterRef) !== null && a !== void 0 && a.isConnected && (clearInterval(o.floaterRefInterval), o.setState({ needsUpdate: !1 }), o.initPopper());
    }, 50);
  } }, { key: "changeWrapperPosition", value: function(o) {
    var a = o.target, i = o.wrapperOptions;
    this.setState({ positionWrapper: i.position && !!a });
  } }, { key: "toggle", value: function(o) {
    var a = this.state.status, i = a === Re.OPEN ? Re.CLOSING : Re.OPENING;
    X.undefined(o) || (i = o), this.setState({ status: i });
  } }, { key: "debug", get: function() {
    var o = this.props.debug;
    return o || Yt() && "ReactFloaterDebug" in window && !!window.ReactFloaterDebug;
  } }, { key: "event", get: function() {
    var o = this.props, a = o.disableHoverToClick, i = o.event;
    return i === "hover" && yl() && !a ? "click" : i;
  } }, { key: "options", get: function() {
    var o = this.props.options;
    return Ot(lz, o || {});
  } }, { key: "styles", get: function() {
    var o = this, a = this.state, i = a.status, s = a.positionWrapper, l = a.statusWrapper, c = this.props.styles, u = Ot(yz(c), c);
    if (s) {
      var d;
      [Re.IDLE].indexOf(i) === -1 || [Re.IDLE].indexOf(l) === -1 ? d = u.wrapperPosition : d = this.wrapperPopper.styles, u.wrapper = Be(Be({}, u.wrapper), d);
    }
    if (this.target) {
      var f = window.getComputedStyle(this.target);
      this.wrapperStyles ? u.wrapper = Be(Be({}, u.wrapper), this.wrapperStyles) : ["relative", "static"].indexOf(f.position) === -1 && (this.wrapperStyles = {}, s || (Sz.forEach(function(p) {
        o.wrapperStyles[p] = f[p];
      }), u.wrapper = Be(Be({}, u.wrapper), this.wrapperStyles), this.target.style.position = "relative", this.target.style.top = "auto", this.target.style.right = "auto", this.target.style.bottom = "auto", this.target.style.left = "auto"));
    }
    return u;
  } }, { key: "target", get: function() {
    if (!Yt()) return null;
    var o = this.props.target;
    return o ? X.domElement(o) ? o : document.querySelector(o) : this.childRef || this.wrapperRef;
  } }, { key: "render", value: function() {
    var o = this.state, a = o.currentPlacement, i = o.positionWrapper, s = o.status, l = this.props, c = l.children, u = l.component, d = l.content, f = l.disableAnimation, p = l.footer, h = l.hideArrow, g = l.id, w = l.open, b = l.showCloseButton, y = l.style, x = l.target, C = l.title, S = /* @__PURE__ */ B.createElement(e0, { handleClick: this.handleClick, handleMouseEnter: this.handleMouseEnter, handleMouseLeave: this.handleMouseLeave, setChildRef: this.setChildRef, setWrapperRef: this.setWrapperRef, style: y, styles: this.styles.wrapper }, c), R = {};
    return i ? R.wrapperInPortal = S : R.wrapperAsChildren = S, /* @__PURE__ */ B.createElement("span", null, /* @__PURE__ */ B.createElement(Kx, { hasChildren: !!c, id: g, placement: a, setRef: this.setFloaterRef, target: x, zIndex: this.styles.options.zIndex }, /* @__PURE__ */ B.createElement(Zx, { component: u, content: d, disableAnimation: f, footer: p, handleClick: this.handleClick, hideArrow: h || a === "center", open: w, placement: a, positionWrapper: i, setArrowRef: this.setArrowRef, setFloaterRef: this.setFloaterRef, showCloseButton: b, status: s, styles: this.styles, title: C }), R.wrapperInPortal), R.wrapperAsChildren);
  } }]), n;
}(B.Component);
rt(fd, "propTypes", { autoOpen: ae.bool, callback: ae.func, children: ae.node, component: xp(ae.oneOfType([ae.func, ae.element]), function(e) {
  return !e.content;
}), content: xp(ae.node, function(e) {
  return !e.component;
}), debug: ae.bool, disableAnimation: ae.bool, disableFlip: ae.bool, disableHoverToClick: ae.bool, event: ae.oneOf(["hover", "click"]), eventDelay: ae.number, footer: ae.node, getPopper: ae.func, hideArrow: ae.bool, id: ae.oneOfType([ae.string, ae.number]), offset: ae.number, open: ae.bool, options: ae.object, placement: ae.oneOf(["top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "left", "left-start", "left-end", "right", "right-start", "right-end", "auto", "center"]), showCloseButton: ae.bool, style: ae.object, styles: ae.object, target: ae.oneOfType([ae.object, ae.string]), title: ae.node, wrapperOptions: ae.shape({ offset: ae.number, placement: ae.oneOf(["top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "left", "left-start", "left-end", "right", "right-start", "right-end", "auto"]), position: ae.bool }) });
rt(fd, "defaultProps", { autoOpen: !1, callback: Sp, debug: !1, disableAnimation: !1, disableFlip: !1, disableHoverToClick: !1, event: "click", eventDelay: 0.4, getPopper: Sp, hideArrow: !1, offset: 15, placement: "bottom", showCloseButton: !1, styles: {}, target: null, wrapperOptions: { position: !1 } });
var Cz = Object.defineProperty, Ez = (e, t, n) => t in e ? Cz(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, ue = (e, t, n) => Ez(e, typeof t != "symbol" ? t + "" : t, n), Oe = {
  INIT: "init",
  START: "start",
  STOP: "stop",
  RESET: "reset",
  PREV: "prev",
  NEXT: "next",
  GO: "go",
  CLOSE: "close",
  SKIP: "skip",
  UPDATE: "update"
}, Mt = {
  TOUR_START: "tour:start",
  STEP_BEFORE: "step:before",
  BEACON: "beacon",
  TOOLTIP: "tooltip",
  STEP_AFTER: "step:after",
  TOUR_END: "tour:end",
  TOUR_STATUS: "tour:status",
  TARGET_NOT_FOUND: "error:target_not_found",
  ERROR: "error"
}, ve = {
  INIT: "init",
  READY: "ready",
  BEACON: "beacon",
  TOOLTIP: "tooltip",
  COMPLETE: "complete",
  ERROR: "error"
}, Ce = {
  IDLE: "idle",
  READY: "ready",
  WAITING: "waiting",
  RUNNING: "running",
  PAUSED: "paused",
  SKIPPED: "skipped",
  FINISHED: "finished",
  ERROR: "error"
};
function En() {
  var e;
  return !!(typeof window < "u" && ((e = window.document) != null && e.createElement));
}
function t0(e) {
  return e ? e.getBoundingClientRect() : null;
}
function kz(e = !1) {
  const { body: t, documentElement: n } = document;
  if (!t || !n)
    return 0;
  if (e) {
    const r = [
      t.scrollHeight,
      t.offsetHeight,
      n.clientHeight,
      n.scrollHeight,
      n.offsetHeight
    ].sort((a, i) => a - i), o = Math.floor(r.length / 2);
    return r.length % 2 === 0 ? (r[o - 1] + r[o]) / 2 : r[o];
  }
  return Math.max(
    t.scrollHeight,
    t.offsetHeight,
    n.clientHeight,
    n.scrollHeight,
    n.offsetHeight
  );
}
function mn(e) {
  if (typeof e == "string")
    try {
      return document.querySelector(e);
    } catch (t) {
      return process.env.NODE_ENV !== "production" && console.error(t), null;
    }
  return e;
}
function Rz(e) {
  return !e || e.nodeType !== 1 ? null : getComputedStyle(e);
}
function qo(e, t, n) {
  if (!e)
    return Jn();
  const r = Rx(e);
  if (r) {
    if (r.isSameNode(Jn()))
      return n ? document : Jn();
    if (!(r.scrollHeight > r.offsetHeight) && !t)
      return r.style.overflow = "initial", Jn();
  }
  return r;
}
function Ta(e, t) {
  if (!e)
    return !1;
  const n = qo(e, t);
  return n ? !n.isSameNode(Jn()) : !1;
}
function Pz(e) {
  return e.offsetParent !== document.body;
}
function Ur(e, t = "fixed") {
  if (!e || !(e instanceof HTMLElement))
    return !1;
  const { nodeName: n } = e, r = Rz(e);
  return n === "BODY" || n === "HTML" ? !1 : r && r.position === t ? !0 : e.parentNode ? Ur(e.parentNode, t) : !1;
}
function Nz(e) {
  var t;
  if (!e)
    return !1;
  let n = e;
  for (; n && n !== document.body; ) {
    if (n instanceof HTMLElement) {
      const { display: r, visibility: o } = getComputedStyle(n);
      if (r === "none" || o === "hidden")
        return !1;
    }
    n = (t = n.parentElement) != null ? t : null;
  }
  return !0;
}
function Tz(e, t, n) {
  var r, o, a;
  const i = t0(e), s = qo(e, n), l = Ta(e, n), c = Ur(e);
  let u = 0, d = (r = i == null ? void 0 : i.top) != null ? r : 0;
  if (l && c) {
    const f = (o = e == null ? void 0 : e.offsetTop) != null ? o : 0, p = (a = s == null ? void 0 : s.scrollTop) != null ? a : 0;
    d = f - p;
  } else s instanceof HTMLElement && (u = s.scrollTop, !l && !Ur(e) && (d += u), s.isSameNode(Jn()) || (d += Jn().scrollTop));
  return Math.floor(d - t);
}
function _z(e, t, n) {
  var r;
  if (!e)
    return 0;
  const { offsetTop: o = 0, scrollTop: a = 0 } = (r = Rx(e)) != null ? r : {};
  let i = e.getBoundingClientRect().top + a;
  o && (Ta(e, n) || Pz(e)) && (i -= o);
  const s = Math.floor(i - t);
  return s < 0 ? 0 : s;
}
function Jn() {
  var e;
  return (e = document.scrollingElement) != null ? e : document.documentElement;
}
function Iz(e, t) {
  const { duration: n, element: r } = t;
  return new Promise((o, a) => {
    const { scrollTop: i } = r, s = e > i ? e - i : i - e;
    _F.top(r, e, { duration: s < 100 ? 50 : n }, (l) => l && l.message !== "Element already at target scroll position" ? a(l) : o());
  });
}
var So = m0 !== void 0;
function n0(e = navigator.userAgent) {
  let t = e;
  return typeof window > "u" ? t = "node" : document.documentMode ? t = "ie" : /Edge/.test(e) ? t = "edge" : window.opera || e.includes(" OPR/") ? t = "opera" : typeof window.InstallTrigger < "u" ? t = "firefox" : window.chrome ? t = "chrome" : /(Version\/([\d._]+).*Safari|CriOS|FxiOS| Mobile\/)/.test(e) && (t = "safari"), t;
}
function ai(e) {
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase();
}
function Kt(e, t = {}) {
  const { defaultValue: n, step: r, steps: o } = t;
  let a = Jf(e);
  if (a)
    (a.includes("{step}") || a.includes("{steps}")) && r && o && (a = a.replace("{step}", r.toString()).replace("{steps}", o.toString()));
  else if (ur(e) && !Object.values(e.props).length && ai(e.type) === "function") {
    const i = e.type({});
    a = Kt(i, t);
  } else
    a = Jf(n);
  return a;
}
function Mz(e, t) {
  return !ce.plainObject(e) || !ce.array(t) ? !1 : Object.keys(e).every((n) => t.includes(n));
}
function Oz(e) {
  const t = /^#?([\da-f])([\da-f])([\da-f])$/i, n = e.replace(t, (o, a, i, s) => a + a + i + i + s + s), r = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(n);
  return r ? [parseInt(r[1], 16), parseInt(r[2], 16), parseInt(r[3], 16)] : [];
}
function Cp(e) {
  return e.disableBeacon || e.placement === "center";
}
function Ep() {
  return !["chrome", "safari", "firefox", "opera"].includes(n0());
}
function An({ data: e, debug: t = !1, title: n, warn: r = !1 }) {
  const o = r ? console.warn || console.error : console.log;
  t && (n && e ? (console.groupCollapsed(
    `%creact-joyride: ${n}`,
    "color: #ff0044; font-weight: bold; font-size: 12px;"
  ), Array.isArray(e) ? e.forEach((a) => {
    ce.plainObject(a) && a.key ? o.apply(console, [a.key, a.value]) : o.apply(console, [a]);
  }) : o.apply(console, [e]), console.groupEnd()) : console.error("Missing title or data props"));
}
function Dz(e) {
  return Object.keys(e);
}
function r0(e, ...t) {
  if (!ce.plainObject(e))
    throw new TypeError("Expected an object");
  const n = {};
  for (const r in e)
    ({}).hasOwnProperty.call(e, r) && (t.includes(r) || (n[r] = e[r]));
  return n;
}
function Az(e, ...t) {
  if (!ce.plainObject(e))
    throw new TypeError("Expected an object");
  if (!t.length)
    return e;
  const n = {};
  for (const r in e)
    ({}).hasOwnProperty.call(e, r) && t.includes(r) && (n[r] = e[r]);
  return n;
}
function vc(e, t, n) {
  const r = (a) => a.replace("{step}", String(t)).replace("{steps}", String(n));
  if (ai(e) === "string")
    return r(e);
  if (!ur(e))
    return e;
  const { children: o } = e.props;
  if (ai(o) === "string" && o.includes("{step}"))
    return tn(e, {
      children: r(o)
    });
  if (Array.isArray(o))
    return tn(e, {
      children: o.map((a) => typeof a == "string" ? r(a) : vc(a, t, n))
    });
  if (ai(e.type) === "function" && !Object.values(e.props).length) {
    const a = e.type({});
    return vc(a, t, n);
  }
  return e;
}
function $z(e) {
  const { isFirstStep: t, lifecycle: n, previousLifecycle: r, scrollToFirstStep: o, step: a, target: i } = e;
  return !a.disableScrolling && (!t || o || n === ve.TOOLTIP) && a.placement !== "center" && (!a.isFixed || !Ur(i)) && // fixed steps don't need to scroll
  r !== n && [ve.BEACON, ve.TOOLTIP].includes(n);
}
var Lz = {
  options: {
    preventOverflow: {
      boundariesElement: "scrollParent"
    }
  },
  wrapperOptions: {
    offset: -18,
    position: !0
  }
}, o0 = {
  back: "Back",
  close: "Close",
  last: "Last",
  next: "Next",
  nextLabelWithProgress: "Next (Step {step} of {steps})",
  open: "Open the dialog",
  skip: "Skip"
}, Fz = {
  event: "click",
  placement: "bottom",
  offset: 10,
  disableBeacon: !1,
  disableCloseOnEsc: !1,
  disableOverlay: !1,
  disableOverlayClose: !1,
  disableScrollParentFix: !1,
  disableScrolling: !1,
  hideBackButton: !1,
  hideCloseButton: !1,
  hideFooter: !1,
  isFixed: !1,
  locale: o0,
  showProgress: !1,
  showSkipButton: !1,
  spotlightClicks: !1,
  spotlightPadding: 10
}, zz = {
  continuous: !1,
  debug: !1,
  disableCloseOnEsc: !1,
  disableOverlay: !1,
  disableOverlayClose: !1,
  disableScrolling: !1,
  disableScrollParentFix: !1,
  getHelpers: void 0,
  hideBackButton: !1,
  run: !0,
  scrollOffset: 20,
  scrollDuration: 300,
  scrollToFirstStep: !1,
  showSkipButton: !1,
  showProgress: !1,
  spotlightClicks: !1,
  spotlightPadding: 10,
  steps: []
}, Vz = {
  arrowColor: "#fff",
  backgroundColor: "#fff",
  beaconSize: 36,
  overlayColor: "rgba(0, 0, 0, 0.5)",
  primaryColor: "#f04",
  spotlightShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
  textColor: "#333",
  width: 380,
  zIndex: 100
}, Co = {
  backgroundColor: "transparent",
  border: 0,
  borderRadius: 0,
  color: "#555",
  cursor: "pointer",
  fontSize: 16,
  lineHeight: 1,
  padding: 8,
  WebkitAppearance: "none"
}, kp = {
  borderRadius: 4,
  position: "absolute"
};
function Bz(e, t) {
  var n, r, o, a, i;
  const { floaterProps: s, styles: l } = e, c = Ot((n = t.floaterProps) != null ? n : {}, s ?? {}), u = Ot(l ?? {}, (r = t.styles) != null ? r : {}), d = Ot(Vz, u.options || {}), f = t.placement === "center" || t.disableBeacon;
  let { width: p } = d;
  window.innerWidth > 480 && (p = 380), "width" in d && (p = typeof d.width == "number" && window.innerWidth < d.width ? window.innerWidth - 30 : d.width);
  const h = {
    bottom: 0,
    left: 0,
    overflow: "hidden",
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: d.zIndex
  }, g = {
    beacon: {
      ...Co,
      display: f ? "none" : "inline-block",
      height: d.beaconSize,
      position: "relative",
      width: d.beaconSize,
      zIndex: d.zIndex
    },
    beaconInner: {
      animation: "joyride-beacon-inner 1.2s infinite ease-in-out",
      backgroundColor: d.primaryColor,
      borderRadius: "50%",
      display: "block",
      height: "50%",
      left: "50%",
      opacity: 0.7,
      position: "absolute",
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: "50%"
    },
    beaconOuter: {
      animation: "joyride-beacon-outer 1.2s infinite ease-in-out",
      backgroundColor: `rgba(${Oz(d.primaryColor).join(",")}, 0.2)`,
      border: `2px solid ${d.primaryColor}`,
      borderRadius: "50%",
      boxSizing: "border-box",
      display: "block",
      height: "100%",
      left: 0,
      opacity: 0.9,
      position: "absolute",
      top: 0,
      transformOrigin: "center",
      width: "100%"
    },
    tooltip: {
      backgroundColor: d.backgroundColor,
      borderRadius: 5,
      boxSizing: "border-box",
      color: d.textColor,
      fontSize: 16,
      maxWidth: "100%",
      padding: 15,
      position: "relative",
      width: p
    },
    tooltipContainer: {
      lineHeight: 1.4,
      textAlign: "center"
    },
    tooltipTitle: {
      fontSize: 18,
      margin: 0
    },
    tooltipContent: {
      padding: "20px 10px"
    },
    tooltipFooter: {
      alignItems: "center",
      display: "flex",
      justifyContent: "flex-end",
      marginTop: 15
    },
    tooltipFooterSpacer: {
      flex: 1
    },
    buttonNext: {
      ...Co,
      backgroundColor: d.primaryColor,
      borderRadius: 4,
      color: "#fff"
    },
    buttonBack: {
      ...Co,
      color: d.primaryColor,
      marginLeft: "auto",
      marginRight: 5
    },
    buttonClose: {
      ...Co,
      color: d.textColor,
      height: 14,
      padding: 15,
      position: "absolute",
      right: 0,
      top: 0,
      width: 14
    },
    buttonSkip: {
      ...Co,
      color: d.textColor,
      fontSize: 14
    },
    overlay: {
      ...h,
      backgroundColor: d.overlayColor,
      mixBlendMode: "hard-light"
    },
    overlayLegacy: {
      ...h
    },
    overlayLegacyCenter: {
      ...h,
      backgroundColor: d.overlayColor
    },
    spotlight: {
      ...kp,
      backgroundColor: "gray"
    },
    spotlightLegacy: {
      ...kp,
      boxShadow: `0 0 0 9999px ${d.overlayColor}, ${d.spotlightShadow}`
    },
    floaterStyles: {
      arrow: {
        color: (i = (a = (o = c == null ? void 0 : c.styles) == null ? void 0 : o.arrow) == null ? void 0 : a.color) != null ? i : d.arrowColor
      },
      options: {
        zIndex: d.zIndex + 100
      }
    },
    options: d
  };
  return Ot(g, u);
}
function Hz(e) {
  return Az(
    e,
    "beaconComponent",
    "disableCloseOnEsc",
    "disableOverlay",
    "disableOverlayClose",
    "disableScrolling",
    "disableScrollParentFix",
    "floaterProps",
    "hideBackButton",
    "hideCloseButton",
    "locale",
    "showProgress",
    "showSkipButton",
    "spotlightClicks",
    "spotlightPadding",
    "styles",
    "tooltipComponent"
  );
}
function Cr(e, t) {
  var n, r, o, a, i, s;
  const l = t ?? {}, c = Ot.all([Fz, Hz(e), l], {
    isMergeableObject: ce.plainObject
  }), u = Bz(e, c), d = Ta(
    mn(c.target),
    c.disableScrollParentFix
  ), f = Ot.all([
    Lz,
    (n = e.floaterProps) != null ? n : {},
    (r = c.floaterProps) != null ? r : {}
  ]);
  return f.offset = c.offset, f.styles = Ot((o = f.styles) != null ? o : {}, u.floaterStyles), f.offset += (i = (a = e.spotlightPadding) != null ? a : c.spotlightPadding) != null ? i : 0, c.placementBeacon && f.wrapperOptions && (f.wrapperOptions.placement = c.placementBeacon), d && f.options.preventOverflow && (f.options.preventOverflow.boundariesElement = "window"), {
    ...c,
    locale: Ot.all([o0, (s = e.locale) != null ? s : {}, c.locale || {}]),
    floaterProps: f,
    styles: r0(u, "floaterStyles")
  };
}
function a0(e, t = !1) {
  return ce.plainObject(e) ? e.target ? !0 : (An({
    title: "validateStep",
    data: "target is missing from the step",
    warn: !0,
    debug: t
  }), !1) : (An({
    title: "validateStep",
    data: "step must be an object",
    warn: !0,
    debug: t
  }), !1);
}
function Rp(e, t = !1) {
  return ce.array(e) ? e.every((n) => a0(n, t)) : (An({
    title: "validateSteps",
    data: "steps must be an array",
    warn: !0,
    debug: t
  }), !1);
}
var i0 = {
  action: "init",
  controlled: !1,
  index: 0,
  lifecycle: ve.INIT,
  origin: null,
  size: 0,
  status: Ce.IDLE
}, Pp = Dz(r0(i0, "controlled", "size")), Wz = class {
  constructor(e) {
    ue(this, "beaconPopper"), ue(this, "tooltipPopper"), ue(this, "data", /* @__PURE__ */ new Map()), ue(this, "listener"), ue(this, "store", /* @__PURE__ */ new Map()), ue(this, "addListener", (o) => {
      this.listener = o;
    }), ue(this, "setSteps", (o) => {
      const { size: a, status: i } = this.getState(), s = {
        size: o.length,
        status: i
      };
      this.data.set("steps", o), i === Ce.WAITING && !a && o.length && (s.status = Ce.RUNNING), this.setState(s);
    }), ue(this, "getPopper", (o) => o === "beacon" ? this.beaconPopper : this.tooltipPopper), ue(this, "setPopper", (o, a) => {
      o === "beacon" ? this.beaconPopper = a : this.tooltipPopper = a;
    }), ue(this, "cleanupPoppers", () => {
      this.beaconPopper = null, this.tooltipPopper = null;
    }), ue(this, "close", (o = null) => {
      const { index: a, status: i } = this.getState();
      i === Ce.RUNNING && this.setState({
        ...this.getNextState({ action: Oe.CLOSE, index: a + 1, origin: o })
      });
    }), ue(this, "go", (o) => {
      const { controlled: a, status: i } = this.getState();
      if (a || i !== Ce.RUNNING)
        return;
      const s = this.getSteps()[o];
      this.setState({
        ...this.getNextState({ action: Oe.GO, index: o }),
        status: s ? i : Ce.FINISHED
      });
    }), ue(this, "info", () => this.getState()), ue(this, "next", () => {
      const { index: o, status: a } = this.getState();
      a === Ce.RUNNING && this.setState(this.getNextState({ action: Oe.NEXT, index: o + 1 }));
    }), ue(this, "open", () => {
      const { status: o } = this.getState();
      o === Ce.RUNNING && this.setState({
        ...this.getNextState({ action: Oe.UPDATE, lifecycle: ve.TOOLTIP })
      });
    }), ue(this, "prev", () => {
      const { index: o, status: a } = this.getState();
      a === Ce.RUNNING && this.setState({
        ...this.getNextState({ action: Oe.PREV, index: o - 1 })
      });
    }), ue(this, "reset", (o = !1) => {
      const { controlled: a } = this.getState();
      a || this.setState({
        ...this.getNextState({ action: Oe.RESET, index: 0 }),
        status: o ? Ce.RUNNING : Ce.READY
      });
    }), ue(this, "skip", () => {
      const { status: o } = this.getState();
      o === Ce.RUNNING && this.setState({
        action: Oe.SKIP,
        lifecycle: ve.INIT,
        status: Ce.SKIPPED
      });
    }), ue(this, "start", (o) => {
      const { index: a, size: i } = this.getState();
      this.setState({
        ...this.getNextState(
          {
            action: Oe.START,
            index: ce.number(o) ? o : a
          },
          !0
        ),
        status: i ? Ce.RUNNING : Ce.WAITING
      });
    }), ue(this, "stop", (o = !1) => {
      const { index: a, status: i } = this.getState();
      [Ce.FINISHED, Ce.SKIPPED].includes(i) || this.setState({
        ...this.getNextState({ action: Oe.STOP, index: a + (o ? 1 : 0) }),
        status: Ce.PAUSED
      });
    }), ue(this, "update", (o) => {
      var a, i;
      if (!Mz(o, Pp))
        throw new Error(`State is not valid. Valid keys: ${Pp.join(", ")}`);
      this.setState({
        ...this.getNextState(
          {
            ...this.getState(),
            ...o,
            action: (a = o.action) != null ? a : Oe.UPDATE,
            origin: (i = o.origin) != null ? i : null
          },
          !0
        )
      });
    });
    const { continuous: t = !1, stepIndex: n, steps: r = [] } = e ?? {};
    this.setState(
      {
        action: Oe.INIT,
        controlled: ce.number(n),
        continuous: t,
        index: ce.number(n) ? n : 0,
        lifecycle: ve.INIT,
        origin: null,
        status: r.length ? Ce.READY : Ce.IDLE
      },
      !0
    ), this.beaconPopper = null, this.tooltipPopper = null, this.listener = null, this.setSteps(r);
  }
  getState() {
    return this.store.size ? {
      action: this.store.get("action") || "",
      controlled: this.store.get("controlled") || !1,
      index: parseInt(this.store.get("index"), 10),
      lifecycle: this.store.get("lifecycle") || "",
      origin: this.store.get("origin") || null,
      size: this.store.get("size") || 0,
      status: this.store.get("status") || ""
    } : { ...i0 };
  }
  getNextState(e, t = !1) {
    var n, r, o, a, i;
    const { action: s, controlled: l, index: c, size: u, status: d } = this.getState(), f = ce.number(e.index) ? e.index : c, p = l && !t ? c : Math.min(Math.max(f, 0), u);
    return {
      action: (n = e.action) != null ? n : s,
      controlled: l,
      index: p,
      lifecycle: (r = e.lifecycle) != null ? r : ve.INIT,
      origin: (o = e.origin) != null ? o : null,
      size: (a = e.size) != null ? a : u,
      status: p === u ? Ce.FINISHED : (i = e.status) != null ? i : d
    };
  }
  getSteps() {
    const e = this.data.get("steps");
    return Array.isArray(e) ? e : [];
  }
  hasUpdatedState(e) {
    const t = JSON.stringify(e), n = JSON.stringify(this.getState());
    return t !== n;
  }
  setState(e, t = !1) {
    const n = this.getState(), {
      action: r,
      index: o,
      lifecycle: a,
      origin: i = null,
      size: s,
      status: l
    } = {
      ...n,
      ...e
    };
    this.store.set("action", r), this.store.set("index", o), this.store.set("lifecycle", a), this.store.set("origin", i), this.store.set("size", s), this.store.set("status", l), t && (this.store.set("controlled", e.controlled), this.store.set("continuous", e.continuous)), this.listener && this.hasUpdatedState(n) && this.listener(this.getState());
  }
  getHelpers() {
    return {
      close: this.close,
      go: this.go,
      info: this.info,
      next: this.next,
      open: this.open,
      prev: this.prev,
      reset: this.reset,
      skip: this.skip
    };
  }
};
function jz(e) {
  return new Wz(e);
}
function Gz({ styles: e }) {
  return /* @__PURE__ */ v.createElement(
    "div",
    {
      key: "JoyrideSpotlight",
      className: "react-joyride__spotlight",
      "data-test-id": "spotlight",
      style: e
    }
  );
}
var Uz = Gz, qz = class extends v.Component {
  constructor() {
    super(...arguments), ue(this, "isActive", !1), ue(this, "resizeTimeout"), ue(this, "scrollTimeout"), ue(this, "scrollParent"), ue(this, "state", {
      isScrolling: !1,
      mouseOverSpotlight: !1,
      showSpotlight: !0
    }), ue(this, "hideSpotlight", () => {
      const { continuous: e, disableOverlay: t, lifecycle: n } = this.props, r = [
        ve.INIT,
        ve.BEACON,
        ve.COMPLETE,
        ve.ERROR
      ];
      return t || (e ? r.includes(n) : n !== ve.TOOLTIP);
    }), ue(this, "handleMouseMove", (e) => {
      const { mouseOverSpotlight: t } = this.state, { height: n, left: r, position: o, top: a, width: i } = this.spotlightStyles, s = o === "fixed" ? e.clientY : e.pageY, l = o === "fixed" ? e.clientX : e.pageX, c = s >= a && s <= a + n, d = l >= r && l <= r + i && c;
      d !== t && this.updateState({ mouseOverSpotlight: d });
    }), ue(this, "handleScroll", () => {
      const { target: e } = this.props, t = mn(e);
      if (this.scrollParent !== document) {
        const { isScrolling: n } = this.state;
        n || this.updateState({ isScrolling: !0, showSpotlight: !1 }), clearTimeout(this.scrollTimeout), this.scrollTimeout = window.setTimeout(() => {
          this.updateState({ isScrolling: !1, showSpotlight: !0 });
        }, 50);
      } else Ur(t, "sticky") && this.updateState({});
    }), ue(this, "handleResize", () => {
      clearTimeout(this.resizeTimeout), this.resizeTimeout = window.setTimeout(() => {
        this.isActive && this.forceUpdate();
      }, 100);
    });
  }
  componentDidMount() {
    const { debug: e, disableScrolling: t, disableScrollParentFix: n = !1, target: r } = this.props, o = mn(r);
    this.scrollParent = qo(o ?? document.body, n, !0), this.isActive = !0, process.env.NODE_ENV !== "production" && !t && Ta(o, !0) && An({
      title: "step has a custom scroll parent and can cause trouble with scrolling",
      data: [{ key: "parent", value: this.scrollParent }],
      debug: e
    }), window.addEventListener("resize", this.handleResize);
  }
  componentDidUpdate(e) {
    var t;
    const { disableScrollParentFix: n, lifecycle: r, spotlightClicks: o, target: a } = this.props, { changed: i } = yi(e, this.props);
    if (i("target") || i("disableScrollParentFix")) {
      const s = mn(a);
      this.scrollParent = qo(s ?? document.body, n, !0);
    }
    i("lifecycle", ve.TOOLTIP) && ((t = this.scrollParent) == null || t.addEventListener("scroll", this.handleScroll, { passive: !0 }), setTimeout(() => {
      const { isScrolling: s } = this.state;
      s || this.updateState({ showSpotlight: !0 });
    }, 100)), (i("spotlightClicks") || i("disableOverlay") || i("lifecycle")) && (o && r === ve.TOOLTIP ? window.addEventListener("mousemove", this.handleMouseMove, !1) : r !== ve.TOOLTIP && window.removeEventListener("mousemove", this.handleMouseMove));
  }
  componentWillUnmount() {
    var e;
    this.isActive = !1, window.removeEventListener("mousemove", this.handleMouseMove), window.removeEventListener("resize", this.handleResize), clearTimeout(this.resizeTimeout), clearTimeout(this.scrollTimeout), (e = this.scrollParent) == null || e.removeEventListener("scroll", this.handleScroll);
  }
  get overlayStyles() {
    const { mouseOverSpotlight: e } = this.state, { disableOverlayClose: t, placement: n, styles: r } = this.props;
    let o = r.overlay;
    return Ep() && (o = n === "center" ? r.overlayLegacyCenter : r.overlayLegacy), {
      cursor: t ? "default" : "pointer",
      height: kz(),
      pointerEvents: e ? "none" : "auto",
      ...o
    };
  }
  get spotlightStyles() {
    var e, t, n;
    const { showSpotlight: r } = this.state, {
      disableScrollParentFix: o = !1,
      spotlightClicks: a,
      spotlightPadding: i = 0,
      styles: s,
      target: l
    } = this.props, c = mn(l), u = t0(c), d = Ur(c), f = Tz(c, i, o);
    return {
      ...Ep() ? s.spotlightLegacy : s.spotlight,
      height: Math.round(((e = u == null ? void 0 : u.height) != null ? e : 0) + i * 2),
      left: Math.round(((t = u == null ? void 0 : u.left) != null ? t : 0) - i),
      opacity: r ? 1 : 0,
      pointerEvents: a ? "none" : "auto",
      position: d ? "fixed" : "absolute",
      top: f,
      transition: "opacity 0.2s",
      width: Math.round(((n = u == null ? void 0 : u.width) != null ? n : 0) + i * 2)
    };
  }
  updateState(e) {
    this.isActive && this.setState((t) => ({ ...t, ...e }));
  }
  render() {
    const { showSpotlight: e } = this.state, { onClickOverlay: t, placement: n } = this.props, { hideSpotlight: r, overlayStyles: o, spotlightStyles: a } = this;
    if (r())
      return null;
    let i = n !== "center" && e && /* @__PURE__ */ v.createElement(Uz, { styles: a });
    if (n0() === "safari") {
      const { mixBlendMode: s, zIndex: l, ...c } = o;
      i = /* @__PURE__ */ v.createElement("div", { style: { ...c } }, i), delete o.backgroundColor;
    }
    return /* @__PURE__ */ v.createElement(
      "div",
      {
        className: "react-joyride__overlay",
        "data-test-id": "overlay",
        onClick: t,
        role: "presentation",
        style: o
      },
      i
    );
  }
}, Yz = class extends v.Component {
  constructor() {
    super(...arguments), ue(this, "node", null);
  }
  componentDidMount() {
    const { id: e } = this.props;
    En() && (this.node = document.createElement("div"), this.node.id = e, document.body.appendChild(this.node), So || this.renderReact15());
  }
  componentDidUpdate() {
    En() && (So || this.renderReact15());
  }
  componentWillUnmount() {
    !En() || !this.node || (So || Rn.unmountComponentAtNode(this.node), this.node.parentNode === document.body && (document.body.removeChild(this.node), this.node = null));
  }
  renderReact15() {
    if (!En())
      return;
    const { children: e } = this.props;
    this.node && Rn.unstable_renderSubtreeIntoContainer(this, e, this.node);
  }
  renderReact16() {
    if (!En() || !So)
      return null;
    const { children: e } = this.props;
    return this.node ? Rn.createPortal(e, this.node) : null;
  }
  render() {
    return So ? this.renderReact16() : null;
  }
}, Kz = class {
  constructor(e, t) {
    if (ue(this, "element"), ue(this, "options"), ue(this, "canBeTabbed", (n) => {
      const { tabIndex: r } = n;
      return r === null || r < 0 ? !1 : this.canHaveFocus(n);
    }), ue(this, "canHaveFocus", (n) => {
      const r = /input|select|textarea|button|object/, o = n.nodeName.toLowerCase();
      return (r.test(o) && !n.getAttribute("disabled") || o === "a" && !!n.getAttribute("href")) && this.isVisible(n);
    }), ue(this, "findValidTabElements", () => [].slice.call(this.element.querySelectorAll("*"), 0).filter(this.canBeTabbed)), ue(this, "handleKeyDown", (n) => {
      const { code: r = "Tab" } = this.options;
      n.code === r && this.interceptTab(n);
    }), ue(this, "interceptTab", (n) => {
      n.preventDefault();
      const r = this.findValidTabElements(), { shiftKey: o } = n;
      if (!r.length)
        return;
      let a = document.activeElement ? r.indexOf(document.activeElement) : 0;
      a === -1 || !o && a + 1 === r.length ? a = 0 : o && a === 0 ? a = r.length - 1 : a += o ? -1 : 1, r[a].focus();
    }), ue(this, "isHidden", (n) => {
      const r = n.offsetWidth <= 0 && n.offsetHeight <= 0, o = window.getComputedStyle(n);
      return r && !n.innerHTML ? !0 : r && o.getPropertyValue("overflow") !== "visible" || o.getPropertyValue("display") === "none";
    }), ue(this, "isVisible", (n) => {
      let r = n;
      for (; r; )
        if (r instanceof HTMLElement) {
          if (r === document.body)
            break;
          if (this.isHidden(r))
            return !1;
          r = r.parentNode;
        }
      return !0;
    }), ue(this, "removeScope", () => {
      window.removeEventListener("keydown", this.handleKeyDown);
    }), ue(this, "checkFocus", (n) => {
      document.activeElement !== n && (n.focus(), window.requestAnimationFrame(() => this.checkFocus(n)));
    }), ue(this, "setFocus", () => {
      const { selector: n } = this.options;
      if (!n)
        return;
      const r = this.element.querySelector(n);
      r && window.requestAnimationFrame(() => this.checkFocus(r));
    }), !(e instanceof HTMLElement))
      throw new TypeError("Invalid parameter: element must be an HTMLElement");
    this.element = e, this.options = t, window.addEventListener("keydown", this.handleKeyDown, !1), this.setFocus();
  }
}, Xz = class extends v.Component {
  constructor(e) {
    if (super(e), ue(this, "beacon", null), ue(this, "setBeaconRef", (o) => {
      this.beacon = o;
    }), e.beaconComponent)
      return;
    const t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
    n.id = "joyride-beacon-animation", e.nonce && n.setAttribute("nonce", e.nonce), n.appendChild(document.createTextNode(`
        @keyframes joyride-beacon-inner {
          20% {
            opacity: 0.9;
          }
        
          90% {
            opacity: 0.7;
          }
        }
        
        @keyframes joyride-beacon-outer {
          0% {
            transform: scale(1);
          }
        
          45% {
            opacity: 0.7;
            transform: scale(0.75);
          }
        
          100% {
            opacity: 0.9;
            transform: scale(1);
          }
        }
      `)), t.appendChild(n);
  }
  componentDidMount() {
    const { shouldFocus: e } = this.props;
    process.env.NODE_ENV !== "production" && (ce.domElement(this.beacon) || console.warn("beacon is not a valid DOM element")), setTimeout(() => {
      ce.domElement(this.beacon) && e && this.beacon.focus();
    }, 0);
  }
  componentWillUnmount() {
    const e = document.getElementById("joyride-beacon-animation");
    e != null && e.parentNode && e.parentNode.removeChild(e);
  }
  render() {
    const {
      beaconComponent: e,
      continuous: t,
      index: n,
      isLastStep: r,
      locale: o,
      onClickOrHover: a,
      size: i,
      step: s,
      styles: l
    } = this.props, c = Kt(o.open), u = {
      "aria-label": c,
      onClick: a,
      onMouseEnter: a,
      ref: this.setBeaconRef,
      title: c
    };
    let d;
    if (e) {
      const f = e;
      d = /* @__PURE__ */ v.createElement(
        f,
        {
          continuous: t,
          index: n,
          isLastStep: r,
          size: i,
          step: s,
          ...u
        }
      );
    } else
      d = /* @__PURE__ */ v.createElement(
        "button",
        {
          key: "JoyrideBeacon",
          className: "react-joyride__beacon",
          "data-test-id": "button-beacon",
          style: l.beacon,
          type: "button",
          ...u
        },
        /* @__PURE__ */ v.createElement("span", { style: l.beaconInner }),
        /* @__PURE__ */ v.createElement("span", { style: l.beaconOuter })
      );
    return d;
  }
};
function Jz({ styles: e, ...t }) {
  const { color: n, height: r, width: o, ...a } = e;
  return /* @__PURE__ */ B.createElement("button", { style: a, type: "button", ...t }, /* @__PURE__ */ B.createElement(
    "svg",
    {
      height: typeof r == "number" ? `${r}px` : r,
      preserveAspectRatio: "xMidYMid",
      version: "1.1",
      viewBox: "0 0 18 18",
      width: typeof o == "number" ? `${o}px` : o,
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ B.createElement("g", null, /* @__PURE__ */ B.createElement(
      "path",
      {
        d: "M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z",
        fill: n
      }
    ))
  ));
}
var Qz = Jz;
function Zz(e) {
  const { backProps: t, closeProps: n, index: r, isLastStep: o, primaryProps: a, skipProps: i, step: s, tooltipProps: l } = e, { content: c, hideBackButton: u, hideCloseButton: d, hideFooter: f, showSkipButton: p, styles: h, title: g } = s, w = {};
  return w.primary = /* @__PURE__ */ v.createElement(
    "button",
    {
      "data-test-id": "button-primary",
      style: h.buttonNext,
      type: "button",
      ...a
    }
  ), p && !o && (w.skip = /* @__PURE__ */ v.createElement(
    "button",
    {
      "aria-live": "off",
      "data-test-id": "button-skip",
      style: h.buttonSkip,
      type: "button",
      ...i
    }
  )), !u && r > 0 && (w.back = /* @__PURE__ */ v.createElement("button", { "data-test-id": "button-back", style: h.buttonBack, type: "button", ...t })), w.close = !d && /* @__PURE__ */ v.createElement(Qz, { "data-test-id": "button-close", styles: h.buttonClose, ...n }), /* @__PURE__ */ v.createElement(
    "div",
    {
      key: "JoyrideTooltip",
      "aria-label": Kt(g ?? c),
      className: "react-joyride__tooltip",
      style: h.tooltip,
      ...l
    },
    /* @__PURE__ */ v.createElement("div", { style: h.tooltipContainer }, g && /* @__PURE__ */ v.createElement("h1", { "aria-label": Kt(g), style: h.tooltipTitle }, g), /* @__PURE__ */ v.createElement("div", { style: h.tooltipContent }, c)),
    !f && /* @__PURE__ */ v.createElement("div", { style: h.tooltipFooter }, /* @__PURE__ */ v.createElement("div", { style: h.tooltipFooterSpacer }, w.skip), w.back, w.primary),
    w.close
  );
}
var e3 = Zz, t3 = class extends v.Component {
  constructor() {
    super(...arguments), ue(this, "handleClickBack", (e) => {
      e.preventDefault();
      const { helpers: t } = this.props;
      t.prev();
    }), ue(this, "handleClickClose", (e) => {
      e.preventDefault();
      const { helpers: t } = this.props;
      t.close("button_close");
    }), ue(this, "handleClickPrimary", (e) => {
      e.preventDefault();
      const { continuous: t, helpers: n } = this.props;
      if (!t) {
        n.close("button_primary");
        return;
      }
      n.next();
    }), ue(this, "handleClickSkip", (e) => {
      e.preventDefault();
      const { helpers: t } = this.props;
      t.skip();
    }), ue(this, "getElementsProps", () => {
      const { continuous: e, index: t, isLastStep: n, setTooltipRef: r, size: o, step: a } = this.props, { back: i, close: s, last: l, next: c, nextLabelWithProgress: u, skip: d } = a.locale, f = Kt(i), p = Kt(s), h = Kt(l), g = Kt(c), w = Kt(d);
      let b = s, y = p;
      if (e) {
        if (b = c, y = g, a.showProgress && !n) {
          const x = Kt(u, {
            step: t + 1,
            steps: o
          });
          b = vc(u, t + 1, o), y = x;
        }
        n && (b = l, y = h);
      }
      return {
        backProps: {
          "aria-label": f,
          children: i,
          "data-action": "back",
          onClick: this.handleClickBack,
          role: "button",
          title: f
        },
        closeProps: {
          "aria-label": p,
          children: s,
          "data-action": "close",
          onClick: this.handleClickClose,
          role: "button",
          title: p
        },
        primaryProps: {
          "aria-label": y,
          children: b,
          "data-action": "primary",
          onClick: this.handleClickPrimary,
          role: "button",
          title: y
        },
        skipProps: {
          "aria-label": w,
          children: d,
          "data-action": "skip",
          onClick: this.handleClickSkip,
          role: "button",
          title: w
        },
        tooltipProps: {
          "aria-modal": !0,
          ref: r,
          role: "alertdialog"
        }
      };
    });
  }
  render() {
    const { continuous: e, index: t, isLastStep: n, setTooltipRef: r, size: o, step: a } = this.props, { beaconComponent: i, tooltipComponent: s, ...l } = a;
    let c;
    if (s) {
      const u = {
        ...this.getElementsProps(),
        continuous: e,
        index: t,
        isLastStep: n,
        size: o,
        step: l,
        setTooltipRef: r
      }, d = s;
      c = /* @__PURE__ */ v.createElement(d, { ...u });
    } else
      c = /* @__PURE__ */ v.createElement(
        e3,
        {
          ...this.getElementsProps(),
          continuous: e,
          index: t,
          isLastStep: n,
          size: o,
          step: a
        }
      );
    return c;
  }
}, n3 = class extends v.Component {
  constructor() {
    super(...arguments), ue(this, "scope", null), ue(this, "tooltip", null), ue(this, "handleClickHoverBeacon", (e) => {
      const { step: t, store: n } = this.props;
      e.type === "mouseenter" && t.event !== "hover" || n.update({ lifecycle: ve.TOOLTIP });
    }), ue(this, "setTooltipRef", (e) => {
      this.tooltip = e;
    }), ue(this, "setPopper", (e, t) => {
      var n;
      const { action: r, lifecycle: o, step: a, store: i } = this.props;
      t === "wrapper" ? i.setPopper("beacon", e) : i.setPopper("tooltip", e), i.getPopper("beacon") && (i.getPopper("tooltip") || a.placement === "center") && o === ve.INIT && i.update({
        action: r,
        lifecycle: ve.READY
      }), (n = a.floaterProps) != null && n.getPopper && a.floaterProps.getPopper(e, t);
    }), ue(this, "renderTooltip", (e) => {
      const { continuous: t, helpers: n, index: r, size: o, step: a } = this.props;
      return /* @__PURE__ */ v.createElement(
        t3,
        {
          continuous: t,
          helpers: n,
          index: r,
          isLastStep: r + 1 === o,
          setTooltipRef: this.setTooltipRef,
          size: o,
          step: a,
          ...e
        }
      );
    });
  }
  componentDidMount() {
    const { debug: e, index: t } = this.props;
    An({
      title: `step:${t}`,
      data: [{ key: "props", value: this.props }],
      debug: e
    });
  }
  componentDidUpdate(e) {
    var t;
    const {
      action: n,
      callback: r,
      continuous: o,
      controlled: a,
      debug: i,
      helpers: s,
      index: l,
      lifecycle: c,
      shouldScroll: u,
      status: d,
      step: f,
      store: p
    } = this.props, { changed: h, changedFrom: g } = yi(e, this.props), w = s.info(), b = o && n !== Oe.CLOSE && (l > 0 || n === Oe.PREV), y = h("action") || h("index") || h("lifecycle") || h("status"), x = g("lifecycle", [ve.TOOLTIP, ve.INIT], ve.INIT), C = h("action", [
      Oe.NEXT,
      Oe.PREV,
      Oe.SKIP,
      Oe.CLOSE
    ]), S = a && l === e.index;
    if (C && (x || S) && r({
      ...w,
      index: e.index,
      lifecycle: ve.COMPLETE,
      step: e.step,
      type: Mt.STEP_AFTER
    }), f.placement === "center" && d === Ce.RUNNING && h("index") && n !== Oe.START && c === ve.INIT && p.update({ lifecycle: ve.READY }), y) {
      const R = mn(f.target), E = !!R;
      E && Nz(R) ? (g("status", Ce.READY, Ce.RUNNING) || g("lifecycle", ve.INIT, ve.READY)) && r({
        ...w,
        step: f,
        type: Mt.STEP_BEFORE
      }) : (console.warn(E ? "Target not visible" : "Target not mounted", f), r({
        ...w,
        type: Mt.TARGET_NOT_FOUND,
        step: f
      }), a || p.update({ index: l + (n === Oe.PREV ? -1 : 1) }));
    }
    g("lifecycle", ve.INIT, ve.READY) && p.update({
      lifecycle: Cp(f) || b ? ve.TOOLTIP : ve.BEACON
    }), h("index") && An({
      title: `step:${c}`,
      data: [{ key: "props", value: this.props }],
      debug: i
    }), h("lifecycle", ve.BEACON) && r({
      ...w,
      step: f,
      type: Mt.BEACON
    }), h("lifecycle", ve.TOOLTIP) && (r({
      ...w,
      step: f,
      type: Mt.TOOLTIP
    }), u && this.tooltip && (this.scope = new Kz(this.tooltip, { selector: "[data-action=primary]" }), this.scope.setFocus())), g("lifecycle", [ve.TOOLTIP, ve.INIT], ve.INIT) && ((t = this.scope) == null || t.removeScope(), p.cleanupPoppers());
  }
  componentWillUnmount() {
    var e;
    (e = this.scope) == null || e.removeScope();
  }
  get open() {
    const { lifecycle: e, step: t } = this.props;
    return Cp(t) || e === ve.TOOLTIP;
  }
  render() {
    const { continuous: e, debug: t, index: n, nonce: r, shouldScroll: o, size: a, step: i } = this.props, s = mn(i.target);
    return !a0(i) || !ce.domElement(s) ? null : /* @__PURE__ */ v.createElement("div", { key: `JoyrideStep-${n}`, className: "react-joyride__step" }, /* @__PURE__ */ v.createElement(
      fd,
      {
        ...i.floaterProps,
        component: this.renderTooltip,
        debug: t,
        getPopper: this.setPopper,
        id: `react-joyride-step-${n}`,
        open: this.open,
        placement: i.placement,
        target: i.target
      },
      /* @__PURE__ */ v.createElement(
        Xz,
        {
          beaconComponent: i.beaconComponent,
          continuous: e,
          index: n,
          isLastStep: n + 1 === a,
          locale: i.locale,
          nonce: r,
          onClickOrHover: this.handleClickHoverBeacon,
          shouldFocus: o,
          size: a,
          step: i,
          styles: i.styles
        }
      )
    ));
  }
}, s0 = class extends v.Component {
  constructor(e) {
    super(e), ue(this, "helpers"), ue(this, "store"), ue(this, "callback", (i) => {
      const { callback: s } = this.props;
      ce.function(s) && s(i);
    }), ue(this, "handleKeyboard", (i) => {
      const { index: s, lifecycle: l } = this.state, { steps: c } = this.props, u = c[s];
      l === ve.TOOLTIP && i.code === "Escape" && u && !u.disableCloseOnEsc && this.store.close("keyboard");
    }), ue(this, "handleClickOverlay", () => {
      const { index: i } = this.state, { steps: s } = this.props;
      Cr(this.props, s[i]).disableOverlayClose || this.helpers.close("overlay");
    }), ue(this, "syncState", (i) => {
      this.setState(i);
    });
    const { debug: t, getHelpers: n, run: r = !0, stepIndex: o } = e;
    this.store = jz({
      ...e,
      controlled: r && ce.number(o)
    }), this.helpers = this.store.getHelpers();
    const { addListener: a } = this.store;
    An({
      title: "init",
      data: [
        { key: "props", value: this.props },
        { key: "state", value: this.state }
      ],
      debug: t
    }), a(this.syncState), n && n(this.helpers), this.state = this.store.getState();
  }
  componentDidMount() {
    if (!En())
      return;
    const { debug: e, disableCloseOnEsc: t, run: n, steps: r } = this.props, { start: o } = this.store;
    Rp(r, e) && n && o(), t || document.body.addEventListener("keydown", this.handleKeyboard, { passive: !0 });
  }
  componentDidUpdate(e, t) {
    if (!En())
      return;
    const { action: n, controlled: r, index: o, status: a } = this.state, { debug: i, run: s, stepIndex: l, steps: c } = this.props, { stepIndex: u, steps: d } = e, { reset: f, setSteps: p, start: h, stop: g, update: w } = this.store, { changed: b } = yi(e, this.props), { changed: y, changedFrom: x } = yi(t, this.state), C = Cr(this.props, c[o]), S = !ut(d, c), R = ce.number(l) && b("stepIndex"), E = mn(C.target);
    if (S && (Rp(c, i) ? p(c) : console.warn("Steps are not valid", c)), b("run") && (s ? h(l) : g()), R) {
      let G = ce.number(u) && u < l ? Oe.NEXT : Oe.PREV;
      n === Oe.STOP && (G = Oe.START), [Ce.FINISHED, Ce.SKIPPED].includes(a) || w({
        action: n === Oe.CLOSE ? Oe.CLOSE : G,
        index: l,
        lifecycle: ve.INIT
      });
    }
    !r && a === Ce.RUNNING && o === 0 && !E && (this.store.update({ index: o + 1 }), this.callback({
      ...this.state,
      type: Mt.TARGET_NOT_FOUND,
      step: C
    }));
    const M = {
      ...this.state,
      index: o,
      step: C
    };
    if (y("action", [
      Oe.NEXT,
      Oe.PREV,
      Oe.SKIP,
      Oe.CLOSE
    ]) && y("status", Ce.PAUSED)) {
      const G = Cr(this.props, c[t.index]);
      this.callback({
        ...M,
        index: t.index,
        lifecycle: ve.COMPLETE,
        step: G,
        type: Mt.STEP_AFTER
      });
    }
    if (y("status", [Ce.FINISHED, Ce.SKIPPED])) {
      const G = Cr(this.props, c[t.index]);
      r || this.callback({
        ...M,
        index: t.index,
        lifecycle: ve.COMPLETE,
        step: G,
        type: Mt.STEP_AFTER
      }), this.callback({
        ...M,
        type: Mt.TOUR_END,
        // Return the last step when the tour is finished
        step: G,
        index: t.index
      }), f();
    } else x("status", [Ce.IDLE, Ce.READY], Ce.RUNNING) ? this.callback({
      ...M,
      type: Mt.TOUR_START
    }) : (y("status") || y("action", Oe.RESET)) && this.callback({
      ...M,
      type: Mt.TOUR_STATUS
    });
    this.scrollToStep(t);
  }
  componentWillUnmount() {
    const { disableCloseOnEsc: e } = this.props;
    e || document.body.removeEventListener("keydown", this.handleKeyboard);
  }
  scrollToStep(e) {
    const { index: t, lifecycle: n, status: r } = this.state, {
      debug: o,
      disableScrollParentFix: a = !1,
      scrollDuration: i,
      scrollOffset: s = 20,
      scrollToFirstStep: l = !1,
      steps: c
    } = this.props, u = Cr(this.props, c[t]), d = mn(u.target), f = $z({
      isFirstStep: t === 0,
      lifecycle: n,
      previousLifecycle: e.lifecycle,
      scrollToFirstStep: l,
      step: u,
      target: d
    });
    if (r === Ce.RUNNING && f) {
      const p = Ta(d, a), h = qo(d, a);
      let g = Math.floor(_z(d, s, a)) || 0;
      An({
        title: "scrollToStep",
        data: [
          { key: "index", value: t },
          { key: "lifecycle", value: n },
          { key: "status", value: r }
        ],
        debug: o
      });
      const w = this.store.getPopper("beacon"), b = this.store.getPopper("tooltip");
      if (n === ve.BEACON && w) {
        const { offsets: y, placement: x } = w;
        !["bottom"].includes(x) && !p && (g = Math.floor(y.popper.top - s));
      } else if (n === ve.TOOLTIP && b) {
        const { flipped: y, offsets: x, placement: C } = b;
        ["top", "right", "left"].includes(C) && !y && !p ? g = Math.floor(x.popper.top - s) : g -= u.spotlightPadding;
      }
      g = g >= 0 ? g : 0, r === Ce.RUNNING && Iz(g, { element: h, duration: i }).then(
        () => {
          setTimeout(() => {
            var y;
            (y = this.store.getPopper("tooltip")) == null || y.instance.update();
          }, 10);
        }
      );
    }
  }
  render() {
    if (!En())
      return null;
    const { index: e, lifecycle: t, status: n } = this.state, {
      continuous: r = !1,
      debug: o = !1,
      nonce: a,
      scrollToFirstStep: i = !1,
      steps: s
    } = this.props, l = n === Ce.RUNNING, c = {};
    if (l && s[e]) {
      const u = Cr(this.props, s[e]);
      c.step = /* @__PURE__ */ v.createElement(
        n3,
        {
          ...this.state,
          callback: this.callback,
          continuous: r,
          debug: o,
          helpers: this.helpers,
          nonce: a,
          shouldScroll: !u.disableScrolling && (e !== 0 || i),
          step: u,
          store: this.store
        }
      ), c.overlay = /* @__PURE__ */ v.createElement(Yz, { id: "react-joyride-portal" }, /* @__PURE__ */ v.createElement(
        qz,
        {
          ...u,
          continuous: r,
          debug: o,
          lifecycle: t,
          onClickOverlay: this.handleClickOverlay
        }
      ));
    }
    return /* @__PURE__ */ v.createElement("div", { className: "react-joyride" }, c.step, c.overlay);
  }
};
ue(s0, "defaultProps", zz);
var r3 = s0;
const l0 = bt(void 0), _4 = ({
  steps: e,
  callback: t,
  onTourEnd: n,
  children: r,
  styles: o,
  ...a
}) => {
  const [i, s] = ye(!1), l = () => s(!0), c = () => s(!1), u = (d) => {
    const { status: f } = d;
    t && t(d), (Ce.FINISHED === f || Ce.SKIPPED === f) && (s(!1), n == null || n());
  };
  return /* @__PURE__ */ ee(
    l0.Provider,
    { value: { startTour: l, stopTour: c, isTourRunning: i }, children: [
      r,
      /* @__PURE__ */ m(
        r3,
        {
          steps: e,
          run: i,
          continuous: !0,
          showSkipButton: !0,
          showProgress: !0,
          callback: u,
          locale: {
            back: "Back",
            close: "Close",
            last: "Finish",
            next: "Next",
            nextLabelWithProgress: "Next (Step {step} of {steps})",
            open: "Open the dialog",
            skip: "Skip"
          },
          styles: {
            tooltipContainer: { textAlign: "left", ...o == null ? void 0 : o.tooltipContainer },
            beaconInner: { backgroundColor: "#FEC72F" },
            beaconOuter: {
              backgroundColor: "rgba(254, 199, 47, 0.2)",
              border: "2px solid #FEC72F"
            },
            buttonNext: {
              backgroundColor: "#011ec1",
              borderColor: "#011ec1",
              ...o == null ? void 0 : o.buttonNext
            },
            buttonBack: { marginRight: 10, ...o == null ? void 0 : o.buttonBack },
            ...o
          },
          ...a
        }
      )
    ] }
  );
}, I4 = () => {
  const e = Xe(l0);
  if (!e)
    throw new Error("useTour must be used within a TourProvider");
  return e;
}, o3 = oe("tw-flex tw-w-full tw-items-stretch", {
  variants: {
    layout: {
      desktop: "tw-flex-row tw-justify-between md:tw-flex-row md:tw-justify-between",
      mobile: "tw-flex-col tw-gap-4"
    }
  },
  defaultVariants: {
    layout: "desktop"
  },
  compoundVariants: [{
    layout: "desktop",
    className: "sm:tw-flex-col"
  }]
}), a3 = oe("tw-flex tw-flex-col tw-items-center tw-flex-1", {
  variants: {
    clickable: {
      true: "tw-cursor-pointer hover:tw-opacity-80"
    }
  }
}), Np = oe("tw-flex-1 tw-h-[1px] tw-self-center", {
  variants: {
    state: {
      started: "tw-bg-transparent",
      "start-completed": "tw-bg-[#218358]",
      current: "tw-bg-[#218358]",
      completed: "tw-bg-[#218358]",
      incomplete: "tw-bg-[#E5E7EB]",
      exception: "tw-bg-[#EF4444]",
      connector: "tw-bg-[#E5E7EB] tw-mt-[9px]",
      // 1px off, so arbitraty to get it flush with the line
      "end-complete": "tw-bg-[#218358]"
    },
    position: {
      left: "",
      right: ""
    },
    visible: {
      true: "",
      false: "tw-opacity-0"
    }
  },
  defaultVariants: {
    state: "incomplete",
    visible: !0
  }
}), i3 = oe("tw-flex tw-items-center tw-justify-center tw-w-full", {
  variants: {
    connector: {
      true: "tw-mb-0"
    }
  },
  defaultVariants: {
    connector: !1
  }
}), s3 = oe("tw-flex tw-flex-col tw-items-center tw-w-full", {
  variants: {
    connector: {
      true: "tw-mt-0"
    }
  },
  defaultVariants: {
    connector: !1
  }
}), l3 = oe("tw-text-sm tw-font-bold tw-text-center tw-h-[40px] tw-w-full tw-flex tw-items-center tw-justify-center", {
  variants: {
    state: {
      started: "tw-text-[#202020]",
      "start-completed": "tw-text-[#202020]",
      current: "tw-text-[#202020]",
      completed: "tw-text-[#202020]",
      incomplete: "tw-text-[#959595]",
      exception: "tw-text-[#202020]",
      connector: "tw-text-[#959595]",
      "end-complete": "tw-text-[#202020]"
    }
  },
  defaultVariants: {
    state: "incomplete"
  }
}), Tp = oe("tw-text-xs tw-text-text-tertiary tw-text-center", {
  variants: {
    state: {
      started: "",
      "start-completed": "",
      current: "",
      completed: "",
      incomplete: "tw-text-[#959595]",
      exception: "",
      connector: "tw-hidden",
      "end-complete": ""
    }
  }
}), c3 = oe("tw-z-10 tw-shrink-0", {
  variants: {
    state: {
      started: "tw-text-[#218358]",
      "start-completed": "tw-text-[#218358]",
      current: "tw-text-[#218358]",
      completed: "tw-text-[#218358]",
      incomplete: "tw-text-[#E5E7EB]",
      exception: "tw-text-[#EF4444]",
      connector: "tw-text-[#E5E7EB]",
      "end-complete": "tw-text-[#218358]"
    }
    // No variants needed - all styling controlled by state
  },
  defaultVariants: {
    state: "completed"
  }
}), u3 = q(
  ({
    className: e,
    state: t,
    title: n,
    caption1: r,
    caption2: o,
    showLeftLine: a = !0,
    showRightLine: i = !0,
    icon: s,
    onClick: l,
    ...c
  }, u) => {
    const d = t === "connector", p = s || {
      started: "circle-check",
      "start-completed": "circle-check",
      current: "circle-check",
      completed: "circle-check",
      incomplete: "circle-check",
      exception: "circle-check",
      connector: "circle-check",
      "end-complete": "circle-check"
    }[t];
    return /* @__PURE__ */ ee(
      "div",
      {
        ref: u,
        className: N(
          a3({ clickable: !!l }),
          e
        ),
        onClick: l,
        ...c,
        children: [
          /* @__PURE__ */ ee(
            "div",
            { className: i3({ connector: d }), children: [
              /* @__PURE__ */ m("div", { className: N(
                Np({
                  state: t,
                  position: "left",
                  visible: a && t !== "started" && t !== "start-completed"
                })
              ) }),
              !d && p && /* @__PURE__ */ m(
                de,
                {
                  icon: p,
                  size: "lg",
                  className: c3({ state: t })
                }
              ),
              /* @__PURE__ */ m("div", { className: N(
                Np({
                  state: t === "current" || t === "started" ? "incomplete" : t,
                  position: "right",
                  visible: i && t !== "end-complete"
                })
              ) })
            ] }
          ),
          /* @__PURE__ */ ee(
            "div",
            { className: s3({ connector: d }), children: [
              /* @__PURE__ */ m(
                "div",
                { className: l3({ state: t }), children: n }
              ),
              r && /* @__PURE__ */ m(
                "div",
                { className: Tp({ state: t }), children: r }
              ),
              o && /* @__PURE__ */ m(
                "div",
                { className: Tp({ state: t }), children: o }
              )
            ] }
          )
        ]
      }
    );
  }
);
u3.displayName = "TrackerStop";
const d3 = q(
  ({ className: e, children: t, forceMobileLayout: n, ...r }, o) => /* @__PURE__ */ m(
    "div",
    {
      ref: o,
      className: N(
        o3({ layout: n ? "mobile" : "desktop" }),
        e
      ),
      ...r,
      children: t
    }
  )
);
d3.displayName = "Tracker";
export {
  Oe as ACTIONS,
  BS as Accordion,
  tm as AccordionContent,
  HS as AccordionItem,
  WS as AccordionTrigger,
  ok as Alert,
  sk as AlertContent,
  ik as AlertDescription,
  ak as AlertHeading,
  x3 as AnchorBar,
  pk as AspectRatio,
  sR as Autocomplete,
  $g as AutocompleteCommand,
  uR as AutocompleteEmpty,
  lR as AutocompleteGroup,
  Lg as AutocompleteInput,
  cR as AutocompleteItem,
  Fg as AutocompleteList,
  sR as AutocompleteV2,
  zg as Badge,
  bR as Breadcrumb,
  k3 as BreadcrumbDropdownMenu,
  OP as BreadcrumbDropdownMenuContent,
  DP as BreadcrumbDropdownMenuItem,
  _P as BreadcrumbDropdownMenuTrigger,
  xR as BreadcrumbItem,
  SR as BreadcrumbLink,
  yR as BreadcrumbList,
  CR as BreadcrumbPage,
  ER as BreadcrumbSeparator,
  pt as Button,
  T_ as Calendar,
  F_ as Carousel,
  W_ as CarouselCounter,
  z_ as CarouselMainContainer,
  V_ as CarouselMainItem,
  H_ as CarouselThumbItem,
  B_ as CarouselThumbsContainer,
  zl as Checkbox,
  P3 as Collapsible,
  T3 as CollapsibleContent,
  N3 as CollapsibleTrigger,
  Mu as Command,
  I3 as CommandDialog,
  Av as CommandEmpty,
  $v as CommandGroup,
  qI as CommandInput,
  Lv as CommandItem,
  Dv as CommandList,
  YI as CommandSeparator,
  KI as CommandShortcut,
  QI as Container,
  l4 as CustomRadioButton,
  M3 as DataTable,
  j3 as DateDisplay,
  II as Dialog,
  OI as DialogClose,
  Ov as DialogContent,
  LI as DialogDescription,
  AI as DialogFooter,
  DI as DialogHeader,
  Hl as DialogOverlay,
  MI as DialogPortal,
  $I as DialogTitle,
  _3 as DialogTrigger,
  QO as Drawer,
  Q3 as DrawerClose,
  eD as DrawerContent,
  oD as DrawerDescription,
  nD as DrawerFooter,
  tD as DrawerHeader,
  fw as DrawerOverlay,
  ZO as DrawerPortal,
  rD as DrawerTitle,
  J3 as DrawerTrigger,
  G3 as DropdownMenu,
  bO as DropdownMenuCheckboxItem,
  vO as DropdownMenuContent,
  q3 as DropdownMenuGroup,
  wO as DropdownMenuItem,
  xO as DropdownMenuLabel,
  Y3 as DropdownMenuPortal,
  X3 as DropdownMenuRadioGroup,
  yO as DropdownMenuRadioItem,
  SO as DropdownMenuSeparator,
  CO as DropdownMenuShortcut,
  K3 as DropdownMenuSub,
  hO as DropdownMenuSubContent,
  gO as DropdownMenuSubTrigger,
  U3 as DropdownMenuTrigger,
  Mt as EVENTS,
  Kc as Heading,
  de as Icon,
  mt as IconButton,
  Gw as InfoBanner,
  pw as InputField,
  r3 as Joyride,
  gD as Label,
  nm as Loading,
  zD as Menubar,
  GD as MenubarCheckboxItem,
  WD as MenubarContent,
  t4 as MenubarGroup,
  jD as MenubarItem,
  qD as MenubarLabel,
  e4 as MenubarMenu,
  n4 as MenubarPortal,
  o4 as MenubarRadioGroup,
  UD as MenubarRadioItem,
  YD as MenubarSeparator,
  KD as MenubarShortcut,
  r4 as MenubarSub,
  HD as MenubarSubContent,
  BD as MenubarSubTrigger,
  VD as MenubarTrigger,
  a4 as Multiselect,
  tA as NumberStepper,
  aA as Pagination,
  iA as PaginationContent,
  fA as PaginationEnd,
  sA as PaginationItem,
  lA as PaginationItemCount,
  ba as PaginationLink,
  uA as PaginationNext,
  cA as PaginationPrevious,
  dA as PaginationStart,
  bA as Playlist,
  EA as PlaylistArticle,
  SA as PlaylistContent,
  xA as PlaylistTab,
  yA as PlaylistTabs,
  CA as PlaylistVideo,
  Km as Popover,
  w3 as PopoverAnchor,
  y3 as PopoverArrow,
  b3 as PopoverClose,
  Wc as PopoverContent,
  Xm as PopoverTrigger,
  s4 as RadioButton,
  LA as RadioGroup,
  d4 as ResizableHandle,
  u4 as ResizablePanel,
  c4 as ResizablePanelGroup,
  Ce as STATUS,
  m4 as Select,
  e$ as SelectContent,
  g4 as SelectGroup,
  n$ as SelectItem,
  t$ as SelectLabel,
  v4 as SelectPortal,
  gy as SelectScrollDownButton,
  my as SelectScrollUpButton,
  r$ as SelectSeparator,
  Z2 as SelectTrigger,
  h4 as SelectValue,
  w4 as SelectViewport,
  ug as Separator,
  b4 as Sheet,
  x4 as SheetClose,
  d$ as SheetContent,
  g$ as SheetDescription,
  p$ as SheetFooter,
  f$ as SheetHeader,
  hy as SheetOverlay,
  u$ as SheetPortal,
  m$ as SheetTitle,
  y4 as SheetTrigger,
  S4 as Skeleton,
  tg as SlidingArea,
  ng as SlidingAreaContent,
  rg as SlidingAreaItem,
  ag as SlidingAreaNext,
  og as SlidingAreaPrevious,
  E$ as Switch,
  Yv as Table,
  Xv as TableBody,
  nO as TableCaption,
  Yl as TableCell,
  Jv as TableHead,
  Kv as TableHeader,
  ni as TableRow,
  L$ as Tabs,
  V$ as TabsContent,
  F$ as TabsList,
  z$ as TabsTrigger,
  H$ as Tag,
  Vg as TextLink,
  Q$ as Textarea,
  Zy as Toast,
  ex as ToastClose,
  nx as ToastDescription,
  CL as ToastProvider,
  rx as ToastTimeoutIndicator,
  tx as ToastTitle,
  Qy as ToastViewport,
  R4 as Toaster,
  IL as Toggle,
  LL as ToggleGroup,
  FL as ToggleGroupItem,
  lF as Tooltip,
  l0 as TourContext,
  _4 as TourProvider,
  d3 as Tracker,
  u3 as TrackerStop,
  f4 as Typeahead,
  S2 as TypeaheadButton,
  y2 as TypeaheadInput,
  x2 as TypeaheadList,
  fR as badgeIconDefaultStyles,
  dR as badgeStyles,
  A3 as columns,
  L3 as columnsSort,
  F3 as columnsSortAlignment,
  $3 as columnsWithCellStyle,
  O3 as columnsWithStyle,
  V3 as data,
  z3 as dataCustom,
  B3 as dataWithStyle,
  W3 as expandableRowsData,
  H3 as paginableData,
  D3 as paginableDataColumns,
  PL as reducer,
  NL as toast,
  $L as toggleGroupStyles,
  ax as toggleStyles,
  TL as useToast,
  I4 as useTour
};
